import { useState, useEffect, useMemo, useRef, useCallback, lazy, Suspense } from "react";
import {
  Users, FileText, Bell, Shield, Search, Plus, Edit2, Trash2,
  ChevronRight, Upload, Send, CheckCircle, X, Save, Eye,
  LogOut, Globe, GraduationCap, MoreVertical, TrendingUp, Folder, Mail, Phone,
  Calendar, Hash, Building, AlertTriangle, ArrowLeft, Link2,
  Copy, Check, ListTodo, UserCircle, Crown, UserPlus, Flag,
  ClipboardList, CheckSquare, Circle, UserCog, Heart, Smile, ShieldCheck,
  FolderOpen, RefreshCw, FileSignature, ExternalLink, Gift,
  DollarSign, BarChart2, ClipboardCheck, CalendarPlus, Star, Lock, Unlock,
  PenTool, Receipt, ChevronDown, Layers, Activity, Clock,
  Download, EyeOff, Paperclip, XCircle, CreditCard, MessageSquare, LifeBuoy,
  ChevronLeft, Edit3, UserX, Megaphone, Settings, Repeat, Sparkles,
  ShieldOff, KeyRound, Bot, BookOpen, Table, Ticket, PhoneOff, LayoutDashboard,
  HeartPulse
} from "lucide-react";
import {
  BetaOnboardScreen, OnboardingTour,
  useBetaTokenFromUrl, hasOnboarded,
} from "./deskte-onboarding.jsx";
import { FileActions } from "./deskte-file-utils.jsx";
import { DocTypeThumbnail, DocFolder } from "./crm-app/components/DocFolder.jsx";
import { UsersManager } from "./crm-app/components/UsersManager.jsx";
import { MyDigitalCard } from "./crm-app/components/MyDigitalCard.jsx";
import { CajaConScroll, verMenuEntero } from "./crm-app/components/CajaConScroll.jsx";
import { AddressSuggestions } from "./crm-app/components/AddressSuggestions.jsx";
import { OtrosIngresos } from "./crm-app/components/OtrosIngresos.jsx";
import { CalendarioMensual } from "./crm-app/components/CalendarioMensual.jsx";
import { LeadsView, SEED_LEADS } from "./crm-app/components/LeadsView.jsx";
import { ConversationsView } from "./crm-app/components/ConversationsView.jsx";
import { PipelineView } from "./crm-app/components/PipelineView.jsx";
import { Modal, Input, Select, Textarea, Avatar, StatCard, InfoBlock, ConfirmHost, confirmDialog } from "./crm-app/components/ui.jsx";
import { totalNewForClient } from "./crm-app/clientFreshness.js";
import { enTandas, ANCHO_DE_HOJAS } from "./crm-app/enTandas.js";
import { intervaloVisible } from "./crm-app/relojVisible.js";
import { assetUrl } from "./crm-app/assetUrl.js";
import { coincideEnMenu } from "./crm-app/buscarEnMenu.js";
import { MAX_FICHAS, abrirFicha, cerrarFicha } from "./crm-app/fichasAbiertas.js";
import { hayGuardiaDeSalida, pedirPermisoParaSalir } from "./crm-app/salidaSinGuardar.js";
import { aseguradorasVivas, polizasVivas } from "./crm-app/polizaEstado.js";
import { searchTokens, matchesAllTokens, clientSearchHaystack } from "./crm-app/searchNorm.js";
import { nombreDelRol } from "./crm-app/rolesDeLaCuenta.js";
import { claveEstado, SIN_ESTADO } from "./crm-app/estadosUsa.js";
import { safeHtml } from "./crm-app/sanitizeHtml.js";
import { createScheduledSend as apiCreateScheduledSend } from "./crm-app/api.js";
import { normalizeColumns, opcionesDeColumna, opcionesDeFiltroDeColumna, pasaFiltroDeColumnaPropia, tipoDeColumna } from "./crm-app/customColumns.js";
import CustomColumnsManager from "./crm-app/components/CustomColumnsManager.jsx";
import { guardarColumnasDeTabla } from "./crm-app/columnasDeTabla.js";
import CeldaPropia from "./crm-app/components/CeldaPropia.jsx";
import { createRecurringCampaign as apiCreateRecurringCampaign } from "./crm-app/api.js";
import { IS_DEMO, IS_DEMO_BUILD, DEMO_COMO_PLATAFORMA } from "./crm-app/demoMode.js";
import { bdayPersonKey, birthdayDayKey, bdayGreetingKey, plantillaVivaDelSaludo } from "./crm-app/greetings.js";
import { chipsDelKit } from "./crm-app/camposDelKit.js";
import { useGreetingQueue } from "./crm-app/greetingQueue.js";
import UnscheduleGreetingButton from "./crm-app/components/UnscheduleGreetingButton.jsx";
import { reportFrontendError } from "./crm-app/sentry.js";
import { useServerEvents } from "./crm-app/hooks.js";
import { retrasosDeResincronizacion } from "./crm-app/resincronizacion.js";
import { PinSecurityPanel } from "./crm-app/components/PinSecurityPanel.jsx";
import { ExportarClientesModal } from "./crm-app/components/ExportarClientesModal.jsx";
import { AutenticadorPanel } from "./crm-app/components/AutenticadorPanel.jsx";
import { CerrarSesionesPanel } from "./crm-app/components/CerrarSesionesPanel.jsx";
import { BillingTab } from "./crm-app/components/BillingTab.jsx";
import { PhiWarningModal } from "./crm-app/components/PhiWarningModal.jsx";
import { BillingBanner } from "./crm-app/components/BillingBanner.jsx";
import { NotificationBell } from "./crm-app/components/NotificationBell.jsx";
import ClientExportHistoryModal from "./crm-app/components/ClientExportHistoryModal.jsx";
import ClientsTrashModal from "./crm-app/components/ClientsTrashModal.jsx";
import EmailRichEditor from "./crm-app/components/EmailRichEditor.jsx";
import { aHtmlDeDocumento } from "./crm-app/documentoConFormato.js";
import { AnnouncementsBell } from "./crm-app/components/AnnouncementsBell.jsx";
import { CalculatorWidget } from "./crm-app/components/CalculatorWidget.jsx";
import { SsnRevealModal, pinErrorText, pinOwnerLabel } from "./crm-app/components/SsnRevealModal.jsx";
import { MailingLabelsModal } from "./crm-app/components/MailingLabelsModal.jsx";
import {
  ChangeHistoryTab, ClientHousehold, PaymentMethodsTab, ClientCommsTab,
  EligibilityTab, ClientNotesTab, ClientSignatures, ClientDetail,
  ActivityLogView,
  SEED_DOC_TEMPLATES, CSS_STR,
} from "./crm-app/components/ClientDetail.jsx";
// Los filtros de Clientes y Pólizas se quedan puestos por persona.
import { useStickyFilter, useStickyFilterList } from "./crm-app/stickyFilter.js";
import { FiltroMultiple } from "./crm-app/components/FiltroMultiple.jsx";
import { CAMPOS_DE_MEDICARE } from "./crm-app/medicareDelCliente.js";
import { cambiosDeCatalogo, cambiosDeColores, cambiosDeColaboradores, idDeColaboradorNuevo, hayCambios, fusionarRespuesta } from "./crm-app/cambiosDeEtiquetas.js";
import { fmt as fmtShared, setDateFormatPref, setNameOrderPref, formatClientName, setCollaboratorsPref, holidayDateForYear, tagColorFor, tagChipStyle, presentingAgentName, alertLeadDays, renewalLeadDaysForType, renewalWindowDays, ALERT_LEAD_DEFAULTS, ageLabelSuffix, etapaDeRenovacion, repartirRenovaciones, renovadaEnCicloCerrado, renovadaConPolizaNueva, canceladaPeroRenovada, coincideConSeleccion, nombreDeQuienRefirio, conPlazosDeLaAgencia, puedeCambiarLosPlazos, ordenDeNombreQueManda, puedeCambiarElOrdenDelNombre } from "./crm-app/utils.js";
// Los filtros de Renovaciones: cuales son, cuales estan puestos y a que hay
// que volver para quitarlos. Vive en un `.js` para que una prueba pueda
// comprobar que "Quitar los filtros" los toca TODOS (regla 48).
import { filtrosPuestos, valoresSinFiltro } from "./crm-app/filtrosDeRenovaciones.js";
import { FORMAS_DEL_LOGO, formaDelLogo, estiloDelLogo } from "./crm-app/formaDelLogo.js";
import { compararNombresDeCliente } from "./crm-app/ordenPorCliente.js";
import { faltanMiembrosDelHogar, avisoDeMiembrosQueFaltan } from "./crm-app/miembrosDelHogar.js";
import { openWhatsApp } from "./crm-app/whatsapp.js";
import { TaskCard, TaskForm, TasksView, ClientTasksInline } from "./crm-app/components/TasksView.jsx";
import { CommissionTracker, ReportsView } from "./crm-app/components/CommissionTracker.jsx";
// MassEmailView: se carga al abrir su modulo. Ver MODULOS_BAJO_DEMANDA.
// EncuestasView: se carga al abrir su modulo. Ver MODULOS_BAJO_DEMANDA.
// PlatformAdminView: se carga al abrir su modulo. Ver MODULOS_BAJO_DEMANDA.
import { Dashboard, HolidayGreetingsPanel, TeamDoneBadge, APPT_DATA } from "./crm-app/components/DashboardView.jsx";
// QuotesInvoicesView: se carga al abrir su modulo. Ver MODULOS_BAJO_DEMANDA.
import { CommissionsTableView } from "./crm-app/components/CommissionsTableView.jsx";
import { AnalystCommissionsView } from "./crm-app/components/AnalystCommissionsView.jsx";
import { pasaElFiltroDePoliza } from "./crm-app/filtroDeClientesPorPoliza.js";
import BirthdayGreetingComposer from "./crm-app/components/BirthdayGreetingComposer.jsx";
import { CalendarView } from "./crm-app/components/CalendarView.jsx";
// MonthEventsView: se carga al abrir su modulo. Ver MODULOS_BAJO_DEMANDA.
import { ScheduledSendsView } from "./crm-app/components/ScheduledSendsView.jsx";
import { FollowupsView, countOverdueFollowups } from "./crm-app/components/FollowupsView.jsx";
// OnboardingView: se carga al abrir su modulo. Ver MODULOS_BAJO_DEMANDA.
import StickyNotes, { StickyNoteButton } from "./crm-app/components/StickyNotes.jsx";
import { AppointmentsView } from "./crm-app/components/AppointmentsView.jsx";
import CitasMedicasView from "./crm-app/components/CitasMedicasView.jsx";
import { TicketsView, countOpenTickets } from "./crm-app/components/TicketsView.jsx";
import { seatLabelFor as seatLabelForUtil, attendOptions, EncargadoPicker } from "./crm-app/components/AttendedBy.jsx";
import { filaDeSolicitud } from "./crm-app/filaDeSolicitud.js";
import { etiquetaDeAtiende, nombresLibresDeLaCartera, pasaElFiltroDeAtiende, PREFIJO_LIBRE, encargadoDeLaRenovacion, agenteEscritoEnLaFicha } from "./crm-app/atiende.js";
import { DEFAULT_RENEWAL_STATUSES, todosLosEstatusDeRenovacion, recordarEstatusPropiosDeRenovacion } from "./crm-app/estatusDeRenovacion.js";
import { contarEtiquetas, pasaElFiltroDeEtiqueta, textoSinEtiqueta } from "./crm-app/filtroDeEtiquetas.js";
import { QuitarEtiquetaModal, sinEtiqueta } from "./crm-app/components/QuitarEtiquetaModal.jsx";
import { idiomaDelCliente } from "./crm-app/idiomaDelCliente.js";
import { PLANTILLAS_DE_FABRICA, VARIABLES as VARS_DEL_ENLACE, LARGO_MAXIMO as LARGO_DEL_MENSAJE, componerMensaje, llaveDe, plantillaDe, problemaDeLaPlantilla, problemaDeLaTraduccion, limpiarMensajes } from "./crm-app/mensajeDelEnlaceDeRenovacion.js";
// Por que no se envio un SMS de renovacion, en el idioma de la pantalla.
import { motivoDelSms, resumenDelEnvio } from "./crm-app/motivoDelSmsDeRenovacion.js";
import { VarChips, useVarInserter, TextareaWithVars } from "./crm-app/components/VarChips.jsx";
import { AiDraftButton } from "./crm-app/components/AiDraftButton.jsx";
import { CompanyAppointmentsView } from "./crm-app/components/CompanyAppointmentsView.jsx";
import { LicensesView } from "./crm-app/components/LicensesView.jsx";
import { MetricsView } from "./crm-app/components/MetricsView.jsx";
import { AgencyView, AgencyNamePanel } from "./crm-app/components/AgencyView.jsx";
import { BrandFontEditor, brandFontOf, brandFontStyle } from "./crm-app/components/BrandFontEditor.jsx";
import { SignaturePad, PublicSigningPage } from "./crm-app/components/SignaturePad.jsx";
// SignaturesView: se carga al abrir su modulo. Ver MODULOS_BAJO_DEMANDA.
import { DocRequests } from "./crm-app/components/DocRequests.jsx";
// ImportView: se carga al abrir su modulo. Ver MODULOS_BAJO_DEMANDA.
import { ClientDuplicates } from "./crm-app/components/ClientDuplicates.jsx";
import { ExpensesView, SEED_EXPENSES } from "./crm-app/components/ExpensesView.jsx";
import PayrollDocsView from "./crm-app/components/PayrollDocsView.jsx";
import HelpCenterView from "./crm-app/components/HelpCenterView.jsx";
import DateField from "./crm-app/components/DateField.jsx";
import DateTimeField from "./crm-app/components/DateTimeField.jsx";
import { ResourcesView } from "./crm-app/components/ResourcesView.jsx";
import { TeamTrainingView } from "./crm-app/components/TeamTrainingView.jsx";
// VaultView: se carga al abrir su modulo. Ver MODULOS_BAJO_DEMANDA.
import CompanyInfoView from "./crm-app/components/CompanyInfoView.jsx";
import TeamChatView from "./crm-app/components/TeamChatView.jsx";
import ChatWidget from "./crm-app/components/ChatWidget.jsx";
import DeskteAiWidget from "./crm-app/components/DeskteAiWidget.jsx";
import DeskteAiChat from "./crm-app/components/DeskteAiChat.jsx";
import SupportView from "./crm-app/components/SupportView.jsx";
import { SupportMenu } from "./crm-app/components/SupportMenu.jsx";
import IdeasBoard from "./crm-app/components/IdeasBoard.jsx";
// SheetsView: se carga al abrir su modulo. Ver MODULOS_BAJO_DEMANDA.
import HipaaSeatBundlePanel, { HipaaTrainingGate } from "./crm-app/components/HipaaSeatBundle.jsx";
import { PublicResourcePortal } from "./crm-app/components/PublicResourcePortal.jsx";
import { InvoicesView } from "./crm-app/components/InvoicesView.jsx";
import { MyEmailView, OAuthCallbackPage } from "./crm-app/components/MyEmailView.jsx";
import { WhatsappIntegrationView } from "./crm-app/components/WhatsappIntegrationView.jsx";
import { PhoneIntegrationView } from "./crm-app/components/PhoneIntegrationView.jsx";
import { HealthSherpaIntegrationView } from "./crm-app/components/HealthSherpaIntegrationView.jsx";
import { HealthSherpaEmparejarView } from "./crm-app/components/HealthSherpaEmparejarView.jsx";
import { HealthSherpaInscribirView } from "./crm-app/components/HealthSherpaInscribirView.jsx";
import { SentEmailsView } from "./crm-app/components/SentEmailsView.jsx";
import { LeadFormsView } from "./crm-app/components/LeadFormsView.jsx";
import { ApplicationsView } from "./crm-app/components/ApplicationsView.jsx";
import { ActionTemplatesView, ApplyTemplateModal } from "./crm-app/components/ActionTemplatesView.jsx";
import { RecurringTasksView } from "./crm-app/components/RecurringTasksView.jsx";
import { RecurringInvoicesView } from "./crm-app/components/RecurringInvoicesView.jsx";
import { prefsGet, prefsSet, prefsRemove, installPrefsMirror, seedPrefsFromServer, podarFrescura, podarFrescuraDelNavegador } from "./crm-app/uiPrefsStore.js";
import { publicarEquipo } from "./crm-app/equipoParaMenciones.js";
import { ReportsAnalyticsView } from "./crm-app/components/ReportsAnalyticsView.jsx";
import { ReportsClientsView } from "./crm-app/components/ReportsClientsView.jsx";
import { SalesReportView } from "./crm-app/components/SalesReportView.jsx";
import { AVATAR_PRESETS, FACE_PRESETS, buildAvatarSvg, buildFaceSvg, svgToDataUrl } from "./crm-app/components/avatarGallery.js";
import ReportsTeamView from "./crm-app/components/ReportsTeamView.jsx";
import ReportDashboardsView from "./crm-app/components/ReportDashboardsView.jsx";
import { ProductionByAgentView } from "./crm-app/components/ProductionByAgentView.jsx";
import { AgencyAnalyticsView } from "./crm-app/components/AgencyAnalyticsView.jsx";
import { MembersReportView } from "./crm-app/components/MembersReportView.jsx";
// WorkflowsView: se carga al abrir su modulo. Ver MODULOS_BAJO_DEMANDA.
import { AIAssistantView } from "./crm-app/components/AIAssistantView.jsx";
import { GoalsView } from "./crm-app/components/GoalsView.jsx";
// EmailSequencesView: se carga al abrir su modulo. Ver MODULOS_BAJO_DEMANDA.
import { EmailSuppressionsView } from "./crm-app/components/EmailSuppressionsView.jsx";
import { SmsSuppressionsView } from "./crm-app/components/SmsSuppressionsView.jsx";
import { hasSeatPermission, normalizeSeatPermissions, REPORTE_DE_LA_VISTA, seatPuedeVerReporte } from "./crm-app/seatPermissions.js";
import { esSoloSusProspectos } from "./crm-app/alcanceDelAsiento.js";
// El unico camino para abrir la ficha de un cliente DESDE OTRA PANTALLA. Deja
// la direccion en `#client/<id>` sin pasar por `#clients`, que es lo que hace
// que "Atras" devuelva a la pantalla de la que se venia (E-316).
import { irAlCliente } from "./crm-app/irAlCliente.js";
import {
  PolicyForm, PolicyCard, PaymentInfoBlock, PoliciesView, PolicyTypeManager,
  PaymentTrackerView,
} from "./crm-app/components/PoliciesView.jsx";
import {
  POLICY_TYPES, CUSTOM_ICON_CHOICES, getPolicyType,
  tiposDePolizaConKit, tiposPropiosDeLaAgencia,
  addCustomPolicyType, removeCustomPolicyType,
  memberHasCoverage, countInsuredMembers, hasCurrentSpouse,
} from "./crm-app/policyTypes.js";
import { KIT_RENOVACION, mensajeDeKit, mapaConMensaje, esLlaveDeCambioDeVida, mensajeDeKitEnIngles } from "./crm-app/kitPorContexto.js";
import { SelectorDeIdiomaDelKit } from "./crm-app/components/SelectorDeIdiomaDelKit.jsx";
import { leerEntrada, borrarEntrada } from "./crm-app/entradaGuardada.js";
import { fusionarAccionesDelEquipo, unirPorClave, rangoDeCumpleanos } from "./crm-app/accionesDelEquipo.js";
import { avisarKitEnviado, textoSinMensajeDeKit } from "./crm-app/mensajeDelKitUsado.js";
import { todosLosMotivos, etiquetaDeMotivo, unirMotivo } from "./crm-app/motivosDeCancelacion.js";
import VistaPreviaDelKit from "./crm-app/components/VistaPreviaDelKit.jsx";
// La columna "Asegurados" del Excel de clientes: la misma regla que la tarjeta (E-342).
import { aseguradosDelCliente } from "./crm-app/aseguradosDeLaPoliza.js";
import { copiaDePoliza } from "./crm-app/copiaDePoliza.js";
import { columnasDePolizasActivas, columnasDeDocumento, columnasPorPoliza, celdaEnUnaLinea, MAX_CELDA_EXCEL } from "./crm-app/polizasActivasParaExcel.js";
// Que estados civiles conservan a la pareja: "married" Y "domestic_partner". Se
// pregunta aqui y no se compara a mano — ver crm-app/estadoCivil.js.
import { tienePareja, estadoCivilParaConservarPareja } from "./crm-app/estadoCivil.js";
import {
  listClients as apiListClients,
  getClient as apiGetClient,
  createClient as apiCreateClient,
  updateClient as apiUpdateClient,
  setClientAssignedAgent as apiSetClientAssignedAgent,
  deleteClient as apiDeleteClient,
  listPolicies as apiListPolicies,
  createPolicy as apiCreatePolicy,
  updatePolicy as apiUpdatePolicy,
  bulkUpdatePolicyStatus as apiBulkUpdatePolicyStatus,
  deletePolicy as apiDeletePolicy,
  listTasks as apiListTasks,
  createTask as apiCreateTask,
  updateTask as apiUpdateTask,
  deleteTask as apiDeleteTask,
  listLeads as apiListLeads,
  createLead as apiCreateLead,
  updateLead as apiUpdateLead,
  deleteLead as apiDeleteLead,
  listCommissions as apiListCommissions,
  createCommission as apiCreateCommission,
  listAppointments as apiListAppointments,
  createAppointment as apiCreateAppointment,
  updateAppointment as apiUpdateAppointment,
  listUsers as apiListUsers,
  sendTeamInvite as apiSendTeamInvite,
  listTeamInvitations as apiListTeamInvitations,
  revokeTeamInvitation as apiRevokeTeamInvitation,
  resendTeamInvitation as apiResendTeamInvitation,
  listDocuments as apiListDocuments,
  uploadDocument as apiUploadDocument,
  deleteDocument as apiDeleteDocument,
  getDocumentReadUrl as apiGetDocumentReadUrl,
  listNotes as apiListNotes,
  listNoteStamps as apiListNoteStamps,
  createNote as apiCreateNote,
  deleteNote as apiDeleteNote,
  listSignatures as apiListSignatures,
  createSignature as apiCreateSignature,
  mapTaskFromApi,
  mapNoteFromApi,
  mapSignatureFromApi,
  mapDocumentFromApi,
  mapPolicyFromApi,
  mapLeadFromApi,
  mapAppointmentFromApi,
  setRenewalStage as apiSetRenewalStage,
  programarCancelacion as apiProgramarCancelacion,
  savePaymentCustomData as apiSavePaymentCustomData,
  sendWelcomeKit as apiSendWelcomeKit,
  previewRenewalKit as apiPreviewRenewalKit,
  setRenewalNote as apiSetRenewalNote,
  ensureRenewalReview as apiEnsureRenewalReview,
  sendRenewalReviewSms as apiSendRenewalReviewSms,
  sendRenewalReviewEmail as apiSendRenewalReviewEmail,
  renewalReviewsByPolicies as apiRenewalReviewsByPolicies,
  revokeRenewalReview as apiRevokeRenewalReview,
  getAgencySettings as apiGetAgencySettings,
  updateAgencySettings as apiUpdateAgencySettings,
  getCustomColumnValues as apiGetCustomColumnValues,
  saveCustomColumnValues as apiSaveCustomColumnValues,
  listActivity as apiListActivity,
  getEmailIntegrationStatus as apiGetEmailIntegrationStatus,
  sendClientEmail as apiSendClientEmail,
  listTimeEntries as apiListTimeEntries,
  createTimeEntry as apiCreateTimeEntry,
  updateTimeEntry as apiUpdateTimeEntry,
  heartbeatTimeEntry as apiHeartbeatTimeEntry,
  deleteTimeEntry as apiDeleteTimeEntry,
} from "./crm-app/api.js";
import { toast } from "./crm-app/components/Toast.jsx";
import { enviarSmsAlCliente } from "./crm-app/enviarSms.js";
// Policy type catalog now lives in ./crm-app/policyTypes.js (imported above).
import { REQUIRED_DOCS_BY_POLICY_DEFAULT, getAutoDocsForClient } from "./crm-app/policyDocs.js";
import { ESTATUS_MIGRATORIOS, etiquetasDeEstatus, normalizarEstatus, SIN_ESTATUS, contarEstatusMigratorio, pasaElFiltroDeEstatusMigratorio, estatusParaElegir, getAgencyEstatusMigratorios, setAgencyEstatusMigratorios, idParaEstatusNuevo, renombrarEstatusPropio, quitarEstatusPropio } from './crm-app/estatusMigratorio.js';
// Recorrer TODAS las paginas de clientes. Lo usan el arranque y los dos sitios
// que vuelven a pedir la lista (papelera y duplicados), que se traian solo la
// primera y dejaban la cartera en 500. Ver la cabecera de ese archivo.
import { cargarCarteraCompleta } from "./crm-app/carteraCompleta.js";
import { LINEAS_DE_BLOQUEO } from "./crm-app/lineasDeBloqueo.js";
import EquipoDelEnlace from "./crm-app/components/EquipoDelEnlace.jsx";
import AparienciaDelEnlace from "./crm-app/components/AparienciaDelEnlace.jsx";
// Pantallas que usan todo el ancho en vez del tope de 1200px (ver el <main>).
// Company Appointments, Info de Compañías, Tickets y Tareas se sumaron el
// 2026-10-13 (Lissette: "agrandarlo" como Clientes y Pólizas). El Calendario
// el 2026-11-04 ("lo volviste a poner pequeño").
const VISTAS_A_TODO_LO_ANCHO = new Set(["vault","my_vault","client_reports","reports","renewals","clients","policies","payment_tracker","onboarding","prospects","commissions_table","sales_report","analyst_commissions","report_dashboards","appointments","company_info","tickets","tasks","calendar"]);
// Upload storage layer — wrapped for easy backend migration
const FOLDER_COLORS = ["#1d6fa4","#10b981","#f59e0b","#8b5cf6","#ef4444","#ec4899","#64748b"];
// Wall-clock date in the user's LOCAL timezone as YYYY-MM-DD. Time
// tracking stores/reads wall-clock HH:MM in local time, so the date must
// also be local — toISOString() (UTC) files a late-evening session under
// the next UTC day (the "10pm Saturday shows as Sunday" bug).
const localDay = (d = new Date()) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;


// Short two-tone "ding" for chat notifications, synthesized with the Web
// Audio API so there's no external audio asset to fetch (CSP-safe: no
// media-src needed). Reuses a single AudioContext and best-effort resumes
// it (browsers suspend it until a user gesture — by the time a chat message
// arrives the user has almost always clicked something). Fully guarded: any
// failure (no AudioContext, autoplay blocked) is swallowed silently.
let _chatAudioCtx = null;
// Browsers keep a freshly-created AudioContext "suspended" until it is
// resumed from inside a real user gesture. A chat chime is triggered by an
// SSE event (NOT a gesture), so resuming there is often blocked and the
// sound is silently dropped. Prime + resume the context once on the first
// interaction of the session (any click/keypress/touch), so later chimes
// play. Registered once, self-removing.
function _primeChatAudio() {
  try {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return;
    if (!_chatAudioCtx) _chatAudioCtx = new AC();
    if (_chatAudioCtx.state === "suspended") { _chatAudioCtx.resume().catch(() => {}); }
  } catch { /* audio unavailable — ignore */ }
}
if (typeof window !== "undefined") {
  const _unlock = () => {
    _primeChatAudio();
    window.removeEventListener("pointerdown", _unlock);
    window.removeEventListener("keydown", _unlock);
    window.removeEventListener("touchstart", _unlock);
  };
  window.addEventListener("pointerdown", _unlock);
  window.addEventListener("keydown", _unlock);
  window.addEventListener("touchstart", _unlock);
}
function playChatChime() {
  try {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return;
    if (!_chatAudioCtx) _chatAudioCtx = new AC();
    const ctx = _chatAudioCtx;
    if (ctx.state === "suspended") { ctx.resume().catch(() => {}); }
    const now = ctx.currentTime;
    const gain = ctx.createGain();
    gain.connect(ctx.destination);
    // Gentle fade so it's a soft "ding", not a click.
    gain.gain.setValueAtTime(0.0001, now);
    gain.gain.exponentialRampToValueAtTime(0.18, now + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.45);
    [880, 1174].forEach((freq, i) => {
      const osc = ctx.createOscillator();
      osc.type = "sine";
      osc.frequency.value = freq;
      osc.connect(gain);
      osc.start(now + i * 0.09);
      osc.stop(now + 0.45);
    });
  } catch { /* audio unavailable / autoplay blocked — ignore */ }
}
// ─── EXPORT / PRINT UTILITIES ───
async function exportToExcel(data, filename, sheetName) {
  const XLSX = await import("https://cdn.sheetjs.com/xlsx-0.20.3/package/xlsx.mjs");
  // Excel no acepta celdas de mas de 32.767 caracteres y la libreria LANZA:
  // unas notas largas tumbaban la descarga entera (Lissette 2026-10-15).
  const seguras = (data || []).map(row => Object.fromEntries(Object.entries(row).map(([k, v]) => [k,
    typeof v === "string" && v.length > MAX_CELDA_EXCEL ? `${v.slice(0, MAX_CELDA_EXCEL - 20)}... [recortado]` : v])));
  const ws = XLSX.utils.json_to_sheet(seguras);
  // Columnas con un ancho razonable: una nota larga queda en UNA linea y se
  // lee entera al hacer clic en la celda, sin estirar la hoja hasta el fondo.
  const cabeceras = Object.keys(seguras[0] || {});
  ws["!cols"] = cabeceras.map(h => ({ wch: Math.min(45, Math.max(String(h).length + 2,
    ...seguras.slice(0, 200).map(r => String(r[h] ?? "").length)) ) }));
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheetName || "Data");
  XLSX.writeFile(wb, filename);
}
function exportToCSV(data, filename) {
  if (!data.length) return;
  const headers = Object.keys(data[0]);
  const csv = [headers.join(","), ...data.map(row => headers.map(h => `"${String(row[h]||"").replace(/"/g,'""')}"`).join(","))].join("\n");
  const blob = new Blob(["\uFEFF"+csv], {type:"text/csv;charset=utf-8;"});
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a"); a.href = url; a.download = filename;
  document.body.appendChild(a); a.click(); document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
// HTML-escape user-controlled values before they go into `document.write`.
// The print window inherits the opener's origin (`app.deskte.com`) and
// can read `window.opener.__deskteAuth.getAccessToken` — so a stored XSS
// payload in any client field (notes, firstName from a bad CSV import,
// dependent name, etc.) would otherwise execute in the authenticated
// session's origin and exfiltrate the bearer token. Closed by audit fix
// C3 (2026-05-20).
function escapeHtmlAttr(value) {
  if (value === null || value === undefined) return '';
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}
function printClientFicha(client, policies, docs, lang) {
  const es = lang === "es";
  const fmt = d => d ? new Date(d).toLocaleDateString("en-US",{year:"numeric",month:"short",day:"numeric"}) : "—";
  const mask = s => s ? "***-**-" + String(s).slice(-4) : "—";
  const na = "—";
  const h = escapeHtmlAttr; // local shortcut — every user-controlled interpolation MUST be wrapped in h(...)
  const statusMap = {active:es?"Activo":"Active",pending:es?"Pendiente":"Pending",inactive:es?"Inactivo":"Inactive",prospect:es?"Prospecto":"Prospect",referral:es?"Referido":"Referral"};
  const immigMap = {us_citizen:es?"Ciudadano":"US Citizen",permanent_resident:es?"Residente Permanente":"Permanent Resident",cuban_haitian_entrant:es?"Entrante cubano/haitiano (parole)":"Cuban/Haitian entrant (parole)",visa_holder:es?"Titular de Visa":"Visa Holder",undocumented:es?"Indocumentado":"Undocumented",daca:es?"DACA":"DACA",tps:"TPS",asylee:es?"Asilado / Refugiado":"Asylee / Refugee",work_permit:es?"Permiso de Trabajo (EAD)":"Work Permit (EAD)",pending:es?"En Proceso":"Pending",other:es?"Otro":"Other"};
  const pols = (policies||[]).filter(p=>p.clientId===client.id);
  const clientDocs = (docs||[]).filter(d=>d.clientId===client.id);
  const sp = client.spouse || {};
  const deps = client.dependents || [];
  const w = window.open("","_blank","width=900,height=700");
  if(!w)return;
  // Defense in depth: even if escaping ever slips, the print window
  // should never be able to read the opener's auth bearer. Clearing
  // `opener` breaks the parent-child JS bridge before any user-supplied
  // content is rendered.
  try { w.opener = null; } catch {}
  // Callers MUST pre-escape user-controlled values they pass in (use
  // h() below). row/row2 don't auto-escape because some cells embed
  // legitimate inline HTML (<strong>, badges) wrapping already-escaped
  // values. Pre-built HTML strings should already contain only escaped
  // user content.
  const row = (label, val) => `<tr><th>${label}</th><td>${val || na}</td></tr>`;
  const row2 = (l1, v1, l2, v2) => `<tr><th>${l1}</th><td>${v1 || na}</td><th>${l2}</th><td>${v2 || na}</td></tr>`;
  const html = `<!DOCTYPE html><html><head><meta charset="utf-8"><title>${h(client.firstName)} ${h(client.lastName)} — Deskte</title>
<style>*{margin:0;padding:0;box-sizing:border-box}body{font-family:'Segoe UI',system-ui,sans-serif;color:#1a1a2e;padding:40px 50px;line-height:1.5;font-size:13px}
.header{display:flex;align-items:center;justify-content:space-between;border-bottom:3px solid #0ea5e9;padding-bottom:16px;margin-bottom:24px}
.logo{font-size:28px;font-weight:900;letter-spacing:-0.02em}.logo-des{color:#0ea5e9}.logo-kte{color:#1a1a2e}
.title{font-size:11px;color:#64748b;text-transform:uppercase;letter-spacing:0.15em;font-weight:700}
table{width:100%;border-collapse:collapse;margin-bottom:16px}th{background:#f1f5f9;text-align:left;padding:7px 10px;font-size:10px;color:#475569;text-transform:uppercase;letter-spacing:0.08em;border:1px solid #e2e8f0;width:20%}
td{padding:7px 10px;border:1px solid #e2e8f0;font-size:12px}
h2{font-size:15px;color:#0ea5e9;margin:20px 0 10px;border-bottom:1px solid #e2e8f0;padding-bottom:5px}
.badge{display:inline-block;padding:2px 10px;border-radius:100px;font-size:10px;font-weight:700}
.badge-active{background:#dcfce7;color:#15803d}.badge-pending{background:#fef3c7;color:#92400e}.badge-inactive{background:#f1f5f9;color:#64748b}
.footer{margin-top:24px;padding-top:10px;border-top:1px solid #e2e8f0;font-size:9px;color:#94a3b8;display:flex;justify-content:space-between}
.page-break{page-break-before:always}
@media print{body{padding:15px 25px;font-size:11px}td,th{padding:5px 8px}}</style></head><body>
<div class="header"><div><span class="logo"><span class="logo-des">Des</span><span class="logo-kte">kte</span></span><br><span class="title">${es?"Ficha Completa del Cliente":"Complete Client Profile"}</span></div><div style="text-align:right;font-size:11px;color:#64748b">${es?"Impreso":"Printed"}: ${new Date().toLocaleDateString("en-US",{year:"numeric",month:"long",day:"numeric"})}</div></div>

<h2>1. ${es?"Informacion Personal":"Personal Information"}</h2>
<table>
${row2(es?"Nombre":"First Name",`<strong>${h(client.firstName)}</strong>`,es?"Apellido":"Last Name",`<strong>${h(client.lastName)}</strong>`)}
${row2(es?"Telefono":"Phone",h(client.phone),"Email",h(client.email))}
${row2(es?"Fecha de Nacimiento":"Date of Birth",fmt(client.dob),es?"Estado Civil":"Marital Status",h(client.maritalStatus))}
${row2(es?"Idioma Preferido":"Preferred Language",client.preferredLang==="spanish"?(es?"Espanol":"Spanish"):(es?"Ingles":"English"),es?"Estado del Cliente":"Client Status",`<span class="badge badge-${h(client.status||"active")}">${h(statusMap[client.status]||client.status)}</span>`)}
${row(es?"Direccion":"Address",h([client.addressStreet,client.addressCity,client.addressState,client.addressZip].filter(Boolean).join(", ")))}
${row2(es?"Ingresos del Primario":"Primary Income",h(client.annualIncome),es?"Empleador":"Employer",h(client.employer))}
${row2("SSN",mask(client.ssn),es?"Estatus Migratorio":"Immigration Status",h(immigMap[client.immigrationStatus]||client.immigrationStatus))}
${row2(es?"Tamano del Hogar":"Household Size",client.householdSize?(h(client.householdSize)+" "+(es?"personas":"persons")):"",es?"Miembros Asegurados":"Insured Members",h(String(countInsuredMembers(client))))}
${row2(es?"Referido por":"Referred By",client.refFirstName?h(`${client.refFirstName} ${client.refLastName||""} ${client.refPhone?("("+client.refPhone+")"):""}`.trim()):"",es?"Creado":"Created",fmt(client.createdAt))}
</table>

${sp.firstName?`<h2>2. ${es?"Conyuge / Pareja":"Spouse / Partner"}</h2>
<table>
${row2(es?"Nombre":"First Name",h(sp.firstName),es?"Apellido":"Last Name",h(sp.lastName))}
${row2(es?"Telefono":"Phone",h(sp.phone),es?"Fecha de Nacimiento":"DOB",fmt(sp.dob))}
${row2(es?"Empleador":"Employer",h(sp.employer),es?"Ingresos":"Income",h(sp.income))}
${row2(es?"Estatus Migratorio":"Immigration",h(immigMap[sp.immigrationStatus]||sp.immigrationStatus),"SSN",mask(sp.ssn))}
</table>`:`<h2>2. ${es?"Conyuge / Pareja":"Spouse / Partner"}</h2><p style="color:#94a3b8;font-size:12px;margin-bottom:16px">${es?"No registrado":"Not on file"}</p>`}

<h2>3. ${es?"Dependientes":"Dependents"} (${deps.length})</h2>
${deps.length?`<table>
<tr><th>${es?"Nombre":"Name"}</th><th>${es?"Relacion":"Relation"}</th><th>${es?"Fecha Nac.":"DOB"}</th><th>${es?"Empleador":"Employer"}</th><th>${es?"Ingresos":"Income"}</th><th>${es?"Inmig.":"Immig."}</th><th>SSN</th><th>${es?"Asegurado":"Insured"}</th></tr>
${deps.map(d=>`<tr><td>${h(d.firstName)} ${h(d.lastName)}</td><td>${h(d.relation)||na}</td><td>${fmt(d.dob)}</td><td>${h(d.employer)||na}</td><td>${h(d.income)||na}</td><td>${h(immigMap[d.immigrationStatus]||d.immigrationStatus)||na}</td><td>${mask(d.ssn)}</td><td>${d.insured?(es?"Si":"Yes"):(es?"No":"No")}</td></tr>`).join("")}
</table>`:`<p style="color:#94a3b8;font-size:12px;margin-bottom:16px">${es?"Sin dependientes registrados":"No dependents on file"}</p>`}

<h2>4. ${es?"Polizas":"Policies"} (${pols.length})</h2>
${pols.length?`<table>
<tr><th>${es?"Tipo":"Type"}</th><th>${es?"Compania":"Carrier"}</th><th>Plan</th><th># ${es?"Poliza":"Policy"}</th><th>Member ID</th><th>${es?"Prima/Mes":"Premium/Mo"}</th><th>${es?"Estado":"Status"}</th><th>${es?"Inicio":"Effective"}</th><th>${es?"Renovacion":"Renewal"}</th></tr>
${pols.map(p=>`<tr><td>${h((getPolicyType(p.type)?.label)||p.type)}</td><td>${h(p.carrier)||na}</td><td>${h(p.plan)||na}</td><td>${h(p.policyNumber)||na}</td><td>${h(p.memberId)||na}</td><td>$${h(p.monthlyPremium||0)}</td><td>${h(p.status)||na}</td><td>${fmt(p.effectiveDate)}</td><td>${fmt(p.renewalDate)}</td></tr>`).join("")}
</table>`:`<p style="color:#94a3b8;font-size:12px;margin-bottom:16px">${es?"Sin polizas":"No policies"}</p>`}

<h2>5. ${es?"Documentos":"Documents"} (${clientDocs.length})</h2>
${clientDocs.length?`<table>
<tr><th>${es?"Nombre del Archivo":"File Name"}</th><th>${es?"Tipo":"Type"}</th><th>${es?"Requerido":"Required"}</th><th>${es?"Fecha de Subida":"Upload Date"}</th></tr>
${clientDocs.map(d=>`<tr><td>${h(d.name)}</td><td>${h(d.type)||na}</td><td>${d.required?(es?"Si":"Yes"):(es?"No":"No")}</td><td>${d.uploadedAt?fmt(d.uploadedAt):`<span style="color:#dc2626;font-weight:700">${es?"PENDIENTE":"PENDING"}</span>`}</td></tr>`).join("")}
</table>`:`<p style="color:#94a3b8;font-size:12px;margin-bottom:16px">${es?"Sin documentos":"No documents"}</p>`}

${client.notes?`<h2>6. ${es?"Notas del Agente":"Agent Notes"}</h2><div style="padding:10px 14px;background:#f8fafc;border:1px solid #e2e8f0;border-radius:6px;font-size:12px;white-space:pre-wrap;margin-bottom:16px">${h(client.notes)}</div>`:""}

<div class="footer"><span>${es?"CONFIDENCIAL":"CONFIDENTIAL"} — Deskte CRM — ${es?"Solo para uso interno":"Internal use only"}</span><span>ID: ${h(client.id)} | ${new Date().toLocaleTimeString("en-US",{ hour:"numeric", minute:"2-digit" })}</span></div>
</body></html>`;
  w.document.write(html);
  w.document.close();
  setTimeout(()=>w.print(), 600);
}
const SIGN_TYPES = ["Scope of Appointment (SOA)","Consent Form","Income Letter","HIPAA Authorization","Enrollment Form","Custom"];
const T = {
  en: {
    appName:"Deskte", tagline:"Your Insurance Desk",
    nav:{ dashboard:"Dashboard", clients:"Clients", policies:"Policies", renewals:"Renewals",
          tasks:"Tasks", requests:"Doc Requests", signatures:"Signatures",
          folders:"Folders", reports:"Reports", team:"Team" },
    dashboard:{ title:"Overview", totalClients:"Total Clients", activeClients:"Active",
      pendingDocs:"Docs Pending", renewalsSoon:"Renewals Soon", viewAll:"View All",
      pendingAlerts:"Alerts & Reminders", noAlerts:"No alerts", birthdayToday:"Birthday Today",
      birthdayThisWeek:"Birthday this week", myTasks:"My Open Tasks" },
    clients:{ title:"Client CRM", addClient:"Add Client", search:"Search clients...",
      all:"All", active:"Active", pending:"Pending", inactive:"Inactive", prospect:"Prospect", referral:"Referral",
      noClients:"No clients found", deleteConfirm:"Delete this client?",
      viewProfile:"View Profile", policies:"Policies" },
    clientForm:{ firstName:"First Name", middleName:"Middle Name", lastName:"Last Name", phone:"Phone", email:"Email",
      dob:"Date of Birth", status:"Status", notes:"Notes",
      addressStreet:"Street Address", addressCity:"City", addressState:"State", addressZip:"ZIP", county:"County",
      save:"Save Client", cancel:"Cancel", addTitle:"New Client", editTitle:"Edit Client",
      sectionContact:"Contact", sectionAddress:"Address", sectionOther:"Notes & Other",
      preferredLang:"Preferred Language", english:"English", spanish:"Spanish",
      sectionHousehold:"Household & Income", householdSize:"Household Members",
      insuredMembers:"Members to Insure", annualIncome:"Primary Income",
      employer:"Employer (Primary)", employerPhone:"Employer Phone", immigrationStatus:"Immigration Status",
      ssn:"Social Security #", ssnHint:"Only last 4 shown - click to reveal",
      maritalStatus:"Marital Status", single:"Single", married:"Married", widowed:"Widowed", divorced:"Divorced",
      domesticPartner:"Domestic Partner", separated:"Separated",
      sectionSpouse:"Spouse / Partner Information",
      spouseFirstName:"Spouse First Name", spouseMiddleName:"Spouse Middle Name", spouseLastName:"Spouse Last Name",
      spousePhone:"Spouse Phone", spouseEmail:"Spouse Email", spouseDob:"Spouse DOB", spouseEmployer:"Spouse Employer", spouseEmployerPhone:"Spouse Employer Phone",
      spouseIncome:"Spouse Income", spouseImmigration:"Immigration Status", spouseSSN:"Spouse SSN",
      sectionDependents:"Dependents / Household Members",
      depFirstName:"First Name", depMiddleName:"Middle Name", depLastName:"Last Name", depRelation:"Relation",
      depDob:"DOB", depEmployer:"Employer", depEmployerPhone:"Employer Phone", depIncome:"Income", depImmigration:"Immigration Status", depSSN:"SSN",
      depPhone:"Phone (optional)", depEmail:"Email (optional)",
      addDependent:"+ Add Member", createProfile:"Create Separate Profile", adultDepNote:"Age 26+ - may need separate policy",
      sectionReferral:"Referral", referredBy:"Referred By",
      refFirstName:"Ref. First Name", refLastName:"Ref. Last Name", refPhone:"Ref. Phone",
      sectionDocs:"Policy Documents",
    },
    policies:{ title:"Policies", addPolicy:"Add Policy", type:"Type", carrier:"Carrier",
      plan:"Plan", policyNumber:"Policy #", memberId:"Member ID", effectiveDate:"Effective",
      renewalDate:"Renewal", monthlyPremium:"Premium/mo", familySize:"Family", membersActive:"Active Members",
      // "Policy Status" en los dos idiomas a propósito (Lissette 2026-08-13): es
      // el nombre que usa el equipo, y decía solo "Estado", que se confunde con
      // el estado del CLIENTE (activo/prospecto). Mismo nombre en la tarjeta y
      // en los importadores para no tener que adivinar cuál es cuál.
      status:"Policy Status", noPolcies:"No policies", addTitle:"New Policy", editTitle:"Edit Policy",
      save:"Save Policy", cancel:"Cancel", allPolicies:"All Policies" },
    renewals:{ title:"Renewals", thisMonth:"This Month", next30:"Next 30 Days",
      next60:"Next 60 Days", next90:"Next 90 Days", overdue:"Overdue",
      renewNow:"Renew Now", markRenewed:"Mark Renewed", noRenewals:"No renewals in this period",
      daysLeft:"days left" },
    signatures:{ title:"Digital Signatures", newRequest:"New Request", type:"Document Type",
      client:"Client", status:"Status", sentAt:"Sent", signedAt:"Signed",
      pending:"Pending Signature", signed:"Signed", declined:"Declined",
      noSignatures:"No signature requests", sendRequest:"Send for Signature",
      copyLink:"Copy Link", viewDoc:"View Document",
      comingSoon:"Full digital signing requires Phase 2 (Supabase backend). Link generation available now." },
    folders:{ title:"Folders", newFolder:"New Folder", shared:"Shared", private:"Private",
      addClients:"Add Clients", noFolders:"No folders", deleteConfirm:"Delete this folder?",
      clients:"clients", rename:"Rename" },
    reports:{ title:"Reports", tab1099:"1099 / Agent Pay", tabRenewals:"Renewal Summary",
      tabPolicies:"Policy Mix", year:"Year", agent:"Agent",
      totalEarned:"Total Earned", totalPolicies:"Total Policies",
      download:"Download Report", comingSoon:"Full 1099 auto-generation connects to commission data in Phase 2.",
      manualEntry:"Manual Commission Entry", addEntry:"Add Entry", amount:"Amount ($)",
      description:"Description", entries:"Entries" },
    quoteForm:{ title:"Quote & Lead Forms", newForm:"New Form", formTitle:"Form Title",
      fields:"Fields", copyLink:"Copy Public Link", submissions:"Submissions",
      noForms:"No forms yet", preview:"Preview Form",
      comingSoon:"Public form URL requires Phase 2 hosting. Form builder available now." },
    docFolder:{ title:"Documents", upload:"Upload", noFiles:"No documents",
      required:"Required", optional:"Optional", missing:"Missing required docs",
      addRequired:"Add Required Type" },
    docRequests:{ title:"Doc Requests", newRequest:"New Request", copyLink:"Copy Link",
      pending:"Pending", received:"Received", overdue:"Overdue", noRequests:"No requests",
      sendRequest:"Send Request", selectClient:"Select client", enterDocs:"Document name" },
    tasks:{ title:"Tasks", newTask:"New Task", general:"General", byClient:"By Client",
      all:"All", todo:"To Do", inprogress:"In Progress", done:"Done",
      taskTitle:"Title", description:"Description", priority:"Priority",
      dueDate:"Due Date", assignedTo:"Assigned To", client:"Client",
      high:"High", medium:"Medium", low:"Low", unassigned:"Unassigned",
      noTasks:"No tasks", addTitle:"New Task", editTitle:"Edit Task", save:"Save Task",
      myTasks:"My Tasks", allTasks:"All Tasks", overdue:"Overdue", dueToday:"Due Today" },
    users:{ title:"Team", addUser:"Add User", name:"Full Name", role:"Role",
      owner:"Owner", assistant:"Seat", pin:"PIN (4 digits)", confirmPin:"Confirm PIN",
      noUsers:"No team members", editUser:"Edit", deleteConfirm:"Remove this member?",
      addTitle:"Add Team Member", ownerNote:"Only the owner can manage the team." },
    login:{ welcome:"Welcome back", selectUser:"Select your profile",
      enterPin:"Enter your PIN", wrongPin:"Incorrect PIN.", login:"Sign In", back:"Back" },
    statuses:{ active:"Active", pending:"Pending", inactive:"Inactive", cancelled:"Cancelled", prospect:"Prospect", referral:"Referral" },
    timetrack:{ title:"Time Tracking", clockIn:"Clock In", clockOut:"Clock Out", isClockedIn:"Currently Clocked In",
      date:"Date", start:"Start", end:"End", hours:"Hours", notes:"Notes", total:"Total Hours",
      noEntries:"No time entries", week:"This Week", month:"This Month", all:"All",
      byUser:"By Team Member", ownerOnly:"Only the owner can view time reports.",
      myHours:"My Hours", byTeam:"By Team", backToTeam:"Back to team",
      teamHeading:"Team — pick a member to see their hours", teamMembers:"team member(s)",
      noTeamMembers:"No team members with recorded hours yet.", viewingMember:"Viewing",
      addManual:"Add Manual Entry", report:"Time Report", export:"Export" },
    activitylog:{ title:"Activity Log", who:"Changed by", what:"Change", when:"When",
      noActivity:"No activity recorded yet", fieldChanged:"Field changed",
      created:"Client created", updated:"Client updated", policyAdded:"Policy added",
      policyUpdated:"Policy updated", policyDeleted:"Policy deleted",
      docUploaded:"Document uploaded", docDeleted:"Document deleted",
      taskCreated:"Task created", taskCompleted:"Task completed",
      noteAdded:"Note added", statusChanged:"Status changed" },
    emailtpl:{ title:"Email Templates", compose:"Compose Email", newTemplate:"New Template",
      subject:"Subject", body:"Body", to:"To", send:"Send Email", preview:"Preview",
      variables:"Variables", insertVar:"Insert Variable", save:"Save Template",
      noTemplates:"No templates", templateName:"Template Name",
      comingSoon:"Live email sending requires Phase 2 (Resend integration). Templates are ready to save.",
      vars:"Available: {{firstName}}, {{lastName}}, {{carrier}}, {{plan}}, {{renewalDate}}, {{phone}} (client's), {{agentName}}, {{agentPhone}} (yours), {{agentOfficePhone}} (your office)",
      sent:"Email queued (Phase 2 will send)", selectClient:"Select Client",
      templates:{ renewal:"Renewal Reminder", welcome:"Welcome New Client", missing:"Missing Documents", birthday:"Birthday Greeting", followup:"Follow Up" }
    },
    resources:{ title:"Resources", addResource:"Add Resource", search:"Search resources...",
      all:"All", video:"Video", pdf:"PDF", image:"Image", document:"Document",
      noResources:"No resources found", deleteConfirm:"Delete this resource?",
      carrier:"Carrier", category:"Category", type:"Type", sharedWith:"Shared with",
      allClients:"All Clients", clients:"clients", uploadFile:"Upload File",
      videoUrl:"Video URL (YouTube/Vimeo)", dragDrop:"Drag & drop or click to upload",
      title_field:"Title", description_field:"Description", tags:"Tags",
      editResource:"Edit Resource", addTitle:"New Resource", editTitle:"Edit Resource",
      save:"Save Resource", cancel:"Cancel", preview:"Preview", copyPortalLink:"Copy Portal Link",
      generateLink:"Generate Client Portal Link", selectClient:"Select Client",
      portalLinkCopied:"Portal link copied!", sharedWithAll:"Shared with all clients",
      shareWith:"Share with clients", noFile:"No file uploaded", fileTooBig:"File too large (max 5MB)",
      selectCarrier:"Select or type carrier", selectCategory:"Select category",
      portalTitle:"Your Resources", portalSubtitle:"Resources shared by your insurance agent",
      portalNoResources:"No resources available at this time.", portalInvalidLink:"Invalid or expired portal link.",
      portalContact:"Please contact your agent for a new link.", filterByCarrier:"Filter by carrier",
      filterByCategory:"Filter by category", filterByType:"Filter by type" },
    common:{ edit:"Edit", delete:"Delete", cancel:"Cancel", save:"Save", close:"Close",
      back:"Back", confirm:"Confirm", yes:"Yes", no:"No", comingSoon:"Coming in Phase 2" },
  },
  es: {
    appName:"Deskte", tagline:"Your Insurance Desk",
    nav:{ dashboard:"Inicio", clients:"Clientes", policies:"Pólizas", renewals:"Renovaciones",
          tasks:"Tareas", requests:"Solicitudes", signatures:"Firmas",
          folders:"Carpetas", reports:"Reportes", team:"Equipo" },
    dashboard:{ title:"Resumen", totalClients:"Total Clientes", activeClients:"Activos",
      pendingDocs:"Docs Pendientes", renewalsSoon:"Próximas Renovaciones", viewAll:"Ver Todo",
      pendingAlerts:"Alertas y Recordatorios", noAlerts:"Sin alertas", birthdayToday:"Cumpleaños Hoy",
      birthdayThisWeek:"Cumpleaños esta semana", myTasks:"Mis Tareas Abiertas" },
    clients:{ title:"CRM de Clientes", addClient:"Agregar Cliente", search:"Buscar clientes...",
      all:"Todos", active:"Activos", pending:"Pendientes", inactive:"Inactivos", prospect:"Prospectos", referral:"Referidos",
      noClients:"No se encontraron clientes", deleteConfirm:"¿Eliminar este cliente?",
      viewProfile:"Ver Perfil", policies:"Pólizas" },
    clientForm:{ firstName:"Nombre", middleName:"Segundo Nombre", lastName:"Apellido", phone:"Teléfono", email:"Correo",
      dob:"Fecha de Nacimiento", status:"Estado", notes:"Notas",
      addressStreet:"Dirección", addressCity:"Ciudad", addressState:"Estado", addressZip:"Código Postal", county:"Condado",
      sectionHousehold:"Hogar e Ingresos", householdSize:"Personas en el Hogar",
      insuredMembers:"Personas a Asegurar", annualIncome:"Ingresos del Primario",
      employer:"Empleador (Principal)", employerPhone:"Tel. del Empleador", immigrationStatus:"Estatus Migratorio",
      ssn:"Número de Seguro Social", ssnHint:"Solo se muestran los últimos 4 dígitos",
      maritalStatus:"Estado Civil", single:"Soltero/a", married:"Casado/a", widowed:"Viudo/a", divorced:"Divorciado/a",
      domesticPartner:"Pareja de Hecho", separated:"Separado/a",
      sectionSpouse:"Información del Cónyuge",
      spouseFirstName:"Nombre Cónyuge", spouseMiddleName:"Segundo Nombre Cónyuge", spouseLastName:"Apellido Cónyuge",
      spousePhone:"Tel. Cónyuge", spouseEmail:"Correo Cónyuge", spouseDob:"Fecha Nac. Cónyuge", spouseEmployer:"Empleador Cónyuge", spouseEmployerPhone:"Tel. Empleador Cónyuge",
      spouseIncome:"Ingresos Cónyuge", spouseImmigration:"Estatus Migratorio", spouseSSN:"NSS Cónyuge",
      sectionDependents:"Dependientes / Miembros del Hogar",
      depFirstName:"Nombre", depMiddleName:"Segundo Nombre", depLastName:"Apellido", depRelation:"Parentesco",
      depDob:"Fecha Nac.", depEmployer:"Empleador", depEmployerPhone:"Tel. Empleador", depIncome:"Ingresos", depImmigration:"Estatus Migratorio", depSSN:"NSS",
      depPhone:"Teléfono (opcional)", depEmail:"Correo (opcional)",
      addDependent:"+ Agregar Miembro", createProfile:"Crear Perfil Separado", adultDepNote:"Mayor de 26 - puede necesitar póliza aparte",
      sectionReferral:"Referido", referredBy:"Referido Por",
      refFirstName:"Nombre Ref.", refLastName:"Apellido Ref.", refPhone:"Tel. Ref.",
      sectionDocs:"Documentos de Póliza",
      save:"Guardar Cliente", cancel:"Cancelar", addTitle:"Nuevo Cliente", editTitle:"Editar Cliente",
      sectionContact:"Contacto", sectionAddress:"Dirección", sectionOther:"Notas",
      preferredLang:"Idioma Preferido", english:"Inglés", spanish:"Español" },
    policies:{ title:"Pólizas", addPolicy:"Agregar Póliza", type:"Tipo", carrier:"Aseguradora",
      plan:"Plan", policyNumber:"# Póliza", memberId:"# Member ID", effectiveDate:"Vigencia",
      renewalDate:"Renovación", monthlyPremium:"Prima/mes", familySize:"Familia", membersActive:"Miembros Activos",
      status:"Policy Status", noPolcies:"Sin pólizas", addTitle:"Nueva Póliza", editTitle:"Editar Póliza",
      save:"Guardar Póliza", cancel:"Cancelar", allPolicies:"Todas las Pólizas" },
    renewals:{ title:"Renovaciones", thisMonth:"Este Mes", next30:"Próximos 30 Días",
      next60:"Próximos 60 Días", next90:"Próximos 90 Días", overdue:"Vencidas",
      renewNow:"Renovar Ahora", markRenewed:"Marcar Renovada", noRenewals:"Sin renovaciones en este período",
      daysLeft:"días restantes" },
    signatures:{ title:"Firmas Digitales", newRequest:"Nueva Solicitud", type:"Tipo de Documento",
      client:"Cliente", status:"Estado", sentAt:"Enviado", signedAt:"Firmado",
      pending:"Pendiente de Firma", signed:"Firmado", declined:"Rechazado",
      noSignatures:"Sin solicitudes de firma", sendRequest:"Enviar para Firma",
      copyLink:"Copiar Link", viewDoc:"Ver Documento",
      comingSoon:"La firma digital completa requiere Fase 2 (Supabase). La generación de links está disponible ahora." },
    folders:{ title:"Carpetas", newFolder:"Nueva Carpeta", shared:"Compartida", private:"Privada",
      addClients:"Agregar Clientes", noFolders:"Sin carpetas", deleteConfirm:"¿Eliminar esta carpeta?",
      clients:"clientes", rename:"Renombrar" },
    reports:{ title:"Reportes", tab1099:"1099 / Pago Agentes", tabRenewals:"Resumen Renovaciones",
      tabPolicies:"Mix de Pólizas", year:"Año", agent:"Agente",
      totalEarned:"Total Ganado", totalPolicies:"Total Pólizas",
      download:"Descargar Reporte", comingSoon:"La generación automática de 1099 se conecta a datos de comisiones en Fase 2.",
      manualEntry:"Entrada Manual de Comisiones", addEntry:"Agregar", amount:"Monto ($)",
      description:"Descripción", entries:"Entradas" },
    quoteForm:{ title:"Formularios de Cotización", newForm:"Nuevo Formulario", formTitle:"Título",
      fields:"Campos", copyLink:"Copiar Link Público", submissions:"Respuestas",
      noForms:"Sin formularios", preview:"Vista Previa",
      comingSoon:"El URL público requiere Fase 2. El constructor de formularios está disponible ahora." },
    docFolder:{ title:"Documentos", upload:"Subir", noFiles:"Sin documentos",
      required:"Requerido", optional:"Opcional", missing:"Faltan docs requeridos",
      addRequired:"Agregar Tipo Requerido" },
    docRequests:{ title:"Solicitudes de Docs", newRequest:"Nueva Solicitud", copyLink:"Copiar Link",
      pending:"Pendiente", received:"Recibido", overdue:"Vencido", noRequests:"Sin solicitudes",
      sendRequest:"Enviar Solicitud", selectClient:"Seleccionar cliente", enterDocs:"Nombre del documento" },
    tasks:{ title:"Tareas", newTask:"Nueva Tarea", general:"General", byClient:"Por Cliente",
      all:"Todas", todo:"Pendiente", inprogress:"En Progreso", done:"Completada",
      taskTitle:"Título", description:"Descripción", priority:"Prioridad",
      dueDate:"Fecha Límite", assignedTo:"Asignado A", client:"Cliente",
      high:"Alta", medium:"Media", low:"Baja", unassigned:"Sin asignar",
      noTasks:"No hay tareas", addTitle:"Nueva Tarea", editTitle:"Editar Tarea", save:"Guardar Tarea",
      myTasks:"Mis Tareas", allTasks:"Todas", overdue:"Vencida", dueToday:"Vence Hoy" },
    users:{ title:"Equipo", addUser:"Agregar Usuario", name:"Nombre Completo", role:"Rol",
      owner:"Dueña/Dueño", assistant:"Asiento", pin:"PIN (4 dígitos)", confirmPin:"Confirmar PIN",
      noUsers:"Sin miembros", editUser:"Editar", deleteConfirm:"¿Eliminar este miembro?",
      addTitle:"Agregar Miembro", ownerNote:"Solo la dueña puede gestionar el equipo." },
    login:{ welcome:"Bienvenida de nuevo", selectUser:"Selecciona tu perfil",
      enterPin:"Ingresa tu PIN", wrongPin:"PIN incorrecto.", login:"Entrar", back:"Atrás" },
    statuses:{ active:"Activo", pending:"Pendiente", inactive:"Inactivo", cancelled:"Cancelada", prospect:"Prospecto", referral:"Referido" },
    timetrack:{ title:"Control de Horas", clockIn:"Registrar Entrada", clockOut:"Registrar Salida", isClockedIn:"Actualmente trabajando",
      date:"Fecha", start:"Entrada", end:"Salida", hours:"Horas", notes:"Notas", total:"Total Horas",
      noEntries:"Sin registros de horas", week:"Esta Semana", month:"Este Mes", all:"Todos",
      byUser:"Por Miembro del Equipo", ownerOnly:"Solo el dueño puede ver reportes de horas.",
      myHours:"Mis Horas", byTeam:"Por Equipo", backToTeam:"Volver al equipo",
      teamHeading:"Equipo — elige un miembro para ver sus horas", teamMembers:"miembro(s) del equipo",
      noTeamMembers:"Aún no hay miembros del equipo con horas registradas.", viewingMember:"Viendo a",
      addManual:"Agregar Entrada Manual", report:"Reporte de Horas", export:"Exportar" },
    activitylog:{ title:"Historial de Actividad", who:"Modificado por", what:"Cambio", when:"Cuándo",
      noActivity:"Sin actividad registrada", fieldChanged:"Campo modificado",
      created:"Cliente creado", updated:"Cliente actualizado", policyAdded:"Póliza agregada",
      policyUpdated:"Póliza actualizada", policyDeleted:"Póliza eliminada",
      docUploaded:"Documento subido", docDeleted:"Documento eliminado",
      taskCreated:"Tarea creada", taskCompleted:"Tarea completada",
      noteAdded:"Nota agregada", statusChanged:"Estado cambiado" },
    emailtpl:{ title:"Plantillas de Email", compose:"Redactar Email", newTemplate:"Nueva Plantilla",
      subject:"Asunto", body:"Cuerpo", to:"Para", send:"Enviar Email", preview:"Vista Previa",
      variables:"Variables", insertVar:"Insertar Variable", save:"Guardar Plantilla",
      noTemplates:"Sin plantillas", templateName:"Nombre de Plantilla",
      comingSoon:"El envío real requiere Fase 2 (integración con Resend). Las plantillas están listas para guardar.",
      vars:"Disponibles: {{firstName}}, {{lastName}}, {{carrier}}, {{plan}}, {{renewalDate}}, {{phone}} (del cliente), {{agentName}}, {{agentPhone}} (el tuyo), {{agentOfficePhone}} (el de tu oficina)",
      sent:"Email en cola (Fase 2 lo enviará)", selectClient:"Seleccionar Cliente",
      templates:{ renewal:"Recordatorio de Renovación", welcome:"Bienvenida Nuevo Cliente", missing:"Documentos Faltantes", birthday:"Felicitación de Cumpleaños", followup:"Seguimiento" }
    },
    resources:{ title:"Recursos", addResource:"Agregar Recurso", search:"Buscar recursos...",
      all:"Todos", video:"Video", pdf:"PDF", image:"Imagen", document:"Documento",
      noResources:"No se encontraron recursos", deleteConfirm:"¿Eliminar este recurso?",
      carrier:"Compañía", category:"Categoría", type:"Tipo", sharedWith:"Compartido con",
      allClients:"Todos los Clientes", clients:"clientes", uploadFile:"Subir Archivo",
      videoUrl:"URL del Video (YouTube/Vimeo)", dragDrop:"Arrastra y suelta o haz clic para subir",
      title_field:"Título", description_field:"Descripción", tags:"Etiquetas",
      editResource:"Editar Recurso", addTitle:"Nuevo Recurso", editTitle:"Editar Recurso",
      save:"Guardar Recurso", cancel:"Cancelar", preview:"Vista Previa", copyPortalLink:"Copiar Link del Portal",
      generateLink:"Generar Link del Portal", selectClient:"Seleccionar Cliente",
      portalLinkCopied:"¡Link del portal copiado!", sharedWithAll:"Compartido con todos los clientes",
      shareWith:"Compartir con clientes", noFile:"Sin archivo subido", fileTooBig:"Archivo muy grande (máx 5MB)",
      selectCarrier:"Seleccionar o escribir compañía", selectCategory:"Seleccionar categoría",
      portalTitle:"Tus Recursos", portalSubtitle:"Recursos compartidos por tu agente de seguros",
      portalNoResources:"No hay recursos disponibles en este momento.", portalInvalidLink:"Link del portal inválido o expirado.",
      portalContact:"Por favor contacta a tu agente para un nuevo link.", filterByCarrier:"Filtrar por compañía",
      filterByCategory:"Filtrar por categoría", filterByType:"Filtrar por tipo" },
    common:{ edit:"Editar", delete:"Eliminar", cancel:"Cancelar", save:"Guardar", close:"Cerrar",
      back:"Atrás", confirm:"Confirmar", yes:"Sí", no:"No", comingSoon:"Disponible en Fase 2" },
  }
};
const SEED_CLIENTS = [ { id:"c1", firstName:"Maria", lastName:"Rodriguez", phone:"305-555-0101", email:"m.rodriguez@example.com", dob:"1975-04-12", status:"active", preferredLang:"spanish", maritalStatus:"widowed", addressStreet:"1234 Palm Ave Apt 2B", addressCity:"Hialeah", addressState:"FL", addressZip:"33012", annualIncome:"$38,500", employer:"Self-employed (Cleaning Services)", immigrationStatus:"us_citizen", ssn:"900-11-2233", householdSize:"2", insuredMembers:"2", spouse:{firstName:"",lastName:"",phone:"",dob:"",employer:"",income:"",immigrationStatus:"",ssn:""}, dependents:[{id:"d10",firstName:"Luis",lastName:"Rodriguez",relation:"child",dob:"2008-03-21",employer:"",income:"",immigrationStatus:"us_citizen",ssn:"",separateProfile:false,insured:true}], notes:"Prefers calls in Spanish. Has diabetes Rx coverage.", createdAt:"2024-01-15" }, { id:"c2", firstName:"James", lastName:"Thompson", phone:"941-555-0234", email:"jthompson@example.com", dob:"1961-06-15", status:"active", preferredLang:"english", maritalStatus:"married", addressStreet:"890 Bayshore Rd", addressCity:"Sarasota", addressState:"FL", addressZip:"34232", annualIncome:"$78,000", employer:"Retired (Federal Gov)", immigrationStatus:"us_citizen", ssn:"900-22-3344", householdSize:"2", insuredMembers:"2", spouse:{firstName:"Linda",lastName:"Thompson",phone:"941-555-0235",dob:"1963-01-10",employer:"Retired",income:"$24,000",immigrationStatus:"us_citizen",ssn:"900-22-5566"}, dependents:[], notes:"Moving to GA in Q3 - follow up re plan change", createdAt:"2024-03-10" }, { id:"c3", firstName:"Ana", lastName:"Gutierrez", phone:"407-555-0378", email:"anag@example.com", dob:"1980-11-05", status:"pending", preferredLang:"spanish", maritalStatus:"single", addressStreet:"567 Orange Blossom Dr", addressCity:"Kissimmee", addressState:"FL", addressZip:"34741", annualIncome:"$31,000", employer:"Marriott Hotels", immigrationStatus:"permanent_resident", ssn:"900-33-4455", householdSize:"3", insuredMembers:"3", spouse:{firstName:"",lastName:"",phone:"",dob:"",employer:"",income:"",immigrationStatus:"",ssn:""}, dependents:[{id:"d20",firstName:"Isabella",lastName:"Gutierrez",relation:"child",dob:"2012-06-15",employer:"",income:"",immigrationStatus:"us_citizen",ssn:"",separateProfile:false,insured:true},{id:"d21",firstName:"Marco",lastName:"Gutierrez",relation:"child",dob:"2015-09-22",employer:"",income:"",immigrationStatus:"us_citizen",ssn:"",separateProfile:false,insured:true}], notes:"Waiting on income verification for APTC", createdAt:"2024-02-20" }, { id:"c4", firstName:"Robert", lastName:"Chen", phone:"404-555-0445", email:"rchen@example.com", dob:"1958-06-17", status:"active", preferredLang:"english", maritalStatus:"divorced", addressStreet:"221 Peachtree St NE Apt 12", addressCity:"Atlanta", addressState:"GA", addressZip:"30309", annualIncome:"$92,000", employer:"Deloitte Consulting", immigrationStatus:"us_citizen", ssn:"900-44-5566", householdSize:"1", insuredMembers:"1", spouse:{firstName:"",lastName:"",phone:"",dob:"",employer:"",income:"",immigrationStatus:"",ssn:""}, dependents:[], notes:"Turning 65 soon - Medicare transition.", createdAt:"2024-04-01" }, { id:"c5", firstName:"Lucia", lastName:"Fernandez", phone:"407-555-0512", email:"luciaf@example.com", dob:"1992-02-28", status:"prospect", preferredLang:"spanish", maritalStatus:"single", addressStreet:"44 Silver Pine Blvd", addressCity:"Orlando", addressState:"FL", addressZip:"32819", annualIncome:"$42,000", employer:"Amazon Warehouse", immigrationStatus:"permanent_resident", ssn:"900-55-6677", householdSize:"1", insuredMembers:"1", spouse:{firstName:"",lastName:"",phone:"",dob:"",employer:"",income:"",immigrationStatus:"",ssn:""}, dependents:[], notes:"Interested in upgrading to Silver. Call in November.", createdAt:"2024-05-18" }, { id:"c6", firstName:"Carlos", lastName:"Mendoza", phone:"813-555-0620", email:"cmendoza@example.com", dob:"1985-07-14", status:"active", preferredLang:"spanish", maritalStatus:"married", addressStreet:"72 Magnolia Lane", addressCity:"Tampa", addressState:"FL", addressZip:"33604", annualIncome:"$67,000", employer:"Construction Foreman (self)", immigrationStatus:"us_citizen", ssn:"900-66-7788", householdSize:"3", insuredMembers:"3", spouse:{firstName:"Elena",lastName:"Mendoza",phone:"813-555-0621",dob:"1988-02-19",employer:"Childcare Provider",income:"$18,000",immigrationStatus:"permanent_resident",ssn:"900-66-9900"}, dependents:[{id:"d30",firstName:"Mateo",lastName:"Mendoza",relation:"child",dob:"2017-11-08",employer:"",income:"",immigrationStatus:"us_citizen",ssn:"",separateProfile:false,insured:true}], notes:"Has 2 vehicles + homeowners. Referred by Maria Rodriguez.", createdAt:"2025-08-10" }, { id:"c7", firstName:"Patricia", lastName:"Williams", phone:"770-555-0710", email:"pwilliams@example.com", dob:"1971-03-22", status:"active", preferredLang:"english", maritalStatus:"married", addressStreet:"3300 Sunrise Ave", addressCity:"Marietta", addressState:"GA", addressZip:"30060", annualIncome:"$85,000", employer:"Cobb County Schools", immigrationStatus:"us_citizen", ssn:"900-77-8899", householdSize:"2", insuredMembers:"2", spouse:{firstName:"David",lastName:"Williams",phone:"770-555-0711",dob:"1969-08-05",employer:"UPS Driver",income:"$62,000",immigrationStatus:"us_citizen",ssn:"900-77-1122"}, dependents:[], notes:"Homeowners + renters for rental property. Annual review in April.", createdAt:"2025-09-15" }, { id:"c8", firstName:"Diego", lastName:"Ramirez", phone:"713-555-0831", email:"dramirez@example.com", dob:"1978-11-30", status:"active", preferredLang:"spanish", maritalStatus:"married", addressStreet:"1500 Louisiana St Suite 400", addressCity:"Houston", addressState:"TX", addressZip:"77002", annualIncome:"$120,000", employer:"Owner - Ramirez Construction LLC", immigrationStatus:"us_citizen", ssn:"900-88-9900", householdSize:"4", insuredMembers:"4", spouse:{firstName:"Monica",lastName:"Ramirez",phone:"713-555-0832",dob:"1982-04-15",employer:"Office Manager",income:"$45,000",immigrationStatus:"permanent_resident",ssn:"900-88-1122"}, dependents:[{id:"d40",firstName:"Sebastian",lastName:"Ramirez",relation:"child",dob:"2010-01-25",employer:"",income:"",immigrationStatus:"us_citizen",ssn:"",separateProfile:false,insured:true},{id:"d41",firstName:"Valentina",lastName:"Ramirez",relation:"child",dob:"2013-07-12",employer:"",income:"",immigrationStatus:"us_citizen",ssn:"",separateProfile:false,insured:true}], notes:"Business owner - commercial + umbrella. Needs annual liability review.", createdAt:"2025-10-02" }, { id:"c9", firstName:"Carmen", lastName:"Villanueva", phone:"305-555-0941", email:"cvillanueva@example.com", dob:"1975-03-14", status:"active", preferredLang:"spanish", maritalStatus:"married", addressStreet:"8820 NW 22nd Ave Apt 4C", addressCity:"Miami", addressState:"FL", addressZip:"33147", annualIncome:"$52,000", employer:"Miami-Dade County Schools", immigrationStatus:"permanent_resident", ssn:"900-44-1234", householdSize:"5", insuredMembers:"4", spouse:{ firstName:"Roberto", lastName:"Villanueva", phone:"305-555-0942", dob:"1972-08-22", employer:"US Foods", income:"$61,000", immigrationStatus:"permanent_resident", ssn:"900-44-5678" }, dependents:[ { id:"d1", firstName:"Sofia", lastName:"Villanueva", relation:"child", dob:"2000-07-10", employer:"", income:"", immigrationStatus:"us_citizen", ssn:"", separateProfile:false, insured:true }, { id:"d2", firstName:"Miguel", lastName:"Villanueva", relation:"child", dob:"2011-09-03", employer:"", income:"", immigrationStatus:"us_citizen", ssn:"", separateProfile:false, insured:true }, { id:"d3", firstName:"Daniela", lastName:"Villanueva", relation:"child", dob:"1997-02-18", employer:"Target Corp", income:"$28,000", immigrationStatus:"permanent_resident", ssn:"900-44-9012", separateProfile:true, separateProfileId:"c9d", insured:false } ], refFirstName:"Maria", refLastName:"Rodriguez", refPhone:"305-555-0101", notes:"Grupo familiar con hija mayor de 26 (Daniela) con perfil separado.", createdAt:"2025-11-05" }, { id:"c9d", firstName:"Daniela", lastName:"Villanueva", phone:"305-555-0943", email:"dvillanueva@example.com", dob:"1997-02-18", status:"active", preferredLang:"spanish", maritalStatus:"single", addressStreet:"8820 NW 22nd Ave Apt 4C", addressCity:"Miami", addressState:"FL", addressZip:"33147", annualIncome:"$28,000", employer:"Target Corp", immigrationStatus:"permanent_resident", ssn:"900-44-9012", householdSize:"1", insuredMembers:"1", linkedParentId:"c9", linkedParentName:"Carmen Villanueva", spouse:{firstName:"",lastName:"",phone:"",dob:"",employer:"",income:"",immigrationStatus:"",ssn:""}, dependents:[], refFirstName:"", refLastName:"", refPhone:"", notes:"Dependiente mayor de edad de Carmen Villanueva (grupo familiar). Póliza individual.", createdAt:"2025-11-05" },
  // ── c10-c29: cartera ampliada del demo (2026-08). Todo inventado — nombres,
  // teléfonos 555, correos example.com y SSN 900-xx (rango inválido real).
  { id:"c10", firstName:"Yolanda", lastName:"Castillo", phone:"305-555-1010", email:"ycastillo@example.com", dob:"1983-09-08", status:"active", preferredLang:"spanish", maritalStatus:"married", addressStreet:"2740 SW 8th St Apt 12", addressCity:"Miami", addressState:"FL", addressZip:"33135", annualIncome:"$46,000", employer:"Baptist Health (Housekeeping)", immigrationStatus:"permanent_resident", ssn:"900-10-1010", householdSize:"3", insuredMembers:"3", spouse:{firstName:"Andres",lastName:"Castillo",phone:"305-555-1011",dob:"1980-01-19",employer:"Uber / Lyft",income:"$29,000",immigrationStatus:"permanent_resident",ssn:"900-10-2020"}, dependents:[{id:"d50",firstName:"Camila",lastName:"Castillo",relation:"child",dob:"2014-05-02",employer:"",income:"",immigrationStatus:"us_citizen",ssn:"",separateProfile:false,insured:true}], refFirstName:"Carmen", refLastName:"Villanueva", refPhone:"305-555-0941", notes:"Referida por Carmen Villanueva. Renovar ACA en OEP con ingreso actualizado.", createdAt:"2025-12-01" },
  { id:"c11", firstName:"Pedro", lastName:"Alvarez", phone:"786-555-1102", email:"palvarez@example.com", dob:"1990-05-17", status:"active", preferredLang:"spanish", maritalStatus:"single", addressStreet:"961 E 25th St", addressCity:"Hialeah", addressState:"FL", addressZip:"33013", annualIncome:"$34,500", employer:"Amazon DSP (Driver)", immigrationStatus:"us_citizen", ssn:"900-11-1102", householdSize:"1", insuredMembers:"1", spouse:{firstName:"",lastName:"",phone:"",dob:"",employer:"",income:"",immigrationStatus:"",ssn:""}, dependents:[], notes:"Pidió agregar dental este año. Contacto preferido: WhatsApp.", createdAt:"2026-01-08" },
  { id:"c12", firstName:"Rosa", lastName:"Jimenez", phone:"407-555-1203", email:"rjimenez@example.com", dob:"1957-10-02", status:"active", preferredLang:"spanish", maritalStatus:"widowed", addressStreet:"4418 Curry Ford Rd", addressCity:"Orlando", addressState:"FL", addressZip:"32806", annualIncome:"$21,000", employer:"Retired", immigrationStatus:"us_citizen", ssn:"900-12-1203", householdSize:"1", insuredMembers:"1", spouse:{firstName:"",lastName:"",phone:"",dob:"",employer:"",income:"",immigrationStatus:"",ssn:""}, dependents:[], notes:"Medicare Advantage $0. Hija Marta ayuda con el papeleo — copiarla en los correos.", createdAt:"2025-11-20" },
  { id:"c13", firstName:"Miguel", lastName:"Santos", phone:"813-555-1304", email:"msantos@example.com", dob:"1987-01-23", status:"active", preferredLang:"spanish", maritalStatus:"married", addressStreet:"8206 N Armenia Ave", addressCity:"Tampa", addressState:"FL", addressZip:"33604", annualIncome:"$58,000", employer:"HVAC Tech (self-employed)", immigrationStatus:"us_citizen", ssn:"900-13-1304", householdSize:"2", insuredMembers:"2", spouse:{firstName:"Paola",lastName:"Santos",phone:"813-555-1305",dob:"1989-11-12",employer:"Publix",income:"$26,000",immigrationStatus:"permanent_resident",ssn:"900-13-2305"}, dependents:[], notes:"Ingreso variable (1099) — revisar estimado antes de renovar el subsidio.", createdAt:"2026-01-15" },
  { id:"c14", firstName:"Gladys", lastName:"Herrera", phone:"305-555-1405", email:"gherrera@example.com", dob:"1954-12-11", status:"active", preferredLang:"spanish", maritalStatus:"widowed", addressStreet:"1180 W Flagler St Apt 305", addressCity:"Miami", addressState:"FL", addressZip:"33130", annualIncome:"$19,500", employer:"Retired", immigrationStatus:"us_citizen", ssn:"900-14-1405", householdSize:"1", insuredMembers:"1", spouse:{firstName:"",lastName:"",phone:"",dob:"",employer:"",income:"",immigrationStatus:"",ssn:""}, dependents:[], notes:"Dual eligible (Medicare + Medicaid). Prefiere llamadas por la mañana.", createdAt:"2025-12-10" },
  { id:"c15", firstName:"Jorge", lastName:"Paredes", phone:"407-555-1506", email:"jparedes@example.com", dob:"1993-06-30", status:"pending", preferredLang:"spanish", maritalStatus:"married", addressStreet:"2331 Fortune Rd", addressCity:"Kissimmee", addressState:"FL", addressZip:"34744", annualIncome:"$39,000", employer:"Disney (Food Services)", immigrationStatus:"work_permit", ssn:"900-15-1506", householdSize:"2", insuredMembers:"1", spouse:{firstName:"Mariela",lastName:"Paredes",phone:"",dob:"1995-02-08",employer:"",income:"",immigrationStatus:"pending",ssn:""}, dependents:[], notes:"Aplicación ACA en proceso — falta prueba del permiso de trabajo (EAD).", createdAt:"2026-02-05" },
  { id:"c16", firstName:"Barbara", lastName:"Mitchell", phone:"941-555-1607", email:"bmitchell@example.com", dob:"1959-04-04", status:"active", preferredLang:"english", maritalStatus:"single", addressStreet:"5219 Fruitville Rd", addressCity:"Sarasota", addressState:"FL", addressZip:"34232", annualIncome:"$47,000", employer:"Retired (Nurse)", immigrationStatus:"us_citizen", ssn:"900-16-1607", householdSize:"1", insuredMembers:"1", spouse:{firstName:"",lastName:"",phone:"",dob:"",employer:"",income:"",immigrationStatus:"",ssn:""}, dependents:[], notes:"Medigap G since Feb. Ask about dental add-on at annual review.", createdAt:"2026-01-28" },
  { id:"c17", firstName:"Luis", lastName:"Ortega", phone:"305-555-1708", email:"lortega@example.com", dob:"1981-08-19", status:"active", preferredLang:"spanish", maritalStatus:"married", addressStreet:"10650 NW 41st St", addressCity:"Doral", addressState:"FL", addressZip:"33178", annualIncome:"$88,000", employer:"Freight Broker (LLC propia)", immigrationStatus:"us_citizen", ssn:"900-17-1708", householdSize:"2", insuredMembers:"2", spouse:{firstName:"Daniela",lastName:"Ortega",phone:"305-555-1709",dob:"1984-03-16",employer:"Realtor",income:"$41,000",immigrationStatus:"us_citizen",ssn:"900-17-2709"}, dependents:[], notes:"Gold + term life. Candidato a umbrella cuando compre la segunda propiedad.", createdAt:"2026-02-12" },
  { id:"c18", firstName:"Teresa", lastName:"Nunez", phone:"786-555-1809", email:"tnunez@example.com", dob:"1986-03-27", status:"active", preferredLang:"spanish", maritalStatus:"married", addressStreet:"540 W 29th St", addressCity:"Hialeah", addressState:"FL", addressZip:"33012", annualIncome:"$44,000", employer:"Elena's Bakery (co-owner)", immigrationStatus:"permanent_resident", ssn:"900-18-1809", householdSize:"5", insuredMembers:"5", spouse:{firstName:"Ramon",lastName:"Nunez",phone:"786-555-1810",dob:"1983-07-21",employer:"Elena's Bakery (co-owner)",income:"$44,000",immigrationStatus:"permanent_resident",ssn:"900-18-2810"}, dependents:[{id:"d60",firstName:"Alejandra",lastName:"Nunez",relation:"child",dob:"2009-10-30",employer:"",income:"",immigrationStatus:"us_citizen",ssn:"",separateProfile:false,insured:true},{id:"d61",firstName:"Bruno",lastName:"Nunez",relation:"child",dob:"2012-12-14",employer:"",income:"",immigrationStatus:"us_citizen",ssn:"",separateProfile:false,insured:true},{id:"d62",firstName:"Clara",lastName:"Nunez",relation:"child",dob:"2018-04-09",employer:"",income:"",immigrationStatus:"us_citizen",ssn:"",separateProfile:false,insured:true}], notes:"Familia de 5, negocio propio. Revisar ingreso del negocio antes de OEP.", createdAt:"2026-02-20" },
  { id:"c19", firstName:"Frank", lastName:"Delgado", phone:"239-555-1910", email:"fdelgado@example.com", dob:"1976-07-07", status:"active", preferredLang:"english", maritalStatus:"married", addressStreet:"1822 SE 46th Ln", addressCity:"Cape Coral", addressState:"FL", addressZip:"33904", annualIncome:"$74,000", employer:"Lee County Utilities", immigrationStatus:"us_citizen", ssn:"900-19-1910", householdSize:"2", insuredMembers:"2", spouse:{firstName:"Nancy",lastName:"Delgado",phone:"239-555-1911",dob:"1978-09-02",employer:"Dental Hygienist",income:"$52,000",immigrationStatus:"us_citizen",ssn:"900-19-2911"}, dependents:[], notes:"Auto + homeowners bundle. Shop rates at renewal — roof replaced 2025.", createdAt:"2026-03-03" },
  { id:"c20", firstName:"Marisol", lastName:"Rivas", phone:"305-555-2011", email:"mrivas@example.com", dob:"1995-11-15", status:"prospect", preferredLang:"spanish", maritalStatus:"single", addressStreet:"15720 SW 88th St Apt 210", addressCity:"Miami", addressState:"FL", addressZip:"33196", annualIncome:"$37,000", employer:"Nail Salon (self-employed)", immigrationStatus:"us_citizen", ssn:"", householdSize:"1", insuredMembers:"1", spouse:{firstName:"",lastName:"",phone:"",dob:"",employer:"",income:"",immigrationStatus:"",ssn:""}, dependents:[], notes:"Cotización ACA Bronze/Silver enviada — dar seguimiento la próxima semana.", createdAt:"2026-07-18" },
  { id:"c21", firstName:"Hector", lastName:"Baez", phone:"404-555-2112", email:"hbaez@example.com", dob:"1984-02-09", status:"active", preferredLang:"spanish", maritalStatus:"married", addressStreet:"2890 Campbellton Rd SW", addressCity:"Atlanta", addressState:"GA", addressZip:"30311", annualIncome:"$49,000", employer:"Roofing Crew Lead", immigrationStatus:"permanent_resident", ssn:"900-21-2112", householdSize:"2", insuredMembers:"2", spouse:{firstName:"Lorena",lastName:"Baez",phone:"404-555-2113",dob:"1986-06-18",employer:"Cleaning Services",income:"$21,000",immigrationStatus:"permanent_resident",ssn:"900-21-3113"}, dependents:[], notes:"Cliente de GA — verificar red del plan al renovar (viaja a FL seguido).", createdAt:"2026-03-10" },
  { id:"c22", firstName:"Sandra", lastName:"Whitfield", phone:"770-555-2213", email:"swhitfield@example.com", dob:"1956-09-21", status:"active", preferredLang:"english", maritalStatus:"divorced", addressStreet:"1470 Powder Springs Rd", addressCity:"Marietta", addressState:"GA", addressZip:"30064", annualIncome:"$33,000", employer:"Retired (Teacher)", immigrationStatus:"us_citizen", ssn:"900-22-2213", householdSize:"1", insuredMembers:"1", spouse:{firstName:"",lastName:"",phone:"",dob:"",employer:"",income:"",immigrationStatus:"",ssn:""}, dependents:[], notes:"Medigap N + PDP. Review drug list every October before AEP.", createdAt:"2026-03-18" },
  { id:"c23", firstName:"Omar", lastName:"Guzman", phone:"713-555-2314", email:"oguzman@example.com", dob:"1989-12-05", status:"active", preferredLang:"spanish", maritalStatus:"married", addressStreet:"9330 Richmond Ave Apt 522", addressCity:"Houston", addressState:"TX", addressZip:"77063", annualIncome:"$63,000", employer:"Oil Field Services (W2)", immigrationStatus:"us_citizen", ssn:"900-23-2314", householdSize:"2", insuredMembers:"2", spouse:{firstName:"Karla",lastName:"Guzman",phone:"713-555-2315",dob:"1992-08-25",employer:"Daycare Assistant",income:"$19,000",immigrationStatus:"permanent_resident",ssn:"900-23-3315"}, dependents:[], notes:"ACA + IUL. Esperan bebé en diciembre — agregar al plan en cuanto nazca (QLE).", createdAt:"2026-04-02" },
  { id:"c24", firstName:"Ines", lastName:"Salazar", phone:"512-555-2415", email:"isalazar@example.com", dob:"1998-04-26", status:"active", preferredLang:"spanish", maritalStatus:"single", addressStreet:"6800 Manchaca Rd Apt 134", addressCity:"Austin", addressState:"TX", addressZip:"78745", annualIncome:"$31,500", employer:"H-E-B", immigrationStatus:"daca", ssn:"900-24-2415", householdSize:"1", insuredMembers:"1", spouse:{firstName:"",lastName:"",phone:"",dob:"",employer:"",income:"",immigrationStatus:"",ssn:""}, dependents:[], notes:"Primer año con ACA. Recordarle que el subsidio depende de renovar el DACA a tiempo.", createdAt:"2026-04-15" },
  { id:"c25", firstName:"Ricardo", lastName:"Pena", phone:"407-555-2516", email:"rpena@example.com", dob:"1991-10-14", status:"inactive", preferredLang:"spanish", maritalStatus:"single", addressStreet:"5905 Raleigh St Apt 812", addressCity:"Orlando", addressState:"FL", addressZip:"32835", annualIncome:"$45,000", employer:"Siemens Energy", immigrationStatus:"us_citizen", ssn:"900-25-2516", householdSize:"1", insuredMembers:"1", spouse:{firstName:"",lastName:"",phone:"",dob:"",employer:"",income:"",immigrationStatus:"",ssn:""}, dependents:[], notes:"Se mudó a Carolina del Norte en junio — póliza cancelada. Mantener contacto por si regresa.", createdAt:"2025-12-18" },
  { id:"c26", firstName:"Dorothy", lastName:"Klein", phone:"239-555-2617", email:"dklein@example.com", dob:"1951-05-30", status:"active", preferredLang:"english", maritalStatus:"widowed", addressStreet:"3418 Gulf Shore Blvd N Apt 5C", addressCity:"Naples", addressState:"FL", addressZip:"34103", annualIncome:"$61,000", employer:"Retired", immigrationStatus:"us_citizen", ssn:"900-26-2617", householdSize:"1", insuredMembers:"1", spouse:{firstName:"",lastName:"",phone:"",dob:"",employer:"",income:"",immigrationStatus:"",ssn:""}, dependents:[], notes:"Medigap G + PDP. Snowbird — pasa jun-sep en Michigan; solo correo en verano.", createdAt:"2026-04-22" },
  { id:"c27", firstName:"Alejandro", lastName:"Fuentes", phone:"305-555-2718", email:"afuentes@example.com", dob:"1979-06-24", status:"active", preferredLang:"spanish", maritalStatus:"married", addressStreet:"7290 SW 40th St", addressCity:"Miami", addressState:"FL", addressZip:"33155", annualIncome:"$132,000", employer:"Owner - Restaurante La Palma", immigrationStatus:"us_citizen", ssn:"900-27-2718", householdSize:"4", insuredMembers:"4", spouse:{firstName:"Beatriz",lastName:"Fuentes",phone:"305-555-2719",dob:"1982-10-08",employer:"Restaurante La Palma (Admin)",income:"$38,000",immigrationStatus:"us_citizen",ssn:"900-27-3719"}, dependents:[{id:"d70",firstName:"Emilia",lastName:"Fuentes",relation:"child",dob:"2011-01-17",employer:"",income:"",immigrationStatus:"us_citizen",ssn:"",separateProfile:false,insured:true},{id:"d71",firstName:"Tomas",lastName:"Fuentes",relation:"child",dob:"2015-08-03",employer:"",income:"",immigrationStatus:"us_citizen",ssn:"",separateProfile:false,insured:true}], notes:"Restaurante con 12 empleados: BOP + umbrella. Preguntó por plan de salud grupal para 2027.", createdAt:"2026-05-06" },
  { id:"c28", firstName:"Vilma", lastName:"Contreras", phone:"561-555-2819", email:"vcontreras@example.com", dob:"1988-09-13", status:"active", preferredLang:"spanish", maritalStatus:"married", addressStreet:"4795 Okeechobee Blvd Apt 209", addressCity:"West Palm Beach", addressState:"FL", addressZip:"33417", annualIncome:"$41,000", employer:"Home Health Aide", immigrationStatus:"tps", ssn:"900-28-2819", householdSize:"2", insuredMembers:"2", spouse:{firstName:"Danilo",lastName:"Contreras",phone:"561-555-2820",dob:"1985-04-11",employer:"Landscaping",income:"$27,000",immigrationStatus:"tps",ssn:"900-28-3820"}, dependents:[], notes:"Silver con subsidio. Póliza en período de gracia — pago de agosto pendiente, llamar esta semana.", createdAt:"2026-05-19" },
  { id:"c29", firstName:"Kevin", lastName:"Brooks", phone:"813-555-2920", email:"kbrooks@example.com", dob:"1994-01-31", status:"referral", preferredLang:"english", maritalStatus:"single", addressStreet:"2610 W Kennedy Blvd Apt 8", addressCity:"Tampa", addressState:"FL", addressZip:"33609", annualIncome:"$71,000", employer:"Software QA (remote)", immigrationStatus:"us_citizen", ssn:"", householdSize:"1", insuredMembers:"1", spouse:{firstName:"",lastName:"",phone:"",dob:"",employer:"",income:"",immigrationStatus:"",ssn:""}, dependents:[], refFirstName:"James", refLastName:"Thompson", refPhone:"941-555-0234", notes:"Referido por James Thompson. Interesado en term life $500k — agendar llamada.", createdAt:"2026-08-12" },
];

const SEED_POLICIES = [ { id:"p9a", clientId:"c9", type:"aca", carrier:"Oscar", plan:"Silver Select PPO", policyNumber:"OSC-2025-9441", memberId:"OSC-M-9441", monthlyPremium:"185.00", subsidy:"642.00", planTotalCost:"827.00", deductible:"2500", outOfPocketMax:"$9,200", pcpCopay:"$30", specialistCopay:"$60", erCopay:"$500", genericDrugCopay:"$15", familySize:"4", membersActive:"4", effectiveDate:"2025-01-01", renewalDate:"2026-12-31", status:"active", policyInsured:["d1","d2","d3"], policyInsuredExtra:["Roberto Villanueva"] }, { id:"p9d", clientId:"c9d", type:"aca", carrier:"CareFirst", plan:"BlueChoice Gold HMO", policyNumber:"CF-2025-1197", memberId:"CF-M-1197", monthlyPremium:"312.00", familySize:"1", membersActive:"1", effectiveDate:"2025-01-01", renewalDate:"2026-12-31", status:"active" }, { id:"p1", clientId:"c1", type:"ma", carrier:"Aetna", plan:"Medicare Advantage HMO", policyNumber:"AET-2024-0891", memberId:"AET-M-100291", monthlyPremium:"42.50", familySize:"1", membersActive:"1", effectiveDate:"2024-01-01", renewalDate:"2026-12-31", status:"active" }, { id:"p2", clientId:"c1", type:"dental", carrier:"Delta Dental", plan:"Dental Plus", policyNumber:"DD-2024-1122", memberId:"DD-M-991", monthlyPremium:"28.00", familySize:"1", membersActive:"1", effectiveDate:"2024-01-01", renewalDate:"2026-12-31", status:"active" }, { id:"p3", clientId:"c2", type:"medsup", carrier:"Humana", plan:"Medigap Plan G", policyNumber:"HUM-G-44521", memberId:"HUM-44521", monthlyPremium:"187.00", familySize:"2", membersActive:"2", effectiveDate:"2024-03-01", renewalDate:"2026-03-15", status:"active" }, { id:"p4", clientId:"c3", type:"aca", carrier:"CareFirst", plan:"ACA Silver Plan", policyNumber:"CF-SLV-2024-3312", memberId:"CF-33129", monthlyPremium:"215.00", familySize:"3", membersActive:"2", effectiveDate:"2024-01-01", renewalDate:"2026-04-01", status:"pending" }, { id:"p5", clientId:"c4", type:"partd", carrier:"WellCare", plan:"Medicare Part D", policyNumber:"WC-PD-88934", memberId:"WC-88934", monthlyPremium:"33.50", familySize:"1", membersActive:"1", effectiveDate:"2024-01-01", renewalDate:"2026-03-20", status:"active" }, { id:"p6", clientId:"c5", type:"aca", carrier:"Kaiser", plan:"ACA Bronze Plan", policyNumber:"KAI-BRZ-7721", memberId:"KAI-77210", monthlyPremium:"98.00", familySize:"4", membersActive:"3", effectiveDate:"2024-01-01", renewalDate:"2026-05-01", status:"prospect" }, { id:"p7", clientId:"c2", type:"life", carrier:"MetLife", plan:"Term Life 20yr", policyNumber:"MET-TL-55210", memberId:"MET-55210", monthlyPremium:"45.00", familySize:"2", membersActive:"2", effectiveDate:"2020-06-01", renewalDate:"2040-06-01", status:"active" }, { id:"p8", clientId:"c6", type:"home", carrier:"State Farm", plan:"Homeowners HO-3", policyNumber:"SF-HO-2025-4421", memberId:"", monthlyPremium:"145.00", familySize:"1", membersActive:"1", effectiveDate:"2025-08-15", renewalDate:"2026-08-15", status:"active", propertyAddress:"72 Birch Lane, Rockville MD 20852", insuredValue:"$425,000" }, { id:"p9", clientId:"c6", type:"auto", carrier:"GEICO", plan:"Auto Full Coverage", policyNumber:"GEI-AUTO-8834", memberId:"", monthlyPremium:"210.00", familySize:"1", membersActive:"1", effectiveDate:"2025-08-15", renewalDate:"2026-08-15", status:"active", vehicleYear:"2022", vin:"1HGBH41JXMN109186" }, { id:"p10", clientId:"c6", type:"auto", carrier:"GEICO", plan:"Auto Liability", policyNumber:"GEI-AUTO-8835", memberId:"", monthlyPremium:"95.00", familySize:"1", membersActive:"1", effectiveDate:"2025-08-15", renewalDate:"2026-08-15", status:"active", vehicleYear:"2019", vin:"2T1BURHE0JC034672" }, { id:"p11", clientId:"c7", type:"home", carrier:"Allstate", plan:"Homeowners Standard", policyNumber:"ALL-HO-7712", memberId:"", monthlyPremium:"162.00", familySize:"1", membersActive:"1", effectiveDate:"2025-09-01", renewalDate:"2026-09-01", status:"active", propertyAddress:"3300 Sunrise Ave, Bowie MD 20715", insuredValue:"$380,000" }, { id:"p12", clientId:"c7", type:"renters", carrier:"Allstate", plan:"Renters Plus", policyNumber:"ALL-RNT-5503", memberId:"", monthlyPremium:"22.00", familySize:"1", membersActive:"1", effectiveDate:"2025-09-01", renewalDate:"2026-09-01", status:"active", propertyAddress:"88 Oak Court Apt 2, Rockville MD 20850" }, { id:"p13", clientId:"c8", type:"commercial", carrier:"Hartford", plan:"BOP Business Owners", policyNumber:"HFD-BOP-3391", memberId:"", monthlyPremium:"385.00", familySize:"1", membersActive:"1", effectiveDate:"2025-10-01", renewalDate:"2026-10-01", status:"active", propertyAddress:"1500 K St NW Suite 400, Washington DC 20005" }, { id:"p14", clientId:"c8", type:"umbrella", carrier:"Hartford", plan:"Commercial Umbrella $2M", policyNumber:"HFD-UMB-3392", memberId:"", monthlyPremium:"125.00", familySize:"1", membersActive:"1", effectiveDate:"2025-10-01", renewalDate:"2026-10-01", status:"active" },
  // ── p15+: pólizas de la cartera ampliada (c10-c28) ──
  { id:"p15", clientId:"c10", type:"aca", carrier:"Ambetter", plan:"Balanced Care Silver 4", policyNumber:"AMB-2026-3310", memberId:"AMB-M-3310", monthlyPremium:"128.00", familySize:"3", membersActive:"3", effectiveDate:"2026-01-01", renewalDate:"2026-12-31", status:"active" },
  { id:"p16", clientId:"c11", type:"aca", carrier:"Oscar", plan:"Bronze Classic HMO", policyNumber:"OSC-2026-5512", memberId:"OSC-M-5512", monthlyPremium:"76.00", familySize:"1", membersActive:"1", effectiveDate:"2026-02-01", renewalDate:"2026-12-31", status:"active" },
  { id:"p17", clientId:"c11", type:"dental", carrier:"Delta Dental", plan:"PPO Basic", policyNumber:"DD-2026-8802", memberId:"DD-M-8802", monthlyPremium:"24.00", familySize:"1", membersActive:"1", effectiveDate:"2026-02-01", renewalDate:"2026-12-31", status:"active" },
  { id:"p18", clientId:"c12", type:"ma", carrier:"Humana", plan:"Gold Plus HMO", policyNumber:"HUM-MA-66120", memberId:"HUM-M-66120", monthlyPremium:"0.00", familySize:"1", membersActive:"1", effectiveDate:"2026-01-01", renewalDate:"2026-12-31", status:"active" },
  { id:"p19", clientId:"c13", type:"aca", carrier:"Florida Blue", plan:"BlueSelect Silver 1443", policyNumber:"FB-2026-7301", memberId:"FB-M-7301", monthlyPremium:"164.00", familySize:"2", membersActive:"2", effectiveDate:"2026-02-01", renewalDate:"2026-12-31", status:"active" },
  { id:"p20", clientId:"c14", type:"ma", carrier:"Aetna", plan:"Medicare Eagle PPO", policyNumber:"AET-MA-77401", memberId:"AET-M-77401", monthlyPremium:"0.00", familySize:"1", membersActive:"1", effectiveDate:"2026-01-01", renewalDate:"2026-12-31", status:"active" },
  { id:"p21", clientId:"c14", type:"dental", carrier:"Delta Dental", plan:"Dental Plus", policyNumber:"DD-2026-9917", memberId:"DD-M-9917", monthlyPremium:"26.00", familySize:"1", membersActive:"1", effectiveDate:"2026-02-01", renewalDate:"2026-12-31", status:"active" },
  { id:"p22", clientId:"c15", type:"aca", carrier:"Ambetter", plan:"Everyday Bronze", policyNumber:"AMB-2026-4470", memberId:"AMB-M-4470", monthlyPremium:"42.00", familySize:"2", membersActive:"1", effectiveDate:"2026-03-01", renewalDate:"2026-12-31", status:"pending" },
  { id:"p23", clientId:"c16", type:"medsup", carrier:"Mutual of Omaha", plan:"Medigap Plan G", policyNumber:"MOO-G-21055", memberId:"MOO-21055", monthlyPremium:"156.00", familySize:"1", membersActive:"1", effectiveDate:"2026-02-01", renewalDate:"2027-02-01", status:"active" },
  { id:"p24", clientId:"c17", type:"aca", carrier:"Florida Blue", plan:"BlueOptions Gold", policyNumber:"FB-2026-8815", memberId:"FB-M-8815", monthlyPremium:"231.00", familySize:"2", membersActive:"2", effectiveDate:"2026-03-01", renewalDate:"2026-12-31", status:"active" },
  { id:"p25", clientId:"c17", type:"life", carrier:"Banner Life", plan:"Term Life 20yr $400k", policyNumber:"BAN-TL-30982", memberId:"BAN-30982", monthlyPremium:"38.00", familySize:"1", membersActive:"1", effectiveDate:"2026-03-01", renewalDate:"2046-03-01", status:"active" },
  { id:"p26", clientId:"c18", type:"aca", carrier:"Ambetter", plan:"Complete Silver", policyNumber:"AMB-2026-6603", memberId:"AMB-M-6603", monthlyPremium:"96.00", familySize:"5", membersActive:"5", effectiveDate:"2026-03-01", renewalDate:"2026-12-31", status:"active" },
  { id:"p27", clientId:"c19", type:"auto", carrier:"Progressive", plan:"Auto Full Coverage", policyNumber:"PRG-AUTO-4419", memberId:"", monthlyPremium:"188.00", familySize:"1", membersActive:"1", effectiveDate:"2026-03-15", renewalDate:"2027-03-15", status:"active", vehicleYear:"2021", vin:"5YJ3E1EA7MF873201" },
  { id:"p28", clientId:"c19", type:"home", carrier:"Universal Property", plan:"Homeowners HO-3", policyNumber:"UPC-HO-2026-118", memberId:"", monthlyPremium:"205.00", familySize:"1", membersActive:"1", effectiveDate:"2026-03-15", renewalDate:"2027-03-15", status:"active", propertyAddress:"1822 SE 46th Ln, Cape Coral FL 33904", insuredValue:"$342,000" },
  { id:"p29", clientId:"c21", type:"aca", carrier:"Ambetter", plan:"Peach State Silver", policyNumber:"AMB-GA-2210", memberId:"AMB-M-2210", monthlyPremium:"143.00", familySize:"2", membersActive:"2", effectiveDate:"2026-03-01", renewalDate:"2026-12-31", status:"active" },
  { id:"p30", clientId:"c22", type:"partd", carrier:"WellCare", plan:"Value Script PDP", policyNumber:"WC-PD-91427", memberId:"WC-91427", monthlyPremium:"12.40", familySize:"1", membersActive:"1", effectiveDate:"2026-01-01", renewalDate:"2026-12-31", status:"active" },
  { id:"p31", clientId:"c22", type:"medsup", carrier:"Cigna", plan:"Medigap Plan N", policyNumber:"CIG-N-55307", memberId:"CIG-55307", monthlyPremium:"118.00", familySize:"1", membersActive:"1", effectiveDate:"2026-04-01", renewalDate:"2027-04-01", status:"active" },
  { id:"p32", clientId:"c23", type:"aca", carrier:"BCBS Texas", plan:"MyBlue Silver 405", policyNumber:"BCTX-2026-7742", memberId:"BCTX-M-7742", monthlyPremium:"176.00", familySize:"2", membersActive:"2", effectiveDate:"2026-04-01", renewalDate:"2026-12-31", status:"active" },
  { id:"p33", clientId:"c23", type:"life", carrier:"Mutual of Omaha", plan:"IUL Express $250k", policyNumber:"MOO-IUL-8830", memberId:"MOO-8830", monthlyPremium:"92.00", familySize:"1", membersActive:"1", effectiveDate:"2026-05-01", renewalDate:"2046-05-01", status:"active" },
  { id:"p34", clientId:"c24", type:"aca", carrier:"Ambetter", plan:"CelticCare Bronze", policyNumber:"AMB-TX-5521", memberId:"AMB-M-5521", monthlyPremium:"58.00", familySize:"1", membersActive:"1", effectiveDate:"2026-05-01", renewalDate:"2026-12-31", status:"active" },
  { id:"p35", clientId:"c25", type:"aca", carrier:"Oscar", plan:"Silver Simple", policyNumber:"OSC-2026-2201", memberId:"OSC-M-2201", monthlyPremium:"149.00", familySize:"1", membersActive:"1", effectiveDate:"2026-01-01", renewalDate:"2026-12-31", status:"cancelled" },
  { id:"p36", clientId:"c26", type:"medsup", carrier:"Humana", plan:"Medigap Plan G", policyNumber:"HUM-G-70233", memberId:"HUM-70233", monthlyPremium:"172.00", familySize:"1", membersActive:"1", effectiveDate:"2026-05-01", renewalDate:"2027-05-01", status:"active" },
  { id:"p37", clientId:"c26", type:"partd", carrier:"Humana", plan:"Premier Rx PDP", policyNumber:"HUM-PD-70234", memberId:"HUM-70234", monthlyPremium:"28.60", familySize:"1", membersActive:"1", effectiveDate:"2026-05-01", renewalDate:"2026-12-31", status:"active" },
  { id:"p38", clientId:"c27", type:"commercial", carrier:"Hartford", plan:"BOP Restaurante", policyNumber:"HFD-BOP-5501", memberId:"", monthlyPremium:"296.00", familySize:"1", membersActive:"1", effectiveDate:"2026-05-15", renewalDate:"2027-05-15", status:"active", propertyAddress:"7290 SW 40th St, Miami FL 33155" },
  { id:"p39", clientId:"c27", type:"umbrella", carrier:"Hartford", plan:"Commercial Umbrella $1M", policyNumber:"HFD-UMB-5502", memberId:"", monthlyPremium:"88.00", familySize:"1", membersActive:"1", effectiveDate:"2026-05-15", renewalDate:"2027-05-15", status:"active" },
  { id:"p40", clientId:"c28", type:"aca", carrier:"Florida Blue", plan:"BlueCare Silver 1452", policyNumber:"FB-2026-9928", memberId:"FB-M-9928", monthlyPremium:"152.00", familySize:"2", membersActive:"2", effectiveDate:"2026-06-01", renewalDate:"2026-12-31", status:"grace" },
];

// ── PDF generator: builds a valid multi-line PDF with correct xref offsets ──
// Used for seeded demo documents and for signed-signature copies so the View
// button can render a real PDF inside the FilePreviewModal iframe.
function buildPdf(lines) {
  const safe = (s) => String(s || "").replace(/\\/g, "\\\\").replace(/\(/g, "\\(").replace(/\)/g, "\\)");
  // Build content stream: 12pt Helvetica, 1in margins, ~18pt line spacing.
  // Start cursor high on the page and walk down.
  const cmds = ["BT", "/F1 12 Tf", "72 720 Td"];
  lines.forEach((ln, i) => {
    if (i === 0) cmds.push("/F1 16 Tf", `(${safe(ln)}) Tj`, "/F1 12 Tf", "0 -28 Td");
    else { cmds.push(`(${safe(ln)}) Tj`); cmds.push("0 -18 Td"); }
  });
  cmds.push("ET");
  const stream = cmds.join("\n");
  const objs = [
    "<< /Type /Catalog /Pages 2 0 R >>",
    "<< /Type /Pages /Kids [3 0 R] /Count 1 /MediaBox [0 0 612 792] >>",
    "<< /Type /Page /Parent 2 0 R /Resources << /Font << /F1 5 0 R >> >> /Contents 4 0 R >>",
    `<< /Length ${stream.length} >>\nstream\n${stream}\nendstream`,
    "<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica >>",
  ];
  let out = "%PDF-1.4\n";
  const offsets = [0];
  for (let i = 0; i < objs.length; i++) {
    offsets.push(out.length);
    out += `${i + 1} 0 obj\n${objs[i]}\nendobj\n`;
  }
  const xrefStart = out.length;
  out += `xref\n0 ${objs.length + 1}\n`;
  out += "0000000000 65535 f \n";
  for (let i = 1; i <= objs.length; i++) {
    out += String(offsets[i]).padStart(10, "0") + " 00000 n \n";
  }
  out += `trailer\n<< /Size ${objs.length + 1} /Root 1 0 R >>\nstartxref\n${xrefStart}\n%%EOF\n`;
  // Convert to base64 data URL. Strip any non-Latin1 chars so btoa never chokes.
  const ascii = out.replace(/[^\x00-\xff]/g, "?");
  let b64;
  if (typeof btoa !== "undefined") b64 = btoa(ascii);
  else if (typeof Buffer !== "undefined") b64 = Buffer.from(ascii, "binary").toString("base64");
  else b64 = ascii;
  return "data:application/pdf;base64," + b64;
}

// Strip diacritics and replace curly quotes/dashes so content round-trips
// through PDF's Latin1 font safely.
function asciiFold(s) {
  return String(s || "")
    .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    .replace(/[\u2018\u2019\u201A\u201B]/g, "'")
    .replace(/[\u201C\u201D\u201E\u201F]/g, '"')
    .replace(/[\u2013\u2014]/g, "-")
    .replace(/\u2026/g, "...")
    .replace(/\u00A0/g, " ");
}

// Build a signed-document PDF for a given signature record.
function buildSignedDocPdf(sig, client, lang) {
  const es = lang === "es";
  const clientName = client ? `${client.firstName} ${client.lastName}` : (sig?.signerName || "Client");
  const lines = [
    sig?.type || "Signed Document",
    "",
    `${es ? "Cliente" : "Client"}: ${clientName}`,
    `${es ? "Enviado" : "Sent"}: ${sig?.sentAt || ""}`,
    `${es ? "Firmado" : "Signed"}: ${sig?.signedAt || ""}`,
    "",
    (sig?.filledBody || (es
      ? "Este es un documento de demostracion. El cliente ha firmado electronicamente este formulario y acepta todos los terminos descritos."
      : "This is a demo document. The client has electronically signed this form and agrees to all terms described herein.")),
    "",
    "",
    `${es ? "Firmado electronicamente por" : "Electronically signed by"}: ${sig?.signerName || clientName}`,
    sig?.signedAtFull ? `${es ? "Fecha/Hora" : "Date/Time"}: ${new Date(sig.signedAtFull).toLocaleString("en-US",{ dateStyle:"medium", timeStyle:"short" })}` : "",
    "",
    es
      ? "Firmado conforme a la Ley ESIGN (15 U.S.C. 7001) y UETA."
      : "Signed pursuant to the ESIGN Act (15 U.S.C. 7001) and UETA.",
    "Powered by Deskte — DALCERSERVICES LLC",
  ].filter(Boolean);
  // Wrap long lines at ~80 chars so they fit the page width
  const wrapped = [];
  lines.map(asciiFold).forEach(ln => {
    if (ln.length <= 80) { wrapped.push(ln); return; }
    let rest = ln;
    while (rest.length > 80) {
      let cut = rest.lastIndexOf(" ", 80);
      if (cut < 40) cut = 80;
      wrapped.push(rest.slice(0, cut));
      rest = rest.slice(cut).replace(/^\s+/, "");
    }
    if (rest) wrapped.push(rest);
  });
  return buildPdf(wrapped);
}

// ── Demo file data URLs (auto-generated — tiny but valid PDF/PNG/CSV/TXT) ──
const DEMO_PDF_MEDICARE = buildPdf([
  "MEDICARE CARD",
  "",
  "Name: Maria Rodriguez",
  "Medicare Number: 1EG4-TE5-MK73",
  "Part A (Hospital) Effective: 01-01-2024",
  "Part B (Medical) Effective: 01-01-2024",
  "",
  "This is a demo card reproduction for sales demo only.",
]);
const DEMO_PDF_HIPAA = buildPdf([
  "HIPAA CONSENT / AUTHORIZATION FOR RELEASE",
  "",
  "Patient: Maria Rodriguez",
  "Date of Birth: 03/15/1959",
  "",
  "I authorize Deskte Insurance Services to use and disclose my",
  "protected health information for the purpose of coordinating",
  "insurance coverage, claims processing, and communication with",
  "carriers on my behalf.",
  "",
  "This authorization is valid for one (1) year from the date of",
  "signing and may be revoked at any time in writing.",
  "",
  "Signed: Maria Rodriguez",
  "Date: 01/16/2026",
]);
const DEMO_PDF_MEDIGAP = buildPdf([
  "MEDIGAP PLAN G - POLICY DOCUMENT",
  "",
  "Insured: James Thompson",
  "Carrier: Humana",
  "Policy Number: HUM-G-44521",
  "Effective Date: 03/01/2024",
  "Monthly Premium: $187.00",
  "",
  "Plan G covers all Medicare Part A and Part B cost-sharing except",
  "the Part B deductible. This plan provides foreign travel emergency",
  "coverage up to plan limits.",
  "",
  "Benefits include:",
  "- Part A hospital copayments and coinsurance",
  "- Part B coinsurance and copayments",
  "- First three pints of blood",
  "- Skilled nursing facility coinsurance",
  "- Part A hospice care coinsurance",
  "- Part A deductible",
  "- Part B excess charges",
]);
const DEMO_PDF_INCOME = buildPdf([
  "INCOME VERIFICATION LETTER - 2024",
  "",
  "Client: James Thompson",
  "SSN: XXX-XX-4421",
  "",
  "This letter certifies that the above named individual reported",
  "the following income for tax year 2024:",
  "",
  "Wages (W-2): $48,500.00",
  "Self-employment income: $6,200.00",
  "Total Adjusted Gross Income: $54,700.00",
  "",
  "Household size: 2",
  "Used for ACA subsidy eligibility determination.",
  "",
  "Deskte Insurance Services",
  "Date: 03/11/2026",
]);
const DEMO_PDF_LIC_FL = buildPdf([
  "FLORIDA DEPARTMENT OF FINANCIAL SERVICES",
  "INSURANCE LICENSE CERTIFICATE",
  "",
  "Licensee: AGENCIA DEMO LLC",
  "License Number: FL-P234567",
  "Lines of Authority: Life, Health, Variable Annuity",
  "Issue Date: 01-15-2023",
  "Expiration Date: 01-15-2027",
  "Status: ACTIVE",
  "",
  "Continuing Education: 22 of 24 credits completed",
  "",
  "This license is issued pursuant to Chapter 626, Florida Statutes.",
]);
const DEMO_PDF_LIC_MD = buildPdf([
  "GEORGIA OFFICE OF INSURANCE",
  "PRODUCER LICENSE",
  "",
  "Licensee: AGENCIA DEMO LLC",
  "License Number: MD-H189234",
  "Lines of Authority: Health, Life",
  "Issue Date: 06-01-2022",
  "Expiration Date: 06-01-2026",
  "Status: ACTIVE",
  "",
  "Continuing Education: 14 of 16 credits completed",
]);
const DEMO_PNG_CARD     = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAIAAAD8GO2jAAAAKUlEQVR4nO3NQQkAAAgEsEtiZhtrCh/CYP+lek5FIBAIBAKBQCAQfAkWKZ60W665Z4AAAAAASUVORK5CYII=";
const DEMO_PNG_ID       = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAIAAAD8GO2jAAAAKklEQVR4nGPQO1NIU8QwasGoBaMWjFowasGoBaMWjFowasGoBaMWDBULAMPtrEzucPBfAAAAAElFTkSuQmCC";
const DEMO_PNG_LIC      = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAIAAAD8GO2jAAAAK0lEQVR4nGP4eISfpohh1IJRC0YtGLVg1IJRC0YtGLVg1IJRC0YtGCoWAAAWuRBq5HtVwQAAAABJRU5ErkJggg==";
const DEMO_CSV_COMMS    = "data:text/csv;base64,Q2xpZW50LENhcnJpZXIsUGxhbixNb250aCxBbW91bnQKTWFyaWEgUm9kcmlndWV6LEFldG5hLE1lZGljYXJlIEFkdmFudGFnZSwyMDI2LTAyLDQyLjUwCkphbWVzIFRob21wc29uLEh1bWFuYSxNZWRpZ2FwIEcsMjAyNi0wMiwxODcuMDAKQW5hIEd1dGllcnJleixDYXJlRmlyc3QsQUNBIFNpbHZlciwyMDI2LTAyLDIxNS4wMAo=";
const DEMO_TXT_NOTES    = "data:text/plain;base64,Q2xpZW50IG5vdGVzIC0gc2FtcGxlCgpNYXJpYSBjYWxsZWQgYWJvdXQgZGlhYmV0ZXMgbWVkaWNhdGlvbiBjb3ZlcmFnZS4KUmVjb21tZW5kZWQgU2lsdmVyIHBsYW4gdXBncmFkZSBzdGFydGluZyBNYXJjaC4KRm9sbG93aW5nIHVwIE1hcmNoIDFzdC4K";

const SEED_DOCS = [
  { id:"d1", clientId:"c1", name:"Medicare_Card_Rodriguez.pdf",       type:"Medicare Card",         uploadedAt:"2026-01-16", size:"312 KB", required:true,  data:DEMO_PDF_MEDICARE, mimeType:"application/pdf" },
  { id:"d2", clientId:"c1", name:"HIPAA_Consent_Signed.pdf",          type:"Consent Form",          uploadedAt:"2026-01-16", size:"88 KB",  required:true,  data:DEMO_PDF_HIPAA,    mimeType:"application/pdf" },
  { id:"d1b",clientId:"c1", name:"ID_Rodriguez_front.png",            type:"Government ID",         uploadedAt:"2026-08-22", size:"45 KB",  required:true,  data:DEMO_PNG_ID,       mimeType:"image/png" },
  { id:"d3", clientId:"c2", name:"Medigap_Policy_G.pdf",              type:"Policy Document",       uploadedAt:"2026-03-11", size:"1.2 MB", required:true,  data:DEMO_PDF_MEDIGAP,  mimeType:"application/pdf" },
  { id:"d3b",clientId:"c2", name:"Thompson_notes.txt",                type:"Notes",                 uploadedAt:"2026-09-19", size:"1 KB",   required:false, data:DEMO_TXT_NOTES,    mimeType:"text/plain" },
  { id:"d4", clientId:"c3", name:"Income_Verification_2024.pdf",      type:"Income Verification",   uploadedAt:null,         size:null,     required:true },
  { id:"d5", clientId:"c3", name:"HIPAA_Consent.pdf",                 type:"Consent Form",          uploadedAt:"2026-02-21", size:"88 KB",  required:true,  data:DEMO_PDF_HIPAA,    mimeType:"application/pdf" },
  { id:"d6", clientId:"c6", name:"Driver_License_Mendoza.png",        type:"Driver License",        uploadedAt:"2026-08-15", size:"52 KB",  required:true,  data:DEMO_PNG_LIC,      mimeType:"image/png" },
  { id:"d7", clientId:"c9", name:"Medicare_Card_Villanueva.png",      type:"Medicare Card",         uploadedAt:"2026-11-05", size:"48 KB",  required:true,  data:DEMO_PNG_CARD,     mimeType:"image/png" },
  { id:"d8", clientId:"c9", name:"Commissions_Q4_2025.csv",           type:"Commission Report",    uploadedAt:"2026-01-05", size:"2 KB",   required:false, data:DEMO_CSV_COMMS,    mimeType:"text/csv" },
];

const SEED_REQUESTS = [ { id:"r1", clientId:"c3", docs:[{ name:"Income Verification 2023", status:"pending" },{ name:"Government ID", status:"received" }], sentAt:"2024-02-22", link:"https://deskte.com/upload/r1abc123", email:"anag@example.com" },
  { id:"r2", clientId:"c9", docs:[{ name:"Tax Return 2024", status:"pending" },{ name:"Pay Stubs (3 months)", status:"pending" },{ name:"SSN Card - Roberto", status:"received" }], sentAt:"2025-11-10", link:"https://deskte.com/upload/r2def456", email:"cvillanueva@example.com" },
  { id:"r3", clientId:"c6", docs:[{ name:"Vehicle Registration - 2022 Honda", status:"received" },{ name:"Vehicle Registration - 2019 Toyota", status:"received" },{ name:"Driver License", status:"received" }], sentAt:"2025-08-12", link:"https://deskte.com/upload/r3ghi789", email:"cmendoza@example.com" },
  { id:"r4", clientId:"c5", docs:[{ name:"Proof of Address", status:"overdue" },{ name:"Income Letter", status:"pending" }], sentAt:"2025-12-01", link:"https://deskte.com/upload/r4jkl012", email:"luciaf@example.com" },
  { id:"r5", clientId:"c8", docs:[{ name:"Business License", status:"received" },{ name:"Commercial Lease Agreement", status:"pending" },{ name:"Certificate of Insurance (Prior)", status:"overdue" }], sentAt:"2025-10-05", link:"https://deskte.com/upload/r5mno345", email:"dramirez@example.com" },
];

// Demo handwritten-style signature (SVG data URL — renders reliably in all browsers).
// Each seeded signature references this via signatureImage.
const makeDemoSig = (name) => {
  const safe = String(name || "Signature").replace(/[^a-zA-Z .'-]/g, "");
  const svg = `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 260 70' width='260' height='70'>
  <path d='M10 50 Q 30 10, 55 40 T 100 40 Q 120 20, 140 45 T 200 38 Q 220 25, 245 42' stroke='%231e3a8a' stroke-width='2.2' fill='none' stroke-linecap='round'/>
  <text x='12' y='60' font-family='Brush Script MT, Lucida Handwriting, cursive' font-size='22' fill='%231e3a8a'>${safe}</text>
  </svg>`;
  return "data:image/svg+xml;utf8," + svg.replace(/\n\s*/g, " ").replace(/#/g, "%23");
};
const DEMO_SIG_MARIA   = makeDemoSig("Maria Rodriguez");
const DEMO_SIG_JAMES   = makeDemoSig("James Thompson");
const DEMO_SIG_CARMEN  = makeDemoSig("Carmen Villanueva");
const DEMO_SIG_CARLOS  = makeDemoSig("Carlos Mendoza");
const DEMO_SIG_DIEGO   = makeDemoSig("Diego Ramirez");
const DEMO_SIG_PATRICIA= makeDemoSig("Patricia Williams");
const SEED_SIGNATURES = [
  { id:"s1", clientId:"c1", type:"Scope of Appointment (SOA)",    status:"signed",  sentAt:"2026-01-15", signedAt:"2026-01-16", link:"https://deskte.com/sign/s1abc", signedPdf:DEMO_PDF_HIPAA,   signatureImage:DEMO_SIG_MARIA,    signerName:"Maria Rodriguez",   signedAtFull:"2026-01-16T10:22:00" },
  { id:"s2", clientId:"c3", type:"Consent Form",                  status:"pending", sentAt:"2026-02-20", signedAt:null,         link:"https://deskte.com/sign/s2abc" },
  { id:"s3", clientId:"c2", type:"Income Letter",                 status:"signed",  sentAt:"2026-03-10", signedAt:"2026-03-11", link:"https://deskte.com/sign/s3abc", signedPdf:DEMO_PDF_INCOME,  signatureImage:DEMO_SIG_JAMES,    signerName:"James Thompson",    signedAtFull:"2026-03-11T09:15:00" },
  { id:"s4", clientId:"c9", type:"HIPAA Authorization",           status:"signed",  sentAt:"2025-11-05", signedAt:"2025-11-06", link:"https://deskte.com/sign/s4xyz", signedPdf:DEMO_PDF_HIPAA,   signatureImage:DEMO_SIG_CARMEN,   signerName:"Carmen Villanueva", signedAtFull:"2025-11-06T14:30:00" },
  { id:"s5", clientId:"c6", type:"Auto Coverage Acknowledgement", status:"signed",  sentAt:"2025-08-15", signedAt:"2025-08-15", link:"https://deskte.com/sign/s5xyz", signedPdf:DEMO_PDF_MEDIGAP, signatureImage:DEMO_SIG_CARLOS,   signerName:"Carlos Mendoza",    signedAtFull:"2025-08-15T16:45:00" },
  { id:"s6", clientId:"c8", type:"Commercial Terms Acceptance",   status:"signed",  sentAt:"2025-10-01", signedAt:"2025-10-02", link:"https://deskte.com/sign/s6xyz", signedPdf:DEMO_PDF_HIPAA,   signatureImage:DEMO_SIG_DIEGO,    signerName:"Diego Ramirez",     signedAtFull:"2025-10-02T11:20:00" },
  { id:"s7", clientId:"c5", type:"ACA Enrollment Consent",        status:"pending", sentAt:"2026-03-01", signedAt:null,         link:"https://deskte.com/sign/s7xyz" },
  { id:"s8", clientId:"c7", type:"Homeowners Declaration Page",   status:"signed",  sentAt:"2025-09-01", signedAt:"2025-09-02", link:"https://deskte.com/sign/s8xyz", signedPdf:DEMO_PDF_MEDIGAP, signatureImage:DEMO_SIG_PATRICIA, signerName:"Patricia Williams", signedAtFull:"2025-09-02T13:10:00" },
  { id:"s9", clientId:"c4", type:"Scope of Appointment (SOA)",    status:"pending", sentAt:"2026-04-01", signedAt:null,         link:"https://deskte.com/sign/s9xyz" },
];

const SEED_FOLDERS = [ { id:"f1", name:"Medicare Clients", type:"shared", color:"#8b5cf6", ownerId:"u1", clientIds:["c1","c2","c4"] }, { id:"f2", name:"ACA 2024", type:"shared", color:"#3b82f6", ownerId:"u1", clientIds:["c3","c5"] }, { id:"f3", name:"Prospects", type:"private", color:"#f59e0b", ownerId:"u1", clientIds:["c5"] },
];

const SEED_TEAM_ACTIONS = [];
// Team-action dedup key. The date component is the agent's LOCAL wall-clock
// day — `toISOString()` is UTC and stamped every action taken after 8 PM ET
// under TOMORROW, which is why a greeting sent in the evening showed as
// pending on a screen that asked with the local day (ticket 2026-08-14).
//
// For birthdays `clientId` is the canonical PERSON key (see
// crm-app/greetings.js) and `extra.forDate` is the LOCAL date of the birthday
// occurrence being greeted — not the day the button was pressed. That is what
// makes a greeting scheduled today for tomorrow's birthday still read as
// "enviado" tomorrow, instead of coming back red and inviting a second send.
function teamActionKey(type, clientId, extra) {
  extra = extra || {};
  const today = localDay();
  const monthKey = today.slice(0,7);
  switch(type) {
    case "greeting_sent":
      if (extra.kind === "bday") return bdayGreetingKey(clientId, extra.forDate || today);
      if (extra.kind === "holiday") return `hol_${extra.holidayId}_${clientId}_${today}`;
      return `greet_${clientId}_${today}`;
    case "signature_requested":
      return `sig_${clientId}_${(extra.signatureType||"").replace(/\s+/g,"_")}_${monthKey}`;
    case "doc_request_sent":
      return `docreq_${clientId}_${extra.requestId||monthKey}`;
    case "email_sent":
      return `email_${clientId}_${extra.templateType||"generic"}_${today}`;
    case "renewal_marked":
      return `renew_${extra.policyId}_${extra.oldRenewalDate||""}`;
    default:
      return `${type}_${clientId}_${today}`;
  }
}
const SEED_USERS = [
  { id:"u1", name:"Agency", email:"", role:"agency_owner", pin:"2026", color:"#1d6fa4", initials:"AG", agencyId:"a1", parentAgentId:null, phone:"", dob:"", address:"", hireDate:"", npn:"", title:"Agency Owner", companyName:"", companyLogo:"", website:"", bio:"", licenseStates:"" },
  { id:"u2", name:"Agent", email:"", role:"agent", pin:"4050", color:"#06d6a0", initials:"AG", agencyId:"a1", parentAgentId:null, phone:"", dob:"", address:"", hireDate:"", npn:"", title:"Licensed Insurance Agent", companyName:"", companyLogo:"", website:"", bio:"", licenseStates:"" },
  { id:"u3", name:"Assistant", email:"", role:"assistant", pin:"7711", color:"#f472b6", initials:"AS", agencyId:"a1", parentAgentId:"u2", phone:"", dob:"", address:"", hireDate:"", npn:"", title:"Assistant", companyName:"", companyLogo:"", website:"", bio:"", licenseStates:"" },
];

const SEED_TASKS = [
  { id:"t1",  title:"Follow up Ana: income verification",   description:"She needs to send W2 2024 before May 15 deadline",                priority:"high",   status:"todo",       dueDate:"2026-05-01", assignedTo:"u2", clientId:"c3", createdBy:"u2", createdAt:"2026-02-20" },
  { id:"t2",  title:"Review Medigap G renewal — James",      description:"Plan G renewal Mar 15, premium +$8",                              priority:"high",   status:"inprogress", dueDate:"2026-03-10", assignedTo:"u2", clientId:"c2", createdBy:"u2", createdAt:"2026-02-15" },
  { id:"t3",  title:"Send welcome packet to new prospects",   description:"Lucia Fernandez — ACA Bronze prospect",                          priority:"medium", status:"inprogress", dueDate:"2026-04-20", assignedTo:"u3", clientId:"c5", createdBy:"u2", createdAt:"2026-04-01" },
  { id:"t4",  title:"Update CMS credentials before OEP",      description:"Annual renewal",                                                  priority:"medium", status:"todo",       dueDate:"2026-10-15", assignedTo:"u2", clientId:null, createdBy:"u2", createdAt:"2026-02-10" },
  { id:"t5",  title:"Request Luis Medicare card replacement", description:"Call mymedicare.gov or help Maria in office",                    priority:"high",   status:"done",       dueDate:"2026-08-30", assignedTo:"u3", clientId:"c1", createdBy:"u2", createdAt:"2026-08-22" },
  { id:"t6",  title:"Upload LTC quote for Linda Thompson",    description:"Mutual of Omaha quote requested by client",                      priority:"medium", status:"done",       dueDate:"2026-09-25", assignedTo:"u3", clientId:"c2", createdBy:"u2", createdAt:"2026-09-19" },
  { id:"t7",  title:"Annual liability review — Diego",         description:"Commercial + Umbrella, check $2M coverage still adequate",       priority:"high",   status:"todo",       dueDate:"2026-04-22", assignedTo:"u2", clientId:"c8", createdBy:"u2", createdAt:"2026-04-01" },
  { id:"t8",  title:"Verify Tampa network for James",          description:"Moving to Tampa FL in Jul. Check if Humana MedSupp covers FL",   priority:"medium", status:"todo",       dueDate:"2026-06-01", assignedTo:"u2", clientId:"c2", createdBy:"u2", createdAt:"2026-11-04" },
  { id:"t9",  title:"Follow-up call — Patricia annual review", description:"Homeowners + renters review",                                   priority:"low",    status:"todo",       dueDate:"2026-04-17", assignedTo:"u2", clientId:"c7", createdBy:"u2", createdAt:"2026-04-10" },
  { id:"t10", title:"Call Carmen about Sofia dependency age",  description:"Sofia turning 26 in July — plan for separate enrollment",       priority:"medium", status:"todo",       dueDate:"2026-06-15", assignedTo:"u2", clientId:"c9", createdBy:"u2", createdAt:"2026-04-01" },
  { id:"t11", title:"Aetna carrier training webinar",           description:"New MA plans 2027 preview",                                     priority:"low",    status:"todo",       dueDate:"2026-04-25", assignedTo:"u2", clientId:null, createdBy:"u2", createdAt:"2026-04-10" },
  { id:"t12", title:"Upload ID of Luis Rodriguez",              description:"For household size verification",                                priority:"medium", status:"done",       dueDate:"2026-08-22", assignedTo:"u3", clientId:"c1", createdBy:"u2", createdAt:"2026-08-20" },
];

// Demo commissions — 6 months of realistic data across multiple clients
// Shape: { id, month, carrier, policyType, clientNameRaw, clientId, memberIdRaw, amount, matchScore, saleType, state, status, source, dueMonth, importedAt }
const SEED_COMMISSIONS = [
  // Maria Rodriguez — Aetna MA (monthly recurring)
  { id:"cm_c1_1", month:"2025-11", carrier:"Aetna",       policyType:"ma",         clientNameRaw:"Maria Rodriguez",  clientId:"c1", memberIdRaw:"AET-M-100291", amount:42.50, matchScore:95, saleType:"new",    state:"FL", status:"paid", source:"upload", dueMonth:"Nov-25", importedAt:"2025-11-15" },
  { id:"cm_c1_2", month:"2025-12", carrier:"Aetna",       policyType:"ma",         clientNameRaw:"Maria Rodriguez",  clientId:"c1", memberIdRaw:"AET-M-100291", amount:42.50, matchScore:95, saleType:"renew",  state:"FL", status:"paid", source:"upload", dueMonth:"Dec-25", importedAt:"2025-12-15" },
  { id:"cm_c1_3", month:"2026-01", carrier:"Aetna",       policyType:"ma",         clientNameRaw:"Maria Rodriguez",  clientId:"c1", memberIdRaw:"AET-M-100291", amount:42.50, matchScore:95, saleType:"renew",  state:"FL", status:"paid", source:"upload", dueMonth:"Jan-26", importedAt:"2026-01-15" },
  { id:"cm_c1_4", month:"2026-02", carrier:"Aetna",       policyType:"ma",         clientNameRaw:"Maria Rodriguez",  clientId:"c1", memberIdRaw:"AET-M-100291", amount:42.50, matchScore:95, saleType:"renew",  state:"FL", status:"paid", source:"upload", dueMonth:"Feb-26", importedAt:"2026-02-15" },
  { id:"cm_c1_5", month:"2026-03", carrier:"Aetna",       policyType:"ma",         clientNameRaw:"Maria Rodriguez",  clientId:"c1", memberIdRaw:"AET-M-100291", amount:42.50, matchScore:95, saleType:"renew",  state:"FL", status:"paid", source:"upload", dueMonth:"Mar-26", importedAt:"2026-03-15" },
  // Maria Rodriguez — Delta Dental
  { id:"cm_c1_6", month:"2026-01", carrier:"Delta Dental",policyType:"dental",     clientNameRaw:"Maria Rodriguez",  clientId:"c1", memberIdRaw:"DD-M-991",     amount:28.00, matchScore:95, saleType:"new",    state:"FL", status:"paid", source:"upload", dueMonth:"Jan-26", importedAt:"2026-01-20" },
  { id:"cm_c1_7", month:"2026-02", carrier:"Delta Dental",policyType:"dental",     clientNameRaw:"Maria Rodriguez",  clientId:"c1", memberIdRaw:"DD-M-991",     amount:28.00, matchScore:95, saleType:"renew",  state:"FL", status:"paid", source:"upload", dueMonth:"Feb-26", importedAt:"2026-02-20" },
  // James Thompson — Humana Medigap G (big monthly)
  { id:"cm_c2_1", month:"2025-11", carrier:"Humana",      policyType:"medicare",   clientNameRaw:"James Thompson",   clientId:"c2", memberIdRaw:"HUM-44521",    amount:187.00,matchScore:98, saleType:"renew",  state:"MD", status:"paid", source:"upload", dueMonth:"Nov-25", importedAt:"2025-11-15" },
  { id:"cm_c2_2", month:"2025-12", carrier:"Humana",      policyType:"medicare",   clientNameRaw:"James Thompson",   clientId:"c2", memberIdRaw:"HUM-44521",    amount:187.00,matchScore:98, saleType:"renew",  state:"MD", status:"paid", source:"upload", dueMonth:"Dec-25", importedAt:"2025-12-15" },
  { id:"cm_c2_3", month:"2026-01", carrier:"Humana",      policyType:"medicare",   clientNameRaw:"James Thompson",   clientId:"c2", memberIdRaw:"HUM-44521",    amount:187.00,matchScore:98, saleType:"renew",  state:"MD", status:"paid", source:"upload", dueMonth:"Jan-26", importedAt:"2026-01-15" },
  { id:"cm_c2_4", month:"2026-02", carrier:"Humana",      policyType:"medicare",   clientNameRaw:"James Thompson",   clientId:"c2", memberIdRaw:"HUM-44521",    amount:187.00,matchScore:98, saleType:"renew",  state:"MD", status:"paid", source:"upload", dueMonth:"Feb-26", importedAt:"2026-02-15" },
  // James Thompson — MetLife Term Life
  { id:"cm_c2_5", month:"2025-11", carrier:"MetLife",     policyType:"life",       clientNameRaw:"James Thompson",   clientId:"c2", memberIdRaw:"MET-55210",    amount:45.00, matchScore:97, saleType:"renew",  state:"MD", status:"paid", source:"upload", dueMonth:"Nov-25", importedAt:"2025-11-15" },
  { id:"cm_c2_6", month:"2026-02", carrier:"MetLife",     policyType:"life",       clientNameRaw:"James Thompson",   clientId:"c2", memberIdRaw:"MET-55210",    amount:45.00, matchScore:97, saleType:"renew",  state:"MD", status:"paid", source:"upload", dueMonth:"Feb-26", importedAt:"2026-02-15" },
  // Ana Gutierrez — CareFirst ACA (pending)
  { id:"cm_c3_1", month:"2026-01", carrier:"CareFirst",   policyType:"aca",        clientNameRaw:"Ana Gutierrez",    clientId:"c3", memberIdRaw:"CF-33129",     amount:215.00,matchScore:92, saleType:"new",    state:"MD", status:"paid", source:"upload", dueMonth:"Jan-26", importedAt:"2026-01-25" },
  { id:"cm_c3_2", month:"2026-02", carrier:"CareFirst",   policyType:"aca",        clientNameRaw:"Ana Gutierrez",    clientId:"c3", memberIdRaw:"CF-33129",     amount:215.00,matchScore:92, saleType:"renew",  state:"MD", status:"paid", source:"upload", dueMonth:"Feb-26", importedAt:"2026-02-25" },
  // Robert Chen — WellCare Part D
  { id:"cm_c4_1", month:"2026-01", carrier:"WellCare",    policyType:"medicare",   clientNameRaw:"Robert Chen",      clientId:"c4", memberIdRaw:"WC-88934",     amount:33.50, matchScore:96, saleType:"renew",  state:"DC", status:"paid", source:"upload", dueMonth:"Jan-26", importedAt:"2026-01-15" },
  { id:"cm_c4_2", month:"2026-02", carrier:"WellCare",    policyType:"medicare",   clientNameRaw:"Robert Chen",      clientId:"c4", memberIdRaw:"WC-88934",     amount:33.50, matchScore:96, saleType:"renew",  state:"DC", status:"paid", source:"upload", dueMonth:"Feb-26", importedAt:"2026-02-15" },
  // Carlos Mendoza — State Farm HO + GEICO Auto (P&C)
  { id:"cm_c6_1", month:"2025-12", carrier:"State Farm",  policyType:"home",       clientNameRaw:"Carlos Mendoza",   clientId:"c6", memberIdRaw:"SF-HO-2025-4421",amount:145.00, matchScore:96, saleType:"new",    state:"MD", status:"paid", source:"upload", dueMonth:"Dec-25", importedAt:"2025-12-20" },
  { id:"cm_c6_2", month:"2026-01", carrier:"GEICO",       policyType:"auto",       clientNameRaw:"Carlos Mendoza",   clientId:"c6", memberIdRaw:"GEI-AUTO-8834",amount:24.50, matchScore:94, saleType:"new",    state:"MD", status:"paid", source:"upload", dueMonth:"Jan-26", importedAt:"2026-01-20" },
  { id:"cm_c6_3", month:"2026-02", carrier:"GEICO",       policyType:"auto",       clientNameRaw:"Carlos Mendoza",   clientId:"c6", memberIdRaw:"GEI-AUTO-8835",amount:18.25, matchScore:94, saleType:"new",    state:"MD", status:"paid", source:"upload", dueMonth:"Feb-26", importedAt:"2026-02-20" },
  // Patricia Williams — Allstate HO
  { id:"cm_c7_1", month:"2026-01", carrier:"Allstate",    policyType:"home",       clientNameRaw:"Patricia Williams",clientId:"c7", memberIdRaw:"ALL-HO-7712",  amount:31.00, matchScore:96, saleType:"renew",  state:"MD", status:"paid", source:"upload", dueMonth:"Jan-26", importedAt:"2026-01-15" },
  { id:"cm_c7_2", month:"2026-02", carrier:"Allstate",    policyType:"renters",    clientNameRaw:"Patricia Williams",clientId:"c7", memberIdRaw:"ALL-RNT-5503", amount:4.40,  matchScore:96, saleType:"renew",  state:"MD", status:"paid", source:"upload", dueMonth:"Feb-26", importedAt:"2026-02-15" },
  // Diego Ramirez — Hartford Commercial (biggest)
  { id:"cm_c8_1", month:"2025-11", carrier:"Hartford",    policyType:"commercial", clientNameRaw:"Diego Ramirez",    clientId:"c8", memberIdRaw:"HFD-BOP-3391", amount:77.00, matchScore:97, saleType:"new",    state:"DC", status:"paid", source:"upload", dueMonth:"Nov-25", importedAt:"2025-11-20" },
  { id:"cm_c8_2", month:"2025-12", carrier:"Hartford",    policyType:"commercial", clientNameRaw:"Diego Ramirez",    clientId:"c8", memberIdRaw:"HFD-BOP-3391", amount:77.00, matchScore:97, saleType:"renew",  state:"DC", status:"paid", source:"upload", dueMonth:"Dec-25", importedAt:"2025-12-20" },
  { id:"cm_c8_3", month:"2026-01", carrier:"Hartford",    policyType:"commercial", clientNameRaw:"Diego Ramirez",    clientId:"c8", memberIdRaw:"HFD-BOP-3391", amount:77.00, matchScore:97, saleType:"renew",  state:"DC", status:"paid", source:"upload", dueMonth:"Jan-26", importedAt:"2026-01-20" },
  { id:"cm_c8_4", month:"2026-01", carrier:"Hartford",    policyType:"commercial", clientNameRaw:"Diego Ramirez",    clientId:"c8", memberIdRaw:"HFD-UMB-3392", amount:25.00, matchScore:97, saleType:"new",    state:"DC", status:"paid", source:"upload", dueMonth:"Jan-26", importedAt:"2026-01-20" },
  // Carmen Villanueva — Oscar ACA (family plan)
  { id:"cm_c9_1", month:"2025-11", carrier:"Oscar",       policyType:"aca",        clientNameRaw:"Carmen Villanueva",clientId:"c9", memberIdRaw:"OSC-M-9441",   amount:37.00, matchScore:98, saleType:"new",    state:"MD", status:"paid", source:"upload", dueMonth:"Nov-25", importedAt:"2025-11-15" },
  { id:"cm_c9_2", month:"2025-12", carrier:"Oscar",       policyType:"aca",        clientNameRaw:"Carmen Villanueva",clientId:"c9", memberIdRaw:"OSC-M-9441",   amount:37.00, matchScore:98, saleType:"renew",  state:"MD", status:"paid", source:"upload", dueMonth:"Dec-25", importedAt:"2025-12-15" },
  { id:"cm_c9_3", month:"2026-01", carrier:"Oscar",       policyType:"aca",        clientNameRaw:"Carmen Villanueva",clientId:"c9", memberIdRaw:"OSC-M-9441",   amount:37.00, matchScore:98, saleType:"renew",  state:"MD", status:"paid", source:"upload", dueMonth:"Jan-26", importedAt:"2026-01-15" },
  { id:"cm_c9_4", month:"2026-02", carrier:"Oscar",       policyType:"aca",        clientNameRaw:"Carmen Villanueva",clientId:"c9", memberIdRaw:"OSC-M-9441",   amount:37.00, matchScore:98, saleType:"renew",  state:"MD", status:"paid", source:"upload", dueMonth:"Feb-26", importedAt:"2026-02-15" },
  // Chargeback example (negative)
  { id:"cm_cb_1", month:"2026-02", carrier:"Oscar",       policyType:"aca",        clientNameRaw:"Lucia Fernandez",  clientId:"c5", memberIdRaw:"OSC-M-LUCF",   amount:-98.00,matchScore:90, saleType:"cb",     state:"MD", status:"paid", source:"upload", dueMonth:"Feb-26", importedAt:"2026-02-25" },
  // Unmatched example (no clientId) — shows "needs review"
  { id:"cm_un_1", month:"2026-02", carrier:"Ambetter",    policyType:"aca",        clientNameRaw:"Esteban Morales",  clientId:null, memberIdRaw:"AMB-77192",    amount:82.50, matchScore:0,  saleType:"new",    state:"FL", status:"unmatched", source:"upload", dueMonth:"Feb-26", importedAt:"2026-02-25" },
  // ── Continuación Mar-26 → Ago-26 de las series recurrentes de arriba ──
  { id:"cm_c1_8",  month:"2026-04", carrier:"Aetna",        policyType:"ma",       clientNameRaw:"Maria Rodriguez",  clientId:"c1", memberIdRaw:"AET-M-100291", amount:42.50, matchScore:95, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"Apr-26", importedAt:"2026-04-15" },
  { id:"cm_c1_9",  month:"2026-05", carrier:"Aetna",        policyType:"ma",       clientNameRaw:"Maria Rodriguez",  clientId:"c1", memberIdRaw:"AET-M-100291", amount:42.50, matchScore:95, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"May-26", importedAt:"2026-05-15" },
  { id:"cm_c1_10", month:"2026-06", carrier:"Aetna",        policyType:"ma",       clientNameRaw:"Maria Rodriguez",  clientId:"c1", memberIdRaw:"AET-M-100291", amount:42.50, matchScore:95, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"Jun-26", importedAt:"2026-06-15" },
  { id:"cm_c1_11", month:"2026-07", carrier:"Aetna",        policyType:"ma",       clientNameRaw:"Maria Rodriguez",  clientId:"c1", memberIdRaw:"AET-M-100291", amount:42.50, matchScore:95, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"Jul-26", importedAt:"2026-07-15" },
  { id:"cm_c1_12", month:"2026-08", carrier:"Aetna",        policyType:"ma",       clientNameRaw:"Maria Rodriguez",  clientId:"c1", memberIdRaw:"AET-M-100291", amount:42.50, matchScore:95, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"Aug-26", importedAt:"2026-08-15" },
  { id:"cm_c1_13", month:"2026-03", carrier:"Delta Dental", policyType:"dental",   clientNameRaw:"Maria Rodriguez",  clientId:"c1", memberIdRaw:"DD-M-991",     amount:28.00, matchScore:95, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"Mar-26", importedAt:"2026-03-20" },
  { id:"cm_c1_14", month:"2026-05", carrier:"Delta Dental", policyType:"dental",   clientNameRaw:"Maria Rodriguez",  clientId:"c1", memberIdRaw:"DD-M-991",     amount:28.00, matchScore:95, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"May-26", importedAt:"2026-05-20" },
  { id:"cm_c1_15", month:"2026-07", carrier:"Delta Dental", policyType:"dental",   clientNameRaw:"Maria Rodriguez",  clientId:"c1", memberIdRaw:"DD-M-991",     amount:28.00, matchScore:95, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"Jul-26", importedAt:"2026-07-20" },
  { id:"cm_c2_7",  month:"2026-03", carrier:"Humana",       policyType:"medicare", clientNameRaw:"James Thompson",   clientId:"c2", memberIdRaw:"HUM-44521",    amount:187.00,matchScore:98, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"Mar-26", importedAt:"2026-03-15" },
  { id:"cm_c2_8",  month:"2026-04", carrier:"Humana",       policyType:"medicare", clientNameRaw:"James Thompson",   clientId:"c2", memberIdRaw:"HUM-44521",    amount:195.00,matchScore:98, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"Apr-26", importedAt:"2026-04-15" },
  { id:"cm_c2_9",  month:"2026-05", carrier:"Humana",       policyType:"medicare", clientNameRaw:"James Thompson",   clientId:"c2", memberIdRaw:"HUM-44521",    amount:195.00,matchScore:98, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"May-26", importedAt:"2026-05-15" },
  { id:"cm_c2_10", month:"2026-06", carrier:"Humana",       policyType:"medicare", clientNameRaw:"James Thompson",   clientId:"c2", memberIdRaw:"HUM-44521",    amount:195.00,matchScore:98, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"Jun-26", importedAt:"2026-06-15" },
  { id:"cm_c2_11", month:"2026-07", carrier:"Humana",       policyType:"medicare", clientNameRaw:"James Thompson",   clientId:"c2", memberIdRaw:"HUM-44521",    amount:195.00,matchScore:98, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"Jul-26", importedAt:"2026-07-15" },
  { id:"cm_c2_12", month:"2026-08", carrier:"Humana",       policyType:"medicare", clientNameRaw:"James Thompson",   clientId:"c2", memberIdRaw:"HUM-44521",    amount:195.00,matchScore:98, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"Aug-26", importedAt:"2026-08-15" },
  { id:"cm_c3_3",  month:"2026-03", carrier:"CareFirst",    policyType:"aca",      clientNameRaw:"Ana Gutierrez",    clientId:"c3", memberIdRaw:"CF-33129",     amount:215.00,matchScore:92, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"Mar-26", importedAt:"2026-03-25" },
  { id:"cm_c3_4",  month:"2026-04", carrier:"CareFirst",    policyType:"aca",      clientNameRaw:"Ana Gutierrez",    clientId:"c3", memberIdRaw:"CF-33129",     amount:215.00,matchScore:92, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"Apr-26", importedAt:"2026-04-25" },
  { id:"cm_c4_3",  month:"2026-03", carrier:"WellCare",     policyType:"medicare", clientNameRaw:"Robert Chen",      clientId:"c4", memberIdRaw:"WC-88934",     amount:33.50, matchScore:96, saleType:"renew", state:"GA", status:"paid", source:"upload", dueMonth:"Mar-26", importedAt:"2026-03-15" },
  { id:"cm_c4_4",  month:"2026-05", carrier:"WellCare",     policyType:"medicare", clientNameRaw:"Robert Chen",      clientId:"c4", memberIdRaw:"WC-88934",     amount:33.50, matchScore:96, saleType:"renew", state:"GA", status:"paid", source:"upload", dueMonth:"May-26", importedAt:"2026-05-15" },
  { id:"cm_c4_5",  month:"2026-07", carrier:"WellCare",     policyType:"medicare", clientNameRaw:"Robert Chen",      clientId:"c4", memberIdRaw:"WC-88934",     amount:33.50, matchScore:96, saleType:"renew", state:"GA", status:"paid", source:"upload", dueMonth:"Jul-26", importedAt:"2026-07-15" },
  { id:"cm_c6_4",  month:"2026-08", carrier:"State Farm",   policyType:"home",     clientNameRaw:"Carlos Mendoza",   clientId:"c6", memberIdRaw:"SF-HO-2025-4421",amount:148.00,matchScore:96, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"Aug-26", importedAt:"2026-08-20" },
  { id:"cm_c6_5",  month:"2026-08", carrier:"GEICO",        policyType:"auto",     clientNameRaw:"Carlos Mendoza",   clientId:"c6", memberIdRaw:"GEI-AUTO-8834",amount:25.10, matchScore:94, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"Aug-26", importedAt:"2026-08-20" },
  { id:"cm_c8_5",  month:"2026-02", carrier:"Hartford",     policyType:"commercial",clientNameRaw:"Diego Ramirez",   clientId:"c8", memberIdRaw:"HFD-BOP-3391", amount:77.00, matchScore:97, saleType:"renew", state:"TX", status:"paid", source:"upload", dueMonth:"Feb-26", importedAt:"2026-02-20" },
  { id:"cm_c8_6",  month:"2026-04", carrier:"Hartford",     policyType:"commercial",clientNameRaw:"Diego Ramirez",   clientId:"c8", memberIdRaw:"HFD-BOP-3391", amount:77.00, matchScore:97, saleType:"renew", state:"TX", status:"paid", source:"upload", dueMonth:"Apr-26", importedAt:"2026-04-20" },
  { id:"cm_c8_7",  month:"2026-06", carrier:"Hartford",     policyType:"commercial",clientNameRaw:"Diego Ramirez",   clientId:"c8", memberIdRaw:"HFD-BOP-3391", amount:77.00, matchScore:97, saleType:"renew", state:"TX", status:"paid", source:"upload", dueMonth:"Jun-26", importedAt:"2026-06-20" },
  { id:"cm_c8_8",  month:"2026-08", carrier:"Hartford",     policyType:"commercial",clientNameRaw:"Diego Ramirez",   clientId:"c8", memberIdRaw:"HFD-BOP-3391", amount:77.00, matchScore:97, saleType:"renew", state:"TX", status:"paid", source:"upload", dueMonth:"Aug-26", importedAt:"2026-08-20" },
  { id:"cm_c9_5",  month:"2026-03", carrier:"Oscar",        policyType:"aca",      clientNameRaw:"Carmen Villanueva",clientId:"c9", memberIdRaw:"OSC-M-9441",   amount:37.00, matchScore:98, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"Mar-26", importedAt:"2026-03-15" },
  { id:"cm_c9_6",  month:"2026-04", carrier:"Oscar",        policyType:"aca",      clientNameRaw:"Carmen Villanueva",clientId:"c9", memberIdRaw:"OSC-M-9441",   amount:37.00, matchScore:98, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"Apr-26", importedAt:"2026-04-15" },
  { id:"cm_c9_7",  month:"2026-05", carrier:"Oscar",        policyType:"aca",      clientNameRaw:"Carmen Villanueva",clientId:"c9", memberIdRaw:"OSC-M-9441",   amount:37.00, matchScore:98, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"May-26", importedAt:"2026-05-15" },
  { id:"cm_c9_8",  month:"2026-06", carrier:"Oscar",        policyType:"aca",      clientNameRaw:"Carmen Villanueva",clientId:"c9", memberIdRaw:"OSC-M-9441",   amount:37.00, matchScore:98, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"Jun-26", importedAt:"2026-06-15" },
  { id:"cm_c9_9",  month:"2026-07", carrier:"Oscar",        policyType:"aca",      clientNameRaw:"Carmen Villanueva",clientId:"c9", memberIdRaw:"OSC-M-9441",   amount:37.00, matchScore:98, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"Jul-26", importedAt:"2026-07-15" },
  { id:"cm_c9_10", month:"2026-08", carrier:"Oscar",        policyType:"aca",      clientNameRaw:"Carmen Villanueva",clientId:"c9", memberIdRaw:"OSC-M-9441",   amount:37.00, matchScore:98, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"Aug-26", importedAt:"2026-08-15" },
  // ── Series de la cartera ampliada (c10-c28) ──
  { id:"cm_c10_1", month:"2026-01", carrier:"Ambetter",     policyType:"aca",      clientNameRaw:"Yolanda Castillo", clientId:"c10", memberIdRaw:"AMB-M-3310",  amount:54.00, matchScore:96, saleType:"new",   state:"FL", status:"paid", source:"upload", dueMonth:"Jan-26", importedAt:"2026-01-25" },
  { id:"cm_c10_2", month:"2026-02", carrier:"Ambetter",     policyType:"aca",      clientNameRaw:"Yolanda Castillo", clientId:"c10", memberIdRaw:"AMB-M-3310",  amount:54.00, matchScore:96, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"Feb-26", importedAt:"2026-02-25" },
  { id:"cm_c10_3", month:"2026-03", carrier:"Ambetter",     policyType:"aca",      clientNameRaw:"Yolanda Castillo", clientId:"c10", memberIdRaw:"AMB-M-3310",  amount:54.00, matchScore:96, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"Mar-26", importedAt:"2026-03-25" },
  { id:"cm_c10_4", month:"2026-04", carrier:"Ambetter",     policyType:"aca",      clientNameRaw:"Yolanda Castillo", clientId:"c10", memberIdRaw:"AMB-M-3310",  amount:54.00, matchScore:96, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"Apr-26", importedAt:"2026-04-25" },
  { id:"cm_c10_5", month:"2026-05", carrier:"Ambetter",     policyType:"aca",      clientNameRaw:"Yolanda Castillo", clientId:"c10", memberIdRaw:"AMB-M-3310",  amount:54.00, matchScore:96, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"May-26", importedAt:"2026-05-25" },
  { id:"cm_c10_6", month:"2026-06", carrier:"Ambetter",     policyType:"aca",      clientNameRaw:"Yolanda Castillo", clientId:"c10", memberIdRaw:"AMB-M-3310",  amount:54.00, matchScore:96, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"Jun-26", importedAt:"2026-06-25" },
  { id:"cm_c10_7", month:"2026-07", carrier:"Ambetter",     policyType:"aca",      clientNameRaw:"Yolanda Castillo", clientId:"c10", memberIdRaw:"AMB-M-3310",  amount:54.00, matchScore:96, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"Jul-26", importedAt:"2026-07-25" },
  { id:"cm_c10_8", month:"2026-08", carrier:"Ambetter",     policyType:"aca",      clientNameRaw:"Yolanda Castillo", clientId:"c10", memberIdRaw:"AMB-M-3310",  amount:54.00, matchScore:96, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"Aug-26", importedAt:"2026-08-25" },
  { id:"cm_c11_1", month:"2026-02", carrier:"Oscar",        policyType:"aca",      clientNameRaw:"Pedro Alvarez",    clientId:"c11", memberIdRaw:"OSC-M-5512",  amount:19.00, matchScore:95, saleType:"new",   state:"FL", status:"paid", source:"upload", dueMonth:"Feb-26", importedAt:"2026-02-15" },
  { id:"cm_c11_2", month:"2026-03", carrier:"Oscar",        policyType:"aca",      clientNameRaw:"Pedro Alvarez",    clientId:"c11", memberIdRaw:"OSC-M-5512",  amount:19.00, matchScore:95, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"Mar-26", importedAt:"2026-03-15" },
  { id:"cm_c11_3", month:"2026-05", carrier:"Oscar",        policyType:"aca",      clientNameRaw:"Pedro Alvarez",    clientId:"c11", memberIdRaw:"OSC-M-5512",  amount:19.00, matchScore:95, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"May-26", importedAt:"2026-05-15" },
  { id:"cm_c11_4", month:"2026-08", carrier:"Oscar",        policyType:"aca",      clientNameRaw:"Pedro Alvarez",    clientId:"c11", memberIdRaw:"OSC-M-5512",  amount:19.00, matchScore:95, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"Aug-26", importedAt:"2026-08-15" },
  { id:"cm_c11_5", month:"2026-02", carrier:"Delta Dental", policyType:"dental",   clientNameRaw:"Pedro Alvarez",    clientId:"c11", memberIdRaw:"DD-M-8802",   amount:4.80,  matchScore:95, saleType:"new",   state:"FL", status:"paid", source:"upload", dueMonth:"Feb-26", importedAt:"2026-02-20" },
  { id:"cm_c11_6", month:"2026-06", carrier:"Delta Dental", policyType:"dental",   clientNameRaw:"Pedro Alvarez",    clientId:"c11", memberIdRaw:"DD-M-8802",   amount:4.80,  matchScore:95, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"Jun-26", importedAt:"2026-06-20" },
  { id:"cm_c12_1", month:"2026-01", carrier:"Humana",       policyType:"medicare", clientNameRaw:"Rosa Jimenez",     clientId:"c12", memberIdRaw:"HUM-M-66120", amount:46.00, matchScore:97, saleType:"new",   state:"FL", status:"paid", source:"upload", dueMonth:"Jan-26", importedAt:"2026-01-15" },
  { id:"cm_c12_2", month:"2026-03", carrier:"Humana",       policyType:"medicare", clientNameRaw:"Rosa Jimenez",     clientId:"c12", memberIdRaw:"HUM-M-66120", amount:46.00, matchScore:97, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"Mar-26", importedAt:"2026-03-15" },
  { id:"cm_c12_3", month:"2026-05", carrier:"Humana",       policyType:"medicare", clientNameRaw:"Rosa Jimenez",     clientId:"c12", memberIdRaw:"HUM-M-66120", amount:46.00, matchScore:97, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"May-26", importedAt:"2026-05-15" },
  { id:"cm_c12_4", month:"2026-07", carrier:"Humana",       policyType:"medicare", clientNameRaw:"Rosa Jimenez",     clientId:"c12", memberIdRaw:"HUM-M-66120", amount:46.00, matchScore:97, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"Jul-26", importedAt:"2026-07-15" },
  { id:"cm_c13_1", month:"2026-02", carrier:"Florida Blue", policyType:"aca",      clientNameRaw:"Miguel Santos",    clientId:"c13", memberIdRaw:"FB-M-7301",   amount:43.00, matchScore:96, saleType:"new",   state:"FL", status:"paid", source:"upload", dueMonth:"Feb-26", importedAt:"2026-02-18" },
  { id:"cm_c13_2", month:"2026-04", carrier:"Florida Blue", policyType:"aca",      clientNameRaw:"Miguel Santos",    clientId:"c13", memberIdRaw:"FB-M-7301",   amount:43.00, matchScore:96, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"Apr-26", importedAt:"2026-04-18" },
  { id:"cm_c13_3", month:"2026-06", carrier:"Florida Blue", policyType:"aca",      clientNameRaw:"Miguel Santos",    clientId:"c13", memberIdRaw:"FB-M-7301",   amount:43.00, matchScore:96, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"Jun-26", importedAt:"2026-06-18" },
  { id:"cm_c13_4", month:"2026-08", carrier:"Florida Blue", policyType:"aca",      clientNameRaw:"Miguel Santos",    clientId:"c13", memberIdRaw:"FB-M-7301",   amount:43.00, matchScore:96, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"Aug-26", importedAt:"2026-08-18" },
  { id:"cm_c14_1", month:"2026-01", carrier:"Aetna",        policyType:"medicare", clientNameRaw:"Gladys Herrera",   clientId:"c14", memberIdRaw:"AET-M-77401", amount:46.00, matchScore:97, saleType:"new",   state:"FL", status:"paid", source:"upload", dueMonth:"Jan-26", importedAt:"2026-01-15" },
  { id:"cm_c14_2", month:"2026-04", carrier:"Aetna",        policyType:"medicare", clientNameRaw:"Gladys Herrera",   clientId:"c14", memberIdRaw:"AET-M-77401", amount:46.00, matchScore:97, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"Apr-26", importedAt:"2026-04-15" },
  { id:"cm_c14_3", month:"2026-06", carrier:"Aetna",        policyType:"medicare", clientNameRaw:"Gladys Herrera",   clientId:"c14", memberIdRaw:"AET-M-77401", amount:46.00, matchScore:97, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"Jun-26", importedAt:"2026-06-15" },
  { id:"cm_c14_4", month:"2026-08", carrier:"Aetna",        policyType:"medicare", clientNameRaw:"Gladys Herrera",   clientId:"c14", memberIdRaw:"AET-M-77401", amount:46.00, matchScore:97, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"Aug-26", importedAt:"2026-08-15" },
  { id:"cm_c14_5", month:"2026-03", carrier:"Delta Dental", policyType:"dental",   clientNameRaw:"Gladys Herrera",   clientId:"c14", memberIdRaw:"DD-M-9917",   amount:5.20,  matchScore:95, saleType:"new",   state:"FL", status:"paid", source:"upload", dueMonth:"Mar-26", importedAt:"2026-03-20" },
  { id:"cm_c14_6", month:"2026-07", carrier:"Delta Dental", policyType:"dental",   clientNameRaw:"Gladys Herrera",   clientId:"c14", memberIdRaw:"DD-M-9917",   amount:5.20,  matchScore:95, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"Jul-26", importedAt:"2026-07-20" },
  { id:"cm_c16_1", month:"2026-02", carrier:"Mutual of Omaha", policyType:"medicare", clientNameRaw:"Barbara Mitchell", clientId:"c16", memberIdRaw:"MOO-21055", amount:31.20, matchScore:97, saleType:"new",   state:"FL", status:"paid", source:"upload", dueMonth:"Feb-26", importedAt:"2026-02-15" },
  { id:"cm_c16_2", month:"2026-03", carrier:"Mutual of Omaha", policyType:"medicare", clientNameRaw:"Barbara Mitchell", clientId:"c16", memberIdRaw:"MOO-21055", amount:31.20, matchScore:97, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"Mar-26", importedAt:"2026-03-15" },
  { id:"cm_c16_3", month:"2026-04", carrier:"Mutual of Omaha", policyType:"medicare", clientNameRaw:"Barbara Mitchell", clientId:"c16", memberIdRaw:"MOO-21055", amount:31.20, matchScore:97, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"Apr-26", importedAt:"2026-04-15" },
  { id:"cm_c16_4", month:"2026-05", carrier:"Mutual of Omaha", policyType:"medicare", clientNameRaw:"Barbara Mitchell", clientId:"c16", memberIdRaw:"MOO-21055", amount:31.20, matchScore:97, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"May-26", importedAt:"2026-05-15" },
  { id:"cm_c16_5", month:"2026-06", carrier:"Mutual of Omaha", policyType:"medicare", clientNameRaw:"Barbara Mitchell", clientId:"c16", memberIdRaw:"MOO-21055", amount:31.20, matchScore:97, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"Jun-26", importedAt:"2026-06-15" },
  { id:"cm_c16_6", month:"2026-07", carrier:"Mutual of Omaha", policyType:"medicare", clientNameRaw:"Barbara Mitchell", clientId:"c16", memberIdRaw:"MOO-21055", amount:31.20, matchScore:97, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"Jul-26", importedAt:"2026-07-15" },
  { id:"cm_c16_7", month:"2026-08", carrier:"Mutual of Omaha", policyType:"medicare", clientNameRaw:"Barbara Mitchell", clientId:"c16", memberIdRaw:"MOO-21055", amount:31.20, matchScore:97, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"Aug-26", importedAt:"2026-08-15" },
  { id:"cm_c17_1", month:"2026-03", carrier:"Florida Blue", policyType:"aca",      clientNameRaw:"Luis Ortega",      clientId:"c17", memberIdRaw:"FB-M-8815",   amount:46.20, matchScore:96, saleType:"new",   state:"FL", status:"paid", source:"upload", dueMonth:"Mar-26", importedAt:"2026-03-18" },
  { id:"cm_c17_2", month:"2026-04", carrier:"Florida Blue", policyType:"aca",      clientNameRaw:"Luis Ortega",      clientId:"c17", memberIdRaw:"FB-M-8815",   amount:46.20, matchScore:96, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"Apr-26", importedAt:"2026-04-18" },
  { id:"cm_c17_3", month:"2026-05", carrier:"Florida Blue", policyType:"aca",      clientNameRaw:"Luis Ortega",      clientId:"c17", memberIdRaw:"FB-M-8815",   amount:46.20, matchScore:96, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"May-26", importedAt:"2026-05-18" },
  { id:"cm_c17_4", month:"2026-06", carrier:"Florida Blue", policyType:"aca",      clientNameRaw:"Luis Ortega",      clientId:"c17", memberIdRaw:"FB-M-8815",   amount:46.20, matchScore:96, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"Jun-26", importedAt:"2026-06-18" },
  { id:"cm_c17_5", month:"2026-07", carrier:"Florida Blue", policyType:"aca",      clientNameRaw:"Luis Ortega",      clientId:"c17", memberIdRaw:"FB-M-8815",   amount:46.20, matchScore:96, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"Jul-26", importedAt:"2026-07-18" },
  { id:"cm_c17_6", month:"2026-08", carrier:"Florida Blue", policyType:"aca",      clientNameRaw:"Luis Ortega",      clientId:"c17", memberIdRaw:"FB-M-8815",   amount:46.20, matchScore:96, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"Aug-26", importedAt:"2026-08-18" },
  { id:"cm_c17_7", month:"2026-03", carrier:"Banner Life",  policyType:"life",     clientNameRaw:"Luis Ortega",      clientId:"c17", memberIdRaw:"BAN-30982",   amount:456.00,matchScore:97, saleType:"new",   state:"FL", status:"paid", source:"upload", dueMonth:"Mar-26", importedAt:"2026-03-28" },
  { id:"cm_c18_1", month:"2026-03", carrier:"Ambetter",     policyType:"aca",      clientNameRaw:"Teresa Nunez",     clientId:"c18", memberIdRaw:"AMB-M-6603",  amount:90.00, matchScore:96, saleType:"new",   state:"FL", status:"paid", source:"upload", dueMonth:"Mar-26", importedAt:"2026-03-25" },
  { id:"cm_c18_2", month:"2026-04", carrier:"Ambetter",     policyType:"aca",      clientNameRaw:"Teresa Nunez",     clientId:"c18", memberIdRaw:"AMB-M-6603",  amount:90.00, matchScore:96, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"Apr-26", importedAt:"2026-04-25" },
  { id:"cm_c18_3", month:"2026-05", carrier:"Ambetter",     policyType:"aca",      clientNameRaw:"Teresa Nunez",     clientId:"c18", memberIdRaw:"AMB-M-6603",  amount:90.00, matchScore:96, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"May-26", importedAt:"2026-05-25" },
  { id:"cm_c18_4", month:"2026-06", carrier:"Ambetter",     policyType:"aca",      clientNameRaw:"Teresa Nunez",     clientId:"c18", memberIdRaw:"AMB-M-6603",  amount:90.00, matchScore:96, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"Jun-26", importedAt:"2026-06-25" },
  { id:"cm_c18_5", month:"2026-07", carrier:"Ambetter",     policyType:"aca",      clientNameRaw:"Teresa Nunez",     clientId:"c18", memberIdRaw:"AMB-M-6603",  amount:90.00, matchScore:96, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"Jul-26", importedAt:"2026-07-25" },
  { id:"cm_c18_6", month:"2026-08", carrier:"Ambetter",     policyType:"aca",      clientNameRaw:"Teresa Nunez",     clientId:"c18", memberIdRaw:"AMB-M-6603",  amount:90.00, matchScore:96, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"Aug-26", importedAt:"2026-08-25" },
  { id:"cm_c19_1", month:"2026-03", carrier:"Progressive",  policyType:"auto",     clientNameRaw:"Frank Delgado",    clientId:"c19", memberIdRaw:"PRG-AUTO-4419", amount:22.55, matchScore:95, saleType:"new", state:"FL", status:"paid", source:"upload", dueMonth:"Mar-26", importedAt:"2026-03-28" },
  { id:"cm_c19_2", month:"2026-03", carrier:"Universal Property", policyType:"home", clientNameRaw:"Frank Delgado",  clientId:"c19", memberIdRaw:"UPC-HO-2026-118", amount:24.60, matchScore:95, saleType:"new", state:"FL", status:"paid", source:"upload", dueMonth:"Mar-26", importedAt:"2026-03-28" },
  { id:"cm_c21_1", month:"2026-03", carrier:"Ambetter",     policyType:"aca",      clientNameRaw:"Hector Baez",      clientId:"c21", memberIdRaw:"AMB-M-2210",  amount:36.00, matchScore:95, saleType:"new",   state:"GA", status:"paid", source:"upload", dueMonth:"Mar-26", importedAt:"2026-03-25" },
  { id:"cm_c21_2", month:"2026-05", carrier:"Ambetter",     policyType:"aca",      clientNameRaw:"Hector Baez",      clientId:"c21", memberIdRaw:"AMB-M-2210",  amount:36.00, matchScore:95, saleType:"renew", state:"GA", status:"paid", source:"upload", dueMonth:"May-26", importedAt:"2026-05-25" },
  { id:"cm_c21_3", month:"2026-07", carrier:"Ambetter",     policyType:"aca",      clientNameRaw:"Hector Baez",      clientId:"c21", memberIdRaw:"AMB-M-2210",  amount:36.00, matchScore:95, saleType:"renew", state:"GA", status:"paid", source:"upload", dueMonth:"Jul-26", importedAt:"2026-07-25" },
  { id:"cm_c22_1", month:"2026-01", carrier:"WellCare",     policyType:"medicare", clientNameRaw:"Sandra Whitfield", clientId:"c22", memberIdRaw:"WC-91427",    amount:8.70,  matchScore:96, saleType:"new",   state:"GA", status:"paid", source:"upload", dueMonth:"Jan-26", importedAt:"2026-01-15" },
  { id:"cm_c22_2", month:"2026-06", carrier:"WellCare",     policyType:"medicare", clientNameRaw:"Sandra Whitfield", clientId:"c22", memberIdRaw:"WC-91427",    amount:8.70,  matchScore:96, saleType:"renew", state:"GA", status:"paid", source:"upload", dueMonth:"Jun-26", importedAt:"2026-06-15" },
  { id:"cm_c22_3", month:"2026-04", carrier:"Cigna",        policyType:"medicare", clientNameRaw:"Sandra Whitfield", clientId:"c22", memberIdRaw:"CIG-55307",   amount:23.60, matchScore:97, saleType:"new",   state:"GA", status:"paid", source:"upload", dueMonth:"Apr-26", importedAt:"2026-04-15" },
  { id:"cm_c22_4", month:"2026-06", carrier:"Cigna",        policyType:"medicare", clientNameRaw:"Sandra Whitfield", clientId:"c22", memberIdRaw:"CIG-55307",   amount:23.60, matchScore:97, saleType:"renew", state:"GA", status:"paid", source:"upload", dueMonth:"Jun-26", importedAt:"2026-06-15" },
  { id:"cm_c22_5", month:"2026-08", carrier:"Cigna",        policyType:"medicare", clientNameRaw:"Sandra Whitfield", clientId:"c22", memberIdRaw:"CIG-55307",   amount:23.60, matchScore:97, saleType:"renew", state:"GA", status:"paid", source:"upload", dueMonth:"Aug-26", importedAt:"2026-08-15" },
  { id:"cm_c23_1", month:"2026-04", carrier:"BCBS Texas",   policyType:"aca",      clientNameRaw:"Omar Guzman",      clientId:"c23", memberIdRaw:"BCTX-M-7742", amount:42.00, matchScore:96, saleType:"new",   state:"TX", status:"paid", source:"upload", dueMonth:"Apr-26", importedAt:"2026-04-22" },
  { id:"cm_c23_2", month:"2026-05", carrier:"BCBS Texas",   policyType:"aca",      clientNameRaw:"Omar Guzman",      clientId:"c23", memberIdRaw:"BCTX-M-7742", amount:42.00, matchScore:96, saleType:"renew", state:"TX", status:"paid", source:"upload", dueMonth:"May-26", importedAt:"2026-05-22" },
  { id:"cm_c23_3", month:"2026-06", carrier:"BCBS Texas",   policyType:"aca",      clientNameRaw:"Omar Guzman",      clientId:"c23", memberIdRaw:"BCTX-M-7742", amount:42.00, matchScore:96, saleType:"renew", state:"TX", status:"paid", source:"upload", dueMonth:"Jun-26", importedAt:"2026-06-22" },
  { id:"cm_c23_4", month:"2026-07", carrier:"BCBS Texas",   policyType:"aca",      clientNameRaw:"Omar Guzman",      clientId:"c23", memberIdRaw:"BCTX-M-7742", amount:42.00, matchScore:96, saleType:"renew", state:"TX", status:"paid", source:"upload", dueMonth:"Jul-26", importedAt:"2026-07-22" },
  { id:"cm_c23_5", month:"2026-08", carrier:"BCBS Texas",   policyType:"aca",      clientNameRaw:"Omar Guzman",      clientId:"c23", memberIdRaw:"BCTX-M-7742", amount:42.00, matchScore:96, saleType:"renew", state:"TX", status:"paid", source:"upload", dueMonth:"Aug-26", importedAt:"2026-08-22" },
  { id:"cm_c23_6", month:"2026-05", carrier:"Mutual of Omaha", policyType:"life",  clientNameRaw:"Omar Guzman",      clientId:"c23", memberIdRaw:"MOO-8830",    amount:828.00,matchScore:97, saleType:"new",   state:"TX", status:"paid", source:"upload", dueMonth:"May-26", importedAt:"2026-05-28" },
  { id:"cm_c24_1", month:"2026-05", carrier:"Ambetter",     policyType:"aca",      clientNameRaw:"Ines Salazar",     clientId:"c24", memberIdRaw:"AMB-M-5521",  amount:21.00, matchScore:95, saleType:"new",   state:"TX", status:"paid", source:"upload", dueMonth:"May-26", importedAt:"2026-05-25" },
  { id:"cm_c24_2", month:"2026-06", carrier:"Ambetter",     policyType:"aca",      clientNameRaw:"Ines Salazar",     clientId:"c24", memberIdRaw:"AMB-M-5521",  amount:21.00, matchScore:95, saleType:"renew", state:"TX", status:"paid", source:"upload", dueMonth:"Jun-26", importedAt:"2026-06-25" },
  { id:"cm_c24_3", month:"2026-07", carrier:"Ambetter",     policyType:"aca",      clientNameRaw:"Ines Salazar",     clientId:"c24", memberIdRaw:"AMB-M-5521",  amount:21.00, matchScore:95, saleType:"renew", state:"TX", status:"paid", source:"upload", dueMonth:"Jul-26", importedAt:"2026-07-25" },
  { id:"cm_c24_4", month:"2026-08", carrier:"Ambetter",     policyType:"aca",      clientNameRaw:"Ines Salazar",     clientId:"c24", memberIdRaw:"AMB-M-5521",  amount:21.00, matchScore:95, saleType:"renew", state:"TX", status:"paid", source:"upload", dueMonth:"Aug-26", importedAt:"2026-08-25" },
  // Ricardo Pena (c25): pagó ene-may, canceló en junio → chargeback en julio
  { id:"cm_c25_1", month:"2026-01", carrier:"Oscar",        policyType:"aca",      clientNameRaw:"Ricardo Pena",     clientId:"c25", memberIdRaw:"OSC-M-2201",  amount:27.00, matchScore:95, saleType:"new",   state:"FL", status:"paid", source:"upload", dueMonth:"Jan-26", importedAt:"2026-01-15" },
  { id:"cm_c25_2", month:"2026-02", carrier:"Oscar",        policyType:"aca",      clientNameRaw:"Ricardo Pena",     clientId:"c25", memberIdRaw:"OSC-M-2201",  amount:27.00, matchScore:95, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"Feb-26", importedAt:"2026-02-15" },
  { id:"cm_c25_3", month:"2026-03", carrier:"Oscar",        policyType:"aca",      clientNameRaw:"Ricardo Pena",     clientId:"c25", memberIdRaw:"OSC-M-2201",  amount:27.00, matchScore:95, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"Mar-26", importedAt:"2026-03-15" },
  { id:"cm_c25_4", month:"2026-04", carrier:"Oscar",        policyType:"aca",      clientNameRaw:"Ricardo Pena",     clientId:"c25", memberIdRaw:"OSC-M-2201",  amount:27.00, matchScore:95, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"Apr-26", importedAt:"2026-04-15" },
  { id:"cm_c25_5", month:"2026-05", carrier:"Oscar",        policyType:"aca",      clientNameRaw:"Ricardo Pena",     clientId:"c25", memberIdRaw:"OSC-M-2201",  amount:27.00, matchScore:95, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"May-26", importedAt:"2026-05-15" },
  { id:"cm_c25_6", month:"2026-07", carrier:"Oscar",        policyType:"aca",      clientNameRaw:"Ricardo Pena",     clientId:"c25", memberIdRaw:"OSC-M-2201",  amount:-54.00,matchScore:95, saleType:"cb",    state:"FL", status:"paid", source:"upload", dueMonth:"Jul-26", importedAt:"2026-07-15" },
  { id:"cm_c26_1", month:"2026-05", carrier:"Humana",       policyType:"medicare", clientNameRaw:"Dorothy Klein",    clientId:"c26", memberIdRaw:"HUM-70233",   amount:34.40, matchScore:97, saleType:"new",   state:"FL", status:"paid", source:"upload", dueMonth:"May-26", importedAt:"2026-05-15" },
  { id:"cm_c26_2", month:"2026-06", carrier:"Humana",       policyType:"medicare", clientNameRaw:"Dorothy Klein",    clientId:"c26", memberIdRaw:"HUM-70233",   amount:34.40, matchScore:97, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"Jun-26", importedAt:"2026-06-15" },
  { id:"cm_c26_3", month:"2026-07", carrier:"Humana",       policyType:"medicare", clientNameRaw:"Dorothy Klein",    clientId:"c26", memberIdRaw:"HUM-70233",   amount:34.40, matchScore:97, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"Jul-26", importedAt:"2026-07-15" },
  { id:"cm_c26_4", month:"2026-08", carrier:"Humana",       policyType:"medicare", clientNameRaw:"Dorothy Klein",    clientId:"c26", memberIdRaw:"HUM-70233",   amount:34.40, matchScore:97, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"Aug-26", importedAt:"2026-08-15" },
  { id:"cm_c26_5", month:"2026-05", carrier:"Humana",       policyType:"medicare", clientNameRaw:"Dorothy Klein",    clientId:"c26", memberIdRaw:"HUM-70234",   amount:9.40,  matchScore:97, saleType:"new",   state:"FL", status:"paid", source:"upload", dueMonth:"May-26", importedAt:"2026-05-15" },
  { id:"cm_c26_6", month:"2026-08", carrier:"Humana",       policyType:"medicare", clientNameRaw:"Dorothy Klein",    clientId:"c26", memberIdRaw:"HUM-70234",   amount:9.40,  matchScore:97, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"Aug-26", importedAt:"2026-08-15" },
  { id:"cm_c27_1", month:"2026-05", carrier:"Hartford",     policyType:"commercial",clientNameRaw:"Alejandro Fuentes",clientId:"c27", memberIdRaw:"HFD-BOP-5501", amount:59.20, matchScore:97, saleType:"new",  state:"FL", status:"paid", source:"upload", dueMonth:"May-26", importedAt:"2026-05-20" },
  { id:"cm_c27_2", month:"2026-06", carrier:"Hartford",     policyType:"commercial",clientNameRaw:"Alejandro Fuentes",clientId:"c27", memberIdRaw:"HFD-BOP-5501", amount:59.20, matchScore:97, saleType:"renew",state:"FL", status:"paid", source:"upload", dueMonth:"Jun-26", importedAt:"2026-06-20" },
  { id:"cm_c27_3", month:"2026-07", carrier:"Hartford",     policyType:"commercial",clientNameRaw:"Alejandro Fuentes",clientId:"c27", memberIdRaw:"HFD-BOP-5501", amount:59.20, matchScore:97, saleType:"renew",state:"FL", status:"paid", source:"upload", dueMonth:"Jul-26", importedAt:"2026-07-20" },
  { id:"cm_c27_4", month:"2026-08", carrier:"Hartford",     policyType:"commercial",clientNameRaw:"Alejandro Fuentes",clientId:"c27", memberIdRaw:"HFD-BOP-5501", amount:59.20, matchScore:97, saleType:"renew",state:"FL", status:"paid", source:"upload", dueMonth:"Aug-26", importedAt:"2026-08-20" },
  { id:"cm_c27_5", month:"2026-05", carrier:"Hartford",     policyType:"commercial",clientNameRaw:"Alejandro Fuentes",clientId:"c27", memberIdRaw:"HFD-UMB-5502", amount:17.60, matchScore:97, saleType:"new",  state:"FL", status:"paid", source:"upload", dueMonth:"May-26", importedAt:"2026-05-20" },
  // Vilma Contreras (c28): jun y jul pagados; agosto NO llegó (póliza en gracia)
  { id:"cm_c28_1", month:"2026-06", carrier:"Florida Blue", policyType:"aca",      clientNameRaw:"Vilma Contreras",  clientId:"c28", memberIdRaw:"FB-M-9928",   amount:38.00, matchScore:96, saleType:"new",   state:"FL", status:"paid", source:"upload", dueMonth:"Jun-26", importedAt:"2026-06-18" },
  { id:"cm_c28_2", month:"2026-07", carrier:"Florida Blue", policyType:"aca",      clientNameRaw:"Vilma Contreras",  clientId:"c28", memberIdRaw:"FB-M-9928",   amount:38.00, matchScore:96, saleType:"renew", state:"FL", status:"paid", source:"upload", dueMonth:"Jul-26", importedAt:"2026-07-18" },
  // Sin conciliar del mes corriente — para practicar "necesita revisión"
  { id:"cm_un_2", month:"2026-08", carrier:"Ambetter",      policyType:"aca",      clientNameRaw:"Yaneisy Blanco",   clientId:null, memberIdRaw:"AMB-88341",    amount:61.00, matchScore:0,  saleType:"new",   state:"FL", status:"unmatched", source:"upload", dueMonth:"Aug-26", importedAt:"2026-08-25" },
];

const SEED_CHANGEHISTORY = [ { id:"h1", type:"client", entityId:"c1", clientId:"c1", date:"2025-11-15T14:32:00.000Z", user:"Sarah Johnson", changes:[ {field:"addressStreet", label:"Dirección", from:"789 Pine St Apt 1A", to:"1234 Elm St Apt 2B"}, {field:"addressCity", label:"Ciudad", from:"Rockville", to:"Silver Spring"}, {field:"addressZip", label:"ZIP", from:"20850", to:"20901"}, ] }, { id:"h2", type:"policy", entityId:"p1a", clientId:"c1", date:"2025-12-01T09:15:00.000Z", user:"Sarah Johnson", carrier:"CareFirst -> Oscar", policyType:"aca", changes:[ {field:"carrier", label:"Compañía", from:"CareFirst", to:"Oscar"}, {field:"plan", label:"Plan", from:"BlueChoice Gold PPO", to:"Silver Select PPO"}, {field:"monthlyPremium", label:"Prima Mensual", from:"$210.00", to:"$185.00"}, {field:"policyNumber", label:"# Póliza", from:"CFC-2024-8812", to:"OSC-2025-9441"}, {field:"memberId", label:"Member ID", from:"CFC-M-8812", to:"OSC-M-9441"}, {field:"effectiveDate", label:"Fecha Inicio", from:"01/01/2024", to:"01/01/2025"}, {field:"renewalDate", label:"Fecha Renovación",from:"12/31/2024", to:"12/31/2025"}, ] }, { id:"h3", type:"policy", entityId:"p6b", clientId:"c6", date:"2025-10-22T11:48:00.000Z", user:"Sarah Johnson", carrier:"GEICO", policyType:"auto", changes:[ {field:"vehicleYear", label:"Año Vehículo", from:"2019", to:"2023"}, {field:"vehicleMake", label:"Marca", from:"Honda", to:"Toyota"}, {field:"vehicleModel", label:"Modelo", from:"Civic", to:"Camry"}, {field:"vin", label:"VIN", from:"2HGFC2F59KH521743", to:"4T1C11AK8PU712834"}, {field:"licensePlate", label:"Placa", from:"MD-8KJ291", to:"MD-3TL008"}, {field:"monthlyPremium",label:"Prima Mensual", from:"$142.00", to:"$168.00"}, ] }, { id:"h4", type:"client", entityId:"c9", clientId:"c9", date:"2025-11-30T16:05:00.000Z", user:"Sarah Johnson", changes:[ {field:"annualIncome", label:"Ingresos", from:"$48,000", to:"$52,000"}, {field:"householdSize", label:"Tamaño Hogar", from:"4", to:"5"}, {field:"notes", label:"Notas", from:"Grupo familiar.", to:"Grupo familiar con hija mayor de 26 (Daniela) con perfil separado."}, ] }, { id:"h5", type:"policy", entityId:"p9a", clientId:"c9", date:"2025-12-03T10:20:00.000Z", user:"Sarah Johnson", carrier:"Oscar", policyType:"aca", changes:[ {field:"plan", label:"Plan", from:"Bronze Basic HMO", to:"Silver Select PPO"}, {field:"monthlyPremium", label:"Prima Mensual", from:"$112.00", to:"$185.00"}, {field:"familySize", label:"Tamaño Familia", from:"4", to:"4"}, {field:"membersActive", label:"Miembros Activos",from:"3", to:"4"}, {field:"effectiveDate", label:"Fecha Inicio", from:"01/01/2024", to:"01/01/2025"}, ] }, { id:"h6", type:"policy", entityId:"p7a", clientId:"c7", date:"2025-09-18T13:30:00.000Z", user:"Sarah Johnson", carrier:"Nationwide", policyType:"home", changes:[ {field:"insuredValue", label:"Valor Asegurado", from:"$310,000", to:"$375,000"}, {field:"monthlyPremium", label:"Prima Mensual", from:"$145.00", to:"$172.00"}, {field:"deductible", label:"Deducible", from:"$2,500", to:"$1,500"}, ] }, { id:"h7", type:"policy", entityId:"p8a", clientId:"c8", date:"2025-10-05T09:00:00.000Z", user:"Sarah Johnson", carrier:"Travelers", policyType:"commercial", changes:[ {field:"coverageType", label:"Tipo Cobertura", from:"General Liability", to:"BOP (Business Owner Policy)"}, {field:"numEmployees", label:"Empleados", from:"3", to:"8"}, {field:"annualRevenue", label:"Ingresos Anuales", from:"$180,000", to:"$320,000"}, {field:"monthlyPremium", label:"Prima Mensual", from:"$210.00", to:"$385.00"}, ] }, { id:"h8", type:"client", entityId:"c2", clientId:"c2", date:"2025-12-10T15:45:00.000Z", user:"Sarah Johnson", changes:[ {field:"phone", label:"Teléfono", from:"813-555-0199", to:"941-555-0234"}, {field:"email", label:"Email", from:"james.t@oldmail.com", to:"jthompson@example.com"}, {field:"notes", label:"Notas", from:"", to:"Moving to GA in Q3 - follow up re plan change"}, ] },
];


const SEED_TIMELOG = [ { id:"tl1", userId:"u2", date:"2026-02-24", clockIn:"09:02", clockOut:"13:15", hours:4.22, notes:"ACA applications" }, { id:"tl2", userId:"u2", date:"2026-02-24", clockIn:"14:00", clockOut:"17:30", hours:3.5, notes:"Client calls" }, { id:"tl3", userId:"u2", date:"2026-02-25", clockIn:"09:00", clockOut:"12:00", hours:3.0, notes:"Document follow-ups" }, { id:"tl4", userId:"u2", date:"2026-02-26", clockIn:"10:15", clockOut:"14:45", hours:4.5, notes:"Enrollment forms" }, { id:"tl5", userId:"u1", date:"2026-02-26", clockIn:"08:30", clockOut:"17:00", hours:8.5, notes:"Full day" },
];

const SEED_ACTIVITYLOG = [
  // Maria Rodriguez (c1) — Agent and Assistant activity mixed
  { id:"al1",  clientId:"c1", userId:"u2", action:"created",       detail:"Client profile created",                        ts:"2024-01-15T10:22:00" },
  { id:"al2",  clientId:"c1", userId:"u2", action:"policyAdded",   detail:"Added Medicare Advantage (Aetna)",              ts:"2024-01-16T09:11:00" },
  { id:"c1a3", clientId:"c1", userId:"u2", action:"commission",    detail:"Commission logged: $42.50 (Aetna MA)",          ts:"2026-07-01T08:30:00" },
  { id:"c1a4", clientId:"c1", userId:"u2", action:"note",          detail:"Note added: lost Medicare card — order replacement", ts:"2026-08-22T09:48:00" },
  { id:"c1a5", clientId:"c1", userId:"u3", action:"docUploaded",   detail:"Attachment uploaded: ID_Rodriguez.jpg",         ts:"2026-08-22T14:50:00" },
  { id:"c1a6", clientId:"c1", userId:"u3", action:"note",          detail:"Note added: solicité reemplazo de tarjeta Medicare por mymedicare.gov", ts:"2026-08-23T10:15:00" },
  { id:"c1a7", clientId:"c1", userId:"u3", action:"docUploaded",   detail:"Document received: Medicare_Card_Rodriguez.pdf", ts:"2026-09-15T14:12:00" },
  { id:"c1a8", clientId:"c1", userId:"u2", action:"note",          detail:"Note added: son Luis turns 18 in March — review dependency", ts:"2026-10-05T15:15:00" },
  { id:"c1a9", clientId:"c1", userId:"u2", action:"policyUpdated", detail:"Policy updated: Aetna MA HMO — status → active", ts:"2026-10-18T10:00:00" },
  { id:"c1a10",clientId:"c1", userId:"u3", action:"emailSent",     detail:"Email sent: Renewal 2027 confirmation",         ts:"2026-11-08T11:20:00" },
  { id:"c1a11",clientId:"c1", userId:"u2", action:"note",          detail:"Note added: wants to upgrade to Silver — diabetes Rx", ts:"2026-11-12T10:32:00" },
  { id:"c1a12",clientId:"c1", userId:"u2", action:"docUploaded",   detail:"Attachment uploaded: RxList_Rodriguez.pdf",     ts:"2026-11-12T10:33:00" },
  // James Thompson (c2) — Agent and Assistant activity mixed
  { id:"al5",  clientId:"c2", userId:"u2", action:"created",       detail:"Client profile created",                        ts:"2024-03-10T16:45:00" },
  { id:"c2a2", clientId:"c2", userId:"u3", action:"docUploaded",   detail:"Document uploaded: HIPAA_Consent_Thompson.pdf", ts:"2026-03-01T09:30:00" },
  { id:"c2a3", clientId:"c2", userId:"u2", action:"renewal",       detail:"Renewal marked complete: Medigap Plan G",       ts:"2026-03-15T13:10:00" },
  { id:"c2a4", clientId:"c2", userId:"u2", action:"commission",    detail:"Commission logged: $187.00 (Humana Medigap G)", ts:"2026-06-10T08:15:00" },
  { id:"c2a5", clientId:"c2", userId:"u2", action:"note",          detail:"Note added: renewal confirmed — premium +$8",   ts:"2026-06-12T16:22:00" },
  { id:"c2a6", clientId:"c2", userId:"u2", action:"policyUpdated", detail:"Term Life policy: beneficiary → Linda",         ts:"2026-08-30T10:45:00" },
  { id:"c2a7", clientId:"c2", userId:"u3", action:"note",          detail:"Note added: Linda solicitó cotización LTC — enviarle info", ts:"2026-09-19T11:05:00" },
  { id:"c2a8", clientId:"c2", userId:"u3", action:"docUploaded",   detail:"Attachment uploaded: LTC_Quote_Thompson.pdf",   ts:"2026-09-19T11:07:00" },
  { id:"c2a9", clientId:"c2", userId:"u3", action:"emailSent",     detail:"Email sent: Tampa area network check",          ts:"2026-10-20T15:00:00" },
  { id:"c2a10",clientId:"c2", userId:"u2", action:"note",          detail:"Note added: moving to Tampa FL — verify network", ts:"2026-11-04T14:10:00" },
  // Others
  { id:"al3",  clientId:"c3", userId:"u2", action:"statusChanged", detail:"Status: prospect -> pending",                   ts:"2024-02-20T14:05:00" },
  { id:"al4",  clientId:"c3", userId:"u3", action:"docUploaded",   detail:"Uploaded: HIPAA_Consent.pdf",                   ts:"2024-02-21T11:30:00" },
];
// Demo eligibility alerts — for clients with ACA applications
const SEED_ELIG_ALERTS = [
  // Ana Gutierrez (c3) — pending income verification (the classic ACA scenario)
  { id:"elig_c3_1", clientId:"c3", type:"income_docs",       doc:"Verificación de Ingresos — Ana Gutierrez",      docEn:"Income Verification — Ana Gutierrez",      deadline:"2026-05-15", status:"pending",   applicationId:"2025-MD-331298", pdfName:"Eligibility_Gutierrez_2026.pdf", persons:["Ana Gutierrez"], createdAt:"2026-02-20T14:05:00" },
  { id:"elig_c3_2", clientId:"c3", type:"immigration_docs",  doc:"Estatus Migratorio — Ana Gutierrez",            docEn:"Immigration Status — Ana Gutierrez",       deadline:"2026-05-15", status:"pending",   applicationId:"2025-MD-331298", pdfName:"Eligibility_Gutierrez_2026.pdf", persons:["Ana Gutierrez"], createdAt:"2026-02-20T14:05:00" },
  // Lucia Fernandez (c5) — overdue proof of address
  { id:"elig_c5_1", clientId:"c5", type:"address_docs",      doc:"Prueba de Dirección — Lucia Fernandez",         docEn:"Proof of Address — Lucia Fernandez",       deadline:"2026-04-01", status:"pending",   applicationId:"2025-MD-775421", pdfName:"Eligibility_Fernandez_2026.pdf", persons:["Lucia Fernandez"], createdAt:"2026-01-15T10:20:00" },
  // Carmen Villanueva (c9) — completed
  { id:"elig_c9_1", clientId:"c9", type:"income_docs",       doc:"Verificación de Ingresos — Carmen Villanueva",  docEn:"Income Verification — Carmen Villanueva",  deadline:"2026-03-01", status:"completed", applicationId:"2025-MD-944177", pdfName:"Eligibility_Villanueva_2026.pdf", persons:["Carmen Villanueva","Roberto Villanueva"], createdAt:"2025-11-10T09:30:00" },
  { id:"elig_c9_2", clientId:"c9", type:"citizenship_docs",  doc:"Prueba de Ciudadanía — Sofia Villanueva",       docEn:"Citizenship Proof — Sofia Villanueva",     deadline:"2026-03-01", status:"completed", applicationId:"2025-MD-944177", pdfName:"Eligibility_Villanueva_2026.pdf", persons:["Sofia Villanueva"], createdAt:"2025-11-10T09:30:00" },
];

// Demo calendar events — renewals, birthdays, appointments, tasks
const SEED_CAL_EVENTS = [
  // Renewals (orange)
  { id:"ev_ren_c2", date:"2026-03-15", title:"🔄 James Thompson — Medigap G Renewal", type:"renewal", clientId:"c2", time:"10:00", notes:"Llamar con 15 días de anticipación" },
  { id:"ev_ren_c4", date:"2026-03-20", title:"🔄 Robert Chen — Part D Renewal",        type:"renewal", clientId:"c4", time:"11:00", notes:"" },
  { id:"ev_ren_c9", date:"2026-12-31", title:"🔄 Villanueva Family — ACA Renewal",     type:"renewal", clientId:"c9", time:"09:00", notes:"" },
  // Appointments (cyan)
  { id:"ev_app_c1", date:"2026-04-18", title:"📅 Maria Rodriguez — Revisión de plan",  type:"appointment", clientId:"c1", time:"14:00", notes:"Ofrecer upgrade a Silver por insulina" },
  { id:"ev_app_c8", date:"2026-04-22", title:"📅 Diego Ramirez — Revisión comercial",  type:"appointment", clientId:"c8", time:"10:30", notes:"Umbrella + liability review" },
  // Deadlines (red)
  { id:"ev_dl_c3",  date:"2026-05-15", title:"⏰ Ana Gutierrez — Income Verification (90 días)", type:"deadline", clientId:"c3", time:"", notes:"Subir W2 2025 antes de esta fecha" },
  { id:"ev_dl_c5",  date:"2026-04-01", title:"⏰ Lucia Fernandez — Proof of Address",  type:"deadline", clientId:"c5", time:"", notes:"CareFirst podría cancelar la póliza" },
  // Calls (purple)
  { id:"ev_call_c1",date:"2026-04-15", title:"📞 Maria Rodriguez — Follow-up",         type:"call", clientId:"c1", time:"15:00", notes:"Confirmar que recibió tarjeta Medicare de reemplazo" },
  { id:"ev_call_c7",date:"2026-04-17", title:"📞 Patricia Williams — Annual review",   type:"call", clientId:"c7", time:"16:00", notes:"" },
  // Birthdays (pink) — auto-generated too, but adding manual ones for demo
  { id:"ev_bd_c1",  date:"2026-04-12", title:"🎂 Maria Rodriguez",                      type:"birthday", clientId:"c1", time:"", notes:"Mandar tarjeta en español" },
  { id:"ev_bd_c2",  date:"2026-06-15", title:"🎂 James Thompson",                       type:"birthday", clientId:"c2", time:"", notes:"" },
  { id:"ev_bd_c9",  date:"2026-03-14", title:"🎂 Carmen Villanueva",                    type:"birthday", clientId:"c9", time:"", notes:"" },
  // Meetings (green)
  { id:"ev_mtg_1",  date:"2026-04-20", title:"🤝 Weekly team sync",                     type:"meeting", clientId:"", time:"09:00", notes:"Revisar pipeline semanal" },
  { id:"ev_mtg_2",  date:"2026-04-25", title:"🤝 Aetna carrier training — New MA plans",type:"meeting", clientId:"", time:"13:00", notes:"Webinar online" },
  // Follow-ups (amber)
  { id:"ev_fu_c5",  date:"2026-04-14", title:"🔔 Lucia Fernandez — Prospect follow-up", type:"followup", clientId:"c5", time:"11:00", notes:"Still interested in Silver upgrade?" },
];

// Demo agent licenses — the invented "Agencia Demo", never the real agency:
// this dataset ships inside the public demo bundle at deskte.com/demo/app/.
const SEED_LICENSES = [
  { id:"lic_1", userId:"u2", state:"FL", licenseNumber:"FL-P234567", type:"life_health", status:"active",  issuedDate:"2022-03-15", expiryDate:"2027-03-15", npn:"90000001", fileData:DEMO_PDF_LIC_FL, fileName:"FL_License_AgenciaDemo.pdf", fileType:"application/pdf", ceCredits:"22", ceRequired:"24", ceDeadline:"2027-02-01" },
  { id:"lic_2", userId:"u2", state:"GA", licenseNumber:"GA-H189234", type:"life_health", status:"active",  issuedDate:"2023-01-10", expiryDate:"2026-12-31", npn:"90000001", fileData:DEMO_PDF_LIC_MD, fileName:"GA_Health_License.pdf",       fileType:"application/pdf", ceCredits:"14", ceRequired:"16", ceDeadline:"2026-11-15" },
  { id:"lic_3", userId:"u2", state:"TX", licenseNumber:"TX-HL55421", type:"life_health", status:"active",  issuedDate:"2023-06-20", expiryDate:"2026-06-20", npn:"90000001", fileData:DEMO_PNG_LIC,    fileName:"TX_License_scan.png",          fileType:"image/png",        ceCredits:"8",  ceRequired:"12", ceDeadline:"2026-05-15" },
  { id:"lic_4", userId:"u2", state:"SC", licenseNumber:"SC-LH72318", type:"life_health", status:"pending", issuedDate:null,         expiryDate:null,         npn:"90000001" },
];

// Demo carrier appointments (which carriers the agent can sell)
const SEED_COMP_APPTS = {
  u2: [
    { id:"ca_1", carrier:"Aetna",        states:["FL","MD","DC"], appointedSince:"2022-05-01", writingNumber:"AET-W-77215" },
    { id:"ca_2", carrier:"Humana",       states:["FL","MD","DC"], appointedSince:"2022-06-15", writingNumber:"HUM-W-88901" },
    { id:"ca_3", carrier:"CareFirst",    states:["MD","DC"],       appointedSince:"2023-02-10", writingNumber:"CF-W-33129" },
    { id:"ca_4", carrier:"Oscar",        states:["MD"],            appointedSince:"2024-01-05", writingNumber:"OSC-W-9441" },
    { id:"ca_5", carrier:"State Farm",   states:["MD","FL"],       appointedSince:"2024-07-20", writingNumber:"SF-W-44210" },
    { id:"ca_6", carrier:"GEICO",        states:["MD","DC","VA"], appointedSince:"2024-09-15", writingNumber:"GEI-W-8834" },
    { id:"ca_7", carrier:"Allstate",     states:["MD"],            appointedSince:"2025-03-01", writingNumber:"ALL-W-7712" },
    { id:"ca_8", carrier:"Hartford",     states:["DC","MD"],       appointedSince:"2025-08-10", writingNumber:"HFD-W-3391" },
  ]
};

const SEED_CLIENT_NOTES = [
  // Maria Rodriguez (c1) — most recent first, mix of Agent and Assistant authors
  { id:"n_c1_1", clientId:"c1", text:"Llamé para confirmar renovación ACA 2027. Pide que le subamos el plan a Silver porque ahora tiene insulina. Revisar subsidios actualizados.", files:[{ name:"RxList_Rodriguez.pdf", size:126976, type:"application/pdf", data:"" }], authorId:"u2", authorName:"Agent", createdAt:"2026-11-12T10:32:00" },
  { id:"n_c1_2", clientId:"c1", text:"Hijo Luis cumple 18 en marzo — revisar elegibilidad como dependiente en la próxima renovación.", files:[], authorId:"u2", authorName:"Agent", createdAt:"2026-10-05T15:15:00" },
  { id:"n_c1_4", clientId:"c1", text:"Solicité reemplazo de tarjeta Medicare por mymedicare.gov. Queda pendiente llamar a la cliente en 7-10 días para confirmar que llegó por correo.", files:[], authorId:"u3", authorName:"Assistant", createdAt:"2026-08-23T10:15:00" },
  { id:"n_c1_3", clientId:"c1", text:"Cliente perdió tarjeta de Medicare. Pedir reemplazo a través de mymedicare.gov. Ella no tiene computadora — ayudar en oficina.", files:[{ name:"ID_Rodriguez.jpg", size:911360, type:"image/jpeg", data:"" }], authorId:"u2", authorName:"Agent", createdAt:"2026-08-22T09:48:00" },
  // James Thompson (c2)
  { id:"n_c2_1", clientId:"c2", text:"Confirmó mudanza a Tampa FL para julio 2027. Hay que verificar si Humana Medigap G tiene red en FL o si necesita cambio de plan al llegar.", files:[], authorId:"u2", authorName:"Agent", createdAt:"2026-11-04T14:10:00" },
  { id:"n_c2_2", clientId:"c2", text:"Linda (esposa) solicitó cotización de long-term care. Ya le envié la info de Mutual of Omaha por email — esperando respuesta.", files:[{ name:"LTC_Quote_Thompson.pdf", size:348160, type:"application/pdf", data:"" }], authorId:"u3", authorName:"Assistant", createdAt:"2026-09-19T11:05:00" },
  { id:"n_c2_3", clientId:"c2", text:"Renovación Medigap G confirmada. Premium subió $8/mo — le avisé y está de acuerdo.", files:[], authorId:"u2", authorName:"Agent", createdAt:"2026-06-12T16:22:00" },
];

const RESOURCE_CATEGORIES = ["Training","Enrollment Guides","Plan Benefits","Compliance","Marketing Materials","Client Education","Forms","Other"];

const SEED_RESOURCES = [
  { id:"res_1", title:"ACA Enrollment Guide 2026", description:"Step-by-step guide for marketplace enrollment process", type:"pdf", carrier:"Ambetter", category:"Enrollment Guides", fileData:"", fileUrl:"", fileName:"aca_enrollment_guide_2026.pdf", fileSize:245000, uploadedBy:"u1", uploadedAt:"2026-03-01", sharedWithClients:["c1","c3","c5"], sharedWithAll:false, tags:["enrollment","aca","marketplace"] },
  { id:"res_2", title:"Medicare Advantage Overview", description:"Video explaining Medicare Advantage plans and benefits", type:"video", carrier:"Aetna", category:"Client Education", fileData:"", fileUrl:"https://www.youtube.com/watch?v=dQw4w9WgXcQ", fileName:"", fileSize:0, uploadedBy:"u1", uploadedAt:"2026-02-15", sharedWithClients:["c1","c2","c4"], sharedWithAll:false, tags:["medicare","advantage","video"] },
  { id:"res_3", title:"HIPAA Compliance Training", description:"Required compliance training materials for all agents", type:"document", carrier:"General", category:"Compliance", fileData:"", fileUrl:"", fileName:"hipaa_training_2026.docx", fileSize:189000, uploadedBy:"u1", uploadedAt:"2026-01-10", sharedWithClients:[], sharedWithAll:true, tags:["hipaa","compliance","training"] },
  { id:"res_4", title:"Plan Comparison Chart", description:"Visual comparison of all available health plans", type:"image", carrier:"CareFirst", category:"Plan Benefits", fileData:"", fileUrl:"", fileName:"plan_comparison_chart.png", fileSize:520000, uploadedBy:"u1", uploadedAt:"2026-03-20", sharedWithClients:["c3","c5","c9"], sharedWithAll:false, tags:["plans","comparison","chart"] },
  { id:"res_5", title:"Life Insurance Basics", description:"Educational video about term vs permanent life insurance", type:"video", carrier:"MetLife", category:"Client Education", fileData:"", fileUrl:"https://www.youtube.com/watch?v=dQw4w9WgXcQ", fileName:"", fileSize:0, uploadedBy:"u1", uploadedAt:"2026-02-28", sharedWithClients:["c2","c7"], sharedWithAll:false, tags:["life","insurance","education"] },
];

const SEED_RESOURCE_TOKENS = [
  { token:"portal_c1_abc123", clientId:"c1", createdAt:"2026-03-15", createdBy:"u1" },
  { token:"portal_c3_def456", clientId:"c3", createdAt:"2026-03-20", createdBy:"u1" },
];

const EMAIL_TEMPLATE_DEFAULTS = [
  { id:"et1", name:"Renewal Reminder", nameEs:"Recordatorio de Renovación", subject:"Time to review your {{carrier}} plan, {{firstName}}", subjectEs:"Es momento de revisar tu plan de {{carrier}}, {{firstName}}",
    body:`Hi {{firstName}},\n\nI hope you and your family are doing well. I'm reaching out because your {{carrier}} plan is coming up for renewal on {{renewalDate}}, and I want to make sure we get ahead of it together.\n\nA lot can change in a year — your household, your budget, the coverage you need. Before the renewal happens automatically, I'd like to take 15 minutes to:\n\n  • Review your current plan and confirm it still fits.\n  • Compare it against what other carriers are offering for your situation right now.\n  • Catch any savings or extra benefits you're not using.\n\nI'll do all the legwork — you just need to give me a quick call back, or reply to this email with a couple of times that work for you.\n\nThank you for trusting me with your coverage. Looking forward to talking soon.\n\nWarmly,\n{{agentName}}`,
    bodyEs:`Hola {{firstName}},\n\nEspero que tú y tu familia estén bien. Te escribo porque tu plan de {{carrier}} tiene fecha de renovación el {{renewalDate}}, y quiero que nos adelantemos juntos.\n\nUn año puede traer muchos cambios — tu hogar, tu presupuesto, lo que necesitas cubrir. Antes de que se renueve automáticamente, me gustaría tomar 15 minutos para:\n\n  • Revisar tu plan actual y confirmar que aún se ajusta a ti.\n  • Compararlo con lo que otras aseguradoras están ofreciendo hoy para tu situación.\n  • Detectar ahorros o beneficios extra que no estés usando.\n\nYo me encargo de todo el papeleo — tú solo me devuelves una llamada, o respondes este correo con un par de horarios que te funcionen.\n\nGracias por confiar en mí con tu cobertura. Hablamos pronto.\n\nUn abrazo,\n{{agentName}}` },
  { id:"et2", name:"Welcome New Client", nameEs:"Bienvenida Nuevo Cliente", subject:"Welcome aboard, {{firstName}} — and a quick rundown of what's next", subjectEs:"Bienvenido/a, {{firstName}} — y un resumen rápido de lo que sigue",
    body:`Hi {{firstName}},\n\nWelcome to the family! I'm so glad you decided to trust me with your coverage, and I want you to feel taken care of from day one.\n\nHere's what's next:\n\n  1. You'll receive a confirmation directly from {{carrier}} within the next few business days with your member ID, plan documents, and ID card.\n  2. I'll keep all your paperwork organized in your file — if anything ever comes up, just call or text me and I'll handle it.\n  3. We'll touch base again before your plan renews so we can review your options without any surprises.\n\nWhile you wait for your member card, save my number — I'm your main point of contact for anything insurance-related. Doctor question, billing issue, document needed, claim help: text or call me first, I'll point you in the right direction.\n\nAgain, thank you for choosing me. I take this seriously and you're in good hands.\n\nWarmly,\n{{agentName}}`,
    bodyEs:`Hola {{firstName}},\n\n¡Bienvenido/a a la familia! Me alegra mucho que hayas decidido confiar en mí con tu cobertura, y quiero que te sientas en buenas manos desde el día uno.\n\nEsto es lo que sigue:\n\n  1. En los próximos días hábiles vas a recibir una confirmación directa de {{carrier}} con tu número de miembro, los documentos del plan y tu tarjeta.\n  2. Yo mantengo toda tu documentación organizada en tu expediente — si algo se complica, me llamas o me envías mensaje y yo lo manejo.\n  3. Antes de que renueve tu plan, vamos a hablar de nuevo para revisar tus opciones sin sorpresas.\n\nMientras esperas tu tarjeta, guarda mi número — soy tu contacto principal para todo lo relacionado al seguro. Pregunta del doctor, problema con factura, documento que necesitas, ayuda con un reclamo: me escribes a mí primero y yo te oriento.\n\nGracias nuevamente por elegirme. Me tomo esto muy en serio y estás en buenas manos.\n\nUn abrazo,\n{{agentName}}` },
  { id:"et3", name:"Missing Documents", nameEs:"Documentos Faltantes", subject:"{{firstName}}, almost there — just need a couple more docs", subjectEs:"{{firstName}}, casi listos — solo faltan un par de documentos",
    body:`Hi {{firstName}},\n\nQuick favor — we're a step away from having your file 100% complete. The insurance company is still missing a few documents from us, and I want to get them in before anything affects your coverage.\n\nWhat to send:\n\n  • Proof of income (last 2 pay stubs, or last year's tax return)\n  • Proof of legal presence if applicable (green card, work permit, passport)\n  • Anything else we specifically asked for during your enrollment\n\nEasiest way to send them: take a clear photo with your phone and reply to this email with the picture attached. Or text it to me at {{agentPhone}}.\n\nIf you're not sure what's still needed or you have questions, give me a quick call — five minutes and we have it sorted.\n\nThanks so much,\n{{agentName}}`,
    bodyEs:`Hola {{firstName}},\n\nUn pequeño favor — estamos a un paso de tener tu expediente al 100%. La aseguradora todavía nos está pidiendo unos documentos, y quiero entregarlos antes de que afecten tu cobertura.\n\nLo que falta enviar:\n\n  • Comprobante de ingresos (últimos 2 cheques, o la declaración del año pasado)\n  • Comprobante de presencia legal si aplica (green card, permiso de trabajo, pasaporte)\n  • Cualquier otro que te pedimos específicamente durante tu inscripción\n\nLa forma más fácil de mandarlos: les tomas foto clara con el celular y me respondes este correo con la foto adjunta. O me los envías por texto al {{agentPhone}}.\n\nSi no estás segura/o de qué falta o tienes preguntas, me llamas — cinco minutos y lo resolvemos.\n\nMuchas gracias,\n{{agentName}}` },
  { id:"et4", name:"Birthday Greeting", nameEs:"Felicitación de Cumpleaños", subject:"Happy Birthday, {{firstName}}! 🎂🎉", subjectEs:"¡Feliz Cumpleaños, {{firstName}}! 🎂🎉",
    body:`Happy Birthday, {{firstName}}! 🎂\n\nI just wanted to take a moment to wish you a wonderful day full of laughter, love, and the people who matter most to you.\n\nWhether you're celebrating with cake, a quiet dinner, or just a normal day with a little extra joy — I hope it's exactly the kind of day you wanted.\n\nThank you for being part of my agency. Clients like you are the reason I love what I do, and it's a privilege to look out for you and your family year after year.\n\nEnjoy every minute today. 🎉\n\nWith warm wishes,\n{{agentName}}`,
    bodyEs:`¡Feliz Cumpleaños, {{firstName}}! 🎂\n\nQuería tomarme un momento para desearte un día maravilloso, lleno de risas, cariño y las personas que más quieres.\n\nYa sea que celebres con pastel, una cena tranquila, o simplemente un día normal con un toque extra de alegría — espero que sea exactamente el día que querías.\n\nGracias por ser parte de mi agencia. Clientes como tú son la razón por la que amo lo que hago, y es un privilegio cuidarte a ti y a tu familia año tras año.\n\nDisfruta cada minuto de hoy. 🎉\n\nUn abrazo grande,\n{{agentName}}` },
  { id:"et5", name:"Follow Up", nameEs:"Seguimiento", subject:"{{firstName}}, just checking in 👋", subjectEs:"{{firstName}}, solo para saludar 👋",
    body:`Hi {{firstName}},\n\nJust a quick check-in — no urgency, no agenda. I like to reach out to my clients every so often to make sure nothing's lingering on your end.\n\nA few things that might be useful right now:\n\n  • Has your household, income, or address changed in the last few months? If yes, we may want to update your plan.\n  • Any doctor visits, prescriptions, or claims where something didn't go smoothly? I can help fix it.\n  • Did you get a letter or email from your insurance company that you're not sure about? Forward it to me — I'll translate.\n\nIf everything's good on your end, that's great too — no reply needed. But if anything comes up, you know where to find me.\n\nTalk soon,\n{{agentName}}`,
    bodyEs:`Hola {{firstName}},\n\nSolo un saludo rápido — sin urgencia ni agenda. Me gusta comunicarme con mis clientes cada cierto tiempo para asegurarme de que nada se quede pendiente de tu lado.\n\nUn par de cosas que pueden ser útiles ahora:\n\n  • ¿Cambió tu hogar, tus ingresos, o tu dirección en los últimos meses? Si sí, conviene actualizar tu plan.\n  • ¿Alguna visita al doctor, receta o reclamo donde algo no salió bien? Yo te ayudo a arreglarlo.\n  • ¿Recibiste una carta o correo de tu aseguradora que no entendiste? Reenvíamelo — yo te traduzco.\n\nSi todo está bien por tu lado, perfecto también — no necesitas contestar. Pero si surge algo, ya sabes dónde encontrarme.\n\nHablamos pronto,\n{{agentName}}` },
];

/* ─── US Holiday Templates ─── */
const US_HOLIDAYS = [
  { id:"hol_newyear",    month:1,  day:1,  name:"New Year's Day",         nameEs:"Año Nuevo",               emoji:"🎆", subject:"Happy New Year, {{firstName}}! 🎆", subjectEs:"¡Feliz Año Nuevo, {{firstName}}! 🎆",
    body:"Hi {{firstName}}, 🎆\n\nHappy New Year! As we step into a fresh year together, I want to thank you for the trust you placed in me over the last twelve months. Clients like you are what make this work meaningful.\n\nMay this year bring you health, peace, and steady forward motion — at work, at home, and everywhere in between. Whatever the year throws at you, you have someone in your corner for the insurance side of life.\n\nHere's to a strong, healthy, prosperous year ahead.\n\nWith warm wishes for 2026,\n{{agentName}}",
    bodyEs:"Hola {{firstName}}, 🎆\n\n¡Feliz Año Nuevo! Al entrar a un año nuevo juntos, quiero agradecerte la confianza que depositaste en mí durante los últimos doce meses. Clientes como tú son lo que hace que este trabajo tenga sentido.\n\nQue este año te traiga salud, paz, y avance constante — en el trabajo, en casa, y en todo lo demás. Sea lo que sea que traiga el año, tienes a alguien de tu lado en todo lo relacionado al seguro.\n\nPor un año fuerte, saludable y próspero por delante.\n\nUn abrazo grande para empezar el 2026,\n{{agentName}}" },
  { id:"hol_mlk",        month:1,  day:20, name:"Martin Luther King Jr. Day", nameEs:"Día de Martin Luther King Jr.", emoji:"✊", subject:"Honoring Dr. King's dream today", subjectEs:"Honrando el sueño del Dr. King hoy",
    body:"Hi {{firstName}}, ✊\n\nToday we honor the life and work of Dr. Martin Luther King Jr. — a man who believed in equality, justice, and the power of community to do better, together.\n\nHis words still hit just as hard today: \"The time is always right to do what is right.\"\n\nWishing you a meaningful day of reflection, of service if you can give it, and of rest if you need it.\n\nWith respect,\n{{agentName}}",
    bodyEs:"Hola {{firstName}}, ✊\n\nHoy honramos la vida y la obra del Dr. Martin Luther King Jr. — un hombre que creyó en la igualdad, la justicia, y el poder de la comunidad para hacerlo mejor, juntos.\n\nSus palabras siguen siendo igual de fuertes hoy: \"Siempre es el momento adecuado para hacer lo correcto.\"\n\nQue tengas un día significativo de reflexión, de servicio si puedes darlo, y de descanso si lo necesitas.\n\nCon respeto,\n{{agentName}}" },
  { id:"hol_valentines", month:2,  day:14, name:"Valentine's Day",        nameEs:"Día de San Valentín",     emoji:"❤️", subject:"Happy Valentine's Day, {{firstName}}! ❤️", subjectEs:"¡Feliz Día de San Valentín, {{firstName}}! ❤️",
    body:"Hi {{firstName}}, ❤️\n\nHappy Valentine's Day! Whether you're celebrating with someone special, with your kids, with friends, or just with yourself and a good meal — I hope today feels warm.\n\nIt's a small day, but it's a good reminder of the people we love and the ones who love us back. I'm grateful you trust me with your family's coverage — looking out for the people you care about is exactly what I'm here for.\n\nSending love your way today.\n\n{{agentName}}",
    bodyEs:"Hola {{firstName}}, ❤️\n\n¡Feliz Día de San Valentín! Ya sea que celebres con alguien especial, con tus hijos, con amigos, o contigo misma/o y una buena comida — espero que hoy se sienta cálido.\n\nEs un día pequeño, pero es un buen recordatorio de las personas que queremos y de quienes nos quieren de vuelta. Agradezco mucho que me confíes la cobertura de tu familia — cuidar a las personas que te importan es exactamente para lo que estoy aquí.\n\nMucho cariño hoy.\n\n{{agentName}}" },
  { id:"hol_presidents", month:2,  day:17, name:"Presidents' Day",        nameEs:"Día de los Presidentes",  emoji:"🇺🇸", subject:"Happy Presidents' Day, {{firstName}} 🇺🇸", subjectEs:"Feliz Día de los Presidentes, {{firstName}} 🇺🇸",
    body:"Hi {{firstName}}, 🇺🇸\n\nA quick note to wish you a happy Presidents' Day. Whether you're using the long weekend for something fun, catching up on rest, or just enjoying a quiet day at home — I hope it lands the way you need it to.\n\nIf you took advantage of a holiday sale and got a new car, a new home, or anything else worth insuring, you know where to find me. Anytime.\n\nEnjoy the day,\n{{agentName}}",
    bodyEs:"Hola {{firstName}}, 🇺🇸\n\nUna nota rápida para desearte un feliz Día de los Presidentes. Ya sea que aproveches el fin de semana largo para algo divertido, para descansar, o simplemente para un día tranquilo en casa — espero que sea como necesitas que sea.\n\nSi aprovechaste una oferta del feriado y te conseguiste carro nuevo, casa nueva, o cualquier cosa que valga la pena asegurar, ya sabes dónde encontrarme. En cualquier momento.\n\nDisfruta el día,\n{{agentName}}" },
  { id:"hol_mothersday", month:5,  day:11, name:"Mother's Day",           nameEs:"Día de la Madre",         emoji:"🌷", subject:"Happy Mother's Day, {{firstName}} 🌷", subjectEs:"Feliz Día de la Madre, {{firstName}} 🌷",
    body:"Hi {{firstName}}, 🌷\n\nIf you're a mother, a stepmother, a grandmother, an aunt who's been there like a mother, a chosen-family mother, or anyone who has loved and raised a child — today is for you.\n\nMothers are the quiet engine behind so many families. The planning, the worrying, the calls to the doctor, the budget shuffling — much of it happens because someone is making sure everyone else is taken care of.\n\nThank you for everything you do. Enjoy a slower morning, a hug from someone you love, and a moment of feeling seen.\n\nWith love,\n{{agentName}}",
    bodyEs:"Hola {{firstName}}, 🌷\n\nSi eres mamá, madrastra, abuela, una tía que ha sido como una mamá, una mamá de familia escogida, o cualquier persona que ha amado y criado a un niño — hoy es para ti.\n\nLas mamás son el motor silencioso detrás de tantas familias. La planificación, la preocupación, las llamadas al doctor, el malabarismo del presupuesto — mucho de eso pasa porque alguien se está asegurando de que todos los demás estén bien.\n\nGracias por todo lo que haces. Disfruta una mañana sin prisa, un abrazo de alguien que quieres, y un momento de sentirte vista.\n\nCon cariño,\n{{agentName}}" },
  { id:"hol_memorial",   month:5,  day:26, name:"Memorial Day",           nameEs:"Día de los Caídos",       emoji:"🪖", subject:"Memorial Day — remembering those we lost", subjectEs:"Día de los Caídos — recordando a los que perdimos",
    body:"Hi {{firstName}}, 🪖\n\nMemorial Day weekend is here. Before the BBQs and the pool day, I want to take a second to pause for what this day is really about — the men and women who gave their lives so the rest of us could be home today with the people we love.\n\nIf you served, or you have someone in your family who served and never came back, you have my deepest respect today and always.\n\nWishing you a peaceful day with the people who matter to you.\n\nWith gratitude,\n{{agentName}}",
    bodyEs:"Hola {{firstName}}, 🪖\n\nLlegó el fin de semana del Día de los Caídos. Antes de los BBQ y el día en la piscina, quiero tomarme un segundo para pausar y pensar en lo que este día realmente significa — los hombres y mujeres que dieron sus vidas para que el resto de nosotros podamos estar hoy en casa con las personas que amamos.\n\nSi serviste, o tienes a alguien en tu familia que sirvió y no volvió, tienes mi más profundo respeto hoy y siempre.\n\nUn día tranquilo con las personas que te importan.\n\nCon gratitud,\n{{agentName}}" },
  { id:"hol_fathersday", month:6,  day:15, name:"Father's Day",           nameEs:"Día del Padre",           emoji:"👔", subject:"Happy Father's Day, {{firstName}} 👔", subjectEs:"Feliz Día del Padre, {{firstName}} 👔",
    body:"Hi {{firstName}}, 👔\n\nHappy Father's Day to all the dads, stepdads, granddads, uncles, and father-figures out there. The ones who show up. The ones who teach the small lessons. The ones who quietly carry a lot on their shoulders without saying much about it.\n\nWhether you're celebrating today, missing someone today, or both — I hope it's a meaningful one.\n\nEnjoy the day,\n{{agentName}}",
    bodyEs:"Hola {{firstName}}, 👔\n\nFeliz Día del Padre para todos los papás, padrastros, abuelos, tíos, y figuras paternas de la familia. Los que están presentes. Los que enseñan las lecciones pequeñas. Los que callados cargan mucho sobre los hombros sin decir demasiado.\n\nYa sea que estés celebrando hoy, extrañando a alguien hoy, o las dos cosas — espero que sea un día significativo.\n\nDisfruta,\n{{agentName}}" },
  { id:"hol_independence",month:7, day:4,  name:"Independence Day",       nameEs:"Día de la Independencia", emoji:"🎇", subject:"Happy 4th of July, {{firstName}}! 🎇", subjectEs:"¡Feliz 4 de Julio, {{firstName}}! 🎇",
    body:"Hi {{firstName}}, 🎇\n\nHappy Fourth of July! I hope you have a great day planned — whether it's a backyard BBQ, fireworks with the family, the lake, or just an early dinner and the AC turned all the way up.\n\nWhatever Independence Day looks like for you and yours, I hope it's safe, full of good food, and surrounded by people who matter.\n\nGod bless,\n{{agentName}}",
    bodyEs:"Hola {{firstName}}, 🎇\n\n¡Feliz Cuatro de Julio! Espero que tengas un buen día planeado — un BBQ en el patio, fuegos artificiales con la familia, el lago, o solo una cena temprano y el aire acondicionado a tope.\n\nSea como sea que se vea el Día de la Independencia para ti y los tuyos, espero que sea seguro, con buena comida, y rodeado de las personas que importan.\n\nQue Dios te bendiga,\n{{agentName}}" },
  { id:"hol_labor",      month:9,  day:1,  name:"Labor Day",              nameEs:"Día del Trabajo",         emoji:"💪", subject:"Happy Labor Day, {{firstName}} 💪", subjectEs:"Feliz Día del Trabajo, {{firstName}} 💪",
    body:"Hi {{firstName}}, 💪\n\nHappy Labor Day. This one's for the people who get up early, the ones who pull double shifts, the ones building something for their family, the small-business owners — everyone who knows what real work feels like.\n\nI see you. Take the day. Sleep in if you can. Grill if you want to. Sit on the porch and do nothing if that's what your body needs.\n\nYou've earned it.\n\n{{agentName}}",
    bodyEs:"Hola {{firstName}}, 💪\n\nFeliz Día del Trabajo. Este día es para la gente que se levanta temprano, los que doblan turnos, los que están construyendo algo para su familia, los dueños de negocio pequeño — todos los que saben lo que se siente el trabajo de verdad.\n\nTe veo. Toma el día. Duerme tarde si puedes. Haz parrilla si quieres. Siéntate en el porche y no hagas nada si eso es lo que tu cuerpo necesita.\n\nTe lo has ganado.\n\n{{agentName}}" },
  { id:"hol_columbus",   month:10, day:13, name:"Indigenous Peoples' Day",nameEs:"Día de los Pueblos Indígenas",emoji:"🌎", subject:"Indigenous Peoples' Day 🌎", subjectEs:"Día de los Pueblos Indígenas 🌎",
    body:"Hi {{firstName}}, 🌎\n\nA short message today to recognize the history, the resilience, and the contributions of indigenous communities — past and present.\n\nWishing you a thoughtful day with whoever you call family.\n\n{{agentName}}",
    bodyEs:"Hola {{firstName}}, 🌎\n\nUn mensaje breve hoy para reconocer la historia, la resistencia, y las contribuciones de las comunidades indígenas — del pasado y del presente.\n\nQue tengas un día reflexivo con quienes consideras tu familia.\n\n{{agentName}}" },
  { id:"hol_veterans",   month:11, day:11, name:"Veterans Day",           nameEs:"Día de los Veteranos",    emoji:"🎖️", subject:"Thank you for your service, {{firstName}} 🎖️", subjectEs:"Gracias por tu servicio, {{firstName}} 🎖️",
    body:"Hi {{firstName}}, 🎖️\n\nVeterans Day isn't just about ceremony — it's about saying \"thank you\" to real people who gave real years of their lives so the rest of us could live freely.\n\nIf you served, thank you. If your husband, wife, parent, sibling, or child served, thank them for me. They deserve to hear it.\n\nWith deep respect,\n{{agentName}}",
    bodyEs:"Hola {{firstName}}, 🎖️\n\nEl Día de los Veteranos no es solo de ceremonia — es de decirle \"gracias\" a personas reales que dieron años reales de su vida para que el resto de nosotros podamos vivir libres.\n\nSi serviste, gracias. Si tu esposo, esposa, padre, hermana o hija sirvió, dales las gracias de mi parte. Lo merecen escuchar.\n\nCon profundo respeto,\n{{agentName}}" },
  { id:"hol_thanksgiving",month:11,day:27, name:"Thanksgiving",           nameEs:"Día de Acción de Gracias",emoji:"🦃", subject:"Happy Thanksgiving, {{firstName}}! 🦃", subjectEs:"¡Feliz Día de Acción de Gracias, {{firstName}}! 🦃",
    body:"Hi {{firstName}}, 🦃\n\nThanksgiving is one of my favorite holidays of the year — and not because of the turkey (though, yes, the turkey too). It's the one day where the whole point is to slow down, sit at one table with the people we love, and actually name out loud the things we're grateful for.\n\nThis year, you're on my list. Thank you for trusting me with your family's coverage. Thank you for picking up the phone when I call. Thank you for being the kind of client that makes this work feel meaningful instead of transactional.\n\nMay your table be full, your house be loud, and your heart be heavy with gratitude.\n\nHappy Thanksgiving from my family to yours.\n\nWith gratitude,\n{{agentName}}",
    bodyEs:"Hola {{firstName}}, 🦃\n\nEl Día de Acción de Gracias es uno de mis feriados favoritos del año — y no es por el pavo (bueno, también por el pavo). Es el único día donde el punto entero es ir más despacio, sentarse en una sola mesa con la gente que amamos, y nombrar en voz alta las cosas por las que estamos agradecidos.\n\nEste año, tú estás en mi lista. Gracias por confiarme la cobertura de tu familia. Gracias por contestar el teléfono cuando te llamo. Gracias por ser el tipo de cliente que hace que este trabajo se sienta significativo y no solo una transacción.\n\nQue tu mesa esté llena, tu casa esté ruidosa, y tu corazón pesado de agradecimiento.\n\nFeliz Día de Acción de Gracias de mi familia a la tuya.\n\nCon gratitud,\n{{agentName}}" },
  { id:"hol_christmas",  month:12, day:25, name:"Christmas",              nameEs:"Navidad",                 emoji:"🎄", subject:"Merry Christmas, {{firstName}}! 🎄", subjectEs:"¡Feliz Navidad, {{firstName}}! 🎄",
    body:"Hi {{firstName}}, 🎄\n\nMerry Christmas! I'm taking a few minutes today to write to my clients and say what I don't say nearly often enough — thank you. For trusting me. For sticking with me through plan changes, paperwork headaches, and a few hard phone calls. For making it a privilege to do this work.\n\nMay your home be warm tonight, your table be full, and the people around it be the right ones. May the year ahead bring you steadier income, better news at the doctor's office, and the peace of knowing the important things are taken care of.\n\nMerry Christmas from my family to yours. 🎄\n\nWith love,\n{{agentName}}",
    bodyEs:"Hola {{firstName}}, 🎄\n\n¡Feliz Navidad! Hoy me tomo unos minutos para escribirles a mis clientes y decir lo que no digo lo suficientemente seguido — gracias. Por confiar en mí. Por quedarte conmigo a través de cambios de plan, dolores de cabeza de papeleo, y unas cuantas llamadas difíciles. Por hacer de este trabajo un privilegio.\n\nQue tu hogar esté cálido esta noche, tu mesa esté llena, y las personas a su alrededor sean las correctas. Que el año que viene te traiga ingresos más estables, mejores noticias en el consultorio del doctor, y la paz de saber que lo importante está cubierto.\n\nFeliz Navidad de mi familia a la tuya. 🎄\n\nCon cariño,\n{{agentName}}" },
  { id:"hol_newyeareve", month:12, day:31, name:"New Year's Eve",         nameEs:"Noche de Año Nuevo",      emoji:"🥂", subject:"See you on the other side, {{firstName}} 🥂", subjectEs:"Nos vemos del otro lado, {{firstName}} 🥂",
    body:"Hi {{firstName}}, 🥂\n\nIt's the last night of the year. Hard to believe.\n\nBefore the countdown, the fireworks, and whatever 2027 turns out to be — I want to say thank you for letting me be part of this year for you. Whether it was enrolling you, fixing a billing issue, getting a doctor's visit approved, or just answering a quick question — I appreciate you trusting me with all of it.\n\nWishing you a beautiful, safe night with the people you love. See you on the other side. 🥂\n\nCheers to a strong 2027,\n{{agentName}}",
    bodyEs:"Hola {{firstName}}, 🥂\n\nÚltima noche del año. Difícil de creer.\n\nAntes de la cuenta regresiva, los fuegos artificiales, y lo que sea que el 2027 termine siendo — quiero darte las gracias por dejarme ser parte de este año para ti. Sea inscribiéndote, arreglando un problema de factura, aprobando una visita al doctor, o simplemente respondiendo una pregunta rápida — te agradezco que me confíes todo eso.\n\nQue tengas una noche linda y segura con la gente que quieres. Nos vemos del otro lado. 🥂\n\nPor un 2027 fuerte,\n{{agentName}}" },
];
function getUpcomingHolidays() {
  const today = new Date(); today.setHours(0,0,0,0);
  const yr = today.getFullYear();
  return US_HOLIDAYS.map(h => {
    let d = holidayDateForYear(h, yr);
    if(d < today) d = holidayDateForYear(h, yr+1);
    const diff = Math.ceil((d - today)/(1000*60*60*24));
    return { ...h, date:d, daysUntil:diff, dateStr:`${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}-${String(d.getDate()).padStart(2,"0")}` };
  }).sort((a,b) => a.daysUntil - b.daysUntil);
}
/* ─── Send Greeting via Email / WhatsApp / SMS ───
 *
 * El SMS sale POR DESKTE (Quo / Twilio, el proveedor conectado del agente):
 * desde el numero de la agencia y quedando en el hilo del cliente. Antes se
 * abria la app de mensajes del ordenador —Mensajes en el Mac— y el saludo
 * salia, si salia, del telefono personal de quien estuviera sentado ahi
 * (Lissette, 2026-09-01). El enlace `sms:` sigue existiendo como PLAN B dentro
 * de `enviarSmsAlCliente`, ya diciendo por que se cayo a el.
 *
 * Correo y WhatsApp se quedan con su enlace y ES LO CORRECTO: el correo sale
 * del buzon del agente y el WhatsApp de su cuenta; no hay proveedor conectado
 * que pueda mandarlos en su nombre.
 *
 * Es la MISMA funcion que DashboardView.jsx: si una cambia y la otra no, el
 * mismo saludo sale por dos caminos distintos segun desde donde se pulse
 * (E-138). Las dos pasan por `enviarSmsAlCliente`.
 */
async function sendGreeting(channel, client, subject, body, lang) {
  const phone = (client.phone || "").replace(/[^0-9+]/g, "");
  const waPhone = phone.startsWith("+") ? phone.replace("+","") : (phone.startsWith("1") ? phone : "1" + phone);
  if (channel === "email" && client.email) {
    window.open("mailto:" + client.email + "?subject=" + encodeURIComponent(subject) + "&body=" + encodeURIComponent(body), "_blank");
  } else if (channel === "whatsapp" && phone) {
    window.open("https://wa.me/" + waPhone + "?text=" + encodeURIComponent(body), "_blank");
  } else if (channel === "sms") {
    const r = await enviarSmsAlCliente({ clientId: client.id, telefono: client.phone, mensaje: body, lang });
    if (r.enviado) toast.success(lang === "es" ? `SMS enviado a ${client.phone}` : `SMS sent to ${client.phone}`);
    else if (r.texto) toast.warn(r.texto);
  }
}
const CHANNEL_BTNS = [
  { id: "email", icon: "📧", color: "#0099cc" },
  { id: "whatsapp", icon: "💬", color: "#25d366" },
  { id: "sms", icon: "📱", color: "#ffb700" },
];
// Tamano compartido de los iconos de accion de una tarjeta de plantilla
// (enviar / ver / editar / borrar). Vivian a .65rem y se leian como manchitas;
// 1.05rem con 32px de area de pulsado es comodo con raton y deja los cuatro
// del mismo tamano, que antes tampoco lo estaban.
const TPL_ACTION_BTN = {
  minWidth: 32,
  height: 32,
  padding: "0 8px",
  fontSize: "1.05rem",
  lineHeight: 1,
  borderRadius: 7,
  cursor: "pointer",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
};
const uid = () => Math.random().toString(36).substr(2,9);
// Delegates to the shared formatter so the per-user Date Format preference
// (Settings → Preferences) applies to every date in this file too.
const fmt = d => fmtShared(d);
// Full timestamp (date + time, en-US). Accepts ISO datetimes — unlike fmt() which
// only handles date-only strings and would return "Invalid Date" on an ISO datetime.
const fmtDateTime = d => { if(!d) return "--"; const x=new Date(d); return isNaN(x.getTime()) ? "--" : x.toLocaleString("en-US",{month:"short",day:"numeric",year:"numeric",hour:"numeric",minute:"2-digit"}); };
const fmtMoney = v => { if(!v) return "--"; const n=parseFloat(v); return Number.isFinite(n) ? `$${n.toLocaleString("en-US",{minimumFractionDigits:2,maximumFractionDigits:2})}` : "--"; };
const fmtMonth = m => { if(!m) return "--"; const [y,mo]=m.split("-"); return new Date(+y,+mo-1,1).toLocaleDateString("en-US",{month:"long",year:"numeric"}); };
// Normalize a US 10-digit phone to "(305) 555-1234" when (and only when) it
// is exactly 10 digits, or "+1 (305) 555-1234" for a leading-1 11-digit
// number. Anything else (international, extensions, partial mid-typing) is
// returned UNCHANGED so we never mangle data the agent intentionally typed.
// Meant to run on blur, not per-keystroke, to avoid caret jumps.
// Normalize US phones to "+1 (305) 555-1234". We always prepend the +1
// country code on 10-digit numbers so SMS/WhatsApp deep-links work without
// extra fixups. Only the digits matter — any separators the agent typed
// (dashes, dots, parens, spaces) are stripped first. Anything that isn't a
// clean 10- or 1+10-digit US number is left untouched so we never mangle a
// half-typed or genuinely international number.
const formatPhoneUS = (raw) => {
  if (!raw) return raw;
  const s = String(raw).trim();
  const digits = s.replace(/\D/g, "");
  if (/^\d{10}$/.test(digits)) return `+1 (${digits.slice(0,3)}) ${digits.slice(3,6)}-${digits.slice(6)}`;
  if (/^1\d{10}$/.test(digits)) return `+1 (${digits.slice(1,4)}) ${digits.slice(4,7)}-${digits.slice(7)}`;
  return s;
};
// Lenient "looks like an email" check for an inline warning only \u2014 never used
// to BLOCK a save. Requires text@text.tld with no spaces.
const isEmailish = (e) => !e || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(e).trim());
const normName = s => (s||"").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g,"").replace(/[^a-z0-9 ]/g,"").trim();
const normUpper = n => (n||"").toUpperCase().replace(/[^A-Z\s]/g,"").replace(/\s+/g," ").trim();
function simScore(a, b) {
  const na = normUpper(a), nb = normUpper(b);
  if (na === nb) return 1;
  const w1 = new Set(na.split(" ")), w2 = new Set(nb.split(" "));
  if (w1.size && w2.size) {
    if ([...w1].every(x=>w2.has(x))||[...w2].every(x=>w1.has(x))) return 0.95;
    const inter = [...w1].filter(x=>w2.has(x));
    if (inter.length>=2) { const u = new Set([...w1,...w2]); if (inter.length/u.size>=0.5) return 0.92; }
  }
  const len = Math.max(na.length, nb.length);
  if (!len) return 0;
  let d = Array.from({length:na.length+1}, (_,i)=>Array(nb.length+1).fill(0));
  for (let i=0;i<=na.length;i++) d[i][0]=i;
  for (let j=0;j<=nb.length;j++) d[0][j]=j;
  for (let i=1;i<=na.length;i++) for(let j=1;j<=nb.length;j++)
    d[i][j]=Math.min(d[i-1][j]+1,d[i][j-1]+1,d[i-1][j-1]+(na[i-1]!==nb[j-1]?1:0));
  return 1-d[na.length][nb.length]/len;
}
function buildClientVariants(client) {
  const fn = (client.firstName||"").trim(), ln = (client.lastName||"").trim();
  const full = `${fn} ${ln}`.trim(), rev = `${ln} ${fn}`.trim();
  const names = [full, rev];
  if (full.includes("/")) {
    full.split(/\s*\/\s*/).forEach(p => {
      const t = p.trim();
      if (t) { names.push(t); const w = t.split(/\s+/); if (w.length>=2) names.push(w.reverse().join(" ")); }
    });
  }
  const fns = fn.toUpperCase().split(/\s+/), lns = ln.toUpperCase().split(/\s+/);
  if (fns.length > 1 || lns.length > 1) {
    names.push(fns[0] + " " + lns[lns.length-1]);
    names.push(lns[0] + " " + fns[0]);
  }
  [full, rev].forEach(n => { const c = n.replace(/[.\-,]/g,"").trim(); if (c && !names.includes(c)) names.push(c); });
  return names.filter(n => n.trim());
}
function bestMatchScoreForClient(commName, clientNames) {
  let best = 0;
  const cleanComm = commName.replace(/[.\-,]/g,"").trim();
  for (const n of clientNames) {
    const s = Math.max(simScore(commName, n), simScore(cleanComm, n));
    if (s > best) best = s;
  }
  const commWords = normUpper(cleanComm).split(" ").filter(w => w.length > 2);
  const clientWords = clientNames.flatMap(n => normUpper(n).split(" ")).filter(w => w.length > 2);
  const clientWordSet = new Set(clientWords);
  const matchedWords = commWords.filter(w => clientWordSet.has(w));
  if (matchedWords.length >= 2 && commWords.length <= 4) {
    const wordScore = matchedWords.length / Math.max(commWords.length, 2);
    if (wordScore > best) best = Math.min(wordScore, 0.92);
  }
  return best;
}
function fuzzyMatchClient(raw, clients) {
  const r = normName(raw); if (!r) return null;
  let best=null, bestScore=0;
  clients.forEach(c => {
    const names = buildClientVariants(c);
    const score = bestMatchScoreForClient(raw, names);
    if(score>bestScore&&score>=0.65){bestScore=score;best={...c, _matchScore: Math.round(score*100)};}
  });
  return best;
}
const MONTHS_LIST=()=>{const list=[];const now=new Date();for(let i=0;i<24;i++){const d=new Date(now.getFullYear(),now.getMonth()-i,1);list.push(`${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}`);}return list;};
const daysUntil = d => { if(!d) return null; const target=/^\d{4}-\d{2}-\d{2}$/.test(d)?new Date(d+"T00:00:00"):new Date(d); if(isNaN(target.getTime())) return null; const now=new Date(); const a=new Date(target.getFullYear(),target.getMonth(),target.getDate()); const b=new Date(now.getFullYear(),now.getMonth(),now.getDate()); return Math.round((a-b)/86400000); };
const parseDob = (dob) => { if(!dob) return new Date(NaN); const s=String(dob).trim(); if(/^\d{4}-\d{2}-\d{2}$/.test(s)) return new Date(s+"T00:00:00"); const m=s.match(/^(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{4})$/); if(m) return new Date(+m[3], +m[1]-1, +m[2]); return new Date(s); };
const birthdayThisWeek = (dob) => {
  if (!dob) return false;
  const today = new Date(); const bday = parseDob(dob);
  if (isNaN(bday.getTime())) return false;
  const next = new Date(today.getFullYear(), bday.getMonth(), bday.getDate());
  if (next < today) next.setFullYear(today.getFullYear()+1);
  const diff = Math.ceil((next-today)/(1000*60*60*24));
  return diff >= 0 && diff <= 7;
};
const birthdayToday = (dob) => {
  if (!dob) return false;
  const today = new Date(); const bday = parseDob(dob);
  if (isNaN(bday.getTime())) return false;
  return today.getMonth()===bday.getMonth() && today.getDate()===bday.getDate();
};
// ── Age & Milestone Helpers ──
const getAge = (dob) => { if(!dob) return null; const today=new Date(); const b=parseDob(dob); if(isNaN(b.getTime())) return null; let age=today.getFullYear()-b.getFullYear(); const m=today.getMonth()-b.getMonth(); if(m<0||(m===0&&today.getDate()<b.getDate())) age--; return age; };
const willTurnAge = (dob, targetAge) => { if(!dob) return null; const b=parseDob(dob); if(isNaN(b.getTime())) return null; const targetDate=new Date(b.getFullYear()+targetAge,b.getMonth(),b.getDate()); const today=new Date(); return Math.ceil((targetDate-today)/(1000*60*60*24)); };
const daysUntilBirthday = (dob) => { if(!dob) return null; const today=new Date(); today.setHours(0,0,0,0); const b=parseDob(dob); if(isNaN(b.getTime())) return null; let nb=new Date(today.getFullYear(),b.getMonth(),b.getDate()); nb.setHours(0,0,0,0); if(nb<today) nb.setFullYear(nb.getFullYear()+1); return Math.round((nb-today)/(1000*60*60*24)); };
const fmtBday = (dob) => { const b=parseDob(dob); return isNaN(b.getTime()) ? "--" : b.toLocaleDateString("en-US",{month:"short",day:"numeric"}); };
const STATUS_COLORS = {
  active:  { bg:"bg-emerald-500/15", text:"text-emerald-400", dot:"bg-emerald-400" },
  pending: { bg:"bg-amber-500/15",   text:"text-amber-400",   dot:"bg-amber-400"   },
  inactive:{ bg:"bg-slate-500/15",   text:"text-gray-500",   dot:"bg-slate-400"   },
  prospect:{ bg:"bg-blue-500/15",    text:"text-blue-400",    dot:"bg-blue-400"    },
};
const PRIORITY_COLORS = {
  high:  { bg:"bg-red-500/15",   text:"text-red-400"   },
  medium:{ bg:"bg-amber-500/15", text:"text-amber-400" },
  low:   { bg:"bg-slate-500/15", text:"text-gray-500" },
};
const SIGN_STATUS = {
  signed:  { bg:"bg-emerald-500/15", text:"text-emerald-400" },
  pending: { bg:"bg-amber-500/15",   text:"text-amber-400"   },
  declined:{ bg:"bg-red-500/15",     text:"text-red-400"     },
};

/* ═══════════════════════════════════════════════════
   E-SIGNATURE SYSTEM — SignaturePad + PublicSigningPage
   ═══════════════════════════════════════════════════ */


function useLocalStorage(key, init) {
  const [val,setVal] = useState(() => {
    try {
      const stored = localStorage.getItem(key);
      return stored ? JSON.parse(stored) : init;
    } catch { return init; }
  });
  useEffect(() => {
    try { localStorage.setItem(key, JSON.stringify(val)); } catch {}
  }, [key, val]);
  return [val,setVal];
}
function Badge({ status, t, type="client" }) {
  const map={active:'dkt-bdg dkt-bdg-grn',pending:'dkt-bdg dkt-bdg-amb',inactive:'dkt-bdg dkt-bdg-dim',prospect:'dkt-bdg dkt-bdg-cyn',referral:'dkt-bdg dkt-bdg-ref'};
  const cls=map[status]||'dkt-bdg dkt-bdg-dim';
  const label=t.statuses[status]||status;
  return <span className={cls}>
    <span style={{width:5,height:5,borderRadius:'50%',background:'currentColor',display:'inline-block'}}/>
    {label}
  </span>;
}
function PhaseNote({ msg }) {
  return <div className="dkt-phase">
    <Activity size={13} style={{marginTop:1,flexShrink:0}}/>
    <span>{msg}</span>
  </div>;
}
function CopiedBtn({ link, label }) {
  const [copied,setCopied] = useState(false);
  return <button onClick={()=>{ navigator.clipboard?.writeText(link).catch(()=>{}); setCopied(true); setTimeout(()=>setCopied(false),2000); }} className="dkt-copy">
    {copied?<><Check size={11} style={{color:'var(--c-green,#00ff88)'}}/>Copied</>:<><Copy size={11}/>{label}</>}
  </button>;
}
// InfoBlock moved to ./crm-app/components/ui.jsx (imported above).

function LoginScreen({ users, onLogin, lang, setLang }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const es = lang === "es";

  const handleLogin = () => {
    if (!email || !password) { setErr(es ? "Ingresa email y contraseña" : "Enter email and password"); return; }
    const user = users.find(u => u.email === email.toLowerCase().trim() && u.pin === password);
    if (user) { onLogin(user); }
    else { setErr(es ? "Email o contraseña incorrecta" : "Incorrect email or password"); }
  };

  const handleKey = (e) => { if (e.key === "Enter") handleLogin(); };

  // Demo accounts grouped by type
  const soloAccounts = users.filter(u => !u.agencyId);
  const agencyAccounts = users.filter(u => u.agencyId);
  const roleLabels = { agency_owner: "🏢 Agency Owner", agency_admin: "🔧 Admin", agent: "👤 Agent", assistant: es ? "👥 Asiento" : "👥 Seat", solo_agent: "🛡️ Solo Agent" };

  return (<div style={{minHeight:"100dvh",background:"var(--c-bg,#070d14)",display:"flex",alignItems:"center",justifyContent:"center",position:"relative",overflow:"hidden",fontFamily:"Sora,sans-serif"}}>
    <div style={{position:"absolute",width:500,height:500,borderRadius:"50%",background:"var(--c-cyan2,#00b4d8)",filter:"blur(120px)",opacity:.07,top:-150,right:-100}}/>
    <div style={{position:"absolute",width:350,height:350,borderRadius:"50%",background:"var(--c-green,#00ff88)",filter:"blur(100px)",opacity:.06,bottom:-100,left:-50}}/>
    <div className="dkt-login-box" style={{maxWidth:440}}>
      {/* Logo — full stacked (arrow + wordmark) */}
      <div style={{textAlign:'center',marginBottom:'1.25rem'}}>
        <img src={assetUrl('logo/deskte-ocean.svg')} alt="Deskte" style={{height:96,maxWidth:'85%',width:'auto',display:'block',margin:'0 auto .5rem'}}/>
        <div style={{fontSize:'.64rem',color:'var(--c-text3,#45688a)',fontFamily:'var(--font-mono)',letterSpacing:'.16em'}}>YOUR INSURANCE DESK</div>
        <div style={{display:'flex',justifyContent:'center',gap:'.4rem',marginTop:'.75rem'}}>
          <button onClick={()=>setLang('en')} style={{background:lang==='en'?'var(--c-cyan-dim)':'transparent',border:`1px solid ${lang==='en'?'rgba(0,212,255,.3)':'var(--c-border,#1a3550)'}`,color:lang==='en'?'var(--c-cyan,#00d4ff)':'var(--c-text3,#45688a)',padding:'.25rem .7rem',borderRadius:6,fontSize:'.72rem',fontWeight:700,cursor:'pointer',transition:'all .2s'}}>EN</button>
          <button onClick={()=>setLang('es')} style={{background:lang==='es'?'var(--c-cyan-dim)':'transparent',border:`1px solid ${lang==='es'?'rgba(0,212,255,.3)':'var(--c-border,#1a3550)'}`,color:lang==='es'?'var(--c-cyan,#00d4ff)':'var(--c-text3,#45688a)',padding:'.25rem .7rem',borderRadius:6,fontSize:'.72rem',fontWeight:700,cursor:'pointer',transition:'all .2s'}}>ES</button>
        </div>
      </div>

      {/* Sign In Form */}
      <div style={{marginBottom:'.65rem'}}>
        <label style={{fontSize:'.62rem',color:'var(--c-text3,#45688a)',fontWeight:700,textTransform:'uppercase',letterSpacing:'.1em',display:'block',marginBottom:4,fontFamily:'var(--font-mono)'}}>Email</label>
        <input className="dkt-inp" type="email" placeholder="" value={email} onChange={e=>{setEmail(e.target.value);setErr("");}} onKeyDown={handleKey}
          style={{background:'var(--c-surface2,#112538)',border:'1px solid var(--c-border,#1a3550)',borderRadius:10,padding:'.7rem .875rem',width:'100%',boxSizing:'border-box'}} />
      </div>
      <div style={{marginBottom:'.75rem'}}>
        <label style={{fontSize:'.62rem',color:'var(--c-text3,#45688a)',fontWeight:700,textTransform:'uppercase',letterSpacing:'.1em',display:'block',marginBottom:4,fontFamily:'var(--font-mono)'}}>{es?"Contraseña":"Password"}</label>
        <input className="dkt-inp" type="password" placeholder="••••••" value={password} onChange={e=>{setPassword(e.target.value);setErr("");}} onKeyDown={handleKey}
          style={{background:'var(--c-surface2,#112538)',border:'1px solid var(--c-border,#1a3550)',borderRadius:10,padding:'.7rem .875rem',width:'100%',boxSizing:'border-box'}} />
      </div>

      {err && <div style={{textAlign:'center',fontSize:'.72rem',color:'var(--c-red,#ff3d6b)',marginBottom:'.65rem',fontFamily:'var(--font-mono)'}}>✗ {err}</div>}

      <button onClick={handleLogin}
        style={{width:'100%',padding:'.75rem',borderRadius:10,background:'linear-gradient(135deg,#0099cc,#0055aa)',border:'none',color:'#fff',fontSize:'.88rem',fontWeight:700,cursor:'pointer',fontFamily:'inherit',boxShadow:'0 4px 14px rgba(0,153,204,.3)',transition:'all .2s',marginBottom:'1rem'}}>
        🔐 {es?"Iniciar Sesión":"Sign In"}
      </button>

      <div style={{textAlign:'center',marginBottom:'.75rem'}}>
        <span style={{fontSize:'.7rem',color:'var(--c-text3,#45688a)'}}>{es?"¿No tienes cuenta?":"Don't have an account?"} </span>
        <span style={{fontSize:'.7rem',color:'var(--c-cyan,#00d4ff)',fontWeight:700,cursor:'pointer'}}>{es?"Registrarse":"Sign Up"}</span>
      </div>

      {/* Demo accounts section */}
      <div style={{borderTop:'1px solid var(--c-border,#1a3550)',paddingTop:'.75rem'}}>
        <div style={{fontSize:'.58rem',color:'var(--c-text3,#45688a)',fontFamily:'var(--font-mono)',textAlign:'center',letterSpacing:'.1em',textTransform:'uppercase',marginBottom:'.5rem'}}>{es?"Cuentas Demo — Click para entrar":"Demo Accounts — Click to login"}</div>
        
        {/* Solo Agent demo */}
        <div style={{fontSize:'.55rem',color:'var(--c-amber,#ffb700)',fontWeight:700,textTransform:'uppercase',letterSpacing:'.08em',fontFamily:'var(--font-mono)',marginBottom:'.25rem'}}>🛡️ {es?"Agente Independiente":"Solo Agent"}</div>
        <div style={{display:'flex',flexDirection:'column',gap:'.25rem',marginBottom:'.5rem'}}>
          {soloAccounts.map(u => (
            <button key={u.id} onClick={()=>onLogin(u)} style={{display:'flex',alignItems:'center',gap:'.5rem',background:'var(--c-surface2,#112538)',border:'1px solid var(--c-border,#1a3550)',borderRadius:8,padding:'.4rem .6rem',cursor:'pointer',transition:'all .15s',textAlign:'left',width:'100%'}}
              onMouseEnter={e=>{e.currentTarget.style.borderColor='rgba(0,212,255,.3)';e.currentTarget.style.background='var(--c-cyan-dim)';}}
              onMouseLeave={e=>{e.currentTarget.style.borderColor='var(--c-border,#1a3550)';e.currentTarget.style.background='var(--c-surface2,#112538)';}}>
              <div style={{width:26,height:26,borderRadius:'50%',background:u.color,display:'flex',alignItems:'center',justifyContent:'center',fontSize:'.55rem',fontWeight:700,color:'#000',flexShrink:0}}>{u.initials}</div>
              <div style={{flex:1}}>
                <div style={{fontSize:'.72rem',fontWeight:600,color:'var(--c-white,#eef6ff)'}}>{u.name}</div>
                <div style={{fontSize:'.55rem',color:'var(--c-text3,#45688a)',fontFamily:'var(--font-mono)'}}>{u.email} · {roleLabels[u.role]||u.role}</div>
              </div>
              <div style={{fontSize:'.55rem',color:'var(--c-text3,#45688a)'}}>→</div>
            </button>
          ))}
        </div>

        {/* Agency demo */}
        <div style={{fontSize:'.55rem',color:'var(--c-cyan,#00d4ff)',fontWeight:700,textTransform:'uppercase',letterSpacing:'.08em',fontFamily:'var(--font-mono)',marginBottom:'.25rem'}}>🏢 {es?"Agencia":"Agency"}</div>
        <div style={{display:'flex',flexDirection:'column',gap:'.25rem'}}>
          {agencyAccounts.map(u => (
            <button key={u.id} onClick={()=>onLogin(u)} style={{display:'flex',alignItems:'center',gap:'.5rem',background:'var(--c-surface2,#112538)',border:'1px solid var(--c-border,#1a3550)',borderRadius:8,padding:'.4rem .6rem',cursor:'pointer',transition:'all .15s',textAlign:'left',width:'100%'}}
              onMouseEnter={e=>{e.currentTarget.style.borderColor='rgba(0,212,255,.3)';e.currentTarget.style.background='var(--c-cyan-dim)';}}
              onMouseLeave={e=>{e.currentTarget.style.borderColor='var(--c-border,#1a3550)';e.currentTarget.style.background='var(--c-surface2,#112538)';}}>
              <div style={{width:26,height:26,borderRadius:'50%',background:u.color,display:'flex',alignItems:'center',justifyContent:'center',fontSize:'.55rem',fontWeight:700,color:'#000',flexShrink:0}}>{u.initials}</div>
              <div style={{flex:1}}>
                <div style={{fontSize:'.72rem',fontWeight:600,color:'var(--c-white,#eef6ff)'}}>{u.name}</div>
                <div style={{fontSize:'.55rem',color:'var(--c-text3,#45688a)',fontFamily:'var(--font-mono)'}}>{u.email} · {roleLabels[u.role]||u.role}</div>
              </div>
              <div style={{fontSize:'.55rem',color:'var(--c-text3,#45688a)'}}>→</div>
            </button>
          ))}
        </div>
      </div>
    </div>
  </div>);
}
// target: 'primary' (default) | 'spouse' — selects which encrypted SSN
// the PIN-reveal modal should decrypt. Same /clients/:id/reveal-ssn
// endpoint either way; the audit log distinguishes primary vs spouse.
function SSNField({ label, value, hint, ssnMasked, lang, clientId, target = 'primary', hasOnFile = false, dependentId, onSsnSaved }) {
  const [pinModalOpen, setPinModalOpen] = useState(false);
  // Reflects a correction just saved through the modal, so the masked
  // hint updates without a full page refetch. null = use the prop.
  const [localMasked, setLocalMasked] = useState(null);
  // El número está escrito pero TODAVÍA NO ha salido de esta pantalla: cliente
  // nuevo (aún no existe la ficha en el servidor) o un dependiente que todavía
  // no está guardado. La ventana cerraba igual que cuando sí se graba y el
  // campo decía "🔒 SSN guardado" — así que la agente cerraba la ficha
  // convencida, y el social no llegaba a ningún sitio. Un guardado que no ha
  // ocurrido no puede anunciarse como ocurrido (Lissette 2026-08-24: "cuando
  // lo guardo no se guarda y punto", sin ningún mensaje de por medio).
  const [pendiente, setPendiente] = useState(false);
  const typedMask = value ? "***-**-" + String(value).replace(/\D/g,"").slice(-4) : "";
  // "There IS an SSN stored for this record." `ssnMasked` (the real
  // ***-**-1234) only comes from the audited GET /:id; list / fresh
  // create / import send the boolean `hasSsn` instead. For NEW clients,
  // `value` holds the 9 digits the agent just typed inside the PIN
  // modal — treat that as "on file" too so the placeholder shows the
  // masked hint instead of the "add the SSN" prompt.
  const onFile = !!ssnMasked || !!hasOnFile || (!clientId && !!value);
  const shownMask = localMasked !== null ? localMasked : (ssnMasked || (!clientId && value ? typedMask : ''));
  // The SSN field is ALWAYS read-only with a 🔒 PIN box — for existing
  // clients AND for brand-new ones being created. Lissette
  // (2026-05-27): "siempre pin aunque sea nuevo". Editing happens
  // inside SsnRevealModal: it asks for the PIN, then either reveals +
  // edits an existing encrypted SSN (clientId set) or validates the
  // PIN against /auth/verify-pin and bubbles the typed SSN back as
  // `pendingSsn` to ClientForm (no clientId yet — value rides in the
  // createClient body when the whole client is saved).
  const locked = true;
  // Never paint the plaintext SSN into the input (read-only + password
  // shows dots, which looks broken). All visual feedback goes through
  // the placeholder + masked hint below.
  const displayValue = '';
  const placeholder = pendiente
    ? (lang === "es"
        ? `⏳ SSN escrito${shownMask ? ` (${shownMask})` : ''} — SIN GUARDAR: pulsa Guardar abajo`
        : `⏳ SSN entered${shownMask ? ` (${shownMask})` : ''} — NOT SAVED yet: press Save below`)
    : onFile || shownMask
    ? (lang === "es"
        ? `🔒 SSN guardado${shownMask ? ` (${shownMask})` : ''} — SHOW + PIN para ver/editar`
        : `🔒 SSN on file${shownMask ? ` (${shownMask})` : ''} — SHOW + PIN to view/edit`)
    : (lang === "es"
        ? `🔒 SHOW + PIN para agregar el SSN`
        : `🔒 SHOW + PIN to add the SSN`);
  const handleShowClick = () => {
    setPinModalOpen(true);            // view + edit, PIN-gated, in modal
  };
  return <div>
    <label className="dkt-input-lbl" style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
      <span>{label}</span>
      {hint&&<span style={{fontSize:".58rem",color:"var(--c-text3,#45688a)",fontFamily:"var(--font-mono)"}}>{hint}</span>}
    </label>
    <div style={{position:"relative"}}>
      <input type="text" className="dkt-inp" value={displayValue} onChange={()=>{}}
        readOnly placeholder={placeholder}
        style={{paddingRight:70, cursor:"not-allowed", opacity:.75}}/>
      <button type="button" onClick={handleShowClick}
        style={{position:"absolute",right:6,top:"50%",transform:"translateY(-50%)",display:"flex",alignItems:"center",gap:3,
          background:"var(--c-surface3,#162d44)",border:"1px solid var(--c-border,#1a3550)",borderRadius:5,padding:"2px 7px",
          fontSize:".6rem",fontWeight:700,color:"var(--c-cyan,#00d4ff)",cursor:"pointer",fontFamily:"var(--font-mono)"}}>
        <Eye size={9}/>SHOW
      </button>
    </div>
    {pinModalOpen && (
      // View + edit happen entirely inside this modal: PIN → see the
      // number → correct it → Guardar (saved via the dedicated
      // update-ssn endpoint) → closes. The form field is never touched,
      // so nothing stays exposed ("no se queda abierto").
      <SsnRevealModal
        clientId={clientId}
        clientName=""
        lang={lang}
        target={target}
        dependentId={dependentId}
        editable
        hasExisting={onFile || !!shownMask}
        onClose={()=>setPinModalOpen(false)}
        onSaved={(result)=>{
          setLocalMasked(result?.masked || '');
          // `pendingSsn` sin `clientId` = la ventana NO llamó al servidor y
          // NADIE lo va a hacer hasta que se pulse Guardar en la ficha: la
          // ficha todavía no existe. El campo lo dice en vez de fingir que ya
          // está grabado. (Un dependiente recién añadido también llega con
          // `pendingSsn`, pero ahí `persistStayingOpen` guarda el cliente
          // entero en el acto y avisa con su propio toast — ese no es
          // pendiente, y marcarlo sería mentir en la otra dirección.)
          setPendiente(!!result?.pendingSsn && !clientId);
          // Propagate up so the parent (clients list + detail) reflects
          // the new hasSsn / ssnMasked WITHOUT needing a page refresh.
          // Without this the pill kept showing "🔒 sin agregar" even
          // though the SSN was already saved server-side.
          if (typeof onSsnSaved === 'function') {
            onSsnSaved(result, target, clientId, dependentId);
          }
        }}
      />
    )}
  </div>;
}
// Employment kind + free-text job description — one grid row, reused for the
// principal, the spouse and each dependent (Lissette 2026-07-02). The value is
// a stable id; the label is bilingual. Free String on the backend, so adding
// options here needs no migration.
const EMPLOYMENT_TYPES = [
  { id: "w2",              es: "W2 (Empleado)",              en: "W2 (Employee)" },
  { id: "self_employed",   es: "Self-Employed (Cuenta propia)", en: "Self-Employed" },
  { id: "contractor_1099", es: "1099 / Contratista",          en: "1099 / Contractor" },
  { id: "retired",         es: "Retirado",                    en: "Retired" },
  { id: "unemployed",      es: "Desempleado",                 en: "Unemployed" },
  { id: "student",         es: "Estudiante",                  en: "Student" },
  { id: "other",           es: "Otro",                        en: "Other" },
];
export const employmentTypeLabel = (id, lang) => {
  const t = EMPLOYMENT_TYPES.find(x => x.id === id);
  return t ? (lang === "es" ? t.es : t.en) : (id || "");
};
function EmploymentFields({ type, desc, onType, onDesc, lang }) {
  return <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:".65rem"}}>
    <div>
      <label className="dkt-input-lbl">{lang==="es"?"Tipo de empleo":"Employment type"}</label>
      <select className="dkt-inp" value={type||""} onChange={e=>onType(e.target.value)}>
        <option value="">-- {lang==="es"?"Seleccionar":"Select"} --</option>
        {EMPLOYMENT_TYPES.map(t=><option key={t.id} value={t.id}>{lang==="es"?t.es:t.en}</option>)}
      </select>
    </div>
    <Input label={lang==="es"?"Descripción del empleo":"Job description"} value={desc||""} onChange={e=>onDesc(e.target.value)}
      placeholder={lang==="es"?"Ej: chofer de Uber, enfermera, dueño de restaurante…":"E.g. Uber driver, nurse, restaurant owner…"}/>
  </div>;
}
// La lista sale de crm-app/estatusMigratorio.js, que es el unico sitio donde
// se escribe (queja 11 de Lissette, 2026-09-02: "el estatus migratorio sale
// cambiado" al descargar). Estaba copiada a mano aqui, en los filtros de
// reporte y en la descarga, y las tres se habian separado.
//
// DOS COSAS QUE ARREGLA, aparte de dejar de copiar:
//
// 1. `undocumented` ya se puede elegir. El servidor lo guarda y los filtros de
//    reporte lo ofrecen desde el 2026-09-01; esta lista era la unica que no,
//    asi que una ficha guardada como indocumentada salia con la casilla EN
//    BLANCO -- un <select> cuyo valor no coincide con ninguna opcion no enseña
//    nada. Parecia sin capturar cuando si lo estaba.
//
// 2. Una ficha antigua guardada como `asylum` ya se ve. Ese valor no esta en la
//    lista (nadie debe elegirlo hoy) pero el servidor lo conserva; se traduce a
//    `asylee` SOLO PARA ENSEÑARLO, con normalizarEstatus. Lo guardado no se
//    toca hasta que alguien edite el campo a proposito.
/**
 * ESCRIBIR UN ESTATUS MIGRATORIO NUEVO (Lissette, 2026-09-16: *"poder escribir
 * estatus migratorio y que se vayan quedando guardados en el drop down"*).
 *
 * Se escribe UNA VEZ: el nombre se convierte en un id (`parole_humanitario`),
 * entra en el catálogo de la AGENCIA y desde entonces se elige de la lista como
 * cualquier otro. No es una casilla de texto libre por persona — eso ya se
 * probó con el origen del lead (#1822) y dejó "Parole", "parole" y "PAROLE"
 * contando como tres situaciones legales distintas en filtros y reportes.
 *
 * El aviso de "ya existe" no es un error: es lo que evita el cuarto gemelo.
 */
const ESCRIBIR_ESTATUS = "__nuevo__";
const GESTIONAR_ESTATUS = "__gestionar__";

// Guarda el catalogo propio en la agencia (lo usan crear, renombrar y borrar).
// Si no se pudo, se DICE: quedarse callada haria creer que quedo guardado.
function guardarEstatusPropios(siguiente, es) {
  setAgencyEstatusMigratorios(siguiente);
  if (!window.__deskteAuth) return Promise.resolve(true);
  return apiUpdateAgencySettings({ immigrationStatuses: siguiente }).then(() => true).catch((err) => {
    toast.error(es
      ? `NO se pudo guardar en el catálogo de la agencia: ${err?.message || ""}`
      : `Could NOT save to the agency catalog: ${err?.message || ""}`);
    return false;
  });
}

// EDITAR Y BORRAR LOS ESTATUS PROPIOS (Lissette 2026-09-29): "en la ficha del
// cliente poder editar los estatus migratorios que se crean personalizados o
// borrarlos tambien". Renombrar deja el id (las fichas guardan el id), asi que
// todas las que lo usan pasan a leer el nombre nuevo. Borrar solo lo quita de
// la lista: las fichas que ya lo tenian lo conservan. Ver estatusMigratorio.js.
function GestorEstatusMigratorios({ es, onClose }) {
  const [lista, setLista] = useState(() => getAgencyEstatusMigratorios());
  const [editando, setEditando] = useState(null); // { id, nombre }
  const [guardando, setGuardando] = useState(false);
  const renombrar = async () => {
    const r = renombrarEstatusPropio(lista, editando.id, editando.nombre);
    if (r.error) {
      toast.error(r.error === "duplicado"
        ? (es ? "Ya hay un estatus con ese nombre." : "There is already a status with that name.")
        : (es ? "Escribe un nombre." : "Type a name."));
      return;
    }
    setGuardando(true);
    const ok = await guardarEstatusPropios(r.lista, es);
    setGuardando(false);
    if (ok) { setLista(r.lista); setEditando(null); toast.success(es ? "Nombre cambiado en todas las fichas." : "Name changed on every record."); }
  };
  const borrar = async (x) => {
    const ok = await confirmDialog({
      title: es ? `¿Quitar “${x.nombre}” de la lista?` : `Remove “${x.nombre}” from the list?`,
      message: es
        ? "Dejará de ofrecerse para fichas nuevas. Los clientes que ya lo tienen lo conservan guardado, pero en su ficha se verá su código interno en vez del nombre. Si solo quieres cambiarle el nombre, usa ✏️."
        : "It will no longer be offered for new records. Clients that already have it keep it saved, but their record will show its internal code instead of the name. To just change the name, use ✏️.",
      confirmLabel: es ? "Quitar" : "Remove",
      danger: true,
    });
    if (!ok) return;
    const siguiente = quitarEstatusPropio(lista, x.id);
    setGuardando(true);
    const guardado = await guardarEstatusPropios(siguiente, es);
    setGuardando(false);
    if (guardado) setLista(siguiente);
  };
  return <Modal title={es ? "Estatus migratorios personalizados" : "Custom immigration statuses"} onClose={onClose}>
    {lista.length === 0
      ? <div style={{ fontSize: ".8rem", color: "var(--c-text3,#45688a)" }}>{es ? "No hay estatus personalizados." : "There are no custom statuses."}</div>
      : lista.map((x) => (
        <div key={x.id} style={{ display: "flex", alignItems: "center", gap: 8, padding: ".35rem 0", borderBottom: "1px solid var(--c-border,#1a3550)" }}>
          {editando && editando.id === x.id
            ? <>
                <input className="dkt-inp" autoFocus value={editando.nombre} maxLength={60}
                  onChange={(e) => setEditando({ id: x.id, nombre: e.target.value })}
                  onKeyDown={(e) => { if (e.key === "Enter") renombrar(); if (e.key === "Escape") setEditando(null); }}
                  style={{ flex: 1 }} />
                <button type="button" className="dkt-btn-p" disabled={guardando} onClick={renombrar}>{es ? "Guardar" : "Save"}</button>
                <button type="button" className="dkt-btn-s" disabled={guardando} onClick={() => setEditando(null)}>{es ? "Cancelar" : "Cancel"}</button>
              </>
            : <>
                <span style={{ flex: 1, fontSize: ".85rem", color: "var(--c-text,#c8dff0)" }}>{x.nombre}</span>
                <button type="button" className="dkt-btn-s" disabled={guardando} title={es ? "Cambiar el nombre" : "Rename"} onClick={() => setEditando({ id: x.id, nombre: x.nombre })}>✏️</button>
                <button type="button" className="dkt-btn-s" disabled={guardando} title={es ? "Quitar de la lista" : "Remove from list"} onClick={() => borrar(x)}>🗑️</button>
              </>}
        </div>
      ))}
  </Modal>;
}

function ImmigrationSelect({ label, value, onChange, lang }) {
  const es = lang === "es";
  const [gestionando, setGestionando] = useState(false);
  const etiquetas = etiquetasDeEstatus(es);
  const opciones = estatusParaElegir();
  const actual = normalizarEstatus(value);
  const hayPropios = getAgencyEstatusMigratorios().length > 0;
  const elegir = (e) => {
    if (e.target.value === GESTIONAR_ESTATUS) { setGestionando(true); return; }
    if (e.target.value !== ESCRIBIR_ESTATUS) { onChange(e); return; }
    const nombre = (window.prompt(es
      ? "¿Cómo se llama el estatus migratorio nuevo?\n\nSe guarda para toda la agencia y desde ahora sale en la lista."
      : "What is the new immigration status called?\n\nIt is saved for the whole agency and appears in the list from now on.") || "").trim();
    if (!nombre) return;
    const propios = getAgencyEstatusMigratorios();
    // ¿Ya existe con ese mismo nombre? Se elige el que hay en vez de crear un
    // gemelo — que es justo lo que este control existe para no hacer.
    const norm = (x) => String(x).trim().toLowerCase();
    const yaEsta = propios.find((x) => norm(x.nombre) === norm(nombre))
      || opciones.find((k) => norm(etiquetas[k] || k) === norm(nombre));
    if (yaEsta) {
      const id = typeof yaEsta === "string" ? yaEsta : yaEsta.id;
      toast.success(es ? `Ese estatus ya existía; se eligió el que hay.` : `That status already existed; the existing one was picked.`);
      onChange({ target: { value: id } });
      return;
    }
    const id = idParaEstatusNuevo(nombre, propios.map((x) => x.id));
    const siguiente = [...propios, { id, nombre, nombreEn: nombre }];
    setAgencyEstatusMigratorios(siguiente);
    if (window.__deskteAuth) {
      apiUpdateAgencySettings({ immigrationStatuses: siguiente }).catch((err) => {
        // Se dice: el estatus queda puesto en esta ficha, pero si no se guardó
        // el catálogo no estará mañana ni para el resto del equipo.
        toast.error(es
          ? `Se puso en esta ficha, pero NO se pudo guardar en el catálogo de la agencia: ${err?.message || ""}`
          : `It was set on this record, but it could NOT be saved to the agency catalog: ${err?.message || ""}`);
      });
    }
    onChange({ target: { value: id } });
  };
  return <div>
    <label className="dkt-input-lbl">{label}</label>
    <select className="dkt-inp" value={actual} onChange={elegir}>
      <option value="">-- {es?"Seleccionar":"Select"} --</option>
      {opciones.map(k => <option key={k} value={k}>{etiquetas[k] || k}</option>)}
      {/* Un valor guardado que ya no esté en el catálogo sigue saliendo: sin
          esta línea, el desplegable se vería vacío y el primer guardado lo
          borraría sin que nadie lo pidiera. */}
      {!!actual && !opciones.includes(actual) && <option value={actual}>{etiquetas[actual] || actual}</option>}
      <option value={ESCRIBIR_ESTATUS}>➕ {es?"Escribir uno nuevo…":"Type a new one…"}</option>
      {hayPropios && <option value={GESTIONAR_ESTATUS}>⚙️ {es?"Editar personalizados…":"Edit custom ones…"}</option>}
    </select>
    {gestionando && <GestorEstatusMigratorios es={es} onClose={() => setGestionando(false)} />}
  </div>;
}
// Immigration document details — USCIS / A-number, card number, category and
// expiration date. ALL optional. Reused for principal, spouse and dependents.
// `docs` is the { uscisNumber, cardNumber, category, expirationDate } object;
// `onChange(next)` replaces the whole object so the parent's single-field
// setters (set / setSpouse / setDep) can store it under `immigrationDocs`.
// Stateless (module scope) → no remount-wipe risk [[feedback_setstate_updater_side_effects]].
// Qué casillas se piden según el estatus migratorio (Lissette 2026-08-10: "si
// se eligen permiso de trabajo salga los field que estan ahorita, y si sale
// residente salga lo que necesitamos, y si sale ciudadano salga opcional las
// preguntas de certificado de naturalización"). La lista de campos sale de su
// propio Excel, donde ya los había pedido para ACA: "citizen born USA, alien
// number, expiration of card, green card #, issue date, naturalization # and
// date".
//
// Cambian las ETIQUETAS además de los campos: el mismo número se llama "USCIS"
// en un permiso de trabajo y "número A (alien)" en una green card, y la agente
// lo busca en la tarjeta con el nombre que trae impreso.
const IMM_DOC_LAYOUTS = {
  work_permit: {
    fields: ['uscisNumber', 'cardNumber', 'category', 'issueDate', 'expirationDate'],
    labels: {
      es: { uscisNumber: 'USCIS número', cardNumber: 'Número de tarjeta (EAD)' },
      en: { uscisNumber: 'USCIS number', cardNumber: 'Card number (EAD)' },
    },
  },
  permanent_resident: {
    fields: ['cardNumber', 'uscisNumber', 'category', 'issueDate', 'expirationDate'],
    labels: {
      es: { cardNumber: 'Número de green card', uscisNumber: 'Número A (alien)' },
      en: { cardNumber: 'Green card number', uscisNumber: 'A-number (alien)' },
    },
  },
  us_citizen: {
    fields: ['bornCitizen', 'naturalizationNumber', 'naturalizationDate'],
    labels: {},
  },
};
// Cualquier otro estatus (visa, DACA, TPS, asilo, indocumentado, sin estatus
// elegido) conserva exactamente las cuatro casillas de siempre.
const IMM_DOC_DEFAULT_FIELDS = ['uscisNumber', 'cardNumber', 'category', 'expirationDate'];
const IMM_DOC_BASE_LABELS = {
  es: {
    uscisNumber: 'USCIS número', cardNumber: 'Número de tarjeta', category: 'Categoría',
    issueDate: 'Fecha de emisión', expirationDate: 'Fecha de expiración',
    bornCitizen: '¿Nació ciudadano en EE.UU.?',
    naturalizationNumber: 'Número de certificado de naturalización',
    naturalizationDate: 'Fecha de naturalización',
  },
  en: {
    uscisNumber: 'USCIS number', cardNumber: 'Card number', category: 'Category',
    issueDate: 'Issue date', expirationDate: 'Expiration date',
    bornCitizen: 'Born a U.S. citizen?',
    naturalizationNumber: 'Naturalization certificate number',
    naturalizationDate: 'Naturalization date',
  },
};
const IMM_DOC_ALL_FIELDS = [
  'uscisNumber', 'cardNumber', 'category', 'issueDate', 'expirationDate',
  'bornCitizen', 'naturalizationNumber', 'naturalizationDate',
];

function ImmigrationDocsFields({ docs, onChange, lang, status }) {
  const es = lang === "es";
  const d = docs || {};
  const opt = es ? "opcional" : "optional";
  const upd = (k, v) => onChange({ ...d, [k]: v });
  const layout = IMM_DOC_LAYOUTS[status] || null;
  const shown = layout ? layout.fields : IMM_DOC_DEFAULT_FIELDS;
  // NADA SE BORRA AL CAMBIAR DE ESTATUS. `onChange` siempre reenvía el objeto
  // entero (`{...d}`), así que un campo que deja de mostrarse conserva su valor
  // en el formulario y se vuelve a guardar igual. Y si además TIENE algo
  // escrito, se muestra de todos modos aquí abajo: esconder un dato que la
  // agencia ya tecleó es la forma más rápida de que alguien lo dé por perdido
  // (Lissette 2026-08-10: "ojo sin borrar lo que ya las agencias han puesto").
  const extras = IMM_DOC_ALL_FIELDS.filter(
    (k) => !shown.includes(k) && String(d[k] || '').trim(),
  );
  const labelFor = (k) =>
    (layout && layout.labels[es ? 'es' : 'en'] && layout.labels[es ? 'es' : 'en'][k])
    || IMM_DOC_BASE_LABELS[es ? 'es' : 'en'][k]
    || k;
  const field = (k) => {
    if (k === 'bornCitizen') {
      return (
        <Select key={k} label={`${labelFor(k)} (${opt})`} value={d.bornCitizen||""} onChange={e=>upd("bornCitizen",e.target.value)}>
          <option value="">{es?"— Sin responder —":"— Not answered —"}</option>
          <option value="yes">{es?"Sí":"Yes"}</option>
          <option value="no">No</option>
        </Select>
      );
    }
    const isDate = k === 'issueDate' || k === 'expirationDate' || k === 'naturalizationDate';
    return (
      <Input key={k} label={`${labelFor(k)} (${opt})`} type={isDate?"date":"text"}
        value={d[k]||""} onChange={e=>upd(k,e.target.value)}
        placeholder={k==='category' ? (es?"Ej. C09, A05":"e.g. C09, A05") : ""}/>
    );
  };
  return (
    <>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:".6rem"}}>
        {shown.map(field)}
      </div>
      {extras.length > 0 && (
        <div style={{marginTop:".6rem",padding:".5rem .65rem",borderRadius:8,
          background:"rgba(255,183,0,.06)",border:"1px solid rgba(255,183,0,.25)"}}>
          <div style={{fontSize:".62rem",fontWeight:700,color:"var(--c-amber,#ffb700)",
            textTransform:"uppercase",letterSpacing:".08em",marginBottom:".45rem"}}>
            {es ? "Guardado con un estatus anterior — se conserva"
                : "Saved under a previous status — kept"}
          </div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:".6rem"}}>
            {extras.map(field)}
          </div>
        </div>
      )}
    </>
  );
}
// F4 — Module-scope helpers + suggestion lists for the Ficha (Salud/Legal)
// section. They live outside ClientForm because TagsAndNotes carries its own
// useState (the "currently typing" tag input). Defining stateful components
// INSIDE another component remounts them on every parent render and wipes
// their state — see [[feedback_setstate_updater_side_effects]] for the bug.
const F4_MEDICAL_SUGGESTIONS = {
  es: ['Diabetes','Hipertensión','Asma','Colesterol alto','Enfermedad cardíaca','Cáncer','Tiroides','Depresión','Obesidad','Artritis'],
  en: ['Diabetes','Hypertension','Asthma','High cholesterol','Heart disease','Cancer','Thyroid','Depression','Obesity','Arthritis'],
};
const F4_FAMILY_SUGGESTIONS = {
  es: ['Diabetes','Cáncer','Cardíaca','Hipertensión','Mental','Accidente cerebrovascular','Alzheimer'],
  en: ['Diabetes','Cancer','Heart disease','Hypertension','Mental','Stroke','Alzheimer'],
};

function TagsAndNotes({ value, onChange, suggestions, lang, placeholderNotes }) {
  const tags = Array.isArray(value?.tags) ? value.tags : [];
  const notes = typeof value?.notes === 'string' ? value.notes : '';
  const [input, setInput] = useState('');
  const addTag = (raw) => {
    const t = (raw || '').trim();
    if (!t) return;
    if (tags.some((x) => x.toLowerCase() === t.toLowerCase())) { setInput(''); return; }
    onChange({ tags: [...tags, t], notes });
    setInput('');
  };
  const removeTag = (t) => onChange({ tags: tags.filter((x) => x !== t), notes });
  const setNotes = (n) => onChange({ tags, notes: n });
  const remainingSuggestions = (suggestions || []).filter(
    (s) => !tags.some((x) => x.toLowerCase() === s.toLowerCase()),
  );
  return (
    <div style={{display:'flex',flexDirection:'column',gap:'.45rem'}}>
      {tags.length > 0 && (
        <div style={{display:'flex',flexWrap:'wrap',gap:'.35rem'}}>
          {tags.map((t) => (
            <span key={t} style={{display:'inline-flex',alignItems:'center',gap:'.3rem',padding:'.18rem .55rem',borderRadius:100,background:'rgba(0,212,255,.12)',border:'1px solid rgba(0,212,255,.28)',color:'var(--c-cyan,#00d4ff)',fontSize:'.7rem',fontWeight:600}}>
              {t}
              <button type="button" onClick={() => removeTag(t)} style={{background:'none',border:'none',cursor:'pointer',color:'var(--c-cyan,#00d4ff)',padding:0,lineHeight:1,fontSize:'.85rem'}} aria-label={lang==='es'?`Quitar ${t}`:`Remove ${t}`}>×</button>
            </span>
          ))}
        </div>
      )}
      <input
        className="dkt-inp"
        type="text"
        value={input}
        onChange={(e) => setInput(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ',') {
            e.preventDefault();
            addTag(input);
          }
        }}
        placeholder={lang === 'es' ? 'Escribe y presiona Enter para agregar...' : 'Type and press Enter to add...'}
      />
      {remainingSuggestions.length > 0 && (
        <div style={{display:'flex',flexWrap:'wrap',gap:'.3rem'}}>
          <span style={{fontSize:'.62rem',color:'var(--c-text3,#45688a)',fontFamily:'var(--font-mono)',alignSelf:'center'}}>
            {lang === 'es' ? 'Sugerencias:' : 'Suggestions:'}
          </span>
          {remainingSuggestions.map((s) => (
            <button key={s} type="button" onClick={() => addTag(s)} style={{background:'var(--c-surface3,#162d44)',border:'1px solid var(--c-border,#1a3550)',color:'var(--c-text2,#7aa3c0)',padding:'.15rem .55rem',borderRadius:100,fontSize:'.65rem',cursor:'pointer',fontFamily:'inherit'}}>
              + {s}
            </button>
          ))}
        </div>
      )}
      <Textarea
        value={notes}
        onChange={(e) => setNotes(e.target.value)}
        placeholder={placeholderNotes || (lang === 'es' ? 'Detalles adicionales (opcional)...' : 'Additional details (optional)...')}
        rows={3}
      />
    </div>
  );
}

// Render the full Ficha (Salud/Legal) for a single person — principal,
// spouse, or a specific dependent. `update(field, value)` is the setter the
// parent provides; for the medicalConditions/familyHealthHistory bundles it
// receives the whole `{tags, notes}` object.
// País de nacimiento + licencia de conducir — datos GENERALES (Lissette
// 2026-05-28 los sacó de Salud/Legal). Reutilizable para titular, cónyuge y
// dependientes. `update(k,v)` es el setter de la entidad. El número de
// licencia se guarda encriptado en el backend (HIPAA).
function GeneralIdFields({ data, update, lang }) {
  const es = lang === 'es';
  return (
    <div style={{display:'grid',gridTemplateColumns:'2fr 1.6fr 0.8fr',gap:'.6rem'}}>
      <Input label={es?'País de nacimiento':'Country of birth'} value={data.placeOfBirth||''} onChange={(e)=>update('placeOfBirth',e.target.value)} placeholder={es?'Venezuela, EE.UU., ...':'USA, Mexico, ...'}/>
      <Input label={es?'Licencia de conducir #':'Driver license #'} value={data.driverLicenseNumber||''} onChange={(e)=>update('driverLicenseNumber',e.target.value)} placeholder="D123-456-78-901-0"/>
      <Input label={es?'Estado':'State'} value={data.driverLicenseState||''} onChange={(e)=>update('driverLicenseState',e.target.value.toUpperCase())} placeholder="FL" maxLength={8}/>
    </div>
  );
}

/* ¿TIENE MEDICAID? — UNA SOLA VEZ, USADA POR LOS TRES.
 *
 * Lissette 2026-09-19: *"colocale tanto a titular como conyuge y familiares la
 * pregunta de si tienen medicaid"*. Y 2026-09-20, al verla: *"YO NO LO QUERIA
 * ALLI, yo lo queria en las principales preguntas"*.
 *
 * Tenia razon. Estaba dentro de FichaCard, que vive en "Salud / Legal /
 * Demograficos" — al final del formulario, la seccion de suscripcion de Vida e
 * inmigracion. Se puso ahi porque esa tarjeta ya la comparten las tres
 * personas, o sea por COMODIDAD DE QUIEN LO PROGRAMA, no por donde se hace la
 * pregunta. Ahora va arriba: con el nombre, la fecha y el sexo, que es donde se
 * rellena mientras se habla con el cliente.
 *
 * SE MUEVE, NO SE DUPLICA: se quito de FichaCard en el mismo cambio. Dos
 * casillas escribiendo el mismo dato es la forma de que una se quede vieja y
 * nadie sepa cual manda (regla de oro 131).
 *
 * Y es UN componente para los tres, no tres copias: el dia que cambie la
 * pregunta, el texto o las opciones, cambia en un sitio. Tres copias se
 * separan — siempre se separan.
 *
 * TRES OPCIONES, NO UNA CASILLA. Vacio es "no se ha preguntado", que NO es lo
 * mismo que "no tiene". Aqui pesa mas que en el tabaco: quien tiene Medicaid NO
 * puede comprar un plan del Mercado con credito, y una casilla en blanco por
 * defecto marcaria a la cartera entera como que ya se pregunto y dijeron que no.
 */
function PreguntaDeMedicaid({ value, onChange, lang }) {
  return (
    <div>
      <label className="dkt-input-lbl">{lang === 'es' ? '¿Tiene Medicaid?' : 'Has Medicaid?'}</label>
      <select className="dkt-inp" value={value || ''} onChange={onChange}>
        <option value="">{lang === 'es' ? 'Sin preguntar' : 'Not asked'}</option>
        <option value="no">{lang === 'es' ? 'No tiene' : 'No'}</option>
        <option value="yes">{lang === 'es' ? 'Sí tiene' : 'Yes'}</option>
      </select>
    </div>
  );
}

function FichaCard({ data, update, lang, title, icon, accentColor }) {
  const heightInches = typeof data.heightInches === 'number' ? data.heightInches : (parseInt(data.heightInches, 10) || 0);
  const feet = Math.floor(heightInches / 12);
  const inches = heightInches % 12;
  const setHeight = (ft, inch) => {
    const total = Math.max(0, Math.min(120, (Number(ft) || 0) * 12 + (Number(inch) || 0)));
    update('heightInches', total || '');
  };
  return (
    <div style={{
      background: 'var(--c-surface2,#112538)',
      border: '1px solid var(--c-border,#1a3550)',
      borderLeft: `3px solid ${accentColor || 'var(--c-cyan,#00d4ff)'}`,
      borderRadius: 10,
      padding: '.875rem',
      display: 'flex',
      flexDirection: 'column',
      gap: '.75rem',
    }}>
      <div style={{fontSize:'.78rem',fontWeight:700,color:'var(--c-white,#eef6ff)',display:'flex',alignItems:'center',gap:'.4rem'}}>
        <span>{icon}</span>{title}
      </div>

      {/* Datos físicos — solo estatura/peso. País de nacimiento + licencia
          se movieron a Datos Generales (Lissette 2026-05-28). */}
      <div>
        <div style={{fontSize:'.62rem',color:'var(--c-text3,#45688a)',fontWeight:700,textTransform:'uppercase',letterSpacing:'.08em',marginBottom:'.4rem',fontFamily:'var(--font-mono)'}}>
          📏 {lang === 'es' ? 'Estatura, peso y tabaco' : 'Height, weight & tobacco'}
        </div>
        <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(88px,1fr))',gap:'.6rem'}}>
          <div>
            <label className="dkt-input-lbl">{lang === 'es' ? 'Altura (ft)' : 'Height (ft)'}</label>
            <input className="dkt-inp" type="number" min="0" max="9" value={feet || ''} onChange={(e) => setHeight(e.target.value, inches)} placeholder="5"/>
          </div>
          <div>
            <label className="dkt-input-lbl">{lang === 'es' ? 'Pulgadas' : 'Inches'}</label>
            <input className="dkt-inp" type="number" min="0" max="11" value={inches || ''} onChange={(e) => setHeight(feet, e.target.value)} placeholder="10"/>
          </div>
          <div>
            <label className="dkt-input-lbl">{lang === 'es' ? 'Peso (lb)' : 'Weight (lb)'}</label>
            <input className="dkt-inp" type="number" min="0" max="1500" value={data.weightLbs || ''} onChange={(e) => update('weightLbs', e.target.value === '' ? '' : Number(e.target.value))} placeholder="165"/>
          </div>
          {/* ¿Fuma? (Lissette 2026-08-14). Va aqui, con estatura y peso, porque
              es el tercer dato que pide toda cotizacion de Vida — la tarifa de
              fumador puede doblar la prima. Al vivir en FichaCard lo heredan de
              golpe el titular, el conyuge y cada dependiente.

              Vacio = "no se ha preguntado", que NO es lo mismo que "no fuma";
              por eso hay tres opciones y no una casilla de marcar. */}
          <div>
            <label className="dkt-input-lbl">{lang === 'es' ? '¿Fuma?' : 'Smoker?'}</label>
            <select className="dkt-inp" value={data.smoker || ''} onChange={(e) => update('smoker', e.target.value)}>
              <option value="">{lang === 'es' ? 'Sin preguntar' : 'Not asked'}</option>
              <option value="no">{lang === 'es' ? 'No fuma' : 'No'}</option>
              <option value="yes">{lang === 'es' ? 'Sí fuma' : 'Yes'}</option>
            </select>
          </div>
          {/* ¿Tiene Medicaid? SE FUE DE AQUI el 2026-09-20, a las preguntas
              principales de cada persona (Contacto, Conyuge y la fila de cada
              dependiente). Estaba aqui por comodidad —esta tarjeta ya la
              comparten los tres— y no por donde se hace la pregunta. Ver
              PreguntaDeMedicaid, mas arriba en este archivo. */}
        </div>
      </div>

      {/* Legal: DUI + Felony */}
      <div>
        <div style={{fontSize:'.62rem',color:'var(--c-text3,#45688a)',fontWeight:700,textTransform:'uppercase',letterSpacing:'.08em',marginBottom:'.4rem',fontFamily:'var(--font-mono)'}}>
          ⚖️ {lang === 'es' ? 'Historial legal' : 'Legal history'}
        </div>
        <div style={{display:'flex',flexDirection:'column',gap:'.5rem'}}>
          <label style={{display:'flex',alignItems:'center',gap:'.5rem',fontSize:'.78rem',color:'var(--c-text,#c8dff0)',cursor:'pointer'}}>
            <input type="checkbox" checked={!!data.hasDui} onChange={(e) => update('hasDui', e.target.checked)} style={{width:16,height:16,cursor:'pointer'}}/>
            {lang === 'es' ? 'Ha tenido DUI / DWI' : 'Has had a DUI / DWI'}
          </label>
          {data.hasDui && (
            <Textarea value={data.duiDetails || ''} onChange={(e) => update('duiDetails', e.target.value)} rows={2} placeholder={lang === 'es' ? 'Año, estado, resolución...' : 'Year, state, resolution...'}/>
          )}
          <label style={{display:'flex',alignItems:'center',gap:'.5rem',fontSize:'.78rem',color:'var(--c-text,#c8dff0)',cursor:'pointer'}}>
            <input type="checkbox" checked={!!data.hasFelony} onChange={(e) => update('hasFelony', e.target.checked)} style={{width:16,height:16,cursor:'pointer'}}/>
            {lang === 'es' ? 'Ha tenido condena por delito grave (felony)' : 'Has had a felony conviction'}
          </label>
          {data.hasFelony && (
            <Textarea value={data.felonyDetails || ''} onChange={(e) => update('felonyDetails', e.target.value)} rows={2} placeholder={lang === 'es' ? 'Año, cargo, resolución...' : 'Year, charge, resolution...'}/>
          )}
          <label style={{display:'flex',alignItems:'center',gap:'.5rem',fontSize:'.78rem',color:'var(--c-text,#c8dff0)',cursor:'pointer'}}>
            <input type="checkbox" checked={!!data.hasTicket} onChange={(e) => update('hasTicket', e.target.checked)} style={{width:16,height:16,cursor:'pointer'}}/>
            {lang === 'es' ? 'Ha tenido multas / infracciones de tránsito' : 'Has had traffic tickets / violations'}
          </label>
          {data.hasTicket && (
            <Textarea value={data.ticketDetails || ''} onChange={(e) => update('ticketDetails', e.target.value)} rows={2} placeholder={lang === 'es' ? 'Año, tipo, estado, resolución...' : 'Year, type, state, resolution...'}/>
          )}
        </div>
      </div>

      {/* Médico: medical conditions + family history */}
      <div>
        <div style={{fontSize:'.62rem',color:'var(--c-text3,#45688a)',fontWeight:700,textTransform:'uppercase',letterSpacing:'.08em',marginBottom:'.4rem',fontFamily:'var(--font-mono)'}}>
          🏥 {lang === 'es' ? 'Condiciones médicas' : 'Medical conditions'}
        </div>
        <TagsAndNotes value={data.medicalConditions} onChange={(b) => update('medicalConditions', b)} suggestions={F4_MEDICAL_SUGGESTIONS[lang] || F4_MEDICAL_SUGGESTIONS.en} lang={lang} placeholderNotes={lang === 'es' ? 'Medicamentos, doctor de cabecera, detalles...' : 'Medications, primary doctor, details...'}/>
      </div>
      <div>
        <div style={{fontSize:'.62rem',color:'var(--c-text3,#45688a)',fontWeight:700,textTransform:'uppercase',letterSpacing:'.08em',marginBottom:'.4rem',fontFamily:'var(--font-mono)'}}>
          🧬 {lang === 'es' ? 'Historial familiar de salud' : 'Family health history'}
        </div>
        <TagsAndNotes value={data.familyHealthHistory} onChange={(b) => update('familyHealthHistory', b)} suggestions={F4_FAMILY_SUGGESTIONS[lang] || F4_FAMILY_SUGGESTIONS.en} lang={lang} placeholderNotes={lang === 'es' ? 'Padres, hermanos, abuelos...' : 'Parents, siblings, grandparents...'}/>
      </div>
    </div>
  );
}

// Custom-tabs editor. Two distinct concerns, edited side by side:
//   • DEFINITIONS (`defs`) — the tab/field STRUCTURE. Agency-shared: defined
//     once by any agent/seat, they appear on EVERY client. Editing labels here
//     (via onDefsChange) changes them for all clients.
//   • VALUES (`values`) — a { fieldId: value } map for THIS client only.
//     Free-text, encrypted at rest (any value could be PHI), saved with the
//     client via onValuesChange.
// Renaming/adding/removing a tab or field is a SHARED change; typing in a
// value box is a per-client change.
function CustomTabsEditor({ defs, values, onDefsChange, onValuesChange, lang, singleId = null, onAfterRemoveTab }) {
  const es = lang === 'es';
  const list = Array.isArray(defs) ? defs : [];
  const vals = (values && typeof values === 'object') ? values : {};
  // When singleId is set the editor focuses ONE tab (used when each custom tab
  // is a top-level form tab): no chip strip, no "new tab" button — just that
  // tab's fields/values. Otherwise it shows the chip strip for all tabs.
  const single = singleId != null;
  const [active, setActive] = useState(0);
  const commitDefs = (next) => onDefsChange(next);
  const addTab = () => { const next = [...list, { id: 'ct_' + uid(), label: '', fields: [] }]; commitDefs(next); setActive(next.length - 1); };
  const removeTab = (ti) => { commitDefs(list.filter((_, i) => i !== ti)); setActive((a) => (a >= ti && a > 0 ? a - 1 : a)); if (single && onAfterRemoveTab) onAfterRemoveTab(); };
  const renameTab = (ti, label) => commitDefs(list.map((t, i) => (i === ti ? { ...t, label } : t)));
  const addField = (ti) => commitDefs(list.map((t, i) => (i === ti
    ? { ...t, fields: [...(t.fields || []), { id: 'cf_' + uid(), label: '' }] }
    : t)));
  const removeField = (ti, fi) => commitDefs(list.map((t, i) => (i === ti
    ? { ...t, fields: (t.fields || []).filter((_, j) => j !== fi) }
    : t)));
  const renameField = (ti, fi, label) => commitDefs(list.map((t, i) => (i === ti
    ? { ...t, fields: (t.fields || []).map((f, j) => (j === fi ? { ...f, label } : f)) }
    : t)));
  const setValue = (fieldId, val) => onValuesChange({ ...vals, [fieldId]: val });
  const labelStyle = { fontSize: '.62rem', color: 'var(--c-text3,#45688a)', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.08em', fontFamily: 'var(--font-mono)' };
  const inputStyle = { width: '100%', padding: '.5rem .6rem', borderRadius: 8, border: '1px solid var(--c-border,#2a4a68)', background: 'var(--c-surface,#0d1c2e)', color: 'var(--c-white,#eef6ff)', fontSize: '.8rem', fontFamily: 'inherit' };
  const ti = single ? list.findIndex((d) => d && d.id === singleId) : Math.min(active, Math.max(0, list.length - 1));
  const tab = list[ti];
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '.85rem' }}>
      <div style={{ fontSize: '.7rem', color: 'var(--c-text2,#9fc1dd)', background: 'rgba(167,139,250,.08)', border: '1px solid rgba(167,139,250,.25)', borderRadius: 8, padding: '.5rem .7rem', lineHeight: 1.45 }}>
        🧩 {es ? 'Las pestañas y sus campos son compartidos: al crearlos quedan disponibles para TODOS los clientes. Los valores que escribas aquí son solo de este cliente.' : 'Tabs and their fields are shared — once created they appear on ALL clients. The values you type here belong to this client only.'}
      </div>
      {/* Chip strip — only in multi mode (single mode uses the parent's top-level tabs) */}
      {!single && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '.4rem', alignItems: 'center' }}>
          {list.map((d, i) => {
            const on = i === ti;
            return (
              <button key={d.id || i} type="button" onClick={() => setActive(i)} style={{
                display: 'inline-flex', alignItems: 'center', gap: '.35rem', padding: '.4rem .7rem', borderRadius: 9,
                border: on ? '1px solid var(--c-purple,#a78bfa)' : '1px solid var(--c-border,#2a4a68)',
                background: on ? 'rgba(167,139,250,.16)' : 'var(--c-surface,#0d1c2e)',
                color: on ? 'var(--c-purple,#cbb6ff)' : 'var(--c-text2,#9fc1dd)',
                fontWeight: on ? 800 : 600, fontSize: '.76rem', cursor: 'pointer', fontFamily: 'inherit', whiteSpace: 'nowrap',
              }}>
                🧩 {(d.label || '').trim() || (es ? 'Sin nombre' : 'Untitled')}
              </button>
            );
          })}
          <button type="button" onClick={addTab} title={es ? 'Nueva pestaña personalizada' : 'New custom tab'} style={{
            display: 'inline-flex', alignItems: 'center', gap: '.3rem', padding: '.4rem .7rem', borderRadius: 9,
            border: '1px dashed var(--c-purple,#a78bfa)', background: 'rgba(167,139,250,.08)', color: 'var(--c-purple,#a78bfa)',
            fontWeight: 700, fontSize: '.76rem', cursor: 'pointer', fontFamily: 'inherit', whiteSpace: 'nowrap',
          }}>
            + {es ? 'Nueva pestaña' : 'New tab'}
          </button>
        </div>
      )}
      {!single && list.length === 0 && (
        <div style={{ fontSize: '.72rem', color: 'var(--c-text3,#45688a)', fontStyle: 'italic' }}>
          {es ? 'Aún no hay pestañas personalizadas. Crea una para guardar información que no cabe en los campos estándar (ej. mascotas, vehículos, notas de negocio).' : 'No custom tabs yet. Create one to store info that doesn\'t fit the standard fields (e.g. pets, vehicles, business notes).'}
        </div>
      )}
      {single && !tab && (
        <div style={{ fontSize: '.72rem', color: 'var(--c-text3,#45688a)', fontStyle: 'italic' }}>
          {es ? 'Esta pestaña ya no existe.' : 'This tab no longer exists.'}
        </div>
      )}
      {tab && (
        <div key={tab.id || ti} style={{ background: 'var(--c-surface2,#112538)', border: '1px solid var(--c-border,#1a3550)', borderLeft: '3px solid var(--c-purple,#a78bfa)', borderRadius: 10, padding: '.875rem', display: 'flex', flexDirection: 'column', gap: '.7rem' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '.5rem' }}>
            <span style={{ fontSize: '1rem' }}>🧩</span>
            <input
              value={tab.label || ''}
              onChange={(e) => renameTab(ti, e.target.value)}
              placeholder={es ? 'Nombre de la pestaña (ej. Mascotas)' : 'Tab name (e.g. Pets)'}
              maxLength={120}
              style={{ ...inputStyle, fontWeight: 700 }}
            />
            <button type="button" onClick={() => removeTab(ti)} title={es ? 'Eliminar pestaña (para todos los clientes)' : 'Delete tab (for all clients)'} style={{ flexShrink: 0, padding: '.4rem .55rem', borderRadius: 8, border: '1px solid #6b2a3a', background: 'rgba(255,80,110,.08)', color: '#ff8aa3', fontWeight: 700, fontSize: '.78rem', cursor: 'pointer', fontFamily: 'inherit' }}>✕</button>
          </div>
          {(tab.fields || []).map((f, fi) => (
            <div key={f.id || fi} style={{ display: 'grid', gridTemplateColumns: '1fr 1.4fr auto', gap: '.5rem', alignItems: 'start' }}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '.25rem' }}>
                <span style={labelStyle}>{es ? 'Campo (compartido)' : 'Field (shared)'}</span>
                <input value={f.label || ''} onChange={(e) => renameField(ti, fi, e.target.value)} placeholder={es ? 'Etiqueta' : 'Label'} maxLength={120} style={inputStyle} />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '.25rem' }}>
                <span style={labelStyle}>{es ? 'Valor (este cliente)' : 'Value (this client)'}</span>
                <textarea value={vals[f.id] || ''} onChange={(e) => setValue(f.id, e.target.value)} placeholder={es ? 'Información…' : 'Information…'} maxLength={8000} rows={1} style={{ ...inputStyle, resize: 'vertical', minHeight: '2.1rem' }} />
              </div>
              <button type="button" onClick={() => removeField(ti, fi)} title={es ? 'Eliminar campo (para todos los clientes)' : 'Delete field (for all clients)'} style={{ marginTop: '1.3rem', padding: '.4rem .55rem', borderRadius: 8, border: '1px solid #6b2a3a', background: 'rgba(255,80,110,.08)', color: '#ff8aa3', fontWeight: 700, fontSize: '.78rem', cursor: 'pointer', fontFamily: 'inherit' }}>✕</button>
            </div>
          ))}
          <button type="button" onClick={() => addField(ti)} style={{ alignSelf: 'flex-start', padding: '.4rem .75rem', borderRadius: 8, border: '1px dashed var(--c-border,#2a4a68)', background: 'transparent', color: 'var(--c-text2,#9fc1dd)', fontWeight: 600, fontSize: '.74rem', cursor: 'pointer', fontFamily: 'inherit' }}>
            + {es ? 'Agregar campo' : 'Add field'}
          </button>
        </div>
      )}
    </div>
  );
}

function ClientForm({ client, onSave, onPersist, onClose, t, lang, onClientsChange, policies=[], onPoliciesAdd, onSsnSaved, customTabDefs=[], onCustomTabDefsChange }) {
  const tf=t.clientForm;
  const calcAge = dob => { if(!dob) return null; const d=new Date(dob),n=new Date(); return Math.floor((n-d)/31557600000); };
  // F4 ficha defaults — common shape for principal + spouse + dependent.
  // Keeping these in one object makes adding/removing fields a single edit.
  const emptyF4 = {
    placeOfBirth: "", driverLicenseNumber: "", driverLicenseState: "",
    heightInches: "", weightLbs: "",
    hasDui: false, duiDetails: "",
    hasFelony: false, felonyDetails: "",
    hasTicket: false, ticketDetails: "",
    medicalConditions: { tags: [], notes: "" },
    familyHealthHistory: { tags: [], notes: "" },
    // Immigration document details — all optional. Shared by principal,
    // spouse and each dependent (spread via emptyF4).
    immigrationDocs: { uscisNumber: "", cardNumber: "", category: "", issueDate: "", expirationDate: "", bornCitizen: "", naturalizationNumber: "", naturalizationDate: "" },
  };
  const emptyDep={id:"",firstName:"",middleName:"",lastName:"",relation:"",dob:"",phone:"",email:"",employer:"",employerPhone:"",income:"",immigrationStatus:"",ssn:"",separateProfile:false,insured:false,...emptyF4};
  const emptySpouse={firstName:"",middleName:"",lastName:"",phone:"",email:"",dob:"",employer:"",employerPhone:"",income:"",immigrationStatus:"",ssn:"",...emptyF4};
  const empty={firstName:"",lastName:"",phone:"",email:"",dob:"",status:"active",preferredLang:"english",maritalStatus:"",gender:"",
    addressStreet:"",addressCity:"",addressState:"",addressZip:"",county:"",notes:"",
    householdSize:"",insuredMembers:"",annualIncome:"",employer:"",employerPhone:"",immigrationStatus:"",ssn:"",
    spouse:{...emptySpouse}, dependents:[], refFirstName:"",refLastName:"",refPhone:"",
    customValues:{},
    ...emptyF4};
  const [form,setForm]=useState(()=>{
    const base={...empty,...(client||{})};
    base.spouse=client?.spouse||{...emptySpouse};
    base.dependents=client?.dependents||[];
    // Never inherit plaintext SSN values from the loaded client into form
    // state. SSN reveal/edit is handled by SsnRevealModal (PIN-gated,
    // dedicated /update-ssn endpoint) — the form field must stay empty
    // so a routine save (e.g. fixing a typo in the last name) doesn't
    // re-submit the SSN and trip the backend's PIN_REQUIRED gate. The
    // ssnMasked / ssnLast4 / hasSsn signals are kept (they drive the
    // "🔒 SSN on file" placeholder in SSNField).
    base.ssn = '';
    base.spouse = { ...base.spouse, ssn: '' };
    if (Array.isArray(base.dependents)) {
      // Belt-and-suspenders: every dependent should already carry a stable
      // id from mapClientFromApi (deterministic by index for legacy rows
      // stored without one). Keep a guard with the SAME index scheme so a
      // dependent reaching the form by any other path still has a non-empty
      // id — the PIN-gated SSN modal targets a dependent by this id, and an
      // empty id made /update-ssn 400 "dependentId is required".
      base.dependents = base.dependents.map((d, i) => ({
        ...d,
        id: (d && d.id) ? d.id : ('dep_' + i),
        ssn: '',
      }));
    }
    return base;
  });
  const [formTab,setFormTab]=useState("contact");
  const [profileCreated,setProfileCreated]=useState({});
  // After an adult dependent gets its own profile, offer to copy the
  // head-of-household's policies into it. null = closed; object holds
  // the new client + the principal's policies + which are checked.
  const [policyPicker,setPolicyPicker]=useState(null);
  const [copyingPolicies,setCopyingPolicies]=useState(false);
  // ZIP auto-fill flag — true for a few seconds after the lookup populates
  // city/state so the user sees a small "Auto-filled" hint and can correct
  // if the wrong row was inferred. Reset on next manual edit.
  const [zipAutofilled,setZipAutofilled]=useState(false);
  // Las sugerencias de direccion solo se piden cuando alguien TECLEA en la
  // direccion, nunca al abrir una ficha guardada (AddressSuggestions.jsx).
  const [addrTyped,setAddrTyped]=useState(false);
  const pickAddress=(s)=>{
    setAddrTyped(false);
    setForm(f=>({...f,addressStreet:s.street,addressCity:s.city||f.addressCity,addressState:s.state||f.addressState,addressZip:s.zip||f.addressZip,county:s.county||f.county}));
  };
  const set=(k,v)=>setForm(f=>{
    const next={...f,[k]:v};
    return (typeof k==="string"&&k.startsWith("cov_")) ? recalcInsured(next) : next;
  });

  // Hydration guard against the full-overwrite wipe. The clients-list
  // endpoint omits many fields by design (maritalStatus, address/zip,
  // income, immigration, employer, the F4 ficha, …) — it only carries what
  // the list view needs. So a form opened from the list pencil button (or
  // before the on-mount GET resolves) holds EMPTY values for those fields,
  // and because PUT /clients/:id is a full overwrite via mapClientToApi, a
  // routine Save would write null over every omitted field — wiping
  // maritalStatus, the drive folder, medical/legal, etc. This is exactly
  // the 2026-05-28 incident (maritalStatus "divorced" → null on save).
  //
  // Fix: on open, fetch the full record (GET /:id) and fill every field the
  // form is still missing, then mark the form hydrated. Save is BLOCKED
  // until hydration completes, so the payload always carries the complete
  // record. `fillEmpties` only fills blanks, so it never clobbers what the
  // user just typed; once hydrated, an empty value IS an intentional clear
  // and is respected. See [[feedback_partial_patch_and_repair_cascade]] +
  // [[feedback_mapclienttoapi_only_form_fields]].
  const SCALAR_FILL_KEYS = [
    'phone','email','phoneSecondary','dob','maritalStatus','gender','immigrationStatus',
    'employer','employerPhone','annualIncome','householdSize','insuredMembers','source','preferredLang',
    'addressStreet','addressCity','addressState','addressZip','county',
    'refFirstName','refLastName','refPhone','linkedParentId','linkedParentName','notes',
    'placeOfBirth','driverLicenseNumber','driverLicenseState','heightInches','weightLbs',
    'hasDui','duiDetails','hasFelony','felonyDetails','hasTicket','ticketDetails','medicalConditions','familyHealthHistory',
    // 2026-07-31: these were form-owned + always sent by mapClientToApi but
    // MISSING from this list, so a list-opened form nulled them on every save.
    'employmentType','employmentDesc',
  ];
  const SPOUSE_FILL_KEYS = [
    'firstName','lastName','phone','email','dob','employer','employerPhone','income','immigrationStatus',
    'placeOfBirth','driverLicenseNumber','driverLicenseState','heightInches','weightLbs',
    'hasDui','duiDetails','hasFelony','felonyDetails','hasTicket','ticketDetails','medicalConditions','familyHealthHistory',
    'employmentType','employmentDesc', // same 2026-07-31 gap as the principal list
  ];
  const isEmptyVal = (v) =>
    v === '' || v === null || v === undefined || v === false ||
    (v && typeof v === 'object' && (!Array.isArray(v.tags) || v.tags.length === 0) && !v.notes);
  const fillKeys = (target, source, keys) => {
    if (!source) return target;
    const out = { ...target };
    for (const k of keys) {
      if (isEmptyVal(out[k]) && !isEmptyVal(source[k])) out[k] = source[k];
    }
    return out;
  };
  const fillLista = (deForm, delServidor) =>
    ((!Array.isArray(deForm) || deForm.length === 0) && Array.isArray(delServidor)) ? delServidor : deForm;
  const mergeFullIntoForm = (f, full) => {
    if (!full) return f;
    const next = fillKeys(f, full, SCALAR_FILL_KEYS);
    // Tags (the colored labels next to the name) are NOT edited from this form
    // — they live in the detail-header chip editor. So the server copy is
    // always authoritative: always adopt the freshest `tags` from the full GET.
    // Without this, a routine Save made from a form whose snapshot predates a
    // tag added elsewhere (e.g. the owner labels a client while a seat has the
    // edit modal open, or vice-versa) would full-overwrite the tag straight
    // back off — exactly the "the tag doesn't stay for the other seat" report.
    // tags isn't in SCALAR_FILL_KEYS because isEmptyVal() can't reason about a
    // plain string[] (its object branch only understands the {tags,notes}
    // medical-bundle shape), so handle it explicitly here.
    // [[feedback_data_persistence_is_sacred]]
    if (Array.isArray(full.tags)) next.tags = full.tags;
    // immigrationDocs is a {uscisNumber, cardNumber, category, expirationDate}
    // object — isEmptyVal's object branch only understands the {tags,notes}
    // medical-bundle shape (it reports EVERY docs object as empty, even a full
    // one), so fillKeys can't be trusted with it. Handle it explicitly: adopt
    // the server copy only when the form's copy has no values (list-opened
    // form). Without this, mapClientToApi sent the empty object and the
    // backend WIPED the encrypted blob on every list-opened save (2026-07-31).
    const docsHasValues = (d) => !!d && typeof d === 'object' &&
      ['uscisNumber','cardNumber','category','expirationDate'].some((k) => typeof d[k] === 'string' && d[k].trim());
    const fillDocs = (formDocs, fullDocs) =>
      (!docsHasValues(formDocs) && docsHasValues(fullDocs)) ? fullDocs : formDocs;
    next.immigrationDocs = fillDocs(f.immigrationDocs, full.immigrationDocs);
    next.spouse = fillKeys(f.spouse || {}, full.spouse || null, SPOUSE_FILL_KEYS);
    next.spouse.immigrationDocs = fillDocs(next.spouse.immigrationDocs, full.spouse?.immigrationDocs);
    next.dependents = (f.dependents || []).map((dep) => {
      const match = Array.isArray(full.dependents)
        ? full.dependents.find((d) => d.id === dep.id)
        : null;
      if (!match) return dep;
      const merged = fillKeys(dep, match, SPOUSE_FILL_KEYS);
      merged.immigrationDocs = fillDocs(merged.immigrationDocs, match.immigrationDocs);
      merged.otrosIngresos = fillLista(merged.otrosIngresos, match.otrosIngresos);
      return merged;
    });
    // OTROS INGRESOS (2026-10-27). Son listas, y isEmptyVal no sabe de listas
    // (su rama de objetos da por vacia CUALQUIER lista, llena o no), asi que
    // fillKeys no las rellenaria nunca. Se adopta la del servidor cuando la del
    // formulario no existe o esta vacia — un formulario abierto desde la lista,
    // que no trae la columna. Sin esto, mapClientToApi no mandaria nada... o,
    // peor, mandaria la lista vacia y borraria la guardada.
    next.otrosIngresos = fillLista(f.otrosIngresos, full.otrosIngresos);
    next.spouse.otrosIngresos = fillLista(next.spouse.otrosIngresos, full.spouse?.otrosIngresos);
    // customValues is a per-client { fieldId: value } map, not a scalar —
    // fillKeys/isEmptyVal can't reason about it. Only hydrate from the full
    // record when the form hasn't already loaded/edited values (so a
    // Save-before-hydration race or a list-opened form doesn't wipe stored
    // values, but in-progress edits are never clobbered).
    const fullHasValues = full.customValues && typeof full.customValues === 'object' && Object.keys(full.customValues).length > 0;
    const formHasValues = f.customValues && typeof f.customValues === 'object' && Object.keys(f.customValues).length > 0;
    if (fullHasValues && !formHasValues) {
      next.customValues = full.customValues;
    }
    return next;
  };

  // hydratedRef is set true ONLY when the full-record GET actually succeeds.
  // If the fetch fails, it stays false so the Save handler refuses to save a
  // partially-loaded form (which would null out the omitted fields).
  const hydratedRef = useRef(false);
  const [hydrating, setHydrating] = useState(false);
  // Optimistic-concurrency base version. Captured when the form loads (from the
  // list/detail object, then refined by the authoritative GET) and sent back on
  // save as __baseUpdatedAt so the backend can reject a save that would clobber
  // a teammate's concurrent edit. See [[feature_client_coedit_presence]].
  const baseUpdatedAtRef = useRef(client?.updatedAt || null);
  // Set when a `client.updated` SSE for THIS client arrives with a newer
  // version than the one we loaded — i.e. someone else just saved while this
  // form is open. Drives the in-form "otra persona actualizó esta ficha" banner.
  const [staleLive, setStaleLive] = useState(false);
  useEffect(() => {
    const apiMode = typeof window !== "undefined" && !!window.__deskteAuth;
    if (!apiMode || !client?.id) { hydratedRef.current = true; return; }
    hydratedRef.current = false;
    setHydrating(true);
    let cancelled = false;
    apiGetClient(client.id)
      .then((full) => {
        if (cancelled || !full) return;
        setForm((f) => mergeFullIntoForm(f, full));
        // The GET carries the authoritative current version — adopt it as our
        // base so the live banner only fires for edits made AFTER we loaded.
        if (full.updatedAt) baseUpdatedAtRef.current = full.updatedAt;
        hydratedRef.current = true;   // success ONLY — never mark hydrated on failure
      })
      .catch(() => { /* leave hydratedRef=false → Save will refetch or refuse */ })
      .finally(() => { if (!cancelled) setHydrating(false); });
    return () => { cancelled = true; };
  // Only re-run if the client identity changes (form is keyed by id, so
  // this effectively runs once per open).
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [client?.id]);

  // Live heads-up: another seat/agent saved this same client while we're
  // editing. The parent's SSE handler dispatches `deskte:client-updated`; show
  // a non-blocking banner so the user knows their copy is behind before they
  // overwrite it. (The save itself is still hard-guarded server-side, so this
  // is the friendly early warning, not the safety net.)
  useEffect(() => {
    if (!client?.id) return;
    const onUpdated = (e) => {
      const d = e.detail || {};
      if (d.id !== client.id) return;
      // Sin `updatedAt` no hay forma de saber QUÉ versión anuncia el evento, y
      // los endpoints estrechos (driveUrl, estado, agente asignado) emiten
      // `client.updated` sin él — incluso cuando el que los dispara es este
      // mismo usuario. Avisar entonces de "otra persona actualizó esta ficha"
      // es falso por construcción, así que se ignora.
      if (!d.updatedAt) return;
      // Ignore the echo of our own just-saved version.
      if (baseUpdatedAtRef.current && d.updatedAt === baseUpdatedAtRef.current) return;
      setStaleLive(true);
    };
    window.addEventListener('deskte:client-updated', onUpdated);
    return () => window.removeEventListener('deskte:client-updated', onUpdated);
  }, [client?.id]);

  // Save handler. If hydration finished, the form already holds the complete
  // record + the user's edits → save as-is (so intentional clears work). If
  // the user clicked Save before the on-mount GET resolved (race), do one
  // authoritative GET and fill the still-empty fields first. If we STILL
  // can't load the full record, REFUSE to save — a partial save would null
  // out every field the list/detail didn't carry (the 2026-05-28 wipe).
  const [savingForm, setSavingForm] = useState(false);
  const submitForm = async () => {
    // "Pusiste 5 personas en el hogar, pero solo hay 3 llenas" (Lissette
    // 2026-09-15). El desplegable de Personas en el Hogar y la gente que se
    // escribe de verdad no tienen por que cuadrar, y cuando no cuadran no lo
    // dice nadie -- aunque de ese numero salgan el subsidio y la elegibilidad.
    //
    // AVISA, NO BLOQUEA: el boton de la derecha guarda igual. Un hogar a medio
    // llenar es un estado legitimo a mitad de una llamada, y un formulario que
    // no deja guardar lo que se tiene a medias acaba con la agente apuntando en
    // un papel. La regla vive en crm-app/miembrosDelHogar.js.
    //
    // Va ANTES de todo lo demas -- incluido el camino sin servidor de la linea
    // siguiente -- para que el aviso salga tanto en la demo como en produccion.
    const faltaGente = faltanMiembrosDelHogar(form);
    if (faltaGente) {
      const aviso = avisoDeMiembrosQueFaltan(faltaGente, lang === "es");
      if (!(await confirmDialog(aviso))) return;
    }
    const apiMode = typeof window !== "undefined" && !!window.__deskteAuth;
    if (!apiMode || !client?.id) { onSave(recalcInsured(form)); return; }
    setSavingForm(true);
    // Attach the base version so the backend can reject a save that would
    // overwrite a teammate's concurrent edit (optimistic concurrency). The
    // `__baseUpdatedAt` key is stripped before the request is built, so it
    // never reaches the wire as client data.
    const withBase = (f) => ({ ...f, __baseUpdatedAt: baseUpdatedAtRef.current });
    try {
      if (hydratedRef.current) {
        onSave(withBase(recalcInsured(form)));
      } else {
        const full = await apiGetClient(client.id);
        if (!full) throw new Error('no full record');
        if (full.updatedAt) baseUpdatedAtRef.current = full.updatedAt;
        const merged = mergeFullIntoForm(form, full);
        setForm(merged);
        hydratedRef.current = true;
        onSave(withBase(recalcInsured(merged)));
      }
    } catch {
      // Could not load the complete record — do NOT save a partial form.
      alert(lang === "es"
        ? "No pude cargar el perfil completo, así que no guardé (para no borrar datos). Revisa tu conexión y reintenta."
        : "Couldn't load the full profile, so I didn't save (to avoid wiping data). Check your connection and retry.");
    } finally {
      setSavingForm(false);
    }
  };

  // US ZIP → city/state lookup. Uses zippopotam.us — public, free, no auth,
  // ~99% uptime. Only fires when the ZIP is exactly 5 digits, only fills
  // city/state when they're currently empty (never overwrites user typing),
  // and silently no-ops on network failure / unknown ZIP so the form keeps
  // working offline. Long-term replacement is USPS Web Tools or Google
  // Places once the keys land — same fields, different provider.
  useEffect(() => {
    const zip = (form.addressZip || '').trim();
    // Este efecto solo se dispara cuando CAMBIA el ZIP, así que el aviso de
    // "esto lo he rellenado yo" pertenece al ZIP anterior: se apaga aquí.
    setZipAutofilled(false);
    if (!/^\d{5}$/.test(zip)) return;

    let cancelled = false;
    const controller = new AbortController();
    fetch(`https://api.zippopotam.us/us/${zip}`, { signal: controller.signal })
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (cancelled || !data || !Array.isArray(data.places) || data.places.length === 0) return;
        const place = data.places[0];
        const city = (place['place name'] || '').trim();
        const state = (place['state abbreviation'] || '').trim();
        if (!city && !state) return;
        let filledSomething = false;
        setForm((f) => {
          const next = { ...f };
          if (city && !f.addressCity) { next.addressCity = city; filledSomething = true; }
          if (state && !f.addressState) { next.addressState = state; filledSomething = true; }
          return next;
        });
        // El aviso se queda MIENTRAS el valor rellenado siga en pantalla sin
        // guardar. Antes se apagaba solo a los 4 segundos y el valor se
        // quedaba: quien abría una ficha para comprobar si tenía estado veía
        // un "FL" que se acababa de inventar el navegador, sin nada que lo
        // dijera, y concluía que estaba guardado. Nos pasó a nosotros mismos
        // diagnosticando esto (Javier Volcanes, 2026-08-28, E-146).
        if (filledSomething) setZipAutofilled(true);
      })
      .catch(() => { /* offline / unknown ZIP / aborted — fine, user types manually */ });
    return () => { cancelled = true; controller.abort(); };
  // We deliberately only depend on the ZIP. City/state shouldn't retrigger
  // a lookup when the user types in them — that's the whole point.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form.addressZip]);
  const setSpouse=(k,v)=>setForm(f=>{
    const next={...f,spouse:{...f.spouse,[k]:v}};
    return (typeof k==="string"&&k.startsWith("cov_")) ? recalcInsured(next) : next;
  });
  // Persist the client RIGHT NOW without closing the form. Used when a
  // dependent's SSN is saved through the PIN modal but the dependent isn't
  // on the server yet (a legacy row that had no id, or one just added this
  // session): /update-ssn can't target it, so the value is stashed in form
  // state and we save the whole client here so the SSN actually PERSISTS on
  // the modal's Save — instead of silently waiting for a separate "Guardar"
  // click that the user reasonably thinks already happened (Lissette
  // 2026-06-16: "no se están guardando los SSN de los dependientes, eso es
  // un error grave"). Hydration-guarded exactly like submitForm so a save
  // before the on-mount GET resolves can't wipe omitted fields.
  //
  // `aviso` es el texto del toast de exito. Era fijo -"SSN del dependiente
  // guardado"- porque solo lo usaba el SSN; desde que tambien lo usa el perfil
  // separado, un mensaje que habla de otra cosa es peor que ninguno.
  const persistStayingOpen = async (nextForm, aviso) => {
    const apiMode = typeof window !== "undefined" && !!window.__deskteAuth;
    // New client (no id yet) or local mode: nothing to persist immediately —
    // the SSN rides in the createClient body when she saves the whole client.
    // The field already shows it masked, so no nag.
    if (!apiMode || !client?.id || typeof onPersist !== 'function') return;
    try {
      let toSave = nextForm;
      if (!hydratedRef.current) {
        const full = await apiGetClient(client.id);
        if (!full) throw new Error('no full record');
        if (full.updatedAt) baseUpdatedAtRef.current = full.updatedAt;
        toSave = mergeFullIntoForm(nextForm, full);
        setForm(toSave);
        hydratedRef.current = true;
      }
      const result = await onPersist({ ...recalcInsured(toSave), __baseUpdatedAt: baseUpdatedAtRef.current });
      if (result) {
        // Refresh the concurrency base so a later "Guardar" doesn't conflict
        // with our own just-saved version (STALE_WRITE).
        try {
          const fresh = await apiGetClient(client.id);
          if (fresh?.updatedAt) baseUpdatedAtRef.current = fresh.updatedAt;
        } catch { /* non-fatal */ }
        toast.success(aviso || (lang === 'es' ? 'SSN del dependiente guardado ✅' : 'Dependent SSN saved ✅'));
      }
      // result === null → onPersist (save) already alerted the failure.
    } catch (e) {
      toast.error((lang === 'es'
        ? 'No se pudo guardar en la ficha del titular: '
        : 'Could not save on the head-of-household record: ') + (e?.message || e));
    }
  };
  // Intercepts the SsnRevealModal bubble-up. For an EXISTING client
  // (clientIdArg set) the SSN was just persisted server-side via
  // /update-ssn, so we forward the result to the parent (clients list
  // + detail patch + refetch). For a NEW client (clientIdArg null) the
  // SSN was only PIN-validated, never POSTed — so we drop the typed
  // value into the form's local state so it rides in the createClient
  // body when the agent saves the whole client.
  const handleSsnSavedLocal = (result, tgt, clientIdArg, depId) => {
    // A `pendingSsn` means the SSN was PIN-validated but NOT persisted
    // server-side yet — either a brand-new client (no id) OR a dependent
    // that doesn't exist server-side yet (added this session, so
    // /update-ssn 404s with DEPENDENT_NOT_FOUND). In BOTH cases the value
    // must ride along in the next full-client Save, so stash it in form
    // state. (We no longer gate on `!clientIdArg`: the dependent-fallback
    // case arrives WITH a clientId but still needs the form-state path.)
    if (result && result.pendingSsn) {
      if (tgt === 'primary') {
        set('ssn', result.pendingSsn);
      } else if (tgt === 'spouse') {
        setSpouse('ssn', result.pendingSsn);
      } else if (tgt === 'dependent' && depId) {
        // Stash the SSN on the dependent AND persist the client immediately
        // (existing clients) so it doesn't depend on a second "Guardar".
        const last4 = result.ssnLast4 || String(result.pendingSsn || '').replace(/\D/g, '').slice(-4);
        const nextForm = {
          ...form,
          dependents: form.dependents.map(d => d.id === depId ? { ...d, ssn: result.pendingSsn, ssnLast4: last4 } : d),
        };
        setForm(nextForm);
        persistStayingOpen(nextForm);
      }
      return;
    }
    if (typeof onSsnSaved === 'function') {
      onSsnSaved(result, tgt, clientIdArg, depId);
    }
  };
  const addDep=()=>setForm(f=>({...f,dependents:[...f.dependents,{...emptyDep,id:Math.random().toString(36).slice(2)}]}));
  const isCovKey = (k) => typeof k === "string" && k.startsWith("cov_");
  // Re-derive every "insured" flag and the household count straight from the
  // coverage toggles. Nobody is insured unless a coverage is actually ON — no
  // undefined-defaults-to-insured. Runs whenever a coverage toggle changes so
  // turning a policy type OFF immediately drops the person and the count.
  const recalcInsured=(f)=>{
    const deps=(f.dependents||[]).map(d=>({...d,insured:memberHasCoverage(d)}));
    // Invariant: a client whose marital status keeps no partner has NO spouse.
    // "Deleting" a spouse in the UI is done by flipping maritalStatus back to
    // single, but the spouse object used to linger in c.spouse — so it
    // re-appeared as a phantom "Cónyuge" on policies/coverage/signatures/
    // birthdays that only checked spouse.firstName (Marivy 2026-07-28: Tulio
    // Linares). Normalize it away on every save so the removal actually sticks
    // in the DB (mapClientToApi writes the now-empty spouse scalars back,
    // clearing the encrypted fields).
    //
    // CONSERVAN PAREJA DOS ESTADOS, no uno (`tienePareja`). Con el
    // '=== "married"' de antes, este renglon BORRABA a la pareja de hecho de una
    // ficha al primer guardado, aunque la hubiera puesto una importación o el
    // propio formulario: es la razón de fondo de que los importadores
    // escribieran "casado" a la fuerza (2026-09-15).
    const spouse = tienePareja(f.maritalStatus)
      ? (f.spouse ? {...f.spouse,insured:memberHasCoverage(f.spouse)} : f.spouse)
      : {...emptySpouse};
    const next={
      ...f,
      insured:memberHasCoverage(f),
      spouse,
      dependents:deps,
    };
    next.insuredMembers=String(countInsuredMembers(next));
    return next;
  };
  const setDep=(i,k,v)=>setForm(f=>{
    const newDeps=f.dependents.map((d,j)=> j!==i ? d : {...d,[k]:v});
    const next={...f,dependents:newDeps};
    return isCovKey(k) ? recalcInsured(next) : next;
  });
  // (applyCoverageToFamily removed 2026-07-27 — coverage toggles no longer live
  // in the client editor; coverage is set on the policy's insured list instead.)
  const delDep=(i)=>setForm(f=>({...f,dependents:f.dependents.filter((_,j)=>j!==i)}));
  const createSeparateProfile=async (dep,i)=>{
    if(!onClientsChange) return;
    const apiMode = typeof window !== "undefined" && !!window.__deskteAuth;
    const localId=Math.random().toString(36).slice(2);
    // Pull the freshest principal record so the spun-off profile inherits
    // an address the user just saved even if this form's in-memory copy
    // is stale. If the principal genuinely has no city/state/zip, nothing
    // can conjure it — that address must be completed on the principal.
    let principal = client || {};
    if (apiMode && (form.id||client?.id)) {
      try { const fresh = await apiGetClient(form.id||client?.id); if (fresh) principal = { ...client, ...fresh }; } catch { /* fall back to in-memory */ }
    }
    const newClient={
      id:localId, firstName:dep.firstName, lastName:dep.lastName,
      // Contact: the dependent's own phone/email if they have one, else
      // inherit the head-of-household's. Address ALWAYS comes from the
      // principal — sourced through form, fresh server record, then the
      // in-memory client, across every key name it can land under.
      phone:dep.phone||form.phone||principal.phone||"", email:dep.email||form.email||principal.email||"",
      dob:dep.dob, status:"active", preferredLang:form.preferredLang,
      addressStreet:form.addressStreet||form.address||principal.addressStreet||principal.address||"",
      addressCity:form.addressCity||form.city||principal.addressCity||principal.city||"",
      addressState:form.addressState||form.state||principal.addressState||principal.state||"",
      addressZip:form.addressZip||form.zipCode||principal.addressZip||principal.zipCode||"",
      employer:dep.employer, annualIncome:dep.income, immigrationStatus:dep.immigrationStatus, ssn:dep.ssn,
      // Sus ingresos de mas se van con el a su ficha propia (2026-10-27).
      ...(Array.isArray(dep.otrosIngresos) && dep.otrosIngresos.length ? { otrosIngresos: dep.otrosIngresos } : {}),
      immigrationDocs:dep.immigrationDocs||{uscisNumber:"",cardNumber:"",category:"",issueDate:"",expirationDate:"",bornCitizen:"",naturalizationNumber:"",naturalizationDate:""},
      notes:`${lang==="es"?"Dependiente mayor de edad de":"Adult dependent of"} ${form.firstName} ${form.lastName} (${lang==="es"?"grupo familiar":"family group"})`,
      linkedParentId:form.id||client?.id||"", linkedParentName:`${form.firstName} ${form.lastName}`,
      householdSize:"1", insuredMembers:"1", dependents:[], spouse:{...emptySpouse},
      createdAt:new Date().toISOString().split("T")[0], maritalStatus:"", refFirstName:"", refLastName:"", refPhone:""
    };
    // In API mode, persist the dependent-as-separate-client to the backend
    // first so the new row gets a real UUID. Without this the client lives
    // only in localStorage with a frontend-only id, exactly the bug PR #104
    // fixed for the import paths.
    let resolvedId = localId;
    let resolvedClient = newClient;
    if (apiMode) {
      try {
        const created = await apiCreateClient(newClient);
        resolvedClient = { ...newClient, ...created };
        resolvedId = created.id;
      } catch (err) {
        alert((lang === "es" ? "No se pudo crear el perfil separado: " : "Could not create separate profile: ") + err.message);
        return;
      }
    }
    onClientsChange(prev=>[...prev, resolvedClient]);
    // LA MARCA SE GUARDA EN EL ACTO, no cuando alguien se acuerde de pulsar
    // Guardar (Lissette 2026-09-15: *"cuando se cree un perfil de mayor de edad
    // que se quede el anuncio de que ya se creo, en el perfil de donde viene"*).
    //
    // Hasta hoy esto solo tocaba el formulario EN MEMORIA. El cliente nuevo se
    // creaba de verdad en el servidor -con su UUID- pero la ficha del titular
    // no se enteraba hasta el siguiente guardado: cerrar sin guardar, o un F5,
    // y la marca desaparecia. Quedaban DOS fichas sin ninguna relacion entre
    // ellas, el cartel verde se iba, la etiqueta "Perfil sep." de la ficha
    // nunca llegaba a salir, y la proxima vez que alguien abriera al titular no
    // habia forma de saber que ese perfil ya existia -- asi es como se crea el
    // segundo perfil de la misma persona.
    //
    // Se guarda con el MISMO ayudante que ya usa el SSN del dependiente
    // (`persistStayingOpen`), por lo mismo: es un dato que la agente acaba de
    // crear, no un borrador.
    //
    // Se arma DENTRO del actualizador y no desde el `form` de la clausura: entre
    // que se pulso el boton y que el servidor devolvio el id hubo un `await`, y
    // en ese rato la agente puede haber seguido escribiendo en otra casilla.
    // Partir del `form` viejo le borraria lo que acaba de teclear.
    let conLaMarca = null;
    setForm(f => {
      conLaMarca = {
        ...f,
        dependents: f.dependents.map((d,j)=>j===i ? { ...d, separateProfile:true, separateProfileId:resolvedId } : d),
      };
      return conLaMarca;
    });
    setProfileCreated(p=>({...p,[i]:true}));
    if (conLaMarca) persistStayingOpen(conLaMarca, lang==="es"
      ? `Perfil de ${dep.firstName} creado y enlazado a esta ficha ✅`
      : `${dep.firstName}'s profile created and linked to this record ✅`);
    // Offer to copy the head-of-household's policies into the new
    // profile. Lissette picks which (a turning-18 dependent usually
    // needs their own enrollment, but the carrier/plan is a good start).
    const principalId=form.id||client?.id;
    const owned=(policies||[]).filter(p=>p.clientId===principalId);
    if(owned.length){
      setPolicyPicker({clientId:resolvedId, clientName:`${dep.firstName} ${dep.lastName}`.trim(), list:owned, selected:{}});
    }
  };
  const copySelectedPolicies=async ()=>{
    if(!policyPicker) return;
    const apiMode = typeof window !== "undefined" && !!window.__deskteAuth;
    const chosen=policyPicker.list.filter(p=>policyPicker.selected[p.id]);
    if(!chosen.length){ setPolicyPicker(null); return; }
    setCopyingPolicies(true);
    const tagged=lang==="es"?"Copiada del titular":"Copied from head of household";
    const added=[];
    try{
      for(const pol of chosen){
        // Copy is ACTIVE (not draft). Ask, per policy, whether the
        // dependent's premium is the same as the head of household's —
        // if not, leave it blank so she enters the dependent's real one.
        const prem=pol.monthlyPremium||"0";
        const samePrem=await confirmDialog({
          message: lang==="es"
            ? `${pol.carrier||"Póliza"} — ¿La prima del dependiente será la MISMA que la del titular ($${prem}/mes)?`
            : `${pol.carrier||"Policy"} — Will the dependent's premium be the SAME as the head of household's ($${prem}/mo)?`,
          confirmLabel: lang==="es" ? "Sí, misma prima" : "Yes, same premium",
          cancelLabel: lang==="es" ? "No, dejar en $0" : "No, leave $0",
        });
        const copy={...pol, id:undefined, clientId:policyPicker.clientId, status:"active",
          monthlyPremium: samePrem ? pol.monthlyPremium : "",
          policyNumber:"", notes:(pol.notes?pol.notes+" · ":"")+tagged};
        if(apiMode){
          const created=await apiCreatePolicy(copy);
          added.push(created);
        } else {
          added.push({...copy, id:"pi_"+Date.now()+"_"+Math.random().toString(36).slice(2)});
        }
      }
      if(onPoliciesAdd && added.length) onPoliciesAdd(added);
      setPolicyPicker(null);
      alert(lang==="es"
        ? `${added.length} póliza(s) copiada(s) como ACTIVA(S) al perfil de ${policyPicker.clientName}. Revisa el plan y el número de póliza.`
        : `${added.length} policy(ies) copied as ACTIVE to ${policyPicker.clientName}'s profile. Review the plan and policy number.`);
    }catch(err){
      alert((lang==="es"?"No se pudieron copiar las pólizas: ":"Could not copy policies: ")+(err?.message||err));
    }finally{
      setCopyingPolicies(false);
    }
  };
  const S=({label,sub})=>(
    <div style={{borderTop:"1px solid var(--c-border,#1a3550)",paddingTop:10,marginBottom:6}}>
      <span style={{fontSize:".62rem",fontWeight:700,color:"var(--c-cyan,#00d4ff)",textTransform:"uppercase",letterSpacing:".1em",fontFamily:"var(--font-mono)"}}>{label}</span>
      {sub&&<div style={{fontSize:".68rem",color:"var(--c-text3,#45688a)",marginTop:2}}>{sub}</div>}
    </div>
  );
  // Each custom (agency-shared) tab is its own top-level form tab, placed right
  // after Health/Legal (mirrors the read view). A trailing "+ tab" pseudo-tab
  // creates a new one. Editing a tab here changes it for ALL clients (shared
  // definition); typing values is per-client.
  const customFormTabs=(Array.isArray(customTabDefs)?customTabDefs:[]).filter(d=>d&&d.id&&(d.label||"").trim()).map(d=>["custom_"+d.id,"🧩 "+d.label]);
  const TABS=[
    ["contact","👤 "+(lang==="es"?"Contacto":"Contact")],
    ["household","🏠 "+(lang==="es"?"Hogar":"Household")],
    ["dependents","👨‍👩‍👧‍👦 "+(lang==="es"?"Familia":"Family")+(form.dependents.length?` (${form.dependents.length})`:"")],
    ["salud","🏥 "+(lang==="es"?"Salud/Legal":"Health/Legal")],
    // MEDICARE — pestaña FIJA, al lado de Salud (Lissette 2026-09-19: "al lado
    // de la pestaña salud una pestaña fija que diga medicare"). Fija y no una
    // de las que crea la agencia: los tres campos los pidio para todas, y una
    // pestaña que cada agencia tenga que crearse a mano no es la misma funcion.
    ["medicare","⭐ Medicare"],
    ...customFormTabs,
    ["custom_new","➕ "+(lang==="es"?"Pestaña":"Tab")],
    // "Referido" moved out of the editor (2026-06-17). It now lives on the
    // client PROFILE as a button next to Print, where it captures the
    // referrals THIS client GAVE us (outbound). The old inbound referredBy*
    // data is preserved on the record (still shown in the printed ficha and
    // Prospects), it's just no longer editable from this tab.
  ];
  return <div>
    {/* Save bar pinned to the top of the editor (Lissette 2026-06-22: "a veces
        es tedioso ir hasta abajo"). It sticks just under the modal's sticky
        header (.dkt-mhdr ≈ 50px) so it stays reachable while scrolling. Mirrors
        the FOOTER button's disabled state (savingForm/hydrating) — a half-
        hydrated form must never be saveable from here either (data-persistence
        guard). Same submitForm handler, so validation/SSN flow is identical. */}
    <div style={{position:"sticky",top:50,zIndex:8,display:"flex",alignItems:"center",gap:".6rem",margin:"-1.2rem -1.2rem 1rem",padding:".6rem 1.2rem",background:"var(--c-surface,#0d1c2e)",borderBottom:"1px solid var(--c-border,#1a3550)"}}>
      <span style={{fontSize:".68rem",color:"var(--c-text3,#45688a)",marginRight:"auto"}}>{lang==="es"?"Puedes guardar desde aquí ↓":"You can save from here ↓"}</span>
      <button type="button" onClick={submitForm} disabled={savingForm||hydrating} className="dkt-btn-p" style={{padding:".5rem 1.05rem",fontSize:".76rem",opacity:(savingForm||hydrating)?.7:1}}><Save size={14}/>{savingForm?(lang==="es"?"Guardando…":"Saving…"):hydrating?(lang==="es"?"Cargando…":"Loading…"):tf.save}</button>
    </div>
    {policyPicker && (
      <Modal title={lang==="es"?`Copiar pólizas a ${policyPicker.clientName}`:`Copy policies to ${policyPicker.clientName}`} onClose={()=>{ if(!copyingPolicies) setPolicyPicker(null); }}>
        <div style={{display:"flex",flexDirection:"column",gap:".5rem"}}>
          <div style={{fontSize:".72rem",color:"var(--c-text3,#45688a)"}}>
            {lang==="es"?"Elige cuáles pólizas del titular copiar al nuevo perfil. Se crean como BORRADOR (pendiente) — revisa plan y prima.":"Pick which of the head-of-household's policies to copy. They're created as DRAFT (pending) — review plan and premium."}
          </div>
          {policyPicker.list.map(p=>{
            const on=!!policyPicker.selected[p.id];
            const pt=getPolicyType(p.type);
            const toggle=()=>setPolicyPicker(pp=>({...pp,selected:{...pp.selected,[p.id]:!pp.selected[p.id]}}));
            return (
              <div key={p.id} onClick={toggle} style={{display:"flex",alignItems:"center",gap:".6rem",padding:".55rem .7rem",border:`1px solid ${on?"#00d4ff":"#2a4a68"}`,borderRadius:8,cursor:"pointer",background:on?"rgba(0,212,255,.12)":"rgba(255,255,255,.03)"}}>
                <div style={{width:22,height:22,borderRadius:5,flexShrink:0,display:"flex",alignItems:"center",justifyContent:"center",border:`2px solid ${on?"#00d4ff":"#6f93b5"}`,background:on?"#00d4ff":"#0d1c2e",color:"#04121f",fontWeight:900,fontSize:".9rem",lineHeight:1}}>{on?"✓":""}</div>
                <span style={{fontSize:"1rem"}}>{pt.icon}</span>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{fontSize:".78rem",fontWeight:700,color:"#eef6ff"}}>{p.carrier||"—"} · {pt.label}</div>
                  <div style={{fontSize:".66rem",color:"#7aa3c0"}}>{p.plan||(lang==="es"?"sin plan":"no plan")} · ${p.monthlyPremium||"0"}/mo · {p.status}</div>
                </div>
              </div>
            );
          })}
          <div style={{display:"flex",gap:".5rem",justifyContent:"flex-end",marginTop:".5rem"}}>
            <button type="button" disabled={copyingPolicies} onClick={()=>setPolicyPicker(null)} style={{padding:".5rem 1rem",borderRadius:8,border:"1px solid #2a4a68",background:"#16273a",color:"#c8dff0",fontWeight:600,fontSize:".82rem",cursor:"pointer",fontFamily:"inherit"}}>{lang==="es"?"Omitir":"Skip"}</button>
            <button type="button" disabled={copyingPolicies} onClick={copySelectedPolicies} style={{padding:".5rem 1.1rem",borderRadius:8,border:"none",background:copyingPolicies?"#155e75":"#00d4ff",color:"#04121f",fontWeight:800,fontSize:".82rem",cursor:copyingPolicies?"wait":"pointer",fontFamily:"inherit"}}>{copyingPolicies?(lang==="es"?"Copiando…":"Copying…"):(lang==="es"?"Copiar seleccionadas":"Copy selected")}</button>
          </div>
        </div>
      </Modal>
    )}
    {staleLive && (
      <div style={{display:"flex",alignItems:"center",gap:".6rem",marginBottom:".85rem",padding:".6rem .8rem",borderRadius:9,border:"1px solid #d9a441",background:"rgba(217,164,65,.12)"}}>
        <span style={{fontSize:"1.1rem",lineHeight:1}}>🔄</span>
        <div style={{flex:1,minWidth:0,fontSize:".74rem",color:"#f0d49a",fontWeight:600}}>
          {lang==="es"
            ? "Otra persona acaba de actualizar esta ficha mientras la tenías abierta. Si guardas, te avisaremos para no borrar sus cambios."
            : "Someone else just updated this client while you had it open. If you save, we'll warn you so you don't overwrite their changes."}
        </div>
        <button type="button" onClick={()=>setStaleLive(false)} title={lang==="es"?"Ocultar":"Dismiss"}
          style={{background:"none",border:"none",color:"#f0d49a",cursor:"pointer",fontSize:"1rem",lineHeight:1,padding:0,flexShrink:0}}>×</button>
      </div>
    )}
    <div style={{display:"flex",gap:".35rem",marginBottom:"1rem",flexWrap:"wrap"}}>
      {TABS.map(([id,lbl])=><button key={id} type="button" onClick={()=>{
        if(id==="custom_new"){ const nd={id:'ct_'+uid(),label:'',fields:[]}; onCustomTabDefsChange&&onCustomTabDefsChange([...(Array.isArray(customTabDefs)?customTabDefs:[]),nd]); setFormTab("custom_"+nd.id); }
        else setFormTab(id);
      }} className={`dkt-tab${formTab===id?" on":""}`} style={{fontSize:".72rem"}}>{lbl}</button>)}
    </div>
    <form onSubmit={e=>{e.preventDefault();submitForm();}} style={{display:"flex",flexDirection:"column",gap:".75rem"}}>
      {formTab==="contact"&&<>
        <S label={tf.sectionContact}/>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:".75rem"}}>
          <Input label={tf.firstName} value={form.firstName} onChange={e=>set("firstName",e.target.value)} required placeholder=""/>
          <Input label={tf.middleName} value={form.middleName||""} onChange={e=>set("middleName",e.target.value)} placeholder=""/>
          <Input label={tf.lastName} value={form.lastName} onChange={e=>set("lastName",e.target.value)} required placeholder=""/>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:".75rem"}}>
          <Input label={tf.phone} value={form.phone} onChange={e=>set("phone",e.target.value)} onBlur={e=>set("phone",formatPhoneUS(e.target.value))} placeholder=""/>
          <Input label={tf.email} type="email" value={form.email} onChange={e=>set("email",e.target.value)} error={!isEmailish(form.email) ? (lang==="es"?"Correo inválido":"Invalid email") : undefined} placeholder=""/>
        </div>
        {/* auto-fit: al anadir Sexo eran cuatro campos en una rejilla de tres,
            que dejaba el ultimo colgando solo en una fila. */}
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(150px,1fr))",gap:".75rem"}}>
          {/* La edad al lado de la fecha, calculada en vivo mientras se escribe
              (Lissette 2026-08-25). Es un dato derivado: no se guarda, no viaja
              al servidor y no hay una segunda fecha que se pueda desincronizar.
              Mismo tratamiento para el conyuge y cada dependiente. */}
          <Input label={`${tf.dob}${ageLabelSuffix(form.dob,lang==="es")}`} type="date" value={form.dob} onChange={e=>set("dob",e.target.value)}/>
          <div>
            <label className="dkt-input-lbl">{tf.maritalStatus}</label>
            <select className="dkt-inp" value={form.maritalStatus} onChange={e=>set("maritalStatus",e.target.value)}>
              <option value="">--</option>
              <option value="single">{tf.single}</option>
              <option value="married">{tf.married}</option>
              {/* UNION LIBRE Y SEPARADO/A. Los seis estados civiles existen en el
                  servidor (MARITAL_STATUSES), los importadores traducen los seis
                  y la ficha ya pintaba "Pareja de Hecho"... pero ESTE
                  desplegable solo ofrecia cuatro. Un cliente importado como
                  pareja de hecho se abria aqui con la casilla en blanco, y en
                  cuanto alguien elegia cualquier otra cosa el dato se perdia: lo
                  que el servidor sabe hacer y la pantalla no pide es como si no
                  existiera (Lissette, 2026-09-15). */}
              <option value="domestic_partner">{tf.domesticPartner}</option>
              <option value="separated">{tf.separated}</option>
              <option value="widowed">{tf.widowed}</option>
              <option value="divorced">{tf.divorced}</option>
            </select>
          </div>
          <div>
            <label className="dkt-input-lbl">{lang==="es"?"Sexo":"Sex"}</label>
            <select className="dkt-inp" value={form.gender||""} onChange={e=>set("gender",e.target.value)}>
              <option value="">--</option>
              <option value="Male">{lang==="es"?"Masculino":"Male"}</option>
              <option value="Female">{lang==="es"?"Femenino":"Female"}</option>
            </select>
          </div>
          {/* El TITULAR. Aqui arriba, no al final: es una pregunta que se hace
              hablando con el cliente, no al suscribir una poliza de Vida. */}
          <PreguntaDeMedicaid value={form.medicaid} onChange={e=>set("medicaid",e.target.value)} lang={lang}/>
          <Select label={tf.status} value={form.status} onChange={e=>set("status",e.target.value)}>
            <option value="active">{t.statuses.active}</option>
            <option value="pending">{t.statuses.pending}</option>
            <option value="inactive">{t.statuses.inactive}</option>
            <option value="prospect">{t.statuses.prospect}</option>
          </Select>
        </div>
        {/* Identidad — SSN + estatus migratorio del titular, ARRIBA de
            Preferred Language (Lissette 2026-05-28). */}
        <ImmigrationSelect label={tf.immigrationStatus} value={form.immigrationStatus} onChange={e=>set("immigrationStatus",e.target.value)} lang={lang}/>
        <ImmigrationDocsFields docs={form.immigrationDocs} onChange={v=>set("immigrationDocs",v)} lang={lang} status={form.immigrationStatus}/>
        <SSNField label={tf.ssn} value={form.ssn} hint={tf.ssnHint} ssnMasked={client?.ssnMasked} hasOnFile={!!client?.hasSsn} lang={lang} clientId={client?.id} onSsnSaved={handleSsnSavedLocal}/>
        <Select label={tf.preferredLang} value={form.preferredLang} onChange={e=>set("preferredLang",e.target.value)}>
          <option value="english">{tf.english}</option>
          <option value="spanish">{tf.spanish}</option>
        </Select>
        <S label={tf.sectionAddress}/>
        {/* Solo cuando se está cambiando algo que YA estaba escrito. Rellenar
            una casilla vacía no es mudarse de casa, y este cartel salía por
            eso: el autorrelleno del ZIP completa el estado al abrir la ficha,
            y el aviso aparecía solo, avisando de un cambio de dirección que
            nadie había pedido (Javier Volcanes, 2026-08-28, E-146). También
            saltaba con un `undefined` contra un `""`, que es el mismo dato. */}
        {client && (client.addressStreet||client.addressCity) && (
          ["addressStreet","addressCity","addressState","addressZip"]
            .some(k => (client[k]||"") && (form[k]||"") !== (client[k]||""))
        ) && <div style={{
          background:"rgba(255,183,0,.07)",border:"1px solid rgba(255,183,0,.3)",
          borderRadius:9,padding:".6rem .875rem",marginBottom:".25rem"
        }}>
          <div style={{fontSize:".6rem",fontWeight:800,color:"var(--c-amber,#ffb700)",textTransform:"uppercase",
            letterSpacing:".08em",marginBottom:".4rem",display:"flex",alignItems:"center",gap:4}}>
            📍 {lang==="es"?"Dirección anterior (se guardará en historial):":"Previous address (will be saved to history):"}
          </div>
          <div style={{fontSize:".78rem",color:"var(--c-text2,#7aa3c0)",fontFamily:"var(--font-mono)"}}>
            {[client.addressStreet,client.addressCity,client.addressState,client.addressZip].filter(Boolean).join(", ")}
          </div>
        </div>}
        <Input label={tf.addressStreet} value={form.addressStreet} onChange={e=>{setAddrTyped(true);set("addressStreet",e.target.value);}} placeholder="" autoComplete="off"/>
        <AddressSuggestions
          query={{street:form.addressStreet||"",city:form.addressCity||"",state:form.addressState||"",zip:form.addressZip||""}}
          enabled={addrTyped} onPick={pickAddress} lang={lang}/>
        <div style={{display:"grid",gridTemplateColumns:"2fr 1fr 1fr 1.3fr",gap:".75rem"}}>
          <Input label={tf.addressCity} value={form.addressCity} onChange={e=>{setAddrTyped(true);set("addressCity",e.target.value);}} placeholder=""/>
          <Input label={tf.addressState} value={form.addressState} onChange={e=>set("addressState",e.target.value)} placeholder=""/>
          <Input label={tf.addressZip} value={form.addressZip} onChange={e=>{setAddrTyped(true);set("addressZip",e.target.value);}} placeholder="" maxLength={10}/>
          <Input label={tf.county} value={form.county} onChange={e=>set("county",e.target.value)} placeholder=""/>
        </div>
        {zipAutofilled && (
          <div style={{
            marginTop:".25rem",
            fontSize:".65rem",
            color:"var(--c-green,#00ff88)",
            fontFamily:"var(--font-mono)",
            letterSpacing:".05em",
          }}>
            ✓ {lang==="es"
              ? "Ciudad y estado completados desde el ZIP — todavía SIN GUARDAR: dale a Guardar para que queden en la ficha."
              : "City and state auto-filled from the ZIP — NOT SAVED yet: press Save to store them on the record."}
          </div>
        )}
        {/* País de nacimiento + licencia — datos generales (Lissette 2026-05-28). */}
        <GeneralIdFields data={form} update={set} lang={lang}/>
        <S label={tf.sectionOther}/>
        <Textarea label={tf.notes} value={form.notes} onChange={e=>set("notes",e.target.value)} placeholder={lang==="es"?"Notas...":"Notes..."}/>
      </>}
      {formTab==="household"&&<>
        <S label={tf.sectionHousehold}/>
        {/* "Members to Insure" (insuredMembers) lives per-POLICY, not per-client
            — the policy card derives it from who's marked insured on that policy
            (Lissette 2026-06-12). The client-level selector was removed to avoid
            a number that conflicts across policies; insuredMembers is still
            auto-computed elsewhere (countInsuredMembers) for reports. */}
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:".75rem"}}>
          <div>
            <label className="dkt-input-lbl">{tf.householdSize}</label>
            <select className="dkt-inp" value={form.householdSize} onChange={e=>set("householdSize",e.target.value)}>
              <option value="">--</option>
              {[1,2,3,4,5,6,7,8,9,10].map(n=><option key={n} value={n}>{n} {n===1?(lang==="es"?"persona":"person"):(lang==="es"?"personas":"people")}</option>)}
            </select>
          </div>
          <Input label={tf.annualIncome} value={form.annualIncome} onChange={e=>set("annualIncome",e.target.value)} placeholder=""/>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:".65rem"}}>
          <Input label={tf.employer} value={form.employer} onChange={e=>set("employer",e.target.value)} placeholder=""/>
          <Input label={tf.employerPhone} value={form.employerPhone||""} onChange={e=>set("employerPhone",e.target.value)} placeholder={lang==="es"?"Tel. del empleador":"Employer phone"}/>
        </div>
        <EmploymentFields type={form.employmentType} desc={form.employmentDesc}
          onType={v=>set("employmentType",v)} onDesc={v=>set("employmentDesc",v)} lang={lang}/>
        {/* Un segundo trabajo, una pension... (Lissette 2026-10-27). El campo
            de arriba sigue siendo el ingreso principal. crm-app/otrosIngresos.js */}
        <OtrosIngresos principal={form.annualIncome} lista={form.otrosIngresos} onChange={v=>set("otrosIngresos",v)} lang={lang}/>
        {/* Coverage toggles were removed from the client editor (Lissette 2026-07-27):
            coverage is now defined ONLY by creating a policy and marking its insured
            people ("Personas Aseguradas" in PolicyForm). The Policy→Coverage sync
            (ClientDetail.savePolicy) keeps the cov_<type> flags — and every insured
            count/report — in step automatically. */}
        {tienePareja(form.maritalStatus)&&<>
          <S label={tf.sectionSpouse} sub={lang==="es"?"Información del cónyuge o pareja":"Spouse or partner information"}/>
          <div style={{background:"var(--c-surface2,#112538)",border:"1px solid var(--c-border,#1a3550)",borderLeft:"3px solid var(--c-cyan,#00d4ff)",borderRadius:10,padding:".875rem",display:"flex",flexDirection:"column",gap:".65rem"}}>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:".65rem"}}>
              <Input label={tf.spouseFirstName} value={form.spouse.firstName} onChange={e=>setSpouse("firstName",e.target.value)} placeholder=""/>
              <Input label={tf.spouseMiddleName} value={form.spouse.middleName||""} onChange={e=>setSpouse("middleName",e.target.value)} placeholder=""/>
              <Input label={tf.spouseLastName} value={form.spouse.lastName} onChange={e=>setSpouse("lastName",e.target.value)} placeholder=""/>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:".65rem"}}>
              <Input label={tf.spousePhone} value={form.spouse.phone} onChange={e=>setSpouse("phone",e.target.value)} onBlur={e=>setSpouse("phone",formatPhoneUS(e.target.value))} placeholder=""/>
              <Input label={tf.spouseEmail} type="email" value={form.spouse.email||""} onChange={e=>setSpouse("email",e.target.value)} error={!isEmailish(form.spouse.email) ? (lang==="es"?"Correo inválido":"Invalid email") : undefined} placeholder=""/>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:".65rem"}}>
              <Input label={`${tf.spouseDob}${ageLabelSuffix(form.spouse.dob,lang==="es")}`} type="date" value={form.spouse.dob} onChange={e=>setSpouse("dob",e.target.value)}/>
              {/* Ocupa el hueco que ya habia junto a la fecha del conyuge. */}
              <div>
                <label className="dkt-input-lbl">{lang==="es"?"Sexo":"Sex"}</label>
                <select className="dkt-inp" value={form.spouse.gender||""} onChange={e=>setSpouse("gender",e.target.value)}>
                  <option value="">--</option>
                  <option value="Male">{lang==="es"?"Masculino":"Male"}</option>
                  <option value="Female">{lang==="es"?"Femenino":"Female"}</option>
                </select>
              </div>
            </div>
            {/* El CONYUGE, en su propia seccion y entre sus datos de siempre,
                no al final del formulario. */}
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:".65rem"}}>
              <PreguntaDeMedicaid value={form.spouse.medicaid} onChange={e=>setSpouse("medicaid",e.target.value)} lang={lang}/>
              <div/>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:".65rem"}}>
              <Input label={tf.spouseEmployer} value={form.spouse.employer} onChange={e=>setSpouse("employer",e.target.value)} placeholder={lang==="es"?"Empleador...":"Employer..."}/>
              <Input label={tf.spouseIncome} value={form.spouse.income} onChange={e=>setSpouse("income",e.target.value)} placeholder="$38,000"/>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:".65rem"}}>
              <Input label={tf.spouseEmployerPhone} value={form.spouse.employerPhone||""} onChange={e=>setSpouse("employerPhone",e.target.value)} placeholder={lang==="es"?"Tel. del empleador":"Employer phone"}/>
              <div/>
            </div>
            <EmploymentFields type={form.spouse.employmentType} desc={form.spouse.employmentDesc}
              onType={v=>setSpouse("employmentType",v)} onDesc={v=>setSpouse("employmentDesc",v)} lang={lang}/>
            <OtrosIngresos principal={form.spouse.income} lista={form.spouse.otrosIngresos} onChange={v=>setSpouse("otrosIngresos",v)} lang={lang}/>
            <ImmigrationSelect label={tf.spouseImmigration} value={form.spouse.immigrationStatus} onChange={e=>setSpouse("immigrationStatus",e.target.value)} lang={lang}/>
            <ImmigrationDocsFields docs={form.spouse.immigrationDocs} onChange={v=>setSpouse("immigrationDocs",v)} lang={lang} status={form.spouse.immigrationStatus}/>
            <GeneralIdFields data={form.spouse} update={setSpouse} lang={lang}/>
            <SSNField label={tf.spouseSSN} value={form.spouse.ssn} hint={tf.ssnHint} ssnMasked={form.spouse?.ssnMasked || client?.spouse?.ssnMasked} hasOnFile={!!(form.spouse?.ssnMasked || form.spouse?.ssnLast4 || client?.spouse?.ssnMasked || client?.spouse?.ssnLast4)} lang={lang} clientId={client?.id} target="spouse" onSsnSaved={handleSsnSavedLocal}/>
            {/* Spouse coverage toggles removed — coverage comes from the policy's
                insured list now (Lissette 2026-07-27). */}
          </div>
        </>}
        {tienePareja(form.maritalStatus)&&!form.spouse.firstName&&(
          <div className="dkt-phase">💍 {lang==="es"?"Completa la información del cónyuge en el bloque de arriba":"Fill in spouse information in the block above"}</div>
        )}
      </>}
      {formTab==="dependents"&&<>
        <S label={tf.sectionDependents}/>
        {form.dependents.length===0&&(
          <div style={{textAlign:"center",padding:"1.5rem",color:"var(--c-text3,#45688a)",fontSize:".8rem",background:"var(--c-surface2,#112538)",borderRadius:10,border:"1px solid var(--c-border,#1a3550)"}}>
            {lang==="es"?"No hay miembros del hogar agregados":"No household members added yet"}
          </div>
        )}
        {form.dependents.map((dep,i)=>{
          const age=calcAge(dep.dob);
          const isAdult=age!==null&&age>=26;
          return (
          <div key={dep.id||i} style={{background:"var(--c-surface2,#112538)",border:`1px solid ${isAdult?"var(--c-amber,#ffb700)":"var(--c-border,#1a3550)"}`,borderRadius:10,padding:".875rem",position:"relative"}}>
            <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:".6rem"}}>
              <div style={{display:"flex",alignItems:"center",gap:".5rem"}}>
                <span style={{fontSize:".72rem",fontWeight:700,color:isAdult?"var(--c-amber,#ffb700)":"var(--c-cyan,#00d4ff)",fontFamily:"var(--font-mono)",textTransform:"uppercase"}}>
                  {lang==="es"?"Miembro":"Member"} #{i+1}
                </span>
                {age!==null&&<span style={{fontSize:".65rem",background:isAdult?"var(--c-amber-dim)":"var(--c-surface3,#162d44)",color:isAdult?"var(--c-amber,#ffb700)":"var(--c-text3,#45688a)",padding:"1px 6px",borderRadius:5,fontFamily:"var(--font-mono)",fontWeight:700}}>
                  {age} {lang==="es"?"años":"yrs"}
                </span>}
                {isAdult&&<span style={{fontSize:".62rem",color:"var(--c-amber,#ffb700)",fontWeight:700}}>⚠️ {tf.adultDepNote}</span>}
              </div>
              <button type="button" onClick={()=>delDep(i)} style={{background:"none",border:"none",cursor:"pointer",color:"var(--c-text3,#45688a)",padding:2,borderRadius:5,lineHeight:0}}
                onMouseEnter={e=>e.currentTarget.style.color="var(--c-red,#ff3d6b)"} onMouseLeave={e=>e.currentTarget.style.color="var(--c-text3,#45688a)"}><X size={14}/></button>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:".6rem",marginBottom:".6rem"}}>
              <Input label={tf.depFirstName} value={dep.firstName} onChange={e=>setDep(i,"firstName",e.target.value)} placeholder=""/>
              <Input label={tf.depMiddleName} value={dep.middleName||""} onChange={e=>setDep(i,"middleName",e.target.value)} placeholder=""/>
              <Input label={tf.depLastName} value={dep.lastName} onChange={e=>setDep(i,"lastName",e.target.value)} placeholder=""/>
            </div>
            {/* auto-fit: al anadir Sexo pasaron a ser cuatro campos en una
                rejilla de tres. */}
            <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(140px,1fr))",gap:".6rem",marginBottom:".6rem"}}>
              <div>
                <label className="dkt-input-lbl">{tf.depRelation}</label>
                <select className="dkt-inp" value={dep.relation} onChange={e=>setDep(i,"relation",e.target.value)}>
                  <option value="">--</option>
                  <option value="spouse">{lang==="es"?"Esposo/a":"Spouse"}</option>
                  <option value="child">{lang==="es"?"Hijo/a":"Child"}</option>
                  <option value="parent">{lang==="es"?"Padre/Madre":"Parent"}</option>
                  <option value="sibling">{lang==="es"?"Hermano/a":"Sibling"}</option>
                  <option value="other">{lang==="es"?"Otro":"Other"}</option>
                </select>
              </div>
              <Input label={`${tf.depDob}${ageLabelSuffix(dep.dob,lang==="es")}`} type="date" value={dep.dob} onChange={e=>setDep(i,"dob",e.target.value)}/>
              <div>
                <label className="dkt-input-lbl">{lang==="es"?"Sexo":"Sex"}</label>
                <select className="dkt-inp" value={dep.gender||""} onChange={e=>setDep(i,"gender",e.target.value)}>
                  <option value="">--</option>
                  <option value="Male">{lang==="es"?"Masculino":"Male"}</option>
                  <option value="Female">{lang==="es"?"Femenino":"Female"}</option>
                </select>
              </div>
              {/* CADA FAMILIAR, en su propia fila. Aqui es donde mas falta hace
                  de las tres: en un hogar es normal que los hijos tengan
                  Medicaid y los padres no. */}
              <PreguntaDeMedicaid value={dep.medicaid} onChange={e=>setDep(i,"medicaid",e.target.value)} lang={lang}/>
              <Input label={tf.depEmployer} value={dep.employer||""} onChange={e=>setDep(i,"employer",e.target.value)} placeholder={lang==="es"?"Empleador":"Employer"}/>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:".6rem",marginBottom:".6rem"}}>
              <Input label={tf.depPhone} value={dep.phone||""} onChange={e=>setDep(i,"phone",e.target.value)} onBlur={e=>setDep(i,"phone",formatPhoneUS(e.target.value))} placeholder={lang==="es"?"Opcional — si vacío usa el del titular":"Optional — defaults to head of household"}/>
              <Input label={tf.depEmail} type="email" value={dep.email||""} onChange={e=>setDep(i,"email",e.target.value)} error={!isEmailish(dep.email) ? (lang==="es"?"Correo inválido":"Invalid email") : undefined} placeholder={lang==="es"?"Opcional — si vacío usa el del titular":"Optional — defaults to head of household"}/>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:".6rem",marginBottom:".6rem"}}>
              <Input label={tf.depEmployerPhone} value={dep.employerPhone||""} onChange={e=>setDep(i,"employerPhone",e.target.value)} placeholder={lang==="es"?"Tel. empleador":"Employer phone"}/>
              <Input label={tf.depIncome} value={dep.income||""} onChange={e=>setDep(i,"income",e.target.value)} placeholder="$0"/>
              <ImmigrationSelect label={tf.depImmigration} value={dep.immigrationStatus||""} onChange={e=>setDep(i,"immigrationStatus",e.target.value)} lang={lang}/>
            </div>
            <div style={{marginBottom:".6rem"}}>
              <EmploymentFields type={dep.employmentType} desc={dep.employmentDesc}
                onType={v=>setDep(i,"employmentType",v)} onDesc={v=>setDep(i,"employmentDesc",v)} lang={lang}/>
              <OtrosIngresos principal={dep.income} lista={dep.otrosIngresos} onChange={v=>setDep(i,"otrosIngresos",v)} lang={lang}/>
            </div>
            <div style={{marginBottom:".6rem"}}>
              <ImmigrationDocsFields docs={dep.immigrationDocs} onChange={v=>setDep(i,"immigrationDocs",v)} lang={lang} status={dep.immigrationStatus}/>
            </div>
            <div style={{marginBottom:".6rem"}}>
              <GeneralIdFields data={dep} update={(k,v)=>setDep(i,k,v)} lang={lang}/>
            </div>
            <SSNField label={tf.depSSN} value={dep.ssn||""} hint={tf.ssnHint} ssnMasked={dep.ssnLast4?`***-**-${dep.ssnLast4}`:""} hasOnFile={!!dep.ssnLast4 || !!dep.ssn} lang={lang} clientId={client?.id} target="dependent" dependentId={dep.id} onSsnSaved={handleSsnSavedLocal}/>
            {/* Adult dependent (26+) → own coverage / separate profile. Coverage
                toggles were removed (Lissette 2026-07-27); this question no longer
                depends on any coverage toggle — it shows for ANY 26+ dependent with
                a name, so an aging-out child gets their own profile + enrollment. */}
            {isAdult&&dep.firstName&&dep.lastName&&(
              <div style={{marginTop:".6rem"}}>
                {dep.separateProfile||profileCreated[i] ? (
                  <div style={{display:"flex",alignItems:"center",gap:".4rem",fontSize:".7rem",color:"var(--c-green,#00ff88)",fontWeight:600,padding:".45rem .7rem",background:"rgba(0,255,136,.07)",border:"1px solid rgba(0,255,136,.2)",borderRadius:8}}>
                    <CheckCircle size={13}/>{lang==="es"?"Perfil independiente creado":"Separate profile created"} — {dep.firstName} {dep.lastName}
                    <span style={{color:"var(--c-text3,#45688a)",fontWeight:400,fontSize:".62rem"}}>{lang==="es"?"(aparece como cliente en el CRM)":"(appears as client in CRM)"}</span>
                  </div>
                ) : (
                  <div style={{background:"rgba(255,183,0,.06)",border:"1px solid rgba(255,183,0,.2)",borderRadius:8,padding:".5rem .7rem"}}>
                    <div style={{fontSize:".7rem",color:"var(--c-amber,#ffb700)",fontWeight:600,marginBottom:".4rem"}}>
                      ⚠️ {dep.firstName} {lang==="es"?`tiene ${calcAge(dep.dob)} años — ¿desea su propia cobertura (seguro aparte)?`:`is ${calcAge(dep.dob)} — do they want their own coverage (separate insurance)?`}
                    </div>
                    {dep.separateDecision===undefined&&(
                      <div style={{display:"flex",gap:".4rem"}}>
                        <button type="button" onClick={()=>setDep(i,"separateDecision",true)}
                          style={{flex:1,padding:".4rem .5rem",borderRadius:7,border:"1px solid rgba(0,212,255,.3)",background:"rgba(0,212,255,.06)",cursor:"pointer",fontFamily:"inherit",fontWeight:700,fontSize:".72rem",color:"var(--c-cyan,#00d4ff)"}}>
                          ✅ {lang==="es"?"Sí, perfil aparte":"Yes, separate"}
                        </button>
                        <button type="button" onClick={()=>setDep(i,"separateDecision",false)}
                          style={{flex:1,padding:".4rem .5rem",borderRadius:7,border:"1px solid rgba(255,183,0,.25)",background:"rgba(255,183,0,.05)",cursor:"pointer",fontFamily:"inherit",fontWeight:700,fontSize:".72rem",color:"var(--c-amber,#ffb700)"}}>
                          ➡️ {lang==="es"?"No, misma póliza":"No, same policy"}
                        </button>
                      </div>
                    )}
                    {dep.separateDecision===true&&(
                      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",gap:".5rem"}}>
                        <button type="button" onClick={()=>createSeparateProfile(dep,i)}
                          style={{display:"flex",alignItems:"center",gap:4,background:"linear-gradient(135deg,#0099cc,#0055aa)",border:"none",color:"#fff",fontSize:".72rem",fontWeight:700,padding:".38rem .8rem",borderRadius:7,cursor:"pointer",fontFamily:"inherit"}}>
                          <Plus size={12}/>{tf.createProfile}
                        </button>
                        <button type="button" onClick={()=>setDep(i,"separateDecision",undefined)} style={{background:"none",border:"none",cursor:"pointer",color:"var(--c-text3,#45688a)",fontSize:".65rem",fontFamily:"inherit"}}>✕ {lang==="es"?"Cambiar":"Change"}</button>
                      </div>
                    )}
                    {dep.separateDecision===false&&(
                      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                        <span style={{fontSize:".68rem",color:"var(--c-green,#00ff88)",fontWeight:600}}><CheckCircle size={11} style={{display:"inline",marginRight:3}}/>{lang==="es"?"Se mantiene en la póliza familiar":"Stays on family policy"}</span>
                        <button type="button" onClick={()=>setDep(i,"separateDecision",undefined)} style={{background:"none",border:"none",cursor:"pointer",color:"var(--c-text3,#45688a)",fontSize:".65rem",fontFamily:"inherit"}}>✕</button>
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}

          </div>
        );})}
        <button type="button" onClick={addDep} className="dkt-btn-s" style={{width:"100%",justifyContent:"center"}}>
          <Plus size={13}/>{tf.addDependent}
        </button>
        <div className="dkt-phase">
          💡 {lang==="es"?"Los miembros menores de 26 están incluidos en el grupo familiar. Los mayores de 26 pueden crear su propio perfil de cliente con póliza separada.":"Members under 26 are part of the family group. Those 26+ can create their own client profile with a separate policy."}
        </div>
      </>}
      {formTab==="salud"&&<>
        <S label={lang==="es"?"Salud / Legal / Demográficos":"Health / Legal / Demographics"} sub={lang==="es"?"Información requerida principalmente para cotización de pólizas de Vida y casos de inmigración.":"Information mainly used for Life policy underwriting and immigration cases."}/>
        <div className="dkt-phase" style={{marginBottom:".5rem"}}>
          🔒 {lang==="es"?"Los campos sensibles (licencia, DUI, condiciones médicas, historial familiar) se guardan encriptados (HIPAA) y cada lectura queda en el registro de auditoría.":"Sensitive fields (license, DUI, medical conditions, family history) are stored encrypted (HIPAA) and each read is recorded in the audit log."}
        </div>
        <FichaCard data={form} update={set} lang={lang} title={`${form.firstName||""} ${form.lastName||""}`.trim()||(lang==="es"?"Titular":"Primary")} icon="👤" accentColor="var(--c-cyan,#00d4ff)"/>
        {tienePareja(form.maritalStatus) && (
          <FichaCard data={form.spouse||{}} update={setSpouse} lang={lang} title={`${form.spouse?.firstName||""} ${form.spouse?.lastName||""}`.trim()||(lang==="es"?"Cónyuge":"Spouse")} icon="💍" accentColor="var(--c-green,#00ff88)"/>
        )}
        {form.dependents.length>0 && (
          <div style={{fontSize:".7rem",fontWeight:700,color:"var(--c-text3,#45688a)",textTransform:"uppercase",letterSpacing:".08em",fontFamily:"var(--font-mono)",marginTop:".5rem"}}>
            👨‍👩‍👧‍👦 {lang==="es"?"Dependientes":"Dependents"}
          </div>
        )}
        {form.dependents.map((dep,i)=>(
          <FichaCard
            key={dep.id||i}
            data={dep}
            update={(k,v)=>setDep(i,k,v)}
            lang={lang}
            title={`${dep.firstName||""} ${dep.lastName||""}`.trim()||`${lang==="es"?"Miembro":"Member"} #${i+1}`}
            icon="🧒"
            accentColor="var(--c-amber,#ffb700)"
          />
        ))}
        {form.dependents.length===0 && !tienePareja(form.maritalStatus) && (
          <div style={{fontSize:".7rem",color:"var(--c-text3,#45688a)",fontStyle:"italic",marginTop:".25rem"}}>
            💡 {lang==="es"?"Agrega cónyuge en Hogar o dependientes en Familia para verlos también aquí.":"Add a spouse in Household or dependents in Family to also list them here."}
          </div>
        )}
      </>}

      {/* MEDICARE — los tres datos que son de la PERSONA, no de la poliza.
          El MBI, la fecha de Parte A y la de Parte B ya existian en la poliza,
          pero un cliente con un Medicare Advantage y un Part D tiene UN solo
          MBI: tecleado en cada poliza son dos sitios donde escribirlo, dos
          donde equivocarse, y ninguno que conteste "¿cual es el MBI de esta
          señora?". Aqui viven en la ficha, y la poliza los toma de aqui.

          Se guardan en `customValues` con claves reservadas: ya va cifrado (el
          MBI es un identificador sanitario), no hace falta migracion, y no
          puede chocar con una pestaña de la agencia, cuyos campos llevan id
          `cf_<aleatorio>`. La regla vive en crm-app/medicareDelCliente.js. */}
      {formTab==="medicare"&&<>
        <S label={lang==="es"?"⭐ Medicare":"⭐ Medicare"} sub={lang==="es"
          ?"El numero y las fechas son de la PERSONA, no de cada poliza. Lo que se escriba aqui se copia solo a las polizas de Medicare del cliente que todavia lo tengan vacio."
          :"The number and dates belong to the PERSON, not to each policy. What you type here auto-fills the client's Medicare policies that still have it blank."}/>
        <div className="dkt-phase" style={{marginBottom:".5rem"}}>
          🔒 {lang==="es"
            ?"El N° de Medicare se guarda encriptado y cada lectura queda en el registro de auditoria (HIPAA)."
            :"The Medicare number is stored encrypted and every read is recorded in the audit log (HIPAA)."}
        </div>
        <div className="grid grid-cols-3 gap-3">
          {CAMPOS_DE_MEDICARE.map((c)=>(
            <div key={c.clave}>
              <label className="dkt-input-lbl">{lang==="es"?c.es:c.en}</label>
              <input className="dkt-inp" type={c.tipo}
                value={(form.customValues||{})[c.clave]||""}
                placeholder={c.ejemplo||undefined}
                onChange={(e)=>set("customValues",{...(form.customValues||{}),[c.clave]:e.target.value})}/>
            </div>
          ))}
        </div>
      </>}
      {formTab.startsWith("custom_")&&formTab!=="custom_new"&&<>
        <S label={lang==="es"?"Pestaña personalizada":"Custom tab"} sub={lang==="es"?"Edita los campos de esta pestaña (compartidos con todos los clientes) y los valores de este cliente.":"Edit this tab's fields (shared with all clients) and this client's values."}/>
        <div className="dkt-phase" style={{marginBottom:".5rem"}}>
          🔒 {lang==="es"?"El contenido de estas pestañas se guarda encriptado (HIPAA) por si incluye datos sensibles.":"The contents of these tabs are stored encrypted (HIPAA) in case they include sensitive data."}
        </div>
        <CustomTabsEditor defs={customTabDefs||[]} values={form.customValues||{}} singleId={formTab.slice(7)} onAfterRemoveTab={()=>setFormTab("salud")} onDefsChange={(next)=>onCustomTabDefsChange&&onCustomTabDefsChange(next)} onValuesChange={(next)=>set("customValues",next)} lang={lang}/>
      </>}
      {/* The "Referido" tab was removed here (2026-06-17) — referrals now live
          on the client profile (button next to Print). The form still carries
          form.refFirstName/refLastName/refPhone in state so any inbound
          referral already on the record round-trips on save untouched. */}
      <div style={{display:"flex",gap:".5rem",paddingTop:".5rem",borderTop:"1px solid var(--c-border,#1a3550)",marginTop:".25rem"}}>
        <button type="button" onClick={submitForm} disabled={savingForm||hydrating} className="dkt-btn-p" style={{flex:1,justifyContent:"center",opacity:(savingForm||hydrating)?.7:1}}><Save size={14}/>{savingForm?(lang==="es"?"Guardando…":"Saving…"):hydrating?(lang==="es"?"Cargando perfil…":"Loading profile…"):tf.save}</button>
        <button type="button" onClick={onClose} className="dkt-btn-s">{tf.cancel}</button>
      </div>
    </form>
  </div>;
}
/* ─── Eligibility PDF Parser & Alerts Tab ─── */
function Clients({ clients, policies, docs, tasks, signatures, requests, onRequestsChange, activitylog, onClientsChange, onPoliciesChange, onDocsChange, onTasksChange, onActivityLog, clientNotes, noteStamps, onClientNotesChange, users, currentUser, changeHistory, onChangeHistory, docTemplates, eligibilityAlerts, onEligibilityAlertsChange, followups=[], onFollowupsChange, tickets=[], onSaveTicket, onAddTicketMessage, onEditTicketMessage, onDeleteTicketMessage, onDeleteTicket, onNotifyTicketClient, loadClientDocs, ticketEmailOnOpen={}, ticketEmailOnResolve={}, seatLabels={}, onSeatLabelsChange, ticketStatuses=[], ticketTypes=[], customTabDefs=[], onCustomTabDefsChange, tagColors={}, onTagColorsChange, tagLibrary=[], onTagLibraryChange, policyTagLibrary=[], onPolicyTagLibraryChange, policyTagColors={}, onPolicyTagColorsChange, clientsServerTotal=null, onClientsServerTotalChange, clientsLoaded=false, agencySettingsLoaded=false, onFichaAbierta, userPrefs={}, t, lang }) {
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useStickyFilter("deskte:cli:status");
  const [stateFilter, setStateFilter] = useStickyFilter("deskte:cli:state");
  const [cityFilter, setCityFilter] = useStickyFilter("deskte:cli:city");
  const [countyFilter, setCountyFilter] = useStickyFilter("deskte:cli:county");
  // Varias aseguradoras a la vez (Lissette 2026-08-28). Lista vacia = todas.
  const [carrierFilter, setCarrierFilter] = useStickyFilterList("deskte:cli:carrier");
  // Policy-type filter (frontend ids: "aca", "auto", "home", ...). "all"
  // disables the filter. Match logic: client included if any of their
  // policies has the selected type.
  const [policyTypeFilter, setPolicyTypeFilter] = useStickyFilter("deskte:cli:polType");
  const [agentFilter, setAgentFilter] = useStickyFilter("deskte:cli:agent");
  // Custom-tag filter (Lissette 2026-06-22): include a client when they carry
  // the selected tag. "all" disables it.
  const [tagFilter, setTagFilter] = useStickyFilter("deskte:cli:tag");
  const [attendFilter, setAttendFilter] = useStickyFilter("deskte:cli:attend"); // "Atiende" (seat) filter
  // Estatus migratorio (Lissette 2026-09-15). La regla y el conteo viven en
  // crm-app/estatusMigratorio.js, que es el unico sitio donde se escribe este
  // catalogo -- ya se separo tres veces y por eso esta alli (queja 11).
  const [immigFilter, setImmigFilter] = useStickyFilter("deskte:cli:immig");
  // Idioma del cliente (Lissette 2026-09-30). Se lee con idiomaDelCliente, que
  // entiende las dos formas del campo (preferredLanguage 'es'|'en' y
  // preferredLang 'spanish'|'english'); sin idioma cuenta como ingles, que es
  // lo que guarda el servidor por defecto.
  const [langFilter, setLangFilter] = useStickyFilter("deskte:cli:lang");
  // Ordenamiento: por nombre (A→Z / Z→A) o por fecha de alta del cliente
  // ("Recién agregados" / "Más antiguos"). createdAt es ISO, así que el
  // orden lexicográfico coincide con el cronológico.
  const [sortMode, setSortMode] = useState("name-asc");
  // Pagination — render the client cards in pages of N so a 500-client
  // agency doesn't have to scroll a 30-screen list to reach the page
  // footer / sign-out. Page size is user-pickable (25 / 50 / 100 / 200,
  // default 25). Lissette feedback after the initial 50 default: even
  // 50 left her scrolling to reach the footer; 25 fits one screen with
  // room for the page controls. The selection and current page persist
  // across navigation so an agent who's on page 7 stays there if they
  // pop into a detail and back.
  const [pageSize, setPageSize] = useState(() => {
    try {
      const stored = parseInt(prefsGet("deskte:clientsPageSize"), 10);
      return [25, 50, 100, 200].includes(stored) ? stored : 25;
    } catch { return 25; }
  });
  const [page, setPage] = useState(1);
  const [modal, setModal] = useState(null);
  // Seeds the Add-Client form when opened from elsewhere (e.g. the
  // commissions "+Cliente" button) via window.__magAddClient.
  const [addPrefill, setAddPrefill] = useState(null);
  const [detail, setDetail] = useState(null);
  // Optimistic-concurrency conflict ("no te piso"): set when a save is rejected
  // because someone else edited the same client first. Holds the form the user
  // tried to save + the client id so we can offer "recargar y ver" or "guardar
  // de todos modos" (a forced overwrite). { form, modalId } | null.
  const [staleConflict, setStaleConflict] = useState(null);
  // Scroll-to-top when opening a client detail. The parent's `view` state
  // stays "clients" the whole time (the detail is a sub-state of the
  // Clients screen), so the parent's view-scoped scroll-to-top
  // useEffect never fires for list→detail navigation. Without this,
  // clicking a client at the bottom of a long list leaves the detail
  // page scrolled to the same y-offset (Lissette 2026-05-20). Guard on
  // detail?.id so a no-op set (re-render with the same client) doesn't
  // jump unexpectedly.
  useEffect(() => {
    if (!detail?.id) return;
    if (typeof window === 'undefined') return;
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [detail?.id]);
  // Restore the last-viewed client across a hard refresh: when clients hydrate
  // and we're on the Clients view with nothing selected, try to open the one
  // the user was looking at before the reload. Idempotent — runs again if
  // clients reload but the saved id no longer matches anything.
  useEffect(() => {
    if (detail) return;
    // When the user clicks the "Clients" sidebar tab we want the LIST, not the
    // last client they had open. The nav button sets this flag; honoring it
    // here skips the restore. A genuine page refresh never sets the flag, so
    // refreshing while viewing a client still lands back on that client.
    if (typeof window !== "undefined" && window.__deskteSkipClientRestore) {
      window.__deskteSkipClientRestore = false;
      try { prefsRemove("deskte:lastClientId"); } catch {}
      return;
    }
    if (!Array.isArray(clients) || clients.length === 0) return;
    // Prefer the URL hash (#client/<id>): it survives a hard refresh even when
    // localStorage is blocked or stale (e.g. inside the installed PWA), so the
    // agent lands back on the SAME client after pressing refresh. Fall back to
    // the persisted lastClientId for an app relaunch where the start_url dropped
    // the hash (Lissette 2026-06-17: "cuando actualizo se sale, no regresa donde
    // estaba").
    let savedId = null;
    try {
      const h = (window.location.hash || "").replace(/^#/, "");
      if (h.startsWith("client/")) savedId = h.slice("client/".length);
    } catch {}
    if (!savedId) { try { savedId = prefsGet("deskte:lastClientId"); } catch {} }
    if (!savedId) return;
    const found = clients.find((c) => c.id === savedId);
    if (!found) return;
    setDetail(found);
    // Keep the hash pointing at the restored client (when we restored from
    // prefs the hash may be absent) so a further refresh / Back stays consistent.
    try {
      if (typeof window !== "undefined" && found.id && !(window.location.hash || "").startsWith("#client/" + found.id)) {
        window.history.replaceState(null, "", "#client/" + found.id);
      }
    } catch {}
    // Hydrate with the full record — same as openDetail. Without this the
    // restored profile renders from list data only, which omits
    // maritalStatus, address/zip, income, immigration AND the F4 ficha, so
    // the page looked "blank" after every refresh even though the data was
    // saved (Lissette 2026-05-28: "cuando refresco la vista del perfil se
    // borra, pero en Editar están los datos").
    const apiMode = typeof window !== "undefined" && !!window.__deskteAuth;
    if (apiMode && found.id) {
      apiGetClient(found.id)
        .then((full) => setDetail((prev) => (prev?.id === found.id ? { ...prev, ...full } : prev)))
        .catch(() => { /* non-fatal: list data already rendered */ });
    }
  }, [clients?.length]);
  // Persist current client selection so the next refresh can land on the same
  // detail page. Clearing detail (back to list) also clears the marker.
  useEffect(() => {
    try {
      if (detail?.id) prefsSet("deskte:lastClientId", detail.id);
      else prefsRemove("deskte:lastClientId");
    } catch {}
  }, [detail?.id]);
  const [insuredPopup, setInsuredPopup] = useState(null); // clientId
  const [delConfirm, setDelConfirm] = useState(null);
  const [showDuplicates, setShowDuplicates] = useState(false);
  const [showTrash, setShowTrash] = useState(false);
  const [showExportHistory, setShowExportHistory] = useState(false);
  // Exportar pide el PIN: "excel" | "csv" abre el cuadro; null lo cierra.
  const [exportarFormato, setExportarFormato] = useState(null);
  const puedeExportarClientes = currentUser?.role !== "assistant"
    || hasSeatPermission(normalizeSeatPermissions(currentUser?.seatPermissions), "clients.export");
  // Bulk selection: Set of clientIds currently checked. Cleared whenever
  // the filter set changes so the count + "delete N" button always reflect
  // what's actually visible. The bulk delete progress overlay reuses this.
  const [selectedIds, setSelectedIds] = useState(() => new Set());
  const [bulkDelConfirm, setBulkDelConfirm] = useState(false);
  // Quitar una etiqueta en masa (ticket de German Pomares, 2026-10-22):
  // { ids:[...] } de los seleccionados, o { ids:null, inicial } de todos.
  const [quitarEtq, setQuitarEtq] = useState(null);
  const [labelsOpen, setLabelsOpen] = useState(false); // etiquetas de correo
  const [bulkProgress, setBulkProgress] = useState({
    active: false,
    current: 0,
    total: 0,
    currentLabel: '',
    succeeded: 0,
    failed: [],
  });
  // Sidebar click on "Clients" should always drop us back to the list, even
  // when we're already in this view with a client detail open.
  // La barra de fichas abiertas de arriba. Un solo efecto sobre `detail` cubre
  // TODOS los caminos que abren una ficha —el boton Ver, un enlace desde otro
  // modulo, el #client/<id> al cargar—; avisar desde cada sitio que llama a
  // setDetail habria dejado alguno fuera sin que se notara.
  useEffect(()=>{
    if(!onFichaAbierta) return;
    onFichaAbierta(detail?.id?detail:null);
  },[detail?.id,detail?.firstName,detail?.lastName,onFichaAbierta]);
  // Cerrar la pestaña del cliente abierto cierra tambien su ficha... salvo que
  // haya un formulario abierto: ahi se queda como esta, porque cerrarlo se
  // llevaria por delante lo que la persona estuviera escribiendo.
  useEffect(()=>{
    const h=(e)=>{
      if(modal) return;
      const id=e?.detail?.id;
      if(!detail) return;
      if(id && detail.id!==id) return;
      setDetail(null);
      // Y hay que quitar el #client/<id> de la direccion. `openDetail` lo
      // guarda ahi para que el boton Atras del navegador funcione, y al
      // arrancar la aplicacion se restaura la ficha desde el. Cerrando solo la
      // ficha, la direccion se quedaba apuntando al cliente y al recargar
      // volvia a abrirse — la pestaña cerrada reaparecia sola (Lissette
      // 2026-08-21: "la cierro y cuando recargo vuelve a aparecer").
      try { if((window.location.hash||"").startsWith("#client/")) window.history.replaceState(null,"","#clients"); } catch {}
    };
    window.addEventListener("deskte:cerrar-ficha",h);
    return ()=>window.removeEventListener("deskte:cerrar-ficha",h);
  },[modal,detail]);
  useEffect(()=>{
    const h=(e)=>{ if(e?.detail?.view==="clients"){ setDetail(null); setModal(null); setInsuredPopup(null); setDelConfirm(null);
      // Clicking the "Clients" tab means "show me the list" — drop the
      // #client/<id> hash so a later refresh lands on the list, not the last
      // client (the hash is the source of truth for the refresh-restore above).
      try { if((window.location.hash||"").startsWith("#client/")) window.history.replaceState(null,"","#clients"); } catch {} } };
    window.addEventListener("deskte:nav-reset",h);
    return ()=>window.removeEventListener("deskte:nav-reset",h);
  },[]);
  // Browser Back from an open client detail (#client/<id>) → close the detail
  // and return to the list, instead of jumping to the previous view.
  useEffect(()=>{
    if (typeof window === "undefined") return;
    const onPop = () => { if (!(window.location.hash || "").startsWith("#client/")) setDetail(d => d ? null : d); };
    window.addEventListener("popstate", onPop);
    return ()=>window.removeEventListener("popstate", onPop);
  },[]);
  // Opens the client detail with an immediate render from list data, then
  // hydrates with the full record from GET /clients/:id. The list endpoint
  // omits SSN-related fields by design (no bulk decrypt, audit-friendly),
  // so without this second fetch the detail view never shows ssnMasked.
  const isApiMode = typeof window !== "undefined" && !!window.__deskteAuth;
  const openDetail = useCallback((c) => {
    if (!c) return;
    setDetail(c);
    // Push a #client/<id> history entry so the browser Back button returns to
    // the list (instead of jumping to the previous view / exiting).
    try {
      if (typeof window !== "undefined" && c.id && !(window.location.hash || "").startsWith("#client/" + c.id)) {
        window.history.pushState(null, "", "#client/" + c.id);
      }
    } catch {}
    if (isApiMode && c.id) {
      apiGetClient(c.id)
        .then((full) => {
          setDetail((prev) => (prev?.id === c.id ? { ...prev, ...full } : prev));
        })
        .catch(() => {
          // Non-fatal: user already sees the partial data from the list.
          // SSN pill simply won't appear until they reopen the client.
        });
    }
  }, [isApiMode]);
  const tc = t.clients;
  // Estados presentes en la cartera, AGRUPADOS por clave: "fl", "FL" y
  // "Florida" son el mismo estado y antes salían como tres opciones. Cada
  // opción lleva su cuenta, y aparte se cuenta cuántas fichas no tienen
  // estado ninguno.
  //
  // Javier Volcanes, 2026-08-28: *"cuando quiere filtrar por estado solo le
  // sale TX, y verificas su dirección y sí tiene estados"*. El desplegable no
  // mentía: su cartera entró con la dirección entera en una casilla, así que
  // la columna Estado estaba vacía en casi toda la cartera y no había más
  // estados que ofrecer. Un filtro que ofrece una sola opción no puede
  // limitarse a callar — ahora dice cuántas fichas se quedan fuera y deja
  // filtrarlas para arreglarlas (Importar → "Recuperar direcciones"). E-146.
  const allStates = useMemo(() => {
    const porClave = new Map();
    for (const c of clients) {
      const k = claveEstado(c.addressState);
      if (!k) continue;
      const prev = porClave.get(k);
      if (prev) prev.count++;
      else porClave.set(k, { key: k, count: 1 });
    }
    return [...porClave.values()].sort((a, b) => a.key.localeCompare(b.key));
  }, [clients]);
  const clientesSinEstado = useMemo(
    () => clients.reduce((n, c) => (claveEstado(c.addressState) ? n : n + 1), 0),
    [clients],
  );
  // Los filtros se quedan puestos por persona (useStickyFilter), así que uno
  // puede sobrevivir a los datos que lo justificaban: eliges "Sin estado",
  // arreglas las direcciones, y al volver el desplegable ya no tiene esa
  // opción — se queda en blanco y esconde la cartera entera sin decir por qué.
  // Si el valor guardado ya no existe, se vuelve a "Todo Estado".
  // El `clients.length > 0` es imprescindible: antes de que cargue la lista
  // NADA existe, y sin esa guarda se borraría el filtro en cada arranque.
  useEffect(() => {
    if (!clients.length || stateFilter === "all") return;
    const sigueExistiendo = stateFilter === SIN_ESTADO
      ? clientesSinEstado > 0
      : allStates.some(s => s.key === claveEstado(stateFilter));
    if (!sigueExistiendo) setStateFilter("all");
  }, [clients.length, stateFilter, allStates, clientesSinEstado]);
  // Ciudad y condado (Lissette 2026-08-17). Se sacan de los clientes que hay,
  // no de una lista fija: cada agencia trabaja su zona y una lista de los 67
  // condados de Florida sería casi toda ruido. Si nadie tiene condado escrito,
  // el desplegable no se pinta — un filtro que siempre da cero no ayuda, marea.
  const allCities = useMemo(() => [...new Set(clients.map(c => (c.addressCity || c.city || '').trim()).filter(Boolean))].sort((a,b)=>a.localeCompare(b, undefined, { sensitivity:'base' })), [clients]);
  const allCounties = useMemo(() => [...new Set(clients.map(c => (c.county || '').trim()).filter(Boolean))].sort((a,b)=>a.localeCompare(b, undefined, { sensitivity:'base' })), [clients]);
  const allCarriers = useMemo(() => [...new Set(policies.map(p => p.carrier).filter(Boolean))].sort(), [policies]);
  const allAssignedAgents = useMemo(() => [...new Set(clients.map(c => c.assignedAgent || c.agentName).filter(Boolean))].sort(), [clients]);
  // Etiquetas del cliente, con cuantos hay en cada una y cuantos no tienen
  // ninguna. La cuenta y la comparacion viven en filtroDeEtiquetas.js, que es
  // el mismo que usa Polizas.
  const tagCounts = useMemo(() => contarEtiquetas(clients), [clients]);
  // Las opciones del filtro de estatus migratorio, con cuantas fichas hay
  // detras de cada una: un filtro que dice el numero evita el clic a ciegas
  // que no devuelve nada.
  const immigCounts = useMemo(() => contarEstatusMigratorio(clients, lang === "es"), [clients, lang]);
  const langCounts = useMemo(() => {
    const n = { es: 0, en: 0 };
    for (const c of clients) n[idiomaDelCliente(c, "en")]++;
    return n;
  }, [clients]);
  // Options for the per-row "Agente asignado" editor: registered agents + any
  // custom values already used across clients (reusable).
  const agentPickOptions = useMemo(() => {
    const team = (users || []).filter(u => ["agency_owner", "agency_admin", "agent", "solo_agent"].includes(u.role)).map(u => u.name);
    return [...new Set([...team, ...allAssignedAgents].filter(Boolean))].sort();
  }, [users, allAssignedAgents]);
  // Per-row assigned-agent inline editing.
  const [editingAgentId, setEditingAgentId] = useState(null);
  const [agentDraft, setAgentDraft] = useState("");
  const saveCardAgentValue = async (clientId, raw) => {
    const val = (raw || "").trim();
    const cur = clients.find(x => x.id === clientId);
    setEditingAgentId(null);
    if (!cur || val === (cur.assignedAgent || "")) return;
    try {
      if (typeof window !== "undefined" && window.__deskteAuth) await apiSetClientAssignedAgent(clientId, val);
      onClientsChange(prev => prev.map(x => x.id === clientId ? { ...x, assignedAgent: val } : x));
    } catch (e) { alert((lang === "es" ? "No se pudo guardar el agente: " : "Failed to save agent: ") + (e.message || e)); }
  };
  const saveCardAgent = (clientId) => saveCardAgentValue(clientId, agentDraft);
  // Policy types in use across this agency's policies, with friendly label
  // and icon for the dropdown. Sorted by label so the menu order is stable.
  const allPolicyTypes = useMemo(() => {
    // Los que ESTAN EN USO, mas los que la agencia se creo aunque todavia no
    // tengan ni una poliza. Wendy Cercio (Insurance Latino), 2026-09-11: creo
    // "Seguro Privado" e "Internacional"; el primero salia aqui (alguna poliza
    // ya lo usaba) y el segundo no, porque esta lista se sacaba SOLO de las
    // polizas. Un tipo recien creado no tiene ninguna, asi que la pantalla
    // parecia decir que no se habia guardado. Los de fabrica se siguen
    // enseñando solo si hay pólizas: son veintitantos y llenarian el filtro de
    // opciones que no llevan a ninguna parte; el propio, en cambio, lo escribio
    // alguien a proposito hace un momento y su ausencia es justo lo que asusta.
    const ids = [...new Set([
      ...policies.map(p => p.type).filter(Boolean),
      ...tiposPropiosDeLaAgencia().map(pt => pt.id),
    ])];
    return ids
      .map(id => {
        const pt = getPolicyType(id);
        return { id, label: lang === "es" ? (pt.labelEs || pt.label) : pt.label, icon: pt.icon };
      })
      .sort((a, b) => a.label.localeCompare(b.label));
    // `agencySettingsLoaded` va en las dependencias a proposito: los tipos
    // propios NO son estado de React, viven en el catalogo compartido que se
    // llena al arrancar desde los ajustes de la agencia. Sin esa dependencia,
    // esta lista podria quedarse con la foto de antes de que llegaran — y un
    // tipo que no cargo parece un tipo que no existe.
  }, [policies, lang, agencySettingsLoaded]);
  // Index policies by clientId ONCE so the search filter below is O(clients),
  // not O(clients × policies). With ~1.9k clients × ~1.8k policies the old
  // per-client `policies.filter` ran ~3.4M comparisons on EVERY keystroke,
  // which made the search box lag so badly it felt broken (Lissette
  // 2026-06-30 "no funciona la búsqueda"). The map makes each lookup O(1).
  const policiesByClient = useMemo(() => {
    const m = new Map();
    for (const p of policies) {
      const arr = m.get(p.clientId);
      if (arr) arr.push(p); else m.set(p.clientId, [p]);
    }
    return m;
  }, [policies]);
  // Indice por id para resolver el nombre de quien refirio a cada cliente sin
  // un clients.find por fila (Lissette 2026-08-28). Mismo motivo que el de
  // arriba: con carteras de miles, un barrido por fila se nota al escribir.
  const clientesPorId = useMemo(() => new Map((clients || []).map(c => [c.id, c])), [clients]);
  // Perf: index the "freshness" source arrays by clientId ONCE, mirroring
  // policiesByClient above. Without this, the per-row `totalNewForClient`
  // in the list re-filtered EIGHT full agency arrays (incl. the large
  // activitylog / changeHistory audit logs) for EVERY visible row on every
  // render/keystroke — O(pageSize x totalRows). The biggest tenant (most
  // activity) froze the list. Maps make each row O(itsOwnItems).
  const freshIndex = useMemo(() => {
    const groupBy = (arr, keyFn) => {
      const m = new Map();
      for (const it of (arr || [])) {
        const k = keyFn(it);
        if (k == null) continue;
        const a = m.get(k);
        if (a) a.push(it); else m.set(k, [it]);
      }
      return m;
    };
    // Marcas primero, notas completas despues: si una nota esta en las dos,
    // gana la completa.
    const unirPorId = (marcas, completas) => {
      const porId = new Map();
      for (const n of (marcas || [])) if (n && n.id) porId.set(n.id, n);
      for (const n of (completas || [])) if (n && n.id) porId.set(n.id, n);
      return Array.from(porId.values());
    };
    // activitylog rows belong to a client via entityId OR clientId — index
    // under both keys (deduped) so a lookup matches the same rows the old
    // `a.entityId === id || a.clientId === id` filter returned.
    const actMap = new Map();
    for (const a of (activitylog || [])) {
      if (!a) continue;
      const push = (k) => { if (k == null) return; const arr = actMap.get(k); if (arr) arr.push(a); else actMap.set(k, [a]); };
      push(a.entityId);
      if (a.clientId != null && a.clientId !== a.entityId) push(a.clientId);
    }
    return {
      docs: groupBy(docs, d => d.clientId),
      signatures: groupBy(signatures, s => s.clientId),
      tasks: groupBy(tasks, t => t.clientId),
      eligibilityAlerts: groupBy(eligibilityAlerts, e => e.clientId),
      changeHistory: groupBy(changeHistory, h => h.clientId),
      // Las marcas del arranque + las notas completas que ya se abrieron o
      // llegaron en vivo, sin repetir: una nota cuenta una vez.
      clientNotes: groupBy(unirPorId(noteStamps, clientNotes), n => n.clientId),
      activitylog: actMap,
    };
  }, [docs, signatures, tasks, eligibilityAlerts, changeHistory, clientNotes, noteStamps, activitylog]);
  // Perf: clients with >=1 required-but-unuploaded doc, computed once
  // instead of `docs.filter(...)` per row on every render.
  const clientsWithMissingDocs = useMemo(() => {
    const s = new Set();
    for (const d of (docs || [])) {
      if (d && d.required && !d.uploadedAt && d.clientId != null) s.add(d.clientId);
    }
    return s;
  }, [docs]);
  const filtered = useMemo(() => {
    // Tokenized + accent-insensitive. The old code lowercased the query and
    // asked whether the glued-together fields CONTAINED it as one contiguous
    // substring — so "julio" found the client but "julio perez" found nobody
    // ("Julio Pérez" has an accent, "Julio Cesar Perez" has a word in between,
    // and "Perez, Julio" is the wrong order). Lissette 2026-07-21.
    const qTokens = searchTokens(search);
    return clients.filter(c => {
    const clientPolicies = policiesByClient.get(c.id) || [];
    const clientPolicyCarriers = clientPolicies.map(p => p.carrier).join(" ");
    // Spouse + dependent names so searching a family member's name still finds
    // the PRINCIPAL's row (Lissette 2026-06-29: a policy is often under a
    // spouse/dependent — e.g. dental/vision — so the agent types that name).
    // Spouse lives NESTED under c.spouse ({firstName, middleName, lastName}) —
    // the same shape used everywhere else (birthday alerts, household members).
    // The old flat c.spouseFirstName/... fields don't exist on the client, so
    // searching by the spouse's name never matched (dependents did, because
    // c.dependents[].firstName IS correct). Keep the flat fields as a harmless
    // fallback for any legacy row. (Lissette 2026-06-30: "por spouse no sale")
    // clientSearchHaystack covers the person (incl. middleName, which the old
    // string forgot), spouse and dependents; the carriers ride along as extra.
    const matchSearch = matchesAllTokens(clientSearchHaystack(c, clientPolicyCarriers), qTokens);
    const matchStatus = statusFilter === "all" || c.status === statusFilter;
    // Se compara por CLAVE, no por texto: "fl", "FL" y "Florida" son el mismo
    // estado y antes contaban como tres opciones distintas. SIN_ESTADO saca
    // justo las fichas a las que nunca se les rellenó la casilla — que es como
    // se encuentra lo que hay que arreglar en vez de adivinarlo (E-146).
    const matchState = stateFilter === "all"
      || (stateFilter === SIN_ESTADO
        ? !claveEstado(c.addressState)
        : claveEstado(c.addressState) === claveEstado(stateFilter));
    // Se comparan recortados y sin distinguir mayúsculas: la ciudad la escribe
    // quien importa, y "Miami " y "miami" son la misma ciudad.
    const matchCity = cityFilter === "all" || (c.addressCity || c.city || "").trim().toLowerCase() === cityFilter.toLowerCase();
    const matchCounty = countyFilter === "all" || (c.county || "").trim().toLowerCase() === countyFilter.toLowerCase();
    // Company + policy-type filter. When BOTH are set, a SINGLE policy must match
    // both — otherwise a client with e.g. "Ambetter health" + "Florida Blue
    // dental" wrongly matched "Ambetter + dental" because the two checks were
    // independent (Lissette 2026-06-19 #8). When only one is set, any policy with
    // that attribute counts.
    // La aseguradora es ahora una LISTA (vacia = todas), pero la regla de que
    // una SOLA poliza tiene que cumplir las dos condiciones no cambia.
    // Con el estado "Activo" elegido, la poliza que cumple aseguradora/tipo
    // tambien tiene que estar viva (ticket de Jheraldin, filtroDeClientesPorPoliza.js).
    const matchPolicy = pasaElFiltroDePoliza(clientPolicies, {
      aseguradoras: carrierFilter, tipo: policyTypeFilter, soloVivas: statusFilter === "active",
    });
    const matchAgent = agentFilter === "all" || (c.assignedAgent || c.agentName || "") === agentFilter;
    const matchTag = pasaElFiltroDeEtiqueta(c, tagFilter);
    const matchImmig = pasaElFiltroDeEstatusMigratorio(c, immigFilter);
    // Incluye los nombres que trajo una importacion y que aun no son asiento
    // (filtro "txt:<nombre>"), y cuenta como "sin asignar" solo al que no tiene
    // ni asiento ni nombre.
    const matchAttend = pasaElFiltroDeAtiende(c, attendFilter);
    const matchLang = !langFilter || langFilter === "all" || idiomaDelCliente(c, "en") === langFilter;
    return matchSearch && matchStatus && matchState && matchCity && matchCounty && matchPolicy && matchAgent && matchTag && matchAttend && matchImmig && matchLang;
    });
  }, [clients, policiesByClient, search, statusFilter, stateFilter, cityFilter, countyFilter, carrierFilter, policyTypeFilter, agentFilter, tagFilter, attendFilter, immigFilter, langFilter]);
  const sorted = [...filtered].sort((a,b) => {
    if (sortMode === "created-desc" || sortMode === "created-asc") {
      const cmp = String(a.createdAt || "").localeCompare(String(b.createdAt || ""));
      return sortMode === "created-desc" ? -cmp : cmp;
    }
    // Se ordena por el MISMO texto que pinta la fila -formatClientName, que ya
    // conoce la preferencia: "Nombre Apellido" ordena por el nombre, "Apellido,
    // Nombre" por el apellido-. Esto vivia aqui escrito a mano, y desde el
    // 2026-09-15 la lista de Polizas tambien ordena por cliente: con una copia
    // en cada pantalla, el dia que la preferencia gane una opcion una de las
    // dos se entera y la otra no. La regla esta en crm-app/ordenPorCliente.js.
    return compararNombresDeCliente(a, b, sortMode === "name-desc" ? "desc" : "asc", undefined, lang === "es");
  });
  // Pagination slice. totalPages defaults to 1 so the "Page X of Y"
  // footer never shows "Page 1 of 0" on an empty filter. clamp the
  // current page if the filter shrank past the end (e.g. user was on
  // page 8, narrowed the search, now there are only 3 pages).
  const totalPages = Math.max(1, Math.ceil(sorted.length / pageSize));
  useEffect(() => {
    if (page > totalPages) setPage(totalPages);
  }, [totalPages, page]);
  // Reset to page 1 whenever the active filter set changes — staying on
  // page 7 of an unrelated filter result is more surprising than
  // restarting from the top.
  useEffect(() => {
    setPage(1);
  }, [search, statusFilter, stateFilter, cityFilter, countyFilter, carrierFilter, policyTypeFilter, agentFilter, tagFilter, attendFilter, immigFilter, langFilter, pageSize]);
  // Persist the user's chosen page size so refreshing the app doesn't
  // bounce them back to 50.
  useEffect(() => {
    try { prefsSet("deskte:clientsPageSize", String(pageSize)); } catch {}
  }, [pageSize]);
  const pageStart = (page - 1) * pageSize;
  const paginated = sorted.slice(pageStart, pageStart + pageSize);
  const counts = useMemo(() => ({
    all: clients.length,
    active: clients.filter(c => c.status === "active").length,
    pending: clients.filter(c => c.status === "pending").length,
    inactive: clients.filter(c => c.status === "inactive").length,
    prospect: clients.filter(c => c.status === "prospect").length,
    referral: clients.filter(c => c.status === "referral").length,
  }), [clients]);
  const CLIENT_LABELS = {
    firstName:"Nombre",lastName:"Apellido",phone:"Teléfono",email:"Email",
    dob:"Fecha Nac.",ssn:"SSN",addressStreet:"Dirección",addressCity:"Ciudad",
    addressState:"Estado",addressZip:"ZIP",annualIncome:"Ingresos",
    employer:"Empleador",immigrationStatus:"Estatus Migratorio",notes:"Notas",status:"Estado"
  };
  const POLICY_LABELS = {
    carrier:"Compañía",plan:"Plan",policyNumber:"# Póliza",memberId:"Member ID",
    monthlyPremium:"Prima",familySize:"Familia",membersActive:"Miembros Activos",
    effectiveDate:"Fecha Inicio",renewalDate:"Fecha Renovación",status:"Estado",
    coverageType:"Tipo Cobertura",deductible:"Deducible",liabilityCoverage:"Responsabilidad",
    vehicleYear:"Año Vehículo",vehicleMake:"Marca",vehicleModel:"Modelo",
    vin:"VIN",licensePlate:"Placa",driversOnPolicy:"Conductores",
    propertyAddress:"Dirección Propiedad",propertyType:"Tipo Propiedad",
    yearBuilt:"Año Construcción",squareFootage:"Pies Cuadrados",
    insuredValue:"Valor Asegurado",businessName:"Negocio",businessType:"Tipo Negocio",
    businessAddress:"Dir. Negocio",numEmployees:"Empleados",annualRevenue:"Ingresos Anuales",
    agentName:"Agente",producerCode:"Cód. Productor",type:"Tipo Póliza"
  };
  const recordChanges = (type, entityId, clientId, oldObj, newObj, labels) => {
    const today = new Date().toISOString();
    const changes = [];
    Object.keys({...oldObj,...newObj}).forEach(k=>{
      if(!labels[k]) return;
      const ov = String(oldObj[k]||"").trim();
      const nv = String(newObj[k]||"").trim();
      if(ov!==nv && (ov||nv)) changes.push({field:k,label:labels[k],from:ov||"--",to:nv||"--"});
    });
    if(!changes.length) return;
    const entry = {id:uid(),type,entityId,clientId,date:today,changes,
      user: currentUser?.name||"Sistema"};
    if(onChangeHistory) onChangeHistory(prev=>[entry,...(prev||[])]);
  };
  // When MSAL is active, mutations also hit the backend so data persists
  // beyond the browser session. If the API call fails, the modal stays open
  // so the user can retry without losing what they typed.
  // (isApiMode is already declared near openDetail above; reuse it here.)
  // When the backend trips the PIN gate on PUT /clients/:id (because the
  // form is mutating an existing SSN), we stash the in-flight save here
  // and open a small PIN modal. After the user types the PIN we retry
  // apiUpdateClient with it. Keeps the SSN edit gate fully server-side
  // — the frontend can't bypass the gate even if state is tampered with.
  const [ssnEditPin, setSsnEditPin] = useState(null); // { form, modalId, pinError? }
  const performUpdate = async (modalId, form, pin) => {
    const updated = await apiUpdateClient(modalId, form, pin);
    // Strip the transient concurrency metadata before it lands in local state.
    const clean = { ...form };
    delete clean.__baseUpdatedAt;
    delete clean.__force;
    // The edit form only writes `preferredLang` ("spanish"/"english"); the
    // display layer (profile chip + list 🇪🇸 badge) reads `preferredLanguage`
    // ("es"/"en") FIRST. Merging only the form left the OLD preferredLanguage
    // in local state, so the language showed stale until a full refetch (F5)
    // — Lissette 2026-06-19: "el idioma no se guarda solo, tengo que refrescar"
    // (#3b). Sync the alias here so both fields agree and the view updates live.
    if (clean.preferredLang != null) {
      const _pl = String(clean.preferredLang).toLowerCase();
      clean.preferredLanguage = (_pl === 'spanish' || _pl === 'es') ? 'es' : 'en';
    }
    // Adopt the server's fresh updatedAt so the local copy's base version moves
    // forward — otherwise a second edit in the same session would false-trip
    // the "no te piso" guard against the now-stale base.
    if (updated && updated.updatedAt) clean.updatedAt = updated.updatedAt;
    onClientsChange(prev => prev.map(c => c.id === modalId ? { ...c, ...clean } : c));
    if (detail?.id === modalId) setDetail(d => ({ ...d, ...clean }));
    return updated;
  };
  // Bubble-up from SsnRevealModal: PIN-gated /update-ssn save just
  // persisted a new/edited SSN. The form save (PUT /clients/:id) and
  // SSE `client.updated` event are NOT triggered by /update-ssn, so
  // without this patch the local clients list + detail keep showing
  // the stale `hasSsn: false` / no-mask state until the next page
  // refresh — Lissette: "guardo el SSN y no aparece por más que lo
  // guardo" (2026-05-27).
  const handleSsnSaved = (result, target, clientId, dependentId) => {
    if (!result || !clientId) return;
    const patch = (c) => {
      if (target === 'primary') {
        return { ...c, hasSsn: !!result.hasSsn, ssnMasked: result.masked || '' };
      }
      if (target === 'spouse') {
        return {
          ...c,
          spouse: {
            ...(c.spouse || {}),
            ssnMasked: result.masked || '',
            ssnLast4: result.ssnLast4 || '',
          },
        };
      }
      if (target === 'dependent' && dependentId) {
        return {
          ...c,
          dependents: (c.dependents || []).map((d) =>
            d.id === dependentId ? { ...d, ssnLast4: result.ssnLast4 || '' } : d,
          ),
        };
      }
      return c;
    };
    onClientsChange((prev) => prev.map((c) => (c.id === clientId ? patch(c) : c)));
    if (detail?.id === clientId) setDetail((d) => (d ? patch(d) : d));
    // Belt-and-suspenders: trigger an authoritative refetch from GET /:id
    // so the audited decrypt populates `ssnMasked` even if `result.masked`
    // didn't ride through (e.g. older backend, mid-deploy). Without this,
    // the pill could stay on the "third branch" (hasSsn:true + empty mask)
    // until the user manually navigates away and back.
    if (isApiMode) {
      apiGetClient(clientId)
        .then((full) => {
          onClientsChange((prev) => prev.map((c) => (c.id === clientId ? { ...c, ...full } : c)));
          if (detail?.id === clientId) setDetail((d) => (d?.id === clientId ? { ...d, ...full } : d));
        })
        .catch(() => { /* non-fatal; the local patch above already covers the optimistic case */ });
    }
  };
  // Returns the saved client (merged of form + backend response) for the
  // caller to use — e.g. the ClientForm wrapper transitions the modal
  // from "add" to edit mode of the newly-created client so the form
  // stays open ("Lissette: quedarme en el mismo form abierto",
  // 2026-05-27). Returns null on error (the alert already fired).
  // Coverage → Policy auto-sync (additive, silent). Runs right after a client
  // save so the profile's coverage toggles and the policies stay in agreement
  // WITHOUT a manual button (Lissette 2026-05-29: "que se haga directo al
  // guardar el perfil"). For each covered member it adds them to the matching
  // policy, or creates an empty policy of that type when none exists. NEVER
  // removes anyone. Skips types the backend collapses (partd/suppl/referred/
  // final) so repeated saves don't pile up duplicate empty stubs. Best-effort:
  // the client itself already saved, so a sync failure must not read as "the
  // profile didn't save".
  // Coverage → Policy sync on profile save. Acts ONLY on the cov_<type> toggles
  // the agent actually changed in THIS save (delta vs prevClient): newly checked
  // adds the person to the matching policy (or creates a stub), newly unchecked
  // removes them. Members/types left untouched are never modified, so an
  // unrelated profile edit can't strip people off existing policies.
  // DISABLED (Lissette 2026-07-27). The Coverage→Policy direction — saving the
  // client created/moved policies from the (now-removed) coverage toggles — was
  // the confusing, out-of-sync behavior. Coverage is now defined ONLY on the
  // policy (its "Personas Aseguradas" list), and the Policy→Coverage sync in
  // ClientDetail.savePolicy keeps the cov_<type> flags in step. This is a no-op
  // kept as a stub so the save handlers below don't need to change.
  const autoSyncPoliciesFromCoverage = async () => { /* intentionally does nothing */ };
  const save = async form => {
    if (modal === "add") {
      if (isApiMode) {
        try {
          const created = await apiCreateClient(form);
          // Race fix: SSE client.created (PR #389) can arrive BEFORE the
          // HTTP 201 returns here. If the SSE handler already appended,
          // merge into the existing row instead of pushing again —
          // otherwise both paths add and the client renders twice.
          // Same pattern as PR #392 for policies. Lissette 2026-05-27:
          // "me salen dos veces creado, tengo que refrescar".
          const merged = { ...form, ...created };
          onClientsChange(prev =>
            prev.some(c => c.id === merged.id)
              ? prev.map(c => (c.id === merged.id ? { ...c, ...merged } : c))
              : [...prev, merged],
          );
          // The createClient response carries `hasSsn` but NOT
          // `ssnMasked` for the primary (an audited decrypt only
          // happens in GET /:id and POST /update-ssn). Without this
          // refetch, the just-created client's pill stays in the
          // "third branch" (hasSsn:true + empty mask) until the
          // agent navigates away and back. Mirrors handleSsnSaved's
          // belt-and-suspenders pattern.
          const typedAnySsn = !!form.ssn || !!form.spouse?.ssn ||
            (Array.isArray(form.dependents) && form.dependents.some(d => !!d.ssn));
          if (created?.id && typedAnySsn) {
            apiGetClient(created.id)
              .then((full) => {
                onClientsChange((prev) => prev.map((c) => (c.id === created.id ? { ...c, ...full } : c)));
              })
              .catch(() => { /* non-fatal; optimistic merge above already covers the common case */ });
          }
          await autoSyncPoliciesFromCoverage(merged, null);
          return merged;
        } catch (err) {
          alert((lang === "es" ? "No se pudo guardar el cliente: " : "Failed to save client: ") + err.message);
          return null;
        }
      } else {
        const local = { ...form, id: uid(), createdAt: new Date().toISOString().split("T")[0] };
        onClientsChange(prev => [...prev, local]);
        await autoSyncPoliciesFromCoverage(local, null);
        return local;
      }
    } else {
      recordChanges("client", modal.id, modal.id, modal, form, CLIENT_LABELS);
      if (isApiMode) {
        try {
          await performUpdate(modal.id, form);
        } catch (err) {
          if (err && err.code === 'PIN_REQUIRED_FOR_SSN_EDIT') {
            // Open the PIN modal and DO NOT close the edit modal — if
            // the user cancels the PIN, the edit form stays so they can
            // back out cleanly or remove the SSN change.
            setSsnEditPin({ form, modalId: modal.id });
            return null;
          }
          if (err && err.code === 'STALE_WRITE') {
            // Someone saved this client first. Don't clobber them silently —
            // stash the attempted form and let the user choose "recargar y
            // ver" or "guardar de todos modos" via the conflict modal.
            setStaleConflict({ form, modalId: modal.id });
            return null;
          }
          alert((lang === "es" ? "No se pudo actualizar el cliente: " : "Failed to update client: ") + err.message);
          return null;
        }
      } else {
        onClientsChange(prev => prev.map(c => c.id === modal.id ? { ...modal, ...form } : c));
        if(detail?.id===modal.id) setDetail(d=>({...d,...form}));
      }
      const saved = { ...modal, ...form };
      // Keep the language alias coherent on the RETURNED object. The edit-mode
      // onSave merges this into the open profile (setDetail(d=>({...d,...saved}))),
      // but `form` only carries the new `preferredLang` ("spanish"/"english") —
      // `preferredLanguage` ("es"/"en") is still the value the form loaded with,
      // and the profile chip reads `preferredLanguage` FIRST. Without re-deriving
      // it here the profile kept showing the OLD language until exit/re-enter or
      // F5 (Lissette 2026-06-19 #3b: "no quiero tener que salir y entrar o F5").
      if (saved.preferredLang != null) {
        const _pl = String(saved.preferredLang).toLowerCase();
        saved.preferredLanguage = (_pl === 'spanish' || _pl === 'es') ? 'es' : 'en';
      }
      await autoSyncPoliciesFromCoverage(saved, modal);
      // Explicit save confirmation (Lissette 2026-06-19 #6).
      toast.success(lang === "es" ? "Guardado ✓" : "Saved ✓");
      return saved;
    }
  };
  const del = async id => {
    if (isApiMode) {
      try {
        await apiDeleteClient(id);
      } catch (err) {
        alert((lang === "es" ? "No se pudo eliminar el cliente: " : "Failed to delete client: ") + err.message);
        return;
      }
    }
    onClientsChange(prev => prev.filter(c => c.id !== id));
    onDocsChange(prev => prev.filter(d => d.clientId !== id));
    onPoliciesChange(prev => prev.filter(p => p.clientId !== id));
    setDelConfirm(null);
    if (detail?.id === id) setDetail(null);
  };
  // Bulk delete. Iterates one-by-one with live progress + per-row failure
  // tracking — same pattern as ImportView so the user can see exactly
  // what's happening with 100+ rows and which ones (if any) didn't go
  // through. Each successful delete is removed from local state as soon
  // as it completes so the list visibly shrinks during the run.
  const bulkDelete = async () => {
    const ids = Array.from(selectedIds);
    if (ids.length === 0) return;
    const labelFor = (id) => {
      const c = clients.find(x => x.id === id);
      return c ? `${c.firstName || ''} ${c.lastName || ''}`.trim() || id : id;
    };
    setBulkDelConfirm(false);
    setBulkProgress({ active: true, current: 0, total: ids.length, currentLabel: '', succeeded: 0, failed: [] });
    const failures = [];
    const succeededIds = [];
    for (let i = 0; i < ids.length; i++) {
      const id = ids[i];
      const label = labelFor(id);
      setBulkProgress(p => ({ ...p, current: i + 1, currentLabel: label }));
      if (isApiMode) {
        try {
          await apiDeleteClient(id);
          succeededIds.push(id);
          setBulkProgress(p => ({ ...p, succeeded: p.succeeded + 1 }));
        } catch (err) {
          failures.push({ label, error: err.message });
          setBulkProgress(p => ({ ...p, failed: [...p.failed, { label, error: err.message }] }));
        }
      } else {
        succeededIds.push(id);
        setBulkProgress(p => ({ ...p, succeeded: p.succeeded + 1 }));
      }
    }
    // Drop the successfully-deleted ids from local state in one pass so the
    // list doesn't shuffle on every iteration.
    if (succeededIds.length > 0) {
      const succeededSet = new Set(succeededIds);
      onClientsChange(prev => prev.filter(c => !succeededSet.has(c.id)));
      onDocsChange(prev => prev.filter(d => !succeededSet.has(d.clientId)));
      onPoliciesChange(prev => prev.filter(p => !succeededSet.has(p.clientId)));
      if (detail && succeededSet.has(detail.id)) setDetail(null);
    }
    setSelectedIds(new Set(failures.length > 0 ? ids.filter(id => failures.some(f => labelFor(id) === f.label)) : []));
    // Keep the overlay up briefly so the user sees the final counts, then
    // close — they can click anywhere to dismiss the result toast.
    setTimeout(() => setBulkProgress(p => ({ ...p, active: false })), 1200);
  };
  const hasFilters = search || statusFilter !== "all" || stateFilter !== "all" || cityFilter !== "all" || countyFilter !== "all" || (Array.isArray(carrierFilter) && carrierFilter.length > 0) || policyTypeFilter !== "all" || agentFilter !== "all" || tagFilter !== "all" || (attendFilter && attendFilter !== "all") || (immigFilter && immigFilter !== "all") || (langFilter && langFilter !== "all");
  useEffect(()=>{
    const check=()=>{
      if(window.__magGoToClient){
        const target=window.__magGoToClient;
        window.__magGoToClient=null;
        setDetail(target);
      }
      if(window.__magStatusFilter){
        const f=window.__magStatusFilter;
        window.__magStatusFilter=null;
        setStatusFilter(f);
      }
      if(window.__magAddClient){
        const p=window.__magAddClient;
        window.__magAddClient=null;
        setAddPrefill(p);
        setModal("add");
      }
    };
    const t=setTimeout(check,80);
    // The mount-time check above only covers arriving FROM another view.
    // When the user is ALREADY on Clients (e.g. clicking "Ver →" on a chat
    // alert, or a bell item, while sitting in a client's record) the view
    // never remounts and the hint was silently ignored — the click "did
    // nothing" (Lissette 2026-07-03). navigateFromLink now also fires this
    // event so an already-mounted Clients view consumes the hint too.
    window.addEventListener('deskte:go-to-client', check);
    return()=>{ clearTimeout(t); window.removeEventListener('deskte:go-to-client', check); };
  },[]);
  // "Atiende" tambien se limpia. Se quedaba fuera, y como ademas no contaba en
  // `hasFilters`, un valor viejo ahi dentro no se podia quitar por ningun sitio
  // (Lissette, 2026-09-04: 244 clientes y la lista vacia).
  // EL FILTRO "ATIENDE" QUE SE VE COMO "TODOS" Y NO LO ES.
  //
  // Lissette, 2026-09-04: la lista decia "0 of 244 clientes" y "No se
  // encontraron clientes" con TODOS los chips puestos en "todo" — incluido
  // "Atiende: Todos".
  //
  // Se guarda entre visitas (`useStickyFilter`) a proposito. El problema es lo
  // que pasa cuando lo guardado ya NO EXISTE: un asiento que se dio de baja, o
  // —como aqui— una cartera que se borro y se volvio a importar, asi que los
  // identificadores de antes no le corresponden a nadie. `pasaElFiltroDeAtiende`
  // acaba en `c.attendedBySeatId === filtro`, que para un identificador
  // fantasma es false en TODOS los clientes.
  //
  // Y lo que lo vuelve indescifrable: un <select> cuyo `value` no coincide con
  // ninguna <option> pinta la PRIMERA, o sea "Atiende: Todos". La pantalla dice
  // "todos" y esta filtrando por alguien que ya no esta. No hay forma de verlo.
  //
  // Asi que si el valor guardado no esta entre las opciones de HOY, se vuelve a
  // "todos" solo. Un filtro que no se puede ver ni quitar no es un filtro: es
  // una cartera que desaparece.
  useEffect(() => {
    if (!attendFilter || attendFilter === "all" || attendFilter === "none") return;
    if (!clientsLoaded) return; // con la libreta a medias, media lista de opciones
    const valido = attendFilter.startsWith(PREFIJO_LIBRE)
      ? nombresLibresDeLaCartera(clients).some((n) => PREFIJO_LIBRE + n === attendFilter)
      : attendOptions(users).some((u) => u.id === attendFilter);
    if (!valido) setAttendFilter("all");
  }, [attendFilter, clients, users, clientsLoaded]);

  const clearFilters = () => { setSearch(""); setStatusFilter("all"); setStateFilter("all"); setCityFilter("all"); setCountyFilter("all"); setCarrierFilter("all"); setPolicyTypeFilter("all"); setAgentFilter("all"); setTagFilter("all"); setAttendFilter("all"); setImmigFilter("all"); setLangFilter("all"); };
  // VOLVER A PEDIR LA CARTERA, ENTERA.
  //
  // La papelera y los duplicados cambian la lista EN EL SERVIDOR, y esta
  // pantalla no se entera: sin esto, el cliente restaurado no aparece y el
  // duplicado absorbido sigue ahi hasta recargar la pagina.
  //
  // Los dos pedian `listClients({ page: 1, limit: 500 })` y con esa unica
  // pagina reemplazaban la lista entera. En una agencia de 955 clientes eso
  // dejaba 500: 455 personas desaparecian de la lista, de los contadores de las
  // pestañas, de los numeros de los filtros y de los correos masivos, sin decir
  // nada y hasta que alguien recargara. Y pasaba justo despues de "combinar
  // duplicados", que es lo que se aprieta cuando los numeros no cuadran
  // (Wendy Cercio, 2026-09-17).
  //
  // SI LA RECARGA SALE A MEDIAS, NO SE PISA LA BUENA. Una lista completa y con
  // un dato viejo es mejor que una incompleta: lo viejo se ve y se corrige
  // recargando, lo que falta no se ve. Se dice, y se dice que recargue.
  const recargarCartera = async () => {
    if (typeof window === "undefined" || !window.__deskteAuth) return;
    const es = lang === "es";
    try {
      const { clientes, paginasFallidas, totalDelServidor } = await cargarCarteraCompleta({ listClients: apiListClients });
      if (paginasFallidas > 0) {
        toast.error(es
          ? `No se pudo traer la lista completa (${paginasFallidas} página(s) fallaron). Se deja la que había: recarga la página para verla al día.`
          : `Couldn't fetch the full list (${paginasFallidas} page(s) failed). Keeping the previous one: reload the page to see it up to date.`);
        return;
      }
      onClientsChange(clientes);
      // El total del SERVIDOR también cambió: combinar duplicados deja un
      // cliente menos. Sin actualizarlo, el aviso ámbar de arriba compararía
      // 954 contra el 955 de antes y diría que falta gente por cargar — un
      // número falso justo en la pantalla donde se vino a mirar por qué los
      // números no cuadran.
      if (typeof onClientsServerTotalChange === "function" && totalDelServidor != null) {
        onClientsServerTotalChange(totalDelServidor);
      }
    } catch (err) {
      toast.error(es
        ? `No se pudo actualizar la lista de clientes: ${err?.message || ""}. Recarga la página.`
        : `Couldn't refresh the client list: ${err?.message || ""}. Please reload the page.`);
    }
  };
  const renderInsuredModal = () => {
    if (!insuredPopup) return null;
    const mc = clients.find(x => x.id === insuredPopup);
    if (!mc) return null;
    const calcAge = dob => dob ? Math.floor((new Date() - new Date(dob)) / 31557600000) : null;
    const all = [];
    all.push({ name: `${mc.firstName} ${mc.lastName}`, relation: lang==="es"?"Titular":"Primary", dob: mc.dob, isPrimary: true, insured: memberHasCoverage(mc), age: calcAge(mc.dob) });
    if (hasCurrentSpouse(mc))
      all.push({ name: `${mc.spouse.firstName} ${mc.spouse.lastName||""}`.trim(), relation: lang==="es"?"Cónyuge":"Spouse", dob: mc.spouse.dob, insured: memberHasCoverage(mc.spouse), age: calcAge(mc.spouse?.dob) });
    (mc.dependents||[]).forEach(dep => {
      if (!dep.firstName) return;
      const age = calcAge(dep.dob);
      all.push({ name: `${dep.firstName} ${dep.lastName||""}`.trim(), relation: dep.relation||"dep", dob: dep.dob, age, isAdult: age !== null && age >= 26, insured: memberHasCoverage(dep), hasSeparate: dep.separateProfile });
    });
    return (
      <div style={{position:"fixed",inset:0,zIndex:99999,background:"rgba(0,0,0,.78)",backdropFilter:"blur(6px)",display:"flex",alignItems:"center",justifyContent:"center",padding:"1rem"}}
        onClick={()=>setInsuredPopup(null)}>
        <div onClick={e=>e.stopPropagation()} style={{background:"var(--c-surface,#0d1c2e)",border:"2px solid rgba(0,212,255,.4)",borderRadius:16,width:"100%",maxWidth:500,maxHeight:"80vh",display:"flex",flexDirection:"column",boxShadow:"0 32px 80px rgba(0,0,0,.7)",overflow:"hidden"}}>
          <div style={{padding:"1rem 1.25rem",background:"linear-gradient(135deg,rgba(0,212,255,.15),rgba(0,150,180,.08))",borderBottom:"1px solid rgba(0,212,255,.25)",display:"flex",alignItems:"center",justifyContent:"space-between",flexShrink:0}}>
            <div>
              <div style={{fontFamily:"var(--font-display)",fontWeight:800,fontSize:"1.05rem",color:"var(--c-white,#eef6ff)"}}>🛡️ {lang==="es"?"Miembros del Hogar":"Household Members"}</div>
              <div style={{fontSize:".73rem",color:"var(--c-cyan,#00d4ff)",marginTop:2,fontWeight:600}}>{mc.firstName} {mc.lastName} . {all.length} {lang==="es"?"personas":"people"}</div>
            </div>
            <button onClick={()=>setInsuredPopup(null)} style={{background:"var(--c-surface2,#112538)",border:"1px solid var(--c-border,#1a3550)",borderRadius:8,cursor:"pointer",color:"var(--c-text2,#7aa3c0)",lineHeight:0,padding:7}}>
              <X size={16}/>
            </button>
          </div>
          <div style={{overflowY:"auto",padding:".75rem",flex:1}}>
            {all.map((m,mi) => (
              <div key={mi} style={{display:"flex",alignItems:"center",gap:".875rem",padding:".7rem .875rem",borderRadius:10,marginBottom:".4rem",
                background:m.insured?"rgba(0,212,255,.07)":"var(--ci-bg-02)",
                border:`1px solid ${m.insured?"rgba(0,212,255,.25)":"var(--c-border,#1a3550)"}`}}>
                <div style={{width:40,height:40,borderRadius:"50%",flexShrink:0,display:"flex",alignItems:"center",justifyContent:"center",
                  fontWeight:800,fontSize:".9rem",fontFamily:"var(--font-display)",
                  background:m.isPrimary?"var(--c-cyan,#00d4ff)":m.insured?"var(--c-surface3,#162d44)":"var(--c-surface2,#112538)",
                  color:m.isPrimary?"#071828":"var(--c-text,#c8dff0)",
                  border:`2px solid ${m.isPrimary?"rgba(0,212,255,.8)":m.insured?"rgba(0,212,255,.2)":"var(--c-border,#1a3550)"}`}}>
                  {(m.name||"?")[0].toUpperCase()}
                </div>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{fontWeight:700,fontSize:".92rem",color:m.insured?"var(--c-white,#eef6ff)":"var(--c-text3,#45688a)",marginBottom:3}}>{m.name}</div>
                  <div style={{display:"flex",alignItems:"center",gap:".4rem",flexWrap:"wrap"}}>
                    <span style={{fontSize:".68rem",color:"var(--c-text3,#45688a)",textTransform:"capitalize",background:"var(--c-surface2,#112538)",padding:"1px 6px",borderRadius:4}}>{m.relation}</span>
                    {m.dob && <span style={{fontSize:".65rem",color:"var(--c-text3,#45688a)",fontFamily:"var(--font-mono)"}}>📅 {m.dob}{m.age!=null?` . ${m.age}a`:""}</span>}
                    {m.isAdult && <span style={{fontSize:".62rem",background:"var(--c-amber-dim)",color:"var(--c-amber,#ffb700)",padding:"1px 5px",borderRadius:4,fontWeight:700,border:"1px solid rgba(255,183,0,.2)"}}>⚠️ Mayor 26</span>}
                    {m.hasSeparate && <span style={{fontSize:".62rem",background:"var(--c-green-dim)",color:"var(--c-green,#00ff88)",padding:"1px 5px",borderRadius:4,fontWeight:700}}>✓ Perfil sep.</span>}
                  </div>
                </div>
                <div style={{flexShrink:0}}>
                  {m.insured
                    ? <span style={{display:"inline-flex",alignItems:"center",gap:4,fontSize:".72rem",fontWeight:800,background:"var(--c-cyan,#00d4ff)",color:"#071828",padding:".3rem .75rem",borderRadius:7,whiteSpace:"nowrap",letterSpacing:".02em"}}>🛡️ {lang==="es"?"ASEGURADO":"COVERED"}</span>
                    : <span style={{display:"inline-flex",alignItems:"center",gap:4,fontSize:".72rem",fontWeight:700,background:"var(--c-surface3,#162d44)",color:"var(--c-text3,#45688a)",padding:".3rem .75rem",borderRadius:7,border:"1px solid var(--c-border,#1a3550)",whiteSpace:"nowrap"}}>✕ {lang==="es"?"NO ASEG.":"NOT COVERED"}</span>
                  }
                </div>
              </div>
            ))}
          </div>
          <div style={{padding:".875rem 1rem",borderTop:"1px solid var(--c-border,#1a3550)",display:"flex",gap:".5rem",justifyContent:"flex-end",flexShrink:0,background:"var(--c-surface,#0d1c2e)"}}>
            <button onClick={()=>{setInsuredPopup(null);setDetail(mc);}}
              style={{display:"flex",alignItems:"center",gap:5,fontSize:".78rem",fontWeight:700,background:"var(--c-cyan,#00d4ff)",color:"#071828",border:"none",padding:".5rem 1.1rem",borderRadius:9,cursor:"pointer"}}>
              <Eye size={14}/> {lang==="es"?"Ver Perfil Completo":"View Full Profile"}
            </button>
            <button onClick={()=>setInsuredPopup(null)}
              style={{fontSize:".78rem",fontWeight:600,background:"var(--c-surface2,#112538)",color:"var(--c-text2,#7aa3c0)",border:"1px solid var(--c-border,#1a3550)",padding:".5rem .875rem",borderRadius:9,cursor:"pointer"}}>
              {lang==="es"?"Cerrar":"Close"}
            </button>
          </div>
        </div>
      </div>
    );
  };
  // "No te piso" conflict resolution modal. A save was rejected because a
  // teammate edited the same client first. Defined once and rendered in BOTH
  // the detail and list return paths (an edit can be launched from either), so
  // the prompt shows wherever the user happened to be.
  const conflictModalEl = staleConflict && (
    <Modal title={lang === "es" ? "⚠️ Otra persona editó esta ficha" : "⚠️ Someone else edited this client"} onClose={() => setStaleConflict(null)}>
      <div style={{ display: "flex", flexDirection: "column", gap: ".9rem" }}>
        <div style={{ fontSize: ".82rem", color: "var(--c-text,#c8dff0)", lineHeight: 1.5 }}>
          {lang === "es"
            ? "Mientras editabas, otra persona del equipo guardó cambios en este mismo cliente. Para no borrar su trabajo, elige qué hacer:"
            : "While you were editing, a teammate saved changes to this same client. To avoid erasing their work, choose what to do:"}
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: ".55rem" }}>
          <button type="button" className="dkt-btn-p" style={{ justifyContent: "center" }} onClick={async () => {
            const fresh = await apiGetClient(staleConflict.modalId).catch(() => null);
            if (fresh) {
              onClientsChange(prev => prev.map(c => c.id === staleConflict.modalId ? { ...c, ...fresh } : c));
              setDetail(d => (d && d.id === staleConflict.modalId ? { ...d, ...fresh } : d));
            }
            setModal(null); setStaleConflict(null);
          }}>
            🔄 {lang === "es" ? "Recargar y ver sus cambios (descarta los míos)" : "Reload and see their changes (discards mine)"}
          </button>
          <button type="button" className="dkt-btn-s" style={{ justifyContent: "center" }} onClick={async () => {
            try {
              await performUpdate(staleConflict.modalId, { ...staleConflict.form, __force: true });
            } catch (e) {
              alert((lang === "es" ? "No se pudo guardar: " : "Couldn't save: ") + (e.message || e));
            }
            setModal(null); setStaleConflict(null);
          }}>
            💾 {lang === "es" ? "Guardar de todos modos (sobrescribe lo de la otra persona)" : "Save anyway (overwrites their changes)"}
          </button>
          <button type="button" onClick={() => setStaleConflict(null)}
            style={{ background: "none", border: "none", color: "var(--c-text3,#45688a)", fontSize: ".78rem", fontWeight: 600, cursor: "pointer", padding: ".3rem" }}>
            {lang === "es" ? "Cancelar" : "Cancel"}
          </button>
        </div>
      </div>
    </Modal>
  );

  if (detail) return <div>
    {renderInsuredModal()}
    {conflictModalEl}
    <ClientDetail client={detail} policies={policies} docs={docs} tasks={tasks} signatures={signatures}
      activitylog={activitylog}
      onPoliciesChange={onPoliciesChange} onDocsChange={onDocsChange} onTasksChange={onTasksChange}
      clientNotes={(clientNotes||[]).filter(n=>n.clientId===detail.id)} onClientNotesChange={onClientNotesChange}
      users={users} clients={clients} currentUser={currentUser} userPrefs={userPrefs}
      onBack={() => { setDetail(null); try { if (typeof window !== "undefined" && (window.location.hash||"").startsWith("#client/")) window.history.back(); } catch {} }} onEditClient={() => setModal(detail)}
      onClientPatched={(patch)=>{ setDetail(d=>d?{...d,...patch}:d); onClientsChange(prev=>prev.map(c=>c.id===detail.id?{...c,...patch}:c)); }}
      onClientCreated={(nc)=>{ if(nc) onClientsChange(prev=>[nc, ...prev]); }}
      onChangeHistory={onChangeHistory} changeHistory={changeHistory||[]} docTemplates={docTemplates||[]} eligibilityAlerts={eligibilityAlerts} onEligibilityAlertsChange={onEligibilityAlertsChange} followups={followups} onFollowupsChange={onFollowupsChange} tickets={tickets} onSaveTicket={onSaveTicket} onAddTicketMessage={onAddTicketMessage} onEditTicketMessage={onEditTicketMessage} onDeleteTicketMessage={onDeleteTicketMessage} onDeleteTicket={onDeleteTicket} onNotifyTicketClient={onNotifyTicketClient} loadClientDocs={loadClientDocs} ticketEmailOnOpen={ticketEmailOnOpen} ticketEmailOnResolve={ticketEmailOnResolve} seatLabels={seatLabels} onSeatLabelsChange={onSeatLabelsChange} ticketStatuses={ticketStatuses} ticketTypes={ticketTypes} requests={(requests||[]).filter(r=>r.clientId===detail.id)} onRequestsChange={onRequestsChange} customTabDefs={customTabDefs} tagColors={tagColors} onTagColorsChange={onTagColorsChange} tagLibrary={tagLibrary} onTagLibraryChange={onTagLibraryChange} policyTagLibrary={policyTagLibrary} onPolicyTagLibraryChange={onPolicyTagLibraryChange} policyTagColors={policyTagColors} onPolicyTagColorsChange={onPolicyTagColorsChange} t={t} lang={lang} />
    {modal && <Modal title={modal === "add" ? t.clientForm.addTitle : t.clientForm.editTitle} onClose={() => setModal(null)} wide>
      {/* Only merge form fields back into `detail` on EDIT. On ADD the form
          has no id yet (it arrives only in the backend's create response),
          so merging would seed `detail` with an idless ghost client and the
          next save would PUT /clients/undefined → 404. */}
      <ClientForm key={modal === "add" ? "add" : modal.id} client={modal === "add" ? (addPrefill || null) : modal} onSave={async f => {
        const result = await save(f);
        // Lissette 2026-05-27 ("quedarme en el mismo form abierto"):
        // after creating a NEW client, keep the modal open but flip
        // it to edit mode of the just-created client (key change
        // remounts ClientForm so `base.ssn=''` resets and the SSN
        // field shows the 🔒 pill instead of the typed plaintext).
        if (modal === "add") {
          if (result) {
            setModal(result);
            setAddPrefill(null);
          }
          // If result is null, save() already alerted — leave the form
          // open with the typed values so she can retry.
          return;
        }
        // Edit-mode save: close the form AND open the client's
        // profile (detail view), not the clients list. Lissette
        // 2026-05-27 ("no se va a el perfil de cliente"). result
        // includes the canonical merged client so the detail panel
        // shows the up-to-date state immediately.
        if (result) {
          setDetail(d => ({ ...(d || {}), ...result }));
        }
        setModal(null);
        setAddPrefill(null);
      }} onPersist={save} onClose={() => { setModal(null); setAddPrefill(null); }} t={t} lang={lang} onClientsChange={onClientsChange} policies={policies} onPoliciesAdd={(np)=>onPoliciesChange(prev=>[...prev,...np])} onSsnSaved={handleSsnSaved} customTabDefs={customTabDefs} onCustomTabDefsChange={onCustomTabDefsChange} />
    </Modal>}
  </div>;
  // Excel/CSV export of the WHOLE client book. The in-memory list rows are
  // LIGHT (the list endpoint strips address/income/marital/spouse detail/notes
  // for perf+PHI), so exports built from them came out mostly EMPTY (Lissette
  // 2026-07-16). Pull full decrypted rows from GET /clients/export and merge;
  // policy columns keep coming from the in-memory policies (already complete).
  // Pide el PIN (auditoría de seguridad 2026-09-27). Si el servidor dice que
  // no —PIN mal, sin permiso, tope por hora— el error SUBE al cuadro del PIN:
  // antes, cualquier fallo caía a "se exporta lo cargado", y con el PIN eso
  // sería justo la puerta de atrás que se quiere cerrar.
  const exportClientsRows = async (format, pin) => {
    const es = lang === "es";
    const { exportClientsFull } = await import("./crm-app/api.js");
    // El formato y cuantas fichas se van a escribir se declaran aqui porque
    // el servidor no puede saberlos: el recorte visible sale de los filtros
    // de esta pantalla. Es lo que despues se lee en el historial.
    const fullById = new Map((await exportClientsFull({ format, exported: sorted.length, pin })).map(r => [r.id, r]));
    // Todas las polizas de cada cliente (las del servidor si las hay) y cuantas
    // tiene el que mas: tantos bloques "Poliza N - ..." lleva CADA fila.
    const polizasDe = c => {
      const f = fullById.get(c.id) || {};
      return Array.isArray(f.policies) && f.policies.length ? f.policies : (policies || []).filter(p => p.clientId === c.id);
    };
    const maxPolizas = sorted.reduce((m, c) => Math.max(m, polizasDe(c).length), 0);
    return sorted.map(c => {
      const f = fullById.get(c.id) || {};
      // Policies: prefer the SERVER's complete set (the in-memory array can be
      // partial → "no salen todas las pólizas", 2026-07-16); normalize both
      // shapes to the fields the summary lines read.
      const srvPols = Array.isArray(f.policies) && f.policies.length ? f.policies : null;
      const cPols = srvPols
        ? srvPols.map(p => ({
            type: p.type, plan: p.plan, carrier: p.carrier, policyNumber: p.policyNumber, memberId: p.memberId, status: p.status,
            monthlyPremium: p.premiumFrequency === "MONTHLY" ? (p.premium || 0) : 0,
            premiumLabel: `$${p.premium || 0}${p.premiumFrequency === "MONTHLY" ? "/mo" : p.premiumFrequency ? "/" + String(p.premiumFrequency).toLowerCase() : ""}`,
          }))
        : (policies || []).filter(p => p.clientId === c.id).map(p => ({ ...p, premiumLabel: `$${p.monthlyPremium || 0}/mo` }));
      const sp = c.spouse || {};
      // Dependents: the server rows now carry a composed `dob` (from the safe
      // monthDay+year pair) — DOBs were missing before (2026-07-16).
      const depsArr = (Array.isArray(f.dependents) && f.dependents.length ? f.dependents : (c.dependents || []));
      const deps = depsArr.map(d => `${d.firstName || ""} ${d.lastName || ""}`.trim() + ` (${d.relation || ""}${d.dob ? ", " + d.dob : ""})`).join("; ");
      const polSummary = cPols.map(p => `${p.type}: ${p.plan ? p.plan + " — " : ""}${p.carrier || ""} #${p.policyNumber || ""} MID:${p.memberId || ""} ${p.premiumLabel}${p.status ? ` (${String(p.status).toLowerCase()})` : ""}`).join("; ");
      const carriers = [...new Set(cPols.map(p => p.carrier).filter(Boolean))].join(", ");
      // "Asegurados" = personas distintas marcadas en sus polizas que siguen
      // cubriendo, con la MISMA regla que la tarjeta. Antes contaba los
      // interruptores de cobertura de la ficha y una familia de 7 salia con 6
      // (E-342). Los dependientes del servidor traen `key`, la clave con la
      // que la poliza los marca.
      const insuredCount = aseguradosDelCliente(
        srvPols || cPols,
        { firstName: c.firstName, lastName: c.lastName,
          spouse: { firstName: f.spouseFirstName || sp.firstName || "", lastName: f.spouseLastName || sp.lastName || "" } },
        Array.isArray(f.dependents) && f.dependents.length ? f.dependents.map(d => ({ ...d, id: d.key })) : (c.dependents || []),
      );
      return {
        [es ? "Nombre" : "First Name"]: c.firstName,
        [es ? "Apellido" : "Last Name"]: c.lastName,
        [es ? "Telefono" : "Phone"]: f.phone || c.phone || "",
        Email: f.email || c.email || "",
        [es ? "Fecha Nac." : "DOB"]: f.dob || c.dob || "",
        Status: c.status || "",
        [es ? "Calle" : "Street"]: f.address || c.addressStreet || "",
        [es ? "Ciudad" : "City"]: f.city || c.addressCity || "",
        [es ? "Estado" : "State"]: f.state || c.addressState || "",
        ZIP: f.zipCode || c.addressZip || "",
        [es ? "Condado" : "County"]: f.county || "",
        [es ? "Idioma" : "Language"]: f.preferredLanguage || c.preferredLang || "",
        [es ? "Estado Civil" : "Marital"]: f.maritalStatus || c.maritalStatus || "",
        [es ? "Ingresos" : "Income"]: f.annualIncome || c.annualIncome || "",
        [es ? "Empleador" : "Employer"]: f.employer || c.employer || "",
        [es ? "Inmigr." : "Immig."]: f.immigrationStatus || c.immigrationStatus || "",
        // El documento migratorio (Lissette 2026-10-08): lo descifra el
        // servidor y solo manda el # USCIS / A, el # de tarjeta y el vencimiento.
        ...columnasDeDocumento(f.immigrationDoc, "", es),
        SSN: c.ssn ? "***-**-" + c.ssn.slice(-4) : "",
        [es ? "Hogar" : "Household"]: f.householdSize || c.householdSize || "",
        [es ? "Asegurados" : "Insured"]: insuredCount,
        [es ? "Agente asignado" : "Assigned agent"]: f.assignedAgent || c.assignedAgent || "",
        [es ? "Referido por" : "Referred by"]: f.referredByFirstName ? `${f.referredByFirstName} ${f.referredByLastName || ""}`.trim() : "",
        [es ? "Conyuge Nombre" : "Spouse Name"]: f.spouseFirstName ? `${f.spouseFirstName} ${f.spouseLastName || ""}`.trim() : (sp.firstName ? `${sp.firstName} ${sp.lastName || ""}` : ""),
        [es ? "Conyuge Tel." : "Spouse Phone"]: f.spousePhone || sp.phone || "",
        [es ? "Conyuge Fecha Nac." : "Spouse DOB"]: f.spouseDob || sp.dob || "",
        [es ? "Conyuge Empleador" : "Spouse Employer"]: f.spouseEmployer || sp.employer || "",
        [es ? "Conyuge Ingresos" : "Spouse Income"]: f.spouseAnnualIncome || sp.income || "",
        [es ? "Conyuge Inmigr." : "Spouse Immig."]: f.spouseImmigrationStatus || "",
        ...columnasDeDocumento(f.spouseImmigrationDoc, es ? "Conyuge " : "Spouse ", es),
        [es ? "Dependientes" : "Dependents"]: deps,
        [es ? "Companias" : "Carriers"]: carriers,
        [es ? "Nombre(s) del Plan" : "Plan Name(s)"]: [...new Set(cPols.map(p => p.plan).filter(Boolean))].join(", "),
        [es ? "Polizas Detalle" : "Policies Detail"]: polSummary,
        [es ? "# Polizas" : "# Policies"]: cPols.length,
        [es ? "Prima Total/Mes" : "Total Premium/Mo"]: cPols.reduce((s, p) => s + (parseFloat(p.monthlyPremium) || 0), 0),
        // Las pólizas ACTIVAS, columna por dato (Lissette 2026-10-08): prima,
        // vencimiento, forma de pago y costos del plan. Ver polizasActivasParaExcel.js.
        ...columnasDePolizasActivas(srvPols || (policies || []).filter(p => p.clientId === c.id), es),
        // Cada poliza, de cualquier tipo y estatus, en sus propias columnas
        // (Lissette 2026-10-15: "solo se descarga la info de una poliza").
        ...columnasPorPoliza(polizasDe(c), maxPolizas, es),
        [es ? "Notas" : "Notes"]: f.notes || c.notes || "",
        [es ? "Notas (historial)" : "Notes (history)"]: f.notesThread || "",
        [es ? "Creado" : "Created"]: String(f.createdAt || c.createdAt || "").slice(0, 10),
      };
    }).map(fila => Object.fromEntries(Object.entries(fila).map(([k, v]) => [k, celdaEnUnaLinea(v)])));
  };
  return <div>
    {conflictModalEl}
    <div className="flex items-center justify-between mb-5">
      <div>
        <div className="dkt-sec-title">{tc.title}</div>
        <div className="dkt-sec-sub">{sorted.length} of {clients.length} {lang==="es"?"clientes . A->Z":"clients . A->Z"}</div>
        {/* La lista se carga por páginas. Si alguna falla, antes solo se sabía
            por un aviso que pasaba volando y una línea en la consola del
            navegador — así que "subí 1.400 y solo veo 500" no tenía respuesta a
            la vista. Ahora la pantalla compara lo cargado con lo que dice el
            SERVIDOR que hay, y lo canta (Lissette 2026-08-15). */}
        {clientsServerTotal != null && clients.length < clientsServerTotal && (
          <div style={{fontSize:".72rem",color:"var(--c-amber,#ffb700)",marginTop:2}}>
            ⚠️ {lang==="es"
              ? `Se cargaron ${clients.length} de ${clientsServerTotal} clientes que hay en el servidor. Recarga la página para traer el resto.`
              : `Loaded ${clients.length} of the ${clientsServerTotal} clients on the server. Reload the page to fetch the rest.`}
          </div>
        )}
      </div>
      <div style={{display:"flex",gap:".4rem",alignItems:"center"}}>
        {/* Un asiento solo ve estos botones si su agente le dio "Exportar
            clientes"; el servidor lo vuelve a comprobar de todos modos. */}
        {puedeExportarClientes && <>
          <button onClick={()=>setExportarFormato("excel")} className="dkt-btn-g" title="Export Excel"><Download size={13}/> Excel</button>
          <button onClick={()=>setExportarFormato("csv")} className="dkt-btn-g" title="Export CSV"><Download size={13}/> CSV</button>
        </>}
        <button onClick={() => setShowExportHistory(true)} className="dkt-btn-g" title={lang==="es"?"Ver quien exporto la lista de clientes y cuando":"See who exported the client list and when"}>🕓 {lang==="es"?"Historial":"History"}</button>
        <button onClick={() => setShowTrash(true)} className="dkt-btn-g" title={lang==="es"?"Clientes borrados que todavia se pueden devolver":"Deleted clients that can still be restored"}>🗑️ {lang==="es"?"Papelera":"Trash"}</button>
        <button onClick={() => setShowDuplicates(true)} className="dkt-btn-g" title={lang==="es"?"Buscar y combinar clientes duplicados":"Find and merge duplicate clients"}>🔀 {lang==="es"?"Duplicados":"Duplicates"}</button>
        <button onClick={() => setModal("add")} className="dkt-btn-p"><Plus size={14}/>{tc.addClient}</button>
      </div>
    </div>
    {exportarFormato && (
      <ExportarClientesModal
        lang={lang}
        count={sorted.length}
        formato={exportarFormato}
        onClose={() => setExportarFormato(null)}
        onConfirm={async (pin) => {
          const filas = await exportClientsRows(exportarFormato, pin);
          if (exportarFormato === "csv") exportToCSV(filas, "deskte-clients.csv");
          else exportToExcel(filas, "deskte-clients.xlsx", "Clients");
        }}
      />
    )}
    {showExportHistory && (
      <ClientExportHistoryModal lang={lang} onClose={() => setShowExportHistory(false)} />
    )}
    {showTrash && (
      <ClientsTrashModal
        lang={lang}
        onClose={() => setShowTrash(false)}
        onRestored={() => {
          // El cliente volvio en el servidor; esta pantalla no lo sabe. Se
          // re-pide la lista igual que tras combinar duplicados, o el
          // devuelto no aparece hasta recargar la pagina entera.
          recargarCartera();
        }}
      />
    )}
    {showDuplicates && (
      <ClientDuplicates
        lang={lang}
        onClose={() => setShowDuplicates(false)}
        onMerged={() => {
          // A merge changed the server state — re-pull the client list
          // so the absorbed row disappears and the survivor shows its
          // filled-in fields.
          recargarCartera();
        }}
      />
    )}
    <div style={{position:'relative',marginBottom:'.875rem'}}>
      <Search size={14} style={{position:'absolute',left:12,top:'50%',transform:'translateY(-50%)',color:'var(--c-text3,#45688a)',pointerEvents:'none'}}/>
      <input value={search} onChange={e=>setSearch(e.target.value)}
        placeholder={lang==="es"?"Buscar nombre, aseguradora, estado, teléfono...":"Search name, carrier, state, phone..."}
        className="dkt-search" style={{paddingLeft:36}}/>
      {search&&<button onClick={()=>setSearch("")} style={{position:'absolute',right:10,top:'50%',transform:'translateY(-50%)',background:'none',border:'none',cursor:'pointer',color:'var(--c-text3,#45688a)'}}><X size={13}/></button>}
    </div>
    <div className="flex flex-wrap gap-2 mb-5">
      <div style={{display:'flex',gap:'.4rem',flexWrap:'wrap'}}>
        {["all","active","pending","inactive","prospect","referral"].map(s=>(
          <button key={s} onClick={()=>setStatusFilter(s)} className={`dkt-tab${statusFilter===s?" on":""}`}>
            {tc[s]} <span style={{opacity:.6}}>({counts[s]})</span>
          </button>
        ))}
      </div>
      {(allStates.length > 0 || clientesSinEstado > 0) && (
        <select value={stateFilter} onChange={e=>setStateFilter(e.target.value)} className="dkt-inp" style={{fontSize:'.73rem',padding:'.4rem .75rem',width:'auto',cursor:'pointer'}}
          title={lang==="es"?"Filtrar por estado":"Filter by state"}>
          <option value="all">{lang === "es" ? `🗺️ Todo Estado (${allStates.length})` : `🗺️ All States (${allStates.length})`}</option>
          {allStates.map(s => <option key={s.key} value={s.key}>{s.key} ({s.count})</option>)}
          {clientesSinEstado > 0 && (
            <option value={SIN_ESTADO}>
              {lang === "es" ? `Sin estado (${clientesSinEstado})` : `No state (${clientesSinEstado})`}
            </option>
          )}
        </select>
      )}
      {allCities.length > 0 && (
        <select value={cityFilter} onChange={e=>setCityFilter(e.target.value)} className="dkt-inp" style={{fontSize:'.73rem',padding:'.4rem .75rem',width:'auto',cursor:'pointer'}} title={lang==="es"?"Filtrar por ciudad":"Filter by city"}>
          <option value="all">{lang === "es" ? "🏙️ Toda Ciudad" : "🏙️ All Cities"}</option>
          {allCities.map(ci => <option key={ci} value={ci}>{ci}</option>)}
        </select>
      )}
      {allCounties.length > 0 && (
        <select value={countyFilter} onChange={e=>setCountyFilter(e.target.value)} className="dkt-inp" style={{fontSize:'.73rem',padding:'.4rem .75rem',width:'auto',cursor:'pointer'}} title={lang==="es"?"Filtrar por condado":"Filter by county"}>
          <option value="all">{lang === "es" ? "📍 Todo Condado" : "📍 All Counties"}</option>
          {allCounties.map(co => <option key={co} value={co}>{co}</option>)}
        </select>
      )}
      {allPolicyTypes.length > 0 && (
        <select value={policyTypeFilter} onChange={e=>setPolicyTypeFilter(e.target.value)} className="dkt-inp" style={{fontSize:'.73rem',padding:'.4rem .75rem',width:'auto',cursor:'pointer'}}>
          <option value="all">{lang === "es" ? "📋 Todo Tipo" : "📋 All Types"}</option>
          {allPolicyTypes.map(pt => <option key={pt.id} value={pt.id}>{pt.icon} {pt.label}</option>)}
        </select>
      )}
      {allCarriers.length > 0 && (
        <FiltroMultiple
          opciones={allCarriers}
          seleccion={carrierFilter}
          onChange={setCarrierFilter}
          textoTodas={lang === "es" ? "Toda Aseguradora" : "All Carriers"}
          titulo={lang === "es" ? "Filtrar por aseguradora" : "Filter by carrier"}
          lang={lang} />
      )}
      {allAssignedAgents.length > 0 && (
        <select value={agentFilter} onChange={e=>setAgentFilter(e.target.value)} className="dkt-inp" style={{fontSize:'.73rem',padding:'.4rem .75rem',width:'auto',cursor:'pointer'}} title={lang==="es"?"Filtrar por agente":"Filter by agent"}>
          <option value="all">{lang === "es" ? "👤 Todo Agente" : "👤 All Agents"}</option>
          {allAssignedAgents.map(a => <option key={a} value={a}>{a}</option>)}
        </select>
      )}
      <select value={tagFilter} onChange={e=>setTagFilter(e.target.value)} className="dkt-inp" style={{fontSize:'.73rem',padding:'.4rem .75rem',width:'auto',cursor:'pointer'}} title={lang==="es"?"Filtrar por etiqueta":"Filter by tag"}>
        <option value="all">{lang === "es" ? "🏷️ Toda Etiqueta" : "🏷️ All Tags"}</option>
        {tagCounts.sinEtiqueta > 0 && <option value="none">{textoSinEtiqueta(tagCounts.sinEtiqueta, lang)}</option>}
        {tagCounts.opciones.map(t => <option key={t.label} value={t.label}>{t.label} ({t.n})</option>)}
      </select>
      {tagFilter !== "all" && tagFilter !== "none" && (
        <button onClick={() => setQuitarEtq({ ids: null, inicial: tagFilter })}
          title={lang === "es" ? "Quitar esta etiqueta de todos los clientes que la tienen" : "Remove this tag from every client that has it"}
          style={{display:'inline-flex',alignItems:'center',gap:4,padding:'.35rem .6rem',borderRadius:7,cursor:'pointer',border:'1px solid rgba(239,68,68,.45)',background:'rgba(239,68,68,.1)',color:'var(--c-red,#ef4444)',fontSize:'.7rem',fontWeight:700,fontFamily:'inherit'}}>
          ✂️ {lang === "es" ? "Quitar de todos" : "Remove from all"}
        </button>
      )}
      {/* ESTATUS MIGRATORIO (Lissette 2026-09-15). Solo se ofrecen los que
          alguien tiene de verdad: una lista de diez donde ocho dan cero es
          ruido. Y "Sin estatus" saca justo las fichas a las que nunca se les
          rellenó la casilla, que es como se encuentra lo que hay que completar
          en vez de adivinarlo (el mismo criterio que el filtro de estado). */}
      {(immigCounts.opciones.length > 0 || immigCounts.sinEstatus > 0) && (
        <select value={immigFilter} onChange={e=>setImmigFilter(e.target.value)} className="dkt-inp" style={{fontSize:'.73rem',padding:'.4rem .75rem',width:'auto',cursor:'pointer'}} title={lang==="es"?"Filtrar por estatus migratorio":"Filter by immigration status"}>
          <option value="all">{lang === "es" ? "🛂 Todo Estatus Migratorio" : "🛂 All Immigration Statuses"}</option>
          {immigCounts.opciones.map(o => <option key={o.id} value={o.id}>{o.label} ({o.n})</option>)}
          {immigCounts.sinEstatus > 0 && <option value={SIN_ESTATUS}>{lang === "es" ? `Sin estatus (${immigCounts.sinEstatus})` : `No status (${immigCounts.sinEstatus})`}</option>}
        </select>
      )}
      <select value={langFilter} onChange={e=>setLangFilter(e.target.value)} className="dkt-inp" style={{fontSize:'.73rem',padding:'.4rem .75rem',width:'auto',cursor:'pointer'}} title={lang==="es"?"Filtrar por idioma del cliente":"Filter by client language"}>
        <option value="all">{lang === "es" ? "🗣️ Todo Idioma" : "🗣️ All Languages"}</option>
        <option value="es">{lang === "es" ? `🇪🇸 Español (${langCounts.es})` : `🇪🇸 Spanish (${langCounts.es})`}</option>
        <option value="en">{lang === "es" ? `🇺🇸 Inglés (${langCounts.en})` : `🇺🇸 English (${langCounts.en})`}</option>
      </select>
      <select value={attendFilter} onChange={e=>setAttendFilter(e.target.value)} className="dkt-inp" style={{fontSize:'.73rem',padding:'.4rem .75rem',width:'auto',cursor:'pointer'}} title={lang==="es"?"Filtrar por quién atiende":"Filter by who handles"}>
        <option value="all">{lang === "es" ? "👤 Atiende: Todos" : "👤 Handled: All"}</option>
        <option value="none">{lang === "es" ? "Sin asignar" : "Unassigned"}</option>
        {attendOptions(users).map(u => { const l = seatLabelForUtil(u.id, seatLabels, users); return <option key={u.id} value={u.id}>{l.name}</option>; })}
        {/* Nombres que vinieron de una importacion y todavia no tienen asiento.
            Sin esto una cartera importada seria imposible de filtrar por quien
            la atiende hasta dar de alta a cada persona. */}
        {nombresLibresDeLaCartera(clients).map(n => <option key={PREFIJO_LIBRE+n} value={PREFIJO_LIBRE+n}>{n}{lang==="es"?" (sin asiento)":" (no seat)"}</option>)}
      </select>
      <select value={sortMode} onChange={e=>setSortMode(e.target.value)} className="dkt-inp"
        style={{fontSize:'.73rem',padding:'.4rem .75rem',width:'auto',cursor:'pointer'}}
        title={lang==="es"?"Ordenar clientes":"Sort clients"}>
        <option value="name-asc">{lang === "es" ? "🔤 Nombre A → Z" : "🔤 Name A → Z"}</option>
        <option value="name-desc">{lang === "es" ? "🔤 Nombre Z → A" : "🔤 Name Z → A"}</option>
        <option value="created-desc">{lang === "es" ? "🆕 Recién agregados" : "🆕 Newest first"}</option>
        <option value="created-asc">{lang === "es" ? "📁 Más antiguos" : "📁 Oldest first"}</option>
      </select>
      {hasFilters && (
        <button onClick={clearFilters} className="dkt-btn-g">
          <X size={11} /> {lang === "es" ? "Limpiar" : "Clear"}
        </button>
      )}
    </div>
    {/* Un filtro que solo ofrece una opción tiene que explicarse, no callar.
        Javier Volcanes, 2026-08-28: "solo le sale TX, y verificas su dirección
        y sí tiene estados" — su cartera entró con la dirección entera en una
        casilla, así que la columna Estado estaba vacía y no había más estados
        que ofrecer. El aviso solo sale en ese caso concreto (una opción o
        ninguna, y fichas sin estado de verdad), no cada vez que a alguien le
        falte un dato suelto. E-146 / regla de oro 20. */}
    {clientesSinEstado > 0 && allStates.length <= 1 && (
      <div style={{fontSize:'.72rem',color:'var(--c-amber,#ffb700)',background:'var(--c-surface2,#112538)',border:'1px solid var(--c-border,#1a3550)',borderRadius:8,padding:'.5rem .7rem',marginBottom:'.75rem',lineHeight:1.5}}>
        {lang === "es"
          ? `📍 El filtro por estado solo puede ofrecer ${allStates.length} porque ${clientesSinEstado} fichas tienen la casilla Estado vacía — normalmente porque la importación no trajo esa columna. En Importar tienes "Recuperar direcciones", que lo saca del código postal de cada ficha sin pisar nada de lo que ya esté escrito.`
          : `📍 The state filter can only offer ${allStates.length} because ${clientesSinEstado} records have an empty State box — usually because the import never brought that column. Import has a "Recover addresses" tool that derives it from each record's ZIP code without overwriting anything already filled in.`}
      </div>
    )}
    {/* Bulk selection bar — visible whenever ≥1 client is checked. The
        "select all" toggle operates on the currently-visible (filtered +
        sorted) set so the user can't accidentally delete clients hidden
        by a filter. */}
    {sorted.length > 0 && (() => {
      const visibleIds = sorted.map(c => c.id);
      const visibleSelectedCount = visibleIds.filter(id => selectedIds.has(id)).length;
      const allVisibleSelected = visibleSelectedCount === visibleIds.length && visibleIds.length > 0;
      const someVisibleSelected = visibleSelectedCount > 0 && !allVisibleSelected;
      const toggleAllVisible = () => {
        setSelectedIds(prev => {
          const next = new Set(prev);
          if (allVisibleSelected) {
            for (const id of visibleIds) next.delete(id);
          } else {
            for (const id of visibleIds) next.add(id);
          }
          return next;
        });
      };
      return (
        <div style={{display:'flex',alignItems:'center',gap:'.75rem',marginBottom:'.6rem',padding:'.55rem .85rem',background:selectedIds.size>0?'rgba(0,212,255,.06)':'var(--c-surface2,#112538)',border:`1px solid ${selectedIds.size>0?'rgba(0,212,255,.25)':'var(--c-border,#1a3550)'}`,borderRadius:8,flexWrap:'wrap'}}>
          <label style={{display:'flex',alignItems:'center',gap:'.45rem',cursor:'pointer',fontSize:'.75rem',color:'var(--c-text2,#7aa3c0)',fontWeight:600}}>
            <input
              type="checkbox"
              checked={allVisibleSelected}
              ref={el => { if (el) el.indeterminate = someVisibleSelected; }}
              onChange={toggleAllVisible}
              style={{width:16,height:16,cursor:'pointer',accentColor:'var(--c-cyan,#00d4ff)'}}
            />
            <span>{lang === 'es' ? 'Seleccionar todos' : 'Select all'} ({sorted.length})</span>
          </label>
          {selectedIds.size > 0 && (
            <>
              <div style={{height:18,width:1,background:'var(--c-border,#1a3550)'}}/>
              <span style={{fontSize:'.75rem',fontWeight:700,color:'var(--c-cyan,#00d4ff)'}}>
                {selectedIds.size} {lang === 'es' ? 'seleccionado' + (selectedIds.size === 1 ? '' : 's') : 'selected'}
              </span>
              {/* Etiquetas de correo para lo seleccionado. Va aquí y no en una
                  pantalla aparte porque el filtrado que hace falta para un
                  envío (por agente, estado, etiquetas…) ya está resuelto en
                  esta lista — duplicarlo sería mantener dos buscadores. */}
              <button
                onClick={() => setLabelsOpen(true)}
                style={{display:'inline-flex',alignItems:'center',gap:5,padding:'.35rem .8rem',borderRadius:7,cursor:'pointer',border:'1px solid var(--c-border,#1a3550)',background:'var(--c-surface2,#112538)',color:'var(--c-text,#c8dff0)',fontSize:'.73rem',fontWeight:700,fontFamily:'inherit'}}
              >
                🏷️ {lang === 'es' ? 'Etiquetas de correo' : 'Mailing labels'}
              </button>
              <button
                onClick={() => setQuitarEtq({ ids: [...selectedIds] })}
                title={lang === 'es' ? 'Quitar una etiqueta de los seleccionados' : 'Remove a tag from the selected'}
                style={{display:'inline-flex',alignItems:'center',gap:5,padding:'.35rem .8rem',borderRadius:7,cursor:'pointer',border:'1px solid var(--c-border,#1a3550)',background:'var(--c-surface2,#112538)',color:'var(--c-text,#c8dff0)',fontSize:'.73rem',fontWeight:700,fontFamily:'inherit'}}
              >
                ✂️ {lang === 'es' ? 'Quitar etiqueta' : 'Remove tag'}
              </button>
              <button
                onClick={() => setBulkDelConfirm(true)}
                style={{display:'inline-flex',alignItems:'center',gap:5,padding:'.35rem .8rem',borderRadius:7,cursor:'pointer',border:'1px solid var(--c-red,#ef4444)',background:'rgba(239,68,68,.12)',color:'var(--c-red,#ef4444)',fontSize:'.73rem',fontWeight:700,fontFamily:'inherit'}}
              >
                <Trash2 size={12}/>
                {lang === 'es' ? `Borrar ${selectedIds.size}` : `Delete ${selectedIds.size}`}
              </button>
              <button
                onClick={() => setSelectedIds(new Set())}
                style={{display:'inline-flex',alignItems:'center',gap:4,padding:'.35rem .65rem',borderRadius:7,cursor:'pointer',border:'1px solid var(--c-border,#1a3550)',background:'var(--c-surface2,#112538)',color:'var(--c-text2,#7aa3c0)',fontSize:'.7rem',fontWeight:600,fontFamily:'inherit'}}
              >
                <X size={11}/>
                {lang === 'es' ? 'Limpiar' : 'Clear'}
              </button>
            </>
          )}
        </div>
      );
    })()}
    {sorted.length === 0 && (
      /* "No se encontraron clientes" MIENTE cuando SÍ los hay y lo que pasa es
         que un filtro los tapa. Lissette, 2026-09-04: acababa de importar la
         cartera de una agencia, abrió Clientes, y la pantalla le dijo que no
         había ninguno — con 244 dentro y el filtro "Inactivos (0)" pegado de
         una visita anterior. Recién importado, eso se lee como "se perdió
         todo", que es el peor susto que puede dar esta pantalla.

         Los filtros se recuerdan a propósito (para eso están), así que el
         arreglo no es olvidarlos: es DECIR LA VERDAD — cuántos hay, que lo que
         estorba es el filtro, y un botón grande para quitarlo. */
      <div className="dkt-card" style={{textAlign:"center",padding:"3.5rem 1rem"}}>
        {hasFilters && clients.length > 0 ? (
          <>
            <div style={{color:"var(--c-white,#eef6ff)",fontSize:".95rem",fontWeight:700,marginBottom:".35rem"}}>
              {lang === "es"
                ? `Tienes ${clients.length} cliente${clients.length === 1 ? "" : "s"} — los está tapando un filtro`
                : `You have ${clients.length} client${clients.length === 1 ? "" : "s"} — a filter is hiding them`}
            </div>
            <div style={{color:"var(--c-text3,#45688a)",fontSize:".8rem",marginBottom:".75rem",lineHeight:1.5}}>
              {lang === "es"
                ? "Ninguno cumple los filtros de arriba. No se ha perdido nada."
                : "None of them match the filters above. Nothing has been lost."}
            </div>
            <button onClick={clearFilters} className="dkt-btn-p">
              {lang === "es" ? "Quitar los filtros y verlos todos" : "Clear the filters and show them all"}
            </button>
          </>
        ) : esSoloSusProspectos(currentUser?.seatScope) ? (
          /* MISMA LECCIÓN QUE EL BLOQUE DE ARRIBA, otro motivo. Un asiento de
             "solo sus prospectos" abre esta pantalla el primer día y está
             VACÍA de verdad: su lista solo tiene lo que ella misma cree, y
             todavía no ha creado nada. "No se encontraron clientes" ahí se lee
             como que no cargó, y la llamada le llega a Lissette.

             Se dice lo que pasa y lo que sigue. (Regla de oro 89: un vacío sin
             explicar se lee como avería.) */
          <>
            <div style={{color:"var(--c-white,#eef6ff)",fontSize:".95rem",fontWeight:700,marginBottom:".35rem"}}>
              {lang === "es" ? "Aquí van los prospectos que tú crees" : "Your own prospects show up here"}
            </div>
            <div style={{color:"var(--c-text3,#45688a)",fontSize:".8rem",lineHeight:1.5}}>
              {lang === "es"
                ? "Esta lista empieza vacía a propósito: solo muestra las fichas que creas tú, mientras sigan en Prospecto. Los clientes que ya existían en la agencia no salen aquí. Crea el primero con el botón de arriba."
                : "This list starts empty on purpose: it only shows the records you create, while they stay in Prospect. Clients that already existed in the agency never appear here. Create your first one with the button above."}
            </div>
          </>
        ) : (
          <>
            <div style={{color:"var(--c-text3,#45688a)",fontSize:".85rem",marginBottom:".5rem"}}>{tc.noClients}</div>
            {hasFilters && <button onClick={clearFilters} className="text-xs text-blue-600 hover:underline">{lang === "es" ? "Limpiar filtros" : "Clear filters"}</button>}
          </>
        )}
      </div>
    )}
    {/* La lista y su paginacion bajan en su propia caja; lo de arriba se
        queda quieto (Lissette 2026-09-25, CajaConScroll.jsx). */}
    <CajaConScroll>
    <div className="space-y-2">
      {paginated.map(c => {
        const cp = policiesByClient.get(c.id) || [];
        const hasMissing = clientsWithMissingDocs.has(c.id);
        const hasBday = birthdayToday(c.dob);
        // Solo las aseguradoras de polizas VIVAS. Antes salian todas, asi
        // que un cliente con una poliza cancelada seguia enseñando esa
        // aseguradora como si estuviera al dia (Lissette 2026-08-21).
        const carriers = aseguradorasVivas(cp);
        // Lissette 2026-05-27 (fix): use the PER-TAB lastSeen stamps so
        // items added during a visit appear as soon as the user is back
        // in the list — NOT after a second visit (the old unmount-stamp
        // bug). totalNewForClient sums each tab's count using the same
        // stamps the profile tabs read.
        const newCount = totalNewForClient({
          userId: currentUser?.id,
          clientId: c.id,
          policies: cp,
          docs: freshIndex.docs.get(c.id) || [],
          signatures: freshIndex.signatures.get(c.id) || [],
          tasks: freshIndex.tasks.get(c.id) || [],
          eligibilityAlerts: freshIndex.eligibilityAlerts.get(c.id) || [],
          changeHistory: freshIndex.changeHistory.get(c.id) || [],
          activitylog: freshIndex.activitylog.get(c.id) || [],
          clientNotes: freshIndex.clientNotes.get(c.id) || [],
        });
        return (
          <div key={c.id} onClick={()=>openDetail(c)} className="dkt-card"
            style={{padding:'1rem 1.1rem',cursor:'pointer',display:'flex',alignItems:'center',gap:'1rem',
              background:selectedIds.has(c.id)?'rgba(0,212,255,.05)':undefined,
              borderColor:selectedIds.has(c.id)?'rgba(0,212,255,.35)':undefined}}>
            <div style={{position:'absolute',left:0,top:'15%',bottom:'15%',width:3,borderRadius:'0 3px 3px 0',
              background:c.status==='active'?'var(--c-green,#00ff88)':c.status==='pending'?'var(--c-amber,#ffb700)':c.status==='prospect'?'var(--c-cyan,#00d4ff)':'var(--c-text3,#45688a)'}}/>
            {/* Row checkbox. stopPropagation so clicking the box doesn't
                also trigger openDetail. */}
            <input
              type="checkbox"
              checked={selectedIds.has(c.id)}
              onClick={e => e.stopPropagation()}
              onChange={e => {
                const checked = e.target.checked;
                setSelectedIds(prev => {
                  const next = new Set(prev);
                  if (checked) next.add(c.id); else next.delete(c.id);
                  return next;
                });
              }}
              style={{width:16,height:16,cursor:'pointer',accentColor:'var(--c-cyan,#00d4ff)',flexShrink:0}}
            />
            <div style={{position:'relative',flexShrink:0}}>
              <Avatar client={c} size={11}/>
              {hasBday&&<span style={{position:'absolute',top:-3,right:-3,fontSize:13}}>🎂</span>}
            </div>
            <div style={{flex:1,minWidth:0}}>
              <div style={{display:'flex',alignItems:'center',gap:'.5rem',flexWrap:'wrap',marginBottom:'.3rem'}}>
                {/* El nombre es un ENLACE de verdad, no un texto con onClick.
                    Así el navegador ofrece "abrir en pestaña nueva" con el
                    clic derecho, y el clic con rueda o con Ctrl también la
                    abren — sin que Deskte tenga que programar nada de eso
                    (Lissette 2026-08-19). El clic normal sigue abriendo la
                    ficha en la misma pantalla, como siempre: por eso el
                    preventDefault, que solo se aplica al clic simple. */}
                <a href={`#client/${c.id}`}
                  onClick={(e)=>{ if(e.metaKey||e.ctrlKey||e.shiftKey||e.button===1) return; e.preventDefault(); }}
                  style={{fontWeight:700,fontSize:'.95rem',color:'var(--c-white,#eef6ff)',textDecoration:'none'}}>{formatClientName(c)}</a>
                {newCount > 0 && <span title={lang==="es"?`${newCount} novedades desde tu última visita`:`${newCount} new since your last visit`} style={{background:"#ffb700",color:"#1a2332",borderRadius:"9999px",padding:"1px 7px",fontSize:".6rem",fontWeight:800,fontFamily:"var(--font-mono)",lineHeight:1.3,letterSpacing:".02em",boxShadow:"0 0 6px rgba(255,183,0,.4)"}} aria-label={lang==="es"?`${newCount} novedades`:`${newCount} new`}>{newCount > 99 ? "99+" : newCount}</span>}
                <Badge status={c.status} t={t}/>
                {/* LISTA PARA SOMETER (Lissette 2026-09-21: "que lo siga
                    mostrando en prospectos con etiqueta"). Va AL LADO del
                    estatus y no en su lugar: la persona sigue siendo prospecto
                    o referido — por eso no desaparece de esa lista — y esto
                    solo dice que ya está lista para someterse. */}
                {c.readyToSubmit && <span title={lang==="es"?"Lista para someter":"Ready to submit"}
                  style={{fontSize:'.62rem',background:'rgba(20,184,166,.15)',border:'1px solid #14b8a6',color:'#14b8a6',padding:'.1rem .5rem',borderRadius:100,fontWeight:700,display:'inline-flex',alignItems:'center',gap:3}}>
                  📤 {lang==="es"?"Lista para someter":"Ready to submit"}
                </span>}
                {/* "Atiende" chip — who handles this client, visible right in the
                    list (Lissette 2026-06-24: "quiero verla también afuera"). */}
                {(()=>{ const al=etiquetaDeAtiende(c.attendedBySeatId,c.attendedByName,seatLabels,users); return al ? <span title={lang==="es"?(al.libre?`Atiende: ${al.name} (todavia sin asiento)`:"Atiende"):(al.libre?`Handled by ${al.name} (no seat yet)`:"Handled by")} style={{fontSize:'.62rem',background:`${al.color}22`,border:`1px ${al.libre?'dashed':'solid'} ${al.color}`,color:al.color,padding:'.1rem .5rem',borderRadius:100,fontWeight:700,display:'inline-flex',alignItems:'center',gap:3}}><span style={{width:6,height:6,borderRadius:'50%',background:al.color}}/>{al.name}</span> : null; })()}
                {/* Custom tags/labels up top, right by the name (Lissette
                    2026-06-19: "no la quiero ahí abajo, la quiero arriba donde
                    te lo marqué"). Show ALL, no truncation; cyan pill style. */}
                {Array.isArray(c.tags)&&c.tags.length>0&&c.tags.map((tag,ti)=>{ const st=tagChipStyle(tagColorFor(tag,tagColors)); return <span key={'tag'+ti} title={lang==="es"?"Etiqueta":"Tag"} style={{fontSize:'.62rem',background:st.bg,border:`1px solid ${st.border}`,color:st.fg,padding:'.1rem .5rem',borderRadius:100,fontWeight:700}}>{tag}</span>;})}
                {/* "Falta info" — the import flow stamps missing required
                    names with "(falta nombre)" / "(falta apellido)" so the
                    row can save. Surface these rows so the user can find
                    + correct them after a bulk import. */}
                {(typeof c.firstName === 'string' && c.firstName.includes('(falta')) || (typeof c.lastName === 'string' && c.lastName.includes('(falta')) ? (
                  <span style={{display:'flex',alignItems:'center',gap:3,fontSize:'.62rem',color:'var(--c-amber,#ffb700)',background:'var(--c-amber-dim)',padding:'.1rem .45rem',borderRadius:100,border:'1px solid rgba(255,183,0,.35)',fontWeight:700}}>
                    <AlertTriangle size={8}/>{lang==="es"?"Falta info":"Missing info"}
                  </span>
                ) : null}
                {hasMissing&&<span style={{display:'flex',alignItems:'center',gap:3,fontSize:'.62rem',color:'var(--c-amber,#ffb700)',background:'var(--c-amber-dim)',padding:'.1rem .45rem',borderRadius:100,border:'1px solid rgba(255,183,0,.15)',fontWeight:700}}><AlertTriangle size={8}/>{lang==="es"?"Docs":"Missing docs"}</span>}
                {c.linkedParentName&&<span style={{fontSize:'.6rem',color:'var(--c-amber,#ffb700)',fontWeight:600}}>↗ {c.linkedParentName}</span>}
                {/* Referido por — automatica, igual que la de arriba. El dato ya
                    estaba en la ficha; lo que faltaba era enseñarlo donde se ve
                    de un vistazo (Lissette 2026-08-28). */}
                {(()=>{ const quien=nombreDeQuienRefirio(c,(id)=>clientesPorId.get(id)); return quien
                  ? <span title={lang==="es"?`Referido por ${quien}`:`Referred by ${quien}`}
                      style={{display:'inline-flex',alignItems:'center',gap:3,fontSize:'.6rem',color:'#a78bfa',background:'rgba(167,139,250,.12)',border:'1px solid rgba(167,139,250,.28)',padding:'.1rem .45rem',borderRadius:100,fontWeight:700}}>
                      🔗 {lang==="es"?"Referido por":"Referred by"} {quien}
                    </span>
                  : null; })()}
              </div>
              <div style={{display:'flex',flexWrap:'wrap',gap:'.75rem',marginBottom:'.3rem'}}>
                {c.phone&&<span style={{display:'flex',alignItems:'center',gap:4,fontSize:'.75rem',color:'var(--c-text2,#7aa3c0)'}}><Phone size={10}/>{c.phone}</span>}
                {c.phone&&<a href={`tel:${String(c.phone).replace(/[^\d+]/g,'')}`} onClick={e=>e.stopPropagation()} title={lang==="es"?"Llamar a este cliente":"Call this client"} style={{display:'inline-flex',alignItems:'center',gap:3,fontSize:'.68rem',background:'rgba(16,185,129,.12)',border:'1px solid rgba(16,185,129,.35)',color:'#10b981',padding:'.08rem .45rem',borderRadius:6,cursor:'pointer',fontWeight:700,lineHeight:1.4,textDecoration:'none'}}><Phone size={10}/>{lang==="es"?"Llamar":"Call"}</a>}
                {c.phone&&<button onClick={e=>{e.stopPropagation();openWhatsApp(c.phone);}} title={lang==="es"?"Abrir WhatsApp con este cliente":"Open WhatsApp with this client"} style={{display:'inline-flex',alignItems:'center',gap:3,fontSize:'.68rem',background:'rgba(37,211,102,.1)',border:'1px solid rgba(37,211,102,.3)',color:'#25d366',padding:'.08rem .45rem',borderRadius:6,cursor:'pointer',fontWeight:600,lineHeight:1.4}}><MessageSquare size={10}/>WhatsApp</button>}
                {c.email&&<span style={{display:'flex',alignItems:'center',gap:4,fontSize:'.75rem',color:'var(--c-text2,#7aa3c0)'}}><Mail size={10}/>{c.email}</span>}
                {(c.addressCity||c.addressState)&&<span style={{display:'flex',alignItems:'center',gap:4,fontSize:'.75rem',color:'var(--c-text2,#7aa3c0)'}}><Building size={10}/>{[c.addressCity,c.addressState].filter(Boolean).join(", ")}</span>}
              </div>
              <div style={{display:'flex',flexWrap:'wrap',alignItems:'center',gap:'.4rem'}}>
                {carriers.map((car,ci)=><span key={ci} style={{fontSize:'.68rem',background:'var(--c-surface2,#112538)',border:'1px solid var(--c-border,#1a3550)',color:'var(--c-text2,#7aa3c0)',padding:'.1rem .5rem',borderRadius:6,fontWeight:600}}>{car}</span>)}
                {/* Iconos de tipo de poliza: solo las vivas (Lissette
                    2026-06-23: "me salen todas hasta las canceladas"). Ya
                    filtraba bien; usa el ayudante compartido para que las
                    etiquetas de al lado y estos iconos no puedan volver a
                    discrepar. */}
                {(()=>{ const liveCp=polizasVivas(cp); return liveCp.length>0&&<div style={{display:'flex',gap:2}}>{liveCp.map(p=><span key={p.id} title={getPolicyType(p.type).label} style={{fontSize:13}}>{getPolicyType(p.type).icon}</span>)}</div>; })()}
                {/* Tamaño de familia — SIEMPRE visible en la lista. Usa el
                    campo "Personas en el Hogar" si está lleno; si no, lo
                    calcula (titular + cónyuge + dependientes) con los datos que
                    ya viajan en la fila. Antes dependía solo de householdSize,
                    que casi nunca se llena, así que el badge no salía nunca
                    (Lissette 2026-06-30: "no me muestra el family size en la lista"). */}
                {(()=>{
                  const spouseIn = hasCurrentSpouse(c) ? 1 : 0;
                  const depIn = Array.isArray(c.dependents) ? c.dependents.filter(d=>d&&(d.firstName||d.lastName)).length : 0;
                  const hh = Number(c.householdSize);
                  const famSize = (c.householdSize && !Number.isNaN(hh) && hh>0) ? hh : (1 + spouseIn + depIn);
                  return <>
                    <div style={{width:1,height:14,background:'var(--c-border,#1a3550)'}}/>
                    <span title={lang==="es"?"Tamaño de familia (titular + cónyuge + dependientes)":"Family size (primary + spouse + dependents)"} style={{fontSize:'.65rem',background:'var(--c-surface2,#112538)',border:'1px solid var(--c-border,#1a3550)',color:'var(--c-text2,#7aa3c0)',padding:'.1rem .45rem',borderRadius:6,fontWeight:600}}>🏠 {famSize}</span>
                  </>;
                })()}
                {/* Agente asignado — editable inline (click to edit, blur/Enter to save) */}
                <div style={{width:1,height:14,background:'var(--c-border,#1a3550)'}}/>
                {editingAgentId===c.id ? (
                  // Real <select> (the old datalist input wouldn't open reliably and
                  // had no "none" option; clearing it + clicking the row opened the
                  // ficha). No seats — agentPickOptions already excludes assistants.
                  // The current value is merged in so a legacy name still shows. E-015.
                  (()=>{ const rowAgentOpts=[...new Set([...agentPickOptions, agentDraft].filter(Boolean))].sort((a,b)=>a.localeCompare(b)); return (
                  <select autoFocus value={rowAgentOpts.includes(agentDraft)?agentDraft:""}
                    onClick={e=>e.stopPropagation()}
                    onMouseDown={e=>e.stopPropagation()}
                    onChange={e=>{ e.stopPropagation(); const v=e.target.value; if(v==="__custom__"){ const name=window.prompt(lang==="es"?"Nombre del agente:":"Agent name:"); setEditingAgentId(null); if(name!=null&&name.trim()) saveCardAgentValue(c.id,name.trim()); return; } setAgentDraft(v); saveCardAgentValue(c.id,v); }}
                    onBlur={()=>setEditingAgentId(null)}
                    onKeyDown={e=>{ if(e.key==="Escape"){setEditingAgentId(null);} }}
                    style={{fontSize:'.68rem',padding:'.1rem .4rem',borderRadius:6,border:'1px solid var(--c-cyan,#00d4ff)',background:'var(--c-surface2,#112538)',color:'var(--c-cyan,#00d4ff)',outline:'none',maxWidth:170,fontFamily:'inherit',cursor:'pointer'}}>
                    <option value="">{lang==="es"?"— Sin asignar —":"— Unassigned —"}</option>
                    {rowAgentOpts.map(a=><option key={a} value={a}>{a}</option>)}
                    <option value="__custom__">{lang==="es"?"✏️ Otro nombre…":"✏️ Other name…"}</option>
                  </select> ); })()
                ) : (
                  <button onClick={e=>{e.stopPropagation();setAgentDraft(c.assignedAgent||c.agentName||"");setEditingAgentId(c.id);}}
                    title={lang==="es"?"Cambiar agente":"Change agent"}
                    style={{fontSize:'.65rem',background:'rgba(0,212,255,.08)',border:'1px solid rgba(0,212,255,.2)',color:'var(--c-cyan,#00d4ff)',padding:'.1rem .5rem',borderRadius:6,fontWeight:700,cursor:'pointer',fontFamily:'inherit',display:'inline-flex',alignItems:'center',gap:4}}>
                    👤 {c.assignedAgent||c.agentName||(lang==="es"?"Sin agente":"No agent")}
                  </button>
                )}
              </div>
            </div>
            <div style={{display:'flex',alignItems:'center',gap:'.3rem',flexShrink:0}} onClick={e=>e.stopPropagation()}>
              <button onClick={e=>{e.stopPropagation();openDetail(c);}} className="dkt-btn-g"><Eye size={12}/>{lang==="es"?"Ver":"View"}</button>
              <button onClick={e=>{e.stopPropagation();setModal(c);}} className="dkt-btn-g"><Edit2 size={12}/></button>
              <button onClick={e=>{e.stopPropagation();setDelConfirm(c.id);}} style={{background:'none',border:'none',cursor:'pointer',color:'var(--c-text3,#45688a)',padding:'4px',borderRadius:6,lineHeight:0,transition:'color .2s'}}
                onMouseEnter={e=>e.currentTarget.style.color='var(--c-red,#ff3d6b)'}
                onMouseLeave={e=>e.currentTarget.style.color='var(--c-text3,#45688a)'}><Trash2 size={13}/></button>
            </div>
          </div>
        );
      })}
    </div>
    {/* Pagination footer. Shows whenever there's anything to paginate
        (sorted.length > 0). "Showing N–M of T" sits on the left, the
        page size selector + prev / next on the right. Hidden entirely
        when the filter result is empty since the placeholder above
        already explains the state. */}
    {sorted.length > 0 && (
      <div style={{
        display:'flex', alignItems:'center', justifyContent:'space-between',
        gap:'.75rem', flexWrap:'wrap',
        marginTop:'1rem', padding:'.6rem .85rem',
        background:'var(--c-surface2,#112538)', border:'1px solid var(--c-border,#1a3550)',
        borderRadius:8, fontSize:'.72rem', color:'var(--c-text2,#7aa3c0)',
      }}>
        <div>
          {lang === 'es'
            ? `Mostrando ${pageStart + 1}–${Math.min(pageStart + pageSize, sorted.length)} de ${sorted.length}`
            : `Showing ${pageStart + 1}–${Math.min(pageStart + pageSize, sorted.length)} of ${sorted.length}`}
        </div>
        <div style={{display:'flex', alignItems:'center', gap:'.5rem', flexWrap:'wrap'}}>
          <label style={{display:'flex', alignItems:'center', gap:'.35rem', fontSize:'.7rem'}}>
            <span>{lang === 'es' ? 'Por página:' : 'Per page:'}</span>
            <select
              value={pageSize}
              onChange={e => setPageSize(parseInt(e.target.value, 10))}
              style={{padding:'2px 6px', borderRadius:6, border:'1px solid var(--c-border,#1a3550)', background:'var(--c-surface,#0d1c2e)', color:'var(--c-text,#c8dff0)', fontFamily:'inherit', cursor:'pointer'}}
            >
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
              <option value={200}>200</option>
            </select>
          </label>
          <div style={{display:'flex', alignItems:'center', gap:'.4rem'}}>
            <button
              type="button"
              onClick={() => setPage(p => Math.max(1, p - 1))}
              disabled={page <= 1}
              style={{
                padding:'.3rem .7rem', borderRadius:6, fontFamily:'inherit', fontSize:'.7rem', fontWeight:700,
                border:'1px solid var(--c-border,#1a3550)',
                background: page <= 1 ? 'var(--c-surface,#0d1c2e)' : 'var(--c-surface2,#112538)',
                color: page <= 1 ? 'var(--c-text3,#45688a)' : 'var(--c-text,#c8dff0)',
                cursor: page <= 1 ? 'not-allowed' : 'pointer',
              }}
            >
              ◀ {lang === 'es' ? 'Anterior' : 'Prev'}
            </button>
            <span style={{fontSize:'.7rem', fontWeight:700, color:'var(--c-text,#c8dff0)', minWidth:90, textAlign:'center'}}>
              {lang === 'es' ? `Página ${page} de ${totalPages}` : `Page ${page} of ${totalPages}`}
            </span>
            <button
              type="button"
              onClick={() => setPage(p => Math.min(totalPages, p + 1))}
              disabled={page >= totalPages}
              style={{
                padding:'.3rem .7rem', borderRadius:6, fontFamily:'inherit', fontSize:'.7rem', fontWeight:700,
                border:'1px solid var(--c-border,#1a3550)',
                background: page >= totalPages ? 'var(--c-surface,#0d1c2e)' : 'var(--c-surface2,#112538)',
                color: page >= totalPages ? 'var(--c-text3,#45688a)' : 'var(--c-text,#c8dff0)',
                cursor: page >= totalPages ? 'not-allowed' : 'pointer',
              }}
            >
              {lang === 'es' ? 'Siguiente' : 'Next'} ▶
            </button>
          </div>
        </div>
      </div>
    )}
    </CajaConScroll>
    {renderInsuredModal()}
    {modal && <Modal title={modal === "add" ? t.clientForm.addTitle : t.clientForm.editTitle} onClose={() => setModal(null)} wide>
      {/* On ADD, modal === "add" (a string) so modal?.id and detail?.id are
          BOTH undefined — the equality check below would otherwise be true
          and we'd seed `detail` with an idless ghost client, which then
          PUTs to /clients/undefined → 404 on the next edit. The extra
          modal !== "add" guard prevents that contamination. */}
      <ClientForm key={modal === "add" ? "add" : modal.id} client={modal === "add" ? null : modal} onSave={async f => {
        const result = await save(f);
        if (modal === "add") {
          if (result) setModal(result);
          return;
        }
        // Edit-mode save: close the form AND open the client's
        // profile (detail view), not the clients list. Lissette
        // 2026-05-27 ("no se va a el perfil de cliente").
        if (result) {
          setDetail(d => ({ ...(d || {}), ...result }));
        }
        setModal(null);
      }} onPersist={save} onClose={() => setModal(null)} t={t} lang={lang} onClientsChange={onClientsChange} policies={policies} onPoliciesAdd={(np)=>onPoliciesChange(prev=>[...prev,...np])} onSsnSaved={handleSsnSaved} customTabDefs={customTabDefs} onCustomTabDefsChange={onCustomTabDefsChange} />
    </Modal>}
    {delConfirm && <Modal title={t.common.confirm} onClose={() => setDelConfirm(null)}>
      <p style={{color:"var(--c-text,#c8dff0)",marginBottom:"1.25rem",fontSize:".88rem"}}>{tc.deleteConfirm}</p>
      <div className="flex gap-3">
        <button onClick={() => del(delConfirm)} className="flex-1 bg-red-600 text-gray-900 font-semibold py-2.5 rounded-xl">{t.common.yes}</button>
        <button onClick={() => setDelConfirm(null)} className="flex-1 bg-gray-100 text-gray-700 font-semibold py-2.5 rounded-xl">{t.common.no}</button>
      </div>
    </Modal>}
    {/* PIN gate for SSN mutations. The backend rejects the PUT with
        PIN_REQUIRED_FOR_SSN_EDIT when an existing SSN (primary or
        spouse) is being changed without a PIN. We open this small
        modal, the user types their 6-digit PIN, and we retry the
        update with the pin in the payload. */}
    {ssnEditPin && (
      <Modal title={lang === 'es' ? '🔒 PIN requerido para modificar SSN' : '🔒 PIN required to modify SSN'} onClose={() => setSsnEditPin(null)}>
        <p style={{color:"var(--c-text2,#7aa3c0)",marginBottom:".85rem",fontSize:".8rem",lineHeight:1.5}}>
          {lang === 'es'
            ? `Estás cambiando el SSN de un cliente que ya lo tenía registrado. Ingresa ${pinOwnerLabel(true)} para confirmar.`
            : `You are changing the SSN of a client who already had one on file. Enter ${pinOwnerLabel(false)} to confirm.`}
        </p>
        <input
          type="text"
          inputMode="numeric"
          autoComplete="off"
          data-1p-ignore
          data-lpignore="true"
          maxLength={6}
          className="dkt-inp"
          value={ssnEditPin.pin || ''}
          onChange={(e) => {
            const v = e.target.value.replace(/\D/g, '').slice(0, 6);
            setSsnEditPin(s => ({ ...s, pin: v, pinError: null }));
          }}
          placeholder="••••••"
          style={{textAlign:'center',fontSize:'1.1rem',fontFamily:'var(--font-mono)',letterSpacing:'.4em',marginBottom:'.5rem',WebkitTextSecurity:'disc'}}
          autoFocus
        />
        {ssnEditPin.pinError && (
          <div style={{color:'var(--c-red,#ef4444)',fontSize:'.72rem',marginBottom:'.5rem'}}>
            ⚠ {ssnEditPin.pinError}
          </div>
        )}
        <div className="flex gap-3" style={{marginTop:'.75rem'}}>
          <button
            onClick={() => setSsnEditPin(null)}
            className="flex-1 bg-gray-100 text-gray-700 font-semibold py-2.5 rounded-xl"
            disabled={ssnEditPin.submitting}
          >
            {lang === 'es' ? 'Cancelar' : 'Cancel'}
          </button>
          <button
            onClick={async () => {
              const pin = ssnEditPin.pin || '';
              if (!/^\d{6}$/.test(pin)) {
                setSsnEditPin(s => ({ ...s, pinError: lang === 'es' ? 'PIN debe ser 6 dígitos' : 'PIN must be 6 digits' }));
                return;
              }
              setSsnEditPin(s => ({ ...s, submitting: true, pinError: null }));
              try {
                await performUpdate(ssnEditPin.modalId, ssnEditPin.form, pin);
                setSsnEditPin(null);
                setModal(null);
              } catch (err) {
                // Todo lo que sea del PIN se queda DENTRO de la ventana, con el
                // texto que arma pinErrorText (el mismo que usa la ventana del
                // SSN). Antes solo se traducía PIN_WRONG: un PIN bloqueado o sin
                // configurar caía al `alert` con el mensaje del servidor en
                // inglés y encima cerraba la ventana, así que se perdía todo lo
                // editado en la ficha.
                const esPin = err && ['PIN_WRONG', 'PIN_FORMAT', 'PIN_LOCKED', 'PIN_NOT_SET', 'NO_PIN_OWNER'].includes(err.code);
                if (esPin) {
                  setSsnEditPin(s => ({ ...s, submitting: false, pinError: pinErrorText(err, lang === 'es'), pin: '' }));
                } else {
                  alert((lang === 'es' ? 'Error guardando: ' : 'Save failed: ') + (err.message || err));
                  setSsnEditPin(null);
                }
              }
            }}
            className="flex-1 bg-blue-600 text-white font-semibold py-2.5 rounded-xl"
            disabled={ssnEditPin.submitting}
          >
            {ssnEditPin.submitting ? (lang === 'es' ? 'Verificando…' : 'Verifying…') : (lang === 'es' ? 'Confirmar' : 'Confirm')}
          </button>
        </div>
      </Modal>
    )}
    {/* Etiquetas de correo. Recibe los objetos completos (no los ids) porque
        necesita dirección, sexo y cónyuge para armar el nombre y el sobre. */}
    {labelsOpen && (
      <MailingLabelsModal
        clients={clients.filter(c => selectedIds.has(c.id))}
        onClose={() => setLabelsOpen(false)}
        lang={lang}
      />
    )}

    {/* Bulk delete confirmation. Count is stable here because the user
        commits to a specific number of rows before the loop starts. */}
    {quitarEtq && <QuitarEtiquetaModal
      de="clientes"
      ids={quitarEtq.ids}
      inicial={quitarEtq.inicial || ""}
      opciones={quitarEtq.ids ? contarEtiquetas((clients || []).filter(c => quitarEtq.ids.includes(c.id))).opciones : tagCounts.opciones}
      lang={lang}
      onClose={() => setQuitarEtq(null)}
      onDone={({ etiqueta, ids }) => {
        const tocados = new Set(ids);
        onClientsChange(prev => prev.map(c => tocados.has(c.id) ? { ...c, tags: sinEtiqueta(c.tags, etiqueta) } : c));
        if (String(tagFilter).toLowerCase() === String(etiqueta).toLowerCase()) setTagFilter("all");
        if (quitarEtq.ids) setSelectedIds(new Set());
      }}/>}
    {bulkDelConfirm && (
      <Modal title={lang === 'es' ? '⚠️ Borrar varios clientes' : '⚠️ Delete multiple clients'} onClose={() => setBulkDelConfirm(false)}>
        <p style={{color:"var(--c-text,#c8dff0)",marginBottom:".75rem",fontSize:".88rem"}}>
          {lang === 'es'
            ? `Estás a punto de borrar ${selectedIds.size} cliente${selectedIds.size === 1 ? '' : 's'}.`
            : `You are about to delete ${selectedIds.size} client${selectedIds.size === 1 ? '' : 's'}.`}
        </p>
        <p style={{color:"var(--c-text2,#a0b8d0)",marginBottom:"1.25rem",fontSize:".78rem",lineHeight:1.5}}>
          {lang === 'es'
            ? 'Sus pólizas y documentos asociados también se ocultarán. La operación es reversible solo desde la base de datos — desde la app no hay "deshacer".'
            : 'Their policies and associated documents will also be hidden. The operation is reversible only from the database — there is no in-app undo.'}
        </p>
        <div className="flex gap-3">
          <button onClick={bulkDelete} className="flex-1 bg-red-600 text-white font-semibold py-2.5 rounded-xl">
            {lang === 'es' ? `Sí, borrar ${selectedIds.size}` : `Yes, delete ${selectedIds.size}`}
          </button>
          <button onClick={() => setBulkDelConfirm(false)} className="flex-1 bg-gray-100 text-gray-700 font-semibold py-2.5 rounded-xl">
            {lang === 'es' ? 'Cancelar' : 'Cancel'}
          </button>
        </div>
      </Modal>
    )}
    {/* Live progress overlay during the bulk delete. Mirrors the import
        overlay so the UX is consistent — same per-row label, succeeded /
        failed counters, and tail of failure messages. */}
    {bulkProgress.active && (() => {
      const pct = bulkProgress.total > 0 ? Math.round((bulkProgress.current / bulkProgress.total) * 100) : 0;
      return (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(8,17,28,0.85)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem' }}>
          <div style={{ background: 'var(--c-surface,#0d1b2a)', border: '1px solid var(--c-border,#1a3550)', borderRadius: 12, padding: '1.5rem', maxWidth: 480, width: '100%', boxShadow: '0 20px 60px rgba(0,0,0,0.5)' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '.5rem', marginBottom: '.75rem' }}>
              <span style={{ fontSize: '1.4rem' }}>🗑️</span>
              <h3 style={{ margin: 0, fontSize: '.95rem', fontWeight: 700, color: 'var(--c-white,#eef6ff)' }}>
                {lang === 'es' ? 'Borrando clientes…' : 'Deleting clients…'}
              </h3>
            </div>
            <div style={{ fontSize: '.7rem', color: 'var(--c-text3,#45688a)', marginBottom: '.5rem', fontFamily: 'var(--font-mono)' }}>
              {bulkProgress.current} / {bulkProgress.total} · {pct}%
            </div>
            <div style={{ height: 8, background: 'var(--c-surface2,#112538)', borderRadius: 4, overflow: 'hidden', marginBottom: '.75rem' }}>
              <div style={{ height: '100%', width: `${pct}%`, background: 'var(--c-red,#ef4444)', transition: 'width 0.2s ease' }} />
            </div>
            {bulkProgress.currentLabel && (
              <div style={{ fontSize: '.75rem', color: 'var(--c-text2,#a0b8d0)', marginBottom: '.75rem', wordBreak: 'break-word' }}>
                {lang === 'es' ? 'Borrando:' : 'Deleting:'} <span style={{ color: 'var(--c-white,#eef6ff)' }}>{bulkProgress.currentLabel}</span>
              </div>
            )}
            <div style={{ display: 'flex', gap: '1rem', fontSize: '.72rem', fontFamily: 'var(--font-mono)' }}>
              <span style={{ color: 'var(--c-green,#22c55e)' }}>✅ {bulkProgress.succeeded}</span>
              <span style={{ color: bulkProgress.failed.length > 0 ? 'var(--c-red,#ef4444)' : 'var(--c-text3,#45688a)' }}>❌ {bulkProgress.failed.length}</span>
            </div>
            {bulkProgress.failed.length > 0 && (
              <div style={{ marginTop: '.75rem', maxHeight: 140, overflowY: 'auto', borderTop: '1px solid var(--c-border,#1a3550)', paddingTop: '.5rem' }}>
                {bulkProgress.failed.slice(-8).map((f, idx) => (
                  <div key={idx} style={{ fontSize: '.68rem', color: 'var(--c-red,#ef4444)', marginBottom: 4, wordBreak: 'break-word' }}>
                    <span style={{ color: 'var(--c-text2,#a0b8d0)' }}>{f.label}:</span> {f.error}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      );
    })()}
  </div>;
}
function CancelledPoliciesView({policies,clients,lang,t}){const pp=(policies||[]).filter(p=>p.status==="inactive"||p.status==="cancelled");return <div style={{padding:"1rem"}}>{pp.map(p=>{const c=(clients||[]).find(cl=>cl.id===p.clientId);return <div key={p.id} style={{display:"flex",alignItems:"center",gap:".75rem",padding:".65rem .875rem",background:"var(--c-surface2,#112538)",border:"1px solid var(--c-border,#1a3550)",borderRadius:8,marginBottom:".4rem"}}><div style={{flex:1}}><div style={{fontSize:".82rem",fontWeight:600,color:"var(--c-white,#eef6ff)"}}>{c?`${c.firstName} ${c.lastName}`:"--"}</div><div style={{fontSize:".68rem",color:"var(--c-text3,#45688a)"}}>{p.carrier||"--"} . {p.type||"--"}</div></div><span style={{fontSize:".68rem",background:"rgba(255,61,107,.1)",color:"var(--c-red,#ff3d6b)",padding:".2rem .5rem",borderRadius:5,fontWeight:700}}>Cancelada</span></div>;})}</div>;}
// F2 Renewals pipeline. A LIST of policies near renewal (within the 90-day
// window). Each row shows company, an editable note, a colored status toggle
// (4 built-ins + agency-defined custom statuses), and who last changed it.
// Moving a policy to DONE auto-sends the agency's welcome-kit email to the
// client. The stage is pinned to the policy's current cycle and auto-resets
// once the policy renews into a new term (see mapPolicyFromApi).
// ─── F6 — Global Alerts ──────────────────────────────────────────────────
// A single screen that aggregates every "action item" across ALL clients the
// user can see (renewals, birthdays, missing docs, age milestones, eligibility)
// plus a date-ranged feed of who-did-what across the team. Filter by alert
// type, client, and seat.
function AlertsView({ clients=[], policies=[], docs=[], activitylog=[], users=[], currentUser, setView, eligibilityAlerts=[], requests=[], tasks=[], tickets=[], emailTemplates=[], hasTeamActionBeenDone, logTeamAction, forgetTeamAction, userPrefs={}, licenses=[], t, lang }) {
  // Plazos configurables (Perfil -> Preferencias -> Avisos). Sin nada guardado
  // devuelven los mismos numeros de siempre.
  const leadRenewalFor = (type) => renewalLeadDaysForType(userPrefs, type);
  const leadTask = alertLeadDays(userPrefs, "task");
  const leadTicket = alertLeadDays(userPrefs, "ticket");
  const leadLicense = alertLeadDays(userPrefs, "license");
  const es = lang==="es";
  // Default range = current week (Sunday → today).
  const weekStart = (() => { const d=new Date(); d.setDate(d.getDate()-d.getDay()); return localDay(d); })();
  const [from,setFrom]=useState(weekStart);
  const [to,setTo]=useState(localDay());
  const [typeFilter,setTypeFilter]=useState("all");
  const [seatFilter,setSeatFilter]=useState("all");
  const [query,setQuery]=useState("");
  // Birthday greeting composer opened in place (overlay) when a birthday alert
  // is clicked — holds the client being greeted, or null when closed.
  const [bdayCompose,setBdayCompose]=useState(null);
  // Cola de saludos pendientes: es lo que permite ofrecer "Desprogramar" en
  // una alerta que ya está en verde.
  const greetingQueue = useGreetingQueue();


  // Index clients by id ONCE so the alerts computation below (which loops over
  // ALL policies, docs, eligibility alerts and requests) does O(1) lookups
  // instead of O(clients) per item — same O(n×m)→O(n) fix applied to the
  // Clients search (Lissette 2026-06-30 lentitud al crecer).
  const clientsById = useMemo(() => new Map((clients||[]).map(c => [c.id, c])), [clients]);
  const goToClient = (id) => { const cl=clientsById.get(id); if(cl) irAlCliente(cl,setView); };
  // Birthday alerts open the SAME send/schedule greeting composer the dashboard
  // uses, but RIGHT HERE as an overlay so the page stays on Alertas (Lissette
  // 2026-06-19: "sale para enviar mail pero la página se va al dashboard, no se
  // queda en alerta"). Falls back to the client profile when there's no email.
  const openAlert = (a) => {
    // Tasks/tickets open their own module (they aren't always tied to a client).
    if(a.cat==="task"){ setView("tasks"); return; }
    if(a.cat==="ticket"){ setView("tickets"); return; }
    const cl = a.clientId ? clients.find(c=>c.id===a.clientId) : null;
    if(!cl) return;
    // Carry the birthday PERSON (spouse/dependent keep their own name + email)
    // and the occurrence being greeted, so the composer addresses the right
    // person and stamps the marker every other screen reads back.
    if(a.cat==="bday" && (a.person?.email || cl.email)){ setBdayCompose({ client:cl, person:a.person, personKey:a.personKey, dayKey:a.dayKey }); return; }
    goToClient(a.clientId);
  };
  // A birthday alert is "done" once a greeting_sent team action exists for THIS
  // PERSON and THIS birthday — the same persisted, agency-shared signal the
  // Dashboard's greetings panel writes/reads (crm-app/greetings.js owns the
  // key). Sending from Alertas used to leave no marker at all (Lissette
  // 2026-07-08), and then left one under the wrong key: the bare clientId and
  // today's UTC date, so a spouse's greeting never marked the Inicio card and a
  // greeting scheduled for tomorrow expired at midnight (ticket 2026-08-14).
  const bdayAlertDone = (a) => {
    if(!a?.personKey || !hasTeamActionBeenDone) return false;
    try { return !!hasTeamActionBeenDone(bdayGreetingKey(a.personKey, a.dayKey)).done; }
    catch(_) { return false; }
  };

  // ── Build the alert list (mirrors the Dashboard's categories, wider windows) ──
  const alerts = useMemo(() => {
    const list=[];
    const add = (dob,name,clientId,isDep,person) => {
      if(!dob) return;
      const dB=daysUntilBirthday(dob), d65=willTurnAge(dob,65), d26=willTurnAge(dob,26);
      // `personKey` + `dayKey` are the canonical (who, which birthday) pair the
      // whole app dedups greetings by — see crm-app/greetings.js.
      if(dB!==null&&dB>=0&&dB<=7) list.push({cat:"bday",icon:"🎂",label:es?"Cumpleaños":"Birthday",msg:dB===0?(es?`¡Hoy cumple años ${name}!`:`Today is ${name}'s birthday!`):(es?`${name} cumple en ${dB} día${dB===1?"":"s"}`:`${name}'s birthday in ${dB} day${dB===1?"":"s"}`),color:"#f472b6",urgent:dB<=1,clientId,personKey:person?.personKey||clientId,dayKey:birthdayDayKey(dob),person,daysUntil:dB});
      if(isDep&&d26!==null&&d26>0&&d26<=365) list.push({cat:"age",icon:"⚠️",label:es?"Edad/Medicare":"Age/Medicare",msg:es?`${name} cumplirá 26 en ${d26} días — sale del plan de los padres`:`${name} turns 26 in ${d26} days — ages off parent's plan`,color:"#fbbf24",urgent:d26<=90,clientId});
      if(d65!==null&&d65>0&&d65<=90) list.push({cat:"age",icon:"🚨",label:es?"Edad/Medicare":"Age/Medicare",msg:es?`¡${name} cumple 65 en ${d65} días! — Inscribir en Medicare`:`${name} turns 65 in ${d65} days! — Enroll in Medicare`,color:"#ff3d6b",urgent:true,clientId});
      else if(d65!==null&&d65>90&&d65<=365) list.push({cat:"age",icon:"🏥",label:es?"Edad/Medicare":"Age/Medicare",msg:es?`${name} cumplirá 65 en ${d65} días`:`${name} will turn 65 in ${d65} days`,color:"#00d4ff",urgent:false,clientId});
    };
    clients.forEach(c=>{
      const head=`${c.firstName} ${c.lastName}`;
      add(c.dob,head,c.id,false,{personKey:bdayPersonKey(c.id),firstName:c.firstName,lastName:c.lastName,email:c.email,phone:c.phone,preferredLang:c.preferredLang});
      if(hasCurrentSpouse(c)&&c.spouse?.dob) add(c.spouse.dob,`${c.spouse.firstName} ${c.spouse.lastName||c.lastName} — ${es?"Cónyuge":"Spouse"}`,c.id,false,{personKey:bdayPersonKey(c.id,'spouse'),firstName:c.spouse.firstName,lastName:c.spouse.lastName||c.lastName,email:c.spouse.email||c.email,phone:c.spouse.phone||c.phone,preferredLang:c.spouse.preferredLang||c.preferredLang,rel:es?"cónyuge":"spouse",ofName:head});
      (c.dependents||[]).forEach((dep,i)=>{ if(dep.dob&&dep.firstName) add(dep.dob,`${dep.firstName} ${dep.lastName||c.lastName} — ${es?"Dependiente":"Dependent"}`,c.id,true,{personKey:bdayPersonKey(c.id,'dep',dep.id||i),firstName:dep.firstName,lastName:dep.lastName||c.lastName,email:dep.email||c.email,phone:dep.phone||c.phone,preferredLang:c.preferredLang,rel:es?"dependiente":"dependent",ofName:head}); });
    });
    policies.forEach(p=>{ const d=daysUntil(p.renewalDate); const c=clientsById.get(p.clientId); const pt=getPolicyType(p.type); if(d!==null&&d>=0&&d<=leadRenewalFor(p.type)&&c) list.push({cat:"renewal",icon:pt.icon,label:es?"Renovaciones":"Renewals",msg:`${c.firstName} ${c.lastName} — ${es?pt.labelEs:pt.label} ${es?"renueva en":"renews in"} ${d}d`,color:"#ffb700",urgent:d<=7,clientId:c.id}); });
    docs.filter(d=>d.required&&!d.uploadedAt).forEach(d=>{ const c=clientsById.get(d.clientId); if(c) list.push({cat:"doc",icon:"📄",label:es?"Documentos":"Documents",msg:`${c.firstName} ${c.lastName} — ${es?"falta":"missing"}: ${d.type}`,color:"#ff3d6b",urgent:false,clientId:c.id}); });
    // Eligibility-required documents (parsed from the eligibility PDF) are
    // surfaced under the "Documentos" category — Lissette wants every
    // requested document, whether eligibility or otherwise, in one place.
    // Lissette 2026-06-21 #16: an eligibility with documents-to-send must show in
    // Alertas even when the PDF had NO deadline (and not be capped at 90 days).
    (eligibilityAlerts||[]).filter(ea=>ea.status==="pending").forEach(ea=>{ const c=clientsById.get(ea.clientId); if(!c) return; const docName=es?ea.doc:(ea.docEn||ea.doc); if(ea.deadline){ const [y,m,d2]=ea.deadline.split("-").map(Number); const target=new Date(y,m-1,d2); const today=new Date(); today.setHours(0,0,0,0); const dd=Math.ceil((target-today)/(1000*60*60*24)); const od=dd<0; list.push({cat:"doc",icon:od?"🚨":"📋",label:es?"Documentos":"Documents",msg:od?`${c.firstName} ${c.lastName} — ${docName} ${es?"VENCIDO":"OVERDUE"}`:`${c.firstName} ${c.lastName} — ${docName} (${dd} ${es?"días":"days"})`,color:od?"#ff3d6b":dd<=14?"#ffb700":"#00d4ff",urgent:od||dd<=14,clientId:c.id}); } else { list.push({cat:"doc",icon:"📋",label:es?"Documentos":"Documents",msg:`${c.firstName} ${c.lastName} — ${docName} (${es?"pendiente":"pending"})`,color:"#ffb700",urgent:false,clientId:c.id}); } });
    // Document requests ("solicitudes") still outstanding — also under "Documentos".
    (requests||[]).filter(r=>r.status!=="completed").forEach(req=>{ const c=clientsById.get(req.clientId); if(!c) return; const expired=req.status==="expired"; (req.docs||[]).filter(d=>d.status!=="received").forEach(d=>{ const nm=d.name||(es?"Documento":"Document"); list.push({cat:"doc",icon:expired?"🚨":"📄",label:es?"Documentos":"Documents",msg:expired?`${c.firstName} ${c.lastName} — ${es?"solicitado":"requested"}: ${nm} — ${es?"link VENCIDO":"link EXPIRED"}`:`${c.firstName} ${c.lastName} — ${es?"solicitado":"requested"}: ${nm} — ${es?"pendiente":"pending"}`,color:expired?"#ff3d6b":"#ffb700",urgent:expired,clientId:c.id}); }); });
    // Tasks with a due date within 3 days (or already overdue) that aren't done —
    // Lissette 2026-07-24: "que des alerta desde 3 días antes cuando se vaya a
    // vencer". Uses the same local-day daysUntil helper as renewals.
    (tasks||[]).forEach(tk=>{ if(!tk||tk.status==="done"||tk.completedAt) return; const d=daysUntil(tk.dueDate); if(d===null||d>leadTask) return; const c=tk.clientId?clientsById.get(tk.clientId):null; const who=c?`${c.firstName} ${c.lastName} — `:""; const od=d<0; const when=od?(es?"VENCIDA":"OVERDUE"):d===0?(es?"vence hoy":"due today"):d===1?(es?"vence mañana":"due tomorrow"):(es?`vence en ${d} días`:`due in ${d} days`); list.push({cat:"task",icon:od?"🚨":"🗓️",label:es?"Tareas":"Tasks",msg:`${who}${tk.title||(es?"Tarea":"Task")} — ${when}`,color:od?"#ff3d6b":d<=1?"#ffb700":"#00d4ff",urgent:od||d<=1,clientId:tk.clientId||null}); });
    // Open customer-service tickets (not resolved/closed). Tickets have no due
    // date, so we surface every open one; high/urgent priority = urgent.
    // Licencias: vencimiento y HORAS CONTINUAS. Las horas viven en la ficha de
    // la licencia (ceCredits/ceRequired/ceDeadline) desde siempre, pero nadie
    // avisaba de ellas: había que acordarse de entrar a mirar la barrita
    // (Lissette 2026-08-17). Solo avisa si de verdad FALTAN horas — estar al
    // día no es un pendiente — y usa el mismo plazo configurable que el resto.
    (licenses||[]).forEach(l=>{
      if(!l) return;
      const quien = [l.state, l.licenseNumber].filter(Boolean).join(" ") || (es?"Licencia":"License");
      const dExp = l.expiryDate ? daysUntil(l.expiryDate) : null;
      if(dExp!==null && dExp>=0 && dExp<=leadLicense){
        list.push({cat:"license",icon:"🪪",label:es?"Licencias":"Licenses",
          msg:es?`${quien} vence en ${dExp} día${dExp===1?"":"s"}`:`${quien} expires in ${dExp} day${dExp===1?"":"s"}`,
          color:dExp<=30?"#ff3d6b":"#ffb700",urgent:dExp<=30,clientId:null});
      }
      const req=parseFloat(l.ceRequired), done=parseFloat(l.ceCredits)||0;
      if(!Number.isFinite(req)||req<=0||done>=req) return;
      const faltan = Math.round((req-done)*10)/10;
      const dCe = l.ceDeadline ? daysUntil(l.ceDeadline) : null;
      if(dCe===null || dCe>leadLicense) return;
      const vencida = dCe<0;
      list.push({cat:"license",icon:vencida?"🚨":"⏰",label:es?"Horas continuas":"CE hours",
        msg:vencida
          ? (es?`${quien} — faltan ${faltan} de ${req} horas y la fecha ya pasó`:`${quien} — ${faltan} of ${req} hours missing, deadline passed`)
          : (es?`${quien} — faltan ${faltan} de ${req} horas (${dCe} día${dCe===1?"":"s"})`:`${quien} — ${faltan} of ${req} hours missing (${dCe} day${dCe===1?"":"s"})`),
        color:vencida?"#ff3d6b":dCe<=30?"#ffb700":"#00d4ff",urgent:vencida||dCe<=30,clientId:null});
    });
    (tickets||[]).forEach(tk=>{ if(!tk) return; const st=String(tk.status||""); if(st==="resolved"||st==="closed") return; if(leadTicket>0){ const abierto=tk.createdAt?Math.floor((Date.now()-new Date(tk.createdAt).getTime())/86400000):null; if(abierto===null||abierto<leadTicket) return; } const c=tk.clientId?clientsById.get(tk.clientId):null; const who=c?`${c.firstName} ${c.lastName} — `:(tk.clientName?`${tk.clientName} — `:""); const hi=tk.priority==="high"||tk.priority==="urgent"; const num=tk.number?`#${tk.number} `:""; list.push({cat:"ticket",icon:hi?"🚨":"🎫",label:es?"Tickets":"Tickets",msg:`${num}${who}${tk.subject||"Ticket"}`,color:hi?"#ff3d6b":"#00d4ff",urgent:hi,clientId:tk.clientId||null}); });
    return list.sort((a,b)=>{ if(a.urgent&&!b.urgent) return -1; if(!a.urgent&&b.urgent) return 1; return 0; });
  // OJO con esta lista. `licenses` faltaba, y las licencias llegan del servidor
  // DESPUÉS del primer pintado: el cálculo se quedaba con el array vacío del
  // arranque y la pantalla de Alertas no enseñaba ni una licencia por vencer ni
  // una hora continua pendiente — vacía, sin error, sin nada que mirar
  // (Lissette 2026-08-19: "ya no están las alertas, está vacío"). Parecía
  // aleatorio porque cualquier otra cosa que cambiara —un cliente, una tarea—
  // recalculaba de rebote y ese día sí salían.
  //
  // `userPrefs` manda los cuatro plazos (leadLicense/leadTask/leadTicket y
  // leadRenewalFor); sin él, unas preferencias que cargan tarde dejan los avisos
  // con los plazos de fábrica. `clientsById` se usa para resolver el nombre.
  },[clients,policies,docs,eligibilityAlerts,requests,tasks,tickets,licenses,userPrefs,clientsById,es]);

  const nameOf = (id) => { const c=clientsById.get(id); return c?`${c.firstName} ${c.lastName}`.toLowerCase():""; };
  const q = query.trim().toLowerCase();
  const filteredAlerts = alerts.filter(a=>(typeFilter==="all"||a.cat===typeFilter)&&(!q||a.msg.toLowerCase().includes(q)||nameOf(a.clientId).includes(q)));

  const CATS=[
    {id:"all",label:es?"Todas":"All",icon:"🔔"},
    {id:"renewal",label:es?"Renovaciones":"Renewals",icon:"🔄"},
    {id:"task",label:es?"Tareas":"Tasks",icon:"🗓️"},
    {id:"ticket",label:es?"Tickets":"Tickets",icon:"🎫"},
    {id:"bday",label:es?"Cumpleaños":"Birthdays",icon:"🎂"},
    {id:"doc",label:es?"Documentos":"Documents",icon:"📄"},
    {id:"age",label:es?"Edad/Medicare":"Age/Medicare",icon:"🏥"},
    {id:"license",label:es?"Licencias y horas":"Licenses & CE",icon:"🪪"},
  ];
  const catCount=(id)=>id==="all"?alerts.length:alerts.filter(a=>a.cat===id).length;

  // ── Changes feed (date-ranged audit of who-did-what across the team) ──
  const isPhi=(action)=>{ const a=String(action||""); return a.startsWith("phi.")||a==="ssn.reveal"||a==="ssn.reveal_denied"; };
  const ENT=es?{client:"cliente",policy:"póliza",task:"tarea",lead:"lead",appointment:"cita",note:"nota",commission:"comisión",document:"documento",signature:"firma",user:"usuario",scheduled_send:"correo programado"}:{client:"client",policy:"policy",task:"task",lead:"lead",appointment:"appointment",note:"note",commission:"commission",document:"document",signature:"signature",user:"user",scheduled_send:"scheduled email"};
  const ACT=es?{created:"creó",updated:"actualizó",deleted:"eliminó",registered:"registró",completed:"completó",login:"ingresó",signature_sent:"envió a firmar",signature_signed:"firmó","scheduled_send.queued":"programó","scheduled_send.sent":"envió","scheduled_send.cancelled":"canceló"}:{created:"created",updated:"updated",deleted:"deleted",registered:"registered",completed:"completed",login:"logged in",signature_sent:"sent for signature",signature_signed:"signed","scheduled_send.queued":"scheduled","scheduled_send.sent":"sent","scheduled_send.cancelled":"cancelled"};
  const AICON={created:"✚",updated:"✎",deleted:"✕",registered:"★",completed:"✓",login:"→",signature_sent:"✍︎",signature_signed:"✔︎"};
  const ACOLOR={created:"#10b981",updated:"#06b6d4",deleted:"#ef4444",registered:"#f59e0b",completed:"#8b5cf6",login:"#64748b",signature_sent:"#0099cc",signature_signed:"#10b981"};
  // Human labels for the changed-field list in the activity feed (mirror
  // ClientDetail's FIELD_LABELS so it reads "Nombre · Email, Dirección" instead
  // of raw keys). E-020.
  const FLD = es
    ? { firstName:"Nombre",middleName:"Segundo Nombre",lastName:"Apellido",email:"Email",phone:"Teléfono",phoneSecondary:"Teléfono 2",address:"Dirección",city:"Ciudad",state:"Estado",zipCode:"ZIP",county:"Condado",dateOfBirth:"Fecha Nac.",preferredLanguage:"Idioma",source:"Origen",status:"Estado",maritalStatus:"Estado Civil",immigrationStatus:"Estatus Migratorio",employer:"Empleador",employerPhone:"Tel. Empleador",annualIncome:"Ingresos",householdSize:"Tamaño Hogar",insuredMembers:"Miembros Asegurados",coverage:"Cobertura",dependents:"Dependientes",tags:"Etiquetas",linkedParentName:"Dependiente de",assignedAgent:"Agente",driveUrl:"Carpeta",notes:"Notas",spouseFirstName:"Cónyuge Nombre",spouseLastName:"Cónyuge Apellido",spouseDateOfBirth:"Cónyuge Fecha Nac.",spouseEmployer:"Cónyuge Empleador",spouseAnnualIncome:"Cónyuge Ingresos",spouseImmigrationStatus:"Cónyuge Estatus",referredByFirstName:"Referido (Nombre)",referredByLastName:"Referido (Apellido)",referredByPhone:"Referido (Tel.)" }
    : { firstName:"First Name",middleName:"Middle Name",lastName:"Last Name",email:"Email",phone:"Phone",phoneSecondary:"Phone 2",address:"Address",city:"City",state:"State",zipCode:"ZIP",county:"County",dateOfBirth:"DOB",preferredLanguage:"Language",source:"Source",status:"Status",maritalStatus:"Marital Status",immigrationStatus:"Immigration",employer:"Employer",employerPhone:"Employer Phone",annualIncome:"Income",householdSize:"Household Size",insuredMembers:"Insured Members",coverage:"Coverage",dependents:"Dependents",tags:"Tags",linkedParentName:"Dependent of",assignedAgent:"Agent",driveUrl:"Folder",notes:"Notes",spouseFirstName:"Spouse First",spouseLastName:"Spouse Last",spouseDateOfBirth:"Spouse DOB",spouseEmployer:"Spouse Employer",spouseAnnualIncome:"Spouse Income",spouseImmigrationStatus:"Spouse Immigration",referredByFirstName:"Referrer First",referredByLastName:"Referrer Last",referredByPhone:"Referrer Phone" };
  const fldLabel=(f)=> FLD[f] || String(f||"").replace(/([A-Z])/g," $1").replace(/[._]/g," ").replace(/^\w/,c=>c.toUpperCase()).trim();
  const describe=(a)=>{ const d=a.details||{}; if(a.entityType==="client"){ const c=clients.find(x=>x.id===a.entityId); const nm=d.name||(c?`${c.firstName} ${c.lastName}`.trim():""); const flds=Array.isArray(d.fields)&&d.fields.length?d.fields.map(fldLabel).join(", "):""; return flds?(nm?`${nm} · ${flds}`:flds):nm; } if(a.entityType==="policy"){ const p=policies.find(x=>x.id===a.entityId); const parts=[d.type||p?.type||"",d.carrier||p?.carrier||""].filter(Boolean).join(" · "); const num=d.policyNumber||p?.policyNumber||""; return [parts||null,num?`#${num}`:null].filter(Boolean).join(" "); } if(a.entityType==="scheduled_send"){ const c=clients.find(x=>x.id===d.clientId); const what=d.source==="birthday_greeting"?(es?"saludo de cumpleaños":"birthday greeting"):d.source==="holiday_greeting"?(es?"saludo de fiesta":"holiday greeting"):""; const nm=c?`${c.firstName} ${c.lastName}`.trim():""; return [what||null,nm||null].filter(Boolean).join(" · "); } return d.name||d.title||d.clientName||""; };
  const changes = useMemo(()=>{
    return (activitylog||[]).filter(a=>{
      if(!a.createdAt||isPhi(a.action)) return false;
      const day=localDay(new Date(a.createdAt));
      if(day<from||day>to) return false;
      if(seatFilter!=="all"&&a.userId!==seatFilter) return false;
      if(q){ const hay=`${a.userName||""} ${describe(a)} ${ENT[a.entityType]||a.entityType||""}`.toLowerCase(); if(!hay.includes(q)) return false; }
      return true;
    }).slice(0,150);
  },[activitylog,from,to,seatFilter,q,clients,policies]);
  const seatOptions = useMemo(()=>{ const ids=new Set((activitylog||[]).map(a=>a.userId).filter(Boolean)); return (users||[]).filter(u=>ids.has(u.id)); },[activitylog,users]);

  return <div>
    <div className="dkt-sec-title" style={{margin:"0 0 1rem"}}>{es?"Alertas":"Alerts"} <span style={{fontSize:".8rem",color:"var(--c-text2,#7aa3c0)",fontWeight:600}}>· {alerts.length} {es?"activas":"active"}</span></div>

    {/* Category chips */}
    <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:14}}>
      {CATS.map(cat=>{ const on=typeFilter===cat.id; const n=catCount(cat.id); return <button key={cat.id} onClick={()=>setTypeFilter(cat.id)} style={{display:"inline-flex",alignItems:"center",gap:6,fontSize:".78rem",fontWeight:700,padding:"7px 12px",borderRadius:999,cursor:"pointer",border:`1px solid ${on?"var(--c-green,#00ff88)":"var(--c-border,#1a3550)"}`,background:on?"var(--c-green,#00ff88)18":"var(--c-surface,#0d1c2e)",color:on?"var(--c-green,#00ff88)":"var(--c-text,#c8dff0)"}}>{cat.icon} {cat.label} <span style={{fontSize:".7rem",opacity:.7}}>({n})</span></button>; })}
    </div>

    {/* Alerts list */}
    <div style={{background:"var(--c-surface,#0d1c2e)",border:"1px solid var(--c-border,#1a3550)",borderRadius:14,marginBottom:24}}>
      {filteredAlerts.length===0
        ? <div style={{padding:"36px 16px",textAlign:"center",color:"var(--c-text3,#45688a)"}}>
            <div>{es?"No hay alertas en esta categoría. 🎉":"No alerts in this category. 🎉"}</div>
            {/* Una lista vacía tiene que decir CON QUÉ PLAZO está vacía. Lissette
                tenía el aviso de licencias en pocos días, la pantalla salió en
                blanco y no había forma de saber si era su número o un fallo
                (2026-08-19). Ahora lo dice, y dice dónde se cambia. */}
            <div style={{marginTop:10,fontSize:".74rem",lineHeight:1.5}}>
              {es
                ? `Avisando con ${leadLicense} día${leadLicense===1?"":"s"} para licencias y ${leadTask} para tareas. Se cambia en Perfil → Preferencias → Avisos.`
                : `Warning ${leadLicense} day${leadLicense===1?"":"s"} ahead for licenses and ${leadTask} for tasks. Change it in Profile → Preferences → Alerts.`}
            </div>
          </div>
        : filteredAlerts.map((a,i)=>{ const done=a.cat==="bday"&&bdayAlertDone(a); const queued=done&&a.daysUntil>0; return <button key={i} onClick={done?undefined:()=>openAlert(a)} disabled={done} title={done?(queued?(es?"Saludo de cumpleaños ya programado":"Birthday greeting already scheduled"):(es?"Saludo de cumpleaños ya enviado":"Birthday greeting already sent")):a.cat==="bday"?(es?"Clic para programar o enviar el mensaje 🎂":"Click to schedule or send the message 🎂"):undefined} style={{display:"flex",alignItems:"center",gap:12,width:"100%",textAlign:"left",padding:"12px 16px",background:"none",border:"none",borderTop:i>0?"1px solid var(--c-border,#1a3550)":"none",cursor:done?"default":"pointer",opacity:done?.7:1}}>
            <span style={{fontSize:"1.2rem",flexShrink:0}}>{a.icon}</span>
            <span style={{flex:1,minWidth:0,fontSize:".84rem",color:"var(--c-text,#c8dff0)"}}>{a.msg}</span>
            {done
              ? <span style={{display:"inline-flex",alignItems:"center",gap:8,flexShrink:0}}>
                  <span style={{fontSize:".68rem",fontWeight:700,color:"var(--c-green,#00ff88)"}}>✅ {queued?(es?"Programado":"Scheduled"):(es?"Enviado":"Sent")}</span>
                  <UnscheduleGreetingButton rows={greetingQueue.find(a.clientId,'birthday_greeting',a.dayKey)} personKey={a.personKey} dayKey={a.dayKey}
                    who={a.person?`${a.person.firstName||""} ${a.person.lastName||""}`.trim():""} unschedule={greetingQueue.unschedule}
                    onDone={()=>forgetTeamAction&&forgetTeamAction(bdayGreetingKey(a.personKey,a.dayKey))} lang={lang} compact/>
                </span>
              : a.urgent&&<span style={{fontSize:".62rem",fontWeight:800,textTransform:"uppercase",letterSpacing:".04em",color:"#ff3d6b",background:"#ff3d6b18",padding:"3px 8px",borderRadius:999,flexShrink:0}}>{es?"Urgente":"Urgent"}</span>}
            <span style={{width:8,height:8,borderRadius:99,background:a.color,flexShrink:0}}/>
          </button>; })}
    </div>

    {/* Changes feed */}
    <div className="dkt-sec-title" style={{margin:"0 0 .8rem",fontSize:"1rem"}}>{es?"Cambios del equipo":"Team changes"}</div>
    <div style={{display:"flex",gap:10,flexWrap:"wrap",alignItems:"center",marginBottom:12}}>
      <label style={{fontSize:".74rem",color:"var(--c-text2,#7aa3c0)",display:"inline-flex",alignItems:"center",gap:6}}>{es?"Desde":"From"} <DateField value={from} max={to} onChange={e=>setFrom(e.target.value)} style={{fontSize:".78rem",padding:"5px 8px",borderRadius:8}}/></label>
      <label style={{fontSize:".74rem",color:"var(--c-text2,#7aa3c0)",display:"inline-flex",alignItems:"center",gap:6}}>{es?"Hasta":"To"} <DateField value={to} min={from} max={localDay()} onChange={e=>setTo(e.target.value)} style={{fontSize:".78rem",padding:"5px 8px",borderRadius:8}}/></label>
      <select value={seatFilter} onChange={e=>setSeatFilter(e.target.value)} style={{fontSize:".78rem",padding:"5px 8px",borderRadius:8}}>
        <option value="all">{es?"Todos los miembros":"All members"}</option>
        {seatOptions.map(u=><option key={u.id} value={u.id}>{u.name||u.displayName||u.email}</option>)}
      </select>
      <input value={query} onChange={e=>setQuery(e.target.value)} placeholder={es?"Buscar cliente / cambio…":"Search client / change…"} style={{flex:1,minWidth:160,fontSize:".78rem",padding:"6px 10px",borderRadius:8}}/>
    </div>
    <div style={{background:"var(--c-surface,#0d1c2e)",border:"1px solid var(--c-border,#1a3550)",borderRadius:14}}>
      {changes.length===0
        ? <div style={{padding:"32px 16px",textAlign:"center",color:"var(--c-text3,#45688a)"}}>{es?"Sin cambios en este rango.":"No changes in this range."}</div>
        : changes.map((a,i)=>{ const col=ACOLOR[a.action]||"#64748b"; const subject=describe(a); return <div key={a.id||i} style={{display:"flex",alignItems:"flex-start",gap:12,padding:"11px 16px",borderTop:i>0?"1px solid var(--c-border,#1a3550)":"none"}}>
            <span style={{width:22,height:22,borderRadius:99,background:`${col}1f`,color:col,display:"inline-flex",alignItems:"center",justifyContent:"center",fontSize:".8rem",flexShrink:0,marginTop:1}}>{AICON[a.action]||"•"}</span>
            <div style={{flex:1,minWidth:0}}>
              <div style={{fontSize:".82rem",color:"var(--c-text,#c8dff0)"}}>
                <b style={{color:"var(--c-white,#eef6ff)"}}>{a.userName||(es?"Alguien":"Someone")}</b> {ACT[a.action]||a.action} {ENT[a.entityType]||a.entityType}{subject?<> — <span style={{color:"var(--c-text2,#7aa3c0)"}}>{subject}</span></>:null}
              </div>
              <div style={{fontSize:".66rem",color:"var(--c-text3,#45688a)"}}>{fmtDateTime(a.createdAt)}</div>
            </div>
          </div>; })}
    </div>

    {/* Birthday greeting composer — opens in place so she stays on Alertas. */}
    {bdayCompose && <BirthdayGreetingComposer key={bdayCompose.personKey} client={bdayCompose.client} person={bdayCompose.person} personKey={bdayCompose.personKey} forDate={bdayCompose.dayKey} currentUser={currentUser} lang={lang} emailTemplates={emailTemplates} logTeamAction={logTeamAction} onClose={()=>setBdayCompose(null)} />}
  </div>;
}

const RENEWAL_WINDOW_DAYS = 90;
// Los status de fábrica viven en crm-app/estatusDeRenovacion.js (los usan
// también los Paneles de Reportes y el Reporte de Clientes).
// Built-in welcome-kit template — MUST mirror DEFAULT_KIT_SUBJECT / DEFAULT_KIT_BODY
// in deskte-api/src/routes/policies.routes.ts so the "Ver plantilla por defecto"
// button shows exactly what the backend sends when the agent leaves the kit blank.
const DEFAULT_KIT_SUBJECT_ES = "¡Bienvenido(a)! Tu póliza con {compañía}";
const DEFAULT_KIT_BODY_ES = [
  "Hola {cliente},",
  "",
  "¡Gracias por confiar en nosotros! Tu póliza de {tipo} con {compañía} (#{póliza}) ya está lista.",
  "",
  "En los próximos días recibirás los detalles de tus beneficios y los pasos a seguir. Si tienes cualquier pregunta, no dudes en contactarnos.",
  "",
  "Un cordial saludo,",
  "Tu agente de seguros",
].join("\n");
// Renewal-review field catalog (Part 3). Keys MUST match ALLOWED_FIELD_KEYS in
// the backend renewal-review.routes.ts. `on` = shown by default.
const RR_FIELD_CATALOG=[
  {key:"fullName",es:"Nombre completo",en:"Full name",on:true},
  {key:"dob",es:"Fecha de nacimiento",en:"Date of birth",on:true},
  {key:"phone",es:"Teléfono",en:"Phone",on:true},
  {key:"email",es:"Correo electrónico",en:"Email",on:true},
  {key:"address",es:"Dirección",en:"Address",on:true},
  {key:"maritalStatus",es:"Estado civil",en:"Marital status",on:false},
  {key:"language",es:"Idioma preferido",en:"Preferred language",on:false},
  {key:"income",es:"Ingreso anual del hogar",en:"Annual household income",on:true},
  {key:"spouse",es:"Cónyuge",en:"Spouse",on:false},
  // Lissette 2026-09-26: lo del conyuge y los dependientes que faltaba.
  {key:"spouseDob",es:"Fecha de nacimiento del cónyuge",en:"Spouse date of birth",on:false},
  {key:"dependents",es:"Dependientes (nombre y fecha)",en:"Dependents (name & DOB)",on:true},
  {key:"dependentsCount",es:"Nº de dependientes",en:"# of dependents",on:true},
  {key:"insuredCount",es:"Nº de asegurados",en:"# insured",on:true},
  // Sensible y apagado por defecto, igual que el SSN: viaja en un enlace que
  // puede acabar reenviado. Que el agente lo encienda a proposito.
  {key:"immigrationStatus",es:"Estatus migratorio",en:"Immigration status",on:false,sensitive:true},
  {key:"spouseImmigration",es:"Estatus migratorio del cónyuge",en:"Spouse immigration status",on:false,sensitive:true},
  {key:"dependentsImmigration",es:"Estatus migratorio de los dependientes",en:"Dependents immigration status",on:false,sensitive:true},
  {key:"ssnLast4",es:"SSN (últimos 4)",en:"SSN (last 4)",on:false,sensitive:true},
  // PREGUNTA, no un dato de la ficha: el cliente la contesta Sí/No en el
  // enlace y la respuesta vuelve en review.answers. Ver `question` en
  // FIELD_CATALOG (renewal-review.routes.ts).
  // ¿QUIERE RENOVAR? (Lissette 2026-09-15). Encendida por defecto y primera
  // entre las preguntas: es lo que el enlace de renovacion existe para
  // averiguar. El motivo —cuando contesta que no— viaja solo con ella.
  {key:"renovar",es:"¿Quieres renovar tu póliza?",en:"Do you want to renew your policy?",on:true,question:true,siempre:true},
  {key:"renovarMotivo",es:"¿Por qué no quieres renovarla?",en:"Why not renew it?",on:false,question:true,dependsOn:"renovar"},
  {key:"idme",es:"¿Tienes cuenta ID.me?",en:"Do you have an ID.me account?",on:false,question:true},
  // Tercera pregunta (Lissette 2026-09-09): si dice que SI tiene cuenta, se le
  // enseña el correo que tenemos y se le pregunta si es ese.
  {key:"idmeEmail",es:"¿Usaste este mismo correo para tu cuenta ID.me?",en:"Did you use this same email for your ID.me account?",on:false,question:true,dependsOn:"idme"},
  // Y si NO es el mismo, que escriba cual.
  {key:"idmeEmailOther",es:"¿Con qué correo entras a ID.me?",en:"Which email do you use for ID.me?",on:false,question:true,dependsOn:"idmeEmail"},
];
const RR_DEFAULT_KEYS=RR_FIELD_CATALOG.filter(f=>f.on).map(f=>f.key);
const RR_STATUS_RANK={none:0,PENDING:0,NOTIFIED:1,SENT:2,VIEWED:3,CONFIRMED:4,ADJUST:5};
// El estado que la columna Revision ENSEÑA, y el mismo que filtra y ordena.
// Antes el filtro comparaba rv.status a pelo: una revision creada pero sin
// enviar (PENDING) salia como "Sin enviar" en la pastilla y el filtro "Sin
// enviar" la escondia, porque PENDING no es vacio. Todo lo que la pastilla no
// sabe pintar es "none"; y en mayusculas, por si llega en otra caja.
const estadoDeRevision=(rv)=>{
  if(!rv||rv.revokedAt) return "none";
  const st=String(rv.status||"").toUpperCase();
  return RR_STATUS_RANK[st]>0?st:"none";
};

function RenewalsView({ policies, clients, users, seatLabels, currentUser, onPoliciesChange, logTeamAction, confirmBeforeResend, onAddClient, onOpenClient, userPrefs={}, t, lang }) {
  const es = lang==="es";
  const tr = t.renewals;
  // O(1) client lookups for the filter/sort below — avoids a clients.find scan
  // per policy on every keystroke/sort (Lissette 2026-06-30 lentitud al crecer).
  const clientsById = useMemo(() => new Map((clients||[]).map(c => [c.id, c])), [clients]);
  const isApiModeR = typeof window !== "undefined" && !!window.__deskteAuth;
  // Columnas propias de la agencia (Lissette 2026-09-09). Mismo mecanismo que
  // Baul, Info de Empresa, Pagos del Mes y Seguimientos. Aqui la fila es la
  // POLIZA.
  const [colsPropias,setColsPropias]=useState([]);
  const [celdas,setCeldas]=useState({});          // { [policyId]: { [colId]: texto } }
  const [showColMgr,setShowColMgr]=useState(false);
  useEffect(()=>{ if(!isApiModeR) return; let vivo=true;
    apiGetAgencySettings().then(a=>{ if(vivo) setColsPropias(normalizeColumns(a?.tableCustomColumns?.renewals)); }).catch(()=>{});
    apiGetCustomColumnValues("renewals").then(d=>{ if(vivo) setCeldas(d||{}); }).catch(()=>{});
    return ()=>{vivo=false;}; },[isApiModeR]);
  // Guardar una casilla: se manda la fila ENTERA y el estado local solo se
  // toca cuando el servidor confirma. Pintar antes de tiempo dejaria al
  // equipo creyendo que quedo guardado algo que no llego.
  const guardarCelda=async(policyId,colId,texto)=>{
    const antes=celdas[policyId]||{}; const nuevas={...antes};
    if(texto) nuevas[colId]=texto; else delete nuevas[colId];
    await apiSaveCustomColumnValues("renewals",policyId,nuevas);
    setCeldas(p=>({...p,[policyId]:nuevas}));
  };
  // Solo se borra lo que se borró en la ventana; lo que la ventana no veía se
  // conserva (ticket de Marilyn Sequera, 2026-10-28: "se nos borran las otras
  // columnas"). Ver crm-app/columnasDeTabla.js.
  const guardarColumnas=async(cols)=>{
    setColsPropias(await guardarColumnasDeTabla("renewals",colsPropias,cols));
  };
  // Lo que ofrece cada columna de tipo LISTA: lo que la agencia ya escribio en
  // ella. Asi el desplegable se va creando solo, sin que nadie lo configure
  // (Lissette 2026-09-10). Se deduce de las casillas y no se guarda aparte: una
  // segunda copia de la lista es una copia que se desincroniza.
  const opcionesPorColumna=useMemo(()=>{
    const m={};
    for(const col of colsPropias){
      if(tipoDeColumna(col)!=="list") continue;
      m[col.id]=opcionesDeColumna(col,Object.values(celdas).map(f=>f&&f[col.id]));
    }
    return m;
  },[colsPropias,celdas]);
  // FILTRAR POR UNA COLUMNA PROPIA (Crismar Perez, Maricarmen Nieto,
  // 2026-09-10): *"que las columnas que agreguemos en renovacion tengan la
  // opcion para filtrar a los clientes, como las otras columnas (...) filtrar
  // todos los clientes que no tengan ID me y volver a contactarlos"*.
  //
  // Un filtro por columna, en su propia cabecera, igual que Tipo, Compania,
  // Status, Revision y Encargado. { [idDeColumna]: valorElegido }.
  const [filtrosPropios,setFiltrosPropios]=useState({});
  const [marking,setMarking]=useState(null);
  // "Marcar renovada": con la MISMA poliza (se corre la fecha un año) o con
  // una poliza NUEVA del cliente — entonces el kit sale con los datos de la
  // nueva y la vieja se puede cancelar en el mismo paso (casilla sin marcar:
  // decide ella cada vez). Lissette 2026-09-26.
  //
  // CANCELAR LA VIEJA CON FECHA Y MOTIVO (Lissette 2026-10-20): *"que uno
  // coloque la fecha de cancelacion y motivo y que no se cancele aun sino en la
  // fecha que se coloca"*. Fecha futura = queda programada y la poliza sigue
  // activa hasta ese dia (utils/cancelacionProgramada.ts en el servidor).
  const [renovarCon,setRenovarCon]=useState({modo:"misma",nuevaId:"",cancelarVieja:false,fechaCancel:"",motivoCancel:"",notaCancel:""});
  // Mientras se marca y se envia el kit el boton queda ocupado: antes no daba
  // ninguna señal, se volvia a pulsar y el kit salia varias veces (2026-10-20).
  const [marcandoBusy,setMarcandoBusy]=useState(false);
  // Vista previa del kit en "Marcar renovada" (Lissette 2026-10-17). Se pide
  // al servidor cada vez que cambia la póliza que va en el kit: la misma o la
  // nueva elegida. null = nada que enseñar (sin servidor, en la demo).
  const [kitPrev,setKitPrev]=useState(null);
  useEffect(()=>{
    if(!marking||!isApiModeR){ setKitPrev(null); return undefined; }
    const nuevaId=renovarCon.modo==="nueva"?renovarCon.nuevaId:"";
    if(renovarCon.modo==="nueva"&&!nuevaId){ setKitPrev({esperando:true}); return undefined; }
    let off=false;
    setKitPrev({cargando:true});
    apiPreviewRenewalKit({ policyId:marking, renovadaConPolizaId:nuevaId||undefined })
      .then(data=>{ if(!off) setKitPrev({data}); })
      .catch(err=>{ if(!off) setKitPrev({error:err?.message||"error"}); });
    return ()=>{ off=true; };
  },[marking,renovarCon.modo,renovarCon.nuevaId,isApiModeR]);
  const [crearNueva,setCrearNueva]=useState(null);
  // Para "Enviar de todos modos" (faltan documentos): el reintento tiene que
  // mandar el kit de la MISMA poliza nueva que se eligio.
  const nuevaPorVieja=useRef({});
  const [savingId,setSavingId]=useState(null);
  const [openStatusFor,setOpenStatusFor]=useState(null);
  const [openHistoryFor,setOpenHistoryFor]=useState(null);
  const [editNoteFor,setEditNoteFor]=useState(null);
  const [noteDraft,setNoteDraft]=useState("");
  const [customStatuses,setCustomStatuses]=useState([]);
  const [kitByType,setKitByType]=useState({});            // { [typeId]: {subject,body} } — F4 per-type kits
  const [kitEditType,setKitEditType]=useState(""); // which kit the editor is editing (a policy type)
  const [showStatusMgr,setShowStatusMgr]=useState(false);
  const [showKitEditor,setShowKitEditor]=useState(false);
  const [kitDraft,setKitDraft]=useState({subject:"",body:""});
  // Mando del editor del mensaje: las fichas de campos meten el texto donde
  // esta el cursor de un contentEditable, que no tiene selectionStart.
  const kitBodyApi=useRef(null);
  const [kitFocusField,setKitFocusField]=useState("body"); // which input the field-chips insert into
  const [kitLang,setKitLang]=useState(es?"es":"en");       // current language of the kit draft (translate direction)
  // Qué versión del mensaje se edita: la principal o la de inglés, que es la que
  // les sale a los clientes de idioma inglés (Josef 2026-10-27).
  const [kitVersion,setKitVersion]=useState("es");
  const [kitTranslating,setKitTranslating]=useState(false);
  const [newStatusLabel,setNewStatusLabel]=useState("");
  const [newStatusColor,setNewStatusColor]=useState("#0ea5e9");
  const [missingDocsModal,setMissingDocsModal]=useState(null);
  // Pestana: lo que falta por hacer, o lo ya renovado de este ciclo (Lissette
  // 2026-08-28). Una poliza en DONE ya tiene su kit enviado y no hay nada mas
  // que hacerle, pero seguia ocupando sitio en la lista de trabajo — con 170
  // filas eso es justo lo que estorba para ver lo que falta.
  const [tab,setTab]=useState("pendientes");             // 'pendientes' | 'renovadas'
  const [typeFilter,setTypeFilter]=useState("all");      // filter by policy type
  const [carrierFilter,setCarrierFilter]=useState("all"); // filter by carrier/company
  // Filtrar tambien por Status y por Encargado (Lissette 2026-08-25). Las dos
  // columnas ya estaban, pero solo se podian LEER: con 170 filas eso obliga a
  // recorrerlas con el ojo para contestar "que tengo yo pendiente" o "cuantas
  // llevan sin empezar".
  const [stageFilter,setStageFilter]=useState("all");    // filter by renewal status
  const [encargadoFilter,setEncargadoFilter]=useState("all"); // filter by assignee
  // "Atiende" (handle) = quien atiende al CLIENTE en su ficha, no el encargado
  // de esta renovacion. Se lee solo, no se edita aqui (Lissette 2026-09-30).
  const [atiendeFilter,setAtiendeFilter]=useState("all");
  // "Agente" = el Agente asignado que esta ESCRITO en la ficha del cliente
  // (Lissette 2026-11-04: *"agrega otra columna que diga agentes y que se
  // coloque los agentes que este escrito en el cliente"*). Es un nombre, no un
  // asiento: puede ser alguien sin cuenta en Deskte. Se lee, no se edita aqui.
  const [agenteFilter,setAgenteFilter]=useState("all");
  // Renewal-review (Part 2): per-policy status chip + 2-step SMS (aviso → link).
  const [reviews,setReviews]=useState({});               // { [policyId]: review }
  const [reviewBusy,setReviewBusy]=useState(null);       // policyId mid-ensure
  const [smsModal,setSmsModal]=useState(null);           // { policy, client, reviewId, kind, message }
  const [sendingSms,setSendingSms]=useState(false);
  const [smsTranslating,setSmsTranslating]=useState(false);
  const [reviewFilter,setReviewFilter]=useState("all");  // filter the Revisión column by status
  const [clientFilter,setClientFilter]=useState("");     // text filter on client name (in the Client column)
  const [sortCol,setSortCol]=useState(null);             // 'client' | 'type' | 'review' | null
  const [sortDir,setSortDir]=useState("asc");
  const [selectedIds,setSelectedIds]=useState(()=>new Set()); // bulk-select policies
  const [bulkBusy,setBulkBusy]=useState(false);
  // Part 3: which client fields to show per policy type (saved to agency settings).
  const [reviewFieldsByType,setReviewFieldsByType]=useState({}); // { [typeId]: string[], __default__: [] }
  const [showFieldsEditor,setShowFieldsEditor]=useState(false);
  const [fieldsEditType,setFieldsEditType]=useState("__default__");
  const [fieldsDraft,setFieldsDraft]=useState([]);       // keys being edited
  // Los dos SMS del enlace de renovacion, en los dos idiomas. Guardados en el
  // ajuste de la agencia: los escribe una persona y valen para todo el equipo
  // (Lissette 2026-09-08). Vacio = los de fabrica.
  const [linkMsgs,setLinkMsgs]=useState({});
  const [showMsgEditor,setShowMsgEditor]=useState(false);
  const [msgDraft,setMsgDraft]=useState({});
  // La caja que se esta traduciendo ahora mismo, para apagar los botones y
  // ensenar el "..." solo en esa. Vacio = no hay ninguna en marcha.
  const [msgTranslating,setMsgTranslating]=useState("");
  const [msgSaving,setMsgSaving]=useState(false);

  // Load agency-defined custom statuses + the welcome-kit template (shared
  // across all seats of the agency).
  useEffect(()=>{
    if(!isApiModeR) return;
    apiGetAgencySettings().then(s=>{
      if(Array.isArray(s?.renewalStatuses)){ setCustomStatuses(s.renewalStatuses); recordarEstatusPropiosDeRenovacion(s.renewalStatuses); }
      if(s?.welcomeKitTemplates && typeof s.welcomeKitTemplates==="object") setKitByType(s.welcomeKitTemplates);
      if(s?.renewalReviewFields && typeof s.renewalReviewFields==="object") setReviewFieldsByType(s.renewalReviewFields);
      if(s?.renewalLinkMessages && typeof s.renewalLinkMessages==="object") setLinkMsgs(s.renewalLinkMessages);
    }).catch(()=>{});
  },[]);

  const allStatuses = useMemo(()=>todosLosEstatusDeRenovacion(customStatuses,es?"es":"en"),[customStatuses,es]);
  const statusMeta = id => allStatuses.find(s=>s.id===id) || allStatuses[0];

  // Policies near renewal: within the window OR already overdue (bounded so
  // ancient expired rows don't flood the list).
  // La ventana la manda Perfil -> Preferencias -> Avisos, y puede ser distinta
  // por tipo de poliza (salud con 4 meses, auto con 30 dias...). Antes estaba
  // clavada en 90 dias: se configuraba el aviso y el modulo seguia enseñando lo
  // mismo, asi que las polizas avisadas a 120 dias no aparecian aqui hasta el
  // dia 90 (Lissette 2026-08-25). La regla — y el porque de NO aplicar el plazo
  // general a secas cuando nadie ha configurado nada — vive en
  // `renewalWindowDays`, en crm-app/utils.js, junto a los otros lectores de
  // estos ajustes.
  const windowDaysFor=useCallback((typeId)=>renewalWindowDays(userPrefs,typeId,RENEWAL_WINDOW_DAYS),[userPrefs]);
  const inWindow=useMemo(()=>{
    return policies.filter(p=>{
      // Una cancelada solo sigue si se renovo con una poliza NUEVA: va a
      // "Renovadas". Antes desaparecia siempre, y cancelar la vieja antes del
      // kit borraba a la persona de la lista (Lissette 2026-09-26).
      if(p.status==="inactive"||p.status==="cancelled") return canceladaPeroRenovada(p,windowDaysFor(p.type));
      // Lo que se acaba de RENOVAR entra aunque su fecha nueva quede lejos.
      // Sin esto desaparecia de las dos pestañas en el acto: "Marcar Renovada"
      // mueve la fecha un año adelante, y 365 dias no caben en una ventana de
      // 90. Era la mitad del fallo de la pestaña "Renovadas" (E-294).
      if(renovadaEnCicloCerrado(p,windowDaysFor(p.type))) return true;
      const d=daysUntil(p.renewalDate);
      if(d===null) return false;
      // El limite hacia atras (lo ya vencido) se queda en los 90 dias de
      // siempre: es un tope para que no inunden filas antiguas, no un aviso.
      return d<=windowDaysFor(p.type) && d>=-RENEWAL_WINDOW_DAYS;
    }).sort((a,b)=>daysUntil(a.renewalDate)-daysUntil(b.renewalDate));
  },[policies,windowDaysFor]);

  // Renovadas = las de este ciclo que ya llegaron a DONE, que es cuando se les
  // envia el kit. Se separan de la lista de trabajo en vez de esconderse: la
  // etapa esta amarrada al ciclo (renewalStageCycle), asi que cuando la poliza
  // entra en su nuevo termino el servidor la devuelve sin etapa y vuelve sola a
  // Pendientes. Esta pestana enseña las renovadas DE ESTE CICLO, no un archivo.
  //
  // SOMETIDA no entra aqui (decision de Lissette, 2026-08-28): todavia puede
  // volverse atras, y darla por renovada la sacaria de la vista justo cuando
  // hay que estar pendiente de la respuesta de la aseguradora.
  // La regla de "que cuenta como renovada" vive en crm-app/utils.js, no aqui:
  // asi se puede probar sin React y no acaba escrita dos veces (E-138).
  // stageOf se define arriba del reparto a proposito — declararlo mas abajo lo
  // dejaria sin inicializar cuando este useMemo lo lee, y la pantalla
  // reventaria al entrar.
  const stageOf=etapaDeRenovacion;
  const {pendientes,renovadas,noRenuevan}=useMemo(()=>repartirRenovaciones(inWindow,p=>windowDaysFor(p.type)),[inWindow,windowDaysFor]);
  const visibles=tab==="renovadas"?renovadas:tab==="norenuevan"?noRenuevan:pendientes;
  // EL STATUS QUE SE VE (Lissette 2026-10-17: *"cuando se marca como renovada
  // y le da en ver Renovadas no se cambia el estado a Done"*). Todo lo que está
  // en Renovadas está renovado: enseña "Lista / Done" aunque `renewalStage`
  // venga vacío. Viene vacío cuando la fecha cambió después de marcarla (antes
  // se corría +365 sola) y el ciclo ya no coincide; la marca sigue en
  // `renewalStageGuardada`, que es lo que mira `estaRenovada`.
  const etapaVisible=useCallback(p=>tab==="renovadas"?"DONE":stageOf(p),[tab]);

  // Distinct policy types & carriers present in the window — for the filters.
  const distinctTypes=useMemo(()=>[...new Set(visibles.map(p=>p.type).filter(Boolean))],[visibles]);
  // Que dice el subtitulo: un solo numero cuando todos los tipos a la vista
  // usan el mismo plazo, y "segun Preferencias" cuando hay plazos distintos —
  // enseñar uno de ellos seria mentir sobre los demas.
  // Que dice el subtitulo. Con un tipo filtrado enseña EL PLAZO DE ESE TIPO —
  // que es lo unico que se esta mirando — y con todos, el numero si todos
  // coinciden. "Segun Preferencias" queda solo para cuando de verdad conviven
  // varios plazos distintos a la vista.
  //
  // Antes decia "segun Preferencias" en cuanto hubiera dos plazos distintos, es
  // decir JUSTO cuando alguien afina por tipo — y entonces no habia forma de
  // comprobar si el plazo que acababas de escribir estaba aplicandose o no
  // (Lissette 2026-08-25: "le cambie la alerta y se quedan igual"). Enseñar el
  // numero es lo que convierte esa duda en un dato.
  const windowLabel=useMemo(()=>{
    if(typeFilter!=="all") return `${windowDaysFor(typeFilter)}d`;
    const vals=new Set(distinctTypes.map(windowDaysFor));
    if(vals.size===0) return `${windowDaysFor(null)}d`;
    if(vals.size===1) return `${[...vals][0]}d`;
    return es?"según Preferencias":"per Preferences";
  },[distinctTypes,windowDaysFor,es,typeFilter]);
  const distinctCarriers=useMemo(()=>[...new Set(visibles.map(p=>(p.carrier||"").trim()).filter(Boolean))].sort((a,b)=>a.localeCompare(b)),[visibles]);
  // Reset a filter if its selected value disappears from the window.
  useEffect(()=>{ if(typeFilter!=="all" && !distinctTypes.includes(typeFilter)) setTypeFilter("all"); },[distinctTypes,typeFilter]);
  useEffect(()=>{ if(carrierFilter!=="all" && !distinctCarriers.includes(carrierFilter)) setCarrierFilter("all"); },[distinctCarriers,carrierFilter]);
  // Los status y los encargados que de verdad hay a la vista. Ofrecer el
  // catalogo entero llenaria el desplegable de opciones que no devuelven ni
  // una fila — el mismo criterio que ya usan Tipo y Compania.
  const distinctStages=useMemo(()=>[...new Set(visibles.map(etapaVisible))],[visibles,etapaVisible]);
  // El encargado de cada fila: el guardado, o si nunca se tocó, el que atiende
  // al cliente en su ficha (Lissette 2026-09-30). Ver encargadoDeLaRenovacion.
  const encargadoDe=useCallback(p=>encargadoDeLaRenovacion(p,clientsById.get(p.clientId)),[clientsById]);
  const distinctEncargados=useMemo(()=>[...new Set(visibles.map(encargadoDe).filter(Boolean))],[visibles,encargadoDe]);
  // Las opciones de "Atiende": las que hay de verdad en las filas a la vista,
  // con el mismo vocabulario que el filtro de Clientes (id del asiento, o
  // "txt:" + el nombre suelto cuando todavia no tiene asiento).
  const opcionesAtiende=useMemo(()=>{
    const m=new Map();
    for(const p of visibles){
      const c=clientsById.get(p.clientId); if(!c) continue;
      const al=etiquetaDeAtiende(c.attendedBySeatId,c.attendedByName,seatLabels,users); if(!al) continue;
      const v=c.attendedBySeatId||(PREFIJO_LIBRE+String(c.attendedByName||"").trim());
      if(!m.has(v)) m.set(v,al.name);
    }
    return [...m.entries()].map(([value,label])=>({value,label})).sort((a,b)=>a.label.localeCompare(b.label,"es"));
  },[visibles,clientsById,seatLabels,users]);
  useEffect(()=>{ if(stageFilter!=="all" && stageFilter!=="none" && !distinctStages.includes(stageFilter)) setStageFilter("all"); },[distinctStages,stageFilter]);
  // Al cambiar de pestana se suelta la seleccion: si no, "enviar a los
  // seleccionados" dispararia sobre filas que ya no estan a la vista — el
  // usuario no puede confirmar lo que no ve.
  useEffect(()=>{ setSelectedIds(new Set()); },[tab]);
  useEffect(()=>{ if(encargadoFilter!=="all" && encargadoFilter!=="none" && !distinctEncargados.includes(encargadoFilter)) setEncargadoFilter("all"); },[distinctEncargados,encargadoFilter]);
  useEffect(()=>{ if(atiendeFilter!=="all" && atiendeFilter!=="none" && !opcionesAtiende.some(o=>o.value===atiendeFilter)) setAtiendeFilter("all"); },[opcionesAtiende,atiendeFilter]);
  // Los agentes escritos en las fichas de las filas a la vista.
  const agenteDeLaFila=useCallback(p=>agenteEscritoEnLaFicha(clientsById.get(p.clientId)),[clientsById]);
  const opcionesAgente=useMemo(()=>[...new Set(visibles.map(agenteDeLaFila).filter(Boolean))].sort((a,b)=>a.localeCompare(b,"es")),[visibles,agenteDeLaFila]);
  useEffect(()=>{ if(agenteFilter!=="all" && agenteFilter!=="none" && !opcionesAgente.includes(agenteFilter)) setAgenteFilter("all"); },[opcionesAgente,agenteFilter]);
  // Lo que ofrece el desplegable de cada columna propia. Sale de `visibles` —
  // lo que hay a la vista ANTES de filtrar— y no de `filtered`: si saliera de
  // lo filtrado, elegir una opcion borraria del desplegable todas las demas y
  // no habria manera de cambiar de idea sin volver a "Todas".
  const opcionesDeFiltroPropio=useMemo(()=>{
    const m={};
    for(const col of colsPropias){
      m[col.id]=opcionesDeFiltroDeColumna(col,visibles.map(p=>(celdas[p.id]||{})[col.id]||""),lang);
    }
    return m;
  },[colsPropias,visibles,celdas,lang]);
  // Un filtro puesto sobre algo que ya no esta se suelta solo, como los otros
  // cinco. Si no, la tabla se quedaria vacia por un valor que ya nadie tiene y
  // sin nada que tocar para recuperarla.
  useEffect(()=>{
    setFiltrosPropios(prev=>{
      const next={...prev}; let cambia=false;
      for(const [id,val] of Object.entries(prev)){
        if(!(opcionesDeFiltroPropio[id]||[]).some(o=>o.value===val)){ delete next[id]; cambia=true; }
      }
      return cambia?next:prev;
    });
  },[opcionesDeFiltroPropio]);

  const filtered=useMemo(()=>visibles.filter(p=>{
    if(typeFilter!=="all" && p.type!==typeFilter) return false;
    if(carrierFilter!=="all" && (p.carrier||"").trim()!==carrierFilter) return false;
    if(stageFilter!=="all" && etapaVisible(p)!==stageFilter) return false;
    // "none" = sin encargado. Es una respuesta legitima ("que esta sin
    // repartir"), no la ausencia de filtro.
    if(encargadoFilter!=="all"){
      const enc=encargadoDe(p);
      if(encargadoFilter==="none"){ if(enc) return false; }
      else if(enc!==encargadoFilter) return false;
    }
    if(atiendeFilter!=="all" && !pasaElFiltroDeAtiende(clientsById.get(p.clientId),atiendeFilter)) return false;
    if(agenteFilter!=="all"){
      const ag=agenteDeLaFila(p);
      if(agenteFilter==="none"){ if(ag) return false; }
      else if(ag!==agenteFilter) return false;
    }
    if(clientFilter.trim()){ const c=clientsById.get(p.clientId); const nm=c?`${c.firstName} ${c.lastName}`.toLowerCase():""; if(!nm.includes(clientFilter.trim().toLowerCase())) return false; }
    if(reviewFilter!=="all"){
      const rv=reviews[p.id];
      if(estadoDeRevision(rv)!==reviewFilter) return false;
    }
    // Las columnas propias de la agencia. "Sin valor" es una respuesta
    // legitima y es LA que se pidió: quién no tiene el ID.me todavía.
    for(const col of colsPropias){
      const elegido=filtrosPropios[col.id];
      if(!elegido) continue;
      if(!pasaFiltroDeColumnaPropia(col,(celdas[p.id]||{})[col.id]||"",elegido)) return false;
    }
    return true;
  }),[visibles,typeFilter,carrierFilter,stageFilter,encargadoFilter,atiendeFilter,agenteFilter,reviewFilter,clientFilter,clients,reviews,colsPropias,filtrosPropios,celdas,encargadoDe,etapaVisible,agenteDeLaFila]);

  // DOS VACIOS QUE NO SE PARECEN EN NADA.
  //
  //   · Vacio DE VERDAD: no hay renovaciones en la ventana, o no hay ninguna en
  //     esta pestaña. No hay filtro que quitar, y la tabla no pinta nada.
  //   · Vacio POR FILTROS: hay filas, pero los filtros las esconden. Aqui la
  //     tabla SI se pinta —con su cabecera, que es donde viven los filtros— y
  //     el mensaje va donde irian las filas.
  //
  // Tratarlos igual es lo que dejaba la pantalla sin salida: el mensaje se
  // comia el control que acababa de usarse (Lissette 2026-09-23).
  const vacioDeVerdad=filtered.length===0&&visibles.length===0;
  const vacioPorFiltros=filtered.length===0&&visibles.length>0;
  // Los nombres de las columnas propias, para poder DECIR que filtro esconde
  // las filas en vez de un "ningun resultado" a secas.
  const nombresDeColsPropias=useMemo(()=>Object.fromEntries((colsPropias||[]).map(c=>[c.id,c.name])),[colsPropias]);
  const filtrosActivos=useMemo(()=>filtrosPuestos(
    {typeFilter,carrierFilter,stageFilter,encargadoFilter,atiendeFilter,agenteFilter,reviewFilter,clientFilter,filtrosPropios},
    nombresDeColsPropias,lang,
  ),[typeFilter,carrierFilter,stageFilter,encargadoFilter,atiendeFilter,agenteFilter,reviewFilter,clientFilter,filtrosPropios,nombresDeColsPropias,lang]);
  // Quitarlos TODOS de una vez. La lista de cuales son vive en
  // crm-app/filtrosDeRenovaciones.js para que no se olvide ninguno el dia que
  // se añada el septimo — que es la forma exacta en que esto vuelve.
  const limpiarFiltros=useCallback(()=>{
    const v=valoresSinFiltro();
    setTypeFilter(v.typeFilter);
    setCarrierFilter(v.carrierFilter);
    setStageFilter(v.stageFilter);
    setEncargadoFilter(v.encargadoFilter);
    setAtiendeFilter(v.atiendeFilter);
    setAgenteFilter(v.agenteFilter);
    setReviewFilter(v.reviewFilter);
    setClientFilter(v.clientFilter);
    setFiltrosPropios(v.filtrosPropios);
  },[]);

  // --- Renewal review (Part 2): load per-policy status + 2-step SMS senders ---
  const loadReviews=useCallback(async()=>{
    if(!isApiModeR) return;
    const ids=inWindow.map(p=>p.id);
    if(!ids.length){ setReviews({}); return; }
    try{
      const rows=await apiRenewalReviewsByPolicies(ids);
      const map={}; rows.forEach(r=>{ if(r.policyId) map[r.policyId]=r; });
      setReviews(map);
    }catch{ /* non-fatal — chip just shows "Revisión" */ }
  },[inWindow]);
  useEffect(()=>{ loadReviews(); /* eslint-disable-next-line */ },[loadReviews]);

  const rvMeta=(status)=>({
    NOTIFIED:{label:es?"Aviso enviado":"Notice sent",color:"#64748b"},
    SENT:{label:es?"Link enviado":"Link sent",color:"#0ea5e9"},
    VIEWED:{label:es?"Visto":"Viewed",color:"#06b6d4"},
    CONFIRMED:{label:es?"Confirmado":"Confirmed",color:"#10b981"},
    ADJUST:{label:es?"Pidió ajuste":"Wants change",color:"#f59e0b"},
  }[status]||null);

  // El texto sale de la plantilla de la agencia; si no escribio ninguna, de la
  // de fabrica, que es palabra por palabra la que habia aqui escrita a fuego.
  const composeReviewMsg=(kind,lng,firstName,agentName,url)=>componerMensaje({
    mensajes:linkMsgs, tipo:kind, lang:lng==="es"?"es":"en",
    nombre:firstName, agente:agentName, enlace:url,
  });

  // Insert a real value (client name, agent name, link) at the cursor of the
  // SMS box. This message is a one-off for THIS client, so we drop the literal
  // value — not a {token} — which always renders correctly.
  const insertSmsVar=val=>{
    const el=document.getElementById("sms-msg");
    setSmsModal(m=>{
      if(!m) return m;
      const cur=m.message||"";
      if(!el||typeof el.selectionStart!=="number") return {...m,message:cur+val};
      const start=el.selectionStart,end=el.selectionEnd;
      setTimeout(()=>{ try{ el.focus(); el.selectionStart=el.selectionEnd=start+val.length; }catch{} },40);
      return {...m,message:cur.slice(0,start)+val+cur.slice(end)};
    });
  };
  // ES/EN toggle for the SMS message: translate into the chosen language in
  // place (preserves the link). Clicking the active language is a no-op.
  const translateSmsTo=async(to)=>{
    if(!smsModal||smsTranslating) return;
    const from=smsModal.lng==="es"?"es":"en";
    if(to===from) return;
    setSmsTranslating(true);
    try{
      const { aiTranslateTemplate }=await import("./crm-app/api.js");
      const { translated }=await aiTranslateTemplate({text:smsModal.message||"",fromLang:from,toLang:to});
      // El asunto del correo cambia de idioma con el texto si nadie lo tocó.
      setSmsModal(m=>m?{...m,message:(translated&&translated.trim())?translated:m.message,lng:to,subject:m.subject===asuntoDelLink(from)?asuntoDelLink(to):m.subject}:m);
    }catch(err){ toast.error((es?"No se pudo traducir: ":"Translation failed: ")+(err.message||"")); }
    finally{ setSmsTranslating(false); }
  };
  // El link también por CORREO (Lissette 2026-10-05: "muchas agencias no
  // tienen SMS"). Misma ventana, mismo texto de la agencia; solo cambia por
  // dónde sale y que el correo lleva asunto. Solo el link: el aviso es para que
  // el cliente conteste "SÍ" por SMS.
  const asuntoDelLink=(lng)=>lng==="es"?"Revisa tus datos para la renovación de tu póliza":"Please review your information for your policy renewal";
  const openSmsModal=async(p,c,kind,canal="sms")=>{
    if(!c){ toast.error(es?"Cliente no encontrado":"Client not found"); return; }
    if(canal==="email"){ if(!c.email){ toast.error(es?"Este cliente no tiene correo.":"This client has no email."); return; } }
    else if(!c.phone){ toast.error(es?"Este cliente no tiene teléfono.":"This client has no phone."); return; }
    setReviewBusy(p.id);
    try{
      const { review, url }=await apiEnsureRenewalReview(c.id,{ policyId:p.id, fields:fieldsForPolicy(p.type) });
      const agentName=presentingAgentName(currentUser, "");
      const lng=c.preferredLanguage||c.language||lang;
      setSmsModal({ policy:p, client:c, reviewId:review.id, token:review.token, kind, canal, subject:asuntoDelLink(lng), agentName, url, lng:lng==="es"?"es":"en", message:composeReviewMsg(kind,lng,c.firstName||"",agentName,url) });
      setReviews(prev=>({...prev,[p.id]:{...(prev[p.id]||{}),...review}}));
    }catch(err){ toast.error((es?"No se pudo preparar: ":"Couldn't prepare: ")+(err.message||"")); }
    finally{ setReviewBusy(null); }
  };

  const sendReviewSms=async()=>{
    if(!smsModal) return;
    const { reviewId, kind, message, canal, subject }=smsModal;
    if(!message.trim()){ toast.error(es?"Escribe el mensaje":"Write the message"); return; }
    if(canal==="email"&&!String(subject||"").trim()){ toast.error(es?"Escribe el asunto":"Write the subject"); return; }
    setSendingSms(true);
    try{
      if(canal==="email") await apiSendRenewalReviewEmail(reviewId,{ subject:subject.trim(), message:message.trim() });
      else await apiSendRenewalReviewSms(reviewId,{ kind, message:message.trim() });
      toast.success(kind==="notice"?(es?"Aviso enviado ✅":"Notice sent ✅"):canal==="email"?(es?"Link enviado por correo ✅":"Link emailed ✅"):(es?"Link enviado ✅":"Link sent ✅"));
      setSmsModal(null);
      await loadReviews();
    }catch(err){
      // El motivo, traducido: el servidor contesta en inglés y esta pantalla la
      // usa gente que trabaja en español.
      toast.error((es?"No se pudo enviar: ":"Could not send: ")+motivoDelSms(err?.code,err?.message,lang));
    }
    finally{ setSendingSms(false); }
  };

  const copyReviewLink=(token)=>{
    navigator.clipboard?.writeText(`${window.location.origin}/revision/${token}`).catch(()=>{});
    toast.success(es?"¡Link copiado!":"Link copied!");
  };

  // Acciones de la columna Revisión. Las dos principales (aviso / link) se
  // reparten el ancho en mitades iguales y NUNCA se parten de línea; las
  // utilidades (copiar, cancelar) son iconos cuadrados con menos peso visual.
  // Antes las cuatro eran la misma píldora en una fila con flexWrap, así que
  // la "✕" de cancelar caía sola a un segundo renglón y la celda se veía rota.
  const rvBtn=(color,disabled)=>({flex:1,minWidth:0,display:"inline-flex",alignItems:"center",justifyContent:"center",gap:5,fontSize:".74rem",fontWeight:700,padding:"6px 10px",borderRadius:8,border:`1px solid ${color}55`,background:`${color}14`,color,cursor:disabled?"not-allowed":"pointer",opacity:disabled?.5:1,whiteSpace:"nowrap"});
  const rvIconBtn=(color,disabled)=>({width:28,height:28,flexShrink:0,display:"inline-flex",alignItems:"center",justifyContent:"center",padding:0,borderRadius:8,border:`1px solid ${color}40`,background:`${color}10`,color,cursor:disabled?"not-allowed":"pointer",opacity:disabled?.5:1});

  const cancelReview=async(p)=>{
    const rv=reviews[p.id]; if(!rv) return;
    setReviewBusy(p.id);
    try{ await apiRevokeRenewalReview(rv.id); await loadReviews(); toast.success(es?"Revisión cancelada":"Review canceled"); }
    catch(err){ toast.error(err.message||(es?"No se pudo cancelar":"Could not cancel")); }
    finally{ setReviewBusy(null); }
  };

  // Part 3 — which fields show for a policy: per-type override → default → built-in.
  const fieldsForPolicy=(typeId)=>{
    const map=reviewFieldsByType||{};
    if(Array.isArray(map[typeId])&&map[typeId].length) return map[typeId];
    if(Array.isArray(map.__default__)&&map.__default__.length) return map.__default__;
    return RR_DEFAULT_KEYS;
  };
  const openFieldsEditor=()=>{ setFieldsEditType("__default__"); setFieldsDraft(fieldsForPolicy("__default__")); setShowFieldsEditor(true); };
  // El editor arranca SIEMPRE con texto dentro: si la agencia no ha escrito el
  // suyo, se precarga el de fabrica. Un cuadro vacio no dice que hay un texto
  // por defecto — parece que no se manda nada.
  const openMsgEditor=()=>{
    const d={};
    ["notice","link"].forEach(t=>["es","en"].forEach(l=>{ const k=llaveDe(t,l); d[k]=plantillaDe(linkMsgs,t,l); }));
    setMsgDraft(d); setShowMsgEditor(true);
  };
  const restaurarMensaje=(tipo,lng)=>setMsgDraft(d=>({...d,[llaveDe(tipo,lng)]:PLANTILLAS_DE_FABRICA[llaveDe(tipo,lng)]}));
  // Traducir el texto de un idioma al OTRO con un boton (Lissette 2026-09-09:
  // "que se traduzca automaticamente al apretar el boton"). Misma tuberia que
  // ya usan Firmas, Correos masivos y la ventana de envio de este mismo
  // modulo: /api/v1/ai/translate sobre Azure OpenAI, que esta bajo el BAA.
  //
  // ESCRIBE EN LA CAJA DEL OTRO IDIOMA Y NO TOCA LA DE ORIGEN: apretarlo por
  // equivocacion nunca borra lo que acabas de escribir.
  //
  // Y NO GUARDA NADA: deja el texto puesto para que se lea antes de darle a
  // Guardar. Una traduccion automatica que se publica sola al equipo entero es
  // justo lo que no se puede hacer con el texto que ve un cliente.
  const traducirMensaje=async(tipo,desde)=>{
    const hacia=desde==="es"?"en":"es";
    const destino=llaveDe(tipo,hacia);
    const origen=String(msgDraft[llaveDe(tipo,desde)]||"").trim();
    if(!origen){ toast.error(es?"Escribe primero el mensaje que quieres traducir.":"Write the message you want to translate first."); return; }
    if(msgTranslating) return;
    setMsgTranslating(destino);
    try{
      const { aiTranslateTemplate }=await import("./crm-app/api.js");
      const { translated }=await aiTranslateTemplate({ text:origen, fromLang:desde, toLang:hacia });
      const limpio=String(translated||"").trim().slice(0,LARGO_DEL_MENSAJE);
      // Que las variables sigan ahi se COMPRUEBA. El modelo tiene instrucciones
      // de no tocar lo que va entre llaves, pero "tiene instrucciones" no es
      // "lo hizo", y un {enlace} perdido es un SMS que no lleva el enlace.
      const problema=problemaDeLaTraduccion(origen,limpio,es?"es":"en");
      if(problema){ toast.error(problema); return; }
      setMsgDraft(d=>({...d,[destino]:limpio}));
      toast.success(es?"Traducido. Revisalo y dale a Guardar.":"Translated. Check it and hit Save.");
    }catch(err){ toast.error((es?"No se pudo traducir: ":"Translation failed: ")+(err.message||"")); }
    finally{ setMsgTranslating(""); }
  };
  const saveMsgs=async()=>{
    // Se avisa ANTES de guardar y se dice cual de los cuatro esta mal: guardar
    // un mensaje de enlace sin {enlace} manda al cliente un SMS que le pide
    // revisar algo sin decirle donde.
    for(const t of ["notice","link"]) for(const l of ["es","en"]){
      const problema=problemaDeLaPlantilla(t,msgDraft[llaveDe(t,l)],es?"es":"en");
      if(problema){ toast.error(`${t==="notice"?(es?"Aviso":"Notice"):(es?"Enlace":"Link")} ${l.toUpperCase()}: ${problema}`); return; }
    }
    const next=limpiarMensajes(msgDraft);
    setMsgSaving(true);
    try{
      if(isApiModeR) await apiUpdateAgencySettings({ renewalLinkMessages:next });
      setLinkMsgs(next); setShowMsgEditor(false);
      toast.success(es?"Mensaje guardado para todo el equipo":"Message saved for the whole team");
    }catch(err){ toast.error((es?"No se pudo guardar: ":"Could not save: ")+(err.message||"")); }
    finally{ setMsgSaving(false); }
  };
  const switchFieldsType=(tid)=>{ const map=reviewFieldsByType||{}; setFieldsEditType(tid);
    setFieldsDraft(Array.isArray(map[tid])&&map[tid].length?map[tid]:(Array.isArray(map.__default__)&&map.__default__.length?map.__default__:RR_DEFAULT_KEYS)); };
  const toggleFieldDraft=(key)=>setFieldsDraft(prev=>prev.includes(key)?prev.filter(k=>k!==key):[...prev,key]);
  const saveFields=async()=>{
    if(fieldsDraft.length===0){ toast.error(es?"Elige al menos un campo.":"Pick at least one field."); return; }
    const next={...(reviewFieldsByType||{})};
    next[fieldsEditType]=fieldsDraft;
    setReviewFieldsByType(next); setShowFieldsEditor(false);
    try{ if(isApiModeR) await apiUpdateAgencySettings({ renewalReviewFields:next }); toast.success(es?"Campos guardados":"Fields saved"); }
    catch(err){ toast.error((es?"No se pudo guardar: ":"Could not save: ")+(err.message||"")); }
  };

  // Order rows by review status when the column header is clicked.
  const rrRank=(p)=>RR_STATUS_RANK[estadoDeRevision(reviews[p.id])]??0;
  const cycleSort=(col)=>{ if(sortCol!==col){ setSortCol(col); setSortDir("asc"); } else if(sortDir==="asc"){ setSortDir("desc"); } else { setSortCol(null); } };
  const sortArrow=(col)=> sortCol!==col?"⇅":(sortDir==="asc"?"▲":"▼");
  const displayRows=useMemo(()=>{
    if(!sortCol) return filtered;
    const nameOf=(p)=>{ const c=clientsById.get(p.clientId); return c?`${c.firstName} ${c.lastName}`.toLowerCase():""; };
    const typeOf=(p)=>{ const pt=getPolicyType(p.type); return String((es?(pt.labelEs||pt.label):pt.label)||"").toLowerCase(); };
    return [...filtered].sort((a,b)=>{
      let d=0;
      if(sortCol==="client") d=nameOf(a).localeCompare(nameOf(b));
      else if(sortCol==="type") d=typeOf(a).localeCompare(typeOf(b));
      else d=rrRank(a)-rrRank(b);
      return sortDir==="asc"?d:-d;
    });
  // eslint-disable-next-line
  },[filtered,sortCol,sortDir,reviews,clients]);

  // Bulk select + send (Lissette 2026-06-26): pick several rows and fire the
  // notice/link SMS to all of them with the default message in one go.
  const toggleSelect=(id)=>setSelectedIds(prev=>{ const n=new Set(prev); if(n.has(id))n.delete(id); else n.add(id); return n; });
  const allVisibleSelected=displayRows.length>0 && displayRows.every(p=>selectedIds.has(p.id));
  const toggleSelectAll=()=>setSelectedIds(allVisibleSelected?new Set():new Set(displayRows.map(p=>p.id)));
  const bulkSend=async(kind,canal="sms")=>{
    const ids=[...selectedIds].filter(id=>displayRows.some(p=>p.id===id));
    if(!ids.length){ toast.error(es?"No hay nada seleccionado.":"Nothing selected."); return; }
    const porCorreo=canal==="email";
    const ok=window.confirm(es?`¿Enviar ${kind==="link"?"el LINK":"el AVISO"} por ${porCorreo?"CORREO":"SMS"} a ${ids.length} cliente(s)?`:`Send the ${kind==="link"?"LINK":"NOTICE"} by ${porCorreo?"EMAIL":"SMS"} to ${ids.length} client(s)?`);
    if(!ok) return;
    setBulkBusy(true);
    let sent=0,skipped=0;
    // POR QUE FALLO CADA UNO, no cuantos fallaron.
    //
    // Crismar Perez (agencia de Maricarmen Nieto, 2026-09-14): *"al enviar el
    // mensaje para que el cliente responda SI nos sale error y no se envía"*, y
    // la captura enseñaba **"Enviados: 0 · fallaron: 1"** y nada más. El
    // servidor sí dice el motivo de cada fallo —no hay línea de SMS conectada,
    // el número está en No-Textear, el cliente no tiene teléfono— y aquí un
    // `catch{ failed++ }` lo tiraba entero. Un contador sin motivo no se puede
    // arreglar: no se sabe si falta conectar la línea o si es cosa de ESE
    // cliente.
    const fallos=[];
    for(const pid of ids){
      const p=inWindow.find(x=>x.id===pid);
      const c=p?clients.find(cl=>cl.id===p.clientId):null;
      const nombre=c?`${c.firstName||""} ${c.lastName||""}`.trim():"";
      if(!p){ fallos.push({nombre,motivo:es?"esa póliza ya no está en la lista":"that policy is no longer in the list"}); continue; }
      if(porCorreo){ if(!c?.email){ fallos.push({nombre,motivo:motivoDelSms("no-email","",lang)}); continue; } }
      else if(!c?.phone){ skipped++; continue; }
      try{
        const { review, url }=await apiEnsureRenewalReview(c.id,{ policyId:p.id, fields:fieldsForPolicy(p.type) });
        const agentName=presentingAgentName(currentUser, "");
        const lng=c.preferredLanguage||c.language||lang;
        const message=composeReviewMsg(kind,lng,c.firstName||"",agentName,url);
        if(porCorreo) await apiSendRenewalReviewEmail(review.id,{ subject:asuntoDelLink(lng==="es"?"es":"en"), message });
        else await apiSendRenewalReviewSms(review.id,{ kind, message });
        sent++;
      }catch(err){ fallos.push({nombre,motivo:motivoDelSms(err?.code,err?.message,lang)}); }
    }
    setBulkBusy(false); setSelectedIds(new Set()); await loadReviews();
    const resumen=resumenDelEnvio({enviados:sent,sinTelefono:skipped,fallos,lang});
    // Y si no salió ni uno, el aviso NO es verde. El de antes se pintaba de
    // "todo bien" diciendo "Enviados: 0".
    if(fallos.length) toast.error(resumen); else toast.success(resumen);
  };

  const kitReasonMsg = reason => ({
    no_client_email: es?"El cliente no tiene correo — no se envió el kit.":"Client has no email — kit not sent.",
    no_supervisor: es?"Este asiento no tiene agente asignado.":"This seat has no supervising agent.",
    agent_no_mailbox: es?"Conecta tu correo para enviar el kit.":"Connect your email to send the kit.",
    send_failed: es?"No se pudo enviar el kit. Intenta de nuevo.":"The kit could not be sent. Try again.",
    missing_docs: es?"Faltan documentos requeridos.":"Required documents are missing.",
    already_sent: es?"El kit de este ciclo ya se había enviado; no se volvió a enviar.":"This cycle's kit was already sent; it was not sent again.",
  }[reason] || (es?"No se envió el kit.":"Kit not sent."));

  const reenviarKit = async (p, sentAt, forzar=false) => {
    const cuando = sentAt ? new Date(sentAt).toLocaleDateString(es?"es-US":"en-US",{month:"short",day:"numeric",year:"numeric"}) : "";
    if(!forzar){
      const ok = await confirmDialog({
        title: es?"El kit ya se envió":"Kit already sent",
        message: es
          ? `El kit de bienvenida de este ciclo ya se envió${cuando?` el ${cuando}`:""}. ¿Enviarlo otra vez con los datos y documentos actualizados?`
          : `This cycle's welcome kit was already sent${cuando?` on ${cuando}`:""}. Send it again with the updated details and documents?`,
        confirmLabel: es?"Reenviar kit":"Resend kit",
      });
      if(!ok) return;
    }
    try{
      const { kit } = await apiSendWelcomeKit({ policyId: nuevaPorVieja.current[p.id] || p.id, forceKit: forzar || undefined });
      if(kit?.sent){ avisarKitEnviado(toast,(es?"Kit reenviado a ":"Kit resent to ")+(kit.sentTo||""),kit.mensaje,es); return; }
      if(kit?.reason==="missing_docs" && !forzar){
        const faltan = (Array.isArray(kit.missing)?kit.missing:[]).map(m=>es?(m.nameEs||m.name):(m.name||m.nameEs)).filter(Boolean);
        const seguir = await confirmDialog({
          title: es?"Faltan documentos":"Missing documents",
          message: (es?"Faltan: ":"Missing: ")+(faltan.join(", ")||"—")+(es?". ¿Reenviar el kit de todos modos?":". Resend the kit anyway?"),
          confirmLabel: es?"Reenviar igual":"Resend anyway",
        });
        if(seguir) await reenviarKit(p, sentAt, true);
        return;
      }
      if(kit?.reason==="no_template"){ toast.warn(textoSinMensajeDeKit(kit.mensaje?.tipo,"renovacion",es),{duration:12000}); return; }
      toast.error(kitReasonMsg(kit?.reason));
    }catch(err){
      toast.error((es?"No se pudo reenviar el kit: ":"Could not resend the kit: ")+(err?.message||""));
    }
  };

  const handleKitResult = (p, kit) => {
    if(kit?.sent){ avisarKitEnviado(toast,(es?"Kit de bienvenida enviado a ":"Welcome kit sent to ")+(kit.sentTo||""),kit.mensaje,es); return; }
    if(kit?.reason==="missing_docs"){ setMissingDocsModal({ policy:p, missing:Array.isArray(kit.missing)?kit.missing:[] }); return; }
    // toast es un objeto (toast.info/success/error), no una función: llamarlo así tumbaba
    // "Marcar renovada" con "pe is not a function" cuando el kit ya se había enviado (E-414).
    // YA SE ENVIÓ EN ESTE CICLO: se pregunta si se reenvía, en vez de solo
    // decir que no (Paula Angarita, 2026-11-03: "cambié ingresos en una póliza
    // que renové... el plan cambió de precio y me gustaría volver a enviar el
    // kit"). El reenvío va por /send-welcome-kit, con la póliza nueva si se
    // renovó con otra.
    if(kit?.reason==="already_sent"){ reenviarKit(p, kit.sentAt); return; }
    if(kit?.reason==="no_template"){ toast.warn(textoSinMensajeDeKit(kit.mensaje?.tipo,"renovacion",es),{duration:12000}); return; }
    if(kit?.reason) toast.error(kitReasonMsg(kit.reason));
  };

  const moveStage=async(p,statusId)=>{
    setOpenStatusFor(null);
    if((p.renewalStage||"PROCESO")===statusId) return;
    const snapshot={stage:p.renewalStage??null,byName:p.renewalStageByName??null,at:p.renewalStageAt??null,history:Array.isArray(p.renewalStageHistory)?p.renewalStageHistory:[]};
    const myName=currentUser?.name||(es?"tú":"you");
    const nowIso=new Date().toISOString();
    const optimisticEntry={stage:statusId,by:currentUser?.id||null,byName:myName,at:nowIso};
    setSavingId(p.id);
    onPoliciesChange(prev=>prev.map(x=>x.id===p.id?{...x,renewalStage:statusId,renewalStageByName:myName,renewalStageAt:nowIso,renewalStageHistory:[...snapshot.history,optimisticEntry]}:x));
    try{
      if(isApiModeR){
        const { kit, data } = await apiSetRenewalStage({ policyId:p.id, stage:statusId });
        if(data&&Array.isArray(data.renewalStageHistory)) onPoliciesChange(prev=>prev.map(x=>x.id===p.id?{...x,renewalStageHistory:data.renewalStageHistory,renewalStageAt:data.renewalStageAt||x.renewalStageAt}:x));
        if(statusId==="DONE") handleKitResult(p, kit);
      }
      if(logTeamAction) logTeamAction("renewal_stage_changed", p.clientId, { policyId:p.id, stage:statusId });
    }catch(err){
      onPoliciesChange(prev=>prev.map(x=>x.id===p.id?{...x,renewalStage:snapshot.stage,renewalStageByName:snapshot.byName,renewalStageAt:snapshot.at,renewalStageHistory:snapshot.history}:x));
      toast.error((es?"No se pudo cambiar: ":"Could not change: ")+(err.message||""));
    }finally{ setSavingId(null); }
  };

  // "Send anyway" from the missing-docs alert: re-fire DONE with forceKit so
  // the backend skips the required-docs gate and sends the welcome kit.
  const forceSendKit=async p=>{
    setMissingDocsModal(null);
    if(!isApiModeR) return;
    setSavingId(p.id);
    try{
      const { kit } = await apiSetRenewalStage({ policyId:p.id, stage:"DONE", forceKit:true, renovadaConPolizaId:nuevaPorVieja.current[p.id]||undefined });
      if(kit?.sent) avisarKitEnviado(toast,(es?"Kit de bienvenida enviado a ":"Welcome kit sent to ")+(kit.sentTo||""),kit.mensaje,es);
      else if(kit?.reason) toast.error(kitReasonMsg(kit.reason));
    }catch(err){ toast.error((es?"No se pudo enviar: ":"Could not send: ")+(err.message||"")); }
    finally{ setSavingId(null); }
  };

  const startEditNote=p=>{ setEditNoteFor(p.id); setNoteDraft(p.renewalNote||""); };
  const saveNote=async p=>{
    const note=(noteDraft||"").trim();
    setEditNoteFor(null);
    if((p.renewalNote||"")===note) return;
    const snapshot=p.renewalNote??"";
    onPoliciesChange(prev=>prev.map(x=>x.id===p.id?{...x,renewalNote:note}:x));
    try{ if(isApiModeR) await apiSetRenewalNote({ policyId:p.id, note }); }
    catch(err){ onPoliciesChange(prev=>prev.map(x=>x.id===p.id?{...x,renewalNote:snapshot}:x)); toast.error((es?"No se pudo guardar la nota: ":"Could not save note: ")+(err.message||"")); }
  };

  const markRenewed=id=>{
    if (marcandoBusy) return;
    const pol = policies.find(p=>p.id===id);
    const oldRenewalDate = pol?.renewalDate || "";
    const nueva = renovarCon.modo==="nueva" ? policies.find(p=>p.id===renovarCon.nuevaId) : null;
    // RENOVADA CON UNA POLIZA NUEVA: el kit sale con la nueva, a la vieja NO
    // se le corre la fecha (su ciclo es el que se cierra) y, si se marco la
    // casilla, se cancela con fecha = su vencimiento.
    // La cancelacion de la vieja: con su fecha y su motivo. Si la fecha es
    // futura NO se cancela ahora, queda programada.
    const fechaCancel = renovarCon.fechaCancel || oldRenewalDate || "";
    const motivoCancel = unirMotivo(renovarCon.motivoCancel, (renovarCon.notaCancel||"").trim()).trim();
    const conNueva = async () => {
      let resultadoCancel = null;
      if (isApiModeR && pol) {
        nuevaPorVieja.current[id]=nueva.id;
        try {
          const { kit } = await apiSetRenewalStage({ policyId:id, stage:"DONE", renovadaConPolizaId:nueva.id });
          handleKitResult(pol, kit);
        } catch (err) { toast.error((es?"No se pudo marcar como renovada: ":"Failed to mark renewed: ")+(err.message||"")); return; }
        if (renovarCon.cancelarVieja) {
          try {
            resultadoCancel = await apiProgramarCancelacion(id, { fecha: fechaCancel, motivo: motivoCancel });
            if (resultadoCancel.cancelada) toast.success(es?"Póliza vieja cancelada.":"Old policy cancelled.");
            else toast.success((es?"La póliza vieja se cancelará el ":"The old policy will be cancelled on ")+fmt(fechaCancel)+(es?". Hasta entonces sigue activa.":". It stays active until then."));
          }
          catch (err) { toast.error((es?"Quedó renovada, pero no se pudo cancelar la póliza vieja: ":"Renewed, but the old policy could not be cancelled: ")+(err.message||"")); }
        }
      }
      const canceladaYa = renovarCon.cancelarVieja && (resultadoCancel ? resultadoCancel.cancelada : !isApiModeR);
      onPoliciesChange(prev=>prev.map(p=>p.id!==id?p:{...p,
        ...(canceladaYa?{status:"cancelled",cancellationDate:fechaCancel,renewalDate:"",cancelReason:motivoCancel||p.cancelReason}:{}),
        renewalStage:"DONE",
        renewalStageGuardada:"DONE",
        renewalStageCycle:oldRenewalDate||p.renewalStageCycle||null,
        customData:{...(p.customData||{}),renovadaConId:nueva.id,renovadaConNumero:nueva.policyNumber||"",renovadaConCompania:nueva.carrier||"",
          ...(resultadoCancel?.programada?{cancelacionProgramada:resultadoCancel.programada}:{})},
      }));
      if (logTeamAction) logTeamAction("renewal_marked", pol?.clientId, { policyId: id, oldRenewalDate, newPolicyId: nueva.id });
      setMarking(null);
    };
    if (renovarCon.modo==="nueva" && !nueva) { toast.error(es?"Elige la póliza nueva o créala.":"Pick or create the new policy."); return; }
    if (nueva && renovarCon.cancelarVieja) {
      if (!/^\d{4}-\d{2}-\d{2}$/.test(fechaCancel)) { toast.error(es?"Pon la fecha de cancelación.":"Enter the cancellation date."); return; }
      if (!motivoCancel) { toast.error(es?"Elige o escribe el motivo de la cancelación.":"Pick or write the cancellation reason."); return; }
    }
    // El boton queda ocupado hasta que termina todo (kit incluido).
    const ocupado = fn => async () => { setMarcandoBusy(true); try { await fn(); } finally { setMarcandoBusy(false); } };
    if (nueva) {
      if (confirmBeforeResend) confirmBeforeResend("renewal_marked", pol?.clientId, { policyId: id, oldRenewalDate }, ocupado(conNueva));
      else ocupado(conNueva)();
      return;
    }
    // LA FECHA DE RENOVACIÓN NO SE TOCA (Lissette 2026-10-17: *"no coloque
    // fecha de renovación, uno lo hace manual"*). Antes se corría sola a
    // "hoy + 365 días", que casi nunca es la fecha real del nuevo término. La
    // póliza queda en DONE para el ciclo actual, así que pasa a la pestaña
    // Renovadas; cuando el agente ponga la fecha nueva, el ciclo cambia y la
    // etapa se limpia sola para el próximo año.
    const doIt = async () => {
      if (isApiModeR && pol) {
        // "Marcar renovada" ahora DISPARA el kit de renovación (antes lo hacía el
        // status "Lista"/DONE, que se quitó del menú). El kit no bloquea la
        // renovación: si falla o faltan documentos, igual se renueva la fecha.
        try {
          const { kit } = await apiSetRenewalStage({ policyId:id, stage:"DONE" });
          handleKitResult(pol, kit);
        } catch (err) { toast.error((es?"No se pudo enviar el kit: ":"Could not send kit: ")+(err.message||"")); }
        if (pol.status!=="active") {
          try { await apiUpdatePolicy(id, { ...pol, status: "active" }); }
          catch (err) { alert((es?"No se pudo marcar como renovada: ":"Failed to mark renewed: ")+err.message); return; }
        }
      }
      // El estado local tiene que quedar como quedara el servidor, o la fila
      // se va de la pantalla hasta la siguiente recarga. Hay que dejar la
      // MARCA de renovada: `renewalStageGuardada`
      // (DONE) y `renewalStageCycle` = el vencimiento QUE SE ACABA DE CERRAR
      // — el viejo, no el nuevo. Es lo que mira la pestaña "Renovadas", y es
      // la fecha que el servidor fijo un momento antes, al poner la etapa.
      onPoliciesChange(prev=>prev.map(p=>p.id!==id?p:{...p,
        status:"active",
        // La etapa que se VE también: sin esto la fila seguía diciendo
        // "En proceso" hasta recargar, aunque el servidor ya tenía DONE.
        renewalStage:"DONE",
        renewalStageGuardada:"DONE",
        renewalStageCycle:oldRenewalDate||p.renewalStageCycle||null,
      }));
      if (logTeamAction) logTeamAction("renewal_marked", pol?.clientId, { policyId: id, oldRenewalDate });
      setMarking(null);
    };
    if (confirmBeforeResend) confirmBeforeResend("renewal_marked", pol?.clientId, { policyId: id, oldRenewalDate }, ocupado(doIt));
    else ocupado(doIt)();
  };

  // "Encargado" (assignee) per policy — persisted on policy.customData.encargado
  // (merged server-side, no migration). Lissette 2026-07-11.
  const setEncargado=async(p,userId)=>{
    const nextCustom={...(p.customData||{}),encargado:userId||""};
    onPoliciesChange(prev=>prev.map(x=>x.id===p.id?{...x,customData:nextCustom}:x));
    try{ if(isApiModeR) await apiSavePaymentCustomData({ policyId:p.id, customData:{ encargado:userId||"" } }); }
    catch(err){ toast.error((es?"No se pudo guardar el encargado: ":"Could not save assignee: ")+(err.message||"")); }
  };

  const persistStatuses=async list=>{
    setCustomStatuses(list);
    recordarEstatusPropiosDeRenovacion(list);
    try{ if(isApiModeR) await apiUpdateAgencySettings({ renewalStatuses:list }); }
    catch(err){ toast.error((es?"No se pudieron guardar los status: ":"Could not save statuses: ")+(err.message||"")); }
  };
  const addCustomStatus=()=>{
    const label=newStatusLabel.trim(); if(!label) return;
    persistStatuses([...(customStatuses||[]),{id:"cs_"+Date.now().toString(36),label,color:newStatusColor}]);
    setNewStatusLabel(""); setNewStatusColor("#0ea5e9");
  };
  const removeCustomStatus=id=>persistStatuses((customStatuses||[]).filter(s=>s.id!==id));

  // Load the draft for whichever kit is selected (a policy type, or a life-change key).
  // El mensaje se edita con el editor de correo (Lissette 2026-09-29: negrita,
  // centrar, justificar y pegar imagenes), que trabaja en HTML. Las plantillas
  // guardadas antes son texto plano: se abren convertidas, linea a linea, para
  // no perder sus saltos (aHtmlDeDocumento). El servidor distingue las dos.
  // SIN "⭐ POR DEFECTO" (Lissette 2026-10-23: *"la gente tiene mucha confusión
  // con el predeterminado… deja solo los personalizados"*). Cada tipo tiene su
  // mensaje; un tipo sin mensaje no envía kit. El "por defecto" guardado
  // (renewalKitTemplate) no se borra, pero ya no se ve ni se usa.
  const draftForType=(tid,version=kitVersion)=>{ // Tipo de póliza → el mensaje de RENOVACIÓN (o el de antes). Las
        // llaves de cambio de vida no son de un tipo y se leen tal cual (E-353).
        // La versión en inglés se lee SOLA: vacía si no está escrita, para no
        // enseñar el principal como si fuera el inglés.
        const t=esLlaveDeCambioDeVida(tid)?kitByType[tid]
          :version==="en"?mensajeDeKitEnIngles(kitByType,KIT_RENOVACION,tid)
          :mensajeDeKit(kitByType,KIT_RENOVACION,tid);
        return {subject:(t?.subject)||"",body:aHtmlDeDocumento((t?.body)||"")}; };
  const openKitEditor=()=>{ const primero=tiposDePolizaConKit()[0]||""; setKitVersion("es"); setKitLang("es"); setKitEditType(primero); setKitDraft(draftForType(primero,"es")); setShowKitEditor(true); };
  const switchKitType=tid=>{ setKitEditType(tid); setKitDraft(draftForType(tid)); };
  const switchKitVersion=v=>{ setKitVersion(v); setKitLang(v==="en"?"en":"es"); setKitDraft(draftForType(kitEditType,v)); };
  // Versión en inglés vacía: se rellena con el principal traducido por IA, para
  // no escribirla desde cero. Queda en el editor para revisarla antes de guardar.
  const traducirPrincipalAlIngles=async()=>{
    if(kitTranslating) return;
    const base=draftForType(kitEditType,"es");
    if(!(base.subject||"").trim() && !(base.body||"").trim()){ toast.warn(es?"Primero escribe el mensaje principal.":"Write the main message first."); return; }
    setKitTranslating(true);
    try{
      const { aiTranslateTemplate }=await import("./crm-app/api.js");
      const tr=async t=>(t||"").trim()?((await aiTranslateTemplate({text:t,fromLang:"es",toLang:"en"})).translated||t):t;
      const [sub,bod]=await Promise.all([tr(base.subject),tr(base.body)]);
      setKitDraft(d=>({...d,subject:sub,body:aHtmlDeDocumento(bod)})); setKitLang("en");
      toast.success(es?"Traducido — revísalo y guarda":"Translated — review it and save");
    }catch(err){ toast.error((es?"No se pudo traducir: ":"Translation failed: ")+(err.message||"")); }
    finally{ setKitTranslating(false); }
  };
  // "Usar texto de ejemplo": llena el editor con un texto base para adaptarlo
  // a este tipo. Ya NO es lo que sale con un kit vacío: vacío = no hay kit.
  const loadDefaultKitText=()=>setKitDraft(d=>({...d,subject:DEFAULT_KIT_SUBJECT_ES,body:aHtmlDeDocumento(DEFAULT_KIT_BODY_ES)}));
  // ES/EN language toggle for the kit draft (like the AI Assistant). Clicking a
  // language AI-translates subject+body INTO it (preserving {campos}) and marks
  // it active. Clicking the already-active language is a no-op.
  const translateKitTo=async(to)=>{
    if(to===kitLang||kitTranslating) return;
    const from=kitLang;
    setKitTranslating(true);
    try{
      const { aiTranslateTemplate }=await import("./crm-app/api.js");
      const tr=async t=>(t||"").trim()?((await aiTranslateTemplate({text:t,fromLang:from,toLang:to})).translated||t):t;
      const [s,b]=await Promise.all([tr(kitDraft.subject),tr(kitDraft.body)]);
      setKitDraft(d=>({...d,subject:s,body:aHtmlDeDocumento(b)})); setKitLang(to);
      toast.success(es?"Traducido":"Translated");
    }catch(err){ setKitLang(from); toast.error((es?"No se pudo traducir: ":"Translation failed: ")+(err.message||"")); }
    finally{ setKitTranslating(false); }
  };
  // Click-to-insert merge fields (like the signature template editor). Inserts
  // the exact valid token at the cursor of whichever field was last focused
  // (subject or body), so the agent never mistypes {compañía} and gets a blank.
  const insertKitVar=tag=>{
    const field=kitFocusField==="subject"?"subject":"body";
    if(field==="body"&&kitBodyApi.current){ kitBodyApi.current.insertarTexto(tag); return; }
    const el=document.getElementById(field==="subject"?"kit-subject":"kit-body");
    if(el){
      const start=el.selectionStart??(kitDraft[field]||"").length;
      const end=el.selectionEnd??start;
      const val=kitDraft[field]||"";
      const next=val.slice(0,start)+tag+val.slice(end);
      setKitDraft(d=>({...d,[field]:next}));
      setTimeout(()=>{ try{ el.focus(); el.selectionStart=el.selectionEnd=start+tag.length; }catch{} },40);
    } else { setKitDraft(d=>({...d,[field]:(d[field]||"")+tag})); }
  };
  const saveKit=async()=>{
    // Un editor vaciado deja "<div><br></div>": eso es un mensaje vacio, y
    // vacio significa que a ese tipo NO se le envia kit.
    const cuerpo=(kitDraft.body||"").trim();
    const cuerpoVacio=!cuerpo.replace(/<[^>]*>/g,"").replace(/&nbsp;/gi,"").trim()&&!/<img/i.test(cuerpo);
    const next={subject:(kitDraft.subject||"").trim(),body:cuerpoVacio?"":cuerpo};
    {
      // Empty subject+body removes the type's message (that type sends no kit).
      // Un tipo de póliza se guarda en la llave de RENOVACIÓN
      // (`renovacion__<tipo>`), nunca en la del tipo a secas, que compartía con
      // Prospecto y Referido (E-353). Y sobre el mapa recién leído del
      // servidor, no sobre la copia de cuando se abrió esta pantalla: guardar
      // la copia entera borraba lo que Prospecto hubiera guardado mientras.
      setShowKitEditor(false);
      try{
        const fresco=isApiModeR?await apiGetAgencySettings().then(a=>a?.welcomeKitTemplates).catch(()=>null):null;
        const base=fresco||kitByType;
        let nextMap;
        if(esLlaveDeCambioDeVida(kitEditType)){
          nextMap={...base};
          if(!next.subject && !next.body) delete nextMap[kitEditType]; else nextMap[kitEditType]=next;
        } else nextMap=mapaConMensaje(base,KIT_RENOVACION,kitEditType,next,kitVersion);
        setKitByType(nextMap);
        if(isApiModeR) await apiUpdateAgencySettings({ welcomeKitTemplates:nextMap });
        toast.success(es?"Plantilla guardada":"Template saved");
      }
      catch(err){ toast.error((es?"No se pudo guardar: ":"Could not save: ")+(err.message||"")); }
    }
  };

  const daysBadge=p=>{
    const days=daysUntil(p.renewalDate);
    const color = days<0?"#ef4444":days<=7?"#f59e0b":days<=30?"#d97706":"#64748b";
    const text = days<0?`${Math.abs(days)}d ${es?"vencida":"overdue"}`:days===0?(es?"¡Hoy!":"Today!"):`${days}d ${tr.daysLeft}`;
    return <span style={{fontSize:".7rem",fontWeight:700,color}}>{text}</span>;
  };

  // Las 8 columnas de siempre + una por cada columna propia de la agencia
  // (Lissette 2026-09-09). La rejilla se arma a partir de la lista: con el
  // ancho clavado a mano, anadir una columna descuadraba la tabla entera.
  //
  // LAS RAYAS TORCIDAS (Lissette 2026-10-11: *"si agregamos más columnas se ve
  // todo torcido… las rayas no son equivalentes"*). La cabecera y cada fila son
  // rejillas SEPARADAS, y un "1fr" a secas no baja del ancho de lo que lleva
  // dentro: una fila con un nombre largo o un botón más ensanchaba SU columna y
  // la raya de esa fila se corría respecto a la de arriba. Con
  // minmax(<mínimo fijo>, <parte>) todas las filas reparten el ancho con la
  // misma regla, sin mirar su contenido, y las rayas quedan en el mismo sitio.
  // Los mínimos son lo que cada columna necesita para leerse (Revisión lleva
  // Aviso, Link, Correo y dos iconos). Si la pantalla no da para todos, la
  // tabla se desliza de lado en vez de apretarse.
  const COLS_BASE = [[200,"1.5fr"],[130,"0.9fr"],[120,"1fr"],[130,"1fr"],[150,"1fr"],[250,"1.6fr"],[130,"0.95fr"],[140,"1fr"],[140,"1fr"],[140,"1fr"]];
  const COLS_TODAS = [...COLS_BASE, ...colsPropias.map(() => [130,"1fr"])];
  const COLS = COLS_TODAS.map(([min,fr]) => `minmax(${min}px,${fr})`).join(" ");
  const ANCHO_MINIMO = COLS_TODAS.reduce((suma,[min]) => suma+min, 0);
  // Cuantas columnas hay en total, para saber cual es la ULTIMA y no pintarle
  // el separador de la derecha.
  const N_COLS = COLS_BASE.length + colsPropias.length;
  return <div>
    <div className="flex items-center justify-between flex-wrap gap-3" style={{marginBottom:"1rem"}}>
      <div className="dkt-sec-title" style={{margin:0}}>{tr.title} <span style={{fontSize:".8rem",color:"#94a3b8",fontWeight:600}} title={es?"El plazo sale de Perfil → Preferencias → Avisos y puede ser distinto por tipo de póliza.":"The window comes from Profile → Preferences → Alerts and can differ per policy type."}>· {es?"próximos":"next"} {windowLabel} ({filtered.length}{filtered.length!==visibles.length?`/${visibles.length}`:""})</span></div>
      <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
        <button onClick={()=>setShowStatusMgr(true)} className="dkt-btn-s" style={{display:"inline-flex",alignItems:"center",gap:6}}>🎨 {es?"Status":"Statuses"}</button>
        {/* Al lado de Status, en el mismo modulo, como lo pidio (2026-09-08).
            El punto avisa cuando la agencia ya escribio su propio texto: sin
            el, no hay forma de saber desde fuera si sale el de fabrica o el
            tuyo. */}
        <button onClick={openMsgEditor} className="dkt-btn-s" style={{display:"inline-flex",alignItems:"center",gap:6}} title={es?"El texto de los dos SMS del enlace de renovación, igual para todo el equipo":"The text of both renewal-link texts, the same for the whole team"}>✍️ {es?"Mensaje del enlace":"Link message"}{Object.keys(linkMsgs||{}).length>0?" •":""}</button>
        <button onClick={openKitEditor} className="dkt-btn-s" style={{display:"inline-flex",alignItems:"center",gap:6}}>✉️ {es?"Kit de bienvenida":"Welcome kit"}</button>
        <button onClick={openFieldsEditor} className="dkt-btn-s" style={{display:"inline-flex",alignItems:"center",gap:6}}>📋 {es?"Campos de revisión":"Review fields"}</button>
        {/* Columnas propias de la agencia (Lissette 2026-09-09). El numero
            avisa de cuantas hay puestas: sin el, no se sabe desde fuera si la
            tabla lleva columnas tuyas o no. */}
        <button onClick={()=>setShowColMgr(true)} className="dkt-btn-s" style={{display:"inline-flex",alignItems:"center",gap:6}} title={es?"Crear tus propias columnas en esta tabla":"Create your own columns in this table"}>🧩 {es?"Columnas":"Columns"}{colsPropias.length?` (${colsPropias.length})`:""}</button>
        <button onClick={onAddClient} className="dkt-btn-p" style={{display:"inline-flex",alignItems:"center",gap:6}}><Plus size={14}/>{es?"Agregar cliente nuevo":"Add new client"}</button>
      </div>
    </div>
    {/* Pendientes / Renovadas / Terminados. "Terminados" son las marcadas
        "No va a renovar": salen de Pendientes y pasan ahi (Lissette
        2026-09-30 eligio ese nombre). El numero va SIEMPRE en las dos, tambien cuando
        es cero: "Renovadas (0)" dice que todavia no has terminado ninguna, y
        una pestana sin numero solo deja la duda de si esta vacia o rota. */}
    {inWindow.length>0&&<div style={{display:"flex",alignItems:"center",gap:8,flexWrap:"wrap",marginBottom:"0.85rem"}}>
      {[{id:"pendientes",es:"Pendientes",en:"Pending",n:pendientes.length},
        {id:"renovadas", es:"Renovadas", en:"Renewed", n:renovadas.length},
        {id:"norenuevan",es:"Terminados",en:"Ended",n:noRenuevan.length}].map(tb=>{
        const on=tab===tb.id;
        return <button key={tb.id} onClick={()=>setTab(tb.id)} className="dkt-tab"
          style={{fontSize:".82rem",padding:"7px 15px",borderRadius:999,fontWeight:800,cursor:"pointer",
            border:`1px solid ${on?(tb.id==="renovadas"?"#10b981":tb.id==="norenuevan"?"#ef4444":"var(--c-accent,#3b82f6)"):"var(--c-border,#1a3550)"}`,
            background:on?(tb.id==="renovadas"?"#10b981":tb.id==="norenuevan"?"#ef4444":"var(--c-accent,#3b82f6)"):"transparent",
            color:on?"#fff":"var(--c-text2,#7aa3c0)"}}>
          {tb.id==="renovadas"?"✅ ":tb.id==="norenuevan"?"🚫 ":"⏳ "}{es?tb.es:tb.en} ({tb.n})
        </button>;
      })}
    </div>}
    {inWindow.length>0&&<div style={{display:"flex",alignItems:"center",gap:8,flexWrap:"wrap",marginBottom:"0.85rem"}}>
      <span style={{fontSize:".7rem",fontWeight:800,textTransform:"uppercase",letterSpacing:".03em",color:"var(--c-text3,#45688a)"}}>{es?"Tipo de póliza:":"Policy type:"}</span>
      <button onClick={()=>setTypeFilter("all")} className="dkt-tab" style={{fontSize:".74rem",padding:"5px 11px",borderRadius:999,fontWeight:700,border:"1px solid var(--c-border,#1a3550)",background:typeFilter==="all"?"var(--c-accent,#3b82f6)":"transparent",color:typeFilter==="all"?"#fff":"var(--c-text2,#7aa3c0)",cursor:"pointer"}}>{es?"Todas":"All"}</button>
      {distinctTypes.map(tid=>{ const pt=getPolicyType(tid); const on=typeFilter===tid;
        return <button key={tid} onClick={()=>setTypeFilter(tid)} className="dkt-tab" style={{fontSize:".74rem",padding:"5px 11px",borderRadius:999,fontWeight:700,border:"1px solid var(--c-border,#1a3550)",background:on?"var(--c-accent,#3b82f6)":"transparent",color:on?"#fff":"var(--c-text2,#7aa3c0)",cursor:"pointer",display:"inline-flex",alignItems:"center",gap:5}}><span>{pt.icon}</span>{es?(pt.labelEs||pt.label):pt.label}</button>; })}
    </div>}
    {selectedIds.size>0&&<div style={{display:"flex",alignItems:"center",gap:10,flexWrap:"wrap",padding:"8px 12px",marginBottom:10,background:"rgba(14,165,233,.12)",border:"1px solid rgba(14,165,233,.35)",borderRadius:10}}>
      <span style={{fontSize:".82rem",fontWeight:800,color:"var(--c-text,#c8dff0)"}}>{selectedIds.size} {es?"seleccionados":"selected"}</span>
      <button onClick={()=>bulkSend("notice")} disabled={bulkBusy} className="dkt-btn-s" style={{display:"inline-flex",alignItems:"center",gap:6}}>📲 {es?"Enviar aviso":"Send notice"}</button>
      <button onClick={()=>bulkSend("link")} disabled={bulkBusy} className="dkt-btn-p" style={{display:"inline-flex",alignItems:"center",gap:6}}>🔗 {bulkBusy?(es?"Enviando…":"Sending…"):(es?"Enviar link":"Send link")}</button>
      <button onClick={()=>bulkSend("link","email")} disabled={bulkBusy} className="dkt-btn-s" style={{display:"inline-flex",alignItems:"center",gap:6}}>✉️ {es?"Enviar link por correo":"Email link"}</button>
      <button onClick={()=>setSelectedIds(new Set())} disabled={bulkBusy} className="dkt-btn-s">{es?"Limpiar":"Clear"}</button>
    </div>}
    {/* El vacio tiene que decir CUAL de los cuatro vacios es. "No hay nada" a
        secas se lee como "esto esta roto" o como "no tengo renovaciones",
        cuando muchas veces es que ya estan todas hechas o que el filtro las
        escondio — regla de oro 89, y ya nos costo E-140. */}
    {/* EL VACIO POR FILTROS NO SE COME LA TABLA.
        Lissette, 2026-09-23: *"no me queda como la barra de busqueda para
        eliminar el filtro que tenia, y volver a todos los clientes sin
        refrescar la pagina"*. Los seis filtros viven DENTRO de la cabecera de
        esta tabla, asi que cambiarla por un mensaje se llevaba por delante el
        control que acababa de usarse: la unica salida era recargar. Cuando el
        vacio lo causan los filtros se pinta la tabla IGUAL —con su cabecera— y
        el mensaje va donde irian las filas. Ver crm-app/filtrosDeRenovaciones.js. */}
    {vacioDeVerdad?<div className="text-center py-16" style={{color:"var(--c-text3,#45688a)"}}>{
      inWindow.length===0?tr.noRenewals
      :(tab==="norenuevan"
        ?(es?"Ninguna marcada como “No va a renovar” en este ciclo. Cuando cambies el status de una a “No va a renovar”, saldrá de Pendientes y aparecerá aquí.":"None marked \u201cNot renewing\u201d this cycle. When you set a row's status to \u201cNot renewing\u201d, it leaves Pending and shows up here.")
      :tab==="renovadas"
        ?(es?"Todavía no has terminado ninguna en este ciclo. Cuando muevas una a “Lista” y se le envíe el kit, aparecerá aquí.":"You haven't finished any this cycle. When you move one to \u201cDone\u201d and its kit goes out, it shows up here.")
        :(es?`¡Todo al día! Las ${renovadas.length} de este ciclo ya están renovadas — míralas en la pestaña Renovadas.`:`All caught up! All ${renovadas.length} this cycle are renewed \u2014 see them in the Renewed tab.`))
    }</div>:
    <CajaConScroll>
    <div style={{background:"var(--c-surface,#0d1c2e)",border:"1px solid var(--c-border,#1a3550)",borderRadius:14,minWidth:ANCHO_MINIMO}}>
      {/* dkt-caja-cabecera: la fila de titulos (con sus filtros) se queda
          pegada arriba mientras bajan las filas. */}
      <div className="dkt-caja-cabecera" style={{display:"grid",gridTemplateColumns:COLS,borderBottom:"1px solid var(--c-border,#1a3550)",fontSize:".66rem",fontWeight:800,textTransform:"uppercase",letterSpacing:".03em",color:"var(--c-text3,#45688a)",background:"var(--c-surface2,#112538)",borderRadius:"14px 14px 0 0"}}>
        {[es?"Cliente":"Client",es?"Tipo":"Type",es?"Compañía":"Company",es?"Notas":"Notes",es?"Status":"Status",es?"Revisión":"Review",es?"Quién lo hizo":"Who did it",es?"Encargado":"Assignee",es?"Atiende":"Handled by",es?"Agente":"Agent",...colsPropias.map(c=>c.name)].map((h,i)=>{
          const wrap={padding:"7px 12px",borderRight:i<N_COLS-1?"1px solid var(--c-border,#1a3550)":"none",display:"flex",flexDirection:"column",gap:4};
          const ctl={width:"100%",fontSize:".66rem",fontWeight:600,textTransform:"none",letterSpacing:"normal",padding:"3px 6px",borderRadius:6,border:"1px solid var(--c-border,#1a3550)",background:"var(--c-surface,#0d1c2e)",color:"var(--c-text,#c8dff0)",cursor:"pointer"};
          const sortHead=(col,tip)=> <div onClick={()=>cycleSort(col)} title={tip} style={{cursor:"pointer",userSelect:"none",display:"flex",alignItems:"center",gap:5}}>{h} <span style={{fontSize:".72rem",opacity:sortCol===col?1:.5}}>{sortArrow(col)}</span></div>;
          if(i===0) return <div key={i} style={wrap}><div style={{display:"flex",alignItems:"center",gap:6}}><input type="checkbox" checked={allVisibleSelected} onChange={toggleSelectAll} onClick={e=>e.stopPropagation()} title={es?"Seleccionar todos":"Select all"} style={{accentColor:"#0ea5e9",width:14,height:14,cursor:"pointer",flexShrink:0}}/>{sortHead("client",es?"Ordenar por nombre":"Sort by name")}</div><input value={clientFilter} onChange={e=>setClientFilter(e.target.value)} onClick={e=>e.stopPropagation()} placeholder={es?"Buscar…":"Search…"} style={{...ctl,cursor:"text"}}/></div>;
          if(i===1) return <div key={i} style={wrap}>{sortHead("type",es?"Ordenar por tipo":"Sort by type")}<select value={typeFilter} onChange={e=>setTypeFilter(e.target.value)} onClick={e=>e.stopPropagation()} style={ctl}><option value="all">{es?"Todos":"All"}</option>{distinctTypes.map(tid=>{ const pt=getPolicyType(tid); return <option key={tid} value={tid}>{es?(pt.labelEs||pt.label):pt.label}</option>; })}</select></div>;
          {/* Compania, Status y Encargado: filtro EN la columna, como Tipo y
              Revision. El de Compania estaba en una barra encima de la tabla —
              se mueve aqui para que los cinco filtros vivan en el mismo sitio y
              no haya dos controles para lo mismo. */}
          if(i===2) return <div key={i} style={wrap}>{h}<select value={carrierFilter} onChange={e=>setCarrierFilter(e.target.value)} onClick={e=>e.stopPropagation()} style={ctl}><option value="all">{es?"Todas":"All"}</option>{distinctCarriers.map(cn=><option key={cn} value={cn}>{cn}</option>)}</select></div>;
          if(i===4) return <div key={i} style={wrap}>{h}<select value={stageFilter} onChange={e=>setStageFilter(e.target.value)} onClick={e=>e.stopPropagation()} style={ctl}><option value="all">{es?"Todos":"All"}</option>{distinctStages.map(sid=><option key={sid} value={sid}>{statusMeta(sid).label}</option>)}</select></div>;
          if(i===8) return <div key={i} style={wrap} title={es?"Quién atiende al cliente en su ficha. Se trae solo; se cambia en la ficha del cliente.":"Who handles the client on their record. Filled in automatically; change it on the client's record."}>{h}<select value={atiendeFilter} onChange={e=>setAtiendeFilter(e.target.value)} onClick={e=>e.stopPropagation()} style={ctl}><option value="all">{es?"Todos":"All"}</option><option value="none">{es?"Sin asignar":"Unassigned"}</option>{opcionesAtiende.map(o=><option key={o.value} value={o.value}>{o.label}</option>)}</select></div>;
          if(i===9) return <div key={i} style={wrap} title={es?"El Agente asignado escrito en la ficha del cliente. Se trae solo; se cambia en la ficha del cliente.":"The Assigned agent written on the client's record. Filled in automatically; change it on the client's record."}>{h}<select value={agenteFilter} onChange={e=>setAgenteFilter(e.target.value)} onClick={e=>e.stopPropagation()} style={ctl}><option value="all">{es?"Todos":"All"}</option><option value="none">{es?"Sin agente":"No agent"}</option>{opcionesAgente.map(n=><option key={n} value={n}>{n}</option>)}</select></div>;
          if(i===7) return <div key={i} style={wrap}>{h}<select value={encargadoFilter} onChange={e=>setEncargadoFilter(e.target.value)} onClick={e=>e.stopPropagation()} style={ctl}><option value="all">{es?"Todos":"All"}</option><option value="none">{es?"Sin encargado":"Unassigned"}</option>{distinctEncargados.map(id=><option key={id} value={id}>{seatLabelForUtil(id,seatLabels,users)?.name||id}</option>)}</select></div>;
          if(i===5) return <div key={i} style={wrap}>{sortHead("review",es?"Ordenar por estado":"Sort by status")}<select value={reviewFilter} onChange={e=>setReviewFilter(e.target.value)} onClick={e=>e.stopPropagation()} style={ctl}><option value="all">{es?"Todas":"All"}</option><option value="none">{es?"Sin enviar":"Not sent"}</option><option value="NOTIFIED">{es?"Aviso enviado":"Notice sent"}</option><option value="SENT">{es?"Link enviado":"Link sent"}</option><option value="VIEWED">{es?"Visto":"Viewed"}</option><option value="CONFIRMED">{es?"Confirmado":"Confirmed"}</option><option value="ADJUST">{es?"Pidió ajuste":"Wants change"}</option></select></div>;
          // Las columnas propias de la agencia van al final, y cada una filtra
          // la SUYA desde su propia cabecera — como las cinco de arriba, para
          // que no haya un segundo sitio donde buscar los filtros.
          const ci=i-(N_COLS-colsPropias.length);
          if(ci>=0 && colsPropias[ci]){
            const col=colsPropias[ci];
            return <div key={i} style={{...wrap,borderRight:i<N_COLS-1?"1px solid var(--c-border,#1a3550)":"none"}} title={col.name}>
              <div style={{overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{h}</div>
              <select value={filtrosPropios[col.id]||"all"} onClick={e=>e.stopPropagation()}
                onChange={e=>setFiltrosPropios(prev=>{ const v=e.target.value; const next={...prev}; if(v==="all") delete next[col.id]; else next[col.id]=v; return next; })}
                style={ctl}>
                <option value="all">{es?"Todas":"All"}</option>
                {(opcionesDeFiltroPropio[col.id]||[]).map(o=><option key={o.value} value={o.value}>{o.label}</option>)}
              </select>
            </div>;
          }
          return <div key={i} style={{padding:"10px 14px",borderRight:i<N_COLS-1?"1px solid var(--c-border,#1a3550)":"none",display:"flex",alignItems:"center"}}>{h}</div>;
        })}
      </div>
      {vacioPorFiltros&&<div style={{padding:"2.5rem 1.25rem",textAlign:"center"}}>
        <div style={{fontSize:".9rem",fontWeight:700,color:"var(--c-text2,#7aa3c0)",marginBottom:".45rem"}}>
          {es?"Ningún resultado con esos filtros.":"No results with those filters."}
        </div>
        {/* CUALES son. Con seis filtros repartidos por las cabeceras, "esos
            filtros" obliga a repasarlos uno a uno para encontrar el que
            esconde las filas. */}
        {filtrosActivos.length>0&&<div style={{fontSize:".76rem",color:"var(--c-text3,#45688a)",marginBottom:".9rem"}}>
          {es?"Puestos ahora:":"Currently set:"} {filtrosActivos.map(f=>f.etiqueta).join(" · ")}
        </div>}
        <button type="button" onClick={limpiarFiltros} className="dkt-btn-p" style={{fontSize:".8rem"}}>
          {es?"Quitar los filtros":"Clear the filters"}
        </button>
        <div style={{fontSize:".72rem",color:"var(--c-text3,#45688a)",marginTop:".8rem"}}>
          {es?`Las ${visibles.length} siguen ahí — los filtros solo las esconden.`:`All ${visibles.length} are still there — the filters only hide them.`}
        </div>
      </div>}
      {displayRows.map((p,ri)=>{ const c=clients.find(cl=>cl.id===p.clientId); const pt=getPolicyType(p.type); const cur=statusMeta(etapaVisible(p)); const cb="1px solid var(--c-border,#1a3550)";
        return <div key={p.id} style={{display:"grid",gridTemplateColumns:COLS,borderBottom:ri<displayRows.length-1?cb:"none",alignItems:"stretch"}}>
          <div style={{padding:"12px 14px",borderRight:cb,display:"flex",alignItems:"center",gap:8,minWidth:0}}>
            <input type="checkbox" checked={selectedIds.has(p.id)} onChange={()=>toggleSelect(p.id)} style={{accentColor:"#0ea5e9",width:15,height:15,flexShrink:0,cursor:"pointer"}}/>
            <span style={{fontSize:"1.15rem"}}>{pt.icon}</span>
            <div style={{minWidth:0}}>
              {/* El nombre abre la ficha del cliente (Lissette 2026-08-25). Desde aqui
                  se decide si renovar, y para eso hay que ver la ficha: quien es,
                  que mas tiene, si hay algo pendiente. Antes tocaba salir a
                  Clientes y buscarlo a mano.
                  Es un ENLACE de verdad (<a href="#client/id">), igual que el
                  nombre en Clientes: asi el clic derecho ofrece "abrir en
                  pestaña nueva" y el clic con rueda o con Ctrl la abren. El
                  clic normal sigue abriendo la ficha en la misma pantalla —
                  por eso el preventDefault solo en el clic simple. (Idea del
                  apartado de ideas, 2026-10-27: "en renovaciones no se pueden
                  abrir pestañas aparte de los clientes".) Sin cliente resuelto
                  no se pinta enlace — uno que no lleva a ningun sitio es peor
                  que un texto. */}
              {c ? (
                <a href={`#client/${c.id}`}
                  onClick={(e)=>{ if(e.metaKey||e.ctrlKey||e.shiftKey||e.button===1) return; e.preventDefault(); onOpenClient&&onOpenClient(c); }}
                  title={es?"Abrir la ficha del cliente (clic derecho: abrir en pestaña nueva)":"Open the client profile (right-click: open in new tab)"}
                  style={{cursor:"pointer",fontSize:".92rem",fontWeight:700,color:"var(--c-white,#eef6ff)",textDecoration:"none",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",display:"block",maxWidth:"100%"}}
                  onMouseEnter={e=>{e.currentTarget.style.color="var(--c-cyan,#00d4ff)";e.currentTarget.style.textDecoration="underline";}}
                  onMouseLeave={e=>{e.currentTarget.style.color="var(--c-white,#eef6ff)";e.currentTarget.style.textDecoration="none";}}>
                  {`${c.firstName} ${c.lastName}`}
                </a>
              ) : (
                <div style={{fontSize:".84rem",fontWeight:700,color:"var(--c-text3,#45688a)"}}>—</div>
              )}
              <div style={{display:"flex",alignItems:"center",gap:6,flexWrap:"wrap"}}>{/* Renovada con otra poliza: la vieja conserva su fecha, y "42 dias
                  vencida" en rojo diria lo contrario de lo que paso. */}{renovadaConPolizaNueva(p)?null:daysBadge(p)}<span style={{fontSize:".68rem",color:"var(--c-text3,#45688a)"}}>· {fmt(p.renewalDate)}</span></div>
              {renovadaConPolizaNueva(p)&&<div style={{fontSize:".66rem",color:"var(--c-green,#00ff88)",marginTop:2}}>↻ {es?"Renovada con":"Renewed with"} {[p.customData?.renovadaConCompania,p.customData?.renovadaConNumero?("#"+p.customData.renovadaConNumero):""].filter(Boolean).join(" ")||(es?"póliza nueva":"new policy")}{p.status==="cancelled"?(es?" · vieja cancelada":" · old cancelled"):""}</div>}
            </div>
          </div>
          <div style={{padding:"12px 14px",borderRight:cb,display:"flex",alignItems:"center",gap:6,fontSize:".8rem",color:"var(--c-text,#c8dff0)",minWidth:0}}><span style={{fontSize:"1rem",flexShrink:0}}>{pt.icon}</span><span style={{overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{es?(pt.labelEs||pt.label):pt.label}</span></div>
          <div style={{padding:"12px 14px",borderRight:cb,display:"flex",alignItems:"center",fontSize:".8rem",color:"var(--c-text,#c8dff0)",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{p.carrier||"—"}</div>
          <div style={{padding:"12px 14px",borderRight:cb,display:"flex",alignItems:"center"}}>
            {editNoteFor===p.id
              ? <input autoFocus value={noteDraft} onChange={e=>setNoteDraft(e.target.value)} onBlur={()=>saveNote(p)} onKeyDown={e=>{if(e.key==="Enter")saveNote(p);if(e.key==="Escape")setEditNoteFor(null);}} placeholder={es?"Escribe una nota…":"Write a note…"} style={{width:"100%",fontSize:".78rem",padding:"5px 8px",borderRadius:8}}/>
              : <button onClick={()=>startEditNote(p)} style={{textAlign:"left",width:"100%",fontSize:".78rem",color:p.renewalNote?"var(--c-text,#c8dff0)":"var(--c-text3,#45688a)",background:"none",border:"1px dashed var(--c-border,#1a3550)",borderRadius:8,padding:"5px 8px",cursor:"text",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{p.renewalNote||(es?"+ Nota":"+ Note")}</button>}
          </div>
          {/* La letra del status mezcla su color con la letra del tema: un color
              personalizado oscuro no se leia en modo oscuro (Lissette 2026-10-22). */}
          <div style={{padding:"12px 14px",borderRight:cb,position:"relative",display:"flex",alignItems:"center"}}>
            <button disabled={savingId===p.id} onClick={()=>setOpenStatusFor(openStatusFor===p.id?null:p.id)} style={{display:"inline-flex",alignItems:"center",gap:7,width:"100%",justifyContent:"space-between",fontSize:".76rem",fontWeight:700,padding:"6px 10px",borderRadius:999,border:`1px solid ${cur.color}55`,background:`${cur.color}1f`,color:`color-mix(in srgb, ${cur.color} 55%, var(--c-white,#eef6ff))`,cursor:"pointer"}}>
              <span style={{display:"inline-flex",alignItems:"center",gap:7,minWidth:0}}><span style={{width:8,height:8,borderRadius:99,background:cur.color,flexShrink:0}}/><span style={{overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{cur.label}</span></span>
              <ChevronDown size={13}/>
            </button>
            {openStatusFor===p.id&&<>
              <div onClick={()=>setOpenStatusFor(null)} style={{position:"fixed",inset:0,zIndex:40}}/>
              <div ref={verMenuEntero} style={{position:"absolute",top:"calc(100% + 4px)",left:0,zIndex:41,minWidth:190,background:"var(--c-surface2,#112538)",border:"1px solid var(--c-border,#1a3550)",borderRadius:12,boxShadow:"0 10px 30px rgba(0,0,0,.4)",padding:6}}>
                {allStatuses.filter(s=>s.id!=="DONE").map(s=><button key={s.id} onClick={()=>moveStage(p,s.id)} style={{display:"flex",alignItems:"center",gap:8,width:"100%",textAlign:"left",fontSize:".78rem",fontWeight:600,padding:"7px 9px",borderRadius:8,border:"none",background:s.id===cur.id?"var(--c-surface3,#162d44)":"none",color:"var(--c-white,#eef6ff)",cursor:"pointer"}}>
                  <span style={{width:9,height:9,borderRadius:99,background:s.color,flexShrink:0}}/><span style={{overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{s.label}</span>
                </button>)}
                <div style={{height:1,background:"var(--c-border,#1a3550)",margin:"5px 0"}}/>
                <button onClick={()=>{setOpenStatusFor(null);setMarking(p.id);setRenovarCon({modo:"misma",nuevaId:"",cancelarVieja:false,fechaCancel:"",motivoCancel:"",notaCancel:""});}} style={{display:"flex",alignItems:"center",gap:8,width:"100%",textAlign:"left",fontSize:".78rem",fontWeight:700,padding:"7px 9px",borderRadius:8,border:"none",background:"none",color:"var(--c-green,#00ff88)",cursor:"pointer"}}><RefreshCw size={12}/>{es?"Marcar renovada":"Mark renewed"}<span style={{marginLeft:"auto",fontSize:".62rem"}} title={es?"Envía el kit de renovación":"Sends the renewal kit"}>✉️</span></button>
              </div>
            </>}
          </div>
          <div style={{padding:"10px 12px",borderRight:cb,display:"flex",flexDirection:"column",justifyContent:"center",gap:6,minWidth:0}}>
            {(() => { const rv=reviews[p.id]; const m=rvMeta(estadoDeRevision(rv)); const noPhone=!c?.phone; const busy=reviewBusy===p.id;
              return <>
                <div style={{display:"flex",alignItems:"center",gap:5,flexWrap:"wrap"}}>
                  <span style={{fontSize:".66rem",fontWeight:700,padding:"2px 8px",borderRadius:999,border:`1px solid ${m?m.color+"55":"var(--c-border,#1a3550)"}`,background:m?m.color+"18":"transparent",color:m?m.color:"var(--c-text3,#45688a)"}}>{m?m.label:(es?"Sin enviar":"Not sent")}</span>
                </div>
                {rv?.response==="adjust"&&rv.comment&&<div title={rv.comment} style={{fontSize:".65rem",lineHeight:1.35,color:"var(--c-text2,#7aa3c0)",fontStyle:"italic",borderLeft:"2px solid #f59e0b66",paddingLeft:6,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{rv.comment}</div>}
                <div style={{display:"flex",gap:6,alignItems:"center"}}>
                  <button onClick={()=>openSmsModal(p,c,"notice")} disabled={busy} title={noPhone?(es?"Cliente sin teléfono":"Client has no phone"):(rv?.noticeSentAt?(es?"Reenviar aviso":"Resend notice"):(es?"Enviar aviso":"Send notice"))} style={rvBtn("#64748b",busy)}><MessageSquare size={12}/>{es?"Aviso":"Notice"}</button>
                  <button onClick={()=>openSmsModal(p,c,"link")} disabled={busy} title={noPhone?(es?"Cliente sin teléfono":"Client has no phone"):(rv?.linkSentAt?(es?"Reenviar link":"Resend link"):(es?"Enviar link":"Send link"))} style={rvBtn("#0ea5e9",busy)}><Link2 size={12}/>{es?"Link":"Link"}</button>
                  <button onClick={()=>openSmsModal(p,c,"link","email")} disabled={busy} title={!c?.email?(es?"Cliente sin correo":"Client has no email"):(es?"Enviar el link por correo":"Email the link")} style={rvBtn("#8b5cf6",busy)}><Mail size={12}/>{es?"Correo":"Email"}</button>
                  {rv?.token&&<button onClick={()=>copyReviewLink(rv.token)} title={es?"Copiar link":"Copy link"} style={rvIconBtn("#7aa3c0",false)}><Copy size={12}/></button>}
                  {rv&&<button onClick={()=>cancelReview(p)} disabled={busy} title={es?"Cancelar revisión":"Cancel review"} style={rvIconBtn("#ef4444",busy)}><X size={13}/></button>}
                </div>
              </>; })()}
          </div>
          <div style={{padding:"12px 14px",borderRight:cb,display:"flex",flexDirection:"column",justifyContent:"center",fontSize:".74rem",color:"var(--c-text2,#7aa3c0)",minWidth:0,position:"relative"}}>
            {(() => {
              const hist=Array.isArray(p.renewalStageHistory)?p.renewalStageHistory:[];
              const last=hist.length?hist[hist.length-1]:null;
              const name=(last&&last.byName)||p.renewalStageByName;
              const at=(last&&last.at)||p.renewalStageAt;
              if(!name) return <span style={{color:"var(--c-text3,#45688a)"}}>—</span>;
              return <>
                <div style={{fontWeight:600,color:"var(--c-text,#c8dff0)",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{name}</div>
                {at&&<div style={{fontSize:".66rem",color:"var(--c-text3,#45688a)"}}>{fmtDateTime(at)}</div>}
                {hist.length>1&&<button onClick={()=>setOpenHistoryFor(openHistoryFor===p.id?null:p.id)} style={{marginTop:3,alignSelf:"flex-start",fontSize:".64rem",fontWeight:700,color:"var(--c-text2,#7aa3c0)",background:"none",border:"none",cursor:"pointer",padding:0,display:"inline-flex",alignItems:"center",gap:3}}>🕓 {es?"Historial":"History"} ({hist.length})</button>}
                {openHistoryFor===p.id&&hist.length>1&&<>
                  <div onClick={()=>setOpenHistoryFor(null)} style={{position:"fixed",inset:0,zIndex:40}}/>
                  <div ref={verMenuEntero} style={{position:"absolute",top:"calc(100% - 4px)",right:8,zIndex:41,minWidth:210,maxWidth:280,maxHeight:240,overflowY:"auto",background:"var(--c-surface2,#112538)",border:"1px solid var(--c-border,#1a3550)",borderRadius:12,boxShadow:"0 10px 30px rgba(0,0,0,.4)",padding:8}}>
                    <div style={{fontSize:".62rem",fontWeight:800,textTransform:"uppercase",letterSpacing:".04em",color:"var(--c-text3,#45688a)",padding:"2px 4px 6px"}}>{es?"Historial de cambios":"Change history"}</div>
                    {[...hist].reverse().map((h,hi)=>{ const sm=statusMeta(h.stage); return <div key={hi} style={{display:"flex",gap:8,padding:"6px 4px",borderTop:hi>0?"1px solid var(--c-border,#1a3550)":"none"}}>
                      <span style={{width:8,height:8,borderRadius:99,background:sm.color,flexShrink:0,marginTop:5}}/>
                      <div style={{minWidth:0}}>
                        <div style={{fontSize:".72rem",fontWeight:700,color:"var(--c-white,#eef6ff)"}}>{sm.label}</div>
                        <div style={{fontSize:".68rem",color:"var(--c-text,#c8dff0)"}}>{h.byName||"—"}</div>
                        <div style={{fontSize:".62rem",color:"var(--c-text3,#45688a)"}}>{fmtDateTime(h.at)}</div>
                      </div>
                    </div>; })}
                  </div>
                </>}
              </>;
            })()}
          </div>
          <div style={{padding:"10px 12px",borderRight:cb,display:"flex",alignItems:"center",minWidth:0}}>
            <EncargadoPicker value={encargadoDe(p)} seatLabels={seatLabels} users={users} lang={lang} onChange={id=>setEncargado(p,id)} />
          </div>
          {/* ATIENDE: el de la ficha del cliente, leido tal cual. Solo se
              pinta: se cambia en la ficha, que es donde vive el dato. */}
          <div style={{padding:"10px 12px",borderRight:cb,display:"flex",alignItems:"center",minWidth:0}}>
            {(()=>{ const c=clientsById.get(p.clientId); const al=c?etiquetaDeAtiende(c.attendedBySeatId,c.attendedByName,seatLabels,users):null;
              return al
                ? <span title={al.libre?(es?`${al.name} (todavía sin asiento)`:`${al.name} (no seat yet)`):al.name} style={{fontSize:".7rem",background:`${al.color}22`,border:`1px ${al.libre?"dashed":"solid"} ${al.color}`,color:al.color,padding:".15rem .55rem",borderRadius:100,fontWeight:700,display:"inline-flex",alignItems:"center",gap:4,maxWidth:"100%",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}><span style={{width:6,height:6,borderRadius:"50%",background:al.color,flexShrink:0}}/>{al.name}</span>
                : <span style={{fontSize:".72rem",color:"var(--c-text3,#45688a)"}}>—</span>; })()}
          </div>
          {/* AGENTE: el Agente asignado escrito en la ficha del cliente. Solo
              se pinta; se cambia en la ficha. */}
          <div style={{padding:"10px 12px",borderRight:colsPropias.length?cb:"none",display:"flex",alignItems:"center",minWidth:0}}>
            {(()=>{ const ag=agenteDeLaFila(p);
              return ag
                ? <span title={ag} style={{fontSize:".72rem",fontWeight:700,color:"var(--c-white,#eef6ff)",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{ag}</span>
                : <span style={{fontSize:".72rem",color:"var(--c-text3,#45688a)"}}>—</span>; })()}
          </div>
          {/* Las columnas propias de la agencia. Se escribe directo en la
              tabla: obligar a abrir la fila para apuntar "falta el W2" es
              justo lo que hace que acabe todo en Notas. */}
          {colsPropias.map((col,ci)=>(
            <div key={col.id} style={{padding:"10px 8px",borderRight:ci<colsPropias.length-1?cb:"none",display:"flex",alignItems:"center",minWidth:0}}>
              <CeldaPropia valor={(celdas[p.id]||{})[col.id]||""} lang={lang}
                columna={col} opciones={opcionesPorColumna[col.id]||[]}
                onGuardar={txt=>guardarCelda(p.id,col.id,txt)} />
            </div>
          ))}
        </div>; })}
    </div>
    </CajaConScroll>}

    {/* La MISMA ventana de columnas que usan Baul, Info de Empresa,
        Seguimientos y Prospecto y Referido. Pinta su propio Modal. */}
    {showColMgr&&<CustomColumnsManager columns={colsPropias} lang={lang} modulo="renewals"
      title={es?"Columnas de Renovaciones":"Renewals columns"}
      onClose={()=>setShowColMgr(false)} onSave={guardarColumnas} />}

    {marking&&(()=>{
      // ¿Con la MISMA poliza o con una NUEVA? (Lissette 2026-09-26). Las
      // candidatas son las otras polizas vivas del mismo cliente; primero las
      // del mismo tipo y las mas recientes.
      const vieja=policies.find(x=>x.id===marking);
      const cliente=vieja?clients.find(cl=>cl.id===vieja.clientId):null;
      const candidatas=vieja?policies
        .filter(x=>x.clientId===vieja.clientId&&x.id!==vieja.id&&x.status!=="cancelled"&&x.status!=="inactive")
        .sort((a,b)=>((b.type===vieja.type)-(a.type===vieja.type))||String(b.effectiveDate||"").localeCompare(String(a.effectiveDate||""))):[];
      // Solo se elige sola una del MISMO tipo: preelegir otra (el auto cuando se
      // renueva la casa) mandaria el kit equivocado con un clic de mas.
      const elegirNueva=()=>setRenovarCon(r=>({...r,modo:"nueva",nuevaId:r.nuevaId||(candidatas.find(x=>x.type===vieja.type)?.id||"")}));
      const faltaNueva=renovarCon.modo==="nueva"&&!renovarCon.nuevaId;
      const etiqueta=x=>[getPolicyType(x.type)?.label||x.type,x.carrier,x.plan,x.policyNumber?("#"+x.policyNumber):"",x.effectiveDate?((es?"desde ":"from ")+fmt(x.effectiveDate)):""].filter(Boolean).join(" · ");
      const opcion=(activa)=>({display:"block",width:"100%",textAlign:"left",padding:".7rem .85rem",borderRadius:10,cursor:"pointer",marginBottom:8,
        border:activa?"1px solid var(--c-cyan,#00d4ff)":"1px solid var(--c-border,#1a3550)",background:activa?"var(--c-cyan-dim)":"transparent",color:"var(--c-text,#c8dff0)"});
      return <Modal title={es?"Marcar renovada":"Mark renewed"} onClose={()=>{ if(!marcandoBusy) setMarking(null); }}>
        <p style={{fontSize:".85rem",color:"var(--c-text2,#7aa3c0)",margin:"0 0 .75rem"}}>{es?"¿Cómo se renovó?":"How was it renewed?"}</p>
        <button type="button" onClick={()=>setRenovarCon(r=>({...r,modo:"misma"}))} style={opcion(renovarCon.modo==="misma")}>
          <div style={{fontWeight:700,fontSize:".85rem"}}>{es?"Con la misma póliza":"Same policy"}</div>
          <div style={{fontSize:".75rem",color:"var(--c-text3,#45688a)"}}>{es?"Envía el kit con esta póliza. La fecha de renovación no se cambia: ponla tú en la póliza cuando la tengas.":"Sends the kit with this policy. The renewal date is not changed: set it on the policy when you have it."}</div>
        </button>
        <button type="button" onClick={elegirNueva} style={opcion(renovarCon.modo==="nueva")}>
          <div style={{fontWeight:700,fontSize:".85rem"}}>{es?"Con una póliza nueva":"With a new policy"}</div>
          <div style={{fontSize:".75rem",color:"var(--c-text3,#45688a)"}}>{es?"Otro plan, número o compañía. El kit sale con los datos de la póliza NUEVA.":"Another plan, number or carrier. The kit goes out with the NEW policy's details."}</div>
        </button>
        {renovarCon.modo==="nueva"&&<div style={{margin:".25rem 0 .75rem",padding:".75rem",borderRadius:10,background:"var(--c-surface2,#112538)"}}>
          {candidatas.length>0
            ? <>
                <label className="dkt-input-lbl">{es?"Póliza nueva":"New policy"}</label>
                <select className="dkt-inp" value={renovarCon.nuevaId} onChange={e=>setRenovarCon(r=>({...r,nuevaId:e.target.value}))}>
                  <option value="">{es?"— Elige la póliza nueva —":"— Pick the new policy —"}</option>
                  {candidatas.map(x=><option key={x.id} value={x.id}>{etiqueta(x)}</option>)}
                </select>
              </>
            : <div style={{fontSize:".8rem",color:"var(--c-amber,#ffb700)",marginBottom:".5rem"}}>{es?"Este cliente todavía no tiene la póliza nueva. Créala aquí:":"This client doesn't have the new policy yet. Create it here:"}</div>}
          <button type="button" className="dkt-btn-g" style={{marginTop:".6rem"}} onClick={()=>{
            // Ya llena con lo de la vieja: tipo, compañia, plan, personas.
            // Lo que identifica a la vieja (numero, member id, fechas, etapa
            // de renovacion, columnas propias) se deja en blanco.
            const desde=vieja.renewalDate||"";
            let hasta="";
            if(/^\d{4}-\d{2}-\d{2}$/.test(desde)){const [y,m,d]=desde.split("-").map(Number);const f=new Date(y+1,m-1,d);hasta=`${f.getFullYear()}-${String(f.getMonth()+1).padStart(2,"0")}-${String(f.getDate()).padStart(2,"0")}`;}
            // La misma copia que el boton "Copiar" de la tarjeta (crm-app/copiaDePoliza.js).
            setCrearNueva(copiaDePoliza(vieja,{effectiveDate:desde,renewalDate:hasta}));
          }}>➕ {es?"Crear póliza nueva":"Create new policy"}</button>
          <label style={{display:"flex",alignItems:"center",gap:8,marginTop:".85rem",fontSize:".82rem",cursor:"pointer"}}>
            <input type="checkbox" checked={renovarCon.cancelarVieja} onChange={e=>setRenovarCon(r=>({...r,cancelarVieja:e.target.checked,fechaCancel:r.fechaCancel||vieja?.renewalDate||""}))}/>
            {es?"Cancelar la póliza vieja":"Cancel the old policy"}
          </label>
          {renovarCon.cancelarVieja&&<div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(170px,1fr))",gap:".6rem",marginTop:".6rem"}}>
            <div>
              <label className="dkt-input-lbl">{es?"Fecha de cancelación":"Cancellation date"}</label>
              <DateField className="dkt-inp" value={renovarCon.fechaCancel} onChange={e=>{const v=e.target.value;setRenovarCon(r=>({...r,fechaCancel:v}));}}/>
            </div>
            <div>
              <label className="dkt-input-lbl">{es?"Motivo":"Reason"}</label>
              <select className="dkt-inp" value={renovarCon.motivoCancel} onChange={e=>setRenovarCon(r=>({...r,motivoCancel:e.target.value}))}>
                <option value="">{es?"— Elige el motivo —":"— Pick a reason —"}</option>
                {todosLosMotivos().map(m=><option key={m} value={m}>{etiquetaDeMotivo(m,lang)}</option>)}
              </select>
            </div>
            <div style={{gridColumn:"1 / -1"}}>
              <input className="dkt-inp" value={renovarCon.notaCancel} onChange={e=>setRenovarCon(r=>({...r,notaCancel:e.target.value}))} placeholder={es?"Nota del motivo (opcional si elegiste uno)":"Reason note (optional if you picked one)"}/>
            </div>
          </div>}
          <div style={{fontSize:".72rem",color:"var(--c-text3,#45688a)",marginTop:".35rem"}}>{es?"Si la fecha es futura, la póliza sigue activa y se cancela sola ese día. Aunque la canceles, sigue saliendo en la pestaña Renovadas.":"If the date is in the future, the policy stays active and is cancelled automatically that day. Even if cancelled, it stays in the Renewed tab."}</div>
        </div>}
        {faltaNueva&&<div style={{fontSize:".78rem",color:"var(--c-amber,#ffb700)",marginBottom:".5rem"}}>{es?"Elige la póliza nueva o créala para poder continuar.":"Pick or create the new policy to continue."}</div>}
        <VistaPreviaDelKit estado={kitPrev} es={es}/>
        <div className="flex gap-3" style={{marginTop:".5rem"}}>
          <button disabled={faltaNueva||marcandoBusy} onClick={()=>markRenewed(marking)} className="flex-1 bg-emerald-600 hover:bg-emerald-500 text-gray-900 font-semibold py-2.5 rounded-xl" style={(faltaNueva||marcandoBusy)?{opacity:.5,cursor:"not-allowed"}:undefined}>{marcandoBusy?(es?"Enviando kit…":"Sending kit…"):(es?"Marcar renovada y enviar kit":"Mark renewed & send kit")}</button>
          <button disabled={marcandoBusy} onClick={()=>setMarking(null)} className="flex-1 bg-gray-100 text-gray-700 font-semibold py-2.5 rounded-xl">{t.common.cancel||(es?"Cancelar":"Cancel")}</button>
        </div>
        {crearNueva&&<Modal title={es?"Póliza nueva (renovación)":"New policy (renewal)"} onClose={()=>setCrearNueva(null)} wide>
          <PolicyForm policy={crearNueva} t={t} lang={lang} client={cliente} dependents={cliente?.dependents||[]} onClose={()=>setCrearNueva(null)}
            onSave={async form=>{
              const payload={...form,clientId:vieja.clientId};
              try{
                const created=isApiModeR?await apiCreatePolicy(payload):{...payload,id:"p"+Date.now()};
                const merged={...payload,...created};
                onPoliciesChange(prev=>prev.some(x=>x.id===merged.id)?prev.map(x=>x.id===merged.id?{...x,...merged}:x):[...prev,merged]);
                setRenovarCon(r=>({...r,modo:"nueva",nuevaId:merged.id}));
                setCrearNueva(null);
              }catch(err){ toast.error((es?"No se pudo guardar la póliza: ":"Failed to save policy: ")+(err.message||"")); }
            }}/>
        </Modal>}
      </Modal>;
    })()}

    {smsModal&&<Modal title={smsModal.kind==="notice"?(es?"Enviar aviso por SMS":"Send notice SMS"):smsModal.canal==="email"?(es?"Enviar link por correo":"Email the link"):(es?"Enviar link por SMS":"Send link SMS")} onClose={()=>setSmsModal(null)}>
      <p style={{fontSize:".82rem",color:"#475569",marginBottom:4}}>{es?"Para":"To"} <strong>{smsModal.client?.firstName} {smsModal.client?.lastName}</strong>{smsModal.canal==="email"?(smsModal.client?.email?` · ${smsModal.client.email}`:""):(smsModal.client?.phone?` · ${smsModal.client.phone}`:"")}</p>
      {smsModal.canal==="email"&&<input value={smsModal.subject||""} onChange={e=>setSmsModal(m=>({...m,subject:e.target.value}))} maxLength={200} placeholder={es?"Asunto":"Subject"} aria-label={es?"Asunto":"Subject"} style={{width:"100%",fontSize:".86rem",fontWeight:600,padding:"9px 12px",borderRadius:10,border:"1px solid #cbd5e1",margin:"6px 0 8px",boxSizing:"border-box"}}/>}
      <p style={{fontSize:".74rem",color:"#64748b",marginBottom:10}}>{smsModal.kind==="notice"
        ? (es?"Avísale que le preparaste su revisión. Cuando responda, vuelve y envíale el link.":"Tell them you've prepared their review. When they reply, come back and send the link.")
        : (es?"Este mensaje incluye el link encriptado con sus datos.":"This message includes the encrypted link with their info.")}</p>
      <textarea id="sms-msg" value={smsModal.message} onChange={e=>setSmsModal(m=>({...m,message:e.target.value}))} rows={5} style={{width:"100%",fontSize:".86rem",padding:"10px 12px",borderRadius:10,border:"1px solid #cbd5e1",resize:"vertical",fontFamily:"inherit",boxSizing:"border-box"}}/>
      <div style={{display:"flex",flexWrap:"wrap",gap:6,alignItems:"center",margin:"8px 0 4px"}}>
        <span style={{fontSize:".66rem",color:"#94a3b8",fontWeight:700}}>{es?"Insertar:":"Insert:"}</span>
        {[{label:es?"Nombre":"Name",val:smsModal.client?.firstName||""},{label:es?"Mi nombre":"My name",val:smsModal.agentName||""},...(smsModal.url?[{label:es?"Link":"Link",val:smsModal.url}]:[])].filter(ch=>ch.val).map(ch=>
          <button type="button" key={ch.label} onClick={()=>insertSmsVar(ch.val)} style={{padding:"4px 10px",borderRadius:8,border:"1px solid #bae6fd",background:"#e0f2fe",color:"#0369a1",fontSize:".72rem",fontWeight:700,cursor:"pointer"}}>{ch.label}</button>)}
        <span style={{marginLeft:"auto",display:"inline-flex",gap:6}}>
          {[{id:"es",label:"🇪🇸 ES"},{id:"en",label:"🇺🇸 EN"}].map(L=>{ const on=(smsModal.lng==="es"?"es":"en")===L.id;
            return <button key={L.id} type="button" onClick={()=>translateSmsTo(L.id)} disabled={smsTranslating} title={es?"Traduce el mensaje a este idioma con IA":"AI-translate the message into this language"} style={{fontSize:".72rem",fontWeight:800,borderRadius:8,padding:"4px 11px",cursor:smsTranslating?"wait":"pointer",border:`1px solid ${on?"#0ea5e9":"#cbd5e1"}`,background:on?"#e0f2fe":"#fff",color:on?"#0369a1":"#94a3b8"}}>{smsTranslating&&on?"…":L.label}</button>; })}
        </span>
      </div>
      <div style={{fontSize:".7rem",color:"#94a3b8",margin:"2px 0 14px"}}>{smsModal.canal==="email"?(es?"Sale de tu correo conectado, con tu firma.":"Sent from your connected mailbox, with your signature."):`${smsModal.message.length} ${es?"caracteres":"chars"}`}</div>
      <div className="flex gap-3">
        <button onClick={sendReviewSms} disabled={sendingSms} className="flex-1 dkt-btn-p">{sendingSms?(es?"Enviando…":"Sending…"):smsModal.canal==="email"?(es?"Enviar correo":"Send email"):(es?"Enviar SMS":"Send SMS")}</button>
        <button onClick={()=>setSmsModal(null)} className="flex-1 bg-gray-100 text-gray-700 font-semibold py-2.5 rounded-xl">{es?"Cancelar":"Cancel"}</button>
      </div>
    </Modal>}

    {showFieldsEditor&&<Modal title={es?"Campos de revisión por tipo":"Review fields by type"} onClose={()=>setShowFieldsEditor(false)}>
      <p style={{fontSize:".8rem",color:"#64748b",marginBottom:10}}>{es?"Elige qué datos del cliente se muestran en el link de revisión, por tipo de póliza. Se usan automáticamente al enviar el aviso/link desde Renovaciones.":"Choose which client data shows in the review link, per policy type. Used automatically when you send the notice/link from Renewals."}</p>
      <label style={{fontSize:".74rem",fontWeight:700,color:"#475569"}}>{es?"Campos para":"Fields for"}</label>
      <select value={fieldsEditType} onChange={e=>switchFieldsType(e.target.value)} style={{width:"100%",fontSize:".84rem",padding:"8px 10px",borderRadius:8,border:"1px solid #cbd5e1",margin:"4px 0 12px",background:"#fff"}}>
        <option value="__default__">{es?"⭐ Por defecto (todos los tipos)":"⭐ Default (all types)"}</option>
        {/* Todos los tipos, con los propios de la agencia (Lissette 2026-10-19). */}
        {tiposDePolizaConKit().map(tid=>{ const pt=getPolicyType(tid); const has=Array.isArray(reviewFieldsByType[tid])&&reviewFieldsByType[tid].length;
          return <option key={tid} value={tid}>{pt.icon} {es?(pt.labelEs||pt.label):pt.label}{has?" ✓":""}</option>; })}
      </select>
      <p style={{fontSize:".72rem",color:fieldsEditType==="__default__"?"#94a3b8":"#0ea5e9",marginBottom:10}}>{fieldsEditType==="__default__"
        ? (es?"Se usa para cualquier tipo sin lista propia.":"Used for any type without its own list.")
        : (es?`Lista específica para ${getPolicyType(fieldsEditType).labelEs||getPolicyType(fieldsEditType).label}.`:`Specific list for ${getPolicyType(fieldsEditType).label}.`)}</p>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"6px 12px",marginBottom:14}}>
        {/* Las preguntas de SEGUIMIENTO no se listan aqui (Lissette
            2026-09-09). No son una eleccion aparte: solo salen cuando el
            cliente contesta lo que las abre, y viajan siempre con su pregunta
            madre — el servidor las anade solo. Enseñarlas con su propia
            casilla era la trampa: marcabas "¿Tienes cuenta ID.me?" y la de
            seguimiento no llegaba nunca, sin que nada lo dijera. */}
        {RR_FIELD_CATALOG.filter(f=>!f.dependsOn).map(f=>{ const on=fieldsDraft.includes(f.key);
          return <label key={f.key} style={{display:"flex",alignItems:"center",gap:8,cursor:"pointer",fontSize:".82rem",color:"#334155"}}>
            {/* La de renovar va en TODO enlace: el servidor la añade igual
                (PREGUNTAS_SIEMPRE), asi que se enseña marcada y sin poder
                quitarla en vez de una casilla que no cambia nada. */}
            <input type="checkbox" checked={on||!!f.siempre} disabled={!!f.siempre} onChange={()=>{ if(!f.siempre) toggleFieldDraft(f.key); }} style={{accentColor:"#0ea5e9",width:15,height:15}}/>
            <span>{es?f.es:f.en}{f.siempre&&<span style={{color:"#64748b",marginLeft:6,fontSize:".72rem"}}>{es?"(va siempre)":"(always included)"}</span>}{f.sensitive&&<span style={{color:"#f59e0b",marginLeft:4}} title={es?"Dato sensible":"Sensitive"}>•</span>}{f.question&&<span style={{color:"#0ea5e9",marginLeft:4,fontSize:".68rem",fontWeight:700}} title={es?"El cliente la contesta Sí/No":"The client answers Yes/No"}>{es?"PREGUNTA":"QUESTION"}</span>}</span>
          </label>; })}
      </div>
      <div className="flex gap-3">
        <button onClick={saveFields} className="flex-1 dkt-btn-p">{es?"Guardar":"Save"}</button>
        <button onClick={()=>setShowFieldsEditor(false)} className="flex-1 bg-gray-100 text-gray-700 font-semibold py-2.5 rounded-xl">{es?"Cancelar":"Cancel"}</button>
      </div>
    </Modal>}

    {missingDocsModal&&(()=>{ const mp=missingDocsModal.policy; const mc=clients.find(cl=>cl.id===mp.clientId); const items=missingDocsModal.missing||[];
      return <Modal title={es?"Faltan documentos":"Missing documents"} onClose={()=>setMissingDocsModal(null)}>
      <p style={{fontSize:".84rem",color:"#334155",marginBottom:6}}>{es?"Antes de enviar el kit de bienvenida a ":"Before sending the welcome kit to "}<strong>{mc?`${mc.firstName} ${mc.lastName}`:(es?"el cliente":"the client")}</strong>{es?", faltan estos documentos requeridos:":", these required documents are missing:"}</p>
      <ul style={{margin:"8px 0 14px",padding:"10px 12px",listStyle:"none",background:"#fff7ed",border:"1px solid #fed7aa",borderRadius:10}}>
        {items.length?items.map((d,i)=><li key={i} style={{display:"flex",alignItems:"center",gap:8,fontSize:".82rem",color:"#9a3412",fontWeight:600,padding:"3px 0"}}><span style={{color:"#f59e0b"}}>●</span>{es?(d.nameEs||d.name):(d.name||d.nameEs)}</li>):<li style={{fontSize:".82rem",color:"#9a3412"}}>{es?"Documentos requeridos pendientes.":"Required documents pending."}</li>}
      </ul>
      <p style={{fontSize:".76rem",color:"#64748b",marginBottom:14}}>{es?"La póliza ya quedó como \"Lista\". Puedes pedir/subir los documentos y luego enviar el kit, o enviarlo de todos modos ahora.":"The policy is already marked \"Done\". You can request/upload the documents and send the kit later, or send it anyway now."}</p>
      <div className="flex gap-3">
        <button onClick={()=>forceSendKit(mp)} className="flex-1 dkt-btn-p">{es?"Enviar de todos modos":"Send anyway"}</button>
        <button onClick={()=>setMissingDocsModal(null)} className="flex-1 bg-gray-100 text-gray-700 font-semibold py-2.5 rounded-xl">{es?"Cancelar":"Cancel"}</button>
      </div>
    </Modal>; })()}

    {/* Filas y campo con los colores del TEMA: sin color propio heredaban letra
        oscura y en modo oscuro no se leian (Lissette 2026-10-22, captura). */}
    {showStatusMgr&&<Modal title={es?"Status personalizados":"Custom statuses"} onClose={()=>setShowStatusMgr(false)}>
      <p style={{fontSize:".8rem",color:"#64748b",marginBottom:12}}>{es?"Los 4 status base no se pueden borrar. Agrega los tuyos con color. Solo \"Lista\" envía el kit de bienvenida.":"The 4 base statuses can't be removed. Add your own with a color. Only \"Done\" sends the welcome kit."}</p>
      <div style={{display:"flex",flexDirection:"column",gap:6,marginBottom:14}}>
        {DEFAULT_RENEWAL_STATUSES.map(s=><div key={s.id} style={{display:"flex",alignItems:"center",gap:8,fontSize:".82rem",color:"var(--c-white,#eef6ff)"}}><span style={{width:10,height:10,borderRadius:99,background:s.color}}/>{es?s.es:s.en}<span style={{marginLeft:"auto",fontSize:".66rem",color:"#94a3b8"}}>{es?"base":"built-in"}</span></div>)}
        {(customStatuses||[]).map(s=><div key={s.id} style={{display:"flex",alignItems:"center",gap:8,fontSize:".82rem",color:"var(--c-white,#eef6ff)"}}><span style={{width:10,height:10,borderRadius:99,background:s.color||"#64748b"}}/>{s.label}<button onClick={()=>removeCustomStatus(s.id)} style={{marginLeft:"auto",fontSize:".7rem",color:"#ef4444",background:"none",border:"none",cursor:"pointer",fontWeight:700}}>{es?"Quitar":"Remove"}</button></div>)}
      </div>
      <div style={{display:"flex",gap:8,alignItems:"center"}}>
        <input type="color" value={newStatusColor} onChange={e=>setNewStatusColor(e.target.value)} style={{width:38,height:38,padding:0,border:"1px solid var(--c-border,#1a3550)",borderRadius:8,cursor:"pointer"}}/>
        <input value={newStatusLabel} onChange={e=>setNewStatusLabel(e.target.value)} onKeyDown={e=>{if(e.key==="Enter")addCustomStatus();}} placeholder={es?"Nombre del status":"Status name"} style={{flex:1,fontSize:".84rem",padding:"8px 10px",borderRadius:8,border:"1px solid var(--c-border,#1a3550)",background:"var(--c-surface2,#112538)",color:"var(--c-white,#eef6ff)"}}/>
        <button onClick={addCustomStatus} className="dkt-btn-p">{es?"Agregar":"Add"}</button>
      </div>
    </Modal>}

    {showMsgEditor&&<Modal title={es?"✍️ Mensaje del enlace de renovación":"✍️ Renewal link message"} onClose={()=>setShowMsgEditor(false)}>
      <p style={{fontSize:".8rem",color:"#64748b",marginBottom:4}}>{es
        ? "Lo que escribas aquí queda para TODO el equipo: es el texto que sale por defecto cada vez que alguien manda una renovación. En el momento de enviar todavía se puede retocar para ese cliente, sin cambiar esto."
        : "What you write here applies to the WHOLE team: it is the default text every time someone sends a renewal. At send time it can still be tweaked for that one client, without changing this."}</p>
      <p style={{fontSize:".74rem",color:"#94a3b8",marginBottom:14}}>{es?"Variables: ":"Variables: "}<code>{VARS_DEL_ENLACE.join("  ")}</code></p>
      {[{tipo:"notice",titulo:es?"1 · Aviso (pregunta antes de mandar el enlace)":"1 · Notice (asks before sending the link)"},
        {tipo:"link",titulo:es?"2 · Mensaje con el enlace":"2 · Message carrying the link"}].map(sec=>(
        <div key={sec.tipo} style={{marginBottom:18}}>
          <div style={{fontSize:".78rem",fontWeight:800,color:"#334155",marginBottom:8}}>{sec.titulo}</div>
          {[{id:"es",label:"🇪🇸 Español"},{id:"en",label:"🇺🇸 English"}].map(L=>{
            const k=llaveDe(sec.tipo,L.id); const valor=msgDraft[k]||"";
            const propio=valor.trim()!==PLANTILLAS_DE_FABRICA[k];
            return <div key={k} style={{marginBottom:10}}>
              <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",gap:8,marginBottom:3}}>
                <label style={{fontSize:".72rem",fontWeight:700,color:"#475569"}}>{L.label}</label>
                <div style={{display:"flex",alignItems:"center",gap:8}}>
                  <span style={{fontSize:".68rem",color:valor.length>LARGO_DEL_MENSAJE?"#ef4444":"#94a3b8"}}>{valor.length}/{LARGO_DEL_MENSAJE}</span>
                  {/* Traducir al OTRO idioma (Lissette 2026-09-09). El boton
                      va en la caja de ORIGEN y la flecha dice a donde escribe:
                      en la de al lado, sin tocar esta. */}
                  <button type="button" onClick={()=>traducirMensaje(sec.tipo,L.id)} disabled={!!msgTranslating||!valor.trim()}
                    title={L.id==="es"
                      ? (es?"Traducir este texto al inglés y ponerlo en la caja de abajo":"Translate this text to English into the box below")
                      : (es?"Traducir este texto al español y ponerlo en la caja de arriba":"Translate this text to Spanish into the box above")}
                    style={{fontSize:".68rem",fontWeight:700,color:"#0f766e",background:"#ccfbf1",border:"1px solid #99f6e4",borderRadius:7,padding:"2px 8px",cursor:(msgTranslating||!valor.trim())?"not-allowed":"pointer",opacity:(msgTranslating||!valor.trim())?.5:1}}>
                    {msgTranslating===llaveDe(sec.tipo,L.id==="es"?"en":"es")?"…":`🤖 → ${L.id==="es"?"EN":"ES"}`}
                  </button>
                  {propio&&<button type="button" onClick={()=>restaurarMensaje(sec.tipo,L.id)} style={{fontSize:".68rem",fontWeight:700,color:"#0ea5e9",background:"#e0f2fe",border:"1px solid #bae6fd",borderRadius:7,padding:"2px 8px",cursor:"pointer"}}>{es?"Volver al de fábrica":"Reset to default"}</button>}
                </div>
              </div>
              <textarea value={valor} onChange={e=>setMsgDraft(d=>({...d,[k]:e.target.value.slice(0,LARGO_DEL_MENSAJE)}))} rows={3}
                style={{width:"100%",fontSize:".82rem",padding:"8px 10px",borderRadius:8,border:"1px solid #cbd5e1",resize:"vertical",fontFamily:"inherit"}}/>
            </div>;
          })}
        </div>
      ))}
      <div style={{display:"flex",justifyContent:"flex-end",gap:8}}>
        <button onClick={()=>setShowMsgEditor(false)} className="dkt-btn-s">{es?"Cancelar":"Cancel"}</button>
        <button onClick={saveMsgs} disabled={msgSaving} className="dkt-btn-p">{msgSaving?(es?"Guardando…":"Saving…"):(es?"Guardar para todo el equipo":"Save for the whole team")}</button>
      </div>
    </Modal>}
    {showKitEditor&&<Modal title={es?"Kit de bienvenida":"Welcome kit"} onClose={()=>setShowKitEditor(false)}>
      <p style={{fontSize:".8rem",color:"#64748b",marginBottom:10}}>{es?"Se envía al cliente al marcar la póliza \"Lista\" o con el botón \"Enviar Kit\" en la póliza. Campos: ":"Sent to the client when you mark a policy \"Done\" or with the \"Send Kit\" button on a policy. Fields: "}<code>{"{cliente} {compania} {tipo} {poliza} {portal}"}</code></p>
      <label style={{fontSize:".74rem",fontWeight:700,color:"#475569"}}>{es?"Kit para":"Kit for"}</label>
      <select value={kitEditType} onChange={e=>switchKitType(e.target.value)} style={{width:"100%",fontSize:".84rem",padding:"8px 10px",borderRadius:8,border:"1px solid #cbd5e1",margin:"4px 0 12px",background:"#fff"}}>
        {/* Solo los mensajes de RENOVACIÓN por tipo: ningún "General" ni
            "por defecto" en esta lista (Lissette 2026-10-23 y 2026-10-26). El
            Kit de Cambio de Vida se edita en la ficha de cada cliente (botón
            "Cambio de vida" → "✏️ Editar el mensaje de la agencia"). */}
        {tiposDePolizaConKit().map(tid=>{ const pt=getPolicyType(tid); const has=!!mensajeDeKit(kitByType,KIT_RENOVACION,tid);
          const en=!!mensajeDeKitEnIngles(kitByType,KIT_RENOVACION,tid);
          return <option key={tid} value={tid}>{pt.icon} {es?(pt.labelEs||pt.label):pt.label}{has?" ✓":""}{en?" · EN":""}</option>; })}
      </select>
      <div style={{margin:"0 0 12px"}}>
        <SelectorDeIdiomaDelKit idioma={kitVersion} onChange={switchKitVersion}
          tieneIngles={!!mensajeDeKitEnIngles(kitByType,KIT_RENOVACION,kitEditType)} lang={lang}/>
        {kitVersion==="en"&&!(kitDraft.subject||"").trim()&&!(kitDraft.body||"").replace(/<[^>]*>/g,"").trim()&&
          <button type="button" onClick={traducirPrincipalAlIngles} disabled={kitTranslating} className="dkt-btn-s" style={{marginTop:6,fontSize:".74rem"}}>
            {kitTranslating?"…":`🌐 ${es?"Traducir el principal al inglés":"Translate the main message to English"}`}</button>}
      </div>
      <p style={{fontSize:".72rem",color:"#0ea5e9",marginBottom:12}}>{(es?`Kit para pólizas de ${getPolicyType(kitEditType).labelEs||getPolicyType(kitEditType).label}. Si lo dejas vacío, a las pólizas de este tipo NO se les envía kit.`:`Kit for ${getPolicyType(kitEditType).label} policies. If you leave it blank, policies of this type get NO kit.`)}</p>
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",gap:8}}>
        <label style={{fontSize:".74rem",fontWeight:700,color:"#475569"}}>{es?"Asunto":"Subject"}</label>
        <div style={{display:"flex",gap:6,alignItems:"center"}}>
          {[{id:"es",label:"🇪🇸 ES"},{id:"en",label:"🇺🇸 EN"}].map(L=>{ const on=kitLang===L.id;
            return <button key={L.id} type="button" onClick={()=>translateKitTo(L.id)} disabled={kitTranslating} title={es?"Solo traduce el texto del editor con IA. Para que a los clientes de inglés les llegue en inglés, usa \"Versión en inglés\" arriba.":"Only AI-translates the editor text. For English-speaking clients to get English, use \"English version\" above."} style={{fontSize:".72rem",fontWeight:800,borderRadius:8,padding:"4px 11px",cursor:kitTranslating?"wait":"pointer",border:`1px solid ${on?"#0ea5e9":"#cbd5e1"}`,background:on?"#e0f2fe":"#fff",color:on?"#0369a1":"#94a3b8",boxShadow:on?"0 0 0 2px rgba(14,165,233,.15)":"none"}}>{kitTranslating&&on?"…":L.label}</button>; })}
          <button type="button" onClick={loadDefaultKitText} style={{fontSize:".7rem",fontWeight:700,color:"#0ea5e9",background:"#e0f2fe",border:"1px solid #bae6fd",borderRadius:7,padding:"3px 9px",cursor:"pointer"}} title={es?"Llena el asunto y el mensaje con un texto de ejemplo para que lo adaptes a este tipo":"Fills subject and message with a sample text to adapt for this type"}>📄 {es?"Usar texto de ejemplo":"Use sample text"}</button>
        </div>
      </div>
      <input id="kit-subject" onFocus={()=>setKitFocusField("subject")} value={kitDraft.subject} onChange={e=>setKitDraft(d=>({...d,subject:e.target.value}))} placeholder={es?"¡Bienvenido(a)! Tu póliza con {compañía}":"Welcome! Your policy with {compañía}"} style={{width:"100%",fontSize:".84rem",padding:"8px 10px",borderRadius:8,border:"1px solid #cbd5e1",margin:"4px 0 12px"}}/>
      <label style={{fontSize:".74rem",fontWeight:700,color:"#475569"}}>{es?"Mensaje":"Message"}</label>
      <EmailRichEditor value={kitDraft.body} onChange={v=>setKitDraft(d=>({...d,body:v}))} apiRef={kitBodyApi} onFoco={()=>setKitFocusField("body")} lang={es?"es":"en"} hoja minHeight={190} placeholder={es?"Hola {cliente}, ¡gracias por confiar en nosotros!…":"Hi {cliente}, thank you for trusting us!…"} style={{margin:"4px 0 8px"}}/>
      <div style={{margin:"0 0 14px"}}>
        <div style={{fontSize:".62rem",color:"#64748b",fontWeight:700,textTransform:"uppercase",letterSpacing:".05em",marginBottom:6}}>🔗 {es?`Campos — clic para insertar en ${kitFocusField==="subject"?"el Asunto":"el Mensaje"}`:`Fields — click to insert into ${kitFocusField==="subject"?"Subject":"Message"}`}</div>
        <div style={{display:"flex",flexWrap:"wrap",gap:6}}>
          {chipsDelKit(es?"es":"en").map(ch=>
            <button type="button" key={ch.tag} onMouseDown={e=>e.preventDefault()} onClick={()=>insertKitVar(ch.tag)} title={ch.tag} style={{padding:"5px 11px",borderRadius:9,border:"1px solid #bae6fd",background:"#e0f2fe",color:"#0369a1",fontSize:".74rem",fontWeight:700,cursor:"pointer"}}>{ch.label}</button>)}
        </div>
        {/* {portal} lo pone el SERVIDOR al enviar (ponerEnlaceDelPortal): crea
            el enlace del portal del cliente, y el portal mismo si no lo tiene.
            El navegador no puede hacerlo, por eso no se rellena aqui. */}
        <div style={{fontSize:".7rem",color:"#64748b",marginTop:6}}>{es
          ? "{portal} inserta el enlace al portal del cliente. Si no tiene uno, se le crea al enviar."
          : "{portal} inserts the client's portal link. If they have none, one is created on send."}</div>
      </div>
      {/* Kit documents are chosen per-document inside each CLIENT's Documents tab
          (the "Kit ▾" menu on every uploaded file), NOT here — this editor is the
          agency-wide message. When a kit is sent for a policy, the backend attaches
          the client's documents whose kit matches that policy type (Lissette
          2026-06-01). */}
      <p style={{fontSize:".72rem",color:"#64748b",margin:"0 0 12px",padding:"8px 10px",background:"#f1f5f9",borderRadius:8,border:"1px solid #e2e8f0"}}>📎 {es?"Los documentos del kit se eligen en cada cliente, en su pestaña de Documentos (botón \"Kit\"), marcando a qué kit pertenece cada archivo.":"Kit documents are chosen per client, in their Documents tab (\"Kit\" button), tagging which kit each file belongs to."}</p>
      <div className="flex gap-3">
        <button onClick={saveKit} className="flex-1 dkt-btn-p">{es?"Guardar":"Save"}</button>
        <button onClick={()=>setShowKitEditor(false)} className="flex-1 bg-gray-100 text-gray-700 font-semibold py-2.5 rounded-xl">{es?"Cancelar":"Cancel"}</button>
      </div>
      {/* Sin "por defecto" (Lissette 2026-10-23 y 2026-10-26: "lo hiciste solo en
          prospecto"). Esta línea seguía diciendo que un mensaje vacío usaba una
          plantilla por defecto, que es justo lo que ya no pasa. */}
      <p style={{fontSize:".72rem",color:"#94a3b8",marginTop:10}}>{es?"Si lo dejas vacío, a las pólizas de este tipo NO se les envía kit de renovación.":"If left blank, policies of this type get NO renewal kit."}</p>
    </Modal>}
  </div>;
}
// ═══════════════════════════════════════════════════════════════════
// RESOURCES VIEW — Upload videos, PDFs, images, docs by carrier/category
// ═══════════════════════════════════════════════════════════════════

// ═══════════════════════════════════════════════════════════════════
// PUBLIC RESOURCE PORTAL — Client-facing resource viewer
// ═══════════════════════════════════════════════════════════════════


function TimeTracking({ timelog, onAddEntry, onDeleteEntry, users, currentUser, t, lang }) {
  const tt = t.timetrack;
  const es = lang === "es";
  const isOwner = currentUser?.role !== "assistant"; const isAgencyAdmin = ["agency_owner","agency_admin"].includes(currentUser?.role);
  const [periodFilter, setPeriodFilter] = useState("week");
  const [userFilter, setUserFilter] = useState("me");
  const [showManual, setShowManual] = useState(false);
  const [manualForm, setManualForm] = useState({ date: localDay(), clockIn: "09:00", clockOut: "17:00", notes: "" });
  const [elapsed, setElapsed] = useState("00:00:00");

  // Switching between My Hours / the team roster / a member is an in-view
  // change (not a `view` change), so the app-level scroll-to-top effect
  // doesn't fire. Snap to the top here so the new screen starts at the
  // header instead of wherever the user was scrolled.
  useEffect(() => {
    if (typeof window !== 'undefined') window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [userFilter]);

  const activeEntry = timelog.find(e => e.userId === currentUser?.id && e.clockIn && !e.clockOut);

  // Live timer — updates every second when clocked in
  useEffect(() => {
    if (!activeEntry) { setElapsed("00:00:00"); return; }
    const tick = () => {
      const [inH, inM] = activeEntry.clockIn.split(":").map(Number);
      const now = new Date();
      const diffSec = (now.getHours() * 3600 + now.getMinutes() * 60 + now.getSeconds()) - (inH * 3600 + inM * 60);
      const sec = Math.max(0, diffSec);
      const h = Math.floor(sec / 3600); const m = Math.floor((sec % 3600) / 60); const s = sec % 60;
      setElapsed(`${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`);
    };
    tick();
    const iv = setInterval(tick, 1000);
    return () => clearInterval(iv);
  }, [activeEntry?.id, activeEntry?.clockIn]);

  const addManual = () => {
    const [inH, inM] = manualForm.clockIn.split(":").map(Number);
    const [outH, outM] = manualForm.clockOut.split(":").map(Number);
    // A cleared <input type="time"> yields "" → NaN, which would persist a
    // NaN-hours entry that poisons payroll/report totals. Guard it.
    if ([inH, inM, outH, outM].some(n => Number.isNaN(n))) {
      toast.warn(lang === "es" ? "Pon una hora de entrada y salida válidas." : "Enter a valid clock-in and clock-out time.");
      return;
    }
    const hours = Math.round(((outH * 60 + outM) - (inH * 60 + inM)) / 60 * 100) / 100;
    onAddEntry({
      date: manualForm.date, clockIn: manualForm.clockIn, clockOut: manualForm.clockOut,
      hours: Math.max(0, hours), notes: manualForm.notes
    });
    setShowManual(false);
    setManualForm({ date: localDay(), clockIn: "09:00", clockOut: "17:00", notes: "" });
  };

  const deleteEntry = (id) => onDeleteEntry(id);

  // Date helpers
  const today = new Date();
  const todayStr = localDay(today);
  const getWeekStart = () => {
    const d = new Date(today); d.setDate(d.getDate() - d.getDay()); return localDay(d);
  };
  const getMonthStart = () => `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-01`;

  // Whose data the calendar / summary cards / week chart reflect. "me" =
  // the logged-in user; a specific id = the team member being drilled
  // into; "team"/"all" never reach the detail UI (the picker renders
  // instead) so they safely fall back to self.
  const viewedUserId = (userFilter === "me" || userFilter === "team" || userFilter === "all")
    ? currentUser?.id
    : userFilter;
  const viewingSelf = viewedUserId === currentUser?.id;
  const myEntries = timelog.filter(e => e.userId === viewedUserId);
  const filteredEntries = timelog.filter(e => {
    if (userFilter === "me" && e.userId !== currentUser?.id) return false;
    if (userFilter !== "me" && userFilter !== "all" && e.userId !== userFilter) return false;
    if (!isOwner && e.userId !== currentUser?.id) return false;
    if (periodFilter === "week" && e.date < getWeekStart()) return false;
    if (periodFilter === "month" && e.date < getMonthStart()) return false;
    return true;
  }).sort((a, b) => b.date.localeCompare(a.date) || (b.clockIn || "").localeCompare(a.clockIn || ""));

  const totalHours = filteredEntries.reduce((s, e) => s + (e.hours || 0), 0);

  // Week total
  const weekStart = getWeekStart();
  const weekHours = myEntries.filter(e => e.date >= weekStart && e.hours).reduce((s, e) => s + e.hours, 0);

  // Month total
  const monthStart = getMonthStart();
  const monthHours = myEntries.filter(e => e.date >= monthStart && e.hours).reduce((s, e) => s + e.hours, 0);

  // Today total
  const todayHours = myEntries.filter(e => e.date === todayStr && e.hours).reduce((s, e) => s + e.hours, 0);

  // Group by date
  const grouped = {};
  filteredEntries.forEach(e => { if (!grouped[e.date]) grouped[e.date] = []; grouped[e.date].push(e); });

  const getUserName = (uid) => { const u = users.find(x => x.id === uid); return u ? u.name : "?"; };
  const getUserColor = (uid) => { const u = users.find(x => x.id === uid); return u?.color || "#45688a"; };
  const getUserInitials = (uid) => { const u = users.find(x => x.id === uid); return u?.initials || "?"; };

  const DAYS_LABEL = es
    ? ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"]
    : ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  const DAYS_SHORT = es ? ["Dom","Lun","Mar","Mié","Jue","Vie","Sáb"] : ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
  const MONTHS_LABEL = es
    ? ["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"]
    : ["January","February","March","April","May","June","July","August","September","October","November","December"];
  const dayLabel = (dateStr) => { const d = new Date(dateStr + "T12:00:00"); return DAYS_LABEL[d.getDay()]; };

  // Monthly calendar data — defaults to current month/year, user can navigate
  const [calMonth, setCalMonth] = useState(today.getMonth());
  const [calYear, setCalYear] = useState(today.getFullYear());

  // Payroll summary (team view) — which month the hours-by-member table
  // reflects. Independent of the personal calendar above. Defaults to the
  // current month; the owner can step back to run prior-month payroll.
  const [payMonth, setPayMonth] = useState(today.getMonth());
  const [payYear, setPayYear] = useState(today.getFullYear());
  const firstDay = new Date(calYear, calMonth, 1).getDay();
  const daysInMonth = new Date(calYear, calMonth + 1, 0).getDate();

  const calDays = [];
  for (let i = 0; i < firstDay; i++) calDays.push(null);
  for (let d = 1; d <= daysInMonth; d++) {
    const ds = `${calYear}-${String(calMonth + 1).padStart(2, "0")}-${String(d).padStart(2, "0")}`;
    const hrs = myEntries.filter(e => e.date === ds && e.hours).reduce((s, e) => s + e.hours, 0);
    const isT = ds === todayStr;
    const isPast = ds < todayStr;
    const isWeekend = new Date(calYear, calMonth, d).getDay() === 0 || new Date(calYear, calMonth, d).getDay() === 6;
    calDays.push({ day: d, date: ds, hours: hrs, isToday: isT, isPast, isWeekend, noActivity: isPast && hrs === 0 && !isWeekend });
  }

  // ── Team roster (owner/agent only) ──────────────────────────────────
  // Membership = everyone the backend already let into `timelog` (it is
  // tenant-scoped) ∪ the current user ∪ this agent's own seats and (for
  // an agency admin) every user in the agency. Seats with ZERO recorded
  // hours are intentionally still listed showing "0.0h" — that is the
  // diagnostic signal that a seat's hours aren't landing.
  const teamIds = new Set();
  timelog.forEach(e => teamIds.add(e.userId));
  if (currentUser?.id) teamIds.add(currentUser.id);
  users.forEach(u => {
    if (!u?.id || u.id === currentUser?.id) return;
    const isMySeat = u.role === "assistant" && u.parentAgentId === currentUser?.id;
    if (isMySeat || isAgencyAdmin) teamIds.add(u.id);
  });
  const teamMembers = [...teamIds].map(id => {
    const u = users.find(x => x.id === id);
    const entries = timelog.filter(e => e.userId === id);
    const hrs = entries.filter(e => e.hours).reduce((s, e) => s + (e.hours || 0), 0);
    const open = entries.some(e => e.clockIn && !e.clockOut);
    const isSelf = id === currentUser?.id;
    // `unknown` = there's a TimeEntry for this userId but the user isn't
    // in the loaded roster (deleted/old account, test login, or an
    // orphaned in-progress session). Surface the short id so the owner
    // can identify or clean it up.
    const unknown = !u && !isSelf;
    return {
      id,
      name: u?.name || (isSelf ? (es ? "Yo" : "Me") : (es ? "Usuario desconocido" : "Unknown user")),
      color: u?.color || (unknown ? "#64748b" : "#45688a"),
      initials: u?.initials || (u?.name ? u.name.slice(0, 2).toUpperCase() : (unknown ? "??" : "?")),
      roleLabel: unknown ? `#${String(id).slice(0, 8)}` : (u?.role === "assistant" ? (es ? "Asiento" : "Seat") : (u?.role || "")),
      isSelf, unknown, hrs, open, count: entries.length,
    };
  }).sort((a, b) => b.hrs - a.hrs || a.name.localeCompare(b.name));

  const selectedMember = (!["me", "team", "all"].includes(userFilter))
    ? teamMembers.find(m => m.id === userFilter) || { id: userFilter, name: getUserName(userFilter), initials: getUserInitials(userFilter), color: getUserColor(userFilter) }
    : null;

  // ── Monthly payroll summary (hours per member for the selected month) ──
  // Built only from CLOSED entries with a numeric `hours` value; an in-
  // progress session (no clockOut) contributes 0 until it's closed. Each
  // member also gets a distinct-day count so the owner can sanity-check
  // attendance, not just the hour total.
  const payKey = `${payYear}-${String(payMonth + 1).padStart(2, "0")}`; // 'YYYY-MM'
  const payrollRows = teamMembers.map(m => {
    const monthEntries = timelog.filter(e => e.userId === m.id && e.date && e.date.startsWith(payKey) && e.hours);
    const monthHrs = monthEntries.reduce((s, e) => s + (e.hours || 0), 0);
    const daysWorked = new Set(monthEntries.map(e => e.date)).size;
    return { ...m, monthHrs, daysWorked };
  }).sort((a, b) => b.monthHrs - a.monthHrs || a.name.localeCompare(b.name));
  const payrollTotal = payrollRows.reduce((s, r) => s + r.monthHrs, 0);
  const payrollDaysTotal = payrollRows.reduce((s, r) => s + r.daysWorked, 0);

  // TEAM PICKER — replaces the whole detail view while browsing the roster.
  if (isOwner && userFilter === "team") {
    return (
      <div>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "1rem", flexWrap: "wrap", gap: ".5rem" }}>
          <div style={{ display: "flex", alignItems: "center", gap: ".5rem" }}>
            <Clock size={20} style={{ color: "var(--c-cyan,#00d4ff)" }} />
            <h2 style={{ fontSize: "1.1rem", fontWeight: 800, color: "var(--c-white,#eef6ff)", margin: 0 }}>{tt.title}</h2>
          </div>
          <button type="button" onClick={() => setUserFilter("me")}
            style={{ padding: ".4rem .85rem", borderRadius: 100, border: "1px solid var(--c-border,#1a3550)", background: "transparent", color: "var(--c-text2,#7aa3c0)", fontSize: ".72rem", fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}>
            ← {tt.myHours}
          </button>
        </div>
        <div style={{ fontSize: ".75rem", color: "var(--c-text3,#45688a)", fontWeight: 600, marginBottom: ".75rem" }}>
          👥 {tt.teamHeading} · <span style={{ color: "var(--c-cyan,#00d4ff)" }}>{teamMembers.length} {tt.teamMembers}</span>
        </div>
        {teamMembers.length === 0 && (
          <div style={{ textAlign: "center", padding: "2rem", color: "var(--c-text3,#45688a)", fontSize: ".82rem" }}>{tt.noTeamMembers}</div>
        )}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(190px,1fr))", gap: ".6rem" }}>
          {teamMembers.map(m => (
            <button type="button" key={m.id} onClick={() => setUserFilter(m.id)}
              style={{ display: "flex", alignItems: "center", gap: ".65rem", background: "var(--c-surface2,#112538)", border: "1px solid var(--c-border,#1a3550)", borderRadius: 12, padding: ".75rem .85rem", cursor: "pointer", fontFamily: "inherit", textAlign: "left" }}>
              <div style={{ position: "relative", width: 38, height: 38, borderRadius: "50%", background: m.color, display: "flex", alignItems: "center", justifyContent: "center", fontSize: ".7rem", fontWeight: 800, color: "#fff", flexShrink: 0 }}>
                {m.initials}
                {m.open && <span style={{ position: "absolute", bottom: -1, right: -1, width: 11, height: 11, borderRadius: "50%", background: "var(--c-green,#00ff88)", border: "2px solid var(--c-surface2,#112538)" }} />}
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: ".82rem", fontWeight: 700, color: "var(--c-white,#eef6ff)", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                  {m.name}{m.isSelf && <span style={{ color: "var(--c-text3,#45688a)", fontWeight: 600 }}> ({es ? "yo" : "me"})</span>}
                </div>
                <div style={{ fontSize: ".62rem", color: "var(--c-text3,#45688a)", marginTop: 1 }}>
                  {m.roleLabel}{m.roleLabel ? " · " : ""}<span style={{ color: m.hrs > 0 ? "var(--c-cyan,#00d4ff)" : "#ef4444", fontWeight: 700, fontFamily: "var(--font-mono)" }}>{m.hrs.toFixed(1)}h</span>
                </div>
              </div>
            </button>
          ))}
        </div>

        {/* ── MONTHLY PAYROLL SUMMARY (hours per member, per month) ── */}
        <div style={{ marginTop: "1.5rem", background: "var(--c-surface2,#112538)", border: "1px solid var(--c-border,#1a3550)", borderRadius: 12, padding: ".85rem" }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: ".5rem", marginBottom: ".75rem" }}>
            <div style={{ fontSize: ".8rem", fontWeight: 800, color: "var(--c-white,#eef6ff)", display: "flex", alignItems: "center", gap: ".4rem" }}>
              🗓️ {es ? "Nómina de horas por mes" : "Monthly hours payroll"}
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: ".4rem" }}>
              <button type="button" onClick={() => { if (payMonth === 0) { setPayMonth(11); setPayYear(y => y - 1); } else setPayMonth(m => m - 1); }}
                style={{ background: "none", border: "1px solid var(--c-border,#1a3550)", color: "var(--c-text2,#7aa3c0)", cursor: "pointer", padding: "2px 8px", borderRadius: 6, fontSize: ".75rem", fontWeight: 700, fontFamily: "inherit", lineHeight: 1 }}>‹</button>
              <select value={payMonth} onChange={e => setPayMonth(Number(e.target.value))}
                style={{ background: "var(--c-surface,#0d1c2e)", border: "1px solid var(--c-border,#1a3550)", color: "var(--c-white,#eef6ff)", fontSize: ".7rem", fontWeight: 800, borderRadius: 6, padding: "3px 6px", cursor: "pointer", fontFamily: "inherit" }}>
                {MONTHS_LABEL.map((m, i) => <option key={i} value={i}>{m}</option>)}
              </select>
              <select value={payYear} onChange={e => setPayYear(Number(e.target.value))}
                style={{ background: "var(--c-surface,#0d1c2e)", border: "1px solid var(--c-border,#1a3550)", color: "var(--c-white,#eef6ff)", fontSize: ".7rem", fontWeight: 800, borderRadius: 6, padding: "3px 6px", cursor: "pointer", fontFamily: "inherit" }}>
                {Array.from({ length: 7 }, (_, i) => today.getFullYear() - 3 + i).map(y => <option key={y} value={y}>{y}</option>)}
              </select>
              <button type="button" onClick={() => { if (payMonth === 11) { setPayMonth(0); setPayYear(y => y + 1); } else setPayMonth(m => m + 1); }}
                style={{ background: "none", border: "1px solid var(--c-border,#1a3550)", color: "var(--c-text2,#7aa3c0)", cursor: "pointer", padding: "2px 8px", borderRadius: 6, fontSize: ".75rem", fontWeight: 700, fontFamily: "inherit", lineHeight: 1 }}>›</button>
              {(payMonth !== today.getMonth() || payYear !== today.getFullYear()) && (
                <button type="button" onClick={() => { setPayMonth(today.getMonth()); setPayYear(today.getFullYear()); }}
                  style={{ background: "rgba(0,212,255,.1)", border: "1px solid rgba(0,212,255,.3)", color: "var(--c-cyan,#00d4ff)", cursor: "pointer", padding: "2px 8px", borderRadius: 6, fontSize: ".6rem", fontWeight: 700, fontFamily: "inherit" }}>
                  {es ? "Mes actual" : "This month"}
                </button>
              )}
            </div>
          </div>

          {/* Header row */}
          <div style={{ display: "grid", gridTemplateColumns: "1fr auto auto", gap: ".5rem", padding: ".35rem .5rem", fontSize: ".55rem", fontWeight: 700, color: "var(--c-text3,#45688a)", textTransform: "uppercase", letterSpacing: ".05em", borderBottom: "1px solid var(--c-border,#1a3550)" }}>
            <span>{es ? "Miembro" : "Member"}</span>
            <span style={{ textAlign: "right", minWidth: 64 }}>{es ? "Días" : "Days"}</span>
            <span style={{ textAlign: "right", minWidth: 72 }}>{es ? "Horas" : "Hours"}</span>
          </div>

          {payrollRows.map(r => (
            <div key={r.id} style={{ display: "grid", gridTemplateColumns: "1fr auto auto", gap: ".5rem", padding: ".45rem .5rem", alignItems: "center", borderBottom: "1px solid rgba(26,53,80,.4)" }}>
              <div style={{ display: "flex", alignItems: "center", gap: ".55rem", minWidth: 0 }}>
                <div style={{ width: 26, height: 26, borderRadius: "50%", background: r.color, display: "flex", alignItems: "center", justifyContent: "center", fontSize: ".55rem", fontWeight: 800, color: "#fff", flexShrink: 0 }}>{r.initials}</div>
                <span style={{ fontSize: ".78rem", fontWeight: 600, color: "var(--c-white,#eef6ff)", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                  {r.name}{r.isSelf && <span style={{ color: "var(--c-text3,#45688a)", fontWeight: 600 }}> ({es ? "yo" : "me"})</span>}
                </span>
              </div>
              <span style={{ textAlign: "right", minWidth: 64, fontSize: ".72rem", fontWeight: 600, color: r.daysWorked > 0 ? "var(--c-text2,#7aa3c0)" : "var(--c-text3,#45688a)", fontFamily: "var(--font-mono)" }}>{r.daysWorked}</span>
              <span style={{ textAlign: "right", minWidth: 72, fontSize: ".82rem", fontWeight: 800, color: r.monthHrs > 0 ? "var(--c-cyan,#00d4ff)" : "var(--c-text3,#45688a)", fontFamily: "var(--font-mono)" }}>{r.monthHrs.toFixed(2)}h</span>
            </div>
          ))}

          {/* Grand total */}
          <div style={{ display: "grid", gridTemplateColumns: "1fr auto auto", gap: ".5rem", padding: ".55rem .5rem .15rem", alignItems: "center", marginTop: ".15rem" }}>
            <span style={{ fontSize: ".75rem", fontWeight: 800, color: "var(--c-white,#eef6ff)" }}>{es ? "Total del equipo" : "Team total"}</span>
            <span style={{ textAlign: "right", minWidth: 64, fontSize: ".72rem", fontWeight: 700, color: "var(--c-text2,#7aa3c0)", fontFamily: "var(--font-mono)" }}>{payrollDaysTotal}</span>
            <span style={{ textAlign: "right", minWidth: 72, fontSize: ".95rem", fontWeight: 800, color: "var(--c-green,#00ff88)", fontFamily: "var(--font-mono)" }}>{payrollTotal.toFixed(2)}h</span>
          </div>
          <div style={{ fontSize: ".58rem", color: "var(--c-text3,#45688a)", marginTop: ".5rem", lineHeight: 1.4 }}>
            {es
              ? "Solo cuenta horas de sesiones cerradas. Las sesiones en progreso suman 0 hasta cerrarse. “Días” = días distintos con horas registradas."
              : "Counts closed sessions only. In-progress sessions add 0 until closed. “Days” = distinct days with recorded hours."}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "1rem", flexWrap: "wrap", gap: ".5rem" }}>
        <div style={{ display: "flex", alignItems: "center", gap: ".5rem" }}>
          <Clock size={20} style={{ color: "var(--c-cyan,#00d4ff)" }} />
          <h2 style={{ fontSize: "1.1rem", fontWeight: 800, color: "var(--c-white,#eef6ff)", margin: 0 }}>{tt.title}</h2>
        </div>
        <button type="button" onClick={() => setShowManual(true)}
          style={{ display: "flex", alignItems: "center", gap: 5, background: "var(--c-surface3,#162d44)", border: "1px solid var(--c-border,#1a3550)", color: "var(--c-text2,#7aa3c0)", fontSize: ".75rem", fontWeight: 600, padding: ".45rem .85rem", borderRadius: 9, cursor: "pointer", fontFamily: "inherit" }}>
          <Plus size={13} />{tt.addManual}
        </button>
      </div>

      {/* AUTO ACTIVITY STATUS — only your own live session (a teammate's history has no live clock) */}
      {viewingSelf && (
      <div style={{ background: activeEntry ? "rgba(0,255,136,.06)" : "rgba(239,68,68,.04)", border: `2px solid ${activeEntry ? "rgba(0,255,136,.3)" : "rgba(239,68,68,.15)"}`, borderRadius: 14, padding: "1rem 1.25rem", marginBottom: "1rem", display: "flex", alignItems: "center", gap: "1rem" }}>
        <div style={{ width: 48, height: 48, borderRadius: "50%", background: activeEntry ? "rgba(0,255,136,.1)" : "rgba(239,68,68,.08)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
          <span style={{ width: 14, height: 14, borderRadius: "50%", background: activeEntry ? "var(--c-green,#00ff88)" : "#ef4444", display: "inline-block", animation: activeEntry ? "pulse 1.5s infinite" : "none" }} />
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: ".72rem", color: activeEntry ? "var(--c-green,#00ff88)" : "#ef4444", fontWeight: 700, marginBottom: ".15rem", display: "flex", alignItems: "center", gap: ".4rem" }}>
            {activeEntry ? (es ? "Activo — Rastreando automáticamente" : "Active — Tracking automatically") : (es ? "Inactivo — Se reanuda al detectar actividad" : "Inactive — Resumes when activity detected")}
          </div>
          {activeEntry ? (
            <>
              <div style={{ fontSize: "1.8rem", fontWeight: 800, color: "var(--c-white,#eef6ff)", fontFamily: "var(--font-mono)", letterSpacing: ".05em", lineHeight: 1.1 }}>{elapsed}</div>
              <div style={{ fontSize: ".62rem", color: "var(--c-text3,#45688a)", marginTop: 2 }}>
                {es ? "Desde" : "Since"} {activeEntry.clockIn} · {activeEntry.date}
              </div>
            </>
          ) : (
            <div style={{ fontSize: ".72rem", color: "var(--c-text3,#45688a)" }}>
              {es ? "Mueve el mouse o usa el teclado para reanudar" : "Move mouse or use keyboard to resume"}
            </div>
          )}
        </div>
        <div style={{ textAlign: "right", flexShrink: 0 }}>
          <div style={{ fontSize: ".5rem", color: "var(--c-text3,#45688a)", fontWeight: 700, textTransform: "uppercase", letterSpacing: ".08em" }}>{es ? "Sesiones hoy" : "Sessions today"}</div>
          <div style={{ fontSize: "1rem", fontWeight: 800, color: "var(--c-cyan,#00d4ff)", fontFamily: "var(--font-mono)" }}>
            {myEntries.filter(e => e.date === todayStr).length}
          </div>
        </div>
      </div>
      )}

      {/* SUMMARY CARDS: Today / This Week / This Month */}
      <div style={{ display: "flex", gap: ".5rem", marginBottom: "1rem", flexWrap: "wrap" }}>
        {[
          { label: es ? "Hoy" : "Today", value: todayHours, color: "var(--c-green,#00ff88)", icon: "📅" },
          { label: es ? "Esta Semana" : "This Week", value: weekHours, color: "var(--c-cyan,#00d4ff)", icon: "📊" },
          { label: es ? "Este Mes" : "This Month", value: monthHours, color: "#fbbf24", icon: "📆" },
        ].map((s, i) => (
          <div key={i} style={{ flex: 1, minWidth: 100, background: "var(--c-surface2,#112538)", border: "1px solid var(--c-border,#1a3550)", borderRadius: 10, padding: ".55rem .65rem", textAlign: "center" }}>
            <div style={{ fontSize: ".55rem", color: "var(--c-text3,#45688a)", fontWeight: 700, textTransform: "uppercase", letterSpacing: ".05em", marginBottom: ".2rem" }}>{s.icon} {s.label}</div>
            <div style={{ fontSize: "1.15rem", fontWeight: 800, color: s.color, fontFamily: "var(--font-mono)" }}>{s.value.toFixed(1)}h</div>
          </div>
        ))}
      </div>

      {/* MONTHLY CALENDAR — shows active/inactive days */}
      <div style={{ background: "var(--c-surface2,#112538)", border: "1px solid var(--c-border,#1a3550)", borderRadius: 12, padding: ".85rem", marginBottom: "1rem" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: ".5rem", marginBottom: ".55rem" }}>
          <button type="button" onClick={() => { if (calMonth === 0) { setCalMonth(11); setCalYear(y => y - 1); } else setCalMonth(m => m - 1); }}
            style={{ background: "none", border: "1px solid var(--c-border,#1a3550)", color: "var(--c-text2,#7aa3c0)", cursor: "pointer", padding: "2px 7px", borderRadius: 6, fontSize: ".7rem", fontWeight: 700, fontFamily: "inherit", lineHeight: 1 }}>‹</button>
          <select value={calMonth} onChange={e => setCalMonth(Number(e.target.value))}
            style={{ background: "var(--c-surface,#0d1c2e)", border: "1px solid var(--c-border,#1a3550)", color: "var(--c-white,#eef6ff)", fontSize: ".68rem", fontWeight: 800, borderRadius: 6, padding: "3px 6px", cursor: "pointer", fontFamily: "inherit", textTransform: "uppercase", letterSpacing: ".04em" }}>
            {(es ? ["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"] : ["January","February","March","April","May","June","July","August","September","October","November","December"]).map((m, i) => (
              <option key={i} value={i}>{m}</option>
            ))}
          </select>
          <select value={calYear} onChange={e => setCalYear(Number(e.target.value))}
            style={{ background: "var(--c-surface,#0d1c2e)", border: "1px solid var(--c-border,#1a3550)", color: "var(--c-white,#eef6ff)", fontSize: ".68rem", fontWeight: 800, borderRadius: 6, padding: "3px 6px", cursor: "pointer", fontFamily: "inherit" }}>
            {Array.from({ length: 7 }, (_, i) => today.getFullYear() - 3 + i).map(y => (
              <option key={y} value={y}>{y}</option>
            ))}
          </select>
          <button type="button" onClick={() => { if (calMonth === 11) { setCalMonth(0); setCalYear(y => y + 1); } else setCalMonth(m => m + 1); }}
            style={{ background: "none", border: "1px solid var(--c-border,#1a3550)", color: "var(--c-text2,#7aa3c0)", cursor: "pointer", padding: "2px 7px", borderRadius: 6, fontSize: ".7rem", fontWeight: 700, fontFamily: "inherit", lineHeight: 1 }}>›</button>
          {(calMonth !== today.getMonth() || calYear !== today.getFullYear()) && (
            <button type="button" onClick={() => { setCalMonth(today.getMonth()); setCalYear(today.getFullYear()); }}
              style={{ background: "rgba(0,212,255,.1)", border: "1px solid rgba(0,212,255,.3)", color: "var(--c-cyan,#00d4ff)", cursor: "pointer", padding: "2px 8px", borderRadius: 6, fontSize: ".58rem", fontWeight: 700, fontFamily: "inherit" }}>
              {es ? "Hoy" : "Today"}
            </button>
          )}
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: "3px", textAlign: "center" }}>
          {DAYS_SHORT.map(d => <div key={d} style={{ fontSize: ".52rem", fontWeight: 700, color: "var(--c-text3,#45688a)", padding: "2px 0" }}>{d}</div>)}
          {calDays.map((cell, i) => cell === null ? (
            <div key={`e${i}`} />
          ) : (
            <div key={cell.date} style={{
              padding: "4px 2px", borderRadius: 6, fontSize: ".6rem", fontWeight: cell.isToday ? 800 : 600, position: "relative",
              background: cell.isToday ? "rgba(0,212,255,.15)" : cell.hours > 0 ? "rgba(0,255,136,.08)" : cell.noActivity ? "rgba(239,68,68,.06)" : "transparent",
              border: cell.isToday ? "1px solid rgba(0,212,255,.4)" : cell.hours > 0 ? "1px solid rgba(0,255,136,.2)" : cell.noActivity ? "1px solid rgba(239,68,68,.15)" : "1px solid transparent",
              color: cell.isToday ? "var(--c-cyan,#00d4ff)" : cell.hours > 0 ? "var(--c-green,#00ff88)" : cell.noActivity ? "#ef4444" : cell.isWeekend ? "var(--c-text3,#45688a)" : "var(--c-text2,#7aa3c0)",
            }}>
              {cell.day}
              {cell.hours > 0 && <div style={{ fontSize: ".42rem", fontWeight: 700, color: "var(--c-green,#00ff88)", marginTop: 1 }}>{cell.hours.toFixed(1)}h</div>}
              {cell.noActivity && <div style={{ fontSize: ".42rem", color: "#ef4444", marginTop: 1 }}>--</div>}
            </div>
          ))}
        </div>
        <div style={{ display: "flex", gap: ".75rem", justifyContent: "center", marginTop: ".55rem", fontSize: ".52rem", color: "var(--c-text3,#45688a)" }}>
          <span><span style={{ display: "inline-block", width: 8, height: 8, borderRadius: 2, background: "rgba(0,255,136,.2)", marginRight: 3, verticalAlign: "middle" }} />{es ? "Activo" : "Active"}</span>
          <span><span style={{ display: "inline-block", width: 8, height: 8, borderRadius: 2, background: "rgba(239,68,68,.15)", marginRight: 3, verticalAlign: "middle" }} />{es ? "Sin actividad" : "No activity"}</span>
          <span><span style={{ display: "inline-block", width: 8, height: 8, borderRadius: 2, background: "rgba(0,212,255,.3)", marginRight: 3, verticalAlign: "middle" }} />{es ? "Hoy" : "Today"}</span>
        </div>
      </div>

      {/* DRILL-DOWN BANNER — which teammate you're looking at + a way back */}
      {selectedMember && (
        <div style={{ display: "flex", alignItems: "center", gap: ".65rem", background: "var(--c-surface2,#112538)", border: "1px solid rgba(0,212,255,.25)", borderRadius: 10, padding: ".55rem .75rem", marginBottom: ".75rem" }}>
          <button type="button" onClick={() => setUserFilter("team")}
            style={{ display: "flex", alignItems: "center", gap: 4, background: "var(--c-surface3,#162d44)", border: "1px solid var(--c-border,#1a3550)", color: "var(--c-text2,#7aa3c0)", fontSize: ".72rem", fontWeight: 700, padding: ".35rem .7rem", borderRadius: 8, cursor: "pointer", fontFamily: "inherit" }}>
            ← {tt.backToTeam}
          </button>
          <div style={{ width: 28, height: 28, borderRadius: "50%", background: selectedMember.color, display: "flex", alignItems: "center", justifyContent: "center", fontSize: ".58rem", fontWeight: 800, color: "#fff", flexShrink: 0 }}>{selectedMember.initials}</div>
          <span style={{ fontSize: ".78rem", color: "var(--c-text3,#45688a)", fontWeight: 600 }}>
            {tt.viewingMember} <span style={{ color: "var(--c-white,#eef6ff)", fontWeight: 800 }}>{selectedMember.name}</span>
          </span>
        </div>
      )}

      {/* FILTERS */}
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: ".75rem", flexWrap: "wrap", gap: ".5rem" }}>
        <div style={{ display: "flex", gap: ".35rem" }}>
          {[
            { id: "week", label: tt.week },
            { id: "month", label: tt.month },
            { id: "all", label: tt.all },
          ].map(p => (
            <button type="button" key={p.id} onClick={() => setPeriodFilter(p.id)}
              style={{ padding: ".3rem .7rem", borderRadius: 100, border: `1px solid ${periodFilter === p.id ? "rgba(0,212,255,.4)" : "var(--c-border,#1a3550)"}`, background: periodFilter === p.id ? "var(--c-cyan-dim)" : "transparent", color: periodFilter === p.id ? "var(--c-cyan,#00d4ff)" : "var(--c-text3,#45688a)", fontSize: ".7rem", fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}>
              {p.label}
            </button>
          ))}
        </div>
        {isOwner && (
          <div style={{ display: "flex", gap: ".35rem" }}>
            <button type="button" onClick={() => setUserFilter("me")}
              style={{ padding: ".3rem .7rem", borderRadius: 100, border: `1px solid ${userFilter === "me" ? "rgba(0,212,255,.4)" : "var(--c-border,#1a3550)"}`, background: userFilter === "me" ? "var(--c-cyan-dim)" : "transparent", color: userFilter === "me" ? "var(--c-cyan,#00d4ff)" : "var(--c-text3,#45688a)", fontSize: ".7rem", fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}>
              {tt.myHours}
            </button>
            <button type="button" onClick={() => setUserFilter("team")}
              style={{ padding: ".3rem .7rem", borderRadius: 100, border: `1px solid ${userFilter !== "me" ? "rgba(0,212,255,.4)" : "var(--c-border,#1a3550)"}`, background: userFilter !== "me" ? "var(--c-cyan-dim)" : "transparent", color: userFilter !== "me" ? "var(--c-cyan,#00d4ff)" : "var(--c-text3,#45688a)", fontSize: ".7rem", fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}>
              👥 {tt.byTeam}
            </button>
          </div>
        )}
      </div>

      {/* TOTAL for filtered view */}
      <div style={{ background: "var(--c-surface2,#112538)", border: "1px solid var(--c-border,#1a3550)", borderRadius: 10, padding: ".65rem 1rem", marginBottom: ".75rem", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <span style={{ fontSize: ".75rem", fontWeight: 700, color: "var(--c-text2,#7aa3c0)" }}>{tt.total} ({periodFilter === "week" ? tt.week : periodFilter === "month" ? tt.month : tt.all})</span>
        <span style={{ fontSize: "1.1rem", fontWeight: 800, color: "var(--c-cyan,#00d4ff)", fontFamily: "var(--font-mono)" }}>{totalHours.toFixed(2)}h</span>
      </div>

      {/* ENTRIES GROUPED BY DATE */}
      {Object.keys(grouped).length === 0 && <div style={{ textAlign: "center", padding: "2rem", color: "var(--c-text3,#45688a)", fontSize: ".82rem" }}>{tt.noEntries}</div>}
      <div style={{ display: "flex", flexDirection: "column", gap: ".65rem" }}>
        {Object.entries(grouped).map(([date, entries]) => {
          const dayTotal = entries.reduce((s, e) => s + (e.hours || 0), 0);
          return (
            <div key={date}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: ".3rem" }}>
                <div style={{ display: "flex", alignItems: "center", gap: ".4rem" }}>
                  <span style={{ fontSize: ".7rem", fontWeight: 800, color: "var(--c-white,#eef6ff)" }}>{fmt(date)}</span>
                  <span style={{ fontSize: ".65rem", color: "var(--c-text3,#45688a)" }}>{dayLabel(date)}</span>
                  {date === todayStr && <span style={{ fontSize: ".5rem", padding: "1px 5px", borderRadius: 100, background: "rgba(0,212,255,.12)", color: "var(--c-cyan,#00d4ff)", fontWeight: 700 }}>{es ? "HOY" : "TODAY"}</span>}
                </div>
                <span style={{ fontSize: ".7rem", fontWeight: 700, color: "var(--c-cyan,#00d4ff)", fontFamily: "var(--font-mono)" }}>{dayTotal.toFixed(2)}h</span>
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: ".3rem" }}>
                {entries.map(entry => {
                  const isMine = entry.userId === currentUser?.id;
                  return (
                    <div key={entry.id} style={{ background: "var(--c-surface2,#112538)", border: `1px solid ${entry.clockOut ? "var(--c-border,#1a3550)" : "rgba(0,255,136,.3)"}`, borderLeft: `3px solid ${entry.clockOut ? "var(--c-cyan,#00d4ff)" : "var(--c-green,#00ff88)"}`, borderRadius: 9, padding: ".55rem .75rem", display: "flex", alignItems: "center", gap: ".65rem" }}>
                      {userFilter === "all" && (
                        <div style={{ width: 26, height: 26, borderRadius: "50%", background: getUserColor(entry.userId), display: "flex", alignItems: "center", justifyContent: "center", fontSize: ".55rem", fontWeight: 800, color: "#fff", flexShrink: 0 }}>{getUserInitials(entry.userId)}</div>
                      )}
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ display: "flex", alignItems: "center", gap: ".5rem", flexWrap: "wrap" }}>
                          <span style={{ fontSize: ".82rem", fontWeight: 700, fontFamily: "var(--font-mono)", color: "var(--c-white,#eef6ff)" }}>
                            {entry.clockIn} → {entry.clockOut || <span style={{ color: "var(--c-green,#00ff88)", fontSize: ".72rem" }}>⏳ {es ? "en progreso" : "in progress"}</span>}
                          </span>
                          {entry.hours != null && (
                            <span style={{ fontSize: ".72rem", fontWeight: 800, color: "var(--c-cyan,#00d4ff)", fontFamily: "var(--font-mono)", background: "var(--c-cyan-dim)", padding: "1px 8px", borderRadius: 5 }}>{entry.hours.toFixed(2)}h</span>
                          )}
                          {userFilter === "all" && <span style={{ fontSize: ".65rem", color: "var(--c-text3,#45688a)" }}>{getUserName(entry.userId)}</span>}
                        </div>
                        {entry.notes && <div style={{ fontSize: ".68rem", color: "var(--c-text3,#45688a)", marginTop: 2 }}>📝 {entry.notes}</div>}
                      </div>
                      {isOwner && (
                        // Owner/agent only — a seat must NEVER delete time
                        // (they could erase their own worked hours). Open
                        // rows are deletable too so the owner can clear
                        // orphaned "in progress" sessions (pre-#182 dup
                        // pile, or a tab closed before the idle clock-out).
                        <button type="button" onClick={async () => { if (await confirmDialog(es ? "¿Eliminar entrada?" : "Delete entry?")) deleteEntry(entry.id); }}
                          style={{ background: "none", border: "1px solid var(--c-border,#1a3550)", color: "var(--c-text3,#45688a)", cursor: "pointer", padding: "3px 6px", borderRadius: 6, lineHeight: 0 }}><Trash2 size={11} /></button>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>

      {/* Weekly summary bar chart */}
      {periodFilter === "week" && (() => {
        const ws = new Date(today);
        ws.setDate(ws.getDate() - ws.getDay());
        const days = [];
        for (let i = 0; i < 7; i++) {
          const d = new Date(ws); d.setDate(d.getDate() + i);
          const ds = localDay(d);
          const dayHrs = timelog.filter(e => e.date === ds && e.userId === viewedUserId && e.hours).reduce((s, e) => s + (e.hours || 0), 0);
          days.push({ date: ds, dayName: DAYS_SHORT[i], hours: dayHrs, isToday: ds === todayStr });
        }
        const maxH = Math.max(...days.map(d => d.hours), 1);
        const weekTotal = days.reduce((s, d) => s + d.hours, 0);
        return (
          <div style={{ marginTop: "1.25rem", background: "var(--c-surface2,#112538)", border: "1px solid var(--c-border,#1a3550)", borderRadius: 12, padding: "1rem" }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: ".6rem" }}>
              <span style={{ fontSize: ".65rem", color: "var(--c-text3,#45688a)", fontWeight: 700, textTransform: "uppercase", letterSpacing: ".08em", fontFamily: "var(--font-mono)" }}>📊 {tt.week}</span>
              <span style={{ fontSize: ".75rem", fontWeight: 800, color: "var(--c-cyan,#00d4ff)", fontFamily: "var(--font-mono)" }}>{weekTotal.toFixed(1)}h {es ? "total" : "total"}</span>
            </div>
            <div style={{ display: "flex", alignItems: "flex-end", gap: ".4rem", height: 100 }}>
              {days.map(d => (
                <div key={d.date} style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", gap: 3 }}>
                  <span style={{ fontSize: ".58rem", fontWeight: 700, color: d.hours > 0 ? "var(--c-cyan,#00d4ff)" : "transparent", fontFamily: "var(--font-mono)" }}>{d.hours > 0 ? d.hours.toFixed(1) : "·"}</span>
                  <div style={{ width: "100%", maxWidth: 32, background: d.isToday ? "var(--c-cyan,#00d4ff)" : d.hours > 0 ? "rgba(0,255,136,.3)" : "var(--c-surface3,#162d44)", borderRadius: "4px 4px 0 0", height: Math.max(4, (d.hours / maxH) * 80), transition: "height .3s", border: d.isToday ? "none" : d.hours > 0 ? "1px solid rgba(0,255,136,.2)" : "1px solid var(--c-border,#1a3550)" }} />
                  <span style={{ fontSize: ".58rem", fontWeight: d.isToday ? 800 : 500, color: d.isToday ? "var(--c-cyan,#00d4ff)" : "var(--c-text3,#45688a)" }}>{d.dayName}</span>
                </div>
              ))}
            </div>
          </div>
        );
      })()}

      {/* MANUAL ENTRY MODAL */}
      {showManual && (
        <div style={{ position: "fixed", inset: 0, zIndex: 9999, background: "rgba(0,0,0,.85)", display: "flex", alignItems: "center", justifyContent: "center", padding: "1rem" }}>
          <div style={{ background: "var(--c-surface,#0d1c2e)", border: "1px solid var(--c-border,#1a3550)", borderRadius: 14, padding: "1.5rem", maxWidth: 420, width: "100%" }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "1rem" }}>
              <div style={{ fontWeight: 800, fontSize: "1rem", color: "var(--c-white,#eef6ff)" }}>⏱️ {tt.addManual}</div>
              <button type="button" onClick={() => setShowManual(false)} style={{ background: "none", border: "none", cursor: "pointer", color: "var(--c-text3,#45688a)" }}><X size={18} /></button>
            </div>
            <div style={{ marginBottom: ".65rem" }}>
              <label style={{ fontSize: ".65rem", color: "var(--c-text3,#45688a)", fontWeight: 700, textTransform: "uppercase", letterSpacing: ".08em", display: "block", marginBottom: 4 }}>{tt.date}</label>
              <DateField className="dkt-inp" value={manualForm.date} onChange={e => setManualForm(p => ({ ...p, date: e.target.value }))} style={{ width: "100%", boxSizing: "border-box" }} />
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: ".65rem", marginBottom: ".65rem" }}>
              <div>
                <label style={{ fontSize: ".65rem", color: "var(--c-text3,#45688a)", fontWeight: 700, textTransform: "uppercase", letterSpacing: ".08em", display: "block", marginBottom: 4 }}>{tt.start}</label>
                <input type="time" className="dkt-inp" value={manualForm.clockIn} onChange={e => setManualForm(p => ({ ...p, clockIn: e.target.value }))} style={{ width: "100%", boxSizing: "border-box" }} />
              </div>
              <div>
                <label style={{ fontSize: ".65rem", color: "var(--c-text3,#45688a)", fontWeight: 700, textTransform: "uppercase", letterSpacing: ".08em", display: "block", marginBottom: 4 }}>{tt.end}</label>
                <input type="time" className="dkt-inp" value={manualForm.clockOut} onChange={e => setManualForm(p => ({ ...p, clockOut: e.target.value }))} style={{ width: "100%", boxSizing: "border-box" }} />
              </div>
            </div>
            <div style={{ marginBottom: ".75rem" }}>
              <label style={{ fontSize: ".65rem", color: "var(--c-text3,#45688a)", fontWeight: 700, textTransform: "uppercase", letterSpacing: ".08em", display: "block", marginBottom: 4 }}>{tt.notes}</label>
              <input className="dkt-inp" value={manualForm.notes} onChange={e => setManualForm(p => ({ ...p, notes: e.target.value }))} placeholder={es ? "Ej: Llamadas a clientes" : "E.g.: Client calls"} style={{ width: "100%", boxSizing: "border-box" }} />
            </div>
            <div style={{ display: "flex", gap: ".5rem", justifyContent: "flex-end" }}>
              <button type="button" onClick={() => setShowManual(false)} className="dkt-btn-s">{es ? "Cancelar" : "Cancel"}</button>
              <button type="button" onClick={addManual}
                style={{ display: "flex", alignItems: "center", gap: 5, background: "linear-gradient(135deg,#0099cc,#0055aa)", border: "none", color: "#fff", fontSize: ".78rem", fontWeight: 700, padding: ".5rem 1.2rem", borderRadius: 9, cursor: "pointer", fontFamily: "inherit" }}>
                <Save size={13} />{es ? "Guardar" : "Save"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
// ActivityLogView moved to ./crm-app/components/ClientDetail.jsx (imported above)
/* ─── My Profile View ─── */
// Downscale an uploaded profile photo to a small data URL (longest side capped
// at 256px, JPEG 0.85). Keeps the stored image tiny since it now rides along on
// every chat message author. Falls back to the original on any canvas error.
function downscaleProfilePhoto(file, onDone) {
  const MAX = 256;
  const reader = new FileReader();
  reader.onload = (ev) => {
    const src = ev.target?.result;
    const img = new Image();
    img.onload = () => {
      try {
        let { width, height } = img;
        if (width > MAX || height > MAX) {
          const scale = MAX / Math.max(width, height);
          width = Math.round(width * scale);
          height = Math.round(height * scale);
        }
        const canvas = document.createElement("canvas");
        canvas.width = width; canvas.height = height;
        canvas.getContext("2d").drawImage(img, 0, 0, width, height);
        const type = file.type === "image/png" ? "image/png" : "image/jpeg";
        onDone(canvas.toDataURL(type, 0.85));
      } catch { onDone(src); }
    };
    img.onerror = () => onDone(src);
    img.src = src;
  };
  reader.readAsDataURL(file);
}

/* ─── Agent social profiles ───
   Lissette 2026-08-09: "en el perfil de los agentes poder colocarle redes
   sociales instagram facebook linkedin tiktok con sus iconos y que tambien
   salgan en la firma".

   This list mirrors deskte-api/src/utils/socialLinks.ts field for field — same
   keys, same handle bases, same order. The backend renders the SAME networks
   into outgoing mail (as hosted PNGs, since Gmail strips inline SVG), so a
   network added on one side has to be added on the other or the profile card
   and the signature stop agreeing.

   Glyph outlines: Simple Icons (CC0). LinkedIn's "in" is inlined because
   Simple Icons no longer ships it. */
const SOCIAL_NETWORKS = [
  {
    key: "instagram", field: "instagramUrl", label: "Instagram",
    handleBase: "https://www.instagram.com/", color: "#D62976", placeholder: "@usuario",
    path: "M7.0301.084c-1.2768.0602-2.1487.264-2.911.5634-.7888.3075-1.4575.72-2.1228 1.3877-.6652.6677-1.075 1.3368-1.3802 2.127-.2954.7638-.4956 1.6365-.552 2.914-.0564 1.2775-.0689 1.6882-.0626 4.947.0062 3.2586.0206 3.6671.0825 4.9473.061 1.2765.264 2.1482.5635 2.9107.308.7889.72 1.4573 1.388 2.1228.6679.6655 1.3365 1.0743 2.1285 1.38.7632.295 1.6361.4961 2.9134.552 1.2773.056 1.6884.069 4.9462.0627 3.2578-.0062 3.668-.0207 4.9478-.0814 1.28-.0607 2.147-.2652 2.9098-.5633.7889-.3086 1.4578-.72 2.1228-1.3881.665-.6682 1.0745-1.3378 1.3795-2.1284.2957-.7632.4966-1.636.552-2.9124.056-1.2809.0692-1.6898.063-4.948-.0063-3.2583-.021-3.6668-.0817-4.9465-.0607-1.2797-.264-2.1487-.5633-2.9117-.3084-.7889-.72-1.4568-1.3876-2.1228C21.2982 1.33 20.628.9208 19.8378.6165 19.074.321 18.2017.1197 16.9244.0645 15.6471.0093 15.236-.005 11.977.0014 8.718.0076 8.31.0215 7.0301.0839m.1402 21.6932c-1.17-.0509-1.8053-.2453-2.2287-.408-.5606-.216-.96-.4771-1.3819-.895-.422-.4178-.6811-.8186-.9-1.378-.1644-.4234-.3624-1.058-.4171-2.228-.0595-1.2645-.072-1.6442-.079-4.848-.007-3.2037.0053-3.583.0607-4.848.05-1.169.2456-1.805.408-2.2282.216-.5613.4762-.96.895-1.3816.4188-.4217.8184-.6814 1.3783-.9003.423-.1651 1.0575-.3614 2.227-.4171 1.2655-.06 1.6447-.072 4.848-.079 3.2033-.007 3.5835.005 4.8495.0608 1.169.0508 1.8053.2445 2.228.408.5608.216.96.4754 1.3816.895.4217.4194.6816.8176.9005 1.3787.1653.4217.3617 1.056.4169 2.2263.0602 1.2655.0739 1.645.0796 4.848.0058 3.203-.0055 3.5834-.061 4.848-.051 1.17-.245 1.8055-.408 2.2294-.216.5604-.4763.96-.8954 1.3814-.419.4215-.8181.6811-1.3783.9-.4224.1649-1.0577.3617-2.2262.4174-1.2656.0595-1.6448.072-4.8493.079-3.2045.007-3.5825-.006-4.848-.0608M16.953 5.5864A1.44 1.44 0 1 0 18.39 4.144a1.44 1.44 0 0 0-1.437 1.4424M5.8385 12.012c.0067 3.4032 2.7706 6.1557 6.173 6.1493 3.4026-.0065 6.157-2.7701 6.1506-6.1733-.0065-3.4032-2.771-6.1565-6.174-6.1498-3.403.0067-6.156 2.771-6.1496 6.1738M8 12.0077a4 4 0 1 1 4.008 3.9921A3.9996 3.9996 0 0 1 8 12.0077",
  },
  {
    key: "facebook", field: "facebookUrl", label: "Facebook",
    handleBase: "https://www.facebook.com/", color: "#1877F2", placeholder: "@pagina",
    path: "M9.101 23.691v-7.98H6.627v-3.667h2.474v-1.58c0-4.085 1.848-5.978 5.858-5.978.401 0 .955.042 1.468.103a8.68 8.68 0 0 1 1.141.195v3.325a8.623 8.623 0 0 0-.653-.036 26.805 26.805 0 0 0-.733-.009c-.707 0-1.259.096-1.675.309a1.686 1.686 0 0 0-.679.622c-.258.42-.374.995-.374 1.752v1.297h3.919l-.386 2.103-.287 1.564h-3.246v8.245C19.396 23.238 24 18.179 24 12.044c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.628 3.874 10.35 9.101 11.647Z",
  },
  {
    key: "linkedin", field: "linkedinUrl", label: "LinkedIn",
    handleBase: "https://www.linkedin.com/in/", color: "#0A66C2", placeholder: "usuario",
    path: "M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zM7.119 20.452H3.555V9h3.564v11.452z",
  },
  {
    key: "tiktok", field: "tiktokUrl", label: "TikTok",
    handleBase: "https://www.tiktok.com/@", color: "#000000", placeholder: "@usuario",
    path: "M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z",
  },
];

// Mirror of normalizeSocialUrl() in deskte-api/src/utils/socialLinks.ts. The
// value that gets STORED is normalized by the backend on save; this copy exists
// so the card and signature previews follow along while the agent is still
// typing. Keep the two in step — same rules, same rejections.
function normalizeSocialUrl(network, raw) {
  let v = String(raw ?? "").trim();
  if (!v) return null;
  v = v.replace(/^@+/, "");
  if (!v || /[\s<>"']/.test(v)) return null;

  const scheme = /^([a-z][a-z0-9+.-]*):/i.exec(v);
  if (scheme) {
    // Never let a javascript:/data: value become an href on the card.
    if (!/^https?$/i.test(scheme[1])) return null;
  } else if (/^(www\.)?[a-z0-9-]+(\.[a-z0-9-]+)+([/?#]|$)/i.test(v)) {
    v = "https://" + v;
  } else {
    const handle = v.replace(/^\/+/, "").replace(/[^A-Za-z0-9._-]/g, "");
    if (!handle) return null;
    v = network.handleBase + handle;
  }

  try {
    const u = new URL(v);
    if (u.protocol !== "http:" && u.protocol !== "https:") return null;
    const out = u.toString();
    return out.length > 300 ? null : out;
  } catch { return null; }
}

/** The networks `src` actually filled in, resolved to real URLs, in order. */
function socialLinksOf(src) {
  return SOCIAL_NETWORKS
    .map(network => ({ network, url: normalizeSocialUrl(network, src?.[network.field]) }))
    .filter(l => l.url);
}

// The brand tile: white glyph on the network color, matching the PNG the
// backend serves at /assets/social/<key>.png so the on-screen preview and the
// received email look the same. Instagram's gradient id is shared across
// instances on purpose — every copy defines it identically.
function SocialIcon({ network, size = 22 }) {
  const isIg = network.key === "instagram";
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" role="img" aria-label={network.label} focusable="false" style={{ display: "block" }}>
      {isIg && (
        <defs>
          <linearGradient id="dkt-social-ig" x1="0" y1="1" x2="1" y2="0">
            <stop offset="0%" stopColor="#FEDA75" />
            <stop offset="25%" stopColor="#FA7E1E" />
            <stop offset="55%" stopColor="#D62976" />
            <stop offset="80%" stopColor="#962FBF" />
            <stop offset="100%" stopColor="#4F5BD5" />
          </linearGradient>
        </defs>
      )}
      <rect width="48" height="48" rx="11" ry="11" fill={isIg ? "url(#dkt-social-ig)" : network.color} />
      <g transform="translate(10 10) scale(1.16667)"><path d={network.path} fill="#ffffff" /></g>
    </svg>
  );
}

/** Clickable icon row. Renders nothing when no network is set. */
function SocialIconRow({ source, size = 22, gap = 8, style }) {
  const links = socialLinksOf(source);
  if (!links.length) return null;
  return (
    <div style={{ display: "flex", alignItems: "center", gap, flexWrap: "wrap", ...style }}>
      {links.map(({ network, url }) => (
        <a key={network.key} href={url} target="_blank" rel="noopener noreferrer" title={network.label}
          style={{ display: "inline-flex", lineHeight: 0, textDecoration: "none" }}>
          <SocialIcon network={network} size={size} />
        </a>
      ))}
    </div>
  );
}

// Cupo anual de firmas electrónicas y solicitudes de documentos (Lissette
// 2026-08-07: "quieren saber cuántas tiene, cuántas usadas", con aviso al
// quedar 10). El cupo vivía en Agency.eSignaturesYear / docRequestsYear desde
// el alta pero nadie lo leía: no había conteo ni tope en ninguna parte, así
// que el número era decorativo. GET /agencies/me/usage lo cuenta ahora.
//
// Solo informa. Que el sistema IMPIDA pasarse del tope es una decisión de
// negocio aparte, que Lissette toma con estos números a la vista.
function AgencyUsagePanel({ lang }) {
  const es = lang === "es";
  const [usage, setUsage] = useState(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    let cancelled = false;
    if (!(typeof window !== "undefined" && window.__deskteAuth)) return;
    import("./crm-app/api.js")
      .then(({ getAgencyUsage }) => getAgencyUsage())
      .then((d) => { if (!cancelled) setUsage(d); })
      // Sin datos NO se pinta nada. Un "0 de 0" sería peor que el silencio:
      // parecería que se agotó el cupo.
      .catch(() => { if (!cancelled) setFailed(true); });
    return () => { cancelled = true; };
  }, []);
  if (failed || !usage) return null;

  const ALERT_AT = 10; // Lissette: avisar cuando queden 10.
  // Los clientes se avisan mucho antes: cuando se acaban no es "pide otro
  // pack", es una importacion de 300 filas que se cae a la mitad. Con 50 de
  // margen todavia hay tiempo de comprar la ampliacion antes de subir nada.
  const ALERT_AT_CLIENTS = 50;
  const Row = ({ icon, label, q, alertAt = ALERT_AT, cta }) => {
    // limit <= 0 = sin límite (las agencias demo llevan 999999, y un plan sin
    // tope no debe mostrar una barra llena ni un aviso).
    if (!q || q.limit <= 0) return null;
    const pct = Math.min(100, Math.round((q.used / q.limit) * 100));
    const low = q.remaining <= alertAt;
    const out = q.remaining === 0;
    const color = out ? "var(--c-red,#ff5470)" : low ? "var(--c-amber,#ffb800)" : "var(--c-cyan,#00d4ff)";
    return (
      <div style={{ marginBottom: ".7rem" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", fontSize: ".78rem", marginBottom: ".3rem" }}>
          <span style={{ color: "var(--c-text,#c8dff0)", fontWeight: 600 }}>{icon} {label}</span>
          <span style={{ color, fontWeight: 800 }}>
            {q.used} {es ? "de" : "of"} {q.limit}
          </span>
        </div>
        <div style={{ height: 6, borderRadius: 4, background: "var(--c-bg3,#132741)", overflow: "hidden" }}>
          <div style={{ width: pct + "%", height: "100%", background: color, transition: "width .3s" }} />
        </div>
        {low && (
          <div style={{ marginTop: ".35rem", fontSize: ".74rem", fontWeight: 700, color }}>
            {out
              ? (es ? "⚠️ Se acabaron. " : "⚠️ None left. ")
              : (es ? `⚠️ Te quedan ${q.remaining}. ` : `⚠️ ${q.remaining} left. `)}
            {cta || (es ? "Contacta a Deskte para agregar más." : "Contact Deskte to add more.")}
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="dkt-card" style={{ padding: ".9rem 1rem" }}>
      <div style={{ fontWeight: 800, fontSize: ".82rem", color: "var(--c-white,#eef6ff)", marginBottom: ".6rem" }}>
        {es ? "Tu cupo" : "Your allowance"}
      </div>

      {/* Clientes va primero y con su propia nota: es el unico de los tres que
          NO se reinicia el 1 de enero, y ponerlo bajo el titulo de "este ano"
          seria mentir. Hasta el 2026-09-07 no se veia en ninguna pantalla del
          CRM y el agente importaba sin saber cuanto le cabia. */}
      <Row
        icon="👥" label={es ? "Clientes" : "Clients"} q={usage.clients} alertAt={ALERT_AT_CLIENTS}
        cta={es
          ? "Agrega el pack de +1.000 clientes desde Facturación → Add-ons."
          : "Add the +1,000 clients pack from Billing → Add-ons."}
      />
      {usage.clients?.limit > 0 && (
        <div style={{ fontSize: ".68rem", color: "var(--c-text3,#45688a)", marginTop: "-.4rem", marginBottom: ".8rem" }}>
          {es ? "Tu total de cartera. No se reinicia nunca." : "Your whole book. It never resets."}
        </div>
      )}

      {/* Las fechas REALES del ciclo, que vienen del servidor. Antes decia "el
          1 de enero" a secas; desde el 2026-09-07 el ano cuenta desde el dia
          que la agencia empezo a pagar, y cada una tiene el suyo. Escribirlo
          aqui a mano volveria a mentirle a la mayoria. */}
      <div style={{ fontSize: ".72rem", color: "var(--c-text3,#45688a)", marginBottom: ".5rem" }}>
        {usage.cycleStartLabel && usage.cycleEndLabel
          ? (es
              ? `Tu año — del ${usage.cycleStartLabel} al ${usage.cycleEndLabel}.`
              : `Your year — ${usage.cycleStartLabel} to ${usage.cycleEndLabel}.`)
          : (es ? "Tu año de cupo." : "Your allowance year.")}
      </div>
      <Row icon="✍️" label={es ? "Firmas electrónicas" : "E-signatures"} q={usage.signatures} />
      <Row icon="📄" label={es ? "Solicitudes de documentos" : "Document requests"} q={usage.docRequests} />
    </div>
  );
}

function MyProfileView({ currentUser, onSave, users, lang, userPrefs, onPrefsChange, agencyCollaborators = [], onCollaboratorsChange, initialTab, nameOrder, onNameOrderChange, puedeEditarOrdenDelNombre = false,
  // Los plazos de aviso NO son de esta persona: son de la agencia, y por
  // eso entran y salen por su propia puerta en vez de por `userPrefs`
  // (Lissette 2026-08-28). `puedeEditarPlazos` decide si el panel se deja
  // tocar; se ve siempre.
  alertLead = {}, alertLeadByType = {}, onAlertLeadChange, onAlertLeadByTypeChange, puedeEditarPlazos = false }) {
  const es = lang === "es";
  const isAssistant = currentUser?.role === "assistant";
  const parentAgent = isAssistant && currentUser.parentAgentId ? users.find(u => u.id === currentUser.parentAgentId) : null;
  const [f, setF] = useState({ ...currentUser });
  // Baseline for "what did the user actually change" (Lissette 2026-08-07:
  // "le doy en perfil save para guardar nombre de la compañía y se borra todo
  // lo que tenía el perfil"). `f` is snapshotted ONCE at mount, and the profile
  // arrives progressively at login — so opening this screen early captured a
  // half-empty copy. GET /auth/me sends absent fields as `null`, NOT undefined,
  // and JSON.stringify keeps null, so the old save posted `bio: null`,
  // `website: null`… and the backend's `if (body.x !== undefined)` guards let
  // every one of those nulls through. Saving one field overwrote the rest with
  // blanks. Diffing against this baseline means we only ever send what the user
  // truly touched, so a stale snapshot can no longer clobber anything.
  const baselineRef = useRef({ ...currentUser });
  // Keys the user has edited in this session — they must survive a re-sync.
  const dirtyRef = useRef(new Set());
  // The profile keeps loading after mount. Adopt newly-arrived server values
  // for every field the user has NOT touched, so the form shows the truth and
  // the baseline stays honest.
  useEffect(() => {
    if (!currentUser) return;
    baselineRef.current = { ...currentUser };
    setF((prev) => {
      const next = { ...currentUser };
      for (const k of dirtyRef.current) next[k] = prev[k];
      return next;
    });
  }, [currentUser]);
  const set = (k, v) => { dirtyRef.current.add(k); setF(p => ({ ...p, [k]: v })); };
  // Build the payload from CHANGED keys only. `id` always rides along because
  // the parent's onSave keys its local merge off it.
  const changedOnly = (src) => {
    const base = baselineRef.current || {};
    const out = { id: src.id };
    for (const k of Object.keys(src)) {
      if (k === 'id') continue;
      if (!Object.is(src[k], base[k])) out[k] = src[k];
    }
    return out;
  };
  const [saved, setSaved] = useState(false);
  const [logoPreview, setLogoPreview] = useState(currentUser?.companyLogo || "");
  const [shareOpen, setShareOpen] = useState(false);
  // El correo tal cual lo recibe el cliente, en grande (Lissette 2026-09-23:
  // "lo importante no es el logo, es cómo queda en general la firma que ve el
  // cliente"). Lo arma el servidor; ver la ventana más abajo.
  const [vistaCorreo, setVistaCorreo] = useState(false);
  const [correoDeMuestra, setCorreoDeMuestra] = useState({ html: "", cargando: false, error: "", sinRemitente: false });
  const [shareMsg, setShareMsg] = useState("");
  const [avatarPickerOpen, setAvatarPickerOpen] = useState(false);

  const handleLogoUpload = (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (ev) => { const data = ev.target.result; set("companyLogo", data); setLogoPreview(data); };
    reader.readAsDataURL(file);
  };

  // Quitar el logo del perfil (Lissette 2026-09-23: "se agrega logo pero no
  // tiene un botón de eliminarlo"). Se guarda EN EL ACTO, como la foto: un
  // "Quitar" que además pide pulsar Guardar parece no haber hecho nada. Y va
  // `null`, no "": el servidor lo guarda tal cual y vacío es "no hay logo".
  const quitarLogo = async () => {
    if (!(await confirmDialog({ message: es ? "¿Quitar el logo de tu perfil? Deja de salir en tu firma y en tu tarjeta." : "Remove your profile logo? It will stop showing in your signature and card.", danger: true }))) return;
    setF(prev => ({ ...prev, companyLogo: null }));
    setLogoPreview("");
    onSave({ id: f.id, companyLogo: null });
    baselineRef.current = { ...baselineRef.current, companyLogo: null };
    dirtyRef.current.delete("companyLogo");
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);
  };

  const save = () => {
    // Only what changed — never the whole snapshot. See baselineRef above.
    onSave(changedOnly(f));
    baselineRef.current = { ...baselineRef.current, ...f };
    dirtyRef.current = new Set();
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);
  };

  // Avatar/photo changes persist immediately — picking an avatar or uploading a
  // photo without then pressing "Save" used to be lost on refresh. This updates
  // local state AND fires the same onSave the Save button uses, so it's written
  // to the server right away (and reflected in the sidebar/chat).
  const applyProfilePhoto = (url) => {
    setF(prev => ({ ...prev, profilePhoto: url }));
    // Send ONLY the photo. This used to post `{...f, profilePhoto}` — the whole
    // snapshot, taken from a render closure that could already be a step behind
    // — so picking an avatar could blank out fields the same way Save did.
    onSave({ id: f.id, profilePhoto: url });
    baselineRef.current = { ...baselineRef.current, profilePhoto: url };
    dirtyRef.current.delete('profilePhoto');
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);
  };

  // Effective agent data for signature (assistant uses parent agent's info)
  const agentForSig = isAssistant && parentAgent ? parentAgent : f;
  const companyName = f.companyName || agentForSig.companyName || "";
  const logo = f.companyLogo || agentForSig.companyLogo || "";
  // #4 (Lissette 2026-06-19): a SEAT (assistant) inherits its whole professional
  // identity from the supervising agent — the contact shown on the card +
  // signature is the AGENT's, never the seat's, because everything goes out under
  // the agent. For non-seats these resolve to the user's own fields, so existing
  // behavior is unchanged.
  // El de contacto manda; sin el, el de acceso — que es lo que se hacia antes,
  // asi que una cuenta que no lo rellene no nota ningun cambio.
  const contactEmail = isAssistant
    ? (agentForSig.contactEmail || agentForSig.email || "")
    : (f.contactEmail || f.email || "");
  // El segundo correo y el fijo no tienen respaldo: o están puestos o no salen.
  const contactEmail2 = isAssistant ? (agentForSig.contactEmail2 || "") : (f.contactEmail2 || "");
  const officePhone = isAssistant ? (agentForSig.officePhone || "") : (f.officePhone || "");
  // WhatsApp y fax (Lissette 2026-08-29): misma regla de asiento que los de
  // arriba —lo que sale al cliente es la identidad del agente— y mismo "o
  // están puestos o no salen". Nada cae al móvil si el WhatsApp está vacío.
  const whatsappNumber = isAssistant ? (agentForSig.whatsappNumber || "") : (f.whatsappNumber || "");
  const faxNumber = isAssistant ? (agentForSig.fax || "") : (f.fax || "");
  const contactPhone = isAssistant ? (agentForSig.phone || "") : (f.phone || "");
  const contactWebsite = isAssistant ? (agentForSig.website || "") : (f.website || "");
  const contactLicense = isAssistant ? (agentForSig.licenseStates || "") : (f.licenseStates || "");
  // Social profiles follow the same seat rule as the contacts above: they are
  // the agency's public accounts, so a seat shows (and cannot edit) the
  // supervising agent's. Matches buildAgentSignature on the backend.
  const socialSource = isAssistant ? agentForSig : f;
  const socialLinks = socialLinksOf(socialSource);
  const agentAddrLine = [agentForSig.mailingStreet, [agentForSig.mailingCity, agentForSig.mailingState].filter(Boolean).join(", "), agentForSig.mailingZip].filter(Boolean).join(" · ");

  // El nombre que ve el CLIENTE en la firma. Va por libre desde 2026-08-25:
  // antes era `f.name`, o sea el mismo nombre con el que el agente aparece en
  // todo Deskte, asi que firmar distinto obligaba a renombrarse en el CRM
  // entero. Vacio = el nombre del agente, que es lo de siempre. Tiene que
  // calcularse igual aqui, en la vista previa de abajo y en el servidor
  // (utils/emailSignature.ts) — si los tres no coinciden, el agente ve una
  // cosa y al cliente le llega otra.
  const sigName = ((userPrefs || {}).signatureName || "").trim() || f.name;

  const sigHtml = () => {
    let lines = [];
    if (isAssistant) {
      lines.push(f.title ? `<b>${sigName}</b> | ${f.title}` : `<b>${sigName}</b>`);
    } else {
      lines.push(`<b>${sigName}</b> | ${f.title || "Licensed Insurance Agent"}`);
    }
    // Mismo orden e iconos que la firma que arma el servidor
    // (utils/emailSignature.ts): 📧 correo · 📱 móvil · ☎️ oficina ·
    // 💬 WhatsApp · 📠 fax. Si aquí y allí no coinciden, el agente ve una cosa
    // y al cliente le llega otra — que es exactamente lo que pasó con el
    // correo de contacto.
    {
      const contactos = [
        contactEmail ? `📧 ${contactEmail}` : "",
        contactEmail2 ? `📧 ${contactEmail2}` : "",
        contactPhone ? `📱 ${contactPhone}` : "",
        officePhone ? `☎️ ${officePhone}` : "",
        whatsappNumber ? `💬 ${whatsappNumber}` : "",
        faxNumber ? `📠 ${faxNumber}` : "",
      ].filter(Boolean);
      if (contactos.length) lines.push(contactos.join(" | "));
    }
    if (contactWebsite) lines.push(`🌐 ${contactWebsite}`);
    if (companyName) lines.push(`<b>${companyName}</b>`);
    // The clipboard version is plain text, so the icons become "Network: url" —
    // same lines the backend puts in the text/plain part of the email.
    for (const { network, url } of socialLinks) lines.push(`${network.label}: ${url}`);
    return lines.join("\n");
  };

  const copySig = () => { navigator.clipboard?.writeText(sigHtml().replace(/<[^>]+>/g, "")).catch(() => {}); setSaved(true); setTimeout(() => setSaved(false), 1500); };

  // Shareable business card — excludes NPN by design. Generates a vCard the
  // recipient can save straight to their phone / Outlook contacts, plus a
  // plain-text version for copy / native share.
  const cardName = f.name || "";
  const cardTitle = isAssistant ? (f.title || "") : (f.title || "Licensed Insurance Agent");
  const vcardEsc = (s) => String(s || "").replace(/[\\;,]/g, (m) => "\\" + m).replace(/\n/g, "\\n");
  const buildVCard = () => {
    const parts = cardName.trim().split(/\s+/);
    const first = parts.shift() || cardName;
    const last = parts.join(" ");
    const L = ["BEGIN:VCARD", "VERSION:3.0", `N:${vcardEsc(last)};${vcardEsc(first)};;;`, `FN:${vcardEsc(cardName)}`];
    if (cardTitle) L.push(`TITLE:${vcardEsc(cardTitle)}`);
    if (companyName) L.push(`ORG:${vcardEsc(companyName)}`);
    if (contactPhone) L.push(`TEL;TYPE=CELL:${vcardEsc(contactPhone)}`);
    if (contactEmail) L.push(`EMAIL;TYPE=INTERNET:${vcardEsc(contactEmail)}`);
    if (contactEmail2) L.push(`EMAIL;TYPE=INTERNET:${vcardEsc(contactEmail2)}`);
    if (officePhone) L.push(`TEL;TYPE=WORK,VOICE:${vcardEsc(officePhone)}`);
    if (contactWebsite) L.push(`URL:${vcardEsc(contactWebsite)}`);
    // X-SOCIALPROFILE is what iOS/macOS Contacts reads to fill the social
    // rows; clients that don't know it ignore the line rather than choke.
    for (const { network, url } of socialLinks) {
      L.push(`X-SOCIALPROFILE;TYPE=${network.key}:${vcardEsc(url)}`);
    }
    const note = [];
    if (contactLicense) note.push((es ? "Licencias: " : "Licensed: ") + contactLicense);
    if (f.bio) note.push(f.bio);
    if (note.length) L.push(`NOTE:${vcardEsc(note.join(" — "))}`);
    L.push("END:VCARD");
    // Salto de linea FINAL. El formato lo exige (RFC 6350) y los lectores
    // estrictos —Contactos de Windows entre ellos— rechazan el archivo entero
    // si la ultima linea se queda sin cerrar. Un `join` no lo pone.
    return L.join("\r\n") + "\r\n";
  };
  const cardText = () => {
    const L = [cardName];
    if (cardTitle) L.push(cardTitle);
    if (companyName) L.push(companyName);
    if (contactPhone) L.push((es ? "Tel: " : "Phone: ") + contactPhone);
    if (contactEmail) L.push("Email: " + contactEmail);
    if (contactEmail2) L.push("Email 2: " + contactEmail2);
    if (officePhone) L.push((lang==="es"?"Oficina: ":"Office: ") + officePhone);
    if (contactWebsite) L.push("Web: " + contactWebsite);
    if (contactLicense) L.push((es ? "Licencias: " : "Licensed: ") + contactLicense);
    for (const { network, url } of socialLinks) L.push(`${network.label}: ${url}`);
    return L.join("\n");
  };
  const cardFileName = (cardName || "contacto").replace(/[^a-z0-9]+/gi, "_") + ".vcf";
  const downloadVCard = () => {
    try {
      // Con BOM (\uFEFF) delante. Sin el, Contactos de Windows lee el archivo
      // como si fuera de su idioma local y una tilde lo tumba: la tarjeta se
      // descarga bien y al abrirla no pasa nada, o sale el nombre roto.
      // Aqui SIEMPRE hay acentos —nombres, "Licencias:", el nombre de la
      // agencia—, asi que no es un caso raro: es el caso normal
      // (Lissette, 2026-08-26: "le doy compartir, la descargo, pero no me abre").
      const blob = new Blob(["\uFEFF" + buildVCard()], { type: "text/vcard;charset=utf-8" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url; a.download = cardFileName;
      document.body.appendChild(a); a.click(); a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
      setShareMsg(es ? "Contacto descargado" : "Contact downloaded");
      setTimeout(() => setShareMsg(""), 1800);
    } catch {}
  };
  const copyCardText = () => { navigator.clipboard?.writeText(cardText()).catch(() => {}); setShareMsg(es ? "¡Copiado!" : "Copied!"); setTimeout(() => setShareMsg(""), 1500); };
  const canNativeShare = typeof navigator !== "undefined" && !!navigator.share;
  const nativeShareCard = async () => {
    const text = cardText();
    // Native share is great on phones (and the Windows share sheet), but it
    // silently no-ops or throws on many desktop browsers. Try it first, then
    // always fall back to copying so the button never appears to "do nothing".
    if (typeof navigator !== "undefined" && navigator.share) {
      try {
        const file = new File([buildVCard()], cardFileName, { type: "text/vcard" });
        if (navigator.canShare && navigator.canShare({ files: [file] })) {
          await navigator.share({ files: [file], title: cardName, text });
        } else {
          await navigator.share({ title: cardName, text });
        }
        return;
      } catch (e) {
        if (e && e.name === "AbortError") return; // user dismissed the share sheet — fine
        // any other failure → fall through to the copy fallback below
      }
    }
    try { await navigator.clipboard?.writeText(text); } catch {}
    setShareMsg(es ? "Datos copiados — pégalos donde quieras 📋" : "Details copied — paste anywhere 📋");
    setTimeout(() => setShareMsg(""), 2400);
  };

  const S = {
    inp: { width: "100%", background: "var(--c-surface2,#112538)", border: "1px solid var(--c-border,#1a3550)", borderRadius: 8, padding: "8px 12px", color: "var(--c-white,#eef6ff)", fontSize: ".8rem", outline: "none", boxSizing: "border-box" },
    lbl: { fontSize: ".68rem", color: "var(--c-text3,#45688a)", display: "block", marginBottom: 3, fontWeight: 600 },
    section: { background: "var(--c-surface2,#112538)", border: "1px solid var(--c-border,#1a3550)", borderRadius: 12, padding: "1.1rem", marginBottom: ".75rem" },
  };

  // Read-only "inherited from the agent" field. Used in the seat (assistant)
  // profile so NPN / license / address / website / company show the supervising
  // agent's values without letting the seat edit them (#4).
  const roField = (label, value) => (
    <div>
      <label style={S.lbl}>{label} <span style={{ fontSize: ".58rem", color: "var(--c-text3,#45688a)", fontWeight: 700 }}>🔒 {es ? "del agente" : "from agent"}</span></label>
      <input value={value || ""} readOnly disabled title={es ? "Se hereda de tu agente supervisor" : "Inherited from your supervising agent"} style={{ ...S.inp, opacity: .6, cursor: "not-allowed" }} />
    </div>
  );

  // Initial tab is "profile" by default but callers can request "billing"
  // (used by the trial-banner CTA in the dashboard) so a single click lands
  // the user on the upgrade screen instead of needing two clicks. The founder
  // has only the Perfil tab (see the TABS block), so a requested tab that no
  // longer renders would leave them on a blank screen.
  const isFounder = !!currentUser?.isPlatformOwner;
  const [settingsTab, setSettingsTab] = useState(isFounder ? "profile" : (initialTab || "profile"));
  const prefs = userPrefs || {};
  // Panel "por tipo de póliza" de los avisos de renovación (abajo, en Avisos).
  // Cuántos tipos tienen plazo propio: va en el botón para que se vea que hay
  // algo configurado ahí dentro sin tener que abrirlo.
  const [renewalByType,setRenewalByType]=useState(false);
  const renewalByTypeCount = Object.values(alertLeadByType || {})
    .filter(v => v && v.n !== "" && v.n !== null && v.n !== undefined).length;
  const emailCfg = prefs.emailConfig || { smtpHost:"", smtpPort:"587", smtpUser:"", smtpPass:"", connected:false };
  const setEmailCfg = (k,v) => onPrefsChange && onPrefsChange(p=>({...p, emailConfig:{...emailCfg, [k]:v}}));
  const setPref = (k,v) => onPrefsChange && onPrefsChange(p=>({...p, [k]:v}));
  // La forma del logo (Lissette 2026-09-23): rectangular, redonda o con marco.
  // Un asiento no la elige — es la de su agente, igual que el logo, porque es
  // la que le llega al cliente. Ver crm-app/formaDelLogo.js.
  const formaLogo = isAssistant ? formaDelLogo({ logoShape: agentForSig.companyLogoShape }) : formaDelLogo(prefs);
  // El logo que lleva la FIRMA: el de la agencia manda sobre el del perfil,
  // igual que en el servidor (utils/emailSignature.ts). La vista previa dice
  // "esto es exactamente lo que se adjunta", así que tiene que elegir igual.
  const logoDeLaFirma = currentUser?.agency?.logoUrl || logo;
  // Pedir el correo de muestra al abrir la ventana y cada vez que se toca una
  // forma. La forma va en la petición porque la preferencia tarda 1,5 s en
  // llegar al servidor: sin eso se vería la forma de antes.
  useEffect(() => {
    if (!vistaCorreo) return;
    let cancelado = false;
    setCorreoDeMuestra(p => ({ ...p, cargando: true, error: "" }));
    import("./crm-app/api.js")
      .then(({ vistaPreviaDelCorreo }) => vistaPreviaDelCorreo({ logoShape: isAssistant ? undefined : formaLogo, lang }))
      .then(d => { if (!cancelado) setCorreoDeMuestra({ html: d?.html || "", cargando: false, error: "", sinRemitente: !!d?.sinRemitente }); })
      .catch(err => { if (!cancelado) setCorreoDeMuestra({ html: "", cargando: false, error: err?.message || String(err), sinRemitente: false }); });
    return () => { cancelado = true; };
  }, [vistaCorreo, formaLogo, isAssistant, lang]);
  // Typography of the agency/company name in outgoing email. Resolved through
  // the same defaults the backend applies, so the preview below and the signature
  // card on the right always show what the recipient will actually get.
  const companyFont = brandFontOf(prefs, "companyFont");
  const brandPreviewName = (f.agencyDisplayName || "").trim() || currentUser?.agency?.name || companyName || "";
  const [testingConn, setTestingConn] = useState(false);
  const [testResult, setTestResult] = useState(null);
  const testConnection = () => {
    setTestingConn(true); setTestResult(null);
    setTimeout(() => {
      if (emailCfg.smtpHost && emailCfg.smtpUser) {
        setEmailCfg("connected",true); setTestResult("success");
      } else {
        setTestResult("error");
      }
      setTestingConn(false);
    }, 1500);
  };

  const Toggle = ({ label, checked, onChange }) => (
    <label style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:".65rem 0",borderBottom:"1px solid var(--c-border,#1a3550)",cursor:"pointer"}}>
      <span style={{fontSize:".82rem",color:"var(--c-white,#eef6ff)",fontWeight:600}}>{label}</span>
      <div style={{position:"relative",width:44,height:24,borderRadius:12,background:checked?"var(--c-cyan,#00d4ff)":"var(--c-surface3,#162d44)",transition:"all .2s",border:`1px solid ${checked?"var(--c-cyan,#00d4ff)":"var(--c-border,#1a3550)"}`}} onClick={onChange}>
        <div style={{position:"absolute",top:2,left:checked?22:2,width:18,height:18,borderRadius:"50%",background:"#fff",transition:"all .2s",boxShadow:"0 1px 3px rgba(0,0,0,.3)"}}/>
      </div>
    </label>
  );

  return <div style={{ maxWidth: 1000 }}>
    {/* While a platform owner is viewing-as, this screen shows the TARGET's
        profile (GET /auth/me resolves through the impersonate header) and the
        save now lands on the target too. Say so out loud — the old silent
        behavior wrote the founder's own row and renamed the wrong account. */}
    {currentUser?.impersonatedByPlatform && (
      <div style={{padding:".55rem .9rem",background:"rgba(255,183,0,.10)",border:"1px solid rgba(255,183,0,.4)",borderRadius:9,marginBottom:"1rem",fontSize:".78rem",color:"#ffb700",lineHeight:1.5}}>
        <b>🛡️ {es?"Estás viendo como ":"You are viewing as "}{currentUser?.name||(es?"este usuario":"this user")}.</b>{" "}
        {es
          ? "Lo que guardes aquí se guarda en SU cuenta, no en la tuya. El tema y las preferencias no se guardan mientras ves como otro usuario."
          : "Anything you save here is saved to THEIR account, not yours. Theme and preferences are not saved while viewing as another user."}
      </div>
    )}
    {/* TABS.
        The PLATFORM_OWNER (Deskte founder) gets ONLY "Perfil" — everything
        else here is agency/CRM machinery they don't have (Lissette 2026-08-03):
          Email       → connect a mailbox to write to clients; platform mail
                        (broadcast, support) never goes through it.
          Facturación → their own plan/billing, but the founder has no agency
                        and no plan, so the tab renders empty.
          Seguridad   → the 6-digit SSN-reveal PIN; ROLES_WITH_OWN_PIN is
                        agency_owner/agent/solo_agent, never PLATFORM_OWNER.
          Preferencias→ timezone/format/collaborators/name order, all agency-
                        scoped.
        Note the role check below can't carry this on its own: AuthGate maps
        PLATFORM_OWNER → 'solo_agent' as a shell-rendering shim, so the founder
        matches "solo_agent" too. Gate on isFounder explicitly. */}
    <div style={{display:"flex",gap:".4rem",marginBottom:"1.25rem",borderBottom:"1px solid var(--c-border,#1a3550)",paddingBottom:".6rem"}}>
      <button onClick={()=>setSettingsTab("profile")} className={`dkt-tab${settingsTab==="profile"?" on":""}`}>👤 {es?"Perfil":"Profile"}</button>
      {/* Email connection/signature tab is hidden for seats — they don't manage
          their own mailbox; outbound goes under the supervising agent (#4). */}
      {!isAssistant && !isFounder && <button onClick={()=>setSettingsTab("email")} className={`dkt-tab${settingsTab==="email"?" on":""}`}>📧 Email</button>}
      {/* Billing only for roles that admin the agency — agents/seats borrow
          their owner's plan but don't manage payment. */}
      {!isFounder && ["agency_owner","agency_admin","solo_agent"].includes(currentUser?.role) && (
        <button onClick={()=>setSettingsTab("billing")} className={`dkt-tab${settingsTab==="billing"?" on":""}`}>💳 {es?"Plan & Facturación":"Plan & Billing"}</button>
      )}
      {!isFounder && <button onClick={()=>setSettingsTab("security")} className={`dkt-tab${settingsTab==="security"?" on":""}`}>🔒 {es?"Seguridad":"Security"}</button>}
      {!isFounder && <button onClick={()=>setSettingsTab("preferences")} className={`dkt-tab${settingsTab==="preferences"?" on":""}`}>⚙️ {es?"Preferencias":"Preferences"}</button>}
    </div>

    {/* ═══ BILLING TAB ═══ */}
    {settingsTab==="billing" && <BillingTab currentUser={currentUser} lang={lang}/>}

    {/* ═══ SECURITY TAB ═══ */}
    {settingsTab==="security" && <div style={{maxWidth:600}}>
      <PinSecurityPanel currentUser={currentUser} lang={lang}/>
      {/* La app autenticadora es de la PERSONA que entra, no de a quien se
          "ve como": viendo como otro usuario, el panel mostraría la cuenta de
          la plataforma, así que no se pinta. */}
      {!currentUser?.impersonatedByPlatform && <AutenticadorPanel lang={lang} email={currentUser?.email}/>}
      {!currentUser?.impersonatedByPlatform && <CerrarSesionesPanel lang={lang}/>}
    </div>}

    {/* ═══ EMAIL TAB ═══ */}
    {settingsTab==="email" && <div style={{maxWidth:700}}>
      {/* Email Connection — OAuth, no longer SMTP.
          The legacy SMTP form (Host/Port/User/Pass + Test Connection) was
          removed on 2026-05-13 because Deskte now connects Gmail / Microsoft
          365 mailboxes via OAuth, which is handled in the "Mi Correo" sidebar
          item (MyEmailView). Sending uses the connected mailbox; replies are
          captured via SendGrid Inbound Parse and routed back into each
          client's message thread automatically. */}
      <div style={S.section}>
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:"1rem"}}>
          <div>
            <div style={{fontFamily:"var(--font-display)",fontWeight:700,fontSize:".95rem",color:"var(--c-white,#eef6ff)"}}>📧 {es?"Conexión de Email":"Email Connection"}</div>
            <div style={{fontSize:".72rem",color:"var(--c-text3,#45688a)",marginTop:2}}>{es?"Tu Gmail o Outlook conectado para enviar emails desde el CRM":"Your connected Gmail or Outlook used to send emails from the CRM"}</div>
          </div>
        </div>
        <div style={{padding:"1rem",background:"rgba(0,212,255,.06)",border:"1px solid rgba(0,212,255,.18)",borderRadius:10,display:"flex",alignItems:"center",justifyContent:"space-between",gap:"1rem",flexWrap:"wrap"}}>
          <div style={{fontSize:".82rem",color:"var(--c-text,#c8dff0)",lineHeight:1.5,flex:1,minWidth:260}}>
            {es
              ? "La conexión se hace por OAuth (Gmail o Microsoft 365). Las respuestas de tus clientes se capturan automáticamente en su perfil."
              : "Connection is via OAuth (Gmail or Microsoft 365). Client replies are captured automatically into each client's profile."}
          </div>
          <button
            type="button"
            onClick={()=>window.dispatchEvent(new CustomEvent("deskte:navigate",{detail:{view:"my_email"}}))}
            style={{display:"flex",alignItems:"center",gap:6,background:"var(--c-cyan,#00d4ff)",border:"none",color:"#070d14",fontSize:".78rem",fontWeight:700,padding:".5rem 1rem",borderRadius:9,cursor:"pointer",whiteSpace:"nowrap"}}
          >
            {es?"Ir a Mi Correo →":"Go to My Email →"}
          </button>
        </div>
      </div>

      {/* Email Signature */}
      <div style={S.section}>
        {/* The signature itself is now generated from Mi Perfil (name, title,
            contacts, company, logo) — see buildAgentSignature() on the backend.
            This box is only the optional extra line below it, which is what
            agents actually used it for (disclaimers, licence notices).
            Lissette 2026-07-21. */}
        <div style={{fontFamily:"var(--font-display)",fontWeight:700,fontSize:".95rem",color:"var(--c-white,#eef6ff)",marginBottom:".5rem"}}>✍️ {es?"Texto extra en la firma":"Extra signature text"}</div>
        <div style={{fontSize:".72rem",color:"var(--c-text3,#45688a)",marginBottom:".75rem",lineHeight:1.45}}>{es?"Tu firma (nombre, título, contactos, compañía y logo) se arma sola desde Mi Perfil. Aquí solo agregas una línea extra debajo — un aviso legal, tu licencia, o lo que quieras.":"Your signature (name, title, contacts, company and logo) is built automatically from My Profile. This box only adds an extra line below it — a disclaimer, your licence, or anything you want."}</div>
        <TextareaWithVars value={prefs.emailSignature||""} onChange={v=>setPref("emailSignature",v)}
          vars={["{{agentName}}", "{{agentPhone}}", "{{agentEmail}}", "{{companyName}}"]} lang={lang}
          textareaProps={{ style:{...S.inp,minHeight:80,resize:"vertical",fontFamily:"var(--font-body)"}, placeholder: es?"Opcional. Ejemplo:\nEste mensaje puede contener informacion confidencial.":"Optional. Example:\nThis message may contain confidential information." }}
          chipsStyle={{ marginTop: 4 }} />
      </div>

      {/* Email Preferences */}
      <div style={S.section}>
        <div style={{fontFamily:"var(--font-display)",fontWeight:700,fontSize:".95rem",color:"var(--c-white,#eef6ff)",marginBottom:".75rem"}}>⚙️ {es?"Preferencias de Email":"Email Preferences"}</div>
        <Toggle label={es?"Incluir firma en todos los emails":"Include signature in all outgoing emails"} checked={prefs.includeSignature!==false} onChange={()=>setPref("includeSignature",!prefs.includeSignature)}/>
        <Toggle label={es?"Incluir link de desuscripcion":"Include unsubscribe link"} checked={prefs.includeUnsubscribe!==false} onChange={()=>setPref("includeUnsubscribe",!(prefs.includeUnsubscribe!==false))}/>
        <Toggle label={es?"Registrar emails automaticamente":"Log emails automatically"} checked={prefs.logEmails!==false} onChange={()=>setPref("logEmails",!(prefs.logEmails!==false))}/>
        <Toggle label={es?"Enviar copia a mi email":"Send copy to my email"} checked={!!prefs.sendCopy} onChange={()=>setPref("sendCopy",!prefs.sendCopy)}/>
        <div style={{marginTop:".75rem"}}>
          <label style={S.lbl}>{es?"Email de respuesta (Reply-To)":"Reply-To Address"}</label>
          <input style={S.inp} value={prefs.replyTo||""} onChange={e=>setPref("replyTo",e.target.value)} placeholder={f.email||""}/>
        </div>
      </div>
    </div>}

    {/* ═══ PREFERENCES TAB ═══ */}
    {settingsTab==="preferences" && <div style={{maxWidth:700}}>
      <div style={S.section}>
        <div style={{fontFamily:"var(--font-display)",fontWeight:700,fontSize:".95rem",color:"var(--c-white,#eef6ff)",marginBottom:".75rem"}}>🌐 {es?"General":"General"}</div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:".75rem",marginBottom:".75rem"}}>
          <div>
            <label style={S.lbl}>{es?"Zona Horaria":"Timezone"}</label>
            <select style={S.inp} value={prefs.timezone||"America/New_York"} onChange={e=>setPref("timezone",e.target.value)}>
              <option value="America/New_York">Eastern (ET)</option>
              <option value="America/Chicago">Central (CT)</option>
              <option value="America/Denver">Mountain (MT)</option>
              <option value="America/Los_Angeles">Pacific (PT)</option>
              <option value="America/Anchorage">Alaska (AKT)</option>
              <option value="Pacific/Honolulu">Hawaii (HT)</option>
              <option value="America/Puerto_Rico">Atlantic (AST)</option>
            </select>
          </div>
          <div>
            <label style={S.lbl}>{es?"Formato de Fecha":"Date Format"}</label>
            <select style={S.inp} value={prefs.dateFormat||"MMM D, YYYY"} onChange={e=>setPref("dateFormat",e.target.value)}>
              <option value="MMM D, YYYY">{es?"Feb 10, 1964 (Texto)":"Feb 10, 1964 (Text)"}</option>
              <option value="MM/DD/YYYY">02/10/1964 — MM/DD/YYYY (US)</option>
              <option value="DD/MM/YYYY">10/02/1964 — DD/MM/YYYY (Intl)</option>
              <option value="YYYY-MM-DD">1964-02-10 — YYYY-MM-DD (ISO)</option>
            </select>
          </div>
          {/* EL ORDEN DEL NOMBRE ES DE LA AGENCIA (Lissette 2026-09-15: "sí,
              que sea de la agencia"). Era de cada persona, y por eso la dueña
              podía ver "López, María" mientras su asistente veía "María López"
              en la MISMA lista. Solo la dueña lo cambia; los demás lo ven
              BLOQUEADO, no escondido: es lo que explica por qué su lista se lee
              como se lee. Mismo trato que los plazos de aviso. */}
          <div>
            <label style={S.lbl}>{es?"Orden del nombre del cliente":"Client name order"}</label>
            <select style={{...S.inp, ...(puedeEditarOrdenDelNombre?{}:{opacity:.6,cursor:"not-allowed"})}}
              value={nameOrder||"first-last"}
              disabled={!puedeEditarOrdenDelNombre}
              onChange={e=>onNameOrderChange && onNameOrderChange(e.target.value)}>
              <option value="first-last">{es?"Nombre Apellido (ej. María López)":"First Last (e.g. María López)"}</option>
              <option value="last-first">{es?"Apellido, Nombre (ej. López, María)":"Last, First (e.g. López, María)"}</option>
            </select>
            <div style={{fontSize:".68rem",color:"var(--c-text3,#45688a)",marginTop:4}}>
              {puedeEditarOrdenDelNombre
                ? (es?"Cómo se escriben y se ordenan los nombres en Clientes, Pólizas y Pagos del Mes. Aplica a TODA tu agencia.":"How names are written and sorted in Clients, Policies and Monthly Payments. Applies to your WHOLE agency.")
                : (es?"Lo fija la dueña de la agencia y vale para todo el equipo. Así todos ven la misma lista en el mismo orden.":"Set by the agency owner and applies to the whole team, so everyone sees the same list in the same order.")}
            </div>
          </div>
        </div>
      </div>

      <div style={S.section}>
        <div style={{fontFamily:"var(--font-display)",fontWeight:700,fontSize:".95rem",color:"var(--c-white,#eef6ff)",marginBottom:".4rem"}}>🤝 {es?"Agentes colaboradores":"Collaborating agents"}</div>
        <div style={{fontSize:".75rem",color:"var(--c-text2,#7aa3c0)",marginBottom:".7rem"}}>{es?"Compartidos por toda la agencia: el agente y los asistentes ven y editan la MISMA lista. Aparecen solos en el toggle de Agente de la póliza (traen su NPN al Producer Code) y al enviar firmas.":"Shared across the whole agency: the agent and assistants see and edit the SAME list. They show up automatically in the policy Agent toggle (auto-filling their NPN into Producer Code) and when sending signatures."}</div>
        {(agencyCollaborators||[]).map((co,i)=>(
          <div key={i} style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr auto",gap:".5rem",marginBottom:".4rem",alignItems:"center"}}>
            <input style={S.inp} value={co.name||""} onChange={e=>{const next=[...(agencyCollaborators||[])];next[i]={...next[i],name:e.target.value};onCollaboratorsChange&&onCollaboratorsChange(next);}} placeholder={es?"Nombre":"First name"}/>
            <input style={S.inp} value={co.lastName||""} onChange={e=>{const next=[...(agencyCollaborators||[])];next[i]={...next[i],lastName:e.target.value};onCollaboratorsChange&&onCollaboratorsChange(next);}} placeholder={es?"Apellido":"Last name"}/>
            <input style={S.inp} value={co.npn||""} onChange={e=>{const next=[...(agencyCollaborators||[])];next[i]={...next[i],npn:e.target.value};onCollaboratorsChange&&onCollaboratorsChange(next);}} placeholder="NPN"/>
            <button type="button" title={es?"Quitar colaborador":"Remove collaborator"} onClick={()=>{const next=(agencyCollaborators||[]).filter((_,j)=>j!==i);onCollaboratorsChange&&onCollaboratorsChange(next);}} style={{background:"none",border:"1px solid var(--c-border,#1a3550)",borderRadius:8,color:"var(--c-red,#ff3d6b)",cursor:"pointer",padding:"8px 12px",fontWeight:700}}>✕</button>
          </div>
        ))}
        <button type="button" onClick={()=>onCollaboratorsChange&&onCollaboratorsChange([...(agencyCollaborators||[]),{id:idDeColaboradorNuevo(),name:"",lastName:"",npn:""}])} style={{marginTop:".25rem",fontSize:".78rem",fontWeight:700,color:"var(--c-cyan,#00d4ff)",background:"rgba(0,212,255,.08)",border:"1px solid rgba(0,212,255,.25)",borderRadius:8,padding:".5rem .9rem",cursor:"pointer",fontFamily:"inherit"}}>+ {es?"Agregar colaborador":"Add collaborator"}</button>
      </div>

      <div style={S.section}>
        <div style={{fontFamily:"var(--font-display)",fontWeight:700,fontSize:".95rem",color:"var(--c-white,#eef6ff)",marginBottom:".75rem"}}>🔤 {es?"Texto y Apariencia":"Text & Appearance"}</div>
        <div style={{fontSize:".75rem",color:"var(--c-text2,#7aa3c0)",marginBottom:".6rem"}}>{es?"Cambia el tipo y el tamaño de letra de toda la aplicación. Aplica solo a tu cuenta.":"Change the font and text size of the whole app. Applies only to your account."}</div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:".75rem"}}>
          <div>
            <label style={S.lbl}>{es?"Tipo de letra":"Font"}</label>
            <select style={S.inp} value={prefs.fontFamily||""} onChange={e=>setPref("fontFamily",e.target.value)}>
              <option value="">{es?"Predeterminada (Deskte)":"Default (Deskte)"}</option>
              <option value='system-ui, -apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-serif'>{es?"Sistema":"System"}</option>
              <option value='Georgia, "Times New Roman", serif'>{es?"Clásica (Serif)":"Classic (Serif)"}</option>
              <option value='Verdana, Geneva, "DejaVu Sans", Tahoma, sans-serif'>{es?"Amplia (Verdana)":"Wide (Verdana)"}</option>
            </select>
          </div>
          <div>
            <label style={S.lbl}>{es?"Tamaño de letra":"Font size"}</label>
            <select style={S.inp} value={prefs.fontSize||"md"} onChange={e=>setPref("fontSize",e.target.value)}>
              <option value="sm">{es?"Pequeño":"Small"}</option>
              <option value="md">{es?"Normal":"Normal"}</option>
              <option value="lg">{es?"Grande":"Large"}</option>
              <option value="xl">{es?"Muy grande":"Extra large"}</option>
            </select>
          </div>
        </div>
      </div>

      <div style={S.section}>
        <div style={{fontFamily:"var(--font-display)",fontWeight:700,fontSize:".95rem",color:"var(--c-white,#eef6ff)",marginBottom:".75rem"}}>🔔 {es?"Notificaciones":"Notifications"}</div>
        <Toggle label={es?"Mostrar popup de cumpleaños al iniciar sesion":"Show birthday popup on login"} checked={prefs.showBirthdayPopup!==false} onChange={()=>setPref("showBirthdayPopup",!(prefs.showBirthdayPopup!==false))}/>
        <Toggle label={es?"Mostrar popup de feriados":"Show holiday greetings popup"} checked={prefs.showHolidayPopup!==false} onChange={()=>setPref("showHolidayPopup",!(prefs.showHolidayPopup!==false))}/>
        <Toggle label={es?"Auto-asignar tareas nuevas a mi":"Auto-assign new tasks to me"} checked={!!prefs.autoAssignTasks} onChange={()=>setPref("autoAssignTasks",!prefs.autoAssignTasks)}/>
        <Toggle label={es?"Sonido en notificaciones del chat":"Sound on chat notifications"} checked={prefs.chatSound!==false} onChange={()=>{const on=prefs.chatSound===false; setPref("chatSound",on); if(on)playChatChime();}}/>
        {/* Encendido por defecto (`!==false`), no apagado. Un interruptor que
            nadie sabe que existe es una función que nadie recibe, y el motivo
            de todo esto fue justo que el aviso no llegaba (Maria Fernanda,
            2026-08-20).

            DESDE EL 2026-09-10 ese correo SÍ dice cuál es la tarea y para
            cuándo (Lissette). Va a un buzón personal, así que la etiqueta lo
            dice en voz alta: quien no quiera que el título salga de Deskte
            tiene aquí el interruptor. Lo que sigue sin salir es todo lo demás
            —descripción, notas y cliente vinculado. */}
        <Toggle label={es?"Recibir correo cuando me asignen un ticket o una tarea":"Email me when a ticket or task is assigned to me"} checked={prefs.assignmentEmail!==false} onChange={()=>setPref("assignmentEmail",!(prefs.assignmentEmail!==false))}/>
        <div style={{fontSize:".7rem",color:"var(--c-text3,#45688a)",margin:"-.35rem 0 .6rem 1.9rem",lineHeight:1.4}}>
          {es?"El correo dice el título y la fecha límite, para que sepas si corre sin tener que entrar. No lleva la descripción, las notas ni el cliente."
            :"The email names the title and the due date, so you can tell if it is urgent without opening Deskte. It carries no description, notes or client."}
        </div>
        {/* Mismo criterio: encendido por defecto. El motivo de que exista es
            que el aviso NO llegaba (Manuela Herrera, 2026-09-09). El correo
            lleva la hora, nunca el título de la cita ni datos del cliente. */}
        <Toggle label={es?"Recibir correo antes de una cita del calendario":"Email me before a calendar appointment"} checked={prefs.appointmentEmail!==false} onChange={()=>setPref("appointmentEmail",!(prefs.appointmentEmail!==false))}/>
      </div>

      {/* ── Avisos ──────────────────────────────────────────────────────────
          Cada plazo estaba escrito a mano en el código y nadie podía cambiarlo.
          El plazo bueno depende del negocio: quien renueva Medicare quiere ver
          la renovación con meses de antelación, no con 30 días
          (Lissette 2026-08-17). Sin tocar nada, todo queda como estaba. */}
      <div style={S.section}>
        <div style={{fontFamily:"var(--font-display)",fontWeight:700,fontSize:".95rem",color:"var(--c-white,#eef6ff)",marginBottom:".35rem"}}>🔔 {es?"Avisos":"Alerts"}</div>
        <div style={{fontSize:".72rem",color:"var(--c-text3,#45688a)",marginBottom:".85rem",lineHeight:1.45}}>
          {es?"Con cuánta antelación aparece cada aviso. Es UNO SOLO para toda la agencia: así el agente y sus asientos miran la misma lista."
            :"How far ahead each alert should appear. It is ONE setting for the whole agency, so the agent and their seats look at the same list."}
        </div>
        {/* El asiento y el agente lo VEN, no lo tocan. Esconderlo sería peor:
            el plazo es justo lo que explica por qué la lista de avisos trae lo
            que trae, y un ajuste que desaparece se lee como que ya no existe
            (Lissette 2026-08-28: "los seat no pueden cambiarlo"). */}
        {!puedeEditarPlazos && (
          <div style={{fontSize:".72rem",color:"var(--c-text2,#7aa3c0)",marginBottom:".85rem",lineHeight:1.45,padding:".5rem .65rem",borderRadius:8,background:"rgba(0,212,255,.07)",border:"1px solid var(--c-border,#1a3550)"}}>
            🔒 {es?"Esto lo configura el dueño de la agencia para todos. Aquí ve el plazo que rige ahora mismo."
              :"The agency owner sets this for everyone. Here you can see the timing currently in force."}
          </div>
        )}
        {[
          // El texto decía "cuántos MESES" mientras la casilla de al lado venía
          // en DÍAS: quien escribía 3 pensando en meses se quedaba con 3 días y
          // la pantalla de avisos en blanco (Lissette 2026-08-19). La ayuda no
          // nombra la unidad — la unidad la elige el desplegable.
          { key:"license", icon:"🪪", es:"Licencias por vencer", en:"Licenses about to expire",
            esHelp:"Con cuánta antelación quieres verlas. Lo normal son 90 días: renovar lleva semanas.",
            enHelp:"How far ahead you want to see them. 90 days is typical — renewing takes weeks." },
          { key:"renewal", icon:"🔄", es:"Renovación de pólizas", en:"Policy renewals",
            esHelp:"Cuánto antes de la fecha de renovación.", enHelp:"How long before the renewal date." },
          { key:"task", icon:"🗓️", es:"Tareas por vencer", en:"Tasks coming due",
            esHelp:"Cuánto antes de la fecha límite.", enHelp:"How long before the due date." },
          { key:"ticket", icon:"🎫", es:"Tickets sin resolver", en:"Unresolved tickets",
            esHelp:"Avisar solo si llevan abiertos más de este tiempo. En 0 salen todos.",
            enHelp:"Only alert once they have been open longer than this. At 0, all of them show." },
          // Manuela Herrera (Allinsure Group), 2026-09-09: "me he dejado un par
          // de eventos en el calendario y no recibo notificación para
          // acordarme". Va en MINUTOS u HORAS, no en días: avisar de una
          // reunión de las 3 con tres días de antelación no es un
          // recordatorio, es una agenda.
          { key:"cita", icon:"📅", es:"Citas del calendario", en:"Calendar appointments", lista:"citaMas",
            unidades:[["min","minutos","minutes"],["h","horas","hours"]],
            esHelp:"Cuánto antes de que empiece. Llega a la campana y al correo. En 0 avisa al empezar.",
            enHelp:"How long before it starts. Sent to the bell and by email. At 0 it alerts when it begins." },
          // Lissette 2026-10-28: "hazlo también para el cliente por correo".
          // Solo las citas del Booking Link y del módulo Citas, desde el buzón
          // conectado de la agencia (deskte-api/src/jobs/client-appointment-reminders.job.ts).
          { key:"citaCliente", icon:"✉️", es:"Recordatorio al cliente", en:"Reminder to the client", lista:"citaClienteMas",
            unidades:[["h","horas","hours"],["d","días","days"]],
            esHelp:"Correo al cliente antes de su cita (las del Booking Link y las del módulo Citas). Sale de tu correo conectado. En 0 no se manda.",
            enHelp:"Email to the client before their appointment (Booking Link and Appointments module). Sent from your connected mailbox. At 0 nothing is sent." },
        ].map(row=>{
          const unidades = row.unidades || [["d","días","days"],["m","meses","months"]];
          const unidadPorDefecto = unidades[0][0];
          const cfg = (alertLead||{})[row.key] || { n: ALERT_LEAD_DEFAULTS[row.key], unit:unidadPorDefecto };
          const setCfg = (patch)=>onAlertLeadChange && onAlertLeadChange({ ...(alertLead||{}), [row.key]: { ...cfg, ...patch } });
          return (
            <div key={row.key} style={{display:"flex",alignItems:"flex-start",gap:".75rem",padding:".55rem 0",borderBottom:"1px solid var(--c-border,#1a3550)",flexWrap:"wrap"}}>
              <div style={{flex:1,minWidth:200}}>
                <div style={{fontSize:".82rem",fontWeight:600,color:"var(--c-text,#c8dff0)"}}>{row.icon} {es?row.es:row.en}</div>
                <div style={{fontSize:".68rem",color:"var(--c-text3,#45688a)",marginTop:2,lineHeight:1.35}}>{es?row.esHelp:row.enHelp}</div>
              </div>
              <div style={{display:"flex",alignItems:"center",gap:".4rem"}}>
                <input type="number" min="0" max={row.key==="cita"&&cfg.unit!=="h"?1440:120} value={cfg.n} disabled={!puedeEditarPlazos}
                  onChange={e=>setCfg({ n: e.target.value === "" ? "" : Math.max(0, Number(e.target.value)||0) })}
                  style={{...S.inp,width:74,textAlign:"center",opacity:puedeEditarPlazos?1:.6}}/>
                <select value={cfg.unit||unidadPorDefecto} disabled={!puedeEditarPlazos} onChange={e=>setCfg({ unit: e.target.value })} style={{...S.inp,width:96,opacity:puedeEditarPlazos?1:.6}}>
                  {unidades.map(([v,eu,en])=><option key={v} value={v}>{es?eu:en}</option>)}
                </select>
                {puedeEditarPlazos && <button type="button" onClick={()=>setCfg({ n: ALERT_LEAD_DEFAULTS[row.key], unit:unidadPorDefecto })}
                  title={es?`Volver a lo normal (${ALERT_LEAD_DEFAULTS[row.key]} ${unidades[0][1]})`:`Back to default (${ALERT_LEAD_DEFAULTS[row.key]} ${unidades[0][2]})`}
                  style={{background:"none",border:"none",cursor:"pointer",color:"var(--c-text3,#45688a)",fontSize:".68rem",fontWeight:700}}>↺</button>}
              </div>
              {/* Solo renovaciones se afina por tipo: salud no se renueva como
                  auto ni como vida (Lissette 2026-08-17). Un tipo sin nada
                  propio hereda el plazo de arriba, así que configurar uno no
                  obliga a configurarlos todos. */}
              {/* Más de un aviso por cita (Wendy Cercio, 2026-10-28: "una
                  secuencia de 2 horas, 30 minutos, 5 minutos, tanto para el
                  cliente como para mí"). Hasta dos más; el servidor los lee en
                  utils/alertLead.ts (minutosDeAvisosDeCita / ...AlCliente). */}
              {row.lista && (()=>{
                const mas = Array.isArray((alertLead||{})[row.lista]) ? (alertLead||{})[row.lista] : [];
                const setMas = (lista)=>onAlertLeadChange && onAlertLeadChange({ ...(alertLead||{}), [row.lista]: lista });
                return (
                  <div style={{flexBasis:"100%",display:"flex",flexDirection:"column",gap:".35rem",paddingLeft:".75rem",borderLeft:mas.length?"2px solid var(--c-border,#1a3550)":"none"}}>
                    {mas.map((m,i)=>(
                      <div key={i} style={{display:"flex",alignItems:"center",gap:".4rem"}}>
                        <span style={{flex:1,fontSize:".72rem",color:"var(--c-text2,#7aa3c0)"}}>{es?`Otro aviso (${i+2}º)`:`Another reminder (#${i+2})`}</span>
                        <input type="number" min="0" max={120} value={m.n} disabled={!puedeEditarPlazos}
                          onChange={e=>setMas(mas.map((x,j)=>j===i?{ ...x, n: e.target.value === "" ? "" : Math.max(0, Number(e.target.value)||0) }:x))}
                          style={{...S.inp,width:70,textAlign:"center",fontSize:".72rem",padding:".25rem",opacity:puedeEditarPlazos?1:.6}}/>
                        <select value={m.unit||unidadPorDefecto} disabled={!puedeEditarPlazos}
                          onChange={e=>setMas(mas.map((x,j)=>j===i?{ ...x, unit:e.target.value }:x))}
                          style={{...S.inp,width:84,fontSize:".72rem",padding:".25rem",opacity:puedeEditarPlazos?1:.6}}>
                          {unidades.map(([v,eu,en])=><option key={v} value={v}>{es?eu:en}</option>)}
                        </select>
                        {puedeEditarPlazos && <button type="button" onClick={()=>setMas(mas.filter((_,j)=>j!==i))}
                          title={es?"Quitar este aviso":"Remove this reminder"}
                          style={{background:"none",border:"none",cursor:"pointer",color:"var(--c-text3,#45688a)",fontSize:".8rem",fontWeight:700}}>✕</button>}
                      </div>
                    ))}
                    {puedeEditarPlazos && mas.length<2 && (
                      <button type="button" onClick={()=>setMas([...mas,{ n:"", unit:unidadPorDefecto }])}
                        style={{alignSelf:"flex-start",background:"none",border:"none",cursor:"pointer",color:"var(--c-cyan,#00d4ff)",fontSize:".68rem",fontWeight:700,padding:0}}>
                        {es?"+ Añadir otro aviso":"+ Add another reminder"}
                      </button>
                    )}
                  </div>
                );
              })()}
              {row.key==="renewal" && (
                <div style={{flexBasis:"100%"}}>
                  <button type="button" onClick={()=>setRenewalByType(v=>!v)}
                    style={{background:"none",border:"none",cursor:"pointer",color:"var(--c-cyan,#00d4ff)",fontSize:".68rem",fontWeight:700,padding:0,marginTop:2}}>
                    {renewalByType?"▾":"▸"} {es?"Afinar por tipo de póliza":"Fine-tune per policy type"}
                    {renewalByTypeCount>0 && ` (${renewalByTypeCount})`}
                  </button>
                  {renewalByType && (
                    <div style={{marginTop:".5rem",paddingLeft:".75rem",borderLeft:"2px solid var(--c-border,#1a3550)",display:"flex",flexDirection:"column",gap:".35rem"}}>
                      <div style={{fontSize:".66rem",color:"var(--c-text3,#45688a)",lineHeight:1.4}}>
                        {es?`El que dejes vacío usa el plazo de arriba (${cfg.n||ALERT_LEAD_DEFAULTS.renewal} ${cfg.unit==="m"?"meses":"días"}).`
                          :`Anything left blank uses the plazo above (${cfg.n||ALERT_LEAD_DEFAULTS.renewal} ${cfg.unit==="m"?"months":"days"}).`}
                      </div>
                      {/* Con los tipos propios de la agencia (Lissette 2026-10-19): el
                          plazo se busca por el tipo exacto (utils.js), así que valen igual. */}
                      {POLICY_TYPES.map(pt=>{
                        const tcfg = (alertLeadByType||{})[pt.id] || { n:"", unit:cfg.unit||"d" };
                        const setT = (patch)=>onAlertLeadByTypeChange && onAlertLeadByTypeChange({ ...(alertLeadByType||{}), [pt.id]: { ...tcfg, ...patch } });
                        return (
                          <div key={pt.id} style={{display:"flex",alignItems:"center",gap:".4rem"}}>
                            <span style={{flex:1,fontSize:".72rem",color:"var(--c-text2,#7aa3c0)"}}>{pt.icon} {es?pt.labelEs:pt.label}</span>
                            <input type="number" min="0" max="120" value={tcfg.n} disabled={!puedeEditarPlazos}
                              placeholder={es?"igual":"same"}
                              onChange={e=>setT({ n: e.target.value === "" ? "" : Math.max(0, Number(e.target.value)||0) })}
                              style={{...S.inp,width:70,textAlign:"center",fontSize:".72rem",padding:".25rem"}}/>
                            <select value={tcfg.unit||"d"} disabled={!puedeEditarPlazos} onChange={e=>setT({ unit:e.target.value })} style={{...S.inp,width:84,fontSize:".72rem",padding:".25rem",opacity:puedeEditarPlazos?1:.6}}>
                              <option value="d">{es?"días":"days"}</option>
                              <option value="m">{es?"meses":"months"}</option>
                            </select>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>

      <div style={S.section}>
        <div style={{fontFamily:"var(--font-display)",fontWeight:700,fontSize:".95rem",color:"var(--c-white,#eef6ff)",marginBottom:".75rem"}}>🗄️ {es?"Datos":"Data"}</div>
        <div style={{fontSize:".78rem",color:"var(--c-text2,#7aa3c0)",marginBottom:".5rem"}}>{es?"Las preferencias se guardan automaticamente en tu navegador.":"Preferences are saved automatically in your browser."}</div>
        <div style={{fontSize:".7rem",color:"var(--c-text3,#45688a)",fontFamily:"var(--font-mono)"}}>{es?"Almacenamiento local:":"Local storage:"} {Object.keys(localStorage).filter(k=>k.startsWith("dkt6_")).length} keys</div>
      </div>
    </div>}

    {/* ═══ PROFILE TAB ═══ */}
    {settingsTab==="profile" && <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1rem" }}>
    {/* LEFT: Profile Form */}
    <div>
      <div style={{ fontFamily: "var(--font-display)", fontWeight: 800, fontSize: "1.1rem", color: "var(--c-white,#eef6ff)", marginBottom: ".75rem" }}>👤 {es ? "Mi Perfil" : "My Profile"}</div>

      <div style={S.section}>
        <div style={{ display: "flex", alignItems: "center", gap: ".85rem", marginBottom: "1rem" }}>
          <div style={{ position: "relative" }}>
            {f.profilePhoto ? <img src={f.profilePhoto} alt="" style={{ width: 64, height: 64, borderRadius: 16, objectFit: "cover" }} /> : <div style={{ width: 64, height: 64, borderRadius: 16, background: f.color || "#1d6fa4", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 800, fontSize: "1.2rem", color: "#fff", fontFamily: "var(--font-display)" }}>{f.initials || "?"}</div>}
            <label style={{ position: "absolute", bottom: -4, right: -4, width: 24, height: 24, borderRadius: "50%", background: "var(--c-cyan,#00d4ff)", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", fontSize: ".7rem", border: "2px solid var(--c-bg,#070d14)" }}>📷<input type="file" accept="image/*" onChange={e => { const file = e.target.files && e.target.files[0]; if (!file) return; downscaleProfilePhoto(file, url => applyProfilePhoto(url)); }} style={{ display: "none" }} /></label>
          </div>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: ".9rem", fontWeight: 700, color: "var(--c-white,#eef6ff)" }}>{f.name}</div>
            <div style={{ fontSize: ".72rem", color: "var(--c-cyan,#00d4ff)" }}>{f.role === "assistant" ? (es ? "👥 Asiento" : "👥 Seat") : nombreDelRol(f, users, lang).etiqueta}</div>
            <div style={{ display: "flex", gap: ".7rem", marginTop: 3, flexWrap: "wrap", alignItems: "center" }}>
              <button onClick={() => setAvatarPickerOpen(o => !o)} style={{ fontSize: ".62rem", color: "var(--c-cyan,#00d4ff)", background: "none", border: "none", cursor: "pointer", padding: 0, fontWeight: 700 }}>🎨 {es ? "Elegir avatar" : "Choose avatar"}</button>
              {f.profilePhoto && <button onClick={() => applyProfilePhoto("")} style={{ fontSize: ".62rem", color: "var(--c-text3,#45688a)", background: "none", border: "none", cursor: "pointer", padding: 0 }}>{es ? "Quitar" : "Remove"}</button>}
            </div>
          </div>
        </div>

        {avatarPickerOpen && (
          <div style={{ marginBottom: "1rem", padding: ".8rem", background: "var(--c-surface2,#112538)", border: "1px solid var(--c-border,#1a3550)", borderRadius: 10 }}>
            <div style={{ fontSize: ".66rem", color: "var(--c-text3,#45688a)", marginBottom: ".5rem", textTransform: "uppercase", letterSpacing: ".05em" }}>{es ? "Elige un avatar (o sube tu foto arriba)" : "Pick an avatar (or upload your photo above)"}</div>

            <div style={{ fontSize: ".62rem", color: "var(--c-text2,#7aa3c0)", fontWeight: 700, margin: "0 0 .4rem" }}>{es ? "Geométricos" : "Geometric"}</div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 9, marginBottom: ".85rem" }}>
              {AVATAR_PRESETS.map(p => {
                const url = svgToDataUrl(buildAvatarSvg(p.c1, p.c2, p.motif));
                const selected = f.profilePhoto === url;
                return (
                  <button key={p.id} type="button" onClick={() => { applyProfilePhoto(url); setAvatarPickerOpen(false); }} title={es ? "Usar este avatar" : "Use this avatar"}
                    style={{ width: 46, height: 46, borderRadius: "50%", overflow: "hidden", padding: 0, cursor: "pointer", background: "none", border: selected ? "2px solid var(--c-cyan,#00d4ff)" : "2px solid transparent" }}>
                    <img src={url} alt="" style={{ width: "100%", height: "100%", display: "block", objectFit: "cover" }} />
                  </button>
                );
              })}
            </div>

            <div style={{ fontSize: ".62rem", color: "var(--c-text2,#7aa3c0)", fontWeight: 700, margin: "0 0 .4rem" }}>{es ? "Caras" : "Faces"}</div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 9 }}>
              {FACE_PRESETS.map(p => {
                const url = svgToDataUrl(buildFaceSvg(p.c1, p.c2, p));
                const selected = f.profilePhoto === url;
                return (
                  <button key={p.id} type="button" onClick={() => { applyProfilePhoto(url); setAvatarPickerOpen(false); }} title={es ? "Usar este avatar" : "Use this avatar"}
                    style={{ width: 46, height: 46, borderRadius: "50%", overflow: "hidden", padding: 0, cursor: "pointer", background: "none", border: selected ? "2px solid var(--c-cyan,#00d4ff)" : "2px solid transparent" }}>
                    <img src={url} alt="" style={{ width: "100%", height: "100%", display: "block", objectFit: "cover" }} />
                  </button>
                );
              })}
            </div>
          </div>
        )}

        {isAssistant && (
          <div style={{ marginBottom: ".85rem", padding: ".6rem .75rem", background: "rgba(0,212,255,.06)", border: "1px solid rgba(0,212,255,.18)", borderRadius: 9, fontSize: ".72rem", color: "var(--c-text,#c8dff0)", lineHeight: 1.45 }}>
            🔒 {es
              ? <>Como <b>asistente</b>, tu NPN, licencia, dirección, sitio web, compañía, logo y firma se toman de tu <b>agente{parentAgent ? ` (${parentAgent.name})` : ""}</b>. Tú solo editas tu <b>nombre</b> y <b>título</b>.</>
              : <>As an <b>assistant</b>, your NPN, license, address, website, company, logo and signature come from your <b>agent{parentAgent ? ` (${parentAgent.name})` : ""}</b>. You only edit your <b>name</b> and <b>title</b>.</>}
          </div>
        )}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: ".5rem" }}>
          <div><label style={S.lbl}>{es ? "Nombre Completo" : "Full Name"}</label><input value={f.name || ""} onChange={e => set("name", e.target.value)} style={S.inp} /></div>
          <div><label style={S.lbl}>{es ? "Título" : "Title"}</label><input value={f.title || ""} onChange={e => set("title", e.target.value)} placeholder={isAssistant ? "" : "Licensed Insurance Agent"} style={S.inp} /></div>
          {/* Seats don't manage their own email — outbound always goes under the
              supervising agent — so the field is removed for them (#4). */}
          {!isAssistant && <div>
            <label style={S.lbl}>{lang==="es"?"Correo de contacto":"Contact email"}</label>
            <input value={f.contactEmail || ""} onChange={e => set("contactEmail", e.target.value)} style={S.inp} placeholder={f.email || ""} />
            {/* El correo de ACCESO no se edita aqui: el sistema empareja al
                usuario por el al iniciar sesion, asi que poder escribirlo
                permitiria quedarse con la cuenta de otra persona. Antes el
                campo dejaba teclearlo y aparentaba guardar, pero no viajaba al
                servidor y al recargar volvia el anterior (Lissette 2026-08-14). */}
            <div style={{fontSize:".68rem",color:"var(--c-text3,#45688a)",marginTop:3,lineHeight:1.45}}>
              {lang==="es"
                ? <>Es el que ven tus clientes en la firma y tus materiales. Si lo dejas vacío se usa <strong>{f.email || "tu correo de acceso"}</strong>.</>
                : <>This is what clients see in your signature and materials. Leave it empty to use <strong>{f.email || "your sign-in email"}</strong>.</>}
            </div>
            <div style={{fontSize:".66rem",color:"var(--c-text3,#45688a)",marginTop:2}}>
              🔒 {lang==="es"
                ? `Correo de acceso: ${f.email || "--"} — no se cambia desde aquí.`
                : `Sign-in email: ${f.email || "--"} — not editable here.`}
            </div>
          </div>}
          {/* Segundo correo de contacto. Mismas reglas que el primero: solo se
              muestra, nunca se envía desde él (Lissette 2026-08-19). */}
          {!isAssistant && <div>
            <label style={S.lbl}>{lang==="es"?"Segundo correo de contacto":"Second contact email"}</label>
            <input value={f.contactEmail2 || ""} onChange={e => set("contactEmail2", e.target.value)} style={S.inp} placeholder={lang==="es"?"Opcional":"Optional"} />
          </div>}
          {/* Dos teléfonos con su icono: 📱 el móvil y ☎️ el de la oficina. El
              campo que ya existía es el móvil — no se renombra por dentro para
              no tocar lo que ya está guardado. */}
          {isAssistant
            ? roField(es ? "📱 Móvil" : "📱 Mobile", agentForSig.phone)
            : <div><label style={S.lbl}>{es ? "📱 Móvil" : "📱 Mobile"}</label><input value={f.phone || ""} onChange={e => set("phone", e.target.value)} style={S.inp} /></div>}
          {isAssistant
            ? roField(es ? "☎️ Oficina" : "☎️ Office", agentForSig.officePhone)
            : <div><label style={S.lbl}>{es ? "☎️ Oficina" : "☎️ Office"}</label><input value={f.officePhone || ""} onChange={e => set("officePhone", e.target.value)} style={S.inp} placeholder={lang==="es"?"Opcional":"Optional"} /></div>}
          {/* WHATSAPP Y FAX (Lissette 2026-08-29): "créame en mi perfil un
              nuevo campo para colocar whatsapp number con el icono de whatsapp
              y uno para fax".

              WhatsApp NO es el móvil de arriba: mucha gente lo usa en un número
              distinto del que da a los clientes. Por eso es un campo propio y
              no una casilla al lado del teléfono.

              Un asistente ve los de su agente en solo lectura, igual que el
              resto del bloque: la firma y la tarjeta que manda son las de él. */}
          {isAssistant
            ? roField(es ? "💬 WhatsApp" : "💬 WhatsApp", agentForSig.whatsappNumber)
            : <div><label style={S.lbl}>{es ? "💬 WhatsApp" : "💬 WhatsApp"}</label><input value={f.whatsappNumber || ""} onChange={e => set("whatsappNumber", e.target.value)} style={S.inp} placeholder={lang==="es"?"Opcional — si es distinto de tu móvil":"Optional — if different from your mobile"} /></div>}
          {isAssistant
            ? roField(es ? "📠 Fax" : "📠 Fax", agentForSig.fax)
            : <div><label style={S.lbl}>{es ? "📠 Fax" : "📠 Fax"}</label><input value={f.fax || ""} onChange={e => set("fax", e.target.value)} style={S.inp} placeholder={lang==="es"?"Opcional":"Optional"} /></div>}
          {isAssistant
            ? roField("NPN", agentForSig.npn)
            : <div><label style={S.lbl}>NPN</label><input value={f.npn || ""} onChange={e => set("npn", e.target.value)} placeholder="" style={S.inp} /></div>}
          {isAssistant
            ? roField(es ? "Estados con Licencia" : "Licensed States", agentForSig.licenseStates)
            : <div><label style={S.lbl}>{es ? "Estados con Licencia" : "Licensed States"}</label><input value={f.licenseStates || ""} onChange={e => set("licenseStates", e.target.value)} placeholder="" style={S.inp} /></div>}
          {isAssistant ? (
            <>
              <div style={{ gridColumn: "1/-1" }}>{roField(es ? "Dirección postal (footer CAN-SPAM)" : "Mailing address (CAN-SPAM footer)", agentAddrLine)}</div>
              <div style={{ gridColumn: "1/-1" }}>{roField(es ? "Sitio Web" : "Website", agentForSig.website)}</div>
            </>
          ) : (
            <>
          <div style={{ gridColumn: "1/-1" }}>
            <label style={S.lbl}>
              {es ? "Dirección postal (footer CAN-SPAM)" : "Mailing address (CAN-SPAM footer)"}
              {!(f.mailingStreet || f.mailingCity || f.mailingState || f.mailingZip || f.mailingAddress) && (
                <span style={{ marginLeft: 8, fontSize: ".62rem", color: "var(--c-amber,#ffb700)", fontWeight: 700 }}>
                  ⚠️ {es ? "REQUERIDO" : "REQUIRED"}
                </span>
              )}
            </label>
            <input
              value={f.mailingStreet || ""}
              onChange={e => set("mailingStreet", e.target.value)}
              placeholder={es ? "Dirección (ej. 123 Main St #4)" : "Street address (e.g. 123 Main St #4)"}
              style={S.inp}
            />
            <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr 1fr", gap: ".5rem", marginTop: ".4rem" }}>
              <input
                value={f.mailingCity || ""}
                onChange={e => set("mailingCity", e.target.value)}
                placeholder={es ? "Ciudad" : "City"}
                style={S.inp}
              />
              <input
                value={f.mailingState || ""}
                onChange={e => set("mailingState", e.target.value.toUpperCase().slice(0, 2))}
                placeholder={es ? "Estado (FL)" : "State (FL)"}
                maxLength={2}
                style={{ ...S.inp, textTransform: "uppercase" }}
              />
              <input
                value={f.mailingZip || ""}
                onChange={e => set("mailingZip", e.target.value)}
                placeholder="ZIP"
                style={S.inp}
              />
            </div>
            <div style={{ fontSize: ".62rem", color: "var(--c-text3,#45688a)", marginTop: 4, lineHeight: 1.4 }}>
              {es
                ? "Aparece al pie de cada correo comercial que envías. Ley federal (CAN-SPAM §7704). Usa la dirección de TU agencia o un buzón virtual — NO tu casa. Si lo dejas vacío, se usa la dirección genérica de Deskte como fallback."
                : "Appears at the foot of every commercial email you send. Federal law (CAN-SPAM §7704). Use YOUR agency's address or a virtual mailbox — NOT your home. If empty, Deskte's generic address is used as a fallback."}
            </div>
          </div>
          <div style={{ gridColumn: "1/-1" }}><label style={S.lbl}>{es ? "Sitio Web" : "Website"}</label><input value={f.website || ""} onChange={e => set("website", e.target.value)} placeholder="" style={S.inp} /></div>
            </>
          )}
          <div style={{ gridColumn: "1/-1" }}><label style={S.lbl}>Bio</label><textarea value={f.bio || ""} onChange={e => set("bio", e.target.value)} rows={2} placeholder={es ? "Breve descripción profesional..." : "Short professional bio..."} style={{ ...S.inp, resize: "vertical", fontFamily: "inherit" }} /></div>
        </div>
      </div>

      {/* Social profiles. Same seat rule as the contacts above: a seat shows
          the supervising agent's accounts read-only, because outgoing mail
          goes out under the agent. Only the fields the agent fills render an
          icon — an empty network simply doesn't appear anywhere. */}
      <div style={S.section}>
        <div style={{ fontSize: ".78rem", fontWeight: 700, color: "var(--c-white,#eef6ff)", marginBottom: ".25rem" }}>
          🔗 {es ? "Redes Sociales" : "Social Media"}
          {isAssistant && <span style={{ marginLeft: 6, fontSize: ".58rem", color: "var(--c-text3,#45688a)", fontWeight: 700 }}>🔒 {es ? "del agente" : "from agent"}</span>}
        </div>
        <div style={{ fontSize: ".68rem", color: "var(--c-text3,#45688a)", marginBottom: ".7rem", lineHeight: 1.45 }}>
          {es
            ? "Salen con su icono en tu tarjeta digital y al pie de cada correo que envías. Escribe solo tu usuario (@dalcer) o pega el enlace completo — las que dejes vacías no aparecen."
            : "They appear with their icon on your digital card and at the foot of every email you send. Type just your handle (@dalcer) or paste the full link — the ones you leave empty don't show up."}
        </div>
        {SOCIAL_NETWORKS.map(network => (
          <div key={network.field} style={{ display: "flex", alignItems: "center", gap: ".6rem", marginBottom: ".45rem" }}>
            <SocialIcon network={network} size={28} />
            <input
              value={(isAssistant ? agentForSig[network.field] : f[network.field]) || ""}
              onChange={isAssistant ? undefined : (e => set(network.field, e.target.value))}
              readOnly={isAssistant}
              disabled={isAssistant}
              title={isAssistant ? (es ? "Se hereda de tu agente supervisor" : "Inherited from your supervising agent") : network.label}
              placeholder={network.placeholder}
              style={isAssistant ? { ...S.inp, opacity: .6, cursor: "not-allowed" } : S.inp}
            />
          </div>
        ))}
      </div>

      <div style={S.section}>
        <div style={{ fontSize: ".78rem", fontWeight: 700, color: "var(--c-white,#eef6ff)", marginBottom: ".5rem" }}>🏢 {es ? "Compañía" : "Company"}</div>
        {isAssistant ? (
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: ".5rem" }}>
            {roField(es ? "Nombre de la Compañía" : "Company Name", agentForSig.companyName)}
            <div>
              <label style={S.lbl}>{es ? "Logo de la Compañía" : "Company Logo"} <span style={{ fontSize: ".58rem", color: "var(--c-text3,#45688a)", fontWeight: 700 }}>🔒 {es ? "del agente" : "from agent"}</span></label>
              <div style={{ display: "flex", alignItems: "center", gap: ".5rem", minHeight: 34 }}>
                {logo ? <img src={logo} alt="logo" style={{ ...estiloDelLogo(formaLogo, 36), background: "#fff" }} /> : <span style={{ fontSize: ".72rem", color: "var(--c-text3,#45688a)" }}>—</span>}
              </div>
            </div>
          </div>
        ) : (
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: ".5rem" }}>
          <div><label style={S.lbl}>{es ? "Nombre de la Compañía" : "Company Name"}</label><input value={f.companyName || ""} onChange={e => set("companyName", e.target.value)} style={S.inp} /></div>
          <div>
            <label style={S.lbl}>{es ? "Logo de la Compañía" : "Company Logo"}</label>
            <div style={{ display: "flex", alignItems: "center", gap: ".5rem", flexWrap: "wrap" }}>
              {logoPreview && (
                <img src={logoPreview} alt="logo" onClick={() => setVistaCorreo(true)} title={es ? "Ver cómo lo recibe el cliente" : "See how your client receives it"}
                  style={{ ...estiloDelLogo(formaLogo, 48), background: "#fff", cursor: "zoom-in" }} />
              )}
              <label style={{ padding: "6px 12px", background: "rgba(0,212,255,.08)", border: "1px solid rgba(0,212,255,.2)", color: "var(--c-cyan,#00d4ff)", fontSize: ".72rem", borderRadius: 7, cursor: "pointer" }}>
                📎 {logoPreview ? (es ? "Cambiar" : "Replace") : (es ? "Subir" : "Upload")}<input type="file" accept="image/*" onChange={handleLogoUpload} style={{ display: "none" }} />
              </label>
              {logoPreview && (
                <button type="button" onClick={quitarLogo} style={{ padding: "6px 12px", background: "rgba(255,77,109,.08)", border: "1px solid rgba(255,77,109,.25)", color: "var(--c-red,#ff4d6d)", fontSize: ".72rem", borderRadius: 7, cursor: "pointer" }}>
                  🗑️ {es ? "Quitar" : "Remove"}
                </button>
              )}
              {logoPreview && (
                <button type="button" onClick={() => setVistaCorreo(true)} style={{ padding: "6px 12px", background: "rgba(0,212,255,.08)", border: "1px solid rgba(0,212,255,.2)", color: "var(--c-cyan,#00d4ff)", fontSize: ".72rem", borderRadius: 7, cursor: "pointer" }}>
                  👁️ {es ? "Ver cómo lo recibe el cliente" : "See it as your client does"}
                </button>
              )}
            </div>
            {/* La forma (Lissette 2026-09-23). Sale aunque no haya logo todavía:
                se puede dejar elegida antes de subirlo. */}
            <div style={{ display: "flex", gap: ".35rem", marginTop: ".45rem", flexWrap: "wrap" }}>
              {FORMAS_DEL_LOGO.map(op => {
                const activa = formaLogo === op.id;
                return (
                  <button key={op.id} type="button" onClick={() => setPref("logoShape", op.id)} aria-pressed={activa}
                    style={{ padding: "4px 10px", fontSize: ".68rem", fontWeight: 700, borderRadius: 999, cursor: "pointer",
                      background: activa ? "rgba(0,212,255,.16)" : "transparent",
                      border: `1px solid ${activa ? "var(--c-cyan,#00d4ff)" : "var(--c-border2,#1f3f60)"}`,
                      color: activa ? "var(--c-cyan,#00d4ff)" : "var(--c-text2,#7aa3c0)" }}>
                    {es ? op.es : op.en}
                  </button>
                );
              })}
            </div>
          </div>
        </div>
        )}
        {/* Per-agent agency-name override. Only for agents WITHIN an agency:
            they work under the agency but can show their own name on their
            client-facing materials (emails, quotes, invoices, forms, PDFs)
            without renaming the shared agency for the owner or colleagues.
            Owners/solo agents rename the real agency instead; seats inherit
            the agent's. Empty = uses the agency's real name. */}
        {currentUser?.role === "agent" && (
          <div style={{ marginTop: ".85rem", paddingTop: ".85rem", borderTop: "1px solid var(--c-border,#1a3550)" }}>
            <label style={S.lbl}>{es ? "Nombre de agencia que ven tus clientes" : "Agency name your clients see"}</label>
            <input
              value={f.agencyDisplayName || ""}
              onChange={e => set("agencyDisplayName", e.target.value)}
              maxLength={120}
              placeholder={currentUser?.agency?.name || (es ? "Nombre de la agencia" : "Agency name")}
              style={S.inp}
            />
            <div style={{ fontSize: ".66rem", color: "var(--c-text3,#45688a)", marginTop: 4, lineHeight: 1.45 }}>
              {es
                ? <>Aparece en TUS correos, cotizaciones, facturas, formularios y PDFs — sin cambiar el nombre de la agencia para el dueño ni los demás. Vacío = usa <b>{currentUser?.agency?.name || "el nombre de la agencia"}</b>.</>
                : <>Shows on YOUR emails, quotes, invoices, forms and PDFs — without changing the agency name for the owner or colleagues. Empty = uses <b>{currentUser?.agency?.name || "the agency name"}</b>.</>}
            </div>
          </div>
        )}

        {/* NOMBRE EN EL PORTAL DEL CLIENTE (Lissette 2026-10-20): *"poder
            colocar el nombre del agente como uno quiera"*. Es el que sale en
            "Tu agente" del portal. Un asiento no lo tiene: el portal de sus
            clientes ensena al agente que lo supervisa. */}
        {currentUser?.role !== "assistant" && (
          <div style={{ marginTop: ".85rem", paddingTop: ".85rem", borderTop: "1px solid var(--c-border,#1a3550)" }}>
            <label style={S.lbl}>{es ? "Tu nombre en el portal del cliente" : "Your name in the client portal"}</label>
            <input
              value={f.portalDisplayName || ""}
              onChange={e => set("portalDisplayName", e.target.value)}
              maxLength={120}
              placeholder={currentUser?.name || (es ? "Tu nombre" : "Your name")}
              style={S.inp}
            />
            <div style={{ fontSize: ".66rem", color: "var(--c-text3,#45688a)", marginTop: 4, lineHeight: 1.45 }}>
              {es
                ? <>Es el nombre que tus clientes ven en "Tu agente" cuando abren su portal. Vacío = <b>{currentUser?.name || "tu nombre"}</b>.</>
                : <>The name your clients see under "Your agent" when they open their portal. Empty = <b>{currentUser?.name || "your name"}</b>.</>}
            </div>
          </div>
        )}

        {/* Typography for the agency/company name in outgoing email (Lissette
            2026-07-21: "un editor de letras... esto va en los correos"). Writes
            uiPrefs.companyFont* — auto-saved by the debounced prefs sync, so this
            block needs no Save button of its own. A seat inherits the agent's,
            same rule as the logo and the agency name. */}
        {!isAssistant && (
          <div style={{ marginTop: ".85rem", paddingTop: ".85rem", borderTop: "1px solid var(--c-border,#1a3550)" }}>
            <BrandFontEditor slot="companyFont" prefs={prefs} onSetPref={setPref} previewName={companyName || brandPreviewName} lang={lang} />
          </div>
        )}
      </div>

      {/* Solo agents have no "🏢 Mi Agencia" module (that's owner-only), so the
          agency-name editor lives here in their profile. Owner/admin rename it
          from Mi Agencia → Marca; agents-in-agency and seats can't (backend
          requireOwnerOrSolo blocks them). This panel calls its own endpoint and
          reloads on save — independent of the profile Save button below. */}
      {currentUser?.role === "solo_agent" && (
        <div style={{ marginBottom: "1rem" }}>
          <AgencyNamePanel currentUser={currentUser} lang={lang} userPrefs={prefs} onSetPref={setPref} />
        </div>
      )}

      <div style={{ marginBottom: "1rem" }}>
        <AgencyUsagePanel lang={lang} />
      </div>

      <button onClick={save} style={{ width: "100%", padding: ".65rem", background: saved ? "var(--c-green,#00ff88)" : "var(--c-cyan,#00d4ff)", color: "#0a1628", fontWeight: 800, fontSize: ".88rem", borderRadius: 10, border: "none", cursor: "pointer", transition: "background .3s" }}>{saved ? (es ? "✅ Guardado" : "✅ Saved") : (es ? "💾 Guardar Perfil" : "💾 Save Profile")}</button>

    </div>

    {/* RIGHT: Preview Cards */}
    <div>
      {/* Digital Business Card */}
      <div style={{ fontFamily: "var(--font-display)", fontWeight: 800, fontSize: "1.1rem", color: "var(--c-white,#eef6ff)", marginBottom: ".75rem" }}>🪪 {es ? "Tarjeta Digital" : "Digital Card"}</div>

      <div style={{ background: "linear-gradient(145deg,#0d1c2e,#112538)", border: "1px solid var(--c-border2,#1f3f60)", borderRadius: 16, padding: "1.5rem", marginBottom: ".75rem", position: "relative", overflow: "hidden" }}>
        <div style={{ position: "absolute", top: -30, right: -30, width: 120, height: 120, borderRadius: "50%", background: "rgba(0,212,255,.04)" }} />
        <div style={{ display: "flex", alignItems: "center", gap: "1rem", marginBottom: "1rem" }}>
          {logo ? <img src={logo} alt="logo" style={{ ...estiloDelLogo(formaLogo, 48), background: "#fff" }} /> : <div style={{ width: 48, height: 48, borderRadius: 10, background: f.color || "#1d6fa4", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 800, fontSize: "1rem", color: "#fff" }}>{f.initials || "?"}</div>}
          <div>
            <div style={{ fontFamily: "var(--font-display)", fontWeight: 800, fontSize: "1.05rem", color: "var(--c-white,#eef6ff)" }}>{f.name}</div>
            <div style={{ fontSize: ".74rem", color: "var(--c-cyan,#00d4ff)", fontWeight: 600 }}>{isAssistant ? (f.title || "") : (f.title || "Licensed Insurance Agent")}</div>
          </div>
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: ".35rem", fontSize: ".76rem" }}>
          {contactEmail && <div style={{ color: "var(--c-text2,#7aa3c0)" }}>📧 {contactEmail}</div>}
          {contactEmail2 && <div style={{ color: "var(--c-text2,#7aa3c0)" }}>📧 {contactEmail2}</div>}
          {contactPhone && <div style={{ color: "var(--c-text2,#7aa3c0)" }}>📱 {contactPhone}</div>}
          {officePhone && <div style={{ color: "var(--c-text2,#7aa3c0)" }}>☎️ {officePhone}</div>}
          {whatsappNumber && <div style={{ color: "var(--c-text2,#7aa3c0)" }}>💬 {whatsappNumber}</div>}
          {faxNumber && <div style={{ color: "var(--c-text2,#7aa3c0)" }}>📠 Fax: {faxNumber}</div>}
          {contactWebsite && <div style={{ color: "var(--c-text2,#7aa3c0)" }}>🌐 {contactWebsite}</div>}
          {contactLicense && <div style={{ color: "var(--c-text2,#7aa3c0)" }}>📋 {es ? "Licencias" : "Licensed"}: {contactLicense}</div>}
        </div>
        {companyName && <div style={{ marginTop: ".75rem", paddingTop: ".6rem", borderTop: "1px solid var(--c-border,#1a3550)", fontFamily: "var(--font-display)", fontWeight: 700, fontSize: ".82rem", color: "var(--c-white,#eef6ff)" }}>{companyName}</div>}
        {f.bio && <div style={{ marginTop: ".4rem", fontSize: ".7rem", color: "var(--c-text3,#45688a)", fontStyle: "italic", lineHeight: 1.4 }}>"{f.bio}"</div>}
        <SocialIconRow source={socialSource} size={22} style={{ marginTop: ".7rem" }} />
      </div>

      {/* El enlace publico y el codigo QR (Lissette 2026-08-26). Va PEGADO a la
          vista previa de la tarjeta, que es lo que representa: el enlace abre
          exactamente eso. En otra pestana seria el mismo error que se cometio
          con el nombre de la firma, que estaba lejos de la firma que cambia y
          por eso nadie lo encontraba. */}
      <MyDigitalCard lang={lang} />

      {/* Nombre para la firma. Los agentes pedian firmar con su nombre legal
          completo (o sin el segundo apellido, o con la licencia al lado) sin
          que eso les cambiara el nombre con el que aparecen en Deskte — en
          asignaciones, en el equipo, en los permisos. Vacio deja la firma
          exactamente como estaba. (Lissette 2026-08-25, de parte de los
          agentes.)

          VA AQUI, pegado a la vista previa, y no en la pestana Email donde
          estuvo primero: alli el control quedaba en OTRA pestana distinta de
          la firma que modifica, asi que quien iba a cambiar su firma no lo
          encontraba (Lissette, 2026-08-25: "lo de la firma no sale"). Y la
          pestana Email esta oculta para los asientos, que son precisamente
          quienes firman con su propio nombre — no habrian podido cambiarlo
          NUNCA. El resto de la identidad de la firma (nombre, cargo,
          contactos, compania) tambien se edita en esta pestana: este campo
          pertenece con ellos. */}
      <div style={{ fontSize: ".82rem", fontWeight: 700, color: "var(--c-white,#eef6ff)", marginBottom: ".35rem" }}>🖋️ {es ? "Nombre para la firma" : "Name on the signature"}</div>
      <div style={{ fontSize: ".68rem", color: "var(--c-text3,#45688a)", marginBottom: ".4rem", lineHeight: 1.45 }}>{es ? "Como quieres que aparezca tu nombre en los correos que reciben tus clientes. Dejalo vacio para usar tu nombre de Deskte. Cambiarlo aqui NO cambia tu nombre de agente." : "How you want your name to appear in the emails your clients receive. Leave it empty to use your Deskte name. Changing it here does NOT change your agent name."}</div>
      <input className="dkt-inp" style={{ width: "100%", boxSizing: "border-box", marginBottom: "1rem" }}
        value={prefs.signatureName || ""}
        onChange={e => setPref("signatureName", e.target.value)}
        placeholder={f.name || (es ? "Tu nombre de Deskte" : "Your Deskte name")} />

      {/* Email Signature.
          This block mirrors buildAgentSignature() on the backend field for
          field — before 2026-07-21 it was a preview of a signature that was
          never sent (the mail carried uiPrefs.emailSignature instead, so
          agents who never filled that box got no signature at all, which is
          exactly the "no se ve la firma como sale en el perfil" complaint).
          Keep the two in sync: no avatar fallback when there's no logo,
          because an email cannot render an initials circle. */}
      <div style={{ fontSize: ".82rem", fontWeight: 700, color: "var(--c-white,#eef6ff)", marginBottom: ".5rem" }}>✉️ {es ? "Firma de Correo" : "Email Signature"}</div>

      <div style={{ background: "#ffffff", borderRadius: 10, padding: "1rem 1.1rem", marginBottom: ".4rem", color: "#333" }}>
        <div style={{ display: "flex", alignItems: "flex-start", gap: ".65rem" }}>
          {logoDeLaFirma && <img src={logoDeLaFirma} alt="" style={estiloDelLogo(formaLogo, 44)} />}
          <div style={{ minWidth: 0 }}>
            <div style={{ fontWeight: 700, fontSize: ".85rem", color: "#1a1a1a" }}>{sigName}</div>
            {(isAssistant ? f.title : (f.title || "Licensed Insurance Agent")) && <div style={{ fontSize: ".72rem", color: "#0077b6" }}>{isAssistant ? f.title : (f.title || "Licensed Insurance Agent")}</div>}
            <div style={{ fontSize: ".7rem", color: "#555", marginTop: ".25rem" }}>
              {/* Mismo orden e iconos que la firma que arma el servidor
                  (utils/emailSignature.ts): 📧 correo · 📧 segundo correo ·
                  📱 móvil · ☎️ oficina · 💬 WhatsApp · 📠 fax. Si aquí falta
                  uno, el agente lo escribe, no lo ve, y cree que no se guardó
                  — que es justo lo que pasó con el teléfono de oficina
                  (Lissette 2026-08-19, con captura). */}
              {[
                contactEmail && <span key="e1">📧 {contactEmail}</span>,
                contactEmail2 && <span key="e2">📧 {contactEmail2}</span>,
                contactPhone && <span key="p1">📱 {contactPhone}</span>,
                officePhone && <span key="p2">☎️ {officePhone}</span>,
                whatsappNumber && <span key="wa">💬 {whatsappNumber}</span>,
                faxNumber && <span key="fx">📠 {faxNumber}</span>,
              ].filter(Boolean).map((el, i) => <span key={i}>{i > 0 && <span> | </span>}{el}</span>)}
            </div>
            {contactWebsite && <div style={{ fontSize: ".7rem", color: "#0077b6" }}>🌐 {contactWebsite}</div>}
            {contactLicense && <div style={{ fontSize: ".65rem", color: "#777" }}>📋 {contactLicense}</div>}
            {companyName && <div style={{ ...brandFontStyle(companyFont, Math.min(companyFont.size, 18)), marginTop: ".4rem", paddingTop: ".35rem", borderTop: "1px solid #e5e5e5" }}>{companyName}</div>}
            {/* Icons sit under the company line and above the disclaimer —
                the same order socialLinksHtml() uses in the sent mail. */}
            <SocialIconRow source={socialSource} size={24} gap={6} style={{ marginTop: ".45rem" }} />
            {(prefs.emailSignature || "").trim() && <div style={{ fontSize: ".64rem", color: "#777", marginTop: ".4rem", lineHeight: 1.45, whiteSpace: "pre-wrap" }}>{prefs.emailSignature.trim()}</div>}
          </div>
        </div>
      </div>
      <div style={{ fontSize: ".64rem", color: "var(--c-text3,#45688a)", marginBottom: ".5rem", lineHeight: 1.45 }}>
        {prefs.includeSignature === false
          ? (es ? "⚠️ Está apagada. Enciéndela en Preferencias → Correo para que se adjunte." : "⚠️ Turned off. Enable it under Preferences → Email to attach it.")
          : (es ? "Esto es exactamente lo que se adjunta al final de tus correos. Se arma solo con los datos de arriba." : "This is exactly what gets attached at the end of your emails. It is built from the fields above.")}
      </div>

      <div style={{ display: "flex", gap: ".5rem" }}>
        <button onClick={() => setVistaCorreo(true)} style={{ flex: 1, padding: ".5rem", background: "rgba(0,212,255,.14)", border: "1px solid rgba(0,212,255,.35)", color: "var(--c-cyan,#00d4ff)", fontWeight: 800, fontSize: ".76rem", borderRadius: 8, cursor: "pointer" }}>👁️ {es ? "Ver como la recibe el cliente" : "See it as your client does"}</button>
        <button onClick={copySig} style={{ flex: 1, padding: ".5rem", background: "rgba(0,212,255,.08)", border: "1px solid rgba(0,212,255,.2)", color: "var(--c-cyan,#00d4ff)", fontWeight: 700, fontSize: ".76rem", borderRadius: 8, cursor: "pointer" }}>📋 {es ? "Copiar Firma" : "Copy Signature"}</button>
        <button onClick={() => setShareOpen(true)} style={{ flex: 1, padding: ".5rem", background: "rgba(0,255,136,.08)", border: "1px solid rgba(0,255,136,.2)", color: "var(--c-green,#00ff88)", fontWeight: 700, fontSize: ".76rem", borderRadius: 8, cursor: "pointer" }}>🔗 {es ? "Compartir Tarjeta" : "Share Card"}</button>
      </div>

      {/* CÓMO RECIBE EL CLIENTE EL CORREO, EN GRANDE.
          Lissette 2026-09-23, primero: "no se ve bien, está chiquita, no existe
          la manera de verla grande"; y después, lo que de verdad importaba:
          "lo importante no es el logo, es cómo queda en general la firma que ve
          el cliente". Así que esto NO es un dibujo de la firma: es el correo
          que arma el SERVIDOR con el mismo código que cada envío
          (POST /emails/vista-previa → dressOutgoingHtml). Cabecera de la
          agencia, un texto de ejemplo y la firma entera, tal cual llega. */}
      {vistaCorreo && (
        <Modal title={es ? "👁️ Así recibe el cliente tu correo" : "👁️ How your client receives your email"} onClose={() => setVistaCorreo(false)} xl>
          {!isAssistant && logoDeLaFirma && (
            <div style={{ display: "flex", alignItems: "center", gap: ".5rem", flexWrap: "wrap", marginBottom: ".8rem" }}>
              <span style={{ fontSize: ".72rem", color: "var(--c-text2,#7aa3c0)", fontWeight: 700 }}>{es ? "Forma del logo:" : "Logo shape:"}</span>
              {FORMAS_DEL_LOGO.map(op => {
                const activa = formaLogo === op.id;
                return (
                  <button key={op.id} type="button" onClick={() => setPref("logoShape", op.id)} aria-pressed={activa}
                    style={{ display: "flex", alignItems: "center", gap: ".45rem", padding: ".35rem .7rem .35rem .4rem", background: "#ffffff", borderRadius: 10, cursor: "pointer",
                      border: activa ? "2px solid var(--c-cyan,#00d4ff)" : "2px solid transparent" }}>
                    <img src={logoDeLaFirma} alt="" style={estiloDelLogo(op.id, 30)} />
                    <span style={{ fontSize: ".74rem", fontWeight: 800, color: activa ? "#0077b6" : "#333" }}>{activa ? "✓ " : ""}{es ? op.es : op.en}</span>
                  </button>
                );
              })}
            </div>
          )}
          <div style={{ background: "#ffffff", border: "1px solid #d7dee8", borderRadius: 10, overflow: "hidden", boxShadow: "0 6px 18px rgba(0,0,0,.25)" }}>
            <div style={{ background: "#f3f6fb", borderBottom: "1px solid #e3e9f2", padding: ".6rem .9rem", fontSize: ".76rem", color: "#334155", lineHeight: 1.6 }}>
              <div><b>{es ? "De:" : "From:"}</b> {sigName}{contactEmail ? ` <${contactEmail}>` : ""}</div>
              <div><b>{es ? "Para:" : "To:"}</b> {es ? "María (cliente de ejemplo)" : "Maria (sample client)"}</div>
            </div>
            <div style={{ padding: "1rem 1.2rem", color: "#1a2332", fontFamily: "Arial,Helvetica,sans-serif", fontSize: "14px", lineHeight: 1.5, maxHeight: "60vh", overflowY: "auto", wordBreak: "break-word" }}>
              {correoDeMuestra.cargando && !correoDeMuestra.html
                ? <div style={{ color: "#64748b", padding: "2rem 0", textAlign: "center" }}>{es ? "Armando el correo…" : "Building the email…"}</div>
                : correoDeMuestra.error
                  ? <div style={{ color: "#b91c1c", padding: "1rem 0" }}>{es ? "No se pudo cargar la vista previa: " : "Couldn't load the preview: "}{correoDeMuestra.error}</div>
                  : <div dangerouslySetInnerHTML={safeHtml(correoDeMuestra.html)} />}
            </div>
          </div>
          <div style={{ fontSize: ".68rem", color: "var(--c-text3,#45688a)", marginTop: ".55rem", lineHeight: 1.5 }}>
            {correoDeMuestra.sinRemitente
              ? (es ? "⚠️ No tienes un agente asignado, así que no hay firma que enseñar." : "⚠️ You have no supervising agent assigned, so there is no signature to show.")
              : (es ? "Es el correo de verdad, armado igual que cuando envías. Sale con lo que tienes GUARDADO: si cambiaste datos arriba, pulsa Guardar y vuelve a abrir esto." : "This is the real email, built exactly as when you send. It uses what you have SAVED: if you changed anything above, press Save and reopen this.")}
            {prefs.includeSignature === false && (es ? " ⚠️ Tu firma está apagada (Preferencias → Correo)." : " ⚠️ Your signature is turned off (Preferences → Email).")}
          </div>
        </Modal>
      )}

      {shareOpen && (
        <Modal title={es ? "🔗 Compartir Tarjeta" : "🔗 Share Card"} onClose={() => setShareOpen(false)}>
            {/* Card preview — NPN intentionally excluded */}
            <div style={{ background: "linear-gradient(145deg,#0d1c2e,#112538)", border: "1px solid var(--c-border2,#1f3f60)", borderRadius: 14, padding: "1.1rem", marginBottom: ".9rem" }}>
              <div style={{ display: "flex", alignItems: "center", gap: ".8rem", marginBottom: ".7rem" }}>
                {logo ? <img src={logo} alt="" style={{ ...estiloDelLogo(formaLogo, 44), background: "#fff" }} /> : <div style={{ width: 44, height: 44, borderRadius: 10, background: f.color || "#1d6fa4", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 800, color: "#fff" }}>{f.initials || "?"}</div>}
                <div>
                  <div style={{ fontFamily: "var(--font-display)", fontWeight: 800, fontSize: "1rem", color: "var(--c-white,#eef6ff)" }}>{cardName}</div>
                  {cardTitle && <div style={{ fontSize: ".72rem", color: "var(--c-cyan,#00d4ff)", fontWeight: 600 }}>{cardTitle}</div>}
                </div>
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: ".3rem", fontSize: ".74rem" }}>
                {contactEmail && <div style={{ color: "var(--c-text2,#7aa3c0)" }}>📧 {contactEmail}</div>}
                {contactPhone && <div style={{ color: "var(--c-text2,#7aa3c0)" }}>📱 {contactPhone}</div>}
                {contactWebsite && <div style={{ color: "var(--c-text2,#7aa3c0)" }}>🌐 {contactWebsite}</div>}
                {contactLicense && <div style={{ color: "var(--c-text2,#7aa3c0)" }}>📋 {es ? "Licencias" : "Licensed"}: {contactLicense}</div>}
              </div>
              {companyName && <div style={{ marginTop: ".7rem", paddingTop: ".55rem", borderTop: "1px solid var(--c-border,#1a3550)", fontFamily: "var(--font-display)", fontWeight: 700, fontSize: ".8rem", color: "var(--c-white,#eef6ff)" }}>{companyName}</div>}
              <SocialIconRow source={socialSource} size={20} style={{ marginTop: ".6rem" }} />
            </div>

            <div style={{ fontSize: ".66rem", color: "var(--c-text3,#45688a)", marginBottom: ".7rem", lineHeight: 1.4 }}>{es ? "Guarda el contacto para que la persona lo agregue a su teléfono, o copia los datos para pegarlos donde quieras." : "Save the contact so the recipient can add it to their phone, or copy the details to paste anywhere."}</div>

            <div style={{ display: "flex", flexDirection: "column", gap: ".5rem" }}>
              <button onClick={downloadVCard} style={{ width: "100%", padding: ".6rem", background: "var(--c-cyan,#00d4ff)", color: "#0a1628", fontWeight: 800, fontSize: ".82rem", border: "none", borderRadius: 9, cursor: "pointer" }}>📇 {es ? "Guardar contacto (.vcf)" : "Save contact (.vcf)"}</button>
              {canNativeShare && <button onClick={nativeShareCard} style={{ width: "100%", padding: ".6rem", background: "rgba(0,255,136,.1)", border: "1px solid rgba(0,255,136,.25)", color: "var(--c-green,#00ff88)", fontWeight: 700, fontSize: ".82rem", borderRadius: 9, cursor: "pointer" }}>📤 {es ? "Compartir…" : "Share…"}</button>}
              <button onClick={copyCardText} style={{ width: "100%", padding: ".6rem", background: "rgba(0,212,255,.08)", border: "1px solid rgba(0,212,255,.2)", color: "var(--c-cyan,#00d4ff)", fontWeight: 700, fontSize: ".82rem", borderRadius: 9, cursor: "pointer" }}>📋 {es ? "Copiar datos" : "Copy details"}</button>
            </div>
            {shareMsg && <div style={{ textAlign: "center", marginTop: ".6rem", fontSize: ".72rem", color: "var(--c-green,#00ff88)", fontWeight: 700 }}>{shareMsg}</div>}
        </Modal>
      )}
    </div>
  </div>}
  </div>;
}

// Espejo del estado en un ref.
//
// Existe por un motivo muy concreto: el updater de `setState(prev => ...)`
// tiene que ser PURO. React puede llamarlo MAS DE UNA VEZ para un solo cambio
// (modo estricto en desarrollo, y re-render concurrente en produccion), asi que
// una llamada al servidor metida ahi dentro se dispara dos y tres veces. Eso es
// exactamente lo que reportaron el 2026-08-20 en Seguimiento/Envios: un clic en
// "Gift Card manual" o "Documento manual" creaba la fila varias veces.
//
// Con el espejo, cada handle*Change calcula el siguiente valor FUERA del
// updater, dispara los efectos UNA vez y luego asigna el estado.
function useMirror(value) {
  const ref = useRef(value);
  ref.current = value;
  return ref;
}

/* ─── Campaigns View ─── */
function CampaignsView({ clients, currentUser, holidayTemplates, onHolidayChange, emailTemplates, onEmailChange, customTemplates, onCustomChange, lang }) {
  const es = lang === "es";
  const [tab, setTab] = useState("holidays");
  const [previewLang, setPreviewLang] = useState(lang);
  const pl = previewLang === "es";
  const [editItem, setEditItem] = useState(null);
  const [previewItem, setPreviewItem] = useState(null);
  const [form, setForm] = useState({});
  // Click-to-insert variables for the greeting/template editors (edit + new
  // custom). One inserter serves both since bind() tracks the last-focused field.
  const varIns = useVarInserter();

  // "As it arrives" preview: rendered HTML for the 👁 modal (EN + ES). Built
  // by filling {{variables}} with sample data and re-signing the image SAS so
  // pasted images actually show (the saved display SAS expires → broken <img>).
  const [previewHtml, setPreviewHtml] = useState({ en: "", es: "", loading: false });
  const previewSample = useMemo(
    () => (clients || []).find((c) => c.firstName) || { firstName: es ? "María" : "Maria", lastName: es ? "Pérez" : "Perez" },
    [clients, es],
  );
  const fillSample = (t) => (t || "")
    .replace(/\{\{firstName\}\}/g, previewSample.firstName || "")
    .replace(/\{\{lastName\}\}/g, previewSample.lastName || "")
    .replace(/\{\{agentName\}\}/g, presentingAgentName(currentUser));
  useEffect(() => {
    if (!previewItem) { setPreviewHtml({ en: "", es: "", loading: false }); return; }
    let cancelled = false;
    // Shape the body the SAME way the send path does (blank line → paragraph,
    // single newline → <br>) so the preview matches the recipient's inbox.
    const toHtml = (t) => fillSample(t).split(/\n\n+/).map((p) => `<p style="margin:0 0 12px">${p.replace(/\n/g, "<br>")}</p>`).join("");
    const enRaw = toHtml(previewItem.body);
    const esRaw = toHtml(previewItem.bodyEs);
    setPreviewHtml({ en: enRaw, es: esRaw, loading: true });
    (async () => {
      let en = enRaw, esH = esRaw;
      try {
        const { signEmailImages } = await import("./crm-app/api.js");
        [en, esH] = await Promise.all([signEmailImages(enRaw), signEmailImages(esRaw)]);
      } catch { /* keep unsigned — text still renders */ }
      if (!cancelled) setPreviewHtml({ en, es: esH, loading: false });
    })();
    return () => { cancelled = true; };
  }, [previewItem, previewSample, currentUser]);

  const [sendModal, setSendModal] = useState(null); // {template, type}
  const [showNewCustom, setShowNewCustom] = useState(false);
  const [newForm, setNewForm] = useState({ name:"", nameEs:"", emoji:"🎉", subject:"", subjectEs:"", body:"", bodyEs:"" });
  const EMOJIS = ["🎉","🎊","🙏","❤️","🌟","🏆","📣","🎁","💐","🤝","✨","🔔","🎯","💫","🌺","🦋"];


  const openEdit = (item, type) => {
    setForm({ ...item });
    setEditItem({ item, type });
  };
  const saveEdit = () => {
    if (!editItem) return;
    if (editItem.type === "holiday") onHolidayChange(prev => prev.map(h => h.id === form.id ? { ...h, ...form } : h));
    else if (editItem.type === "custom") onCustomChange(prev => prev.map(t => t.id === form.id ? { ...t, ...form } : t));
    else onEmailChange(prev => prev.map(t => t.id === form.id ? { ...t, ...form } : t));
    setEditItem(null);
  };

  const highlightVars = (text) => {
    if (!text) return "";
    return text.split(/(\{\{[^}]+\}\})/).map((part, i) =>
      part.startsWith("{{") ? <span key={i} style={{ background: "rgba(0,212,255,.15)", color: "var(--c-cyan,#00d4ff)", padding: "0 3px", borderRadius: 3, fontFamily: "var(--font-mono)", fontSize: ".75rem" }}>{part}</span> : part
    );
  };
  // Preview render: when the body carries a pasted/uploaded <img>, render it as
  // HTML so the image actually shows (same as Mass Email). Plain-text templates
  // keep the {{variable}} highlighting. pre-wrap on the container preserves the
  // template's line breaks in both cases.
  const renderBody = (text) =>
    (text || "").includes("<img")
      ? <span dangerouslySetInnerHTML={safeHtml(text)} />
      : highlightVars(text);

  const customs = customTemplates || [];
  const TABS = [["holidays", "🎉 Holidays", holidayTemplates.length], ["emails", "📧 Email", emailTemplates.length], ["custom", "✨ Custom", customs.length]];
  const S = {
    card: { background: "var(--c-surface2,#112538)", border: "1px solid var(--c-border,#1a3550)", borderRadius: 10, padding: ".85rem", marginBottom: ".5rem" },
    // Etiqueta + control del bloque RECURRENCIA del modal de envío masivo.
    lbl: { fontSize: ".62rem", color: "var(--c-text3,#45688a)", fontWeight: 700, textTransform: "uppercase", letterSpacing: ".05em", marginBottom: 3 },
    inp: { width: "100%", boxSizing: "border-box", background: "var(--c-surface,#0d1c2e)", border: "1px solid var(--c-border,#1a3550)", borderRadius: 7, padding: ".38rem .5rem", fontSize: ".78rem", color: "var(--c-text,#c8dff0)", fontFamily: "inherit", outline: "none" },
  };

  const fillTpl = (tmpl, c) => (tmpl||"").replace(/\{\{firstName\}\}/g, c.firstName||"").replace(/\{\{lastName\}\}/g, c.lastName||"").replace(/\{\{agentName\}\}/g, presentingAgentName(currentUser));
  // Batch send confirmation + progress state. The old doSend fired N
  // mailto:/wa.me/sms: links in a forEach loop, which (a) triggered
  // Chrome's "choose external app" popup the first time, (b) was
  // silently blocked after the first few, and (c) never actually sent
  // anything because we never persisted to /clients/:id/emails.
  // New flow: confirm modal → loop sendClientEmail with progress, log
  // per-recipient failures, show a real summary at the end.
  const [batchConfirm, setBatchConfirm] = useState(null); // {channel, tpl, allCandidates, statusFilter, msgLang}
  const [batchProgress, setBatchProgress] = useState({
    active: false, current: 0, total: 0, currentLabel: '',
    succeeded: 0, failed: [],
  });

  // Recipient picker lives inside the confirm modal — same pattern as the
  // Mass Email compose tab. We pre-compute all candidates (clients with the
  // channel contact field) once on open, then the status filter + search +
  // per-row checkbox toggles all narrow visibility / mutate the selected
  // Set on the fly. selectedIds is the source of truth for what gets sent.
  const visibleBatchCandidates = (bc) => {
    if (!bc) return [];
    const list = bc.allCandidates || [];
    const q = (bc.search || '').trim().toLowerCase();
    const sf = bc.statusFilter || 'active';
    return list.filter(c => {
      if (sf !== 'all' && (c.status || '').toLowerCase() !== sf) return false;
      if (q) {
        const hay = `${c.firstName || ''} ${c.lastName || ''} ${c.email || ''}`.toLowerCase();
        if (!hay.includes(q)) return false;
      }
      return true;
    });
  };
  const selectedBatchRecipients = (bc) => {
    if (!bc) return [];
    const sel = bc.selectedIds;
    if (!sel || sel.size === 0) return [];
    return (bc.allCandidates || []).filter(c => sel.has(c.id));
  };

  const doSend = (channel, tpl) => {
    // Bring in every client that has the channel's contact field on file.
    // Status filtering + per-row deselection happens inside the modal so
    // the agent can fine-tune the list before pulling the trigger.
    const allWithContact = clients.filter(c => channel === "email" ? c.email : c.phone);
    if (allWithContact.length === 0) {
      toast.error(es ? `No hay clientes con ${channel === 'email' ? 'email' : 'teléfono'}` : `No clients with ${channel === 'email' ? 'email' : 'phone'}`);
      return;
    }
    // WhatsApp / SMS don't have a backend send yet. Firing N tabs at
    // once is exactly the "leave the app" experience we're trying to
    // kill — surface that and tell the user where to send instead.
    if (channel === 'whatsapp' || channel === 'sms') {
      toast.error(es
        ? `Envío masivo por ${channel === 'whatsapp' ? 'WhatsApp' : 'SMS'} aún no disponible. Envía individualmente desde el perfil de cada cliente.`
        : `Bulk ${channel === 'whatsapp' ? 'WhatsApp' : 'SMS'} send isn't supported yet. Send individually from each client's profile.`);
      setSendModal(null);
      return;
    }
    // Stage the confirmation modal. msgLang is its OWN state on the
    // modal so the user can flip EN/ES at send time. statusFilter +
    // search drive what's VISIBLE in the picker; selectedIds is the
    // source of truth for what actually gets sent. We pre-select all
    // active candidates so the historical one-click "send to actives"
    // workflow still works — the agent can untick rows or click
    // "Limpiar" + select inactive ones to deviate.
    const activeIds = new Set(
      allWithContact
        .filter(c => (c.status || '').toLowerCase() === 'active')
        .map(c => c.id)
    );
    setBatchConfirm({
      channel,
      tpl,
      allCandidates: allWithContact,
      statusFilter: 'active',
      search: '',
      selectedIds: activeIds,
      msgLang: pl ? 'es' : 'en',
      scheduleAt: '',
    });
  };

  const runBatchSend = async () => {
    if (!batchConfirm) return;
    const { tpl, msgLang, scheduleAt } = batchConfirm;
    const recipients = selectedBatchRecipients(batchConfirm);
    if (recipients.length === 0) {
      toast.error(es ? 'No hay destinatarios seleccionados' : 'No recipients selected');
      return;
    }
    const isEs = msgLang === 'es';
    // ── Repetir: en vez de encolar N envíos de una vez, se guarda UNA regla y
    // el servidor la dispara sola cada vuelta. Sale antes del bucle de abajo a
    // propósito: encolar además los de hoy duplicaría el primer envío, porque
    // la regla ya lo incluye. ──
    if (batchConfirm.repeat) {
      if (!scheduleAt) {
        toast.error(es ? 'Pon la fecha y hora del primer envío' : 'Set the date and time of the first send');
        return;
      }
      const d = new Date(scheduleAt);
      const hhmm = `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
      const scope = batchConfirm.statusFilter || 'active';
      try {
        await apiCreateRecurringCampaign({
          name: (isEs ? tpl.nameEs : tpl.name) || tpl.name || 'Campaña',
          templateId: tpl.id,
          subject: isEs ? tpl.subjectEs : tpl.subject,
          htmlBody: isEs ? tpl.bodyEs : tpl.body,
          // La pestaña elegida es la CONDICIÓN; lo que quedó destildado dentro
          // de esa pestaña son las exclusiones fijas. Guardar las dos cosas es
          // lo que permite que un cliente nuevo entre solo en las vueltas
          // siguientes, sin volver a meter a quien se sacó a mano.
          audienceScope: scope,
          excludeIds: (batchConfirm.allCandidates || [])
            .filter(c => scope === 'all'
              || (c.status || '').toLowerCase() === scope)
            .filter(c => !(batchConfirm.selectedIds || new Set()).has(c.id))
            .map(c => c.id),
          frequency: batchConfirm.frequency || 'MONTHLY',
          intervalCount: batchConfirm.intervalCount || 1,
          dayOfWeek: batchConfirm.dayOfWeek ?? d.getDay(),
          dayOfMonth: batchConfirm.dayOfMonth ?? Math.min(28, d.getDate()),
          timeOfDay: hhmm,
          endsAt: batchConfirm.endsAt || null,
          maxOccurrences: batchConfirm.maxOccurrences || null,
        });
        setBatchConfirm(null);
        setSendModal(null);
        toast.success(es ? '🔁 Campaña recurrente creada. Se enviará sola.' : '🔁 Recurring campaign created. It will send on its own.');
      } catch (err) {
        toast.error((es ? 'No se pudo crear: ' : "Couldn't create: ") + (err?.message || ''));
      }
      return;
    }

    setBatchConfirm(null);
    setBatchProgress({ active: true, current: 0, total: recipients.length, currentLabel: '', succeeded: 0, failed: [] });
    // If a future date is set, queue one ScheduledSend per recipient
    // instead of firing the campaign now. Same source label the Mass
    // Email view uses so the Scheduled Sends list groups them together.
    const runAtIso = scheduleAt ? new Date(scheduleAt).toISOString() : null;
    for (let i = 0; i < recipients.length; i++) {
      const c = recipients[i];
      const label = `${c.firstName || ''} ${c.lastName || ''}`.trim() || c.email || `Fila ${i + 1}`;
      setBatchProgress(p => ({ ...p, current: i + 1, currentLabel: label }));
      const subj = fillTpl(isEs ? tpl.subjectEs : tpl.subject, c);
      const bodyText = fillTpl(isEs ? tpl.bodyEs : tpl.body, c);
      try {
        if (runAtIso) {
          await apiCreateScheduledSend({
            clientId: c.id,
            channel: 'email',
            recipient: c.email,
            subject: subj,
            body: bodyText,
            runAt: runAtIso,
            source: 'campaign',
          });
        } else {
          const html = bodyText.split(/\n\n+/).map(p => `<p>${p.replace(/\n/g, '<br>')}</p>`).join('');
          await apiSendClientEmail(c.id, { subject: subj, html, text: bodyText });
        }
        setBatchProgress(p => ({ ...p, succeeded: p.succeeded + 1 }));
      } catch (err) {
        setBatchProgress(p => ({ ...p, failed: [...p.failed, { label, error: err.message }] }));
      }
    }
    if (runAtIso) {
      const at = new Date(scheduleAt).toLocaleString('en-US', { dateStyle: 'medium', timeStyle: 'short' });
      toast.success(es ? `📅 Programados para ${at}` : `📅 Scheduled for ${at}`);
    }
    // Brief pause so the final counts are visible, then close.
    setTimeout(() => setBatchProgress(p => ({ ...p, active: false })), 1500);
    setSendModal(null);
  };
  const addCustom = () => {
    // Accept a name in EITHER language. The old guard required the ENGLISH
    // name, so filling only the Spanish side silently did nothing ("no me deja
    // guardar"). The backend REQUIRES `name`, so backfill it from nameEs.
    const nm = (newForm.name || "").trim();
    const nmEs = (newForm.nameEs || "").trim();
    if (!nm && !nmEs) { toast.error(es ? "Ponle un nombre a la plantilla." : "Give the template a name."); return; }
    onCustomChange(prev => [...prev, { ...newForm, name: nm || nmEs, nameEs: nmEs || nm, id: "ct_" + Date.now() }]);
    setNewForm({ name:"", nameEs:"", emoji:"🎉", subject:"", subjectEs:"", body:"", bodyEs:"" });
    setShowNewCustom(false);
    toast.success(es ? "Plantilla guardada ✓" : "Template saved ✓");
  };
  const deleteCustom = (id) => onCustomChange(prev => prev.filter(t => t.id !== id));

  // AI translate the template content from one language column to the other,
  // reusing the same Azure-OpenAI endpoint as the doc/signature templates.
  // dir 'toEs' = EN→ES, 'toEn' = ES→EN. Translates name + subject + body and
  // preserves {{variables}}. Used by both the new-custom form and the edit modal.
  const [translating, setTranslating] = useState(false);
  const translateInto = async (formObj, setFormFn, dir) => {
    const from = dir === "toEs" ? "en" : "es";
    const to = dir === "toEs" ? "es" : "en";
    const srcName = dir === "toEs" ? formObj.name : formObj.nameEs;
    const srcSubj = dir === "toEs" ? formObj.subject : formObj.subjectEs;
    const srcBody = dir === "toEs" ? formObj.body : formObj.bodyEs;
    if (!((srcName || "").trim() || (srcSubj || "").trim() || (srcBody || "").trim())) {
      toast.error(es ? `Escribe el texto en ${from === "en" ? "inglés" : "español"} primero.` : `Write the ${from === "en" ? "English" : "Spanish"} text first.`);
      return;
    }
    setTranslating(true);
    try {
      const { aiTranslateTemplate } = await import("./crm-app/api.js");
      const tr = async (text) => (text || "").trim() ? ((await aiTranslateTemplate({ text, fromLang: from, toLang: to })).translated || "") : "";
      const [n, s, b] = await Promise.all([tr(srcName), tr(srcSubj), tr(srcBody)]);
      setFormFn(f => dir === "toEs"
        ? { ...f, nameEs: n || f.nameEs, subjectEs: s || f.subjectEs, bodyEs: b || f.bodyEs }
        : { ...f, name: n || f.name, subject: s || f.subject, body: b || f.body });
      toast.success(es ? "Traducido ✓ revisa antes de guardar" : "Translated ✓ review before saving");
    } catch (e) {
      toast.error((es ? "No se pudo traducir: " : "Could not translate: ") + (e?.message || ""));
    } finally { setTranslating(false); }
  };
  // Small EN↔ES translate button pair for a template editor (new or edit).
  const TranslateBtns = ({ formObj, setFormFn }) => (
    <div style={{ display: "flex", gap: ".4rem", alignItems: "center", flexWrap: "wrap", margin: ".25rem 0 .5rem" }}>
      <span style={{ fontSize: ".65rem", color: "var(--c-text3,#45688a)", fontWeight: 700 }}>🌐 {es ? "Traducir con AI:" : "AI translate:"}</span>
      <button type="button" disabled={translating} onClick={() => translateInto(formObj, setFormFn, "toEs")}
        style={{ padding: "3px 9px", borderRadius: 6, border: "1px solid var(--c-border,#1a3550)", background: "var(--c-surface2,#112538)", color: "var(--c-text2,#7aa3c0)", fontSize: ".68rem", fontWeight: 700, cursor: translating ? "not-allowed" : "pointer", opacity: translating ? .6 : 1 }}>
        🇺🇸 → 🇪🇸
      </button>
      <button type="button" disabled={translating} onClick={() => translateInto(formObj, setFormFn, "toEn")}
        style={{ padding: "3px 9px", borderRadius: 6, border: "1px solid var(--c-border,#1a3550)", background: "var(--c-surface2,#112538)", color: "var(--c-text2,#7aa3c0)", fontSize: ".68rem", fontWeight: 700, cursor: translating ? "not-allowed" : "pointer", opacity: translating ? .6 : 1 }}>
        🇪🇸 → 🇺🇸
      </button>
      {translating && <span style={{ fontSize: ".65rem", color: "var(--c-cyan,#00d4ff)" }}>{es ? "traduciendo…" : "translating…"}</span>}
    </div>
  );

  return <div style={{ padding: "1rem" }}>
    {/* Header */}
    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "1rem" }}>
      <div>
        <div style={{ fontFamily: "var(--font-display)", fontWeight: 800, fontSize: "1.1rem", color: "var(--c-white,#eef6ff)" }}>📣 {es ? "Campañas" : "Campaigns"}</div>
        <div style={{ fontSize: ".72rem", color: "var(--c-text3,#45688a)" }}>{es ? "Plantillas de mensajes • Email, WhatsApp, SMS" : "Message templates • Email, WhatsApp, SMS"}</div>
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: ".5rem" }}>
        <span style={{ fontSize: ".68rem", color: "var(--c-text3,#45688a)" }}>{es ? "Idioma preview:" : "Preview lang:"}</span>
        <button onClick={() => setPreviewLang("en")} style={{ padding: "3px 10px", borderRadius: 6, border: previewLang === "en" ? "1px solid var(--c-cyan,#00d4ff)" : "1px solid var(--c-border,#1a3550)", background: previewLang === "en" ? "rgba(0,212,255,.1)" : "transparent", color: previewLang === "en" ? "var(--c-cyan,#00d4ff)" : "var(--c-text3,#45688a)", fontSize: ".7rem", fontWeight: 600, cursor: "pointer" }}>🇺🇸 EN</button>
        <button onClick={() => setPreviewLang("es")} style={{ padding: "3px 10px", borderRadius: 6, border: previewLang === "es" ? "1px solid var(--c-amber,#ffb700)" : "1px solid var(--c-border,#1a3550)", background: previewLang === "es" ? "rgba(255,183,0,.1)" : "transparent", color: previewLang === "es" ? "var(--c-amber,#ffb700)" : "var(--c-text3,#45688a)", fontSize: ".7rem", fontWeight: 600, cursor: "pointer" }}>🇪🇸 ES</button>
      </div>
    </div>
    {/* Tabs */}
    <div style={{ display: "flex", gap: ".4rem", marginBottom: "1rem" }}>
      {TABS.map(([id, label, count]) => <button key={id} onClick={() => setTab(id)} style={{ padding: ".45rem .85rem", borderRadius: 8, border: tab === id ? "1px solid var(--c-cyan,#00d4ff)" : "1px solid var(--c-border,#1a3550)", background: tab === id ? "rgba(0,212,255,.1)" : "transparent", color: tab === id ? "var(--c-cyan,#00d4ff)" : "var(--c-text2,#7aa3c0)", fontSize: ".78rem", fontWeight: 600, cursor: "pointer" }}>{label} ({count})</button>)}
    </div>

    {/* ── Template Card renderer ── */}
    {(tab === "holidays" || tab === "emails" || tab === "custom") && <div>
      {tab === "holidays" && <div style={{ fontSize: ".7rem", color: "var(--c-text3,#45688a)", marginBottom: ".75rem" }}>{es ? "Plantillas de saludo para feriados de USA." : "US holiday greeting templates."}</div>}
      {tab === "emails" && <div style={{ fontSize: ".7rem", color: "var(--c-text3,#45688a)", marginBottom: ".75rem" }}>{es ? "Plantillas de email para comunicaciones con clientes." : "Email templates for client communications."}</div>}
      {tab === "custom" && <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: ".75rem" }}>
        <div style={{ fontSize: ".7rem", color: "var(--c-text3,#45688a)" }}>{es ? "Plantillas personalizadas para ocasiones especiales." : "Custom templates for special occasions."}</div>
        <button onClick={() => setShowNewCustom(true)} style={{ display: "flex", alignItems: "center", gap: 4, padding: "5px 12px", background: "var(--c-cyan,#00d4ff)", color: "#0a1628", fontSize: ".72rem", fontWeight: 700, borderRadius: 7, border: "none", cursor: "pointer" }}>+ {es ? "Nueva Plantilla" : "New Template"}</button>
      </div>}
      {(tab === "holidays" ? holidayTemplates : tab === "emails" ? emailTemplates : customs).map(tpl => <div key={tpl.id} style={S.card}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: ".4rem" }}>
          <div style={{ display: "flex", alignItems: "center", gap: ".5rem" }}>
            {tpl.emoji && <span style={{ fontSize: "1.2rem" }}>{tpl.emoji}</span>}
            <div>
              <div style={{ fontSize: ".84rem", fontWeight: 700, color: "var(--c-white,#eef6ff)" }}>{pl ? (tpl.nameEs || tpl.name) : tpl.name}</div>
              {/* La fecha DE ESTE AÑO, calculada — no el `day` guardado. Ocho
                  feriados son moviles y su dia guardado es el del año en que
                  se escribio la lista, asi que esta etiqueta decia 10/13 para
                  el Dia de los Indigenas cuando en 2026 cae el 12 (E-293). */}
              {tpl.month && (() => { const d = holidayDateForYear(tpl, new Date().getFullYear());
                return <div style={{ fontSize: ".65rem", color: "var(--c-text3,#45688a)" }}>{String(d.getMonth() + 1).padStart(2, "0")}/{String(d.getDate()).padStart(2, "0")}</div>; })()}
            </div>
          </div>
          {/* Iconos de accion de la tarjeta. Estaban a .65rem — unos 10px — y
              se veian como manchitas indistinguibles (Lissette 2026-08-07, con
              captura). Se suben a 1.05rem con un area de pulsado de 32px, que
              es el minimo comodo con raton, y los tres que no lo tenian ganan
              su title: el icono solo no dice que hace. TPL_ACTION_BTN centraliza
              el tamano para que enviar / ver / editar / borrar queden iguales. */}
          <div style={{ display: "flex", gap: ".35rem", alignItems: "center" }}>
            {CHANNEL_BTNS.map(ch => <button key={ch.id} onClick={() => doSend(ch.id, tpl)} title={`${es ? "Enviar por" : "Send via"} ${ch.id}`} style={{ ...TPL_ACTION_BTN, background: `${ch.color}15`, border: `1px solid ${ch.color}30`, color: ch.color }}>{ch.icon}</button>)}
            <button onClick={() => setPreviewItem({ ...tpl })} title={es ? "Vista previa" : "Preview"} style={{ ...TPL_ACTION_BTN, border: "1px solid var(--c-border,#1a3550)", background: "transparent", color: "var(--c-text2,#7aa3c0)" }}>👁</button>
            <button onClick={() => openEdit(tpl, tab === "holidays" ? "holiday" : tab === "custom" ? "custom" : "email")} title={es ? "Editar" : "Edit"} style={{ ...TPL_ACTION_BTN, border: "1px solid rgba(0,212,255,.25)", background: "rgba(0,212,255,.06)", color: "var(--c-cyan,#00d4ff)" }}>✏️</button>
            {tab === "custom" && <button onClick={() => deleteCustom(tpl.id)} title={es ? "Borrar plantilla" : "Delete template"} style={{ ...TPL_ACTION_BTN, border: "1px solid rgba(255,61,107,.25)", background: "rgba(255,61,107,.06)", color: "#ff3d6b" }}>🗑</button>}
          </div>
        </div>
        <div style={{ background: "var(--c-surface,#0d1c2e)", borderRadius: 7, padding: ".5rem .65rem" }}>
          <div style={{ fontSize: ".72rem", fontWeight: 600, color: "var(--c-white,#eef6ff)", marginBottom: 2 }}>{pl ? (tpl.subjectEs || tpl.subject) : tpl.subject}</div>
          <div style={{ fontSize: ".66rem", color: "var(--c-text3,#45688a)", whiteSpace: "pre-wrap", maxHeight: 45, overflow: "hidden" }}>{((pl ? (tpl.bodyEs || tpl.body) : tpl.body) || "").replace(/<img[^>]*>/gi, "🖼️").substring(0, 120)}...</div>
        </div>
      </div>)}
      {tab === "custom" && customs.length === 0 && !showNewCustom && <div style={{ textAlign: "center", padding: "2rem", color: "var(--c-text3,#45688a)", fontSize: ".8rem" }}>
        {es ? "Sin plantillas personalizadas. Crea una para empezar." : "No custom templates. Create one to get started."}
      </div>}
    </div>}

    {/* New Custom Template Form */}
    {showNewCustom && <div className="dkt-card" style={{ padding: "1.25rem", marginTop: ".5rem" }}>
      <div style={{ fontWeight: 700, fontSize: ".88rem", color: "var(--c-white,#eef6ff)", marginBottom: ".75rem" }}>✨ {es ? "Nueva Plantilla Personalizada" : "New Custom Template"}</div>
      <div style={{ display: "flex", gap: ".5rem", marginBottom: ".65rem", alignItems: "center" }}>
        <div style={{ display: "flex", gap: 3 }}>{EMOJIS.map(e => <button key={e} onClick={() => setNewForm(f => ({ ...f, emoji: e }))} style={{ padding: "3px 5px", fontSize: "1rem", borderRadius: 5, border: newForm.emoji === e ? "2px solid var(--c-cyan,#00d4ff)" : "1px solid var(--c-border,#1a3550)", background: newForm.emoji === e ? "rgba(0,212,255,.1)" : "transparent", cursor: "pointer", lineHeight: 1 }}>{e}</button>)}</div>
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: ".5rem", flexWrap: "wrap", marginBottom: ".4rem" }}>
        <TranslateBtns formObj={newForm} setFormFn={setNewForm} />
        <AiDraftButton lang={lang} contextHint="This is a reusable greeting/holiday email template sent to insurance clients. Address the reader with {{firstName}}." onResult={({ subject, body, lang: dl }) => setNewForm(f => dl === 'es' ? { ...f, subjectEs: subject, bodyEs: body } : { ...f, subject, body })} />
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: ".75rem" }}>
        <div>
          <div style={{ fontSize: ".62rem", fontWeight: 800, color: "var(--c-cyan,#00d4ff)", marginBottom: ".3rem", fontFamily: "var(--font-mono)" }}>🇺🇸 ENGLISH</div>
          <input value={newForm.name} onChange={e => setNewForm(f => ({ ...f, name: e.target.value }))} placeholder="Template name" style={{ width: "100%", background: "var(--c-surface2,#112538)", border: "1px solid var(--c-border,#1a3550)", borderRadius: 7, padding: "6px 10px", color: "var(--c-white,#eef6ff)", fontSize: ".78rem", outline: "none", boxSizing: "border-box", marginBottom: ".35rem" }} />
          <input value={newForm.subject} onChange={e => setNewForm(f => ({ ...f, subject: e.target.value }))} {...varIns.bind(() => newForm.subject || "", v => setNewForm(f => ({ ...f, subject: v })))} placeholder="Subject line" style={{ width: "100%", background: "var(--c-surface2,#112538)", border: "1px solid var(--c-border,#1a3550)", borderRadius: 7, padding: "6px 10px", color: "var(--c-white,#eef6ff)", fontSize: ".78rem", outline: "none", boxSizing: "border-box", marginBottom: ".35rem" }} />
          <EmailRichEditor value={newForm.body || ""} onChange={v => setNewForm(f => ({ ...f, body: v }))} inserter={varIns} lang={lang} minHeight={130} placeholder={"Message body…"} />
        </div>
        <div>
          <div style={{ fontSize: ".62rem", fontWeight: 800, color: "var(--c-amber,#ffb700)", marginBottom: ".3rem", fontFamily: "var(--font-mono)" }}>🇪🇸 ESPAÑOL</div>
          <input value={newForm.nameEs} onChange={e => setNewForm(f => ({ ...f, nameEs: e.target.value }))} placeholder="Nombre de plantilla" style={{ width: "100%", background: "var(--c-surface2,#112538)", border: "1px solid var(--c-border,#1a3550)", borderRadius: 7, padding: "6px 10px", color: "var(--c-white,#eef6ff)", fontSize: ".78rem", outline: "none", boxSizing: "border-box", marginBottom: ".35rem" }} />
          <input value={newForm.subjectEs} onChange={e => setNewForm(f => ({ ...f, subjectEs: e.target.value }))} {...varIns.bind(() => newForm.subjectEs || "", v => setNewForm(f => ({ ...f, subjectEs: v })))} placeholder="Línea de asunto" style={{ width: "100%", background: "var(--c-surface2,#112538)", border: "1px solid var(--c-border,#1a3550)", borderRadius: 7, padding: "6px 10px", color: "var(--c-white,#eef6ff)", fontSize: ".78rem", outline: "none", boxSizing: "border-box", marginBottom: ".35rem" }} />
          <EmailRichEditor value={newForm.bodyEs || ""} onChange={v => setNewForm(f => ({ ...f, bodyEs: v }))} inserter={varIns} lang={lang} minHeight={130} placeholder={"Cuerpo del mensaje…"} />
        </div>
      </div>
      <VarChips vars={["{{firstName}}", "{{lastName}}", "{{phone}}", "{{agentName}}", "{{agentPhone}}", "{{agentOfficePhone}}"]} inserter={varIns} lang={lang} style={{ margin: ".5rem 0" }} />
      <div style={{ display: "flex", gap: ".5rem" }}>
        <button onClick={addCustom} style={{ flex: 1, padding: ".55rem", background: "var(--c-cyan,#00d4ff)", color: "#0a1628", fontWeight: 800, fontSize: ".82rem", borderRadius: 9, border: "none", cursor: "pointer" }}>💾 {es ? "Guardar Plantilla" : "Save Template"}</button>
        <button onClick={() => setShowNewCustom(false)} style={{ padding: ".55rem 1rem", borderRadius: 9, border: "1px solid var(--c-border,#1a3550)", background: "transparent", color: "var(--c-text2,#7aa3c0)", cursor: "pointer", fontSize: ".78rem" }}>{es ? "Cancelar" : "Cancel"}</button>
      </div>
    </div>}

    {/* Preview Modal */}
    {previewItem && <div style={{ position: "fixed", inset: 0, zIndex: 9999, background: "rgba(0,0,0,.7)", display: "flex", alignItems: "center", justifyContent: "center", padding: "1rem" }} onClick={() => setPreviewItem(null)}>
      <div onClick={e => e.stopPropagation()} style={{ background: "var(--c-bg2,#0b1622)", border: "1px solid var(--c-border2,#1f3f60)", borderRadius: 14, padding: "1.5rem", maxWidth: 760, width: "100%", maxHeight: "85vh", overflowY: "auto" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: ".4rem" }}>
          <div style={{ display: "flex", alignItems: "center", gap: ".5rem" }}>
            {previewItem.emoji && <span style={{ fontSize: "1.5rem" }}>{previewItem.emoji}</span>}
            <div style={{ fontWeight: 800, fontSize: "1rem", color: "var(--c-white,#eef6ff)" }}>{previewItem.name || previewItem.nameEs}</div>
          </div>
          <button onClick={() => setPreviewItem(null)} style={{ background: "none", border: "none", color: "var(--c-text3,#45688a)", cursor: "pointer", fontSize: "1.1rem" }}>✕</button>
        </div>
        <div style={{ fontSize: ".68rem", color: "var(--c-text3,#45688a)", marginBottom: "1rem" }}>
          {es ? `Así llega el correo. Datos de muestra (ej.: ${previewSample.firstName}); a cada cliente le llega con su nombre.` : `How the email arrives. Sample data (e.g. ${previewSample.firstName}); each client gets their own name.`}
          {previewHtml.loading ? (es ? " · cargando imágenes…" : " · loading images…") : ""}
        </div>
        {(() => {
          // White "inbox" canvas so the agent sees the message exactly as the
          // recipient will — subject filled, body rendered, images shown.
          const EmailCard = ({ flag, subjectTpl, html }) => (
            <div>
              <div style={{ fontSize: ".65rem", fontWeight: 800, color: "var(--c-text3,#45688a)", marginBottom: ".4rem", fontFamily: "var(--font-mono)" }}>{flag}</div>
              <div style={{ background: "#ffffff", border: "1px solid #d7dee8", borderRadius: 10, overflow: "hidden", boxShadow: "0 6px 18px rgba(0,0,0,.25)" }}>
                <div style={{ background: "#f3f6fb", borderBottom: "1px solid #e3e9f2", padding: ".55rem .8rem" }}>
                  <div style={{ fontSize: ".62rem", color: "#64748b", textTransform: "uppercase", letterSpacing: ".06em", fontWeight: 700 }}>{es ? "Asunto" : "Subject"}</div>
                  <div style={{ fontSize: ".82rem", fontWeight: 700, color: "#0f1b2d" }}>{fillSample(subjectTpl) || <span style={{ color: "#94a3b8" }}>{es ? "(sin asunto)" : "(no subject)"}</span>}</div>
                </div>
                <div style={{ padding: ".85rem 1rem", color: "#1a2332", fontFamily: "Arial,Helvetica,sans-serif", fontSize: "14px", lineHeight: 1.5, maxHeight: "46vh", overflowY: "auto", wordBreak: "break-word" }} dangerouslySetInnerHTML={safeHtml(html || `<p style="color:#94a3b8;margin:0">${es ? "(vacío)" : "(empty)"}</p>`)} />
              </div>
            </div>
          );
          return (
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1rem" }}>
              <EmailCard flag="🇺🇸 ENGLISH" subjectTpl={previewItem.subject} html={previewHtml.en} />
              <EmailCard flag="🇪🇸 ESPAÑOL" subjectTpl={previewItem.subjectEs} html={previewHtml.es} />
            </div>
          );
        })()}
        <div style={{ marginTop: ".75rem", fontSize: ".65rem", color: "var(--c-text3,#45688a)" }}>{es ? "Variables disponibles:" : "Available variables:"} <span style={{ color: "var(--c-cyan,#00d4ff)", fontFamily: "var(--font-mono)" }}>{`{{firstName}} {{lastName}} {{phone}} {{agentName}} {{agentPhone}} {{carrier}} {{renewalDate}} {{plan}}`}</span></div>
      </div>
    </div>}

    {/* Edit Modal */}
    {editItem && <div style={{ position: "fixed", inset: 0, zIndex: 9999, background: "rgba(0,0,0,.7)", display: "flex", alignItems: "center", justifyContent: "center", padding: "1rem" }} onClick={() => setEditItem(null)}>
      <div onClick={e => e.stopPropagation()} style={{ background: "var(--c-bg2,#0b1622)", border: "1px solid var(--c-border2,#1f3f60)", borderRadius: 14, padding: "1.5rem", maxWidth: 650, width: "100%", maxHeight: "85vh", overflowY: "auto" }}>
        <div style={{ fontWeight: 800, fontSize: "1rem", color: "var(--c-white,#eef6ff)", marginBottom: ".5rem" }}>✏️ {es ? "Editar Plantilla" : "Edit Template"}: {form.name || form.nameEs}</div>
        {/* El NOMBRE de la plantilla. Ticket de Gabriel De Silva (2026-09-02):
            este modal enseñaba el nombre en el título y dejaba cambiar asunto
            y cuerpo en los dos idiomas, pero el nombre no se podía tocar por
            ningún lado — para corregir una falta de ortografía había que
            borrar la plantilla y volver a escribirla entera.
            El nombre es solo una etiqueta: nada lo usa como llave (las
            plantillas se buscan por `id`), así que se puede cambiar sin
            arrastrar nada. */}
        <div style={{ display: "grid", gridTemplateColumns: "auto 1fr 1fr", gap: ".5rem", alignItems: "end", marginBottom: ".6rem" }}>
          <div>
            <label style={{ fontSize: ".68rem", color: "var(--c-text3,#45688a)", display: "block", marginBottom: 2 }}>{es ? "Icono" : "Icon"}</label>
            <select value={form.emoji || ""} onChange={e => setForm(f => ({ ...f, emoji: e.target.value }))}
              style={{ background: "var(--c-surface2,#112538)", border: "1px solid var(--c-border,#1a3550)", borderRadius: 7, padding: "7px 8px", color: "var(--c-white,#eef6ff)", fontSize: ".95rem", outline: "none", cursor: "pointer" }}>
              <option value="">—</option>
              {/* El icono que YA tiene va primero aunque no este en la lista
                  corta: los feriados de fabrica traen 🦃, 🎆 y demas, y si no
                  saliera, abrir el modal y guardar se lo llevaria por delante
                  sin que nadie lo pidiera. */}
              {(form.emoji && !EMOJIS.includes(form.emoji)) && <option value={form.emoji}>{form.emoji}</option>}
              {EMOJIS.map(x => <option key={x} value={x}>{x}</option>)}
            </select>
          </div>
          <div>
            <label style={{ fontSize: ".68rem", color: "var(--c-text3,#45688a)", display: "block", marginBottom: 2 }}>{es ? "Nombre (inglés)" : "Name (English)"}</label>
            <input value={form.name || ""} onChange={e => setForm(f => ({ ...f, name: e.target.value }))}
              style={{ width: "100%", background: "var(--c-surface2,#112538)", border: "1px solid var(--c-border,#1a3550)", borderRadius: 7, padding: "7px 10px", color: "var(--c-white,#eef6ff)", fontSize: ".78rem", outline: "none", boxSizing: "border-box" }} />
          </div>
          <div>
            <label style={{ fontSize: ".68rem", color: "var(--c-text3,#45688a)", display: "block", marginBottom: 2 }}>{es ? "Nombre (español)" : "Name (Spanish)"}</label>
            <input value={form.nameEs || ""} onChange={e => setForm(f => ({ ...f, nameEs: e.target.value }))}
              style={{ width: "100%", background: "var(--c-surface2,#112538)", border: "1px solid var(--c-border,#1a3550)", borderRadius: 7, padding: "7px 10px", color: "var(--c-white,#eef6ff)", fontSize: ".78rem", outline: "none", boxSizing: "border-box" }} />
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: ".5rem", flexWrap: "wrap", marginBottom: ".4rem" }}>
          <TranslateBtns formObj={form} setFormFn={setForm} />
          <AiDraftButton lang={lang} contextHint="This is a reusable greeting/holiday email template sent to insurance clients. Address the reader with {{firstName}}." onResult={({ subject, body, lang: dl }) => setForm(f => dl === 'es' ? { ...f, subjectEs: subject, bodyEs: body } : { ...f, subject, body })} />
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1rem" }}>
          <div>
            <div style={{ fontSize: ".65rem", fontWeight: 800, color: "var(--c-cyan,#00d4ff)", marginBottom: ".4rem", fontFamily: "var(--font-mono)" }}>🇺🇸 ENGLISH</div>
            <label style={{ fontSize: ".68rem", color: "var(--c-text3,#45688a)", display: "block", marginBottom: 2 }}>Subject</label>
            <input value={form.subject || ""} onChange={e => setForm(f => ({ ...f, subject: e.target.value }))} {...varIns.bind(() => form.subject || "", v => setForm(f => ({ ...f, subject: v })))} style={{ width: "100%", background: "var(--c-surface2,#112538)", border: "1px solid var(--c-border,#1a3550)", borderRadius: 7, padding: "7px 10px", color: "var(--c-white,#eef6ff)", fontSize: ".78rem", outline: "none", boxSizing: "border-box", marginBottom: ".5rem" }} />
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 2 }}>
              <label style={{ fontSize: ".68rem", color: "var(--c-text3,#45688a)" }}>Body</label>
            </div>
            <EmailRichEditor value={form.body || ""} onChange={v => setForm(f => ({ ...f, body: v }))} inserter={varIns} lang={lang} minHeight={190} placeholder={"Message body…"} />
          </div>
          <div>
            <div style={{ fontSize: ".65rem", fontWeight: 800, color: "var(--c-amber,#ffb700)", marginBottom: ".4rem", fontFamily: "var(--font-mono)" }}>🇪🇸 ESPAÑOL</div>
            <label style={{ fontSize: ".68rem", color: "var(--c-text3,#45688a)", display: "block", marginBottom: 2 }}>Asunto</label>
            <input value={form.subjectEs || ""} onChange={e => setForm(f => ({ ...f, subjectEs: e.target.value }))} {...varIns.bind(() => form.subjectEs || "", v => setForm(f => ({ ...f, subjectEs: v })))} style={{ width: "100%", background: "var(--c-surface2,#112538)", border: "1px solid var(--c-border,#1a3550)", borderRadius: 7, padding: "7px 10px", color: "var(--c-white,#eef6ff)", fontSize: ".78rem", outline: "none", boxSizing: "border-box", marginBottom: ".5rem" }} />
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 2 }}>
              <label style={{ fontSize: ".68rem", color: "var(--c-text3,#45688a)" }}>Cuerpo</label>
            </div>
            <EmailRichEditor value={form.bodyEs || ""} onChange={v => setForm(f => ({ ...f, bodyEs: v }))} inserter={varIns} lang={lang} minHeight={190} placeholder={"Cuerpo del mensaje…"} />
          </div>
        </div>
        <VarChips vars={["{{firstName}}", "{{lastName}}", "{{phone}}", "{{agentName}}", "{{agentPhone}}", "{{agentOfficePhone}}", "{{carrier}}", "{{renewalDate}}"]} inserter={varIns} lang={lang} style={{ marginTop: ".75rem" }} />
        <div style={{ display: "flex", gap: ".65rem", marginTop: "1rem" }}>
          <button onClick={saveEdit} style={{ flex: 1, padding: ".6rem", background: "var(--c-cyan,#00d4ff)", color: "#0a1628", fontWeight: 800, fontSize: ".84rem", borderRadius: 9, border: "none", cursor: "pointer" }}>💾 {es ? "Guardar" : "Save"}</button>
          <button onClick={() => setEditItem(null)} style={{ padding: ".6rem 1.2rem", borderRadius: 9, border: "1px solid var(--c-border,#1a3550)", background: "transparent", color: "var(--c-text2,#7aa3c0)", cursor: "pointer", fontSize: ".78rem" }}>{es ? "Cancelar" : "Cancel"}</button>
        </div>
      </div>
    </div>}
    {/* Batch send confirmation modal — replaces the old N-mailto fire-
        and-forget. Lists the recipient count, the template subject (in
        the currently-previewed language), and warns the send will use
        the user's connected mailbox. Send button kicks off runBatchSend
        which iterates with progress + per-recipient failure tracking. */}
    {batchConfirm && (() => {
      const all = batchConfirm.allCandidates || [];
      const selectedIds = batchConfirm.selectedIds || new Set();
      const recipients = selectedBatchRecipients(batchConfirm);
      const visible = visibleBatchCandidates(batchConfirm);
      const activeCount = all.filter(c => (c.status || '').toLowerCase() === 'active').length;
      const inactiveCount = all.filter(c => (c.status || '').toLowerCase() === 'inactive').length;
      const statusFilter = batchConfirm.statusFilter || 'active';
      const STATUS_OPTS = [
        { id: 'active',   labelEs: 'Activos',   labelEn: 'Active',   count: activeCount },
        { id: 'all',      labelEs: 'Todos',     labelEn: 'All',      count: all.length },
        { id: 'inactive', labelEs: 'Inactivos', labelEn: 'Inactive', count: inactiveCount },
      ];
      const toggleId = (id) => setBatchConfirm(p => {
        if (!p) return p;
        const next = new Set(p.selectedIds || []);
        if (next.has(id)) next.delete(id); else next.add(id);
        return { ...p, selectedIds: next };
      });
      const selectAllVisible = () => setBatchConfirm(p => {
        if (!p) return p;
        const next = new Set(p.selectedIds || []);
        visible.forEach(c => next.add(c.id));
        return { ...p, selectedIds: next };
      });
      const clearAll = () => setBatchConfirm(p => p ? { ...p, selectedIds: new Set() } : p);
      return (
      <div style={{position:"fixed",inset:0,zIndex:9999,background:"rgba(8,17,28,.85)",display:"flex",alignItems:"center",justifyContent:"center",padding:"1rem"}}>
        <div style={{background:"var(--c-surface,#0d1b2a)",border:"1px solid var(--c-border,#1a3550)",borderRadius:12,padding:"1.5rem",maxWidth:640,width:"100%",maxHeight:"90vh",overflowY:"auto",boxShadow:"0 20px 60px rgba(0,0,0,.5)"}}>
          <h3 style={{margin:0,marginBottom:".75rem",fontSize:".95rem",fontWeight:700,color:"var(--c-white,#eef6ff)"}}>
            ⚠️ {es ? "Confirmar envío masivo" : "Confirm batch send"}
          </h3>
          <p style={{color:"var(--c-text,#c8dff0)",fontSize:".85rem",marginBottom:".75rem"}}>
            {es
              ? `Vas a enviar este saludo a ${recipients.length} cliente${recipients.length === 1 ? '' : 's'} con email.`
              : `You're about to send this greeting to ${recipients.length} client${recipients.length === 1 ? '' : 's'} with email.`}
          </p>
          {/* Recipient picker — mirrors the Mass Email compose pattern:
              status filter + search + Todos/Limpiar buttons + scrollable
              checkbox list. Filter + search narrow what's VISIBLE; the
              selectedIds Set is what actually gets sent. Pre-seeded with
              all actives on open so the historical one-click flow stays
              intact, but the agent can untick rows or extend the list to
              inactive / prospect clients before confirming. */}
          <div style={{background:"var(--c-surface2,#112538)",border:"1px solid var(--c-border,#1a3550)",borderRadius:10,padding:".7rem",marginBottom:".75rem"}}>
            <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:".45rem"}}>
              <div style={{fontSize:".7rem",fontWeight:700,color:"var(--c-white,#eef6ff)",display:"flex",alignItems:"center",gap:5}}>
                <Users size={12}/> {es ? "Destinatarios" : "Recipients"} ({recipients.length})
              </div>
              <div style={{display:"flex",gap:4}}>
                <button type="button" onClick={selectAllVisible} style={{padding:".2rem .55rem",fontSize:".65rem",fontWeight:700,fontFamily:"inherit",borderRadius:6,border:"1px solid var(--c-border,#1a3550)",background:"var(--c-surface,#0d1b2a)",color:"var(--c-text2,#7aa3c0)",cursor:"pointer"}}>
                  {es ? "Todos" : "All"}
                </button>
                <button type="button" onClick={clearAll} style={{padding:".2rem .55rem",fontSize:".65rem",fontWeight:700,fontFamily:"inherit",borderRadius:6,border:"1px solid var(--c-border,#1a3550)",background:"var(--c-surface,#0d1b2a)",color:"var(--c-text2,#7aa3c0)",cursor:"pointer"}}>
                  {es ? "Limpiar" : "Clear"}
                </button>
              </div>
            </div>
            <div style={{display:"flex",gap:".35rem",marginBottom:".45rem",flexWrap:"wrap"}}>
              {STATUS_OPTS.map(opt => {
                const on = statusFilter === opt.id;
                return (
                  <button
                    type="button"
                    key={opt.id}
                    onClick={() => setBatchConfirm(p => p ? { ...p, statusFilter: opt.id } : p)}
                    style={{
                      flex:"1 1 0",
                      minWidth:0,
                      padding:".35rem .5rem",
                      borderRadius:6,
                      cursor:"pointer",
                      border:`1px solid ${on ? 'var(--c-cyan,#00d4ff)' : 'var(--c-border,#1a3550)'}`,
                      background: on ? 'rgba(0,212,255,.1)' : 'var(--c-surface,#0d1b2a)',
                      color: on ? 'var(--c-cyan,#00d4ff)' : 'var(--c-text2,#7aa3c0)',
                      fontSize:".7rem",
                      fontWeight:700,
                      fontFamily:"inherit",
                    }}>
                    {es ? opt.labelEs : opt.labelEn} ({opt.count})
                  </button>
                );
              })}
            </div>
            <div style={{position:"relative",marginBottom:".45rem"}}>
              <Search size={12} style={{position:"absolute",left:9,top:"50%",transform:"translateY(-50%)",color:"var(--c-text3,#45688a)",pointerEvents:"none"}}/>
              <input
                value={batchConfirm.search || ''}
                onChange={(e) => setBatchConfirm(p => p ? { ...p, search: e.target.value } : p)}
                placeholder={es ? "Buscar cliente..." : "Search client..."}
                style={{width:"100%",paddingLeft:28,padding:".35rem .6rem .35rem 28px",borderRadius:6,border:"1px solid var(--c-border,#1a3550)",background:"var(--c-surface,#0d1b2a)",color:"var(--c-white,#eef6ff)",fontSize:".74rem",fontFamily:"inherit",boxSizing:"border-box",outline:"none"}}
              />
            </div>
            <div style={{maxHeight:220,overflowY:"auto",display:"flex",flexDirection:"column",gap:2}}>
              {visible.length === 0 && (
                <div style={{color:"var(--c-text3,#45688a)",fontSize:".74rem",textAlign:"center",padding:"1rem"}}>{es ? "Sin resultados" : "No matches"}</div>
              )}
              {visible.map(c => {
                const sel = selectedIds.has(c.id);
                return (
                  <button
                    type="button"
                    key={c.id}
                    onClick={() => toggleId(c.id)}
                    style={{
                      display:"flex",alignItems:"center",gap:".5rem",padding:".35rem .55rem",
                      borderRadius:6,
                      background: sel ? 'rgba(0,212,255,.1)' : 'transparent',
                      border:`1px solid ${sel ? 'rgba(0,212,255,.35)' : 'var(--c-border,#1a3550)'}`,
                      cursor:"pointer",textAlign:"left",fontFamily:"inherit",
                    }}>
                    <div style={{
                      width:14,height:14,borderRadius:3,display:"flex",alignItems:"center",justifyContent:"center",
                      background: sel ? 'var(--c-cyan,#00d4ff)' : 'transparent',
                      border:`1px solid ${sel ? 'var(--c-cyan,#00d4ff)' : 'var(--c-border2,#1f3f60)'}`,
                      flexShrink:0,
                    }}>{sel && <Check size={9} color="#000" strokeWidth={3}/>}</div>
                    <div style={{flex:1,minWidth:0}}>
                      <div style={{fontSize:".74rem",fontWeight:600,color:"var(--c-white,#eef6ff)",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{c.firstName} {c.lastName}</div>
                      <div style={{fontSize:".6rem",color:"var(--c-text3,#45688a)",fontFamily:"var(--font-mono)",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{c.email}</div>
                    </div>
                    <div style={{fontSize:".55rem",fontWeight:700,color:(c.status || '').toLowerCase() === 'active' ? 'var(--c-green,#00ff88)' : 'var(--c-text3,#45688a)',textTransform:"uppercase",letterSpacing:".06em"}}>{c.status || ''}</div>
                  </button>
                );
              })}
            </div>
          </div>
          {/* Language toggle — defaults to the page-level previewLang but
              the user can flip it at send time without re-navigating.
              Drives both the preview here AND what actually gets sent
              (read inside runBatchSend from batchConfirm.msgLang). */}
          <div style={{display:"flex",alignItems:"center",gap:".5rem",marginBottom:".6rem"}}>
            <span style={{fontSize:".65rem",color:"var(--c-text3,#45688a)",textTransform:"uppercase",letterSpacing:".08em"}}>
              {es ? "Idioma del mensaje" : "Message language"}
            </span>
            <div style={{display:"flex",gap:4}}>
              <button
                type="button"
                onClick={() => setBatchConfirm(p => p ? { ...p, msgLang: 'en' } : p)}
                style={{display:"inline-flex",alignItems:"center",gap:4,padding:".25rem .55rem",borderRadius:6,cursor:"pointer",
                  border:`1px solid ${batchConfirm.msgLang === 'en' ? 'var(--c-cyan,#00d4ff)' : 'var(--c-border,#1a3550)'}`,
                  background: batchConfirm.msgLang === 'en' ? 'rgba(0,212,255,.1)' : 'var(--c-surface2,#112538)',
                  color: batchConfirm.msgLang === 'en' ? 'var(--c-cyan,#00d4ff)' : 'var(--c-text2,#7aa3c0)',
                  fontSize:".7rem",fontWeight:700,fontFamily:"inherit"}}>
                🇺🇸 English
              </button>
              <button
                type="button"
                onClick={() => setBatchConfirm(p => p ? { ...p, msgLang: 'es' } : p)}
                style={{display:"inline-flex",alignItems:"center",gap:4,padding:".25rem .55rem",borderRadius:6,cursor:"pointer",
                  border:`1px solid ${batchConfirm.msgLang === 'es' ? 'var(--c-cyan,#00d4ff)' : 'var(--c-border,#1a3550)'}`,
                  background: batchConfirm.msgLang === 'es' ? 'rgba(0,212,255,.1)' : 'var(--c-surface2,#112538)',
                  color: batchConfirm.msgLang === 'es' ? 'var(--c-cyan,#00d4ff)' : 'var(--c-text2,#7aa3c0)',
                  fontSize:".7rem",fontWeight:700,fontFamily:"inherit"}}>
                🇪🇸 Español
              </button>
            </div>
          </div>
          <div style={{background:"var(--c-surface2,#112538)",border:"1px solid var(--c-border,#1a3550)",borderRadius:8,padding:".6rem .8rem",marginBottom:".75rem"}}>
            <div style={{fontSize:".62rem",color:"var(--c-text3,#45688a)",textTransform:"uppercase",letterSpacing:".08em",marginBottom:3}}>
              {es ? "Vista previa" : "Preview"} ({batchConfirm.msgLang === 'es' ? "🇪🇸 ES" : "🇺🇸 EN"})
            </div>
            <div style={{fontSize:".82rem",fontWeight:600,color:"var(--c-white,#eef6ff)"}}>
              {batchConfirm.msgLang === 'es' ? (batchConfirm.tpl.nameEs || batchConfirm.tpl.name) : batchConfirm.tpl.name}
            </div>
            <div style={{fontSize:".72rem",color:"var(--c-text2,#a0b8d0)",marginTop:3}}>
              {es ? "Asunto:" : "Subject:"} {batchConfirm.msgLang === 'es' ? (batchConfirm.tpl.subjectEs || batchConfirm.tpl.subject) : batchConfirm.tpl.subject}
            </div>
          </div>
          {/* Optional date+time picker. Empty = send now. Filled = queue
              one ScheduledSend row per recipient via the worker (same
              flow the Mass Email confirm modal uses). */}
          <div style={{marginBottom:"1rem",padding:".6rem .75rem",background:"var(--c-surface2,#112538)",border:"1px dashed var(--c-border2,#1f3f60)",borderRadius:9}}>
            <label style={{fontSize:".62rem",color:"var(--c-text3,#45688a)",fontWeight:700,textTransform:"uppercase",letterSpacing:".06em",display:"block",marginBottom:4}}>
              ⏰ {es ? "Programar para (opcional)" : "Schedule for (optional)"}
            </label>
            <DateTimeField
              value={batchConfirm.scheduleAt || ''}
              onChange={(e) => setBatchConfirm(bc => bc ? { ...bc, scheduleAt: e.target.value } : bc)}
              lang={es ? 'es' : 'en'}
            />
            {batchConfirm.scheduleAt && !batchConfirm.repeat && (
              <div style={{fontSize:".62rem",color:"var(--c-amber,#ffb700)",marginTop:4}}>
                {es ? `📅 Se programará 1 envío por destinatario (${recipients.length}).` : `📅 Will queue 1 send per recipient (${recipients.length}).`}
              </div>
            )}
          </div>

          {/* RECURRENCIA — el mismo bloque de "Marketing > Recurrentes", que es
              la pantalla que Lissette señaló (2026-08-13: "yo quiero eso mismo
              en custom campaña"). Solo para plantillas Custom.

              La hora sale del campo de arriba y NO se repite aquí: en
              Recurrentes hace falta su propia "Hora del día" porque allí no hay
              fecha de inicio; aquí sí la hay, y dos horas en la misma pantalla
              es una que se puede contradecir con la otra. */}
          <div style={{marginBottom:"1rem",padding:".6rem .75rem",background:"var(--c-surface2,#112538)",border:`1px ${batchConfirm.repeat ? "solid var(--c-cyan,#00d4ff)" : "dashed var(--c-border2,#1f3f60)"}`,borderRadius:9}}>
            <label style={{display:"flex",alignItems:"center",gap:8,cursor:"pointer",fontSize:".72rem",fontWeight:700,color:batchConfirm.repeat?"var(--c-cyan,#00d4ff)":"var(--c-text2,#7aa3c0)"}}>
              <input type="checkbox" checked={!!batchConfirm.repeat}
                onChange={(e)=>setBatchConfirm(bc=>bc?{...bc,repeat:e.target.checked}:bc)}
                style={{accentColor:"var(--c-cyan,#00d4ff)",cursor:"pointer"}}/>
              🔁 {es ? "Repetir cada cierto tiempo" : "Repeat on a schedule"}
            </label>

            {batchConfirm.repeat && (<>
              {!batchConfirm.scheduleAt && (
                <div style={{fontSize:".66rem",color:"var(--c-amber,#ffb700)",marginTop:6}}>
                  {es ? "⚠️ Pon arriba la fecha y hora del PRIMER envío." : "⚠️ Set the date and time of the FIRST send above."}
                </div>
              )}
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:".5rem",marginTop:".6rem"}}>
                <div>
                  <div style={S.lbl}>{es?"Frecuencia":"Frequency"}</div>
                  <select value={batchConfirm.frequency||"MONTHLY"} onChange={(e)=>setBatchConfirm(bc=>bc?{...bc,frequency:e.target.value}:bc)} style={S.inp}>
                    <option value="DAILY">{es?"Diaria":"Daily"}</option>
                    <option value="WEEKLY">{es?"Semanal":"Weekly"}</option>
                    <option value="MONTHLY">{es?"Mensual":"Monthly"}</option>
                    <option value="YEARLY">{es?"Anual":"Yearly"}</option>
                  </select>
                </div>
                <div>
                  <div style={S.lbl}>{es?"Cada N":"Every N"}</div>
                  <input type="number" min="1" max="99" value={batchConfirm.intervalCount||1}
                    onChange={(e)=>setBatchConfirm(bc=>bc?{...bc,intervalCount:Math.max(1,parseInt(e.target.value,10)||1)}:bc)} style={S.inp}/>
                </div>
              </div>

              {batchConfirm.frequency==="WEEKLY" && (
                <div style={{marginTop:".5rem"}}>
                  <div style={S.lbl}>{es?"Día de la semana":"Day of week"}</div>
                  <select value={batchConfirm.dayOfWeek??1} onChange={(e)=>setBatchConfirm(bc=>bc?{...bc,dayOfWeek:parseInt(e.target.value,10)}:bc)} style={S.inp}>
                    {(es?["Domingo","Lunes","Martes","Miércoles","Jueves","Viernes","Sábado"]:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]).map((d,i)=><option key={i} value={i}>{d}</option>)}
                  </select>
                </div>
              )}

              {batchConfirm.frequency==="MONTHLY" && (
                <div style={{marginTop:".5rem"}}>
                  <div style={S.lbl}>{es?"Día del mes":"Day of month"}</div>
                  {/* 1..28 y no 31: febrero. Es el mismo tope que usan las
                      tareas recurrentes, para que "el 30" no se salte un mes. */}
                  <input type="number" min="1" max="28" value={batchConfirm.dayOfMonth??1}
                    onChange={(e)=>setBatchConfirm(bc=>bc?{...bc,dayOfMonth:Math.min(28,Math.max(1,parseInt(e.target.value,10)||1))}:bc)} style={S.inp}/>
                  <div style={{fontSize:".6rem",color:"var(--c-text3,#45688a)",marginTop:2}}>{es?"Hasta 28, para que febrero no se salte.":"Up to 28, so February isn't skipped."}</div>
                </div>
              )}

              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:".5rem",marginTop:".5rem"}}>
                <div>
                  <div style={S.lbl}>{es?"Terminar el (opcional)":"Ends on (optional)"}</div>
                  <input type="date" value={batchConfirm.endsAt||""} onChange={(e)=>setBatchConfirm(bc=>bc?{...bc,endsAt:e.target.value}:bc)} style={S.inp}/>
                </div>
                <div>
                  <div style={S.lbl}>{es?"o después de N envíos":"or after N sends"}</div>
                  <input type="number" min="1" placeholder={es?"sin límite":"no limit"} value={batchConfirm.maxOccurrences||""}
                    onChange={(e)=>setBatchConfirm(bc=>bc?{...bc,maxOccurrences:e.target.value}:bc)} style={S.inp}/>
                </div>
              </div>

              {/* Se dice con todas las letras a quién va a llegar en las vueltas
                  siguientes. Una campaña que corre sola durante meses no puede
                  sorprender a nadie con su audiencia. */}
              <div style={{fontSize:".64rem",color:"var(--c-cyan,#00d4ff)",marginTop:".6rem",lineHeight:1.45}}>
                {es
                  ? `🔁 Cada envío irá a los clientes ${({active:"activos",all:"(todos)",inactive:"inactivos"})[batchConfirm.statusFilter||"active"]} DE ESE MOMENTO — los que entren después también lo reciben. Los que destildes aquí quedan fuera siempre.`
                  : `🔁 Each run goes to the ${({active:"active",all:"(all)",inactive:"inactive"})[batchConfirm.statusFilter||"active"]} clients AT THAT TIME — clients added later get it too. Anyone you untick here stays out for good.`}
              </div>
            </>)}
          </div>
          <div style={{fontSize:".7rem",color:"var(--c-text3,#45688a)",marginBottom:"1rem",fontStyle:"italic"}}>
            {es
              ? "Se enviará desde tu cuenta de Deskte (Gmail/Outlook conectada). Cada email queda guardado en el cliente correspondiente."
              : "Will send from your connected Deskte mailbox (Gmail/Outlook). Each email is logged on the matching client."}
          </div>
          <div style={{display:"flex",gap:".5rem",justifyContent:"flex-end"}}>
            <button onClick={() => setBatchConfirm(null)} style={{padding:".5rem 1rem",borderRadius:8,border:"1px solid var(--c-border,#1a3550)",background:"var(--c-surface2,#112538)",color:"var(--c-text2,#7aa3c0)",fontSize:".78rem",fontWeight:600,cursor:"pointer"}}>
              {es ? "Cancelar" : "Cancel"}
            </button>
            <button onClick={runBatchSend} disabled={recipients.length === 0} style={{padding:".55rem 1.4rem",borderRadius:8,border:"none",background:recipients.length === 0 ? "#2a4560" : "linear-gradient(135deg,#059669,#10b981)",color:"#fff",fontSize:".82rem",fontWeight:800,cursor:recipients.length === 0 ? "not-allowed" : "pointer"}}>
              {batchConfirm.repeat
                ? `🔁 ${es ? "Crear campaña recurrente" : "Create recurring campaign"}`
                : batchConfirm.scheduleAt
                ? `📅 ${es ? `Programar ${recipients.length} envío${recipients.length === 1 ? '' : 's'}` : `Schedule ${recipients.length} send${recipients.length === 1 ? '' : 's'}`}`
                : `✉️ ${es ? `Enviar a ${recipients.length}` : `Send to ${recipients.length}`}`}
            </button>
          </div>
        </div>
      </div>
      );
    })()}
    {/* Live progress overlay during the batch send. Same shape as the
        import overlay so the visual vocabulary is consistent across
        bulk operations in the app. */}
    {batchProgress.active && (() => {
      const pct = batchProgress.total > 0 ? Math.round((batchProgress.current / batchProgress.total) * 100) : 0;
      return (
        <div style={{ position: "fixed", inset: 0, background: "rgba(8,17,28,0.85)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center", padding: "1rem" }}>
          <div style={{ background: "var(--c-surface,#0d1b2a)", border: "1px solid var(--c-border,#1a3550)", borderRadius: 12, padding: "1.5rem", maxWidth: 480, width: "100%" }}>
            <h3 style={{ margin: 0, marginBottom: ".75rem", fontSize: ".95rem", fontWeight: 700, color: "var(--c-white,#eef6ff)" }}>
              ✉️ {es ? "Enviando…" : "Sending…"}
            </h3>
            <div style={{ fontSize: ".7rem", color: "var(--c-text3,#45688a)", marginBottom: ".5rem", fontFamily: "var(--font-mono)" }}>
              {batchProgress.current} / {batchProgress.total} · {pct}%
            </div>
            <div style={{ height: 8, background: "var(--c-surface2,#112538)", borderRadius: 4, overflow: "hidden", marginBottom: ".75rem" }}>
              <div style={{ height: "100%", width: `${pct}%`, background: "var(--c-cyan,#00d4ff)", transition: "width .2s ease" }} />
            </div>
            {batchProgress.currentLabel && (
              <div style={{ fontSize: ".75rem", color: "var(--c-text2,#a0b8d0)", marginBottom: ".75rem", wordBreak: "break-word" }}>
                {es ? "Enviando:" : "Sending:"} <span style={{ color: "var(--c-white,#eef6ff)" }}>{batchProgress.currentLabel}</span>
              </div>
            )}
            <div style={{ display: "flex", gap: "1rem", fontSize: ".72rem", fontFamily: "var(--font-mono)" }}>
              <span style={{ color: "var(--c-green,#22c55e)" }}>✅ {batchProgress.succeeded}</span>
              <span style={{ color: batchProgress.failed.length > 0 ? "var(--c-red,#ef4444)" : "var(--c-text3,#45688a)" }}>❌ {batchProgress.failed.length}</span>
            </div>
            {batchProgress.failed.length > 0 && (
              <div style={{ marginTop: ".75rem", maxHeight: 140, overflowY: "auto", borderTop: "1px solid var(--c-border,#1a3550)", paddingTop: ".5rem" }}>
                {batchProgress.failed.slice(-8).map((f, idx) => (
                  <div key={idx} style={{ fontSize: ".68rem", color: "var(--c-red,#ef4444)", marginBottom: 4, wordBreak: "break-word" }}>
                    <span style={{ color: "var(--c-text2,#a0b8d0)" }}>{f.label}:</span> {f.error}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      );
    })()}
  </div>;
}



// ================================================================
// EXPENSES TRACKER
// ================================================================


// ================================================================
// METRICS & ANALYTICS
// ================================================================

// ================================================================
// AGENCY VIEW — Leaderboard, Agent Mgmt, Pricing, Settings
// ================================================================

function PowerDialerView({ clients, leads, lang }) {
  const [dialList, setDialList] = useState("leads"); // leads | clients | custom
  const [calling, setCalling] = useState(null); // id of current call
  // Real session log — starts empty and fills with the calls made this session.
  const [callLog, setCallLog] = useState([]);
  const [dialerActive, setDialerActive] = useState(false);
  const [currentIdx, setCurrentIdx] = useState(0);
  const [callTimer, setCallTimer] = useState(0);
  const [callNote, setCallNote] = useState("");
  const [showDisposition, setShowDisposition] = useState(false);
  const [search, setSearch] = useState(""); // filtra la lista por nombre o telefono

  const allContacts = dialList === "leads"
    ? leads.map(l => ({ id: l.id, name: `${l.firstName} ${l.lastName}`, phone: l.phone, type: "lead" }))
    : clients.map(c => ({ id: c.id, name: `${c.firstName} ${c.lastName}`, phone: c.phone, type: "client" }));

  // The visible/dialable list = allContacts filtered by the search box. The
  // dialer card, the Prev/Next nav and the "x / N" counter all index into
  // THIS filtered array (currentIdx), so navigation respects the search.
  const q = search.trim().toLowerCase();
  const contacts = q
    ? allContacts.filter(c => c.name.toLowerCase().includes(q) || String(c.phone || "").toLowerCase().includes(q))
    : allContacts;

  const current = contacts[currentIdx] || null;

  useEffect(() => {
    let timer;
    if (calling) { timer = setInterval(() => setCallTimer(t => t + 1), 1000); }
    else { setCallTimer(0); }
    return () => clearInterval(timer);
  }, [calling]);

  const fmtTime = (s) => `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;

  const startCall = () => {
    // Hand the number to the OS via the tel: handler. WHICH app answers is an
    // operating-system setting, NOT the provider picked in "SMS y Llamadas" —
    // Deskte has no say here (see CallNoteModal for the note shown to users).
    // The SPA is not navigated away for the tel: scheme.
    const digits = String(current?.phone || "").replace(/[^\d+]/g, "");
    if (digits) { try { window.location.href = `tel:${digits}`; } catch { /* no handler */ } }
    setCalling(current?.id); setCallNote(""); setShowDisposition(false);
  };
  const endCall = (status) => {
    if (current) {
      setCallLog(prev => [{ id: "cl_" + Date.now(), name: current.name, phone: current.phone, duration: fmtTime(callTimer), status, notes: callNote, time: new Date().toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" }) }, ...prev]);
      // Persist the call as a REAL note on the client's profile so notes taken
      // during the call aren't lost. Leads have no Notes tab, so this only
      // saves when dialing the Clients list (current.type === "client").
      if (current.type === "client" && typeof window !== "undefined" && window.__deskteAuth) {
        const label = (STATUS_COLORS[status] || {}).label || status;
        const head = `📞 ${lang === "es" ? "Llamada" : "Call"}${callTimer > 0 ? ` (${fmtTime(callTimer)})` : ""} — ${label}`;
        const text = callNote.trim() ? `${head}\n${callNote.trim()}` : head;
        apiCreateNote({ clientId: current.id, text })
          .then(() => toast.success(lang === "es" ? "Nota de llamada guardada en la ficha" : "Call note saved to profile"))
          .catch(err => toast.error((lang === "es" ? "No se pudo guardar la nota: " : "Couldn't save note: ") + (err.message || err)));
      }
    }
    setCalling(null); setShowDisposition(false); setCallNote("");
  };
  const nextContact = () => { setCurrentIdx(i => Math.min(i + 1, contacts.length - 1)); setCalling(null); setShowDisposition(false); setCallNote(""); };
  const prevContact = () => { setCurrentIdx(i => Math.max(i - 1, 0)); };

  const STATUS_COLORS = { answered: { color: "#00ff88", bg: "rgba(0,255,136,.12)", label: lang === "es" ? "Contestó" : "Answered" }, no_answer: { color: "#ffb700", bg: "rgba(255,183,0,.12)", label: lang === "es" ? "No contestó" : "No Answer" }, voicemail: { color: "#a78bfa", bg: "rgba(167,139,250,.12)", label: "Voicemail" }, busy: { color: "#ef4444", bg: "rgba(239,68,68,.12)", label: lang === "es" ? "Ocupado" : "Busy" }, callback: { color: "#00d4ff", bg: "rgba(0,212,255,.12)", label: "Callback" } };

  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "1rem", flexWrap: "wrap", gap: ".5rem" }}>
        <div style={{ display: "flex", alignItems: "center", gap: ".5rem" }}>
          <span style={{ fontSize: "1.4rem" }}>📞</span>
          <h2 style={{ fontSize: "1.1rem", fontWeight: 800, color: "var(--c-white,#eef6ff)", margin: 0 }}>Power Dialer</h2>
          <span style={{ fontSize: ".65rem", padding: "2px 8px", borderRadius: 100, fontWeight: 700, background: "rgba(0,212,255,.12)", color: "var(--c-cyan,#00d4ff)", border: "1px solid rgba(0,212,255,.25)" }}>BETA</span>
        </div>
        <div style={{ display: "flex", gap: ".35rem" }}>
          {[["leads", "Leads"], ["clients", "👥 " + (lang === "es" ? "Clientes" : "Clients")]].map(([id, label]) => (
            <button type="button" key={id} onClick={() => { setDialList(id); setCurrentIdx(0); setCalling(null); setSearch(""); }}
              style={{ padding: ".35rem .7rem", borderRadius: 8, border: `1px solid ${dialList === id ? "rgba(0,212,255,.4)" : "var(--c-border,#1a3550)"}`, background: dialList === id ? "var(--c-cyan-dim)" : "var(--c-surface2,#112538)", color: dialList === id ? "var(--c-cyan,#00d4ff)" : "var(--c-text3,#45688a)", fontSize: ".72rem", fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}>
              {label} ({id === "leads" ? leads.length : clients.length})
            </button>
          ))}
        </div>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 340px", gap: "1rem", alignItems: "start" }}>
        {/* LEFT COLUMN: dialer card + searchable contact list */}
        <div style={{ display: "flex", flexDirection: "column", gap: "1rem", minWidth: 0 }}>
        {/* DIALER PANEL */}
        <div style={{ background: "var(--c-surface2,#112538)", border: `2px solid ${calling ? "rgba(0,255,136,.3)" : "var(--c-border,#1a3550)"}`, borderRadius: 14, padding: "1.5rem", textAlign: "center" }}>
          {/* Contact info */}
          {current ? (
            <>
              <div style={{ width: 56, height: 56, borderRadius: "50%", background: "linear-gradient(135deg,#0099cc,#0055aa)", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto .75rem", fontSize: "1.2rem", fontWeight: 800, color: "#fff" }}>
                {current.name.split(" ").map(w => w[0]).join("").slice(0, 2)}
              </div>
              <div style={{ fontWeight: 800, fontSize: "1.15rem", color: "var(--c-white,#eef6ff)" }}>{current.name}</div>
              <div style={{ fontSize: ".82rem", color: "var(--c-cyan,#00d4ff)", fontFamily: "var(--font-mono)", margin: ".25rem 0" }}>{current.phone}</div>
              <div style={{ fontSize: ".68rem", color: "var(--c-text3,#45688a)", marginBottom: "1rem" }}>
                {currentIdx + 1} / {contacts.length} · {current.type === "lead" ? "🎯 Lead" : "👤 Client"}
              </div>

              {/* Timer */}
              {calling && (
                <div style={{ fontSize: "2.2rem", fontWeight: 800, fontFamily: "var(--font-mono)", color: "var(--c-green,#00ff88)", marginBottom: ".75rem" }}>
                  <span style={{ width: 10, height: 10, borderRadius: "50%", background: "var(--c-green,#00ff88)", display: "inline-block", marginRight: 8, animation: "pulse 1s infinite" }} />
                  {fmtTime(callTimer)}
                </div>
              )}

              {/* Actions */}
              {!calling ? (
                <div style={{ display: "flex", gap: ".5rem", justifyContent: "center", marginBottom: "1rem" }}>
                  <button type="button" onClick={prevContact} disabled={currentIdx === 0}
                    style={{ padding: ".5rem 1rem", borderRadius: 8, border: "1px solid var(--c-border,#1a3550)", background: "var(--c-surface3,#162d44)", color: "var(--c-text2,#7aa3c0)", cursor: currentIdx === 0 ? "not-allowed" : "pointer", fontFamily: "inherit", fontWeight: 700, fontSize: ".78rem", opacity: currentIdx === 0 ? .4 : 1 }}>⏮ Prev</button>
                  <button type="button" onClick={startCall}
                    style={{ padding: ".6rem 2.5rem", borderRadius: 10, border: "none", background: "linear-gradient(135deg,#059669,#10b981)", color: "#fff", cursor: "pointer", fontFamily: "inherit", fontWeight: 800, fontSize: ".95rem", display: "flex", alignItems: "center", gap: 8 }}>
                    📞 {lang === "es" ? "LLAMAR" : "CALL"}
                  </button>
                  <button type="button" onClick={nextContact} disabled={currentIdx >= contacts.length - 1}
                    style={{ padding: ".5rem 1rem", borderRadius: 8, border: "1px solid var(--c-border,#1a3550)", background: "var(--c-surface3,#162d44)", color: "var(--c-text2,#7aa3c0)", cursor: currentIdx >= contacts.length - 1 ? "not-allowed" : "pointer", fontFamily: "inherit", fontWeight: 700, fontSize: ".78rem", opacity: currentIdx >= contacts.length - 1 ? .4 : 1 }}>Next ⏭</button>
                </div>
              ) : (
                <div>
                  <div style={{ display: "flex", gap: ".5rem", justifyContent: "center", marginBottom: ".75rem" }}>
                    <button type="button" onClick={() => setShowDisposition(true)}
                      style={{ padding: ".6rem 2rem", borderRadius: 10, border: "none", background: "linear-gradient(135deg,#ef4444,#dc2626)", color: "#fff", cursor: "pointer", fontFamily: "inherit", fontWeight: 800, fontSize: ".88rem" }}>
                      🔴 {lang === "es" ? "COLGAR" : "HANG UP"}
                    </button>
                  </div>
                  {/* Notes during call */}
                  <textarea value={callNote} onChange={e => setCallNote(e.target.value)} placeholder={lang === "es" ? "Notas de la llamada..." : "Call notes..."}
                    className="dkt-inp" rows={2} style={{ width: "100%", boxSizing: "border-box", resize: "vertical", fontSize: ".82rem" }} />
                  <div style={{ fontSize: ".62rem", color: "var(--c-text3,#45688a)", marginTop: 4, textAlign: "left" }}>
                    {current?.type === "client"
                      ? (lang === "es" ? "💾 Al elegir el resultado, estas notas se guardan en la ficha del cliente." : "💾 When you pick the outcome, these notes save to the client's profile.")
                      : (lang === "es" ? "ℹ️ Convierte el lead en cliente para guardar las notas en una ficha." : "ℹ️ Convert the lead to a client to save notes to a profile.")}
                  </div>
                </div>
              )}

              {/* Disposition modal */}
              {showDisposition && (
                <div style={{ background: "var(--c-surface,#0d1c2e)", border: "1px solid var(--c-border,#1a3550)", borderRadius: 12, padding: "1rem", marginTop: ".75rem" }}>
                  <div style={{ fontSize: ".7rem", color: "var(--c-text3,#45688a)", fontWeight: 700, textTransform: "uppercase", letterSpacing: ".08em", marginBottom: ".5rem" }}>{lang === "es" ? "Resultado de la llamada" : "Call Disposition"}</div>
                  <div style={{ display: "flex", gap: ".35rem", flexWrap: "wrap", justifyContent: "center" }}>
                    {Object.entries(STATUS_COLORS).map(([key, s]) => (
                      <button type="button" key={key} onClick={() => { endCall(key); nextContact(); }}
                        style={{ padding: ".4rem .8rem", borderRadius: 8, border: `1px solid ${s.color}44`, background: s.bg, color: s.color, fontSize: ".72rem", fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}>
                        {s.label}
                      </button>
                    ))}
                  </div>
                </div>
              )}

              {/* Auto-dial toggle */}
              <div style={{ marginTop: "1rem", display: "flex", alignItems: "center", justifyContent: "center", gap: ".5rem" }}>
                <span style={{ fontSize: ".72rem", color: dialerActive ? "var(--c-green,#00ff88)" : "var(--c-text3,#45688a)", fontWeight: 600 }}>⚡ Auto-Dial</span>
                <button type="button" onClick={() => setDialerActive(!dialerActive)}
                  style={{ width: 38, height: 22, borderRadius: 11, border: "none", cursor: "pointer", background: dialerActive ? "var(--c-green,#00ff88)" : "var(--c-surface3,#162d44)", position: "relative", transition: "background .2s" }}>
                  <div style={{ width: 16, height: 16, borderRadius: "50%", background: "#fff", position: "absolute", top: 3, left: dialerActive ? 19 : 3, transition: "left .2s", boxShadow: "0 1px 3px rgba(0,0,0,.3)" }} />
                </button>
              </div>
            </>
          ) : (
            <div style={{ padding: "2rem", color: "var(--c-text3,#45688a)" }}>{lang === "es" ? "No hay contactos para marcar" : "No contacts to dial"}</div>
          )}
        </div>

        {/* CONTACT LIST + SEARCH — pick anyone to dial; filters by name/phone */}
        <div style={{ background: "var(--c-surface2,#112538)", border: "1px solid var(--c-border,#1a3550)", borderRadius: 14, padding: "1rem" }}>
          <div style={{ fontSize: ".65rem", color: "var(--c-text3,#45688a)", fontWeight: 700, textTransform: "uppercase", letterSpacing: ".08em", marginBottom: ".55rem", fontFamily: "var(--font-mono)" }}>
            👥 {dialList === "leads" ? "Leads" : (lang === "es" ? "Clientes" : "Clients")} ({contacts.length}{q ? ` / ${allContacts.length}` : ""})
          </div>
          {/* Search box */}
          <div style={{ position: "relative", marginBottom: ".6rem" }}>
            <span style={{ position: "absolute", left: 10, top: "50%", transform: "translateY(-50%)", fontSize: ".8rem", pointerEvents: "none" }}>🔍</span>
            <input value={search} onChange={e => { setSearch(e.target.value); setCurrentIdx(0); }}
              placeholder={lang === "es" ? "Buscar por nombre o teléfono..." : "Search by name or phone..."}
              className="dkt-inp" style={{ width: "100%", boxSizing: "border-box", paddingLeft: 30, fontSize: ".82rem" }} />
            {search && (
              <button type="button" onClick={() => { setSearch(""); setCurrentIdx(0); }} title={lang === "es" ? "Limpiar" : "Clear"}
                style={{ position: "absolute", right: 8, top: "50%", transform: "translateY(-50%)", background: "none", border: "none", color: "var(--c-text3,#45688a)", cursor: "pointer", fontSize: ".9rem", lineHeight: 1 }}>✕</button>
            )}
          </div>
          {/* Scrollable list — click a row to make it the active dial target */}
          <div style={{ display: "flex", flexDirection: "column", gap: ".3rem", maxHeight: "42vh", overflowY: "auto" }}>
            {contacts.length === 0 ? (
              <div style={{ padding: "1.25rem", textAlign: "center", color: "var(--c-text3,#45688a)", fontSize: ".8rem" }}>
                {q ? (lang === "es" ? "Sin resultados para esa búsqueda" : "No matches for that search")
                   : (lang === "es" ? "No hay contactos en esta lista" : "No contacts in this list")}
              </div>
            ) : contacts.map((ct, i) => {
              const isCur = i === currentIdx;
              return (
                <button type="button" key={ct.id} onClick={() => { setCurrentIdx(i); setCalling(null); setShowDisposition(false); setCallNote(""); }}
                  style={{ display: "flex", alignItems: "center", gap: ".6rem", textAlign: "left", width: "100%", padding: ".5rem .6rem", borderRadius: 9, border: `1px solid ${isCur ? "rgba(0,212,255,.45)" : "var(--c-border,#1a3550)"}`, background: isCur ? "var(--c-cyan-dim,rgba(0,212,255,.1))" : "var(--c-surface,#0d1c2e)", cursor: "pointer", fontFamily: "inherit" }}>
                  <div style={{ width: 30, height: 30, flexShrink: 0, borderRadius: "50%", background: "linear-gradient(135deg,#0099cc,#0055aa)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: ".7rem", fontWeight: 800, color: "#fff" }}>
                    {ct.name.split(" ").map(w => w[0]).filter(Boolean).join("").slice(0, 2).toUpperCase() || "?"}
                  </div>
                  <div style={{ minWidth: 0, flex: 1 }}>
                    <div style={{ fontWeight: 700, fontSize: ".8rem", color: isCur ? "var(--c-cyan,#00d4ff)" : "var(--c-white,#eef6ff)", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{ct.name.trim() || (lang === "es" ? "(sin nombre)" : "(no name)")}</div>
                    <div style={{ fontSize: ".68rem", color: "var(--c-text3,#45688a)", fontFamily: "var(--font-mono)", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                      {ct.phone || (lang === "es" ? "sin teléfono" : "no phone")}
                    </div>
                  </div>
                  {isCur && <span style={{ fontSize: ".62rem", fontWeight: 700, color: "var(--c-cyan,#00d4ff)", flexShrink: 0 }}>●</span>}
                </button>
              );
            })}
          </div>
        </div>
        </div>{/* end LEFT COLUMN */}

        {/* CALL LOG */}
        <div>
          <div style={{ fontSize: ".65rem", color: "var(--c-text3,#45688a)", fontWeight: 700, textTransform: "uppercase", letterSpacing: ".08em", marginBottom: ".5rem", fontFamily: "var(--font-mono)" }}>📋 {lang === "es" ? "Historial de Llamadas" : "Call Log"} ({callLog.length})</div>
          <div style={{ display: "flex", flexDirection: "column", gap: ".35rem", maxHeight: "60vh", overflowY: "auto" }}>
            {callLog.map(log => {
              const st = STATUS_COLORS[log.status] || STATUS_COLORS.no_answer;
              return (
                <div key={log.id} style={{ background: "var(--c-surface2,#112538)", border: `1px solid ${st.color}22`, borderLeft: `3px solid ${st.color}`, borderRadius: 9, padding: ".55rem .7rem" }}>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: ".2rem" }}>
                    <span style={{ fontWeight: 700, fontSize: ".78rem", color: "var(--c-white,#eef6ff)" }}>{log.name}</span>
                    <span style={{ fontSize: ".6rem", padding: "2px 6px", borderRadius: 100, fontWeight: 700, background: st.bg, color: st.color }}>{st.label}</span>
                  </div>
                  <div style={{ display: "flex", gap: ".5rem", fontSize: ".65rem", color: "var(--c-text3,#45688a)" }}>
                    <span>{log.phone}</span><span>⏱ {log.duration}</span><span>🕐 {log.time}</span>
                  </div>
                  {log.notes && <div style={{ fontSize: ".68rem", color: "var(--c-text2,#7aa3c0)", marginTop: ".2rem" }}>📝 {log.notes}</div>}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

// Create / edit a real backend workflow (trigger → actions). Actions supported
// in the builder: send_email + create_task (the ones that need no pre-existing
// sequence). SMS/WhatsApp are intentionally omitted (no Twilio BAA yet).
function WorkflowEditorModal({ draft, setDraft, onSave, busy, lang, TRIGGER_OPTIONS }) {
  const es = lang === "es";
  const upd = (patch) => setDraft(d => ({ ...d, ...patch }));
  const addAction = (type) => {
    const params = type === "send_email" ? { subject: "", htmlBody: "" } : { title: "", dueInDays: 1, priority: "MEDIUM" };
    upd({ actions: [...draft.actions, { type, params }] });
  };
  const updAction = (i, params) => upd({ actions: draft.actions.map((a, idx) => idx === i ? { ...a, params: { ...a.params, ...params } } : a) });
  const removeAction = (i) => upd({ actions: draft.actions.filter((_, idx) => idx !== i) });
  const inp = { background: "var(--c-surface2,#112538)", border: "1px solid var(--c-border,#1a3550)", borderRadius: 7, padding: ".45rem .65rem", color: "var(--c-text,#c8dff0)", fontSize: ".8rem", outline: "none", width: "100%", boxSizing: "border-box" };
  const lbl = { fontSize: ".65rem", color: "var(--c-text3,#45688a)", fontWeight: 700, textTransform: "uppercase", letterSpacing: ".06em", display: "block", marginBottom: 3 };
  // Variables that the engine actually fills for each trigger (must match the
  // event payloads in the backend routes). Inserted as ${field} (engine syntax).
  const VARS_BY_TRIGGER = {
    "lead.created": ["firstName", "lastName", "email", "phone", "name"],
    "invoice.paid": ["name", "email", "amount", "total", "number"],
    "client.created": ["firstName", "lastName", "email", "name"],
    "policy.created": ["firstName", "lastName", "email", "name", "policyNumber", "carrier"],
    "signature.completed": ["name", "email"],
  };
  const vars = VARS_BY_TRIGGER[draft.triggerType] || ["firstName", "lastName", "email", "name"];
  const renderChips = (onPick) => (
    <div style={{ display: "flex", flexWrap: "wrap", gap: ".25rem", margin: "3px 0" }}>
      {vars.map(v => (
        <button type="button" key={v} onClick={() => onPick("${" + v + "}")}
          style={{ padding: ".15rem .4rem", borderRadius: 5, border: "1px solid rgba(0,212,255,.25)", background: "var(--c-cyan-dim,rgba(0,212,255,.1))", color: "#00d4ff", fontSize: ".6rem", fontWeight: 600, cursor: "pointer", fontFamily: "var(--font-mono,monospace)" }}>
          {"${" + v + "}"}
        </button>
      ))}
    </div>
  );
  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,.7)", backdropFilter: "blur(6px)", zIndex: 120, display: "flex", alignItems: "center", justifyContent: "center", padding: "1rem" }} onClick={() => !busy && setDraft(null)}>
      <div onClick={e => e.stopPropagation()} style={{ background: "var(--c-surface,#0d1c2e)", border: "1px solid var(--c-border2,#1f3f60)", borderRadius: 16, width: "100%", maxWidth: 560, maxHeight: "90vh", display: "flex", flexDirection: "column", overflow: "hidden", boxShadow: "0 24px 80px rgba(0,0,0,.6)" }}>
        <div style={{ padding: "1rem 1.25rem", borderBottom: "1px solid var(--c-border,#1a3550)", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div style={{ fontWeight: 700, fontSize: "1rem", color: "var(--c-white,#eef6ff)" }}>⚡ {draft.id ? (es ? "Editar automatización" : "Edit automation") : (es ? "Nueva automatización" : "New automation")}</div>
          <button onClick={() => !busy && setDraft(null)} style={{ background: "none", border: "none", color: "var(--c-text3,#45688a)", cursor: "pointer", fontSize: "1.3rem" }}>✕</button>
        </div>
        <div style={{ flex: 1, overflowY: "auto", padding: "1rem 1.25rem", display: "flex", flexDirection: "column", gap: ".85rem" }}>
          <div>
            <label style={lbl}>{es ? "Nombre" : "Name"}</label>
            <input style={inp} value={draft.name} onChange={e => upd({ name: e.target.value })} placeholder={es ? "Ej: Bienvenida a nuevo lead" : "e.g. Welcome new lead"} />
          </div>
          <div>
            <label style={lbl}>{es ? "Cuando pase esto (disparador)" : "When this happens (trigger)"}</label>
            <select style={inp} value={draft.triggerType} onChange={e => upd({ triggerType: e.target.value })}>
              {TRIGGER_OPTIONS.map(o => <option key={o.v} value={o.v}>{es ? o.es : o.en}</option>)}
            </select>
          </div>
          <div>
            <label style={lbl}>{es ? "Hacer esto (acciones)" : "Do this (actions)"}</label>
            <div style={{ display: "flex", flexDirection: "column", gap: ".6rem" }}>
              {draft.actions.length === 0 && <div style={{ fontSize: ".72rem", color: "var(--c-text3,#45688a)" }}>{es ? "Agrega al menos una acción ↓" : "Add at least one action ↓"}</div>}
              {draft.actions.map((a, i) => (
                <div key={i} style={{ background: "var(--c-surface2,#112538)", border: "1px solid var(--c-border,#1a3550)", borderRadius: 10, padding: ".7rem" }}>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: ".5rem" }}>
                    <span style={{ fontSize: ".75rem", fontWeight: 700, color: "var(--c-white,#eef6ff)" }}>{a.type === "send_email" ? (es ? "📧 Enviar email" : "📧 Send email") : (es ? "✅ Crear tarea" : "✅ Create task")}</span>
                    <button type="button" onClick={() => removeAction(i)} style={{ background: "none", border: "none", color: "#ef4444", cursor: "pointer", fontSize: ".8rem" }}>🗑</button>
                  </div>
                  {a.type === "send_email" ? (
                    <div style={{ display: "flex", flexDirection: "column", gap: ".4rem" }}>
                      <input style={inp} value={a.params.subject || ""} onChange={e => updAction(i, { subject: e.target.value })} placeholder={es ? "Asunto del email" : "Email subject"} />
                      <div>
                        <div style={{ fontSize: ".6rem", color: "var(--c-text3,#45688a)", fontWeight: 700 }}>{es ? "🔗 Campos — clic para insertar en el mensaje:" : "🔗 Fields — click to insert into the message:"}</div>
                        {renderChips((tok) => updAction(i, { htmlBody: (a.params.htmlBody || "") + tok }))}
                      </div>
                      <textarea style={{ ...inp, resize: "vertical", minHeight: 80 }} value={(a.params.htmlBody || "").replace(/<br\s*\/?>(?!\n)/gi, "\n")} onChange={e => updAction(i, { htmlBody: e.target.value.replace(/\n/g, "<br>") })} placeholder={es ? "Mensaje... ej: Hola ${firstName}, gracias por tu interés..." : "Message... e.g. Hi ${firstName}, thanks for your interest..."} />
                    </div>
                  ) : (
                    <div>
                    <div style={{ display: "grid", gridTemplateColumns: "1fr auto auto", gap: ".4rem", alignItems: "center" }}>
                      <input style={inp} value={a.params.title || ""} onChange={e => updAction(i, { title: e.target.value })} placeholder={es ? "Título de la tarea (ej: Llamar a ${firstName})" : "Task title (e.g. Call ${firstName})"} />
                      <input type="number" min="0" style={{ ...inp, width: 90 }} value={a.params.dueInDays ?? 1} onChange={e => updAction(i, { dueInDays: Number(e.target.value) })} title={es ? "En cuántos días vence" : "Due in days"} />
                      <select style={{ ...inp, width: 110 }} value={a.params.priority || "MEDIUM"} onChange={e => updAction(i, { priority: e.target.value })}>
                        <option value="LOW">{es ? "Baja" : "Low"}</option>
                        <option value="MEDIUM">{es ? "Media" : "Medium"}</option>
                        <option value="HIGH">{es ? "Alta" : "High"}</option>
                        <option value="URGENT">{es ? "Urgente" : "Urgent"}</option>
                      </select>
                    </div>
                    {renderChips((tok) => updAction(i, { title: (a.params.title || "") + tok }))}
                    </div>
                  )}
                </div>
              ))}
            </div>
            <div style={{ display: "flex", gap: ".4rem", marginTop: ".5rem" }}>
              <button type="button" onClick={() => addAction("send_email")} style={{ background: "rgba(0,212,255,.08)", border: "1px solid rgba(0,212,255,.25)", color: "#00d4ff", padding: ".35rem .6rem", borderRadius: 7, fontSize: ".72rem", fontWeight: 700, cursor: "pointer" }}>+ {es ? "Email" : "Email"}</button>
              <button type="button" onClick={() => addAction("create_task")} style={{ background: "rgba(255,183,0,.08)", border: "1px solid rgba(255,183,0,.25)", color: "#ffb700", padding: ".35rem .6rem", borderRadius: 7, fontSize: ".72rem", fontWeight: 700, cursor: "pointer" }}>+ {es ? "Tarea" : "Task"}</button>
            </div>
            <div style={{ fontSize: ".66rem", color: "var(--c-text3,#45688a)", marginTop: ".4rem" }}>{es ? "Nota: SMS/WhatsApp llegarán cuando se active la telefonía." : "Note: SMS/WhatsApp will arrive once telephony is enabled."}</div>
          </div>
        </div>
        <div style={{ padding: "1rem 1.25rem", borderTop: "1px solid var(--c-border,#1a3550)", display: "flex", gap: ".5rem", justifyContent: "flex-end" }}>
          <button type="button" onClick={() => !busy && setDraft(null)} style={{ background: "var(--c-surface2,#112538)", border: "1px solid var(--c-border,#1a3550)", color: "var(--c-text2,#7aa3c0)", padding: ".55rem 1rem", borderRadius: 8, fontSize: ".8rem", cursor: "pointer", fontWeight: 600 }}>{es ? "Cancelar" : "Cancel"}</button>
          <button type="button" disabled={busy} onClick={() => onSave(draft)} style={{ background: "linear-gradient(135deg,#0099cc,#0055aa)", border: "none", color: "#fff", padding: ".55rem 1.2rem", borderRadius: 8, fontSize: ".8rem", cursor: busy ? "wait" : "pointer", opacity: busy ? .6 : 1, fontWeight: 700 }}>{busy ? "…" : (es ? "Guardar" : "Save")}</button>
        </div>
      </div>
    </div>
  );
}

function AIAutomationsView({ clients, leads, lang }) {
  const [activeTab, setActiveTab] = useState("workflows");
  // Real workflows from the backend automation engine (no more demo data).
  const [workflows, setWorkflows] = useState([]);
  const [wfLoading, setWfLoading] = useState(true);
  const [wfModal, setWfModal] = useState(null); // null | {new:true,...} | existing workflow
  const [wfBusy, setWfBusy] = useState(false);

  const loadWorkflows = async () => {
    setWfLoading(true);
    try {
      const { listWorkflows } = await import("./crm-app/api.js");
      const rows = await listWorkflows();
      setWorkflows(Array.isArray(rows) ? rows : []);
    } catch (e) { /* leave list empty on error */ }
    finally { setWfLoading(false); }
  };
  useEffect(() => { loadWorkflows(); }, []);

  const toggleWf = async (wf) => {
    try {
      const api = await import("./crm-app/api.js");
      if (wf.isActive) await api.pauseWorkflow(wf.id); else await api.resumeWorkflow(wf.id);
      setWorkflows(prev => prev.map(w => w.id === wf.id ? { ...w, isActive: !w.isActive } : w));
    } catch (e) { toast.error(String((e && e.message) || e)); }
  };
  const deleteWf = async (wf) => {
    const ok = await confirmDialog({ message: lang === "es" ? `¿Borrar la automatización "${wf.name}"?` : `Delete automation "${wf.name}"?`, danger: true });
    if (!ok) return;
    try {
      const api = await import("./crm-app/api.js");
      await api.deleteWorkflow(wf.id);
      setWorkflows(prev => prev.filter(w => w.id !== wf.id));
    } catch (e) { toast.error(String((e && e.message) || e)); }
  };
  const testWf = async (wf) => {
    try {
      const api = await import("./crm-app/api.js");
      await api.fireWorkflowTest(wf.id);
      toast.success(lang === "es" ? "Prueba enviada — revisa el resultado en unos segundos" : "Test fired — check the result shortly");
    } catch (e) { toast.error(String((e && e.message) || e)); }
  };
  const saveWf = async (draft) => {
    // draft: { id?, name, triggerType, actions:[{type, params}] }
    if (!draft.name.trim()) { toast.error(lang === "es" ? "Ponle un nombre" : "Add a name"); return; }
    if (!draft.actions.length) { toast.error(lang === "es" ? "Agrega al menos una acción" : "Add at least one action"); return; }
    setWfBusy(true);
    try {
      const api = await import("./crm-app/api.js");
      const payload = { name: draft.name.trim(), triggerType: draft.triggerType, actions: draft.actions };
      if (draft.id) { await api.updateWorkflow(draft.id, payload); }
      else { await api.createWorkflow(payload); }
      await loadWorkflows();
      setWfModal(null);
      toast.success(lang === "es" ? "Automatización guardada" : "Automation saved");
    } catch (e) { toast.error(String((e && e.message) || e)); }
    finally { setWfBusy(false); }
  };

  const [aiChat, setAiChat] = useState([
    { role: "ai", text: lang === "es" ? "👋 Hola! Soy MyGuard AI, tu asistente inteligente. Puedo ayudarte a:\n\n• Calificar leads automáticamente\n• Enviar follow-ups personalizados\n• Contestar FAQs de clientes\n• Agendar citas\n• Analizar tu pipeline\n\n¿En qué te puedo ayudar?" : "👋 Hi! I'm MyGuard AI, your intelligent assistant. I can help you:\n\n• Auto-qualify leads\n• Send personalized follow-ups\n• Answer client FAQs\n• Schedule appointments\n• Analyze your pipeline\n\nHow can I help?" },
  ]);
  const [aiInput, setAiInput] = useState("");

  // Real backend triggers + actions (must match workflows.routes.ts).
  const TRIGGER_OPTIONS = [
    { v: "lead.created", es: "🎯 Nuevo lead", en: "🎯 New lead" },
    { v: "client.created", es: "👤 Nuevo cliente", en: "👤 New client" },
    { v: "policy.created", es: "📋 Nueva póliza", en: "📋 New policy" },
    { v: "invoice.paid", es: "💵 Factura pagada", en: "💵 Invoice paid" },
    { v: "signature.completed", es: "✍️ Firma completada", en: "✍️ Signature completed" },
  ];
  const triggerLabel = (v) => { const t = TRIGGER_OPTIONS.find(o => o.v === v); return t ? (lang === "es" ? t.es : t.en) : v; };
  const ACTION_META = {
    send_email: { icon: "📧", color: "#00d4ff", es: "Enviar email", en: "Send email" },
    create_task: { icon: "✅", color: "#ffb700", es: "Crear tarea", en: "Create task" },
    enroll_in_sequence: { icon: "🔁", color: "#a78bfa", es: "Inscribir en secuencia", en: "Enroll in sequence" },
  };
  const actionLabel = (a) => {
    const m = ACTION_META[a.type]; const base = m ? (lang === "es" ? m.es : m.en) : a.type;
    if (a.type === "send_email" && a.params?.subject) return `${base}: ${a.params.subject}`;
    if (a.type === "create_task" && a.params?.title) return `${base}: ${a.params.title}`;
    return base;
  };

  const [aiThinking, setAiThinking] = useState(false);
  const sendAiMsg = async () => {
    if (!aiInput.trim() || aiThinking) return;
    const userMsg = aiInput.trim();
    const priorChat = aiChat;
    setAiChat(prev => [...prev, { role: "user", text: userMsg }]);
    setAiInput("");
    setAiThinking(true);
    try {
      const { aiChat: callAiChat } = await import("./crm-app/api.js");
      // Send the last few turns as context (excluding the canned greeting).
      const history = priorChat.filter(m => m.role === "user" || m.role === "ai").slice(-6);
      const { reply } = await callAiChat({ message: userMsg, history });
      setAiChat(prev => [...prev, { role: "ai", text: reply || (lang === "es" ? "(sin respuesta)" : "(no reply)") }]);
    } catch (e) {
      const msg = String((e && e.message) || e);
      setAiChat(prev => [...prev, { role: "ai", text: (lang === "es" ? "⚠️ No pude responder: " : "⚠️ Couldn't respond: ") + msg }]);
    } finally {
      setAiThinking(false);
    }
  };

  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "1rem" }}>
        <div style={{ display: "flex", alignItems: "center", gap: ".5rem" }}>
          <span style={{ fontSize: "1.4rem" }}>🤖</span>
          <h2 style={{ fontSize: "1.1rem", fontWeight: 800, color: "var(--c-white,#eef6ff)", margin: 0 }}>AI Automations</h2>
          <span style={{ fontSize: ".65rem", padding: "2px 8px", borderRadius: 100, fontWeight: 700, background: "rgba(0,255,136,.12)", color: "#00ff88", border: "1px solid rgba(0,255,136,.25)" }}>POWERED BY AI</span>
        </div>
      </div>

      <div style={{ display: "flex", gap: ".35rem", marginBottom: ".75rem" }}>
        {[["workflows", "⚡ Workflows"]].map(([id, label]) => (
          <button type="button" key={id} onClick={() => setActiveTab(id)}
            style={{ padding: ".35rem .8rem", borderRadius: 8, border: `1px solid ${activeTab === id ? "rgba(0,212,255,.4)" : "var(--c-border,#1a3550)"}`, background: activeTab === id ? "var(--c-cyan-dim)" : "transparent", color: activeTab === id ? "var(--c-cyan,#00d4ff)" : "var(--c-text3,#45688a)", fontSize: ".75rem", fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}>
            {label}
          </button>
        ))}
      </div>

      {activeTab === "workflows" && (
        <div style={{ display: "flex", flexDirection: "column", gap: ".5rem" }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <div style={{ fontSize: ".7rem", color: "var(--c-text3,#45688a)" }}>
              {lang === "es" ? "Automatizaciones que corren solas según un disparador." : "Automations that run on their own from a trigger."}
            </div>
            <button type="button" onClick={() => setWfModal({ new: true, name: "", triggerType: "lead.created", actions: [] })}
              style={{ background: "linear-gradient(135deg,#0099cc,#0055aa)", border: "none", color: "#fff", padding: ".4rem .8rem", borderRadius: 8, cursor: "pointer", fontWeight: 700, fontSize: ".75rem", fontFamily: "inherit" }}>
              + {lang === "es" ? "Crear automatización" : "Create automation"}
            </button>
          </div>

          {wfLoading && <div style={{ textAlign: "center", padding: "1.5rem", color: "var(--c-text3,#45688a)", fontSize: ".8rem" }}>{lang === "es" ? "Cargando…" : "Loading…"}</div>}
          {!wfLoading && workflows.length === 0 && (
            <div style={{ textAlign: "center", padding: "1.75rem 1rem", color: "var(--c-text3,#45688a)", fontSize: ".8rem", lineHeight: 1.7 }}>
              <div style={{ fontSize: "1.6rem", marginBottom: ".3rem" }}>⚡</div>
              {lang === "es" ? "Aún no tienes automatizaciones. Crea una con el botón de arriba." : "No automations yet. Create one with the button above."}
            </div>
          )}

          {workflows.map(wf => (
            <div key={wf.id} style={{ background: "var(--c-surface2,#112538)", border: `1px solid ${wf.isActive ? "rgba(0,255,136,.2)" : "var(--c-border,#1a3550)"}`, borderLeft: `3px solid ${wf.isActive ? "#00ff88" : "#45688a"}`, borderRadius: 10, padding: ".875rem 1rem" }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: ".5rem", gap: ".5rem" }}>
                <div style={{ minWidth: 0 }}>
                  <div style={{ fontWeight: 700, fontSize: ".88rem", color: "var(--c-white,#eef6ff)", display: "flex", alignItems: "center", gap: ".4rem", flexWrap: "wrap" }}>
                    {wf.name}
                    <span style={{ fontSize: ".6rem", padding: "2px 8px", borderRadius: 100, fontWeight: 700, background: wf.isActive ? "rgba(0,255,136,.12)" : "rgba(100,116,139,.12)", color: wf.isActive ? "#00ff88" : "#64748b" }}>{wf.isActive ? (lang === "es" ? "ACTIVA" : "ACTIVE") : "OFF"}</span>
                  </div>
                  <div style={{ fontSize: ".68rem", color: "var(--c-text3,#45688a)", marginTop: 2 }}>
                    {lang === "es" ? "Cuando: " : "When: "}{triggerLabel(wf.triggerType)}
                    {wf.lastError ? <span style={{ color: "#ef4444", marginLeft: 6 }}>⚠️ {lang === "es" ? "último error" : "last error"}</span> : null}
                  </div>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: ".4rem", flex: "0 0 auto" }}>
                  <button type="button" title={lang === "es" ? "Probar" : "Test"} onClick={() => testWf(wf)} style={{ background: "none", border: "1px solid var(--c-border,#1a3550)", color: "var(--c-text2,#7aa3c0)", cursor: "pointer", borderRadius: 6, padding: ".2rem .45rem", fontSize: ".7rem" }}>▶</button>
                  <button type="button" title={lang === "es" ? "Editar" : "Edit"} onClick={() => setWfModal({ id: wf.id, name: wf.name, triggerType: wf.triggerType, actions: Array.isArray(wf.actions) ? wf.actions : [] })} style={{ background: "none", border: "1px solid var(--c-border,#1a3550)", color: "var(--c-text2,#7aa3c0)", cursor: "pointer", borderRadius: 6, padding: ".2rem .45rem", fontSize: ".7rem" }}>✎</button>
                  <button type="button" title={lang === "es" ? "Borrar" : "Delete"} onClick={() => deleteWf(wf)} style={{ background: "none", border: "1px solid rgba(239,68,68,.3)", color: "#ef4444", cursor: "pointer", borderRadius: 6, padding: ".2rem .45rem", fontSize: ".7rem" }}>🗑</button>
                  <button type="button" onClick={() => toggleWf(wf)}
                    style={{ width: 40, height: 22, borderRadius: 11, border: "none", cursor: "pointer", background: wf.isActive ? "#00ff88" : "var(--c-surface3,#162d44)", position: "relative", transition: "background .2s" }}>
                    <div style={{ width: 16, height: 16, borderRadius: "50%", background: "#fff", position: "absolute", top: 3, left: wf.isActive ? 21 : 3, transition: "left .2s", boxShadow: "0 1px 3px rgba(0,0,0,.3)" }} />
                  </button>
                </div>
              </div>
              {/* Actions */}
              <div style={{ display: "flex", gap: ".35rem", flexWrap: "wrap" }}>
                {(Array.isArray(wf.actions) ? wf.actions : []).map((a, si) => {
                  const m = ACTION_META[a.type] || { icon: "📌", color: "#64748b" };
                  return (
                    <div key={si} style={{ display: "flex", alignItems: "center", gap: ".25rem" }}>
                      {si > 0 && <span style={{ color: "var(--c-text3,#45688a)", fontSize: ".6rem" }}>→</span>}
                      <div style={{ background: m.color + "15", border: `1px solid ${m.color}33`, borderRadius: 7, padding: ".25rem .5rem", fontSize: ".65rem", color: m.color, fontWeight: 600 }}>
                        {m.icon} {actionLabel(a)}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      )}

      {wfModal && <WorkflowEditorModal draft={wfModal} setDraft={setWfModal} onSave={saveWf} busy={wfBusy} lang={lang} TRIGGER_OPTIONS={TRIGGER_OPTIONS} />}
    </div>
  );
}

// Full-page "Deskte AI" view (sidebar → AI & Automation). Wraps the reusable
// DeskteAiChat with a header that lets the agency rename the assistant.
function DeskteAiPage({ aiName, lang, onRename }) {
  const es = lang === "es";
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(aiName);
  useEffect(() => { setDraft(aiName); }, [aiName]);
  const save = () => { const n = (draft || "").trim(); if (n && n !== aiName) onRename?.(n); setEditing(false); };
  return (
    <div style={{ maxWidth: 760, margin: "0 auto" }}>
      <div style={{ display: "flex", alignItems: "center", gap: ".5rem", marginBottom: "1rem", flexWrap: "wrap" }}>
        <span style={{ fontSize: "1.4rem" }}>🤖</span>
        {editing ? (
          <span style={{ display: "flex", alignItems: "center", gap: ".4rem" }}>
            <input className="dkt-inp" value={draft} maxLength={40} autoFocus onChange={e => setDraft(e.target.value)}
              onKeyDown={e => { if (e.key === "Enter") save(); if (e.key === "Escape") { setDraft(aiName); setEditing(false); } }}
              style={{ width: 200, padding: ".3rem .5rem", fontSize: ".95rem" }} />
            <button type="button" onClick={save} className="dkt-btn-s" style={{ padding: ".3rem .7rem" }}>{es ? "Guardar" : "Save"}</button>
          </span>
        ) : (
          <>
            <h2 style={{ fontSize: "1.1rem", fontWeight: 800, color: "var(--c-white,#eef6ff)", margin: 0 }}>{aiName}</h2>
            <button type="button" onClick={() => setEditing(true)} title={es ? "Cambiar el nombre" : "Rename"}
              style={{ background: "var(--c-surface2,#112538)", border: "1px solid var(--c-border,#1a3550)", color: "var(--c-text2,#7aa3c0)", cursor: "pointer", padding: "3px 8px", borderRadius: 7, fontSize: ".7rem", fontWeight: 700, display: "inline-flex", alignItems: "center", gap: 4 }}>
              <Edit3 size={12} />{es ? "Renombrar" : "Rename"}
            </button>
          </>
        )}
        <span style={{ fontSize: ".65rem", padding: "2px 8px", borderRadius: 100, fontWeight: 700, background: "rgba(0,255,136,.12)", color: "#00ff88", border: "1px solid rgba(0,255,136,.25)" }}>POWERED BY AI</span>
      </div>
      <DeskteAiChat aiName={aiName} lang={lang} />
    </div>
  );
}

function BookingView({ currentUser, users, lang }) {
  const tt = (es, en) => (lang === "es" ? es : en);
  const DEFAULT_AVAIL = {
    mon: { active: true, start: "09:00", end: "17:00" },
    tue: { active: true, start: "09:00", end: "17:00" },
    wed: { active: true, start: "09:00", end: "17:00" },
    thu: { active: true, start: "09:00", end: "17:00" },
    fri: { active: true, start: "09:00", end: "16:00" },
    sat: { active: false, start: "10:00", end: "14:00" },
    sun: { active: false, start: "", end: "" },
  };
  const DAY_LABELS = lang === "es"
    ? { mon: "Lunes", tue: "Martes", wed: "Miércoles", thu: "Jueves", fri: "Viernes", sat: "Sábado", sun: "Domingo" }
    : { mon: "Monday", tue: "Tuesday", wed: "Wednesday", thu: "Thursday", fri: "Friday", sat: "Saturday", sun: "Sunday" };
  const TIMEZONES = [
    ["America/New_York", tt("Este — New York", "Eastern — New York")],
    ["America/Chicago", tt("Central — Chicago", "Central — Chicago")],
    ["America/Denver", tt("Montaña — Denver", "Mountain — Denver")],
    ["America/Phoenix", "Arizona — Phoenix"],
    ["America/Los_Angeles", tt("Pacífico — Los Angeles", "Pacific — Los Angeles")],
  ];

  const [cfg, setCfg] = useState(null);
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState("");
  const [savedTick, setSavedTick] = useState(0);
  const [copiedLink, setCopiedLink] = useState(false);
  const [mesBloqueo, setMesBloqueo] = useState("");
  // "ENLACE DE:" (Lissette 2026-10-17, opción 2): la dueña y los seats pueden
  // abrir y cambiar el Booking Link de cualquier agente de la agencia. `para`
  // vacío = el mío. La lista la decide el servidor (/booking/editables).
  const [para, setPara] = useState("");
  const [editables, setEditables] = useState([]);
  // Se vuelve a pedir al guardar: la lista "Enlaces creados" enseña la
  // dirección y si está activo, y tiene que verse lo recién guardado.
  const [listaTick, setListaTick] = useState(0);
  useEffect(() => {
    let off = false;
    import("./crm-app/api.js")
      .then((api) => api.getBookingEditables())
      .then((l) => { if (!off) setEditables(Array.isArray(l) ? l : []); })
      .catch(() => { /* sin la lista, solo se ve el enlace propio */ });
    return () => { off = true; };
  }, [listaTick]);
  // UN ASIENTO NO TIENE ENLACE PROPIO (Lissette 2026-10-19): el servidor no le
  // manda "Mi enlace", y sin `para` le abre el de su supervisor.
  const yoId = editables.find((u) => u.yo)?.id || "";
  // Cuál de los enlaces de esa persona está abierto ("" = el primero).
  const [enlace, setEnlace] = useState("");
  const [creando, setCreando] = useState("");
  const [copiadoId, setCopiadoId] = useState("");
  // "Editar" baja a los ajustes; si el enlace aún se está cargando, baja al terminar.
  const irAAjustes = useRef(false);
  const [nuevoNombre, setNuevoNombre] = useState("");
  const sinEnlacePropio = editables.length > 0 && !yoId;

  // Los días bloqueados llegan dentro de `availability` (así los guarda el
  // servidor, sin columna nueva) y aquí se separan: el horario semanal y los
  // bloqueos se editan por su lado y se mandan cada uno en su campo.
  const separarBloqueos = (c) => {
    // `lineas` (Salud / Medicare / Vida que atiende este enlace) también viaja
    // dentro de `availability` y se separa igual (Lissette 2026-10-11).
    // `bufferMinutes` (tiempo entre citas) también (Lissette 2026-10-13).
    // `equipo` (quién atiende cada línea, Lissette 2026-10-17) también.
    // `horarios` (horario propio de cada persona, Lissette 2026-10-17) también.
    // `horasBloqueadas` (día bloqueado solo unas horas, Lissette 2026-10-17) también.
    // `nombre` (el nombre del enlace: Salud, Medicare…, Lissette 2026-10-19) también.
    // `apariencia` (color de la cabecera y ocultar el logo, Gabriel De Silva 2026-10-30, E-404) también.
    const { blockedDates, lineas, bufferMinutes, equipo, horarios, horasBloqueadas, nombre, apariencia, ...semana } = c.availability || {};
    c.nombre = typeof nombre === "string" ? nombre : "";
    c.apariencia = { color: (apariencia && typeof apariencia.color === "string") ? apariencia.color : null, ocultarLogo: !!(apariencia && apariencia.ocultarLogo) };
    c.availability = { ...DEFAULT_AVAIL, ...semana };
    c.blockedDates = Array.isArray(blockedDates) ? blockedDates : [];
    c.lineas = Array.isArray(lineas) ? lineas : [];
    c.bufferMinutes = Number(bufferMinutes) || 0;
    c.equipo = equipo && typeof equipo === "object" && !Array.isArray(equipo) ? equipo : {};
    c.horarios = horarios && typeof horarios === "object" && !Array.isArray(horarios) ? horarios : {};
    c.horasBloqueadas = horasBloqueadas && typeof horasBloqueadas === "object" && !Array.isArray(horasBloqueadas) ? horasBloqueadas : {};
    return c;
  };

  useEffect(() => {
    let off = false;
    (async () => {
      setLoading(true); setErr("");
      try {
        const api = await import("./crm-app/api.js");
        const c = await api.getBookingConfig(para || undefined, enlace || undefined);
        if (off) return;
        setCfg(separarBloqueos(c)); setSavedTick(0);
        setBookings([]);
        try { const bk = await api.getBookingReservations(para || undefined); if (!off) setBookings(bk || []); } catch {}
      } catch (e) { if (!off) setErr(e.message || String(e)); }
      finally { if (!off) setLoading(false); }
    })();
    return () => { off = true; };
  }, [para, enlace]);

  async function crearEnlace(persona) {
    setSaving(true); setErr("");
    try {
      const api = await import("./crm-app/api.js");
      const nuevo = await api.createBookingLink(nuevoNombre.trim(), persona || undefined);
      setCreando(""); setNuevoNombre("");
      setPara(persona); setEnlace(nuevo.id);
      setListaTick(Date.now());
    } catch (e) { setErr(e.message || String(e)); }
    finally { setSaving(false); }
  }
  const bajarAAjustes = () => document.getElementById("ajustes-del-enlace")?.scrollIntoView({ behavior: "smooth", block: "start" });
  function editarEnlace(persona, id, yaAbierto) {
    if (yaAbierto) return bajarAAjustes();
    irAAjustes.current = true;
    setPara(persona); setEnlace(id);
  }
  useEffect(() => {
    if (!loading && irAAjustes.current) { irAAjustes.current = false; setTimeout(bajarAAjustes, 50); }
  }, [loading]);
  async function borrarEnlace(persona, e, cuantos) {
    // El último no se borra (el servidor tampoco lo deja): se explica aquí, a
    // la vista, en vez de un error arriba de la página que no se ve.
    if (cuantos <= 1) {
      window.alert(tt("Es el único enlace de esta persona, así que no se puede borrar. Si no quieres que se use, ábrelo con \"Editar\" y dale \"Desactivar\". También puedes crear otro con \"+ Nuevo enlace\" y luego borrar este.",
        "This is this person's only link, so it can't be deleted. To stop it being used, open it with \"Edit\" and click \"Turn off\". You can also create another with \"+ New link\" and then delete this one."));
      return;
    }
    if (!window.confirm(tt(`¿Borrar el enlace ${e.nombre || e.slug}? Quien tenga esa dirección ya no podrá reservar.`, `Delete the link ${e.nombre || e.slug}? Anyone with that address won't be able to book.`))) return;
    setSaving(true); setErr("");
    try {
      const api = await import("./crm-app/api.js");
      await api.deleteBookingLink(e.id, persona || undefined);
      if (cfg?.id === e.id) setEnlace("");
      setListaTick(Date.now());
    } catch (er) { setErr(er.message || String(er)); }
    finally { setSaving(false); }
  }

  const setField = (patch) => setCfg((c) => ({ ...c, ...patch }));
  const setDay = (day, patch) => setCfg((c) => ({ ...c, availability: { ...c.availability, [day]: { ...c.availability[day], ...patch } } }));

  const origin = (typeof window !== "undefined" && window.location.origin) || "https://app.deskte.com";
  const bookingUrl = cfg ? `${origin}/book/${cfg.slug}` : "";
  const copyLink = () => { navigator.clipboard?.writeText(bookingUrl).catch(() => {}); setCopiedLink(true); setTimeout(() => setCopiedLink(false), 2000); };

  async function persist(extra) {
    if (!cfg) return;
    const merged = { ...cfg, ...(extra || {}) };
    setCfg(merged);
    setSaving(true); setErr("");
    try {
      const api = await import("./crm-app/api.js");
      const saved = await api.saveBookingConfig({
        slug: merged.slug,
        isActive: !!merged.isActive,
        durationMinutes: merged.durationMinutes,
        timezone: merged.timezone,
        meetingTitle: merged.meetingTitle || null,
        welcomeMessage: merged.welcomeMessage || null,
        availability: merged.availability,
        advanceDays: merged.advanceDays,
        minNoticeHours: merged.minNoticeHours,
        blockedDates: merged.blockedDates || [],
        lineas: merged.lineas || [],
        bufferMinutes: Number(merged.bufferMinutes) || 0,
        equipo: merged.equipo || {},
        horarios: merged.horarios || {},
        horasBloqueadas: merged.horasBloqueadas || {},
        nombre: (merged.nombre || "").trim() || null,
        apariencia: { color: merged.apariencia?.color || null, ocultarLogo: !!merged.apariencia?.ocultarLogo },
      }, para || undefined, merged.id);
      setCfg(separarBloqueos(saved)); setSavedTick(Date.now());
      setListaTick(Date.now());
    } catch (e) { setErr(e.message || String(e)); }
    finally { setSaving(false); }
  }
  const save = () => persist();

  const fmtBooking = (iso) => {
    try {
      return new Intl.DateTimeFormat(lang === "es" ? "es-US" : "en-US", { timeZone: cfg?.timezone || "America/New_York", weekday: "short", month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }).format(new Date(iso));
    } catch { return iso; }
  };

  // De quién es el enlace abierto. Un asiento sin `para` tiene abierto el de su
  // supervisor (lo eligió el servidor): el selector lo marca a él.
  const elegido = para || (sinEnlacePropio ? (cfg?.userId || editables[0]?.id || "") : "");
  // "Enlace de:" — si hay más de uno que pueda abrir, o si es un asiento (para
  // que vea de quién es el enlace aunque su agencia tenga uno solo).
  const selectorDeEnlace = (editables.length > 1 || sinEnlacePropio) ? (
    <label style={{ display: "inline-flex", alignItems: "center", gap: 6, fontSize: ".72rem", fontWeight: 700, color: "var(--c-text2,#7aa3c0)" }}>
      {tt("Enlace de:", "Link of:")}
      <select className="dkt-inp" value={elegido} onChange={(e) => { setPara(e.target.value); setEnlace(""); }} disabled={saving} style={{ minWidth: 170, fontSize: ".74rem" }}>
        {editables.map((u) => <option key={u.id} value={u.yo ? "" : u.id}>{u.yo ? tt("Mi enlace", "My link") : (u.name || u.id)}</option>)}
      </select>
    </label>
  ) : null;

  if (loading) {
    return <div style={{ padding: "2rem", textAlign: "center", color: "var(--c-text3,#45688a)" }}>{selectorDeEnlace}<div style={{ marginTop: ".6rem" }}>{tt("Cargando…", "Loading…")}</div></div>;
  }
  if (!cfg) {
    return <div style={{ padding: "2rem", textAlign: "center", color: "#fca5a5" }}>{selectorDeEnlace}<div style={{ marginTop: ".6rem" }}>{err || tt("No se pudo cargar.", "Couldn't load.")}</div></div>;
  }
  const deOtro = !!para || sinEnlacePropio;
  const nombreDelDueno = deOtro ? (editables.find((u) => u.id === (elegido || cfg.userId))?.name || "") : "";

  const lbl = { fontSize: ".65rem", color: "var(--c-text3,#45688a)", fontWeight: 700, textTransform: "uppercase", letterSpacing: ".08em", marginBottom: ".4rem" };

  // DÍAS BLOQUEADOS (2026-10-06): fechas sueltas sin citas aunque ese día de la
  // semana esté abierto. "Hoy" es el de la zona del agente, no el del navegador.
  let hoy = "";
  try { hoy = new Intl.DateTimeFormat("en-CA", { timeZone: cfg.timezone || "America/New_York", year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date()); }
  catch { hoy = new Date().toLocaleDateString("en-CA"); }
  const mesHoy = hoy.slice(0, 7);
  const mesVisto = mesBloqueo || mesHoy;
  const bloqueados = new Set(cfg.blockedDates || []);
  // DÍA BLOQUEADO SOLO UNAS HORAS (Lissette 2026-10-17: "no quiero que se
  // quite, quiero que me diga bloqueado a tal hora"). Un día está bloqueado
  // entero (blockedDates) o de una hora a otra (horasBloqueadas[fecha]).
  const horasBloq = cfg.horasBloqueadas || {};
  const proximosBloqueos = [...new Set([...bloqueados, ...Object.keys(horasBloq)])].filter((f) => f >= hoy).sort();
  const sinRato = (f) => { const { [f]: _f, ...resto } = horasBloq; return resto; };
  const alternarBloqueo = (f) => {
    if (horasBloq[f]) return setField({ horasBloqueadas: sinRato(f) });
    setField({ blockedDates: bloqueados.has(f) ? [...bloqueados].filter((x) => x !== f) : [...bloqueados, f].sort() });
  };
  // "Todo el día" ↔ "Solo de … a …".
  const soloUnasHoras = (f, si) => si
    ? setField({ blockedDates: [...bloqueados].filter((x) => x !== f), horasBloqueadas: { ...horasBloq, [f]: { desde: "09:00", hasta: "10:00" } } })
    : setField({ horasBloqueadas: sinRato(f), blockedDates: [...new Set([...bloqueados, f])].sort() });
  const cambiarRato = (f, cambio) => setField({ horasBloqueadas: { ...horasBloq, [f]: { ...horasBloq[f], ...cambio } } });
  const fmtHora = (hhmm) => { try { const [h, m] = hhmm.split(":").map(Number); return new Date(2000, 0, 1, h, m).toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" }); } catch { return hhmm; } };
  const DOW = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
  const fmtBloqueo = (f) => { try { return new Intl.DateTimeFormat(lang === "es" ? "es-US" : "en-US", { weekday: "short", month: "short", day: "numeric", timeZone: "UTC" }).format(new Date(`${f}T12:00:00Z`)); } catch { return f; } };

  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "1rem", flexWrap: "wrap", gap: ".5rem" }}>
        <div style={{ display: "flex", alignItems: "center", gap: ".5rem" }}>
          <span style={{ fontSize: "1.4rem" }}>🔗</span>
          <h2 style={{ fontSize: "1.1rem", fontWeight: 800, color: "var(--c-white,#eef6ff)", margin: 0 }}>Booking Link{deOtro && nombreDelDueno ? ` — ${nombreDelDueno}` : ""}{cfg.nombre ? ` · ${cfg.nombre}` : ""}</h2>
          {selectorDeEnlace}
          <span style={{ fontSize: ".62rem", padding: "2px 9px", borderRadius: 100, fontWeight: 700, background: cfg.isActive ? "rgba(0,255,136,.12)" : "rgba(255,183,0,.12)", color: cfg.isActive ? "#00ff88" : "#ffb700", border: `1px solid ${cfg.isActive ? "rgba(0,255,136,.3)" : "rgba(255,183,0,.3)"}` }}>
            {cfg.isActive ? tt("Activo", "Active") : tt("Inactivo", "Inactive")}
          </span>
        </div>
        <div style={{ display: "flex", gap: ".4rem", alignItems: "center" }}>
          <button type="button" onClick={() => persist({ isActive: !cfg.isActive })}
            style={{ display: "flex", alignItems: "center", gap: 5, background: "var(--c-surface3,#162d44)", border: "1px solid var(--c-border,#1a3550)", color: "var(--c-text2,#7aa3c0)", fontSize: ".75rem", fontWeight: 700, padding: ".45rem .85rem", borderRadius: 9, cursor: "pointer", fontFamily: "inherit" }}>
            {cfg.isActive ? tt("Desactivar", "Turn off") : tt("Activar", "Turn on")}
          </button>
          <button type="button" onClick={save} disabled={saving}
            style={{ display: "flex", alignItems: "center", gap: 5, background: "linear-gradient(135deg,#0099cc,#0055aa)", border: "none", color: "#fff", fontSize: ".78rem", fontWeight: 700, padding: ".5rem 1rem", borderRadius: 9, cursor: saving ? "wait" : "pointer", fontFamily: "inherit", opacity: saving ? .7 : 1 }}>
            <Check size={14} />{saving ? tt("Guardando…", "Saving…") : (savedTick ? tt("Guardado", "Saved") : tt("Guardar", "Save"))}
          </button>
        </div>
      </div>

      {err && <div style={{ background: "#3a1620", border: "1px solid #7f1d1d", color: "#fecaca", borderRadius: 10, padding: ".6rem .8rem", marginBottom: ".75rem", fontSize: ".78rem" }}>{err}</div>}

      {/* PUBLIC LINK */}
      <div style={{ background: "var(--c-surface2,#112538)", border: "1px solid rgba(0,212,255,.25)", borderRadius: 12, padding: "1rem", marginBottom: "1rem", display: "flex", alignItems: "center", gap: ".75rem", flexWrap: "wrap" }}>
        <div style={{ flex: 1, minWidth: 200 }}>
          <div style={{ ...lbl, marginBottom: ".3rem" }}>{deOtro ? tt(`Link público${nombreDelDueno ? ` de ${nombreDelDueno}` : ""}`, `Public link${nombreDelDueno ? ` of ${nombreDelDueno}` : ""}`) : tt("Tu link público", "Your public link")}</div>
          <div style={{ fontSize: ".82rem", fontFamily: "var(--font-mono)", color: "var(--c-cyan,#00d4ff)", wordBreak: "break-all" }}>{bookingUrl}</div>
          {!cfg.isActive && <div style={{ fontSize: ".68rem", color: "#ffb700", marginTop: ".25rem" }}>{tt("El link está desactivado: los visitantes verán “no disponible”. Actívalo cuando estés lista.", "The link is off: visitors will see “unavailable”. Turn it on when ready.")}</div>}
        </div>
        <button type="button" onClick={copyLink}
          style={{ display: "flex", alignItems: "center", gap: 5, background: copiedLink ? "rgba(0,255,136,.15)" : "var(--c-surface3,#162d44)", border: copiedLink ? "1px solid rgba(0,255,136,.3)" : "1px solid var(--c-border,#1a3550)", color: copiedLink ? "#00ff88" : "var(--c-text2,#7aa3c0)", fontSize: ".78rem", fontWeight: 700, padding: ".5rem 1rem", borderRadius: 9, cursor: "pointer", fontFamily: "inherit" }}>
          {copiedLink ? <><Check size={14} />{tt("Copiado", "Copied")}</> : <><Copy size={14} />{tt("Copiar", "Copy")}</>}
        </button>
        <a href={bookingUrl} target="_blank" rel="noreferrer"
          style={{ display: "flex", alignItems: "center", gap: 5, background: "linear-gradient(135deg,#0099cc,#0055aa)", color: "#fff", fontSize: ".78rem", fontWeight: 700, padding: ".5rem 1rem", borderRadius: 9, textDecoration: "none" }}>
          <ExternalLink size={14} />{tt("Abrir", "Open")}
        </a>
      </div>

      {/* ENLACES GUARDADOS (Lissette 2026-10-19: "¿los links creados dónde se
          pueden ver? Cuando le doy guardar no se ven"; y "si yo creo un link
          para Salud u otro para Medicare"). Cada persona puede tener VARIOS
          enlaces; aquí salen todos los que se pueden abrir, con su nombre, su
          dirección y si está activo. "Ver / editar" lo abre arriba y
          "+ Nuevo enlace" crea otro para esa persona. Siempre visible, aunque
          haya uno solo. */}
      {editables.length > 0 && (
        <div style={{ background: "var(--c-surface2,#112538)", border: "1px solid var(--c-border,#1a3550)", borderRadius: 12, padding: ".8rem 1rem", marginBottom: "1rem" }}>
          <div style={{ ...lbl, marginBottom: ".5rem" }}>{tt("Enlaces guardados", "Saved links")}</div>
          <div style={{ display: "flex", flexDirection: "column", gap: ".6rem" }}>
            {editables.map((u) => {
              const persona = u.yo ? "" : u.id;
              const deEsta = (u.yo ? !elegido : elegido === u.id);
              const suyos = Array.isArray(u.enlaces) ? u.enlaces : [];
              const btn = { fontSize: ".7rem", fontWeight: 700, padding: ".25rem .65rem", borderRadius: 7, border: "1px solid var(--c-border,#1a3550)", background: "var(--c-surface3,#162d44)", color: "var(--c-text2,#7aa3c0)", cursor: "pointer", fontFamily: "inherit" };
              return (
                <div key={u.id}>
                  <div style={{ display: "flex", alignItems: "center", gap: ".5rem", flexWrap: "wrap", marginBottom: ".25rem" }}>
                    <span style={{ fontSize: ".76rem", fontWeight: 800, color: "var(--c-white,#eef6ff)" }}>{u.yo ? tt("Mis enlaces", "My links") : (u.name || u.id)}</span>
                    {creando === u.id ? (
                      <span style={{ display: "inline-flex", gap: ".3rem", alignItems: "center" }}>
                        <input className="dkt-inp" autoFocus value={nuevoNombre} onChange={(e) => setNuevoNombre(e.target.value)} placeholder={tt("Nombre: Salud, Medicare…", "Name: Health, Medicare…")} maxLength={60} style={{ width: 190, fontSize: ".72rem" }}
                          onKeyDown={(e) => { if (e.key === "Enter") crearEnlace(persona); if (e.key === "Escape") setCreando(""); }} />
                        <button type="button" onClick={() => crearEnlace(persona)} disabled={saving} style={btn}>{tt("Crear", "Create")}</button>
                        <button type="button" onClick={() => setCreando("")} style={{ ...btn, background: "transparent" }}>{tt("Cancelar", "Cancel")}</button>
                      </span>
                    ) : (
                      <button type="button" onClick={() => { setCreando(u.id); setNuevoNombre(""); }} disabled={saving} style={btn}>{tt("+ Nuevo enlace", "+ New link")}</button>
                    )}
                  </div>
                  {suyos.length === 0 && (
                    <div style={{ fontSize: ".7rem", color: "var(--c-text3,#45688a)", padding: ".2rem .5rem" }}>
                      {tt("Todavía sin crear. ", "Not created yet. ")}
                      <button type="button" onClick={() => { setPara(persona); setEnlace(""); }} disabled={saving} style={btn}>{tt("Crear", "Create")}</button>
                    </div>
                  )}
                  {suyos.map((e) => {
                    const abierto = deEsta && cfg.id === e.id;
                    const url = `${origin}/book/${e.slug}`;
                    return (
                      <div key={e.id} style={{ display: "flex", alignItems: "center", gap: ".6rem", flexWrap: "wrap", padding: ".3rem .5rem", borderRadius: 8, background: abierto ? "rgba(0,212,255,.06)" : "transparent" }}>
                        <span style={{ fontSize: ".72rem", fontWeight: 700, color: "var(--c-text2,#7aa3c0)", minWidth: 110 }}>{e.nombre || tt("Sin nombre", "No name")}</span>
                        <span style={{ flex: 1, minWidth: 180, fontSize: ".72rem", fontFamily: "var(--font-mono)", color: "var(--c-cyan,#00d4ff)", wordBreak: "break-all" }}>{url}</span>
                        <span style={{ fontSize: ".6rem", padding: "1px 8px", borderRadius: 100, fontWeight: 700, color: e.isActive ? "#00ff88" : "#ffb700", border: `1px solid ${e.isActive ? "rgba(0,255,136,.3)" : "rgba(255,183,0,.3)"}` }}>{e.isActive ? tt("Activo", "Active") : tt("Inactivo", "Inactive")}</span>
                        {/* Los cuatro botones SIEMPRE (Lissette 2026-10-19: "no me
                            deja editarlo o borrarlo o abrirlo" — con un solo
                            enlace la fila no tenía ningún botón). */}
                        <a href={url} target="_blank" rel="noreferrer" style={{ ...btn, textDecoration: "none" }}>{tt("Abrir", "Open")}</a>
                        <button type="button" onClick={() => { navigator.clipboard?.writeText(url).catch(() => {}); setCopiadoId(e.id); setTimeout(() => setCopiadoId(""), 2000); }} style={btn}>
                          {copiadoId === e.id ? tt("Copiado", "Copied") : tt("Copiar", "Copy")}
                        </button>
                        <button type="button" onClick={() => editarEnlace(persona, e.id, abierto)} disabled={saving} style={btn}>{tt("Editar", "Edit")}</button>
                        <button type="button" onClick={() => borrarEnlace(persona, e, suyos.length)} disabled={saving} title={tt("Borrar este enlace", "Delete this link")}
                          style={{ ...btn, color: "#fca5a5", background: "transparent" }}>{tt("Borrar", "Delete")}</button>
                        {abierto && <span style={{ fontSize: ".66rem", color: "var(--c-text3,#45688a)" }}>{tt("(abierto abajo)", "(open below)")}</span>}
                      </div>
                    );
                  })}
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* SETTINGS */}
      <div id="ajustes-del-enlace" style={{ display: "grid", gap: ".85rem", scrollMarginTop: 80 }}>
        <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap" }}>
          <div>
            <div style={lbl}>{tt("Nombre del enlace", "Link name")}</div>
            <input className="dkt-inp" value={cfg.nombre || ""} onChange={(e) => setField({ nombre: e.target.value })} maxLength={60} placeholder={tt("Ej. Salud, Medicare", "e.g. Health, Medicare")} style={{ width: 170 }} />
          </div>
          <div>
            <div style={lbl}>{tt("Enlace (slug)", "Link (slug)")}</div>
            <div style={{ display: "flex", alignItems: "center", gap: ".3rem" }}>
              <span style={{ fontSize: ".72rem", color: "var(--c-text3,#45688a)" }}>/book/</span>
              <input className="dkt-inp" value={cfg.slug} onChange={(e) => setField({ slug: e.target.value.toLowerCase().replace(/[^a-z0-9-]/g, "") })} style={{ width: 190 }} />
            </div>
          </div>
          <div>
            <div style={lbl}>{tt("Duración de cita", "Appointment duration")}</div>
            <div style={{ display: "flex", gap: ".35rem" }}>
              {[15, 30, 45, 60].map((m) => (
                <button type="button" key={m} onClick={() => setField({ durationMinutes: m })}
                  style={{ padding: ".35rem .7rem", borderRadius: 8, border: `1px solid ${cfg.durationMinutes === m ? "rgba(0,212,255,.4)" : "var(--c-border,#1a3550)"}`, background: cfg.durationMinutes === m ? "var(--c-cyan-dim)" : "var(--c-surface2,#112538)", color: cfg.durationMinutes === m ? "var(--c-cyan,#00d4ff)" : "var(--c-text3,#45688a)", fontSize: ".72rem", fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}>
                  {m} min
                </button>
              ))}
            </div>
          </div>
          {/* TIEMPO ENTRE CITAS (ticket de Wendy Cercio 2026-10-13: "dejar 10
              minutos entre una cita y otra"). Separa las horas que se ofrecen
              entre sí y de las citas que ya hay en el calendario. */}
          <div>
            <div style={lbl}>{tt("Tiempo entre citas", "Time between appointments")}</div>
            <div style={{ display: "flex", gap: ".35rem" }}>
              {[0, 5, 10, 15, 30].map((m) => (
                <button type="button" key={m} onClick={() => setField({ bufferMinutes: m })}
                  style={{ padding: ".35rem .7rem", borderRadius: 8, border: `1px solid ${(cfg.bufferMinutes || 0) === m ? "rgba(0,212,255,.4)" : "var(--c-border,#1a3550)"}`, background: (cfg.bufferMinutes || 0) === m ? "var(--c-cyan-dim)" : "var(--c-surface2,#112538)", color: (cfg.bufferMinutes || 0) === m ? "var(--c-cyan,#00d4ff)" : "var(--c-text3,#45688a)", fontSize: ".72rem", fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}>
                  {m === 0 ? tt("Ninguno", "None") : `${m} min`}
                </button>
              ))}
            </div>
          </div>
          <div>
            <div style={lbl}>{tt("Zona horaria", "Timezone")}</div>
            <select className="dkt-inp" value={cfg.timezone} onChange={(e) => setField({ timezone: e.target.value })} style={{ minWidth: 200 }}>
              {TIMEZONES.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
            </select>
          </div>
        </div>

        <div style={{ flex: 1, minWidth: 220 }}>
          <div style={lbl}>{tt("Título de la cita (público)", "Meeting title (public)")}</div>
          <input className="dkt-inp" value={cfg.meetingTitle || ""} onChange={(e) => setField({ meetingTitle: e.target.value })} placeholder={tt("Ej. Consulta gratis de seguros", "e.g. Free insurance consultation")} style={{ width: "100%" }} />
        </div>
        {/* LÍNEAS QUE ATIENDE ESTE ENLACE (Lissette 2026-10-11). Con una o más
            marcadas, el cliente elige para qué es la cita y solo le salen
            ocupadas las horas bloqueadas para ESA línea (o para todas). Sin
            marcar ninguna, todo bloqueo cuenta, como siempre. */}
        <div>
          <div style={lbl}>{tt("¿Para qué líneas es este enlace? (opcional)", "Which lines does this link take? (optional)")}</div>
          <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
            {LINEAS_DE_BLOQUEO.map(({ id, es: es_, en: en_ }) => {
              const on = (cfg.lineas || []).includes(id);
              return (
                <button key={id} type="button"
                  onClick={() => setField({ lineas: on ? cfg.lineas.filter((x) => x !== id) : [...(cfg.lineas || []), id] })}
                  style={{ fontSize: ".72rem", fontWeight: 700, padding: ".3rem .7rem", borderRadius: 100, cursor: "pointer", fontFamily: "inherit",
                    border: `1px solid ${on ? "var(--c-cyan,#00d4ff)" : "var(--c-border,#1a3550)"}`,
                    background: on ? "rgba(0,212,255,.14)" : "transparent", color: on ? "var(--c-cyan,#00d4ff)" : "var(--c-text2,#7aa3c0)" }}>
                  {tt(es_, en_)}
                </button>
              );
            })}
          </div>
          <div style={{ fontSize: ".62rem", color: "var(--c-text3,#45688a)", marginTop: 4 }}>
            {tt("El cliente elige para qué es la cita, y una hora bloqueada para Salud sigue libre para Medicare, Vida, Auto o cualquier otra línea.",
                "The client picks what the appointment is for, and a time blocked for Health stays open for Medicare, Life, Auto or any other line.")}
          </div>
        </div>
        <EquipoDelEnlace cfg={cfg} setField={setField} users={users} lang={lang} yo={yoId || "sin-enlace-propio"} />
        <div>
          <div style={lbl}>{tt("Mensaje de bienvenida (opcional)", "Welcome message (optional)")}</div>
          <textarea className="dkt-inp" value={cfg.welcomeMessage || ""} onChange={(e) => setField({ welcomeMessage: e.target.value })} rows={2} style={{ width: "100%", resize: "vertical", fontFamily: "inherit" }} />
        </div>
        <AparienciaDelEnlace cfg={cfg} setField={setField} lang={lang} />

        <div>
          <div style={lbl}>{tt("Disponibilidad", "Availability")}</div>
          <div style={{ display: "flex", flexDirection: "column", gap: ".3rem" }}>
            {["mon", "tue", "wed", "thu", "fri", "sat", "sun"].map((day) => {
              const c = cfg.availability[day] || { active: false, start: "09:00", end: "17:00" };
              return (
                <div key={day} style={{ display: "flex", alignItems: "center", gap: ".5rem", padding: ".3rem .5rem", borderRadius: 7, background: c.active ? "rgba(0,212,255,.04)" : "transparent" }}>
                  <button type="button" onClick={() => setDay(day, { active: !c.active })}
                    style={{ width: 32, height: 18, borderRadius: 9, border: "none", cursor: "pointer", background: c.active ? "var(--c-cyan,#00d4ff)" : "var(--c-surface3,#162d44)", position: "relative", flexShrink: 0 }}>
                    <div style={{ width: 12, height: 12, borderRadius: "50%", background: "#fff", position: "absolute", top: 3, left: c.active ? 17 : 3, transition: "left .2s" }} />
                  </button>
                  <span style={{ fontSize: ".72rem", fontWeight: 600, color: c.active ? "var(--c-white,#eef6ff)" : "var(--c-text3,#45688a)", width: 80 }}>{DAY_LABELS[day]}</span>
                  {c.active && <>
                    <input type="time" className="dkt-inp" value={c.start} onChange={(e) => setDay(day, { start: e.target.value })} style={{ width: 110, fontSize: ".7rem" }} />
                    <span style={{ color: "var(--c-text3,#45688a)", fontSize: ".7rem" }}>→</span>
                    <input type="time" className="dkt-inp" value={c.end} onChange={(e) => setDay(day, { end: e.target.value })} style={{ width: 110, fontSize: ".7rem" }} />
                    {/* DESCANSO / ALMUERZO del día (Lissette 2026-10-13): esas
                        horas nunca se ofrecen. Vacío = sin descanso. */}
                    <span style={{ color: "var(--c-text3,#45688a)", fontSize: ".66rem", marginLeft: ".6rem" }}>🍽️ {tt("Descanso", "Break")}</span>
                    <input type="time" className="dkt-inp" value={c.breakStart || ""} onChange={(e) => setDay(day, { breakStart: e.target.value })} style={{ width: 110, fontSize: ".7rem" }} title={tt("Inicio del descanso / almuerzo", "Break / lunch start")} />
                    <span style={{ color: "var(--c-text3,#45688a)", fontSize: ".7rem" }}>→</span>
                    <input type="time" className="dkt-inp" value={c.breakEnd || ""} onChange={(e) => setDay(day, { breakEnd: e.target.value })} style={{ width: 110, fontSize: ".7rem" }} title={tt("Fin del descanso / almuerzo", "Break / lunch end")} />
                    {(c.breakStart || c.breakEnd) && (
                      <button type="button" onClick={() => setDay(day, { breakStart: "", breakEnd: "" })} title={tt("Quitar descanso", "Remove break")}
                        style={{ background: "none", border: "none", color: "var(--c-text3,#45688a)", cursor: "pointer", fontSize: ".8rem", padding: 0 }}>✕</button>
                    )}
                  </>}
                </div>
              );
            })}
          </div>
        </div>

        <div>
          <div style={lbl}>🚫 {tt("Días bloqueados", "Blocked days")}</div>
          <div style={{ fontSize: ".72rem", color: "var(--c-text3,#45688a)", marginBottom: ".6rem" }}>{tt("Toca un día para bloquearlo (vacaciones, feriados, un día libre). A la derecha puedes cambiarlo a \"Solo unas horas\" y poner de qué hora a qué hora. Tócalo otra vez para desbloquearlo. Luego pulsa Guardar.", "Tap a day to block it (vacation, holidays, a day off). On the right you can switch it to \"Some hours only\" and set the hours. Tap it again to unblock. Then hit Save.")}</div>
          <div style={{ display: "flex", gap: "1.25rem", flexWrap: "wrap", alignItems: "flex-start" }}>
            <div style={{ flex: "1 1 340px", maxWidth: 460, background: "var(--c-surface2,#112538)", border: "1px solid var(--c-border,#1a3550)", borderRadius: 12, padding: ".85rem" }}>
              <CalendarioMensual
                mes={mesVisto}
                onMes={setMesBloqueo}
                puedeAntes={mesVisto > mesHoy}
                puedeDespues
                lang={lang}
                colores={{ texto: "var(--c-white,#eef6ff)", suave: "var(--c-text3,#45688a)", borde: "var(--c-border,#1a3550)", fondo: "var(--c-surface3,#162d44)" }}
                dia={(f) => {
                  if (f < hoy) return { color: "var(--c-text3,#45688a)" };
                  const bloq = bloqueados.has(f);
                  const rato = horasBloq[f];
                  const dow = DOW[new Date(`${f}T12:00:00Z`).getUTCDay()];
                  const abierto = !!cfg.availability?.[dow]?.active;
                  return {
                    tocable: true, pulsado: bloq || !!rato, onClick: () => alternarBloqueo(f), tachado: bloq,
                    titulo: bloq ? tt("Bloqueado todo el día — toca para desbloquear", "Blocked all day — tap to unblock")
                      : rato ? tt(`Bloqueado de ${fmtHora(rato.desde)} a ${fmtHora(rato.hasta)} — toca para desbloquear`, `Blocked ${fmtHora(rato.desde)}–${fmtHora(rato.hasta)} — tap to unblock`)
                      : tt("Toca para bloquear", "Tap to block"),
                    fondo: bloq ? "rgba(239,68,68,.18)" : rato ? "rgba(245,158,11,.18)" : (abierto ? "rgba(0,212,255,.08)" : "transparent"),
                    borde: bloq ? "1px solid rgba(239,68,68,.6)" : rato ? "1px solid rgba(245,158,11,.6)" : (f === hoy ? "1px solid var(--c-cyan,#00d4ff)" : "1px solid var(--c-border,#1a3550)"),
                    color: bloq ? "#fca5a5" : rato ? "#fcd34d" : (abierto ? "var(--c-white,#eef6ff)" : "var(--c-text3,#45688a)"),
                  };
                }}
              />
              <div style={{ display: "flex", gap: ".9rem", flexWrap: "wrap", marginTop: ".6rem", fontSize: ".66rem", color: "var(--c-text3,#45688a)" }}>
                <span><span style={{ display: "inline-block", width: 9, height: 9, borderRadius: 3, background: "rgba(0,212,255,.35)", marginRight: 4 }} />{tt("Abierto", "Open")}</span>
                <span><span style={{ display: "inline-block", width: 9, height: 9, borderRadius: 3, background: "rgba(239,68,68,.6)", marginRight: 4 }} />{tt("Bloqueado todo el día", "Blocked all day")}</span>
                <span><span style={{ display: "inline-block", width: 9, height: 9, borderRadius: 3, background: "rgba(245,158,11,.6)", marginRight: 4 }} />{tt("Bloqueado unas horas", "Blocked some hours")}</span>
              </div>
            </div>
            <div style={{ flex: "1 1 200px", minWidth: 200 }}>
              <div style={{ fontSize: ".72rem", fontWeight: 700, color: "var(--c-text2,#7aa3c0)", marginBottom: ".4rem" }}>{tt("Próximos días bloqueados", "Upcoming blocked days")} ({proximosBloqueos.length})</div>
              {proximosBloqueos.length === 0
                ? <div style={{ fontSize: ".72rem", color: "var(--c-text3,#45688a)" }}>{tt("Ninguno. Todos los días abiertos se pueden reservar.", "None. Every open day can be booked.")}</div>
                : <div style={{ display: "flex", flexDirection: "column", gap: ".45rem" }}>
                    {proximosBloqueos.map((f) => {
                      const rato = horasBloq[f];
                      const tono = rato ? { b: "rgba(245,158,11,.45)", f: "rgba(245,158,11,.10)", c: "#fcd34d" } : { b: "rgba(239,68,68,.45)", f: "rgba(239,68,68,.12)", c: "#fca5a5" };
                      return (
                        <div key={f} style={{ display: "flex", alignItems: "center", gap: ".4rem", flexWrap: "wrap", padding: ".35rem .55rem", borderRadius: 10, border: `1px solid ${tono.b}`, background: tono.f }}>
                          <span style={{ fontSize: ".72rem", fontWeight: 700, color: tono.c, minWidth: 92 }}>{fmtBloqueo(f)}</span>
                          <select className="dkt-inp" value={rato ? "horas" : "dia"} onChange={(e) => soloUnasHoras(f, e.target.value === "horas")} style={{ fontSize: ".68rem", padding: ".15rem .35rem" }}>
                            <option value="dia">{tt("Todo el día", "All day")}</option>
                            <option value="horas">{tt("Solo unas horas", "Some hours only")}</option>
                          </select>
                          {rato && <>
                            <input type="time" className="dkt-inp" value={rato.desde} onChange={(e) => cambiarRato(f, { desde: e.target.value })} style={{ width: 124, fontSize: ".68rem" }} />
                            <span style={{ color: "var(--c-text3,#45688a)", fontSize: ".66rem" }}>→</span>
                            <input type="time" className="dkt-inp" value={rato.hasta} onChange={(e) => cambiarRato(f, { hasta: e.target.value })} style={{ width: 124, fontSize: ".68rem" }} />
                          </>}
                          <button type="button" onClick={() => alternarBloqueo(f)} title={tt("Quitar bloqueo", "Remove block")}
                            style={{ marginLeft: "auto", background: "none", border: "none", color: tono.c, cursor: "pointer", padding: 0, display: "inline-flex" }}><X size={12} /></button>
                        </div>
                      );
                    })}
                  </div>}
            </div>
          </div>
        </div>

        <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap" }}>
          <div>
            <div style={lbl}>{tt("Reservable hasta (días)", "Bookable ahead (days)")}</div>
            <input type="number" min={1} max={120} className="dkt-inp" value={cfg.advanceDays} onChange={(e) => setField({ advanceDays: Math.max(1, Math.min(120, parseInt(e.target.value || "30", 10))) })} style={{ width: 90 }} />
          </div>
          <div>
            <div style={lbl}>{tt("Aviso mínimo (horas)", "Minimum notice (hours)")}</div>
            <input type="number" min={0} max={168} className="dkt-inp" value={cfg.minNoticeHours} onChange={(e) => setField({ minNoticeHours: Math.max(0, Math.min(168, parseInt(e.target.value || "2", 10))) })} style={{ width: 90 }} />
          </div>
        </div>

        {/* Recent bookings */}
        <div>
          <div style={lbl}>📅 {tt("Citas Reservadas", "Booked Appointments")} ({bookings.length})</div>
          {bookings.length === 0 ? (
            <div style={{ fontSize: ".74rem", color: "var(--c-text3,#45688a)" }}>{tt("Aún no hay reservas. Comparte tu link para empezar.", "No bookings yet. Share your link to get started.")}</div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: ".3rem" }}>
              {bookings.map((bk) => {
                // CANCEL / UPDATE (Lissette 2026-11-03): la hora que ya no vale
                // sale tachada, para que nadie atienda una cita que se movió o
                // se canceló desde el enlace.
                const cancelada = bk.status === "cancelled";
                const cambiada = !cancelada && !!bk.antes;
                const color = cancelada ? "#ff3d6b" : cambiada ? "#ffb700" : "#00ff88";
                const etiqueta = (txt) => <span style={{ fontSize: ".58rem", fontWeight: 800, letterSpacing: ".06em", padding: "1px 6px", borderRadius: 5, background: `${color}22`, color, border: `1px solid ${color}55`, marginLeft: 6 }}>{txt}</span>;
                return (
                <div key={bk.id} style={{ background: "var(--c-surface2,#112538)", border: `1px solid ${color}33`, borderLeft: `3px solid ${color}`, borderRadius: 8, padding: ".45rem .65rem", opacity: cancelada ? .8 : 1 }}>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: ".5rem" }}>
                    <span style={{ fontWeight: 700, fontSize: ".78rem", color: "var(--c-white,#eef6ff)" }}>{bk.name}{cancelada && etiqueta("CANCEL")}{cambiada && etiqueta("UPDATE")}</span>
                    <span style={{ fontSize: ".65rem", color: "var(--c-text3,#45688a)" }}>{bk.email}</span>
                  </div>
                  <div style={{ fontSize: ".65rem", color: "var(--c-text3,#45688a)", marginTop: 2 }}>
                    🗓️ {cambiada && <><span style={{ textDecoration: "line-through", opacity: .75 }}>{fmtBooking(bk.antes)}</span>{" → "}</>}
                    <span style={cancelada ? { textDecoration: "line-through" } : (cambiada ? { color: "var(--c-white,#eef6ff)", fontWeight: 700 } : undefined)}>{fmtBooking(bk.startTime)}</span>
                    {bk.phone ? ` · 📞 ${bk.phone}` : ""}{bk.atiende ? ` · 👤 ${tt("Atiende", "With")} ${bk.atiende}` : ""}
                  </div>
                </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}


// One-time wipe of demo data that earlier SPA builds seeded into the
// browser via useLocalStorage defaults. Flagged on 2026-05-11 when Lissette
// saw 12 demo Company Expenses on a brand-new account. Runs once per
// browser; flag is stored in localStorage so a clean-installed user
// experiences no purge at all. Safe to leave in indefinitely.
const DEMO_PURGE_FLAG = "dkt6_demo_purged_v1";
const DEMO_KEYS_TO_WIPE = [
  "dkt6_clients", "dkt6_policies", "dkt6_history",
  "dkt6_docs_v3", "dkt6_requests", "dkt6_signatures_v5",
  "dkt6_folders", "dkt6_users", "dkt6_tasks_v2",
  "dkt6_commissions_v2", "dkt6_commPerms", "dkt6_timelog",
  "dkt6_activitylog_v4", "dkt6_team_actions", "dkt6_licenses_v4",
  "dkt6_compAppts_v2", "dkt6_expenses", "dkt6_calEvents_v2",
  "dkt6_leads", "dkt6_clientNotes_v3", "dkt6_eligAlerts_v2",
  "dkt6_resources", "dkt6_resource_tokens", "dkt6_doctemplates",
];
try {
  if (typeof localStorage !== "undefined" && !localStorage.getItem(DEMO_PURGE_FLAG)) {
    for (const k of DEMO_KEYS_TO_WIPE) localStorage.removeItem(k);
    localStorage.setItem(DEMO_PURGE_FLAG, String(Date.now()));
  }
} catch (_) {
  // private mode / quota / disabled storage — nothing to do, the
  // defaults are already [] so a fresh user sees the right thing.
}

// Licenses stopped being cached in the browser (see the useState for
// `licenses`), but the key an earlier build wrote is still sitting in every
// existing browser — and it is the big one: whole license PDFs and pasted
// note photos as base64. Until it is removed, that browser's ~5MB storage
// budget stays full and EVERY other dkt6_* key keeps failing to persist, so
// the fix would not reach anyone who already hit the problem. One-time
// removal, own flag, safe to leave in indefinitely.
const LICENSE_CACHE_DROP_FLAG = "dkt6_licenses_cache_dropped_v1";
try {
  if (typeof localStorage !== "undefined" && !localStorage.getItem(LICENSE_CACHE_DROP_FLAG)) {
    localStorage.removeItem("dkt6_licenses_v4");
    localStorage.setItem(LICENSE_CACHE_DROP_FLAG, String(Date.now()));
  }
} catch (_) { /* storage unavailable — nothing cached, nothing to free */ }

// The "already seen this card" marks (deskte:lastVisited / deskte:lastSeenTab)
// were kept in this browser for EVERY card ever opened, per user — 5,400 keys
// in Lissette's browser, which helped fill it (aviso E6, 2026-10-27). Keep the
// most recent cards only; an older one just counts as a first visit. Runs on
// every load (cheap) so it never grows back.
try {
  if (typeof localStorage !== "undefined") podarFrescuraDelNavegador(localStorage);
} catch (_) { /* storage unavailable — nothing to trim */ }

// Stable signature for change-detection on the agency-settings sync effects.
// Object keys are sorted so two structurally identical blobs compare equal no
// matter the insertion order (the server round-trip reorders them), and the
// effects below can send ONLY what the user actually changed. Returns null if
// the value can't be serialized — callers treat that as "changed" (fail toward
// saving, never toward silently dropping an edit).

// ── Los modulos que no se bajan hasta que se abren ──────────────────────────
//
// Lissette, 2026-08-20, despues de arreglar la primera mitad de "abre lento":
// "dale". Esta es la segunda mitad.
//
// Todo el CRM viaja en UN archivo de 5 MB (1,3 MB comprimidos) que el navegador
// tiene que bajar, descomprimir y ejecutar ANTES de pintar un solo pixel. Lo
// paga cada persona, cada vez que entra — incluida la parte que no va a abrir.
//
// Estos seis son los mas gordos que casi nadie mira en una jornada normal:
//
//   PlatformAdminView  147 KB — SOLO lo ve el dueño de la plataforma. Cada
//                               agente de cada agencia se lo bajaba para nada.
//   ImportView         281 KB — se usa el dia que se importa, no todos los dias
//                               (y arrastra consigo el asistente de Monday, otros
//                               126 KB, porque solo el lo importa).
//   SignaturesView     133 KB
//   VaultView           96 KB
//   SheetsView          90 KB
//   OnboardingView      76 KB
//
// Se quedan FUERA de esta lista, a proposito, los que se usan todo el rato:
// ClientDetail (567 KB) y PoliciesView (477 KB) son mas grandes que cualquiera
// de estos, pero son el trabajo diario — diferirlos cambiaria "esperar una vez
// al entrar" por "esperar cada vez que abro una ficha", que es peor.
//
// Cada uno se envuelve en SU PROPIO Suspense en vez de envolver el bloque de
// vistas entero. Eso es lo que deja el resto del archivo intacto: el JSX sigue
// diciendo <ImportView .../> igual que siempre, sin saber que ahora llega tarde.
// Envolver el bloque entero habria obligado a tocar el arbol de vistas, que es
// justo donde un parentesis de mas rompe la pantalla.
function CargandoModulo() {
  return (
    <div style={{ padding: "2rem", textAlign: "center", color: "var(--c-text3,#45688a)", fontSize: ".8rem" }}>
      Cargando...
    </div>
  );
}

/**
 * Envuelve un import() en un componente que se comporta como el de siempre.
 *
 * Va a nivel de MODULO, no dentro de Deskte(): creado dentro, React veria un
 * componente distinto en cada pintada y volveria a montar el modulo entero
 * (perdiendo lo que el usuario llevara escrito) cada vez que cambiara
 * cualquier cosa de la pantalla.
 */
// Marca de "ya recargue una vez por esto". Vive en sessionStorage para
// sobrevivir a la recarga — que es justo lo que hay que recordar — y se limpia
// en cuanto un modulo entra bien, para que el siguiente despliegue del dia
// vuelva a tener su recarga disponible.
const RECARGA_POR_MODULO = "deskte:recarga-por-modulo";

// Cada modulo diferido deja aqui su "traeme". Sirve para precargarlos en
// segundo plano cuando la persona no esta haciendo nada — ver
// precargarModulosEnReposo, justo debajo.
const PRECARGAS = [];

function bajoDemanda(cargar, nombre) {
  const traer = () => cargar().then((m) => {
    try { sessionStorage.removeItem(RECARGA_POR_MODULO); } catch (_) {}
    return { default: m[nombre] };
  });

  // Partir el programa en trozos crea un fallo que antes NO podia existir: el
  // trozo se pide MAS TARDE, y para entonces puede no estar.
  //
  // El caso real, y pasa a diario: se despliega una version nueva mientras
  // alguien tiene Deskte abierto. Los trozos llevan el numero de version en el
  // nombre, asi que los de la version vieja dejan de existir. Esa persona abre
  // Importar, el navegador pide un archivo que ya no esta, y sin esto se
  // encontraria la pantalla gris de "algo salio mal" sin haber hecho nada raro.
  //
  // Dos intentos y una recarga:
  //   1. Reintento a los 600 ms — cubre el tropiezo de red pasajero.
  //   2. Si vuelve a fallar, casi seguro que el trozo ya no existe. Recargar
  //      trae el indice nuevo, que apunta a los nombres nuevos.
  //
  // La marca en sessionStorage es lo que impide el bucle: si despues de
  // recargar sigue fallando, el problema no era la version — se deja pasar el
  // error para que lo recoja el ErrorBoundary y la persona vea algo, en vez de
  // una pagina recargandose sola para siempre.
  PRECARGAS.push(traer);

  const Perezoso = lazy(() =>
    traer().catch(() =>
      new Promise((r) => setTimeout(r, 600)).then(traer).catch((err) => {
        let yaRecargue = false;
        try { yaRecargue = sessionStorage.getItem(RECARGA_POR_MODULO) === "1"; } catch (_) {}
        if (yaRecargue) throw err;
        try { sessionStorage.setItem(RECARGA_POR_MODULO, "1"); } catch (_) {}
        try { window.location.reload(); } catch (_) { throw err; }
        // No se resuelve nunca a proposito: la pagina se esta yendo, y
        // resolver aqui pintaria un parpadeo de error antes de irse.
        return new Promise(() => {});
      }),
    ),
  );

  return function Diferido(props) {
    return (
      <Suspense fallback={<CargandoModulo />}>
        <Perezoso {...props} />
      </Suspense>
    );
  };
}

const MODULOS_BAJO_DEMANDA = true; // ancla para la busqueda desde los imports de arriba
const PlatformAdminView = bajoDemanda(() => import("./crm-app/components/PlatformAdminView.jsx"), "PlatformAdminView");
const ImportView        = bajoDemanda(() => import("./crm-app/components/ImportView.jsx"), "ImportView");
const SheetsView        = bajoDemanda(() => import("./crm-app/components/SheetsView.jsx"), "SheetsView");
const VaultView         = bajoDemanda(() => import("./crm-app/components/VaultView.jsx"), "VaultView");
const SignaturesView    = bajoDemanda(() => import("./crm-app/components/SignaturesView.jsx"), "SignaturesView");
const OnboardingView    = bajoDemanda(() => import("./crm-app/components/OnboardingView.jsx"), "OnboardingView");
const MassEmailView      = bajoDemanda(() => import("./crm-app/components/MassEmailView.jsx"), "MassEmailView");
const EncuestasView      = bajoDemanda(() => import("./crm-app/components/EncuestasView.jsx"), "EncuestasView");
const QuotesInvoicesView = bajoDemanda(() => import("./crm-app/components/QuotesInvoicesView.jsx"), "QuotesInvoicesView");
const WorkflowsView      = bajoDemanda(() => import("./crm-app/components/WorkflowsView.jsx"), "WorkflowsView");
const EmailSequencesView = bajoDemanda(() => import("./crm-app/components/EmailSequencesView.jsx"), "EmailSequencesView");
const MonthEventsView    = bajoDemanda(() => import("./crm-app/components/MonthEventsView.jsx"), "MonthEventsView");

function agencyCfgSig(v) {
  const norm = (x) => {
    if (Array.isArray(x)) return x.map(norm);
    if (x && typeof x === "object") {
      const out = {};
      for (const k of Object.keys(x).sort()) out[k] = norm(x[k]);
      return out;
    }
    return x;
  };
  try { return JSON.stringify(norm(v)) ?? "undefined"; } catch (_) { return null; }
}

// ── Las listas que NO hacen falta para entrar ────────────────────────────────
//
// Lissette, 2026-08-20: "el sistema esta super super lento", y por separado el
// aviso de "se cargaron X de Y clientes" saliendo cada tanto. Son el mismo
// problema.
//
// Al entrar, Deskte pedia DIECISIETE listas de golpe — y clientes y polizas
// ademas se parten en paginas que salian todas en paralelo. Contra un servidor
// donde cada replica atiende 10 consultas a la vez (connection_limit=10), esas
// ~25 peticiones simultaneas hacen cola; la que espera mas de 20 segundos se
// rinde, y esa es exactamente la pagina de clientes que faltaba en el aviso
// amarillo. Nadie mira diecisiete modulos al entrar.
//
// Estas seis no las lee NI el tablero NI ningun contador del menu: viven solo
// dentro de su modulo. Se piden cuando se abre, y el cerrojo `xLoaded` de cada
// efecto hace que se pidan UNA vez y se queden cargadas.
//
// Se comprobo una por una antes de diferirla, y dos cosas se quedaron fuera a
// proposito:
//   - Las que alimentan el tablero (tareas, documentos, facturas, tickets,
//     alertas...) siguen cargando al entrar. Diferirlas dejaria contadores en
//     cero al abrir Deskte, que es peor que esperar.
//   - Ninguna de estas seis tiene sincronizacion que borre en el servidor lo
//     que falte en la lista local. Ese patron SI existe en otras (mira
//     `deleteEligibilityAlert`), y ahi diferir la carga vaciaria la tabla.
const LISTAS_DIFERIDAS = {
  clientNotes: ["clients"],
  resources:   ["resources", "team_training"],
  expenses:    ["agency", "expenses", "metrics", "payroll"],
  // quotes_invoices: la asesoría del cotizador elige un lead de la lista (2026-10-14).
  leads:       ["agency", "automations", "leads", "metrics", "quotes_invoices", "reports_analytics"],
  calEvents:   ["calendar"],
  commissions: ["agency", "metrics", "reports", "reports_analytics"],
};

/**
 * ¿Toca ya pedir esta lista?
 *
 * El caso del portal publico de recursos es el que obliga a mirar tambien la
 * direccion: `#resources/<token>` pinta PublicResourcePortal antes de que el
 * enrutado normal de vistas llegue a correr, asi que `view` nunca vale
 * "resources" ahi y el portal saldria vacio para el cliente.
 */

// Traer los trozos de los modulos EN REPOSO, despues de entrar.
//
// Lissette, 2026-08-21: "ayer hicimos cambio en la carga y hoy todo estaba
// super lento, los demas modulos, la carta de firma, todo".
//
// Tenia razon y la causa era mia. Entre E-097 (las listas se piden al abrir su
// modulo) y E-101 (once modulos bajan su codigo al abrirse), entrar quedo mas
// rapido pero ABRIR CADA MODULO LA PRIMERA VEZ paga dos cosas que antes no
// pagaba. Para quien se pasa el dia saltando de modulo, eso se siente como
// "todo esta lento" — y es una descripcion correcta de su experiencia.
//
// Esto recupera la sensacion de antes sin perder el arranque rapido: mientras
// la persona lee el panel, el navegador va bajando los trozos en huecos
// libres. Cuando abre Firmas, el codigo ya esta.
//
// Lo que NO se precarga son los DATOS. Pedir las diecisiete listas al entrar
// es exactamente lo que se corrigio ayer, y volveria a apretar el grupo de
// conexiones de la base (E-097). El codigo es un archivo estatico servido por
// la CDN; la lista de clientes es una consulta. No son lo mismo.
function precargarModulosEnReposo() {
  if (typeof window === 'undefined') return;
  const con = navigator.connection || {};
  // Respetar el ahorro de datos, y no competir por una conexion mala: ahi
  // precargar hace mas dano que bien.
  if (con.saveData) return;
  if (/(^|-)2g$/.test(String(con.effectiveType || ''))) return;

  const enHueco = (fn) => (typeof window.requestIdleCallback === 'function'
    ? window.requestIdleCallback(fn, { timeout: 4000 })
    : setTimeout(fn, 400));

  let i = 0;
  const siguiente = () => {
    if (i >= PRECARGAS.length) return;
    const traer = PRECARGAS[i++];
    // De uno en uno: doce descargas a la vez le quitarian ancho de banda a lo
    // que la persona SI esta mirando.
    Promise.resolve()
      .then(traer)
      // Un fallo al precargar no se le cuenta a nadie: si el trozo no esta, ya
      // hay reintento y recarga cuando de verdad se abra el modulo.
      .catch(() => {})
      .then(() => enHueco(siguiente));
  };
  enHueco(siguiente);
}

function toca_pedir(id, view) {
  const vistas = LISTAS_DIFERIDAS[id];
  if (!vistas) return true;            // no diferida: siempre
  if (vistas.includes(view)) return true;
  if (id === "resources" && typeof window !== "undefined") {
    return /#resources\//.test(window.location.hash || "");
  }
  return false;
}

// ── Barra de fichas de cliente abiertas ───────────────────────────
// Lissette, 2026-08-21, de una reunion: "si entra a un cliente y se va a
// buscar otra cosa, que el tag del cliente se quede abierto alli para no tener
// que buscarlo de nuevo... y que el tab tenga una x para cerrarlo".
//
// La logica (abrir, cerrar, tope) vive en crm-app/fichasAbiertas.js, un modulo
// plano con pruebas propias. Aqui solo esta la pantalla.
function BarraDeFichas({ fichas, activaId, onIr, onCerrar, es }) {
  if (!fichas || fichas.length === 0) return null;
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap', marginBottom: '.75rem' }}>
      <span style={{ fontSize: '.62rem', fontWeight: 800, letterSpacing: '.08em', textTransform: 'uppercase', color: 'var(--c-text3,#45688a)', fontFamily: 'var(--font-mono)', marginRight: 2 }}>
        {es ? 'Abiertos' : 'Open'}
      </span>
      {fichas.map((f) => {
        const activa = f.id === activaId;
        return (
          <span key={f.id} title={f.nombre}
            style={{ display: 'inline-flex', alignItems: 'center', gap: 2, borderRadius: 9,
              border: `1px solid ${activa ? 'var(--c-cyan,#00d4ff)' : 'var(--c-border2,#1f3f60)'}`,
              background: activa ? 'rgba(0,212,255,.12)' : 'var(--ci-bg-02)' }}>
            <button type="button" onClick={() => onIr(f)}
              style={{ maxWidth: 190, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                padding: '4px 4px 4px 10px', background: 'none', border: 'none', cursor: 'pointer',
                fontSize: '.76rem', fontWeight: activa ? 700 : 600, fontFamily: 'inherit',
                color: activa ? 'var(--c-cyan,#00d4ff)' : 'var(--c-text2,#7aa3c0)' }}>
              {f.nombre}
            </button>
            {/* La X es un boton aparte: pulsarla no puede abrir la ficha. */}
            <button type="button" onClick={(e) => { e.stopPropagation(); onCerrar(f.id); }}
              title={es ? 'Cerrar' : 'Close'} aria-label={es ? `Cerrar ${f.nombre}` : `Close ${f.nombre}`}
              style={{ display: 'inline-flex', alignItems: 'center', padding: '4px 8px 4px 2px',
                background: 'none', border: 'none', cursor: 'pointer', color: 'var(--c-text3,#45688a)' }}>
              <X size={12} />
            </button>
          </span>
        );
      })}
      {fichas.length > 1 && (
        <button type="button" onClick={() => onCerrar(null)}
          style={{ padding: '4px 9px', borderRadius: 9, border: '1px solid var(--c-border2,#1f3f60)',
            background: 'none', cursor: 'pointer', fontSize: '.68rem', fontWeight: 700, fontFamily: 'inherit',
            color: 'var(--c-text3,#45688a)' }}>
          {es ? 'Cerrar todos' : 'Close all'}
        </button>
      )}
    </div>
  );
}

function Deskte() {

  // Lazy init from localStorage so the user's choice survives reload.
  // SSR-safe (no `window` during build) and silently falls back on quota
  // errors / private-mode browsers.
  const [lang,setLang]=useState(()=>{
    if(typeof window==="undefined")return"en";
    try{const v=localStorage.getItem("deskte:lang");return v==="es"||v==="en"?v:"en";}catch{return"en";}
  });
  const [theme,setTheme]=useState(()=>{
    if(typeof window==="undefined")return"dark";
    try{const v=localStorage.getItem("deskte:theme");return v==="light"||v==="dark"?v:"dark";}catch{return"dark";}
  }); // "dark" | "light"
  const [palette,setPalette]=useState(()=>{
    if(typeof window==="undefined")return"ocean";
    try{const v=localStorage.getItem("deskte:palette");return v==="sunset"||v==="ocean"?v:"ocean";}catch{return"ocean";}
  }); // "ocean" | "sunset"
  // Persist on every change. Three small writes, separate keys so a
  // corrupt one doesn't take the others down.
  useEffect(()=>{try{localStorage.setItem("deskte:lang",lang);}catch{} try{document.documentElement.lang=lang;}catch{}},[lang]);
  useEffect(()=>{try{localStorage.setItem("deskte:theme",theme);}catch{}},[theme]);
  useEffect(()=>{try{localStorage.setItem("deskte:palette",palette);}catch{}},[palette]);
  useEffect(()=>{
    // Hotfix 2026-05-22: removed two side effects that were fighting our
    // recent hardening (audit follow-ups + viewport revert):
    //
    //   1. A runtime `vp.content = "width=1280,initial-scale=0.29..."`
    //      assignment that re-broke the desktop viewport on every render —
    //      it overrode the standard <meta name=viewport> in index.html on
    //      mount. The viewport revert in PR #339 only fixed the static
    //      meta tag; this useEffect kept undoing it. The standard
    //      `width=device-width` viewport is now declared once in
    //      crm-app/index.html and we do not touch it from JS.
    //
    //   2. A `<script src="https://cdn.tailwindcss.com">` injection that
    //      F-N7 (PR #332) thought it had retired when it dropped that
    //      origin from the CSP — but this dynamic inject was still here,
    //      so the browser fetch was being blocked, polluting the console
    //      and stranding any Tailwind utility classes the JSX relied on.
    //      The custom .dkt-* class set in crm-app/styles/dkt.css covers
    //      the styling we ship; if a future feature needs more Tailwind
    //      utilities, self-host the runtime (mirror what the website does
    //      under /_assets/vendor/) rather than re-adding the CDN.
    //
    // Google Fonts is the only side effect left — fonts.googleapis.com is
    // already on the CSP style-src + font-src allowlist.
    const fid="dkt-fonts";
    if(!document.getElementById(fid)){
      const l=document.createElement("link");
      l.id=fid; l.rel="stylesheet";
      l.href="https://fonts.googleapis.com/css2?family=Oxanium:wght@400;600;700;800&family=JetBrains+Mono:wght@400;600;700;800&family=Sora:wght@400;500;600;700&display=swap";
      document.head.appendChild(l);
    }
  },[]);
  useEffect(()=>{
    document.body.style.background=theme==="dark"?(palette==="sunset"?"#0f0a16":"#070d14"):"#f0ece6";
    document.documentElement.setAttribute("data-theme",theme);
    document.documentElement.setAttribute("data-palette",palette);
  },[theme,palette]);
  const _uiPrefsHydrated=useRef(false);
  // Always start at the dashboard (or Platform Admin for the owner who is
  // not impersonating). Lissette asked 2026-05-26 NOT to restore the last
  // view on login/refresh — it was disorienting when reopening the app.
  // The role-based default effect below still nudges seats to a valid
  // view if they land on something they can't see.
  const [view,setViewDirecto]=useState(()=>{
    if (typeof window === "undefined") return "dashboard";
    try {
      // Restore the view from the URL hash so a refresh / opened-in-new-tab
      // lands on the same screen (ignore the public #sign/ + #client/ routes).
      const h = (window.location.hash || "").replace(/^#/, "");
      if (h && !h.startsWith("sign/") && !h.startsWith("client/")) return h;
      if (h.startsWith("client/")) return "clients";
      if (leerEntrada("deskte:impersonateUserId")) return "dashboard";
      const mu = window.__deskteAuth?.currentUser;
      const impersonating = !!leerEntrada("deskte:impersonateAgencyId");
      if (mu?.isPlatformOwner) return impersonating ? "dashboard" : "platform_admin";
      return "dashboard";
    }
    catch { return "dashboard"; }
  });
  // CAMBIAR DE MÓDULO PREGUNTA ANTES si la pantalla abierta tiene algo sin
  // guardar (Lissette 2026-09-24, Correo Masivo: *"que el sistema pregunte si
  // le damos click en otro lado sin querer"*). Todo lo que cambia de módulo
  // —el menú, los enlaces, los avisos, el botón Atrás— pasa por aquí, así que
  // la pregunta sale venga el clic de donde venga. Sin guardia puesta el
  // cambio es inmediato, igual que siempre (ver crm-app/salidaSinGuardar.js).
  const _viewActual = useRef(view);
  _viewActual.current = view;
  const setView = useCallback((v) => {
    if (!hayGuardiaDeSalida()) { setViewDirecto(v); return; }
    pedirPermisoParaSalir(v).then((ok) => {
      if (ok) { setViewDirecto(v); return; }
      // Se queda. Si el clic fue el botón Atrás, la dirección ya cambió: se
      // devuelve a la del módulo que sigue abierto.
      try {
        const actual = _viewActual.current;
        if ((window.location.hash || "").replace(/^#/, "") !== actual) window.history.pushState(null, "", "#" + actual);
      } catch (err) { console.warn("[nav] no se pudo restaurar la direccion", err?.message); }
    });
  }, []);
  // Qué pestaña de Platform Admin está abierta. Vive AQUÍ y no dentro de
  // PlatformAdminView porque el menú lateral del founder entra directo a
  // Clientes / Campañas / BAA, y el botón tiene que pintarse activo. El valor
  // viaja como evento (deskte:nav-reset) para no atravesar props por medio
  // archivo. (Lissette 2026-08-03: "que estén en el menú lateral".)
  const [platformTab,setPlatformTab]=useState("overview");
  const goPlatform=(tab)=>{
    setPlatformTab(tab);
    setView("platform_admin");
    setSidebarOpen(false);
    window.dispatchEvent(new CustomEvent("deskte:nav-reset",{detail:{view:"platform_admin",tab}}));
  };
  // ── URL ↔ view router ──────────────────────────────────────────────────────
  // Each top-level view is mirrored in the hash (#clients) so: (1) refresh keeps
  // you on the same screen, (2) the browser Back button moves between the views
  // you visited instead of exiting the app, (3) right-clicking a sidebar link →
  // "open in new tab" works. The public #sign/ and the #client/<id> detail
  // routes are left untouched here.
  const _navFromPop = useRef(false);
  const _firstUrlSync = useRef(true);
  // The view the URL pointed at when the app first mounted (before any sync
  // effect rewrites the hash). Used so the role-default-on-login effect HONORS
  // a refresh/shared-link/new-tab target instead of snapping to the default.
  const _initialUrlView = useRef((() => {
    try {
      const h = (typeof window !== "undefined" ? window.location.hash : "" || "").replace(/^#/, "");
      if (!h || h.startsWith("sign/")) return null;
      return h.startsWith("client/") ? "clients" : h;
    } catch { return null; }
  })());
  useEffect(() => {
    if (typeof window === "undefined") return;
    const apply = () => {
      const h = (window.location.hash || "").replace(/^#/, "");
      if (!h || h.startsWith("sign/")) return;
      const v = h.startsWith("client/") ? "clients" : h;
      _navFromPop.current = true;
      setView(v);
    };
    window.addEventListener("popstate", apply);
    window.addEventListener("hashchange", apply);
    return () => { window.removeEventListener("popstate", apply); window.removeEventListener("hashchange", apply); };
  }, []);
  useEffect(() => {
    if (typeof window === "undefined") return;
    if (_navFromPop.current) { _navFromPop.current = false; return; }
    const cur = (window.location.hash || "").replace(/^#/, "");
    if (cur.startsWith("sign/")) return;
    // A #client/<id> detail is open within the Clients view — keep that hash
    // (openDetail owns it). But if the view moved AWAY from clients, fall
    // through and update the hash to the new view.
    if (cur.startsWith("client/") && view === "clients") return;
    if (cur !== view) {
      try {
        if (_firstUrlSync.current) window.history.replaceState(null, "", "#" + view);
        else window.history.pushState(null, "", "#" + view);
      } catch {}
    }
    _firstUrlSync.current = false;
  }, [view]);
  // Clean up any leftover lastView from older sessions so it doesn't trip
  // up future code that might still read it.
  useEffect(()=>{try{localStorage.removeItem("deskte:lastView");}catch{}},[]);
  // When non-null, the next MyProfileView mount opens directly to this
  // settings tab (e.g. "billing"). Reset to null after consume so a
  // later organic profile click defaults back to Profile.
  const [profileInitialTab, setProfileInitialTab] = useState(null);
  // Single helper used by the trial banner + any future "Upgrade" CTA.
  const openBilling = () => { setProfileInitialTab("billing"); setView("profile"); };
  useEffect(()=>{ window.__deskteOpenBilling = openBilling; return()=>{ window.__deskteOpenBilling = null; }; });
  useEffect(()=>{ if (view !== "profile" && profileInitialTab) setProfileInitialTab(null); }, [view, profileInitialTab]);
  useEffect(()=>{ window.__magSetView=setView; return()=>{ window.__magSetView=null; }; },[]);
  // Scroll back to top whenever the active view changes. Without this, a
  // user who was scrolled deep into one view (e.g. clicking "Import" from
  // far down the Clients list) lands at the previous scroll offset and
  // can't see the new view's header — they have to manually scroll up.
  // Smooth scroll feels less jarring than an instant snap.
  useEffect(() => {
    if (typeof window === 'undefined') return;
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [view]);
  // Cross-component navigation: any component can dispatch a 'deskte:navigate'
  // CustomEvent { detail: { view } } and we route it to setView. Used by Quotes
  // → Leads handoff so the agent lands on the right page after clicking Open Lead.
  useEffect(()=>{
    const handler=(e)=>{ if(e?.detail?.view) setView(e.detail.view); };
    window.addEventListener('deskte:navigate', handler);
    return ()=>window.removeEventListener('deskte:navigate', handler);
  },[]);
  const [sidebarOpen,setSidebarOpen]=useState(false);
  // El buscador del menú de la izquierda (Lissette 2026-10-15). Ver crm-app/buscarEnMenu.js.
  const [buscarMenu,setBuscarMenu]=useState("");
  // Global floating calculator + unit converter — toggled from the header,
  // rendered at the app root so it floats over any view.
  const [calcOpen,setCalcOpen]=useState(false);
  // ────────────────────────────────────────────────────────────────────
  // Audit fix C2 (2026-05-20) — one-time wipe of legacy PHI residue.
  // Previous builds of the SPA persisted every server-hydrated dataset
  // (clients / policies / leads / signatures / etc.) to localStorage via
  // useLocalStorage("dkt6_*", []). That meant browsers that had ever
  // loaded the app held DOB / email / phone / address / ssnMasked /
  // ssnLast4 / spouse / dependents in plaintext JSON on disk — any XSS,
  // extension compromise, or laptop-disposal-with-residual-profile
  // could exfiltrate the entire household. The state slots are now
  // in-memory only; this effect removes the residue on first load.
  // Idempotent: removeItem on a missing key is a no-op.
  // ────────────────────────────────────────────────────────────────────
  useEffect(() => {
    const PHI_LEGACY_KEYS = [
      'dkt6_clients',
      'dkt6_policies',
      'dkt6_history',
      'dkt6_import_batches',
      'dkt6_docs_v3',
      'dkt6_requests',
      'dkt6_signatures_v5',
      'dkt6_users',
      'dkt6_tasks_v2',
      'dkt6_commissions_v2',
      'dkt6_activitylog_v4',
      'dkt6_policyDocs',
      'dkt6_calEvents_v2',
      'dkt6_leads',
      'dkt6_clientNotes_v3',
      'dkt6_eligAlerts_v2',
      'dkt6_invoices',
      'dkt6_uploaded_files',
    ];
    try {
      for (const k of PHI_LEGACY_KEYS) localStorage.removeItem(k);
    } catch {}
  }, []);
  // When AuthGate (MSAL) provides an authenticated user, skip the PIN demo flow.
  const _msalUser = (typeof window !== "undefined" && window.__deskteAuth?.currentUser) || null;
  // Demo mode. Loads the fictional dataset (SEED_*) and signs in as the demo
  // agent, skipping the PIN screen. Two ways in — dev `?demo=1` (screenshots
  // and tutorials) and the VITE_DEMO=1 sales build. See crm-app/demoMode.js.
  //
  // Why it exists: help-centre screenshots and tutorial videos have to show a
  // populated CRM, and a screenshot of PRODUCTION would carry real client PHI
  // (names, DOB, policies) into material every agency can see. This gives a
  // fully-populated Deskte with invented clients instead.
  //
  // The old way in was the reset panel's "load demo data" button, but nothing
  // has called setShowReset(true) since the PHI audit moved clients off
  // localStorage, so the demo login listed zero accounts and was unreachable.
  //
  // Neither flag is set in the app.deskte.com build, so esbuild eliminates
  // this whole path there — production can never expose a demo login.
  const _demoMode = IS_DEMO;
  // Public demo running INSIDE the browser mock on deskte.com/demo/. That page
  // drives its own guided tour (it deep-links this iframe module by module), so
  // the built-in welcome tour would be a modal fighting it for the same job —
  // and a prospect's first sight of Deskte would be an overlay instead of a
  // populated CRM. Opened in its own tab the tour is exactly what a first-time
  // visitor wants, so it still runs there.
  const _demoEmbedded = IS_DEMO_BUILD && (() => {
    try { return window.self !== window.top; } catch { return true; }
  })();
  const [currentUser,setCurrentUser]=useState(_msalUser);
  // ── Fichas de cliente abiertas (la barra de pestañas) ──────────────
  // SOLO EN MEMORIA, a proposito. La correccion de auditoria C2 saco de
  // localStorage todo lo de clientes porque quedaba en texto plano en la
  // maquina; un nombre de cliente de una agencia de salud es ese mismo dato.
  // Las pestañas aguantan moverse entre modulos —que es lo que se pidio— y se
  // van al recargar.
  const [fichas,setFichas]=useState([]);
  const [fichaActiva,setFichaActiva]=useState(null);
  // Estable (`[]`): la vista de Clientes la lleva en las dependencias de un
  // efecto, y una funcion nueva en cada pintada lo haria correr sin parar.
  const registrarFicha=useCallback((cl)=>{
    if(!cl||!cl.id){ setFichaActiva(null); return; }
    setFichaActiva(cl.id);
    setFichas(prev=>abrirFicha(prev,cl,cl.id));
  },[]);
  const irAFicha=(f)=>{
    // El mismo camino que usa cualquier otro enlace a un cliente. El evento es
    // para cuando ya estamos en Clientes: la vista no se vuelve a montar y sin
    // el, el clic "no hace nada".
    irAlCliente((clients||[]).find(c=>c.id===f.id)||{ id:f.id, firstName:f.nombre }, setView);
  };
  const cerrarUnaFicha=(id)=>{
    setFichas(prev=>id===null?[]:cerrarFicha(prev,id));
    // Cerrar la pestaña del cliente que estas mirando cierra tambien su ficha
    // y te devuelve a la lista: dejarla abierta sin pestaña se lee como que el
    // boton no funciono. La vista lo ignora si hay un formulario abierto, para
    // no llevarse por delante lo que se estuviera escribiendo.
    if(id===null||id===fichaActiva){
      setFichaActiva(null);
      try{ window.dispatchEvent(new CustomEvent("deskte:cerrar-ficha",{detail:{id}})); }catch(_){}
    }
  };
  // Cambiar de usuario no puede heredar las fichas del anterior.
  useEffect(()=>{ setFichas([]); setFichaActiva(null); },[currentUser?.id]);
  // Bajar los trozos de los modulos en segundo plano, una vez dentro. Se
  // espera un poco para no competir con las primeras consultas de la pantalla
  // de entrada, y se hace UNA sola vez por sesion.
  const _precargado = useRef(false);
  useEffect(() => {
    if (!currentUser || _precargado.current) return;
    // La marca se pone AL DISPARAR, no al programar, y la limpieza solo
    // cancela el temporizador. Al reves —marcar aqui y cancelar en la
    // limpieza— el efecto corre dos veces (currentUser pasa de null a la
    // sesion, y en desarrollo React lo repite), la limpieza mata el
    // temporizador y la segunda vuelta se salta por la marca: la precarga NO
    // OCURRE NUNCA. Se detecto midiendo en un navegador de verdad, porque
    // "no pasa nada" es indistinguible de "funciona" si no se mira.
    const t = setTimeout(() => {
      if (_precargado.current) return;
      _precargado.current = true;
      precargarModulosEnReposo();
    }, 2500);
    return () => clearTimeout(t);
  }, [currentUser?.id]);
  const [betaToken,setBetaToken]=useBetaTokenFromUrl();
  const [showOnboarding,setShowOnboarding]=useState(false);
  useEffect(()=>{
    if(currentUser && !hasOnboarded(currentUser.id) && !_demoEmbedded) setShowOnboarding(true);
    else setShowOnboarding(false);
  },[currentUser?.id]);
  // Cross-device theme/palette (#3): hydrate from the saved profile once after
  // login, then persist any later change so the look follows the user to
  // another PC (it was localStorage-only before).
  useEffect(()=>{
    if(!currentUser||_uiPrefsHydrated.current)return;
    _uiPrefsHydrated.current=true;
    if(currentUser.uiTheme==="dark"||currentUser.uiTheme==="light")setTheme(currentUser.uiTheme);
    if(currentUser.uiPalette==="ocean"||currentUser.uiPalette==="sunset")setPalette(currentUser.uiPalette);
  },[currentUser?.id]);
  // Never while a platform owner is viewing-as another user: hydration above
  // just loaded the TARGET's theme, so persisting it here would write their
  // look & feel onto the founder's own row (same trap the uiPrefs sync below
  // already guards against).
  useEffect(()=>{
    if(!currentUser||!_uiPrefsHydrated.current||currentUser.impersonatedByPlatform||!(typeof window!=="undefined"&&window.__deskteAuth))return;
    import("./crm-app/api.js").then(({updateMyProfile})=>updateMyProfile({uiTheme:theme,uiPalette:palette})).catch(()=>{});
  },[theme,palette]);
  // Set default view based on role when user logs in. With lastView
  // persistence removed (Lissette 2026-05-26), this is the single source
  // of truth for where someone lands after login or refresh — no more
  // "open where I was last time".
  useEffect(() => {
    if (!currentUser) return;
    // Honor a view the URL already pointed at on first load (refresh / shared
    // link / opened-in-new-tab) instead of snapping to the role default.
    if (_initialUrlView.current) { _initialUrlView.current = null; return; }
    let impersonating = false;
    try { impersonating = !!leerEntrada("deskte:impersonateAgencyId"); } catch {}
    // PLATFORM_OWNER is the SaaS admin — they don't run a CRM. Send them
    // straight to the Platform Admin console; the rest of the sidebar is
    // hidden for them in `visibleNAV` below. EXCEPT when browsing-as-agency:
    // then they act as a normal agency user and land on the CRM dashboard.
    // La entrada de Platform Admin SÍ entró: se quita la marca que dejó el botón
    // "Entrar" / "Ver como" antes de recargar, para que salir luego no se lea
    // como una entrada fallida (ver diagnosticoDeEntrada en PlatformAdminView).
    let verComo = false;
    try { verComo = !!leerEntrada("deskte:impersonateUserId"); } catch {}
    if ((currentUser.isPlatformOwner && impersonating) || (!currentUser.isPlatformOwner && verComo && currentUser.impersonatedByPlatform)) {
      try { localStorage.removeItem("deskte:entradaPedida"); } catch {}
    }
    if (currentUser.isPlatformOwner && !impersonating) setView("platform_admin");
    else if (currentUser.isPlatformOwner && impersonating) setView("dashboard");
    else if (currentUser.role === "agency_owner" || currentUser.role === "agency_admin") setView("agency");
    else if (currentUser.role === "assistant") setView("dashboard"); // seat lands on CRM; snap-back effect refines to first allowed view. NOT my_email (that's the connect-email screen — outbound goes through the agent, so seats should never be nagged to connect on login)
    else setView("dashboard");
  }, [currentUser?.id]);
  const [showReset,setShowReset]=useState(false);
  // Defaults flipped from SEED_* to [] on 2026-05-11. The SEED constants
  // remain in scope only to feed the (auth-gated) Reset button + the legacy
  // BetaOnboardScreen demo flow. A real authenticated agency now starts
  // empty and gets hydrated from the API on login — no demo clients,
  // policies, leads, expenses, etc. show up for a fresh signup.
  // PHI — was useLocalStorage("dkt6_clients", []) until audit fix C2
  // (2026-05-20). Persisting the clients array to disk leaked DOB, email,
  // phone, address, ssnMasked / ssnLast4, spouse, and dependents on every
  // change — any XSS or browser-extension compromise could exfiltrate the
  // entire household. The hydration effect below populates state on mount;
  // diff-wrappers further down don't depend on persistence. Residual
  // localStorage from previous builds is wiped by the cleanup effect at
  // the top of this component. Same pattern applies to every PHI-bearing
  // state slot in this file (policies, signatures, leads, etc.).
  const [clients,setClients]=useState([]);
  // Hydrate clients from real backend when MSAL session is active.
  // Replaces SEED data on first authed render; runs once per logged-in user.
  // The backend caps `limit` at 500 (see paginationDefaults), so an agency
  // with >500 clients would otherwise miss rows. Loop through pages until
  // we have everything — safety stop at 20 pages (=10k clients) so a
  // misbehaving server can't spin us forever.
  const [clientsLoaded, setClientsLoaded] = useState(false);
  // Cuántos clientes dice el SERVIDOR que hay, frente a los que se llegaron a
  // cargar. Se guarda para poder DECIRLO EN PANTALLA: hasta ahora una carga
  // incompleta solo se veía en la consola del navegador —donde nadie mira— y un
  // aviso que pasa volando. Resultado: "subí 1.400 y solo veo 500" se convertía
  // en un misterio en vez de una frase que la propia pantalla contesta
  // (Lissette 2026-08-15). null = todavía no se sabe.
  const [clientsServerTotal, setClientsServerTotal] = useState(null);
  useEffect(() => {
    if (!currentUser || !window.__deskteAuth || clientsLoaded) return;
    let cancelled = false;
    (async () => {
      try {
        // El recorrido por paginas vive en crm-app/carteraCompleta.js, y no
        // aqui, porque NO es solo del arranque: la papelera y los duplicados
        // vuelven a pedir la lista y se traian una sola pagina, dejando la
        // cartera en 500 (2026-09-17). Lo que hace es lo mismo de siempre —
        // pagina 1 para saber cuantas hay, el resto en tandas (nunca todas de
        // golpe: ver crm-app/enTandas.js), techo de 100 paginas y las caidas
        // contadas en vez de descartadas en silencio.
        const { clientes: all, paginasFallidas: failedPages, totalDelServidor } =
          await cargarCarteraCompleta({ listClients: apiListClients });
        if (cancelled) return;
        setClients(all);
        setClientsLoaded(true);
        setClientsServerTotal(totalDelServidor);
        console.log("[clients] hydrated " + all.length + " from backend" + (failedPages ? ` (${failedPages} page(s) failed)` : ""));
        if (failedPages) {
          // Al arrancar NO hay lista anterior que proteger, asi que media lista
          // es mejor que ninguna — pero se dice. (Al refrescar la decision es la
          // contraria; ver `recargarCartera`.)
          toast.error(lang === "es"
            ? `No se pudieron cargar ${failedPages} página(s) de clientes — la lista puede estar incompleta. Recarga la página.`
            : `Couldn't load ${failedPages} page(s) of clients — the list may be incomplete. Please refresh.`);
        }
      } catch (err) {
        if (!cancelled) console.error("[clients] failed to load from API, keeping SEED data:", err.message);
      }
    })();
    return () => { cancelled = true; };
  }, [currentUser?.id, clientsLoaded]);
  const [policiesLoaded, setPoliciesLoaded] = useState(false);
  const [policies,setPolicies]=useState([]); // PHI — see C2 note on clients
  // Las pólizas que crea el cierre de la asesoría del cotizador entran YA en la
  // ficha (crm-app/components/CotizadorEntrevistas.jsx). En producción también
  // llegan por el SSE policy.created: el id evita que salgan dos veces. En la
  // demo, que no tiene SSE, es la única vía.
  useEffect(()=>{
    const h=(e)=>{ const p=e?.detail?.poliza; if(!p||!p.id) return; setPolicies(prev=>prev.some(x=>x.id===p.id)?prev:[...prev,p]); };
    window.addEventListener("deskte:poliza-creada",h);
    return ()=>window.removeEventListener("deskte:poliza-creada",h);
  },[]);
  // Hydrate policies from the backend. Same pagination loop as clients because
  // policies typically outnumber clients (one client can hold 3-5).
  //
  // This used to wait for `clientsLoaded` — "so client-policy relationships use
  // real client IDs" — but nothing in this effect reads client state: it calls
  // apiListPolicies and setPolicies, and mapPolicyFromApi resolves a policy
  // purely from its own row (it carries clientId; names are joined at render).
  // The gate therefore bought no correctness and cost real time: EVERY page of
  // clients had to land before the FIRST policy request even left the browser,
  // so the two slowest parts of login ran back-to-back instead of overlapping
  // (Lissette 2026-08-07: "carga lento clientes y polizas"). Both books now
  // hydrate concurrently, which roughly halves the wall-clock to a usable app.
  useEffect(() => {
    if (!currentUser || !window.__deskteAuth || policiesLoaded) return;
    let cancelled = false;
    (async () => {
      try {
        const PAGE_SIZE = 500;
        // Page 1 first, then the rest CONCURRENTLY — same parallel hydration as
        // clients so a policy-heavy agency doesn't crawl on reload.
        const first = await apiListPolicies({ page: 1, limit: PAGE_SIZE });
        if (cancelled) return;
        const all = [...(first.policies || [])];
        // Policies outnumber clients (3-5x), so cap higher — 100 pages (=50k
        // policies) so a large agency's full book loads (dedupe + import +
        // lists all depend on having every policy). Raised from 20 (10k).
        const totalPages = Math.min(100, (first.pagination && first.pagination.totalPages) || 1);
        let failedPages = 0;
        if (totalPages > 1) {
          // En tandas, igual que clientes justo arriba: el paralelo se queda,
          // pero con techo. Las polizas son 3-5 veces mas que los clientes, o
          // sea que este es el que mas paginas dispara de toda la aplicacion.
          const rest = await enTandas(
            Array.from({ length: totalPages - 1 }, (_, i) => () =>
              apiListPolicies({ page: i + 2, limit: PAGE_SIZE })
                .then((r) => r.policies || [])
                // Same as clients above: don't drop a failed page silently
                // (audit 2026-07-16) — a partial book breaks matching/import.
                .catch(() => { failedPages++; return []; }),
            ),
          );
          if (cancelled) return;
          for (const arr of rest) all.push(...arr);
        }
        if (cancelled) return;
        // Defensive dedupe by id: if a paginated read ever returns the same
        // policy on two pages (non-unique sort key at a page boundary), it must
        // NEVER render twice — a duplicate render made "delete one" remove both
        // copies via filter(p.id!==id). The backend orderBy now tie-breaks by
        // id, but keep this net so an already-loaded book is safe too.
        const seenIds = new Set();
        const uniqueAll = [];
        for (const p of all) { if (p && p.id != null && !seenIds.has(p.id)) { seenIds.add(p.id); uniqueAll.push(p); } }
        setPolicies(uniqueAll);
        setPoliciesLoaded(true);
        console.log("[policies] hydrated " + uniqueAll.length + " from backend" + (uniqueAll.length !== all.length ? ` (deduped ${all.length - uniqueAll.length})` : "") + (failedPages ? ` (${failedPages} page(s) failed)` : ""));
        if (failedPages) {
          toast.error(lang === "es"
            ? `No se pudieron cargar ${failedPages} página(s) de pólizas — la lista puede estar incompleta. Recarga la página.`
            : `Couldn't load ${failedPages} page(s) of policies — the list may be incomplete. Please refresh.`);
        }
      } catch (err) {
        if (!cancelled) console.error("[policies] failed to load from API, keeping SEED data:", err.message);
      }
    })();
    return () => { cancelled = true; };
  }, [currentUser?.id, policiesLoaded]);
  const [changeHistory,setChangeHistory]=useState([]); // PHI — see C2 note on clients
  const [docTemplates,setDocTemplates]=useLocalStorage("dkt6_doctemplates",[]);
  const docTemplatesRef = useMirror(docTemplates);
  const [docTemplatesLoaded,setDocTemplatesLoaded]=useState(false);
  useEffect(() => {
    // IS_DEMO no tiene MSAL (no hay window.__deskteAuth) pero demoApi.js si
    // contesta /doc-templates: sin esta puerta, Firmas se veia SIN una sola
    // plantilla en la demo publica.
    if (!currentUser || (!window.__deskteAuth && !IS_DEMO) || docTemplatesLoaded) return;
    let cancelled = false;
    import("./crm-app/api.js").then(({ listDocTpl }) => listDocTpl())
      .then((rows) => { if (cancelled) return; if (rows.length) setDocTemplates(rows); setDocTemplatesLoaded(true); })
      .catch((err) => { console.error("[docTpl] load failed:", err.message); });
    return () => { cancelled = true; };
  }, [currentUser?.id, docTemplatesLoaded]);
  // Saving is sacred — never fail silently (audit 2026-07-31: six of these
  // diff-wrappers swallowed every rejection with .catch(()=>null), so a seat
  // whose write was rejected by the server SAW the change on screen and it
  // vanished on the next reload with zero explanation). Shared surfacer for
  // the wrappers/auto-saves below: toast the failure so the user knows the
  // change did NOT reach the server. Mirrors handleCustomTemplatesChange.
  const notifySaveFailed = (es, en) => (err) => {
    import("./crm-app/components/Toast.jsx")
      .then(({ toast }) => toast.error((lang === "es" ? es : en) + ": " + (err?.message || "")))
      .catch(() => {});
  };
  // Diff-wrapper for docTemplates: add/update/delete sync to backend.
  const handleDocTemplatesChange = (updater) => {
    // El updater de setState tiene que ser PURO (ver useMirror): las llamadas
    // al servidor van FUERA, y por eso se disparan una sola vez por cambio.
    const prev = docTemplatesRef.current;
    const prevArr = prev || [];
    const next = typeof updater === 'function' ? updater(prevArr) : updater;
    if (window.__deskteAuth && docTemplatesLoaded) {
      const prevById = new Map(prevArr.map(t => [t.id, t]));
      const nextById = new Map(next.map(t => [t.id, t]));
      Promise.resolve().then(() => import("./crm-app/api.js").then(api => {
        prevArr.forEach(t => { if (!nextById.has(t.id)) api.deleteDocTpl(t.id).catch(notifySaveFailed("No se pudo borrar la plantilla de documento en el servidor", "Couldn't delete the document template on the server")); });
        next.forEach(t => {
          const old = prevById.get(t.id);
          if (!old) {
            api.createDocTpl(t).then(created => {
              if (created) setDocTemplates(p => { const nx = (p || []).map(x => x.id === t.id ? created : x); docTemplatesRef.current = nx; return nx; });
            }).catch(notifySaveFailed("No se pudo guardar la plantilla de documento en el servidor", "Couldn't save the document template to the server"));
          } else if (JSON.stringify(old) !== JSON.stringify(t)) {
            api.updateDocTpl(t.id, t).catch(notifySaveFailed("No se pudo actualizar la plantilla de documento en el servidor", "Couldn't update the document template on the server"));
          }
        });
      }));
    }
    docTemplatesRef.current = next;
    setDocTemplates(next);
  };
  // Seed/upgrade the system signature templates. v2 (post PR #255) merges
  // missing system ids (ct1..ct8) into the user's set without touching
  // custom templates, and refreshes the body of any existing `source:"system"`
  // entry whose text drifted from the current SEED (so users on v1 with the
  // old 3-line stubs get the new bilingual legal text). Pushes through the
  // diff-wrapper so the changes also land in the backend — that way every
  // other device the user logs in from picks them up automatically instead
  // of staying stuck on their per-browser localStorage.
  useEffect(() => {
    if (!docTemplatesLoaded) return;
    try {
      // v4 (2026-07-02): adds ct8 "self_employment" — Self-Employment Income
      // Affidavit. The bump re-runs the ADD-ONLY merge below on every browser
      // so existing agencies pick up the new system template; bodies of
      // existing templates are never touched (see #1089 wipe lesson).
      // v5 (2026-10-15): adds ct9 "policy_cancellation" — Carta de
      // Cancelación de Póliza. Same ADD-ONLY merge.
      if (localStorage.getItem("dkt6_doctemplates_seeded") === "v5") return;
      const currentArr = Array.isArray(docTemplates) ? docTemplates : [];
      let result = [...currentArr];
      let mutated = false;

      // 1) Collapse duplicate SYSTEM templates that share a category. The old
      //    seed matched system templates by their seed id (ct1..ct7); once a
      //    template round-tripped through the backend it got a UUID, so the
      //    id match failed and the seed re-inserted a duplicate on every fresh
      //    browser / device / seat. Keep the FIRST occurrence of each category
      //    and drop the rest — the diff-wrapper deletes the extras from the
      //    backend too. Custom templates (source !== "system") are untouched.
      const seenCategories = new Set();
      const deduped = [];
      for (const t of result) {
        if (t.source === "system" && t.category) {
          if (seenCategories.has(t.category)) { mutated = true; continue; }
          seenCategories.add(t.category);
        }
        deduped.push(t);
      }
      result = deduped;

      // 2) Add ONLY the system seeds the agency is missing. Match by
      //    `category` (stable) instead of `id` (UUID drift).
      //    IMPORTANT: never overwrite the body of an existing system template.
      //    Agents customize the predetermined templates; the old "refresh
      //    drifted bodies from SEED" branch reset those edits back to the stub
      //    text AND pushed the wipe to the backend for the whole agency every
      //    time a teammate or a fresh browser ran this one-time migration —
      //    so customizations "no se quedaban". Keeping a customization is
      //    always safer than restoring stub text (data loss is unacceptable).
      const systemByCategory = new Map(
        result.filter(t => t.source === "system" && t.category).map(t => [t.category, t])
      );
      SEED_DOC_TEMPLATES.forEach(seedTpl => {
        if (!systemByCategory.has(seedTpl.category)) {
          result.push(seedTpl);
          mutated = true;
        }
      });

      if (mutated) handleDocTemplatesChange(result);
      localStorage.setItem("dkt6_doctemplates_seeded", "v5");
    } catch (e) {
      console.error("[docTpl] v2 seed failed:", e?.message || e);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [docTemplatesLoaded]);
  const [importBatches,setImportBatches]=useState([]); // PHI — see C2 note on clients
  const importBatchesRef = useMirror(importBatches);
  const [importBatchesLoaded,setImportBatchesLoaded]=useState(false);
  useEffect(() => {
    if (!currentUser || !window.__deskteAuth || importBatchesLoaded) return;
    let cancelled = false;
    import("./crm-app/api.js").then(({ listImportBatches }) => listImportBatches())
      .then((rows) => { if (cancelled) return; setImportBatches(rows); setImportBatchesLoaded(true); })
      .catch((err) => { console.error("[importBatches] load failed:", err.message); });
    return () => { cancelled = true; };
  }, [currentUser?.id, importBatchesLoaded]);
  // Wrapper that detects adds/deletes on importBatches and syncs them
  // to the server. Lets ImportView's existing `onBatchesChange(prev=>...)`
  // callers stay as-is. Newly-added rows get their local id replaced
  // with the server-assigned UUID once createImportBatch resolves.
  const handleImportBatchesChange = (updater) => {
    // El updater de setState tiene que ser PURO (ver useMirror): las llamadas
    // al servidor van FUERA, y por eso se disparan una sola vez por cambio.
    const prev = importBatchesRef.current;
    const prevArr = prev || [];
    const next = typeof updater === 'function' ? updater(prevArr) : updater;
    if (window.__deskteAuth && importBatchesLoaded) {
      const prevById = new Map(prevArr.map(b => [b.id, b]));
      const nextById = new Map(next.map(b => [b.id, b]));
      Promise.resolve().then(() => import("./crm-app/api.js").then(api => {
        prevArr.forEach(b => { if (!nextById.has(b.id)) api.deleteImportBatch(b.id).catch(notifySaveFailed("No se pudo borrar el lote de importación en el servidor", "Couldn't delete the import batch on the server")); });
        next.forEach(b => {
          if (!prevById.has(b.id)) {
            api.createImportBatch(b).then(created => {
              if (created) setImportBatches(p => { const nx = (p || []).map(x => x.id === b.id ? created : x); importBatchesRef.current = nx; return nx; });
            }).catch(notifySaveFailed("No se pudo guardar el lote de importación en el servidor", "Couldn't save the import batch to the server"));
          }
        });
      }));
    }
    importBatchesRef.current = next;
    setImportBatches(next);
  };
  const [docs,setDocs]=useState([]); // PHI — see C2 note on clients
  const [docsLoaded, setDocsLoaded] = useState(false);
  useEffect(() => {
    if (!currentUser || !window.__deskteAuth || docsLoaded) return;
    let cancelled = false;
    apiListDocuments()
      .then(({ documents: apiDocs }) => {
        if (cancelled) return;
        setDocs(apiDocs);
        setDocsLoaded(true);
        console.log("[docs] hydrated " + apiDocs.length + " from backend");
      })
      .catch((err) => {
        console.error("[docs] failed to load from API, keeping SEED data:", err.message);
      });
    return () => { cancelled = true; };
  }, [currentUser?.id, docsLoaded]);
  const [requests,setRequests]=useState([]); // PHI — see C2 note on clients
  const [requestsLoaded, setRequestsLoaded] = useState(false);
  useEffect(() => {
    if (!currentUser || !window.__deskteAuth || requestsLoaded) return;
    let cancelled = false;
    import("./crm-app/api.js").then(({ listDocRequests }) => listDocRequests())
      .then((apiReqs) => {
        if (cancelled) return;
        // La fila la arma UN solo sitio: crm-app/filaDeSolicitud.js. Antes se
        // armaba a mano aqui, en DocRequests al crear, y otra vez en el aviso
        // en vivo — y solo este tenia el nombre del cliente, asi que la lista
        // dependia de refrescar la pagina (Lissette 2026-09-04, queja 76).
        const mapped = apiReqs.map((r) => filaDeSolicitud(r, { origen: window.location.origin }));
        setRequests(mapped);
        setRequestsLoaded(true);
        console.log("[requests] hydrated " + mapped.length + " from backend");
      })
      .catch((err) => console.error("[requests] failed to load:", err.message));
    return () => { cancelled = true; };
  }, [currentUser?.id, requestsLoaded]);
  const [docTemplatesMaster,setDocTemplatesMaster]=useLocalStorage("dkt6_doc_templates_master",REQUIRED_DOCS_BY_POLICY_DEFAULT);
  // Bumped on SSE document.created (portal upload) so DocRequests refetches
  // its per-request uploaded-file lists from the backend. (Was previously a
  // cross-tab localStorage "storage" listener feeding the legacy
  // uploadsLocal.js cache — removed in the M1 portal cleanup.)
  const [uploadsBump,setUploadsBump]=useState(0);
  const [signatures,setSignatures]=useState([]); // PHI — see C2 note on clients
  const [signaturesLoaded, setSignaturesLoaded] = useState(false);
  useEffect(() => {
    if (!currentUser || !window.__deskteAuth || signaturesLoaded) return;
    let cancelled = false;
    apiListSignatures()
      .then(({ signatures: apiSigs }) => {
        if (cancelled) return;
        setSignatures(apiSigs);
        setSignaturesLoaded(true);
        console.log("[signatures] hydrated " + apiSigs.length + " from backend");
      })
      .catch((err) => {
        console.error("[signatures] failed to load from API:", err.message);
      });
    return () => { cancelled = true; };
  }, [currentUser?.id, signaturesLoaded]);
  // (Removed dead `folders` stub 2026-06-14 — was a localStorage-only placeholder
  // view with no real feature. Per-client document folders are DocFolder.jsx.)
  const [users,setUsers]=useState([]); // PII (team emails/phones) — see C2
  const [usersLoaded, setUsersLoaded] = useState(false);
  useEffect(() => {
    if (!currentUser || !window.__deskteAuth || usersLoaded) return;
    let cancelled = false;
    apiListUsers()
      .then(({ users: apiUsers }) => {
        if (cancelled) return;
        setUsers(apiUsers);
        setUsersLoaded(true);
        console.log("[users] hydrated " + apiUsers.length + " from backend");
      })
      .catch((err) => {
        console.error("[users] failed to load from API, keeping SEED data:", err.message);
      });
    return () => { cancelled = true; };
  }, [currentUser?.id, usersLoaded]);

  // El equipo, para el desplegable del "@" (Lissette 2026-09-12). Se publica
  // UNA vez desde aqui y lo lee cualquier caja de notas de la aplicacion, que
  // estan a cinco o seis componentes de distancia y no tienen por que recibir
  // la lista por props. Ver crm-app/equipoParaMenciones.js: es una copia de
  // solo lectura para pintar un menu — quien resuelve la mencion y manda el
  // aviso es el servidor.
  useEffect(() => { publicarEquipo(users); }, [users]);
  const [tasks,setTasks]=useState([]); // PHI (task text references clients) — see C2
  const [tasksLoaded, setTasksLoaded] = useState(false);
  useEffect(() => {
    if (!currentUser || !window.__deskteAuth || tasksLoaded) return;
    let cancelled = false;
    // Loop ALL pages (same pattern as clients/policies) so reports/totals and
    // the global Tasks list are never silently truncated by a single-page cap.
    (async () => {
      try {
        const all = [];
        const PAGE_SIZE = 500;
        for (let page = 1; page <= 20; page++) {
          const { tasks: pageTasks, pagination } = await apiListTasks({ page, limit: PAGE_SIZE });
          if (cancelled) return;
          all.push(...pageTasks);
          if (pageTasks.length < PAGE_SIZE) break;
          if (pagination && page >= (pagination.totalPages || page)) break;
        }
        if (cancelled) return;
        setTasks(all);
        setTasksLoaded(true);
        console.log("[tasks] hydrated " + all.length + " from backend");
      } catch (err) {
        if (!cancelled) console.error("[tasks] failed to load from API, keeping SEED data:", err.message);
      }
    })();
    return () => { cancelled = true; };
  }, [currentUser?.id, tasksLoaded]);
  const [commissions,setCommissions]=useState([]); // PHI (client name + policy) — see C2
  const [commissionsLoaded, setCommissionsLoaded] = useState(false);
  // A seat without `commissions.view` has NO commissions module — every entry
  // that needs it (reports / commissions_table) is filtered out of the nav by
  // SEAT_NAV_PERMISSION_MAP below — so this hydration could only ever come
  // back 403 from requireSeatPermission('commissions.view'). It did, ~4x/day
  // in prod. Gate the fetch on the same permission the nav uses so the seat
  // simply doesn't ask. Owners/agents are never gated.
  // NOTE: computed here, not from the `isAssistant` const further down — that
  // one is declared after this effect and would hit the TDZ in the dep array.
  const canLoadCommissions = currentUser?.role !== "assistant"
    || hasSeatPermission(normalizeSeatPermissions(currentUser?.seatPermissions), "commissions.view");
  useEffect(() => {
    if (!currentUser || !window.__deskteAuth || commissionsLoaded) return;
    if (!toca_pedir("commissions", view)) return;  // se pide al abrir su modulo
    if (!canLoadCommissions) return; // re-runs if the agent grants the bit mid-session
    let cancelled = false;
    // Loop ALL pages so commission totals/KPIs and the Commissions list are
    // never undercounted by a single-page cap (financial numbers must be exact).
    (async () => {
      try {
        const all = [];
        const PAGE_SIZE = 500;
        for (let page = 1; page <= 40; page++) {
          const { commissions: pageComm, pagination } = await apiListCommissions({ page, limit: PAGE_SIZE });
          if (cancelled) return;
          all.push(...pageComm);
          if (pageComm.length < PAGE_SIZE) break;
          if (pagination && page >= (pagination.totalPages || page)) break;
        }
        if (cancelled) return;
        setCommissions(all);
        setCommissionsLoaded(true);
        console.log("[commissions] hydrated " + all.length + " from backend");
      } catch (err) {
        if (!cancelled) console.error("[commissions] failed to load from API, keeping SEED data:", err.message);
      }
    })();
    return () => { cancelled = true; };
  }, [currentUser?.id, commissionsLoaded, canLoadCommissions, view]);
  const [metricsPerms,setMetricsPerms]=useState([]);
  // License / Company-Appointment access for a seat is now governed by the
  // HIPAA seatPermissions system (licenses.view/edit, appointments.view/edit),
  // configured in "My Team". The old per-device localStorage grid was removed.
  // Time tracking is now backend-backed (TimeEntry table) so the owner
  // sees every seat's hours — not just whatever sat in that seat's own
  // browser localStorage. Hydrated from /time-entries on login below.
  const [timelog,setTimelog]=useState([]);
  const [activitylog,setActivitylog]=useState([]); // PHI (audit references PHI access) — see C2
  // Pull the activity feed from the backend on login and refresh every 2 min
  // so newly-recorded actions show up without a hard reload. Era cada 30 s:
  // con varias pestañas abiertas esa consulta ocupaba las pocas conexiones del
  // servidor a la base y el 2026-10-20 tumbo la app 27 minutos (E-375).
  useEffect(() => {
    if (!currentUser || !window.__deskteAuth) return;
    let cancelled = false;
    const refresh = () => {
      apiListActivity({ limit: 100 })
        .then(({ activity }) => {
          if (cancelled) return;
          setActivitylog(activity);
        })
        .catch((err) => {
          console.error("[activity] failed to load from API:", err.message);
        });
    };
    refresh();
    // Solo mientras la pestaña se mira, y un refresco en el acto al volver a
    // ella. Un agente deja Deskte abierto todo el dia y trabaja en otra cosa:
    // sin esto, el servidor recibia esta consulta cada 30 s por cada pestaña
    // abierta de cada agencia, para pintar algo que nadie estaba viendo.
    // Ver crm-app/relojVisible.js. (2026-09-02.)
    const pararReloj = intervaloVisible(refresh, 120000);
    return () => { cancelled = true; pararReloj(); };
  }, [currentUser?.id]);
  // SSE auto-refresh — Phase 2 wired the three highest-value events;
  // Phase 4 adds tasks / notes / signatures / documents.
  // Connection itself is opened by the hook (Phase 1); we just pass
  // handlers that mutate the same state setters the polling effects
  // hit, so the SPA stays consistent whether the update came from a
  // server push or a re-fetch.
  //
  // clientNotes is declared HERE (ahead of its hydration effect below)
  // because the note.* handlers need setClientNotes in scope at the hook
  // call site — see feature_sse_auto_refresh "handler tries to mutate
  // state declared AFTER the hook" gotcha.
  const [clientNotes,setClientNotes]=useState([]); // PHI (free-text notes about clients) — see C2
  // Solo cliente + fecha de cada nota de la agencia (sin texto): alimenta el aviso
  // de "hay algo nuevo" de la lista de Clientes. Ver listNoteStamps en api.js.
  const [noteStamps, setNoteStamps] = useState([]);
  // Internal team chat (Phase 1): unread badge count for the sidebar. The
  // message list itself lives inside TeamChatView (loaded only when the
  // view opens); here we just track how many unseen messages exist so the
  // nav item can show a badge. Bumped by the SSE handler below, cleared
  // when the user opens the chat view (effect further down).
  const [chatUnread,setChatUnread]=useState(0);
  // Support tickets unread badge (agency: replies from the founder;
  // platform owner: tickets awaiting a reply). Same load/SSE pattern as chat.
  const [supportUnread,setSupportUnread]=useState(0);
  // Entry mode for the top-bar support menu (🎧): 'live' | 'suggestion' |
  // 'help'. Set when the user picks an item; SupportView reads it on open
  // and clears it via onEntryConsumed.
  const [supportEntry,setSupportEntry]=useState(null);
  // Shared SPA-link navigator: converts "/clients/<id>", "/quotes", ... into
  // setView (+ deferred open-this-client hint). Used by the notification
  // bell AND the chat's bot messages ("Ver →") so both jump the same way.
  const navigateFromLink = (link) => {
    if (!link) return;
    // Pull a client id from ANY link shape ("/clients/<id>", "clients/<id>",
    // "#client/<id>", or a full URL containing it) so we land on the right
    // client instead of falling back to the dashboard.
    const cm = String(link).match(/(?:#client\/|clients\/)([A-Za-z0-9_-]+)/);
    if (cm && cm[1]) {
      // Optional "?tab=<id>" → land the record on a specific tab (e.g. the
      // Cambio de vida alert opens ?tab=lifechange, not just the client).
      const tm = String(link).match(/[?&]tab=([a-z_]{1,30})/i);
      const c = (clients || []).find(cl => cl.id === cm[1]);
      if (c) {
        if (tm && tm[1]) window.__magClientTab = tm[1].toLowerCase();
        // `irAlCliente` ya avisa a una vista de Clientes YA montada, que es
        // lo que hacia falta para que "Ver ->" funcione sin remontarla.
        irAlCliente(c, setView);
        // Un instante despues, empujar a una ficha YA abierta para que cambie
        // de pestaña (su comprobacion corre al abrir / al cambiar de cliente;
        // esto cubre "el mismo cliente ya estaba abierto").
        setTimeout(() => { try { window.dispatchEvent(new CustomEvent('deskte:client-tab')); } catch {} }, 150);
      }
      return;
    }
    // A full external URL (e.g. a signed-document blob) → open it directly.
    if (/^https?:\/\//i.test(String(link))) { try { window.open(link, '_blank', 'noopener,noreferrer'); } catch {} return; }
    if (link.startsWith('/clients')) setView('clients');
    else if (link.startsWith('/invoices')) setView('invoices');
    else if (link.startsWith('/leads')) setView('leads');
    else if (link.startsWith('/tasks')) setView('tasks');
    else if (link.startsWith('/tickets')) setView('tickets');
    else if (link.startsWith('/quotes')) setView('quotes_invoices');
    else if (link.startsWith('/applications')) setView('applications');
    else if (link.startsWith('/calendar')) setView('calendar');
    else if (link.startsWith('/policies')) setView('policies');
    else if (link.startsWith('/signatures')) setView('signatures');
    else if (link.startsWith('/my_email') || link.startsWith('/emails')) setView('my_email');
    else setView('dashboard');
  };
  // Contador de comentarios de una nota, tal y como lo acaba de contar el
  // servidor. Asignación pura (nunca suma/resta) para que el eco SSE del
  // comentario propio y la respuesta del POST converjan al mismo número.
  const applyNoteCommentCount = (payload) => {
    if (typeof payload.commentCount !== 'number') return;
    const total = Math.max(0, payload.commentCount);
    setClientNotes((prev) => prev.map((x) => (
      x.id === payload.noteId && x.commentCount !== total ? { ...x, commentCount: total } : x
    )));
  };
  // Cada mensaje que entra o sale sube este contador, y la bandeja lo mira
  // para volver a pedir su lista. Va un NUMERO y no la fila: quien puede ver
  // que hilo lo decide el servidor, y el aviso SSE se emite a la agencia
  // entera sin saberlo.
  const [conversationsPing, setConversationsPing] = useState(0);
  // Lo mismo para el tablero del embudo: cualquier cambio en un lead lo
  // refresca. Va aparte del de Conversaciones a proposito -- un SMS que entra
  // no mueve una tarjeta de columna, y refrescar el tablero por cada mensaje
  // seria pedirle al servidor el tablero entero sin motivo.
  const [leadsPing, setLeadsPing] = useState(0);

  // La recarga tras una reconexion, REPARTIDA. Un despliegue apaga la version
  // vieja del servidor y corta el canal en vivo de TODAS las pestanas abiertas
  // en el mismo segundo; cada una se reconectaba y volvia a pedir sus 16 listas
  // completas (cartera, polizas, tareas...) a la vez, contra un servidor recien
  // arrancado y una base B1ms. N pestanas = 16*N consultas pesadas de golpe, y
  // esa cola es la que dejaba el sistema "lentooo" despues de cada merge — la
  // misma forma que E-188. Tres frenos, sin perder la convergencia:
  //   1. cada pestana espera un rato al azar (hasta 45 s las listas ligeras y
  //      hasta ~5 min la cartera, 2026-10-14), asi no llegan juntas;
  //   2. una pestana en segundo plano no pide nada hasta que alguien la mira;
  //   3. las listas se piden por tandas, no las 16 a la vez.
  // Mientras tanto la pantalla sigue mostrando lo que ya tenia; solo tarda un
  // poco mas en traer lo que cambio durante el corte.
  const resyncRef = useRef({ enCamino: false, timers: [], alVolver: null });
  useEffect(() => () => {
    const st = resyncRef.current;
    st.timers.forEach(clearTimeout);
    if (st.alVolver) document.removeEventListener('visibilitychange', st.alVolver);
  }, []);
  const resincronizarEscalonado = useCallback(() => {
    const st = resyncRef.current;
    if (st.enCamino) return; // ya hay una recarga pendiente: esa trae lo ultimo
    st.enCamino = true;
    // La CARTERA (clientes y pólizas) va aparte y con mucho más margen: es lo
    // pesado —~67 páginas en una agencia grande— y la que llenó la fila de
    // conexiones el 2026-10-14 (ver crm-app/resincronizacion.js).
    const cartera = [setClientsLoaded, setPoliciesLoaded];
    const tandas = [
      [setLeadsLoaded, setTasksLoaded, setFollowupsLoaded],
      [setAppointmentsLoaded, setCalEventsLoaded, setNotesLoaded],
      [setDocsLoaded, setRequestsLoaded, setSignaturesLoaded],
      [setUsersLoaded, setTicketsLoaded, setInvoicesLoaded],
      [setEligibilityAlertsLoaded, setCommissionsLoaded],
    ];
    const PASO_MS = 2500;
    const esperarYLanzar = (alVolver) => {
      const { ligeras, cartera: enCartera } = retrasosDeResincronizacion({ alVolver });
      tandas.forEach((tanda, i) => {
        st.timers.push(setTimeout(() => tanda.forEach((marcar) => marcar(false)), ligeras + i * PASO_MS));
      });
      st.timers.push(setTimeout(() => cartera.forEach((marcar) => marcar(false)), enCartera));
      const fin = Math.max(ligeras + tandas.length * PASO_MS, enCartera) + 1000;
      st.timers.push(setTimeout(() => { st.enCamino = false; st.timers = []; }, fin));
    };
    if (document.visibilityState === 'hidden') {
      // Quien vuelve a una pestana ya llega a su hora, no en manada: basta
      // un margen corto.
      st.alVolver = () => {
        if (document.visibilityState === 'hidden') return;
        document.removeEventListener('visibilitychange', st.alVolver);
        st.alVolver = null;
        esperarYLanzar(true);
      };
      document.addEventListener('visibilitychange', st.alVolver);
    } else {
      esperarYLanzar(false);
    }
  }, []);

  useServerEvents({
    enabled: !!currentUser,
    handlers: {
      // Stream died and was rebuilt (hooks.js dispatches this only on a
      // RE-connect, never on startup). Anything emitted while this tab was
      // dark may be gone — the server replays only a 200-event ring, so a
      // deploy, a laptop sleep or a replica restart loses the rest forever.
      // Drop the loaded-flags so every hydration effect refetches its list
      // and the UI converges instead of staying stale until a manual F5
      // (audit 2026-07-31: "no veo las actualizaciones hasta refrescar").
      // Settings blobs (agencySettings/docTemplates/customTemplates) are NOT
      // reset: their hydration re-arms debounced echo PUTs, and they change
      // rarely enough that the per-event handlers cover them.
      connected: (payload) => {
        if (!payload || !payload.reconnect) return;
        resincronizarEscalonado();
      },
      // Citas module (clientAppointment) — event names are 'cita.*', NOT
      // 'appointment.*': the calendar module owns those with a different row
      // shape. Payload = the same toFront row listCitas returns, so a plain
      // merge is safe. Dedup guards absorb the echo of this tab's own write.
      'cita.created': (payload) => {
        if (!payload || !payload.id) return;
        setAppointments((prev) => (prev || []).some((a) => a.id === payload.id) ? prev : [payload, ...(prev || [])]);
      },
      'cita.updated': (payload) => {
        if (!payload || !payload.id) return;
        setAppointments((prev) => (prev || []).map((a) => a.id === payload.id ? { ...a, ...payload } : a));
      },
      'cita.deleted': (payload) => {
        if (!payload || !payload.id) return;
        setAppointments((prev) => (prev || []).filter((a) => a.id !== payload.id));
      },
      // Follow-ups / Seguimiento. RAW setters on purpose — routing these
      // through handleFollowupsChange would diff and re-fire the API calls,
      // turning every received event into a redundant PUT.
      'followup.created': (payload) => {
        if (!payload || !payload.id) return;
        setFollowups((prev) => (prev || []).some((f) => f.id === payload.id) ? prev : [payload, ...(prev || [])]);
      },
      'followup.updated': (payload) => {
        if (!payload || !payload.id) return;
        setFollowups((prev) => (prev || []).map((f) => f.id === payload.id ? { ...f, ...payload } : f));
      },
      'followup.deleted': (payload) => {
        if (!payload || !payload.id) return;
        setFollowups((prev) => (prev || []).filter((f) => f.id !== payload.id));
      },
      'client.created': (payload) => {
        if (!payload || !payload.id) return;
        // The SSE frame is the RAW backend row: `status` is the UPPERCASE
        // Prisma enum ('PROSPECT'/'REFERRAL'/'ACTIVE'/'INACTIVE'), whereas the
        // whole SPA (and the REST fetch path via mapClientFromApi) uses
        // lowercase. Normalize just `status` before merging so a live-merged
        // client keeps matching status-filtered views (e.g. "Prospecto y
        // Referido") instead of dropping out until a refresh. We touch ONLY
        // `status` — a full remap here would blank the encrypted fields the
        // SSE payload deliberately omits (see clients.routes.ts `safe`).
        const p = payload.status ? { ...payload, status: String(payload.status).toLowerCase() } : payload;
        setClients((prev) => {
          // Dedup: the tab that triggered the POST already merged the
          // response locally, so we'll receive an echo of our own
          // create. Drop it if the id is already present.
          if (prev.some((c) => c.id === p.id)) return prev;
          return [...prev, p];
        });
      },
      'client.updated': (payload) => {
        if (!payload || !payload.id) return;
        // Normalize `status` casing (see client.created above): the raw SSE
        // row's UPPERCASE enum would otherwise knock the client out of
        // lowercase status filters on every live edit (its own echo included).
        const p = payload.status ? { ...payload, status: String(payload.status).toLowerCase() } : payload;
        setClients((prev) => {
          if (!prev.some((c) => c.id === p.id)) return prev;
          return prev.map((c) => (c.id === p.id ? { ...c, ...p } : c));
        });
        // Tell an open edit form for this client that the server moved on, so
        // it can show a "otra persona actualizó esta ficha" banner before the
        // user saves stale data over a teammate's change. Carries updatedAt so
        // the form ignores the echo of its own save (same version).
        try {
          window.dispatchEvent(new CustomEvent('deskte:client-updated', {
            detail: { id: payload.id, updatedAt: payload.updatedAt },
          }));
        } catch {}
      },
      'client.presence': (payload) => {
        // { clientId, viewers:[{userId,name}] } — re-broadcast to whichever
        // ClientDetail is currently open for that client (window event keeps
        // the SSE wiring decoupled from the deep component tree).
        if (!payload || !payload.clientId) return;
        try {
          window.dispatchEvent(new CustomEvent('deskte:client-presence', {
            detail: { clientId: payload.clientId, viewers: payload.viewers || [] },
          }));
        } catch {}
      },
      'client.deleted': (payload) => {
        if (!payload || !payload.id) return;
        setClients((prev) => prev.filter((c) => c.id !== payload.id));
      },
      'policy.created': (payload) => {
        if (!payload || !payload.id) return;
        // The backend emits the RAW Prisma row (type:"HEALTH", premium,
        // expirationDate, policy_insured). Map it to the frontend shape or the
        // card renders the wrong type/dates and drops the insured selection.
        const mapped = mapPolicyFromApi(payload);
        setPolicies((prev) => {
          if (prev.some((p) => p.id === mapped.id)) return prev;
          return [...prev, mapped];
        });
      },
      'policy.updated': (payload) => {
        if (!payload || !payload.id) return;
        const mapped = mapPolicyFromApi(payload);
        setPolicies((prev) => {
          if (!prev.some((p) => p.id === mapped.id)) return prev;
          return prev.map((p) => (p.id === mapped.id ? { ...p, ...mapped } : p));
        });
      },
      'policy.deleted': (payload) => {
        if (!payload || !payload.id) return;
        setPolicies((prev) => prev.filter((p) => p.id !== payload.id));
      },
      'policy.payment.updated': (payload) => {
        // Re-broadcast to the PaymentTrackerView (it reconciles by period).
        if (!payload || !payload.policyId) return;
        window.dispatchEvent(new CustomEvent('deskte:policy-payment', { detail: payload }));
      },
      'policy.renewal.updated': (payload) => {
        // Keep the Renewals list in sync across seats/tabs. Stage and note are
        // emitted separately; apply whichever the payload carries.
        if (!payload || !payload.policyId) return;
        setPolicies((prev) => prev.map((p) => {
          if (p.id !== payload.policyId) return p;
          const next = { ...p };
          if (payload.stage !== undefined) next.renewalStage = payload.stage;
          if (payload.note !== undefined) next.renewalNote = payload.note || '';
          return next;
        }));
      },
      // ── Leads ────────────────────────────────────────────────────────
      // Backend emits the RAW Prisma lead row; run it through mapLeadFromApi
      // so a teammate's tab renders the right status/fields (the originating
      // tab already merged its optimistic add, so created dedups the echo).
      'lead.created': (payload) => {
        setLeadsPing((n) => n + 1);
        if (!payload || !payload.id) return;
        const l = mapLeadFromApi(payload);
        setLeads((prev) => {
          if (prev.some((x) => x.id === l.id)) return prev;
          return [...prev, l];
        });
      },
      'lead.updated': (payload) => {
        setLeadsPing((n) => n + 1);
        if (!payload || !payload.id) return;
        const l = mapLeadFromApi(payload);
        setLeads((prev) => {
          if (!prev.some((x) => x.id === l.id)) return prev;
          return prev.map((x) => (x.id === l.id ? { ...x, ...l } : x));
        });
      },
      'lead.deleted': (payload) => {
        setLeadsPing((n) => n + 1);
        if (!payload || !payload.id) return;
        setLeads((prev) => prev.filter((x) => x.id !== payload.id));
      },
      // ── Calendar / appointments ──────────────────────────────────────
      'appointment.created': (payload) => {
        if (!payload || !payload.id) return;
        const e = mapAppointmentFromApi(payload);
        setCalEvents((prev) => {
          if (prev.some((x) => x.id === e.id)) return prev;
          return [...prev, e];
        });
      },
      'appointment.updated': (payload) => {
        if (!payload || !payload.id) return;
        const e = mapAppointmentFromApi(payload);
        setCalEvents((prev) => {
          if (!prev.some((x) => x.id === e.id)) return prev;
          return prev.map((x) => (x.id === e.id ? { ...x, ...e } : x));
        });
      },
      'appointment.deleted': (payload) => {
        if (!payload || !payload.id) return;
        setCalEvents((prev) => prev.filter((x) => x.id !== payload.id));
      },
      // ── Invoices (live in deskte-full state) ─────────────────────────
      // Quotes are owned by QuotesInvoicesView's internal state, so those
      // events are re-broadcast as window CustomEvents for that component
      // to pick up (mirrors the policy.payment.updated bridge).
      'invoice.created': (payload) => {
        if (!payload || !payload.id) return;
        setInvoices((prev) => {
          if (prev.some((x) => x.id === payload.id)) return prev;
          return [...prev, payload];
        });
        window.dispatchEvent(new CustomEvent('deskte:invoice', { detail: { action: 'created', invoice: payload } }));
      },
      'invoice.updated': (payload) => {
        if (!payload || !payload.id) return;
        setInvoices((prev) => prev.map((x) => (x.id === payload.id ? { ...x, ...payload } : x)));
        window.dispatchEvent(new CustomEvent('deskte:invoice', { detail: { action: 'updated', invoice: payload } }));
      },
      'invoice.deleted': (payload) => {
        if (!payload || !payload.id) return;
        setInvoices((prev) => prev.filter((x) => x.id !== payload.id));
        window.dispatchEvent(new CustomEvent('deskte:invoice', { detail: { action: 'deleted', invoice: payload } }));
      },
      'quote.created': (payload) => {
        if (!payload || !payload.id) return;
        window.dispatchEvent(new CustomEvent('deskte:quote', { detail: { action: 'created', quote: payload } }));
      },
      'quote.updated': (payload) => {
        if (!payload || !payload.id) return;
        window.dispatchEvent(new CustomEvent('deskte:quote', { detail: { action: 'updated', quote: payload } }));
      },
      'quote.deleted': (payload) => {
        if (!payload || !payload.id) return;
        window.dispatchEvent(new CustomEvent('deskte:quote', { detail: { action: 'deleted', quote: payload } }));
      },
      'activity.appended': (payload) => {
        if (!payload || !payload.id) return;
        // Prepend; cap at 200 so the in-memory feed doesn't grow
        // unbounded over a long-lived tab session. The polling effect
        // above re-hydrates the full window on a 30s cadence anyway.
        setActivitylog((prev) => {
          if (prev.some((row) => row.id === payload.id)) return prev;
          return [payload, ...prev].slice(0, 200);
        });
      },
      // La bandeja unificada. El aviso NO trae el texto del mensaje (va por el
      // canal de la agencia entera): solo dice que algo se movio.
      'conversation.updated': () => { setConversationsPing((n) => n + 1); },
      'email.received': (payload) => {
        // Body is intentionally NOT on the wire (PHI minimization). We
        // show a toast so the agent notices the inbound — the per-client
        // Emails tab reflects the new message on its next fetch (open
        // the client → fetch).
        const es = lang === 'es';
        const who = payload?.fromName || payload?.fromAddress || (es ? 'remitente' : 'sender');
        const subj = payload?.subject ? ` — "${payload.subject.slice(0, 60)}"` : '';
        toast.info(`📥 ${es ? 'Nuevo email de' : 'New email from'} ${who}${subj}`);
      },
      // ── Phase 4: tasks / notes / signatures / documents ──────────────
      // The SSE frame carries the RAW backend row (camelCase Prisma shape,
      // enum casing like 'PENDING', field names like content/assigneeId).
      // The SPA state holds the MAPPED frontend shape (status:'todo',
      // text, assignedTo, …) so we run every payload through the same
      // map*FromApi the fetch path uses BEFORE merging — otherwise a
      // teammate's tab (which sees the row for the first time via SSE,
      // not via its own optimistic add) would render it wrong until F5.
      //
      // created dedups against the optimistic-add echo, updated merges,
      // deleted filters. The optimistic-add call sites carry the
      // merge-or-push dedup (feedback_sse_echo_dedup_optimistic_add) so an
      // echo arriving before the POST 201 doesn't double-render.
      'task.created': (payload) => {
        if (!payload || !payload.id) return;
        const t = mapTaskFromApi(payload);
        setTasks((prev) => {
          if (prev.some((x) => x.id === t.id)) return prev;
          return [...prev, t];
        });
      },
      'task.updated': (payload) => {
        if (!payload || !payload.id) return;
        // Guard against a partial payload (e.g. a note-add echo carrying only
        // {id}): mapTaskFromApi fills the gaps with defaults (title→'',
        // status→'todo', priority→'medium') and the merge would wipe the row
        // until a reload. A real task always has a title, so if it's missing
        // the payload isn't a full task — the local copy is already correct.
        if (payload.title === undefined || payload.title === null) return;
        const t = mapTaskFromApi(payload);
        setTasks((prev) => {
          if (!prev.some((x) => x.id === t.id)) return prev;
          return prev.map((x) => (x.id === t.id ? { ...x, ...t } : x));
        });
      },
      'task.deleted': (payload) => {
        if (!payload || !payload.id) return;
        setTasks((prev) => prev.filter((x) => x.id !== payload.id));
      },
      'note.created': (payload) => {
        if (!payload || !payload.id) return;
        const n = mapNoteFromApi(payload);
        setClientNotes((prev) => {
          if (prev.some((x) => x.id === n.id)) return prev;
          return [...prev, n];
        });
      },
      'note.updated': (payload) => {
        if (!payload || !payload.id) return;
        const n = mapNoteFromApi(payload);
        setClientNotes((prev) => {
          if (!prev.some((x) => x.id === n.id)) return prev;
          return prev.map((x) => (x.id === n.id ? { ...x, ...n } : x));
        });
      },
      'note.deleted': (payload) => {
        if (!payload || !payload.id) return;
        setClientNotes((prev) => prev.filter((x) => x.id !== payload.id));
        setNoteStamps((prev) => prev.filter((x) => x.id !== payload.id));
      },
      // Comentarios de nota. Aquí solo se mantiene el CONTADOR de la nota (el
      // "💬 3" de la lista); el hilo abierto lo actualiza ClientNotesTab, que
      // escucha el CustomEvent de abajo. Los cuerpos no viven en clientNotes a
      // propósito: se cargan al abrir el hilo, no en el arranque de la app.
      // El contador llega YA CALCULADO por el servidor (`commentCount`) y se
      // asigna, no se suma. Sumar +1 aquí contaba dos veces el comentario
      // propio, porque el hilo abierto ya había publicado su propio total al
      // recibir la respuesta del POST (Crismar 2026-08-11: "coloco 1 comentario
      // y me dice que hay 2"). Asignar es idempotente: el eco y la respuesta
      // pueden llegar en cualquier orden y el número queda igual.
      //
      // Si el payload no trae `commentCount` (servidor viejo — el frontend se
      // despliega ~4 min antes que el backend) no se toca el contador: queda
      // desfasado hasta la siguiente carga, que es infinitamente preferible a
      // volver a inflarlo.
      'note.comment.created': (payload) => {
        if (!payload || !payload.noteId) return;
        applyNoteCommentCount(payload);
        try { window.dispatchEvent(new CustomEvent('deskte:note-comment', { detail: { action: 'created', ...payload } })); } catch {}
      },
      'note.comment.updated': (payload) => {
        if (!payload || !payload.noteId) return;
        try { window.dispatchEvent(new CustomEvent('deskte:note-comment', { detail: { action: 'updated', ...payload } })); } catch {}
      },
      'note.comment.deleted': (payload) => {
        if (!payload || !payload.noteId) return;
        applyNoteCommentCount(payload);
        try { window.dispatchEvent(new CustomEvent('deskte:note-comment', { detail: { action: 'deleted', ...payload } })); } catch {}
      },
      // Tickets (customer-service cases): the list loads once on login, so
      // without this a reassign/status change made by a teammate — e.g.
      // handing a ticket to a seat — never reaches that seat's already-open
      // tab until they reload (Lissette 2026-07-23). Payload is the backend's
      // toFront() shape already, same as listTickets/createTicket/updateTicket,
      // so no mapping is needed before merging.
      'ticket.created': (payload) => {
        if (!payload || !payload.id) return;
        setTickets((prev) => {
          if (prev.some((x) => x.id === payload.id)) return prev;
          return [payload, ...prev];
        });
      },
      'ticket.updated': (payload) => {
        if (!payload || !payload.id) return;
        setTickets((prev) => prev.map((x) => (x.id === payload.id ? { ...x, ...payload } : x)));
      },
      'ticket.deleted': (payload) => {
        if (!payload || !payload.id) return;
        setTickets((prev) => prev.filter((x) => x.id !== payload.id));
      },
      'signature.created': (payload) => {
        if (!payload || !payload.id) return;
        const s = mapSignatureFromApi(payload);
        setSignatures((prev) => {
          if (prev.some((x) => x.id === s.id)) return prev;
          return [...prev, s];
        });
      },
      'signature.updated': (payload) => {
        if (!payload || !payload.id) return;
        const s = mapSignatureFromApi(payload);
        setSignatures((prev) => {
          if (!prev.some((x) => x.id === s.id)) return prev;
          return prev.map((x) => (x.id === s.id ? { ...x, ...s } : x));
        });
      },
      'signature.deleted': (payload) => {
        if (!payload || !payload.id) return;
        setSignatures((prev) => prev.filter((x) => x.id !== payload.id));
      },
      'notification.created': (payload) => {
        if (!payload || !payload.id) return;
        // Nudge the 🔔 to refetch NOW instead of waiting for its 30s poll
        // (Lissette 2026-07-02: "que salga de una la notificación"). The bell
        // refetches through the API (per-user visibility enforced there), so
        // the payload itself carries no titles/bodies.
        window.dispatchEvent(new CustomEvent('deskte:notification', { detail: payload }));
      },
      'document.created': (payload) => {
        if (!payload || !payload.id) return;
        const d = mapDocumentFromApi(payload);
        setDocs((prev) => {
          if (prev.some((x) => x.id === d.id)) return prev;
          return [...prev, d];
        });
        // When the upload fulfilled a document request (client dropped a file in
        // the portal), refetch the requests so their status flips from pending
        // to partial/received live, without a page reload.
        if (d.documentRequestId) {
          // Nudge DocRequests to refetch its per-request uploaded-file lists
          // (count strip + open "View files" modal) from the backend.
          setUploadsBump(Date.now());
          import("./crm-app/api.js").then(({ listDocRequests }) => listDocRequests())
            .then((apiReqs) => {
              // MISMO armador que la hidratacion: cuando este mapeo era una
              // copia suelta, subir un archivo BORRABA los nombres de toda la
              // lista hasta el siguiente refresco.
              const mapped = apiReqs.map((r) => filaDeSolicitud(r, { origen: window.location.origin }));
              setRequests(mapped);
            })
            .catch(() => {/* live refresh is best-effort */});
        }
      },
      'document.updated': (payload) => {
        if (!payload || !payload.id) return;
        const d = mapDocumentFromApi(payload);
        setDocs((prev) => {
          const idx = prev.findIndex((x) => x.id === d.id);
          if (idx === -1) return [...prev, d];
          const next = prev.slice();
          next[idx] = { ...next[idx], ...d };
          return next;
        });
      },
      'document.deleted': (payload) => {
        if (!payload || !payload.id) return;
        setDocs((prev) => prev.filter((x) => x.id !== payload.id));
      },
      // Internal team chat: a teammate (or another tab) sent a message.
      // Re-broadcast it as a window event so an open TeamChatView appends
      // it live. For the sidebar badge, bump unread only when the message
      // isn't mine AND the chat view isn't currently open (an open view
      // marks itself read). `view` is read fresh on each render because
      // the hook keeps handlers in a ref.
      'chat.message.created': (payload) => {
        if (!payload || !payload.id) return;
        try { window.dispatchEvent(new CustomEvent('deskte:chat-message', { detail: payload })); } catch {}
        const mine = payload.author?.id && currentUser?.id && payload.author.id === currentUser.id;
        if (!mine && view !== 'team_chat') {
          setChatUnread((n) => n + 1);
          // Audible chime if the user enabled chat sound (default on). Same
          // `!mine` guard so you never hear a sound for your own messages.
          if (userPrefs?.chatSound !== false) { playChatChime(); }
          // Corner notification so the user notices even from another module.
          // The body is already decrypted on the wire (serialized message).
          try {
            const who = payload.isSystem
              ? '🤖 Deskte'
              : (payload.author?.seatLabel || payload.author?.displayName || (lang === 'es' ? 'Equipo' : 'Team'));
            const preview = payload.attachmentUrl && !payload.body
              ? (lang === 'es' ? '📷 Imagen' : '📷 Image')
              : String(payload.body || '').slice(0, 80);
            toast.info(`💬 ${who}: ${preview}`);
          } catch {}
        }
      },
      'chat.message.updated': (payload) => {
        if (!payload || !payload.id) return;
        try { window.dispatchEvent(new CustomEvent('deskte:chat-message-updated', { detail: payload })); } catch {}
      },
      'chat.message.deleted': (payload) => {
        if (!payload || !payload.id) return;
        try { window.dispatchEvent(new CustomEvent('deskte:chat-message-deleted', { detail: payload })); } catch {}
      },
      'chat.typing': (payload) => {
        try { window.dispatchEvent(new CustomEvent('deskte:chat-typing', { detail: payload })); } catch {}
      },
      // Emoji reactions — the payload carries the message's full aggregated
      // reaction list; an open chat view/widget swaps it in place.
      'chat.message.reacted': (payload) => {
        if (!payload || !payload.id) return;
        try { window.dispatchEvent(new CustomEvent('deskte:chat-reaction', { detail: payload })); } catch {}
      },
      // Presence (online dots) — ephemeral snapshot of connected user ids.
      'chat.presence': (payload) => {
        try { window.dispatchEvent(new CustomEvent('deskte:chat-presence', { detail: payload })); } catch {}
      },
      // Read receipts — a teammate marked a channel read; an open chat view
      // updates its ✓✓ Leído markers.
      'chat.read': (payload) => {
        try { window.dispatchEvent(new CustomEvent('deskte:chat-read', { detail: payload })); } catch {}
        // MY read — from the floating widget, another tab, or another device.
        // The sidebar badge only recomputed on view changes, so reading in the
        // widget left a stale count until a refresh (Lissette 2026-07-16).
        // Refetch the real total, debounced (reads fire per message received).
        if (payload?.userId && currentUser?.id && payload.userId === currentUser.id) {
          clearTimeout(window.__dkChatUnreadT);
          window.__dkChatUnreadT = setTimeout(() => {
            import('./crm-app/api.js').then(({ getChatUnread }) => getChatUnread())
              .then((d) => setChatUnread(d?.total || 0))
              .catch(() => {});
          }, 600);
        }
      },
      // Chat channels created/archived (Phase 2) — refresh an open chat
      // view's channel list. No badge impact (no unread on an empty channel).
      'chat.channel.created': (payload) => {
        try { window.dispatchEvent(new CustomEvent('deskte:chat-channel', { detail: payload })); } catch {}
      },
      'chat.channel.archived': (payload) => {
        try { window.dispatchEvent(new CustomEvent('deskte:chat-channel', { detail: payload })); } catch {}
      },
      // Support tickets: re-broadcast as window events so an open
      // SupportView / Platform Admin Support tab updates live, and bump the
      // sidebar badge when the reply isn't mine and that view isn't open.
      'support.ticket.created': (payload) => {
        if (!payload || !payload.id) return;
        try { window.dispatchEvent(new CustomEvent('deskte:support-ticket', { detail: payload })); } catch {}
        if (view !== 'support' && view !== 'platform_admin') setSupportUnread((n) => n + 1);
      },
      'support.ticket.updated': (payload) => {
        if (!payload || !payload.id) return;
        try { window.dispatchEvent(new CustomEvent('deskte:support-ticket', { detail: payload })); } catch {}
        // Status change by support ("en progreso" / "resuelto"): badge the
        // agent who OPENED the ticket so they know we're working on it
        // (Lissette 2026-07-13). Owner made the change, so no badge for them.
        const mineTicket = payload.openedBy?.id && currentUser?.id && payload.openedBy.id === currentUser.id;
        if (!currentUser?.isPlatformOwner && mineTicket && payload.lastFromOwner && view !== 'support' && view !== 'platform_admin') {
          setSupportUnread((n) => n + 1);
        }
      },
      'support.message.created': (payload) => {
        if (!payload || !payload.id) return;
        try { window.dispatchEvent(new CustomEvent('deskte:support-message', { detail: payload })); } catch {}
        const mine = payload.author?.id && currentUser?.id && payload.author.id === currentUser.id;
        // Owner: any incoming agency reply badges them. Agency user: only a
        // reply on a ticket THEY opened badges them (targets the creator).
        const mineTicket = payload.openedById && currentUser?.id && payload.openedById === currentUser.id;
        const relevant = currentUser?.isPlatformOwner ? true : mineTicket;
        if (!mine && relevant && view !== 'support' && view !== 'platform_admin') setSupportUnread((n) => n + 1);
      },
    },
  });
  // Team chat: load the unread badge once on login, and clear it whenever
  // the user is looking at the chat (also tell the backend we've read up
  // to now so other devices / a reload reflect it).
  useEffect(() => {
    if (!currentUser || !window.__deskteAuth) return;
    // A platform owner has no agency chat UNLESS they're browsing as an
    // agency (then they participate with that agency's real id).
    let _imp = false;
    try { _imp = !!leerEntrada("deskte:impersonateAgencyId"); } catch {}
    if (currentUser.isPlatformOwner && !_imp) return;
    let cancelled = false;
    if (view === 'team_chat') {
      // The chat view itself marks each channel read as it's opened; here we
      // just clear the sidebar badge optimistically while the user is in the
      // chat. On leaving, the else-branch recomputes the real total (channels
      // the user never opened still count).
      setChatUnread(0);
    } else {
      import('./crm-app/api.js').then(({ getChatUnread }) => getChatUnread())
        .then((d) => { if (!cancelled) setChatUnread(d?.total || 0); })
        .catch(() => {});
    }
    return () => { cancelled = true; };
  }, [currentUser?.id, view]);
  // Support unread badge — recomputed on every view change (opening a
  // ticket marks it read on the backend, so leaving & returning settles
  // the count). Works for both the agency side and the platform owner.
  useEffect(() => {
    if (!currentUser || !window.__deskteAuth) return;
    let cancelled = false;
    import('./crm-app/api.js').then(({ getSupportUnread }) => getSupportUnread())
      .then((d) => { if (!cancelled) setSupportUnread(d?.total || 0); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [currentUser?.id, view]);
  const [teamActions,setTeamActions]=useLocalStorage("dkt6_team_actions",[]);
  // Hydrate team actions from the backend on login. Before this lived in
  // localStorage only, so "Lissette sent the bday greeting from her
  // laptop" wouldn't show up when she signed in from a different device,
  // and a teammate couldn't see it had been done. The backend is the
  // source of truth — localStorage is now a cache.
  useEffect(() => {
    if (!currentUser || !window.__deskteAuth) return;
    let cancelled = false;
    const hydrate = () => {
      if (cancelled) return;
      // Las últimas 1000 + TODAS las marcas de los cumpleaños que vienen: un
      // cumpleaños programado con meses de antelación quedaba fuera de las 1000
      // y el aviso decía "sin programar" (Johanna Arosemena, 2026-10-30, E-399).
      // Si la segunda falla, se sigue con la primera, como antes.
      import('./crm-app/api.js').then(({ listTeamActions, listMarcasDeCumpleanos }) => Promise.all([
        listTeamActions({ limit: 1000 }),
        listMarcasDeCumpleanos(rangoDeCumpleanos()).catch((err) => { console.error('[team-actions] cumpleaños:', err.message); return { actions: [] }; }),
      ]))
        .then(([{ actions: recientes }, { actions: deCumpleanos }]) => {
          const actions = unirPorClave(recientes, deCumpleanos);
          if (cancelled) return;
          // Normalize the server shape (ts is an ISO string out of Prisma)
          // to the legacy local shape so downstream filters (which check
          // a.key === key and agencyMates.includes(a.userId)) keep working.
          const normalized = (actions || []).map(a => ({
            id: a.id, type: a.type, key: a.key,
            clientId: a.clientId || null,
            userId: a.userId,
            agencyId: a.agencyId,
            ts: a.ts,
            details: a.details || {},
          }));
          // MERGE, don't blindly replace. logTeamAction() writes the record
          // optimistically to local state, then fires a fire-and-forget POST.
          // This hydrate also runs on `focus`/`visibilitychange` — and the act
          // of sending a greeting (opening a mail client, tabbing away and
          // back) fires `focus`, which can re-hydrate BEFORE the POST commits.
          // A blind `setTeamActions(normalized)` would then wipe the just-sent
          // "greeting_sent" record and the popup would re-show the client as
          // not-greeted even though the email went out ("marca no enviado pero
          // sí llegó", Lissette 2026-06-01). So preserve any local records the
          // server hasn't confirmed yet (matched by key — the backend's own
          // idempotency scope). They reconcile on the next hydrate once the
          // write-through lands.
          // Only RECENT local marks of THIS user survive (crm-app/accionesDelEquipo.js):
          // keeping every unconfirmed one forever grew this cache to 4 MB and
          // filled the browser's storage (aviso E6, 2026-10-27).
          setTeamActions(prev => fusionarAccionesDelEquipo(normalized, prev, { userId: currentUser.id }));
        })
        .catch(err => console.error('[team-actions] hydrate failed:', err.message));
    };
    // Initial load + keep it fresh. Before this only ran once at login,
    // so when a SEAT sent the bday greeting the supervising agent (whose
    // tab was already open) never saw it become "done" — the whole point
    // of the team de-dup. Re-hydrate when the tab regains focus and on a
    // modest interval so a teammate's action shows up without a reload.
    hydrate();
    // `intervaloVisible` ya trae dentro el refresco al volver a la pestaña, que
    // es lo que hacia el `onVisible` de aqui — se quita para no pedirlo DOS
    // veces por cada vuelta. El oyente de `focus` se queda: cubre volver a la
    // ventana sin que la pestaña haya llegado a esconderse (otra ventana
    // encima), que visibilitychange no cuenta.
    window.addEventListener('focus', hydrate);
    const pararReloj = intervaloVisible(hydrate, 45000);
    return () => {
      cancelled = true;
      window.removeEventListener('focus', hydrate);
      pararReloj();
    };
  }, [currentUser?.id]);
  // Cache the licenses WITHOUT their attachments. A license carries its file
  // inline as base64 (up to 5MB) plus every photo pasted into its notes, and
  // localStorage is a single ~5MB budget for the whole app — so a couple of
  // licenses with PDFs filled it, and from then on every OTHER dkt6_* key
  // silently stopped persisting too. The list re-hydrates from the server on
  // every login anyway (listLicenses below), so the cache only needs enough to
  // paint the first frame. It also keeps license documents, which carry the
  // producer's personal data, out of browser storage entirely.
  // NOT cached in localStorage. A license carries its file inline as base64
  // (up to 5MB) plus every photo pasted into its notes, and localStorage is a
  // single ~5MB budget for the WHOLE app — so a couple of licenses with PDFs
  // filled it, the write threw, and from then on every other dkt6_* key
  // silently stopped persisting as well. The list is server-backed and
  // re-hydrates on login (listLicenses below), so the cache bought nothing but
  // that failure; caching a stripped copy instead would risk an edit started
  // before hydration saving the empty file back over the real one. It also
  // keeps license documents — which carry the producer's personal data — out
  // of browser storage entirely.
  const [licenses,setLicenses]=useState([]);
  const [licensesLoaded,setLicensesLoaded]=useState(false);
  useEffect(() => {
    if (!currentUser || !window.__deskteAuth || licensesLoaded) return;
    let cancelled = false;
    import("./crm-app/api.js").then(({ listLicenses }) => listLicenses())
      .then((rows) => {
        if (cancelled) return;
        setLicenses(rows);
        setLicensesLoaded(true);
        console.log("[licenses] hydrated " + rows.length + " from backend");
      })
      .catch((err) => { console.error("[licenses] failed to load from API:", err.message); });
    return () => { cancelled = true; };
  }, [currentUser?.id, licensesLoaded]);
  // Server-backed CRUD (was localStorage-only → didn't sync across devices
  // / wasn't visible to seats). LicensesView calls these; we then patch
  // local state so the UI is snappy.
  const saveLicenseRow = async (row) => {
    // Weight of the JSON body this save will send — the file plus every photo
    // pasted into the notes, all inline as base64. Captured up front so a
    // failure can say whether the payload was the likely reason.
    const payloadKb = Math.round((String(row?.fileData || "").length + String(row?.notes || "").length) / 1024);
    try {
      const { createLicense, updateLicense } = await import("./crm-app/api.js");
      const isExisting = row.id && !String(row.id).startsWith("lic_");
      if (isExisting) {
        const u = await updateLicense(row.id, row);
        setLicenses(p => p.map(l => l.id === u.id ? u : l));
      } else {
        const created = await createLicense(row);
        setLicenses(p => [...p.filter(l => l.id !== row.id), created]);
      }
    } catch (e) {
      // A license save that fails must leave a trace. It didn't: the toast was
      // the ONLY record, so when Wendy Cercio reported "no me deja guardar más
      // licencias" (2026-08-13) there was not one /api/v1/licenses event in
      // Sentry to look at, and support could only guess. Report it, with the
      // payload size attached — that is the first thing to check on a module
      // that ships 5MB files inside the request body.
      try {
        const err = new Error(`license save failed (${payloadKb}KB payload): ${e.message}`);
        err.name = "LicenseSaveError";
        reportFrontendError(err, "saveLicenseRow");
      } catch (_) { /* reporting is best-effort; never costs the user their message */ }
      // A big payload is the likeliest cause and the agent can act on it, so
      // say so instead of surfacing a bare status code.
      const heavy = payloadKb > 4096;
      const detail = heavy
        ? (lang === "es"
          ? ` — el archivo y las fotos de las notas suman ${Math.round(payloadKb / 1024)}MB, prueba con un archivo más liviano o quita alguna foto.`
          : ` — the file plus the notes' photos add up to ${Math.round(payloadKb / 1024)}MB; try a lighter file or remove a photo.`)
        : "";
      import("./crm-app/components/Toast.jsx").then(({ toast }) => toast.error((lang === "es" ? "No se pudo guardar la licencia: " : "Couldn't save license: ") + e.message + detail));
    }
  };
  const deleteLicenseRow = async (id) => {
    try {
      const { deleteLicense } = await import("./crm-app/api.js");
      await deleteLicense(id);
      setLicenses(p => p.filter(l => l.id !== id));
    } catch (e) {
      import("./crm-app/components/Toast.jsx").then(({ toast }) => toast.error((lang === "es" ? "No se pudo eliminar: " : "Couldn't delete: ") + e.message));
    }
  };
  const [compAppts,setCompAppts]=useLocalStorage("dkt6_compAppts_v2",[]);
  // customApptData holds the agent's EXTRA carriers and custom categories
  // that augment the default APPT_DATA grid. Same shape as the legacy
  // localStorage key (`{ categories: {}, carriers: {} }`); now hydrated
  // from PUT /carrier-appointments → custom blob.
  const [customApptData, setCustomApptData] = useLocalStorage(
    "dkt6_customApptData",
    { categories: {}, carriers: {} },
  );
  const customApptDataRef = useMirror(customApptData);
  const [compApptsLoaded,setCompApptsLoaded]=useState(false);
  useEffect(() => {
    if (!currentUser || !window.__deskteAuth || compApptsLoaded) return;
    let cancelled = false;
    import("./crm-app/api.js").then(({ getCarrierAppointments }) => getCarrierAppointments())
      .then(({ appointments, custom }) => {
        if (cancelled) return;
        setCompAppts(appointments || {});
        // Only adopt the server's custom blob if it actually has content —
        // a brand-new agency returns {} and we don't want to clobber any
        // legacy localStorage state until the user explicitly edits it.
        const hasCustom = custom && (
          (custom.categories && Object.keys(custom.categories).length) ||
          (custom.carriers && Object.keys(custom.carriers).length)
        );
        if (hasCustom) setCustomApptData(custom);
        setCompApptsLoaded(true);
        console.log("[compAppts] hydrated " + Object.keys(appointments || {}).length + " ON cells from backend");
      })
      .catch((err) => { console.error("[compAppts] failed to load from API:", err.message); });
    return () => { cancelled = true; };
  }, [currentUser?.id, compApptsLoaded]);
  // Per-cell toggle (server-backed). The view also flips locally for instant
  // feedback; this just syncs the server. The view only calls this for the
  // SELF grid (no userId prop / no prefix) — the parent passes it then.
  const toggleCarrierCell = async (category, state, carrier) => {
    try {
      const { toggleCarrierAppointment } = await import("./crm-app/api.js");
      await toggleCarrierAppointment(category, state, carrier);
    } catch (e) {
      import("./crm-app/components/Toast.jsx").then(({ toast }) => toast.error((lang === "es" ? "No se pudo guardar: " : "Couldn't save: ") + e.message));
    }
  };
  // Wrapper around setCustomApptData that also syncs the new blob to the
  // server (`PUT /carrier-appointments/custom`). Debounced via the React
  // event loop so a burst of mutations only fires once after they settle.
  const handleCustomApptDataChange = (updater) => {
    // El updater de setState tiene que ser PURO (ver useMirror): las llamadas
    // al servidor van FUERA, y por eso se disparan una sola vez por cambio.
    const prev = customApptDataRef.current;
    const next = typeof updater === 'function' ? updater(prev) : updater;
    if (window.__deskteAuth && compApptsLoaded) {
      Promise.resolve().then(() =>
        import("./crm-app/api.js").then(({ updateCarrierApptCustom }) =>
          updateCarrierApptCustom(next).catch(notifySaveFailed("No se pudieron guardar los datos de nombramientos en el servidor", "Couldn't save the carrier-appointment data to the server"))
        ),
      );
    }
    customApptDataRef.current = next;
    setCustomApptData(next);
  };
  const bulkReplaceCarrierAppts = async (appointments, custom) => {
    try {
      const { bulkReplaceCarrierAppointments } = await import("./crm-app/api.js");
      await bulkReplaceCarrierAppointments(appointments, custom);
    } catch (e) {
      import("./crm-app/components/Toast.jsx").then(({ toast }) => toast.error((lang === "es" ? "No se pudo importar: " : "Couldn't import: ") + e.message));
    }
  };
  const [expenses,setExpenses]=useLocalStorage("dkt6_expenses",[]);
  const [expensesLoaded,setExpensesLoaded]=useState(false);
  useEffect(() => {
    if (!currentUser || !window.__deskteAuth || expensesLoaded) return;
    if (!toca_pedir("expenses", view)) return;  // se pide al abrir su modulo
    let cancelled = false;
    import("./crm-app/api.js").then(({ listExpenses }) => listExpenses())
      .then((rows) => {
        if (cancelled) return;
        setExpenses(rows);
        setExpensesLoaded(true);
        console.log("[expenses] hydrated " + rows.length + " from backend");
      })
      .catch((err) => { console.error("[expenses] failed to load from API:", err.message); });
    return () => { cancelled = true; };
  }, [currentUser?.id, expensesLoaded, view]);
  // Server-backed CRUD (was localStorage-only → didn't sync across devices).
  const saveExpenseRow = async (row) => {
    try {
      const { createExpense, updateExpense } = await import("./crm-app/api.js");
      const isExisting = row.id && !String(row.id).startsWith("exp");
      if (isExisting) {
        const u = await updateExpense(row.id, row);
        setExpenses(p => p.map(e => e.id === u.id ? u : e));
      } else {
        const created = await createExpense(row);
        setExpenses(p => [...p.filter(e => e.id !== row.id), created]);
      }
    } catch (e) {
      import("./crm-app/components/Toast.jsx").then(({ toast }) => toast.error((lang === "es" ? "No se pudo guardar el gasto: " : "Couldn't save expense: ") + e.message));
    }
  };
  const deleteExpenseRow = async (id) => {
    try {
      const { deleteExpense } = await import("./crm-app/api.js");
      await deleteExpense(id);
      setExpenses(p => p.filter(e => e.id !== id));
    } catch (e) {
      import("./crm-app/components/Toast.jsx").then(({ toast }) => toast.error((lang === "es" ? "No se pudo eliminar: " : "Couldn't delete: ") + e.message));
    }
  };
  const [calEvents,setCalEvents]=useState([]); // PHI (events may name clients) — see C2
  const [calEventsLoaded, setCalEventsLoaded] = useState(false);
  useEffect(() => {
    if (!currentUser || !window.__deskteAuth || calEventsLoaded) return;
    if (!toca_pedir("calEvents", view)) return;  // se pide al abrir su modulo
    let cancelled = false;
    apiListAppointments()
      .then(({ events: apiEvents }) => {
        if (cancelled) return;
        setCalEvents(apiEvents);
        setCalEventsLoaded(true);
        console.log("[calendar] hydrated " + apiEvents.length + " from backend");
      })
      .catch((err) => {
        console.error("[calendar] failed to load from API, keeping SEED data:", err.message);
      });
    return () => { cancelled = true; };
  }, [currentUser?.id, calEventsLoaded, view]);
  const [leads,setLeads]=useState([]); // PHI (lead has DOB / email / phone) — see C2
  const [leadsLoaded, setLeadsLoaded] = useState(false);
  useEffect(() => {
    if (!currentUser || !window.__deskteAuth || leadsLoaded) return;
    if (!toca_pedir("leads", view)) return;  // se pide al abrir su modulo
    let cancelled = false;
    // Loop ALL pages so the Leads list and conversion metrics aren't truncated.
    (async () => {
      try {
        const all = [];
        const PAGE_SIZE = 500;
        for (let page = 1; page <= 20; page++) {
          const { leads: pageLeads, pagination } = await apiListLeads({ page, limit: PAGE_SIZE });
          if (cancelled) return;
          all.push(...pageLeads);
          if (pageLeads.length < PAGE_SIZE) break;
          if (pagination && page >= (pagination.totalPages || page)) break;
        }
        if (cancelled) return;
        setLeads(all);
        setLeadsLoaded(true);
        console.log("[leads] hydrated " + all.length + " from backend");
      } catch (err) {
        if (!cancelled) console.error("[leads] failed to load from API, keeping SEED data:", err.message);
      }
    })();
    return () => { cancelled = true; };
  }, [currentUser?.id, leadsLoaded, view]);
  // clientNotes useState moved up to the useServerEvents call site (Phase 4)
  // so the note.* SSE handlers have setClientNotes in scope.
  const [notesLoaded, setNotesLoaded] = useState(false);
  useEffect(() => {
    if (!currentUser || !window.__deskteAuth || notesLoaded) return;
    if (!toca_pedir("clientNotes", view)) return;  // se pide al abrir su modulo
    let cancelled = false;
    // Solo las MARCAS (cliente + fecha), no las notas: ver listNoteStamps en
    // crm-app/api.js. Las notas completas las pide la ficha al abrirse.
    apiListNoteStamps()
      .then((marcas) => {
        if (cancelled) return;
        setNoteStamps(marcas);
        setNotesLoaded(true);
        console.log("[notes] hydrated " + marcas.length + " stamps from backend");
      })
      .catch((err) => {
        console.error("[notes] failed to load from API:", err.message);
      });
    return () => { cancelled = true; };
  }, [currentUser?.id, notesLoaded, view]);
  const [eligibilityAlerts,setEligibilityAlerts]=useState([]); // PHI — see C2 note on clients
  const eligibilityAlertsRef = useMirror(eligibilityAlerts);
  const [eligibilityAlertsLoaded,setEligibilityAlertsLoaded]=useState(false);
  useEffect(() => {
    if (!currentUser || !window.__deskteAuth || eligibilityAlertsLoaded) return;
    let cancelled = false;
    import("./crm-app/api.js").then(({ listEligibilityAlerts }) => listEligibilityAlerts())
      .then((rows) => { if (cancelled) return; setEligibilityAlerts(rows); setEligibilityAlertsLoaded(true); })
      .catch((err) => { console.error("[eligAlerts] load failed:", err.message); });
    return () => { cancelled = true; };
  }, [currentUser?.id, eligibilityAlertsLoaded]);
  // Wrapper around setEligibilityAlerts that diffs the next state against
  // the previous one and fires the matching API calls (create / update /
  // delete). This lets the existing `onEligibilityAlertsChange(prev => ...)`
  // callers in EligibilityTab stay untouched. Newly-created rows are
  // patched in-place after the server assigns a real id.
  const handleEligibilityAlertsChange = (updater) => {
    // El updater de setState tiene que ser PURO (ver useMirror): las llamadas
    // al servidor van FUERA, y por eso se disparan una sola vez por cambio.
    const prev = eligibilityAlertsRef.current;
    const prevArr = prev || [];
    const next = typeof updater === 'function' ? updater(prevArr) : updater;
    if (window.__deskteAuth && eligibilityAlertsLoaded) {
      const prevById = new Map(prevArr.map(a => [a.id, a]));
      const nextById = new Map(next.map(a => [a.id, a]));
      Promise.resolve().then(() => import("./crm-app/api.js").then(api => {
        prevArr.forEach(a => { if (!nextById.has(a.id)) api.deleteEligibilityAlert(a.id).catch(notifySaveFailed("No se pudo borrar la alerta de elegibilidad en el servidor", "Couldn't delete the eligibility alert on the server")); });
        next.forEach(a => {
          const old = prevById.get(a.id);
          if (!old) {
            api.createEligibilityAlert(a).then(created => {
              if (created) setEligibilityAlerts(p => { const nx = (p || []).map(x => x.id === a.id ? created : x); eligibilityAlertsRef.current = nx; return nx; });
            }).catch(notifySaveFailed("No se pudo guardar la alerta de elegibilidad en el servidor", "Couldn't save the eligibility alert to the server"));
          } else if (old.status !== a.status || old.deadline !== a.deadline || old.docType !== a.docType || old.notes !== a.notes) {
            api.updateEligibilityAlert(a.id, a).catch(notifySaveFailed("No se pudo actualizar la alerta de elegibilidad en el servidor", "Couldn't update the eligibility alert on the server"));
          }
        });
      }));
    }
    eligibilityAlertsRef.current = next;
    setEligibilityAlerts(next);
  };
  // ── Follow-ups / Seguimiento (gift cards + document submissions) ──
  const [followups,setFollowups]=useState([]);
  const followupsRef = useMirror(followups);
  const [followupsLoaded,setFollowupsLoaded]=useState(false);
  useEffect(() => {
    if (!currentUser || !window.__deskteAuth || followupsLoaded) return;
    let cancelled = false;
    import("./crm-app/api.js").then(({ listFollowups }) => listFollowups())
      .then((rows) => { if (cancelled) return; setFollowups(rows); setFollowupsLoaded(true); })
      .catch((err) => { console.error("[followups] load failed:", err.message); });
    return () => { cancelled = true; };
  }, [currentUser?.id, followupsLoaded]);
  // Diffs next vs prev and fires create / update / delete (same pattern as
  // eligibility alerts). Newly-created rows (temp id "fu_…") are patched with
  // the server id after the create resolves.
  const handleFollowupsChange = (updater) => {
    // El updater de setState tiene que ser PURO (ver useMirror): las llamadas
    // al servidor van FUERA, y por eso se disparan una sola vez por cambio.
    const prev = followupsRef.current;
    const prevArr = prev || [];
    const next = typeof updater === 'function' ? updater(prevArr) : updater;
    if (window.__deskteAuth && followupsLoaded) {
      const prevById = new Map(prevArr.map(a => [a.id, a]));
      const nextById = new Map(next.map(a => [a.id, a]));
      const changedKeys = ['status','title','amount','method','destination','caseRef','clientId','clientName','referrerClientId','referrerName','sentAt','resentAt','respondedAt','dueAt','notes'];
      Promise.resolve().then(() => import("./crm-app/api.js").then(api => {
        prevArr.forEach(a => { if (!nextById.has(a.id)) api.deleteFollowup(a.id).catch(notifySaveFailed("No se pudo borrar el seguimiento en el servidor", "Couldn't delete the follow-up on the server")); });
        next.forEach(a => {
          const old = prevById.get(a.id);
          if (!old) {
            api.createFollowup(a).then(created => {
              if (created) setFollowups(p => { const nx = (p || []).map(x => x.id === a.id ? created : x); followupsRef.current = nx; return nx; });
            }).catch(notifySaveFailed("No se pudo guardar el seguimiento en el servidor", "Couldn't save the follow-up to the server"));
          } else if (changedKeys.some(k => old[k] !== a[k])) {
            api.updateFollowup(a.id, a).catch(notifySaveFailed("No se pudo actualizar el seguimiento en el servidor", "Couldn't update the follow-up on the server"));
          }
        });
      }));
    }
    followupsRef.current = next;
    setFollowups(next);
  };
  const fuOverdue = useMemo(() => countOverdueFollowups(followups), [followups]);
  // ── Appointments / "Citas" ──
  const [appointments,setAppointments]=useState([]);
  const [appointmentsLoaded,setAppointmentsLoaded]=useState(false);
  useEffect(() => {
    // Demo included — crm-app/demoApi.js serves /api/v1/appointments so the
    // Citas module is populated instead of showing its empty state.
    if (!currentUser || (!window.__deskteAuth && !IS_DEMO) || appointmentsLoaded) return;
    let cancelled = false;
    import("./crm-app/api.js").then(({ listCitas }) => listCitas())
      .then((rows) => { if (cancelled) return; setAppointments(rows); setAppointmentsLoaded(true); })
      .catch((err) => { console.error("[appointments] load failed:", err.message); });
    return () => { cancelled = true; };
  }, [currentUser?.id, appointmentsLoaded]);
  // ── Tickets (customer-service cases) ──
  const [tickets,setTickets]=useState([]);
  const [ticketsLoaded,setTicketsLoaded]=useState(false);
  useEffect(() => {
    if (!currentUser || !window.__deskteAuth || ticketsLoaded) return;
    let cancelled = false;
    import("./crm-app/api.js").then(({ listTickets }) => listTickets())
      .then((rows) => { if (cancelled) return; setTickets(rows); setTicketsLoaded(true); })
      .catch((err) => { console.error("[tickets] load failed:", err.message); });
    return () => { cancelled = true; };
  }, [currentUser?.id, ticketsLoaded]);
  const saveTicket = async (payload) => {
    const { createTicket, updateTicket } = await import("./crm-app/api.js");
    const isExisting = payload.id && !String(payload.id).startsWith("tk_");
    if (isExisting) {
      const u = await updateTicket(payload.id, payload);
      setTickets(p => p.map(t => t.id === u.id ? u : t));
      return u;
    }
    const created = await createTicket(payload);
    setTickets(p => [created, ...p.filter(t => t.id !== payload.id)]);
    return created;
  };
  const addTicketMsg = async (id, body, internal, attachments) => {
    const { addTicketMessage } = await import("./crm-app/api.js");
    const u = await addTicketMessage(id, { body, internal, attachments: attachments && attachments.length ? attachments : undefined, authorName: currentUser?.displayName || currentUser?.name || "" });
    setTickets(p => p.map(t => t.id === u.id ? u : t));
    return u;
  };
  // Corregir / retirar un mensaje del hilo (ticket de Francisco Picado,
  // 2026-08-25). El servidor guarda el texto original en `originalBody` y solo
  // deja hacerlo al autor; aqui solo se refresca la fila.
  const editTicketMsg = async (id, msgId, body) => {
    const { editTicketMessage } = await import("./crm-app/api.js");
    const u = await editTicketMessage(id, msgId, body);
    setTickets(p => p.map(t => t.id === u.id ? u : t));
    return u;
  };
  const deleteTicketMsg = async (id, msgId) => {
    const { deleteTicketMessage } = await import("./crm-app/api.js");
    const u = await deleteTicketMessage(id, msgId);
    setTickets(p => p.map(t => t.id === u.id ? u : t));
    return u;
  };
  const deleteTicketRow = async (id) => {
    const { deleteTicket } = await import("./crm-app/api.js");
    await deleteTicket(id);
    setTickets(p => p.filter(t => t.id !== id));
  };
  // Phase 3: send a client email for a ticket (acknowledgement / resolution).
  const notifyTicketClientRow = async (id, payload) => {
    const { notifyTicketClient } = await import("./crm-app/api.js");
    const res = await notifyTicketClient(id, payload);
    if (res?.data) setTickets(p => p.map(t => t.id === res.data.id ? res.data : t));
    return res;
  };
  // Load a client's documents for the "attach" picker in the email modal.
  const loadClientDocsForTicket = async (cid) => {
    const { listDocuments } = await import("./crm-app/api.js");
    const { documents } = await listDocuments({ clientId: cid });
    return documents || [];
  };
  // Re-pull the CRM datasets a Sheet can source from (clients/policies/users/
  // licenses) from the server, for the "Actualizar" button in Hojas (Lissette
  // 2026-07-28: una hoja de datos usa la lista en memoria, que solo se carga al
  // entrar; este botón la refresca a demanda). Returns a promise so the button
  // can show a spinner; the data-sheet rows recompute once the props update.
  //
  // ── DE 3 EN 3, NO LAS 67 DE GOLPE (2026-09-03) ──────────────────────────
  //
  // Este boton pedia la pagina 1 de cada libro y luego TODAS las que faltaban
  // con un `Promise.all`: 30 paginas de polizas + 37 de clientes = 67
  // consultas pesadas en el mismo segundo. Medido en produccion ese dia a las
  // 21:30, arranco `policies?page=1&limit=500` y todo lo demas -actividad,
  // licencias, alertas, plantillas, presencia- termino **9 segundos despues**,
  // todo en el mismo instante. Es una cola, y la pagan los agentes que no
  // apretaron nada: a ellos les sale "Cargando...".
  //
  // El arreglo ya existia y a este sitio se le olvido: el arranque pasa por
  // `enTandas` desde el 2026-09-02 y este camino no. Es la regla de oro 118 —
  // cuando una funcion tiene dos caminos, arreglar uno no es arreglarla.
  //
  // Se trae EXACTAMENTE lo mismo: las 67 paginas, todos los clientes y todas
  // las polizas. Lo unico que cambia es que salen en fila.
  //
  // Las paginas de los DOS libros van por un SOLO limitador a proposito: con
  // uno por libro serian 3 + 3 = 6 encima del servidor.
  //
  const refreshSheetsData = async () => {
    const api = await import("./crm-app/api.js");
    const PAGE = 500;
    const arrancado = Date.now();

    // Primero la pagina 1 de cada libro, para saber cuantas hay. Son dos: caben
    // de sobra bajo el techo.
    const primeras = await enTandas([
      () => api.listClients({ page: 1, limit: PAGE }).catch(() => null),
      () => api.listPolicies({ page: 1, limit: PAGE }).catch(() => null),
    ], ANCHO_DE_HOJAS);

    const libros = [
      { fn: api.listClients, key: "clients", primera: primeras[0] },
      { fn: api.listPolicies, key: "policies", primera: primeras[1] },
    ];
    const trozos = new Map();
    const tareas = [];
    for (const libro of libros) {
      // Si la pagina 1 fallo, ese libro se queda como estaba en pantalla en vez
      // de vaciarse: media lista es peor que la lista de antes.
      if (!libro.primera) continue;
      trozos.set(libro.key, [...(libro.primera[libro.key] || [])]);
      const total = Math.min(100, (libro.primera.pagination && libro.primera.pagination.totalPages) || 1);
      for (let p = 2; p <= total; p++) {
        const pagina = p;
        tareas.push(async () => {
          const r = await libro.fn({ page: pagina, limit: PAGE }).catch(() => null);
          return { key: libro.key, filas: (r && r[libro.key]) || [] };
        });
      }
    }

    // `enTandas` devuelve EN ORDEN, asi que las paginas se pegan como venian y
    // el listado no sale barajado.
    const resto = await enTandas(tareas, ANCHO_DE_HOJAS);
    for (const r of resto) if (r && trozos.has(r.key)) trozos.get(r.key).push(...r.filas);

    const cl = trozos.get("clients");
    const po = trozos.get("policies");
    if (Array.isArray(cl)) setClients(cl);
    if (Array.isArray(po)) setPolicies(po);
    try { const u = await api.listUsers(); if (Array.isArray(u)) setUsers(u); } catch {}
    try { const l = await api.listLicenses(); if (Array.isArray(l)) setLicenses(l); } catch {}

    // EL CRONOMETRO. Sin este numero, "de 3 en 3" es una suposicion: cuanto
    // tarda una pagina SOLA no esta medido en ninguna parte. La primera vez que
    // se aprieta el boton queda medido de verdad, y si tardara demasiado se
    // sube el ancho en crm-app/enTandas.js. Solo numeros: ni un nombre, ni un
    // dato de nadie.
    return { paginas: 2 + tareas.length, ms: Date.now() - arrancado };
  };
  const ticketsOpen = useMemo(() => countOpenTickets(tickets), [tickets]);
  const [resources,setResources]=useLocalStorage("dkt6_resources",[]);
  const [resourceTokens,setResourceTokens]=useLocalStorage("dkt6_resource_tokens",[]);
  const [resourcesLoaded,setResourcesLoaded]=useState(false);
  useEffect(() => {
    if (!currentUser || !window.__deskteAuth || resourcesLoaded) return;
    if (!toca_pedir("resources", view)) return;  // se pide al abrir su modulo
    let cancelled = false;
    import("./crm-app/api.js").then(async ({ listResources, listResourceTokens }) => {
      const [res, toks] = await Promise.all([listResources(), listResourceTokens()]);
      if (cancelled) return;
      setResources(res);
      setResourceTokens(toks);
      setResourcesLoaded(true);
      console.log("[resources] hydrated " + res.length + " resources / " + toks.length + " tokens from backend");
    }).catch((err) => { console.error("[resources] failed to load from API:", err.message); });
    return () => { cancelled = true; };
  }, [currentUser?.id, resourcesLoaded, view]);
  // Server-backed CRUD (was localStorage-only → didn't sync / wasn't shared).
  const saveResourceRow = async (row) => {
    try {
      const { createResource, updateResource } = await import("./crm-app/api.js");
      const isExisting = row.id && !String(row.id).startsWith("res_");
      if (isExisting) {
        const u = await updateResource(row.id, row);
        setResources(p => p.map(r => r.id === u.id ? u : r));
      } else {
        const created = await createResource(row);
        setResources(p => [...p.filter(r => r.id !== row.id), created]);
      }
    } catch (e) {
      import("./crm-app/components/Toast.jsx").then(({ toast }) => toast.error((lang === "es" ? "No se pudo guardar el recurso: " : "Couldn't save resource: ") + e.message));
    }
  };
  const deleteResourceRow = async (id) => {
    try {
      const { deleteResource } = await import("./crm-app/api.js");
      await deleteResource(id);
      setResources(p => p.filter(r => r.id !== id));
    } catch (e) {
      import("./crm-app/components/Toast.jsx").then(({ toast }) => toast.error((lang === "es" ? "No se pudo eliminar: " : "Couldn't delete: ") + e.message));
    }
  };
  // Devuelve lo que guardó el SERVIDOR, no lo que le mandó la pantalla: desde
  // la auditoría del 2026-08-23 el token lo acuña el backend, así que quien
  // pide un enlace tiene que usar el que le contesten (E-118). Devolver []
  // en el fallo es deliberado: la pantalla no pinta un enlace inventado.
  const createResourceTokensRow = async (tokens) => {
    try {
      const { createResourceTokens } = await import("./crm-app/api.js");
      const saved = await createResourceTokens(tokens);
      setResourceTokens(p => {
        const known = new Set(p.map(t => t.token));
        return [...p, ...saved.filter(t => !known.has(t.token))];
      });
      return saved;
    } catch (e) {
      import("./crm-app/components/Toast.jsx").then(({ toast }) => toast.error((lang === "es" ? "No se pudo crear el enlace: " : "Couldn't create portal link: ") + e.message));
      return [];
    }
  };
  const [holidayTemplates,setHolidayTemplates]=useLocalStorage("dkt6_holidays",US_HOLIDAYS);
  const [emailTemplates,setEmailTemplates]=useLocalStorage("dkt6_email_templates",EMAIL_TEMPLATE_DEFAULTS);
  const [customTemplates,setCustomTemplates]=useLocalStorage("dkt6_custom_templates",[]);
  const customTemplatesRef = useMirror(customTemplates);
  const [customTemplatesLoaded,setCustomTemplatesLoaded]=useState(false);
  useEffect(() => {
    if (!currentUser || !window.__deskteAuth || customTemplatesLoaded) return;
    let cancelled = false;
    import("./crm-app/api.js").then(({ listEmailTpl }) => listEmailTpl())
      .then((rows) => { if (cancelled) return; if (rows.length) setCustomTemplates(rows); setCustomTemplatesLoaded(true); })
      .catch((err) => { console.error("[emailTpl] load failed:", err.message); });
    return () => { cancelled = true; };
  }, [currentUser?.id, customTemplatesLoaded]);
  const handleCustomTemplatesChange = (updater) => {
    // El updater de setState tiene que ser PURO (ver useMirror): las llamadas
    // al servidor van FUERA, y por eso se disparan una sola vez por cambio.
    const prev = customTemplatesRef.current;
    const prevArr = prev || [];
    const next = typeof updater === 'function' ? updater(prevArr) : updater;
    if (window.__deskteAuth && customTemplatesLoaded) {
      const prevById = new Map(prevArr.map(t => [t.id, t]));
      const nextById = new Map(next.map(t => [t.id, t]));
      Promise.resolve().then(() => import("./crm-app/api.js").then(api => {
        prevArr.forEach(t => { if (!nextById.has(t.id)) api.deleteEmailTpl(t.id).catch(() => null); });
        next.forEach(t => {
          const old = prevById.get(t.id);
          if (!old) {
            api.createEmailTpl(t).then(created => {
              if (created) setCustomTemplates(p => { const nx = (p || []).map(x => x.id === t.id ? created : x); customTemplatesRef.current = nx; return nx; });
            }).catch((err) => {
              // Saving is sacred — never fail silently. Surface it so the
              // template isn't silently lost on the next reload.
              import("./crm-app/components/Toast.jsx").then(({ toast }) => toast.error((lang === "es" ? "No se pudo guardar la plantilla en el servidor: " : "Couldn't save template to server: ") + (err?.message || ""))).catch(() => {});
            });
          } else if (JSON.stringify(old) !== JSON.stringify(t)) {
            api.updateEmailTpl(t.id, t).catch((err) => {
              import("./crm-app/components/Toast.jsx").then(({ toast }) => toast.error((lang === "es" ? "No se pudo actualizar la plantilla: " : "Couldn't update template: ") + (err?.message || ""))).catch(() => {});
            });
          }
        });
      }));
    }
    customTemplatesRef.current = next;
    setCustomTemplates(next);
  };
  // Invoices — used to live in localStorage (each view called
  // useLocalStorage('dkt6_invoices') directly). That meant Reports &
  // Analytics + Dashboard KPIs always read $0 even when the agency had
  // invoices on the server. Hoisted here so all 3 consumers share one
  // server-hydrated source of truth.
  const [invoices, setInvoices] = useState([]); // PHI (client name + amount) — see C2
  const invoicesRef = useMirror(invoices);
  const [invoicesLoaded, setInvoicesLoaded] = useState(false);
  useEffect(() => {
    // IS_DEMO has no MSAL (no window.__deskteAuth) but crm-app/demoApi.js
    // answers /api/v1/invoices from memory, so the demo hydrates the same way
    // a real account does and the Invoices module is fully usable.
    if (!currentUser || (!window.__deskteAuth && !IS_DEMO) || invoicesLoaded) return;
    let cancelled = false;
    import('./crm-app/api.js').then(({ listInvoices }) => listInvoices())
      .then((rows) => {
        if (cancelled) return;
        setInvoices(rows);
        setInvoicesLoaded(true);
        console.log('[invoices] hydrated ' + rows.length + ' from backend');
      })
      .catch((err) => { console.error('[invoices] load failed:', err.message); });
    return () => { cancelled = true; };
  }, [currentUser?.id, invoicesLoaded]);
  // Diff-wrapper: detects add/update/delete on the invoices array and
  // calls the matching API. Invoices have nested arrays (payments) — for
  // updates we just send the whole invoice; the backend treats PUT as a
  // full replace of the editable fields.
  const handleInvoicesChange = (updater) => {
    // El updater de setState tiene que ser PURO (ver useMirror): las llamadas
    // al servidor van FUERA, y por eso se disparan una sola vez por cambio.
    const prev = invoicesRef.current;
    const prevArr = prev || [];
    const next = typeof updater === 'function' ? updater(prevArr) : updater;
    if ((window.__deskteAuth || IS_DEMO) && invoicesLoaded) {
      const prevById = new Map(prevArr.map((x) => [x.id, x]));
      const nextById = new Map(next.map((x) => [x.id, x]));
      Promise.resolve().then(() => import('./crm-app/api.js').then((api) => {
        prevArr.forEach((x) => {
          if (!nextById.has(x.id)) api.deleteInvoice(x.id).catch(notifySaveFailed("No se pudo borrar la factura en el servidor", "Couldn't delete the invoice on the server"));
        });
        next.forEach((x) => {
          const old = prevById.get(x.id);
          if (!old) {
            api.createInvoice(x).then((created) => {
              if (!created) return;
              // Swap the temp id for the backend row, then collapse any
              // duplicate the SSE 'invoice.created' echo may have inserted
              // first (feedback_sse_echo_dedup_optimistic_add).
              setInvoices((p) => {
                const replaced = (p || []).map((y) => y.id === x.id ? created : y);
                const seen = new Set();
                return replaced.filter((y) => { if (seen.has(y.id)) return false; seen.add(y.id); return true; });
              });
            }).catch(notifySaveFailed("No se pudo guardar la factura en el servidor", "Couldn't save the invoice to the server"));
          } else if (JSON.stringify(old) !== JSON.stringify(x)) {
            api.updateInvoice(x.id, x).catch(notifySaveFailed("No se pudo actualizar la factura en el servidor", "Couldn't update the invoice on the server"));
          }
        });
      }));
    }
    invoicesRef.current = next;
    setInvoices(next);
  };
  // Per-agency settings blob (docTemplatesMaster + emailTemplates +
  // holidayCalendar): used to be browser-localStorage so every agent on
  // every browser saw the seed and lost the agency's customizations.
  // Agency-shared custom client-tab DEFINITIONS [{id,label,fields:[{id,label}]}].
  // Defined once (from any client's ficha) → appear on every client. Per-client
  // VALUES live on each client as `customValues`. Hydrated/persisted with the
  // rest of the agency settings below.
  const [customTabDefs,setCustomTabDefs]=useState([]);
  // Shared "collaborating agents" [{name,lastName,npn}] — agency-wide so the
  // agent AND every seat see/edit the SAME list (Lissette 2026-06-19 #4). Was
  // per-user (userPrefs.collaborators); now lives in AgencySetting.collaborators.
  const [agencyCollaborators,setAgencyCollaborators]=useState([]);
  // Shared client tag colors { tagName(lowercase): "#rrggbb" } — agency-wide so
  // the SAME tag reads the SAME fluorescent color for the agent and every seat
  // (Lissette 2026-06-20). The tag itself stays a plain string on Client.tags.
  const [agencyTagColors,setAgencyTagColors]=useState({});
  // The agency's tag CATALOG (string[] of names). Feeds the "reuse a tag" chips
  // in the client tag panel. Kept apart from the tags actually on clients so a
  // tag survives losing its last client — that list used to be computed from
  // Client.tags, so removing the tag from its only client erased it and it had
  // to be retyped (Lissette 2026-08-10).
  const [agencyTagLibrary,setAgencyTagLibrary]=useState([]);
  // Etiquetas de PÓLIZA: catálogo y colores propios, separados de los de cliente
  // a petición expresa (Lissette 2026-08-15). Una etiqueta de póliza describe la
  // póliza ("pendiente de firma"), no a la persona.
  const [policyTagLibrary,setPolicyTagLibrary]=useState([]);
  const [policyTagColors,setPolicyTagColors]=useState({});
  // "Atiende" seat labels { [seatUserId]: { name, color } } + ticket
  // customization (statuses / request types), agency-wide.
  const [seatLabels,setSeatLabels]=useState({});
  const [ticketStatuses,setTicketStatuses]=useState([]);
  const [appointmentFieldDefs,setAppointmentFieldDefs]=useState({}); // Citas: { [policyTypeId]: string[] } custom field labels, shared per agency
  const [ticketTypes,setTicketTypes]=useState([]);
  // Tickets Phase 3: editable client-email templates { enabled, subject*, body* }.
  const [ticketEmailOnOpen,setTicketEmailOnOpen]=useState({});
  const [ticketEmailOnResolve,setTicketEmailOnResolve]=useState({});
  // Display name for the agency's conversational AI (Deskte AI by default).
  const [aiName,setAiName]=useState("Deskte AI");
  // Con cuánta antelación avisa cada alerta, PARA TODA LA AGENCIA. Vivían en
  // las preferencias de cada persona hasta el 2026-08-28; ahora son una sola y
  // solo el dueño las cambia. Ver `conPlazosDeLaAgencia` en crm-app/utils.js.
  const [agencyAlertLead,setAgencyAlertLead]=useState({});
  const [agencyAlertLeadByType,setAgencyAlertLeadByType]=useState({});
  // El orden del nombre del cliente, de la AGENCIA desde 2026-09-15. `null` no
  // es un valor: es "la agencia no lo ha fijado", y entonces manda la
  // preferencia de cada persona (ver ordenDeNombreQueManda en utils.js).
  const [agencyNameOrder,setAgencyNameOrder]=useState(null);
  const [agencySettingsLoaded,setAgencySettingsLoaded]=useState(false);
  // Cuántas veces se ha intentado cargar los ajustes de la agencia. Entra en las
  // dependencias del efecto para que un fallo pueda REINTENTAR — ver el catch.
  const [agencySettingsTry,setAgencySettingsTry]=useState(0);
  useEffect(() => {
    if (!currentUser || !window.__deskteAuth || agencySettingsLoaded) return;
    let cancelled = false;
    let reintento = null;
    const intento = agencySettingsTry;
    import("./crm-app/api.js").then(({ getAgencySettings }) => getAgencySettings())
      .then((s) => {
        if (cancelled) return;
        if (s.docTemplatesMaster && Object.keys(s.docTemplatesMaster).length) setDocTemplatesMaster(s.docTemplatesMaster);
        if (Array.isArray(s.emailTemplates) && s.emailTemplates.length) setEmailTemplates(s.emailTemplates);
        if (Array.isArray(s.holidayCalendar) && s.holidayCalendar.length) setHolidayTemplates(s.holidayCalendar);
        if (Array.isArray(s.customTabDefs)) setCustomTabDefs(s.customTabDefs);
        // Shared collaborators (#4) — the SERVER is the single source of truth.
        // A one-time backfill already seeded every agency's list from members'
        // legacy per-user lists, so we do NOT re-migrate from uiPrefs here:
        // doing so would RESURRECT a collaborator the user just removed on the
        // next load (the legacy per-user copy lingers).
        setAgencyCollaborators(Array.isArray(s.collaborators) ? s.collaborators : []);
        // Los status de renovación propios: los Paneles de Reportes los nombran
        // aunque no se haya abierto Renovaciones (crm-app/estatusDeRenovacion.js).
        recordarEstatusPropiosDeRenovacion(s.renewalStatuses);
        if (s.tagColors && typeof s.tagColors === "object" && !Array.isArray(s.tagColors)) setAgencyTagColors(s.tagColors);
        if (Array.isArray(s.tagLibrary)) setAgencyTagLibrary(s.tagLibrary);
        if (Array.isArray(s.policyTagLibrary)) setPolicyTagLibrary(s.policyTagLibrary);
        if (s.policyTagColors && typeof s.policyTagColors === 'object') setPolicyTagColors(s.policyTagColors);
        if (s.seatLabels && typeof s.seatLabels === "object" && !Array.isArray(s.seatLabels)) setSeatLabels(s.seatLabels);
        if (Array.isArray(s.ticketStatuses)) setTicketStatuses(s.ticketStatuses);
        if (Array.isArray(s.ticketTypes)) setTicketTypes(s.ticketTypes);
        if (s.ticketEmailOnOpen && typeof s.ticketEmailOnOpen === "object" && !Array.isArray(s.ticketEmailOnOpen)) setTicketEmailOnOpen(s.ticketEmailOnOpen);
        if (s.ticketEmailOnResolve && typeof s.ticketEmailOnResolve === "object" && !Array.isArray(s.ticketEmailOnResolve)) setTicketEmailOnResolve(s.ticketEmailOnResolve);
        if (s.aiAssistantName) setAiName(s.aiAssistantName);
        // Se asignan SIEMPRE, también cuando vienen vacíos: vacío significa
        // "usa los valores de fábrica", que es una respuesta, no una falta de
        // respuesta. Con un `if (…length)` como el de arriba, una agencia que
        // borrara sus plazos se quedaría con los de la carga anterior.
        if (s.alertLead && typeof s.alertLead === "object" && !Array.isArray(s.alertLead)) setAgencyAlertLead(s.alertLead);
        if (s.alertLeadByType && typeof s.alertLeadByType === "object" && !Array.isArray(s.alertLeadByType)) setAgencyAlertLeadByType(s.alertLeadByType);
        // Solo los dos que existen: cualquier otra cosa se trata como "sin
        // fijar", que es lo que devuelve a cada persona su preferencia.
        setAgencyNameOrder(s.nameOrder === "first-last" || s.nameOrder === "last-first" ? s.nameOrder : null);
        // Agency-defined custom policy statuses → shared catalog module so the
        // PolicyForm dropdown and PolicyCard badge pick them up everywhere.
        if (Array.isArray(s.policyStatuses)) {
          import("./crm-app/policyStatuses.js").then(({ setCustomPolicyStatuses }) => setCustomPolicyStatuses(s.policyStatuses)).catch(() => {});
        }
        // Estados propios del PAGO del mes. NO se ofrecen como estado de póliza:
        // se registran para que una póliza marcada con uno de ellos antes de
        // separar los dos mundos siga mostrando su nombre y su color.
        // Marketplaces propios de la agencia → catálogo compartido, para que el
        // desplegable de la póliza los tenga desde el arranque y no solo
        // después de entrar en Pagos del Mes.
        if (Array.isArray(s.marketplaces)) {
          import("./crm-app/components/PoliciesView.jsx").then(({ setAgencyMarketplaces }) => setAgencyMarketplaces(s.marketplaces)).catch(() => {});
        }
        // Motivos de cancelacion propios de la agencia (Lissette 2026-09-19:
        // "que puedan escribir mas y que se vaya quedando en el drop down").
        // Se asigna SIEMPRE, tambien vacio: vacio es "solo los de fabrica", y
        // no asignarlo dejaria los de la agencia ANTERIOR en memoria al
        // cambiar de sesion o al entrar como otra agencia.
        import("./crm-app/motivosDeCancelacion.js")
          .then(({ setMotivosDeAgencia }) => setMotivosDeAgencia(Array.isArray(s.cancelReasons) ? s.cancelReasons : []))
          .catch(() => {});
        // Origenes del lead propios de la agencia (Lissette 2026-08-28). Se
        // asigna SIEMPRE, tambien vacio: vacio significa "solo los de fabrica",
        // que es una respuesta y no una falta de respuesta.
        if (Array.isArray(s.leadSources)) {
          import("./crm-app/leadSources.js").then(({ setAgencyLeadSources }) => setAgencyLeadSources(s.leadSources)).catch(() => {});
        }
        // Los estatus migratorios que se inventó la agencia. Sin esto, el que
        // alguien escribió ayer sale hoy como su id crudo.
        if (Array.isArray(s.immigrationStatuses)) setAgencyEstatusMigratorios(s.immigrationStatuses);
        if (Array.isArray(s.paymentStatuses)) {
          import("./crm-app/policyStatuses.js").then(({ setPaymentStatusCatalog }) => setPaymentStatusCatalog(s.paymentStatuses)).catch(() => {});
        }
        // Agency-shared custom-field DEFINITIONS per policy type → catalog
        // module so PolicyForm surfaces the same field names on every policy of
        // a type, for every client (values stay per-policy).
        if (s.policyCustomFieldDefs && typeof s.policyCustomFieldDefs === "object") {
          import("./crm-app/policyCustomFields.js").then(({ setPolicyCustomFieldDefs }) => setPolicyCustomFieldDefs(s.policyCustomFieldDefs)).catch(() => {});
        }
        // Citas: agency-shared EXTRA appointment fields per policy type.
        if (s.appointmentFieldDefs && typeof s.appointmentFieldDefs === "object" && !Array.isArray(s.appointmentFieldDefs)) setAppointmentFieldDefs(s.appointmentFieldDefs);
        // Custom policy TYPES — now server-backed (AgencySetting.policyTypes),
        // shared across devices/team. One-time migration: if the server has
        // none but this browser still holds legacy localStorage types, push
        // them up so nothing the agent created is lost.
        import("./crm-app/policyTypes.js").then((m) => {
          const serverTypes = Array.isArray(s.policyTypes) ? s.policyTypes : [];
          const legacy = m.legacyLocalCustomTypes ? m.legacyLocalCustomTypes() : [];
          if (serverTypes.length === 0 && legacy.length) {
            m.setCustomPolicyTypes(legacy);
            import("./crm-app/api.js").then(({ updateAgencySettings }) => updateAgencySettings({ policyTypes: legacy }).catch(() => {})).catch(() => {});
          } else {
            m.setCustomPolicyTypes(serverTypes);
          }
        }).catch(() => {});
        setAgencySettingsLoaded(true);
        console.log("[agencySettings] hydrated from backend");
      })
      .catch((err) => {
        if (cancelled) return;
        console.error("[agencySettings] failed to load from API:", err.message);
        // Este catch solo escribía en la consola, y era el fallo más caro del
        // arranque: si esta llamada no vuelve, NADA de lo de arriba se aplica
        // —tipos de póliza personalizados, marketplaces, estados de pago,
        // campos propios de póliza y de cita, catálogos de etiquetas, estados
        // y tipos de ticket, el nombre de la IA—. Y como `agencySettingsLoaded`
        // se queda en false y el efecto solo depende de eso y del usuario, no
        // se reintentaba NUNCA: la sesión entera seguía degradada.
        //
        // Lo que se ve entonces no parece un error de carga, parece que la
        // agencia no tiene esas cosas: en Pólizas desaparecen las pestañas de
        // los ramos propios y sus pólizas solo salen bajo "Todas" (Lissette
        // 2026-08-24, viendo la cuenta de Javier Volcanes justo después del
        // parpadeo de un despliegue). Un dato que no cargó no puede parecer un
        // dato que no existe.
        if (intento < 3) {
          reintento = setTimeout(() => setAgencySettingsTry((n) => n + 1), 2000 * (intento + 1));
          return;
        }
        toast.error(lang === "es"
          ? "No se pudieron cargar los ajustes de tu agencia (tipos de póliza, marketplaces, etiquetas). Recarga la página: mientras tanto algunas pestañas y listas salen incompletas."
          : "Could not load your agency settings (policy types, marketplaces, tags). Reload the page — until then some tabs and lists will look incomplete.");
      });
    return () => { cancelled = true; if (reintento) clearTimeout(reintento); };
  }, [currentUser?.id, agencySettingsLoaded, agencySettingsTry]);
  // Debounced sync of changes back to the server — ONLY the keys the user
  // actually changed.
  //
  // "Skipped until hydration completes" was never enough: React commits the
  // hydrated values AND `agencySettingsLoaded` in the same render, so the first
  // post-hydration pass ran and PUT the server's own blob straight back on
  // EVERY page load. `seatLabels` / `ticketEmailOnOpen` / `ticketEmailOnResolve`
  // are not in SEAT_EDITABLE_SETTING_KEYS, so that echo always reached the
  // agent-or-above PUT /agency-settings and 403'd for every SEAT — a red
  // "no tienes permiso para editarla. Pídeselo a tu agente." on the dashboard,
  // over something the user never touched (reported 2026-08-03).
  // The baseline ref below records what came down from the server and diffs
  // against it, so a quiet load sends nothing and a seat editing ticket
  // statuses sends ticketStatuses alone (seat-writable → 200).
  const agencyBlobBase = useRef();
  useEffect(() => {
    if (!agencySettingsLoaded || !window.__deskteAuth) return;
    // Same PLATFORM_OWNER guard the collaborators / tag-colors / custom-tab-defs
    // twins already carry (#1454): the founder has no agency of its own, so this
    // blob splits into a 400 no_agency on /seat-config AND a 403 on the
    // agent-or-above PUT /agency-settings. The no_agency half is swallowed below
    // but the 403 half toasted "no tienes permiso... pídeselo a tu agente" at the
    // OWNER, on every Platform Admin edit (Lissette 2026-08-03). Skip the save
    // unless actually browsing AS an agency.
    let _imp = false;
    try { _imp = !!leerEntrada("deskte:impersonateAgencyId"); } catch {}
    if (currentUser?.isPlatformOwner && !_imp) return;
    const payload = {
      docTemplatesMaster,
      emailTemplates,
      holidayCalendar: holidayTemplates,
      seatLabels,
      ticketStatuses,
      ticketTypes,
      ticketEmailOnOpen,
      ticketEmailOnResolve,
    };
    // First pass after hydration = the server's own values coming back. Record
    // them as the baseline and send nothing.
    if (!agencyBlobBase.current) {
      const base = {};
      for (const k of Object.keys(payload)) base[k] = agencyCfgSig(payload[k]);
      agencyBlobBase.current = base;
      return;
    }
    const changed = {};
    const changedSigs = {};
    for (const k of Object.keys(payload)) {
      const sig = agencyCfgSig(payload[k]);
      if (sig === null || sig !== agencyBlobBase.current[k]) { changed[k] = payload[k]; changedSigs[k] = sig; }
    }
    if (!Object.keys(changed).length) return;
    const t = setTimeout(() => {
      import("./crm-app/api.js").then(({ updateAgencySettings }) => updateAgencySettings(changed))
      // Only move the baseline forward on a confirmed save, so a failed one is
      // retried with the next edit instead of being forgotten.
      .then(() => { Object.assign(agencyBlobBase.current, changedSigs); })
      .catch((err) => {
        const msg = err?.message || String(err);
        console.warn("[agencySettings] blob save failed:", msg);
        // Same surfacing rules as the custom-tab-defs save below: a
        // console.warn is invisible to a non-developer, and this blob carries
        // ticket statuses/types, seat labels, holiday + email templates and
        // the doc-template master — a silent 403 meant the user saw their
        // change on screen and it vanished on reload (audit 2026-07-31).
        if (/no_agency|has no agency/i.test(msg)) return;
        const denied = /\b403\b|forbidden|permission/i.test(msg);
        import("./crm-app/components/Toast.jsx").then(({ toast }) => toast.error(lang === "es"
          ? (denied
              ? "No se pudo guardar la configuración de la agencia: no tienes permiso para editarla. Pídeselo a tu agente."
              : "No se pudo guardar la configuración de la agencia. Vuelve a intentarlo.")
          : (denied
              ? "Couldn't save the agency settings: you don't have permission to edit them. Ask your agent."
              : "Couldn't save the agency settings. Please try again."))).catch(() => {});
      });
    }, 800);
    return () => clearTimeout(t);
  }, [agencySettingsLoaded, docTemplatesMaster, emailTemplates, holidayTemplates, seatLabels, ticketStatuses, ticketTypes, ticketEmailOnOpen, ticketEmailOnResolve]);
  // Debounced sync of the shared custom client-tab DEFINITIONS to their OWN
  // (seat-writable) endpoint — split out of the agent-or-above blob above so a
  // SEAT with clients.edit can create custom tabs. Before this split the whole
  // blob PUT 403'd for seats and the new tab silently vanished on refresh
  // (Lissette 2026-07-01).
  // The endpoint still requires clients.edit, so a seat with only clients.view
  // gets a 403 here — and a console.error is invisible to a non-developer. The
  // seat saw the tab on screen (local state), then it vanished on reload with
  // no explanation (reported 2026-07-21). Surface it as a toast so they know
  // to ask their agent for the permission instead of retrying forever.
  // ...which made the load-time echo (see the blob above) toast that same
  // permission error at a view-only seat on EVERY page load. Same baseline ref
  // fix: the first post-hydration pass records what the server sent and saves
  // nothing.
  const agencyTabDefsBase = useRef();
  useEffect(() => {
    if (!agencySettingsLoaded || !window.__deskteAuth) return;
    // PLATFORM_OWNER (Deskte founder) has no agency of its own, so this
    // agency-scoped save returns 400 no_agency and the toast below scared the
    // founder with a false "Couldn't save the custom tab" on Platform Admin
    // (Lissette 2026-07-24). Skip entirely unless browsing AS an agency.
    let _imp = false;
    try { _imp = !!leerEntrada("deskte:impersonateAgencyId"); } catch {}
    if (currentUser?.isPlatformOwner && !_imp) return;
    const sig = agencyCfgSig(customTabDefs);
    if (agencyTabDefsBase.current === undefined) { agencyTabDefsBase.current = sig; return; }
    if (sig !== null && sig === agencyTabDefsBase.current) return;
    const t = setTimeout(() => {
      import("./crm-app/api.js").then(({ updateAgencyCustomTabDefs }) => updateAgencyCustomTabDefs(customTabDefs))
        .then(() => { agencyTabDefsBase.current = sig; })
        .catch((err) => {
          const msg = err?.message || String(err);
          console.error("[agencySettings] custom-tab-defs save failed:", msg);
          // no_agency is expected for a context without a real agency — never a
          // user-actionable error, so don't toast it.
          if (/no_agency|has no agency/i.test(msg)) return;
          const denied = /\b403\b|forbidden|permission/i.test(msg);
          toast.error(lang === "es"
            ? (denied
                ? "No se pudo guardar la pestaña personalizada: te falta el permiso de editar clientes. Pídeselo a tu agente."
                : "No se pudo guardar la pestaña personalizada. Vuelve a intentarlo.")
            : (denied
                ? "Couldn't save the custom tab: you're missing the edit-clients permission. Ask your agent for it."
                : "Couldn't save the custom tab. Please try again."));
        });
    }, 800);
    return () => clearTimeout(t);
  }, [agencySettingsLoaded, customTabDefs]);
  // Debounced sync of the shared collaborators list to its own (seat-writable)
  // endpoint (#4). Separate from the blob above because seats can edit this but
  // not the agent-or-above PUT /agency-settings.
  // Same PLATFORM_OWNER guard as custom-tab-defs above: without a real agency
  // these agency-scoped saves 400 no_agency and the toast reads as data loss
  // on Platform Admin (Lissette 2026-08-02). Skip unless browsing AS an agency,
  // and never toast a no_agency response.
  const agencyCollabBase = useRef();
  useEffect(() => {
    if (!agencySettingsLoaded || !window.__deskteAuth) return;
    let _imp = false;
    try { _imp = !!leerEntrada("deskte:impersonateAgencyId"); } catch {}
    if (currentUser?.isPlatformOwner && !_imp) return;
    // Solo los cambios, por id (E-396): la copia entera de una pestaña abierta
    // desde temprano borraba los colaboradores que otra persona añadió después.
    if (agencyCollabBase.current === undefined) { agencyCollabBase.current = agencyCollaborators; return; }
    const cambios = cambiosDeColaboradores(agencyCollabBase.current, agencyCollaborators);
    if (!hayCambios(cambios)) return;
    const enviado = agencyCollaborators;
    const t = setTimeout(() => {
      import("./crm-app/api.js").then(({ updateAgencyCollaborators }) => updateAgencyCollaborators(cambios))
        .then((data) => {
          const v = data?.collaborators;
          if (!Array.isArray(v)) { agencyCollabBase.current = enviado; return; }
          agencyCollabBase.current = v;
          setAgencyCollaborators((ahora) => fusionarRespuesta("colaboradores", v, enviado, ahora));
        })
        .catch((err) => {
        if (/no_agency|has no agency/i.test(err?.message || String(err))) return;
        notifySaveFailed("No se pudo guardar la lista de agentes colaboradores en el servidor", "Couldn't save the collaborating-agents list to the server")(err);
      });
    }, 800);
    return () => clearTimeout(t);
  }, [agencySettingsLoaded, agencyCollaborators]);
  // Debounced sync of the shared tag colors to its own (seat-writable) endpoint
  // — separate from the agent-or-above blob PUT so seats can color tags too.
  const agencyTagColorsBase = useRef();
  useEffect(() => {
    if (!agencySettingsLoaded || !window.__deskteAuth) return;
    let _imp = false;
    try { _imp = !!leerEntrada("deskte:impersonateAgencyId"); } catch {}
    if (currentUser?.isPlatformOwner && !_imp) return;
    // Don't echo the hydrated map back on load (see the blob above).
    // Se manda SOLO lo que cambió desde lo último que se supo del servidor, y
    // el servidor lo aplica sobre lo guardado. Mandar la copia entera borraba
    // lo que otras personas de la agencia habían creado mientras tanto
    // (Pomares, 2026-10-29, E-396). `agencyTagColorsBase` guarda el VALOR, no su firma.
    if (agencyTagColorsBase.current === undefined) { agencyTagColorsBase.current = agencyTagColors; return; }
    const cambios = cambiosDeColores(agencyTagColorsBase.current, agencyTagColors);
    if (!hayCambios(cambios)) return;
    const enviado = agencyTagColors;
    const t = setTimeout(() => {
      import("./crm-app/api.js").then(({ updateAgencyTagColors }) => updateAgencyTagColors(cambios))
        .then((data) => {
          const v = data?.tagColors;
          if (!(v && typeof v === "object" && !Array.isArray(v))) { agencyTagColorsBase.current = enviado; return; }
          agencyTagColorsBase.current = v;
          setAgencyTagColors((ahora) => fusionarRespuesta("colores", v, enviado, ahora));
        })
        .catch((err) => {
        if (/no_agency|has no agency/i.test(err?.message || String(err))) return;
        notifySaveFailed("No se pudieron guardar los colores de etiquetas en el servidor", "Couldn't save the tag colors to the server")(err);
      });
    }, 800);
    return () => clearTimeout(t);
  }, [agencySettingsLoaded, agencyTagColors]);
  // Same debounced sync for the tag catalog — its own seat-writable endpoint,
  // for the same reason as the colors: a seat that tags a client has to be able
  // to create the tag.
  const agencyTagLibraryBase = useRef();
  useEffect(() => {
    if (!agencySettingsLoaded || !window.__deskteAuth) return;
    let _imp = false;
    try { _imp = !!leerEntrada("deskte:impersonateAgencyId"); } catch {}
    if (currentUser?.isPlatformOwner && !_imp) return;
    // Don't echo the hydrated list back on load (see the blob above).
    // Se manda SOLO lo que cambió desde lo último que se supo del servidor, y
    // el servidor lo aplica sobre lo guardado. Mandar la copia entera borraba
    // lo que otras personas de la agencia habían creado mientras tanto
    // (Pomares, 2026-10-29, E-396). `agencyTagLibraryBase` guarda el VALOR, no su firma.
    if (agencyTagLibraryBase.current === undefined) { agencyTagLibraryBase.current = agencyTagLibrary; return; }
    const cambios = cambiosDeCatalogo(agencyTagLibraryBase.current, agencyTagLibrary);
    if (!hayCambios(cambios)) return;
    const enviado = agencyTagLibrary;
    const t = setTimeout(() => {
      import("./crm-app/api.js").then(({ updateAgencyTagLibrary }) => updateAgencyTagLibrary(cambios))
        .then((data) => {
          const v = data?.tagLibrary;
          if (!(Array.isArray(v))) { agencyTagLibraryBase.current = enviado; return; }
          agencyTagLibraryBase.current = v;
          setAgencyTagLibrary((ahora) => fusionarRespuesta("catalogo", v, enviado, ahora));
        })
        .catch((err) => {
        if (/no_agency|has no agency/i.test(err?.message || String(err))) return;
        notifySaveFailed("No se pudo guardar el catalogo de etiquetas en el servidor", "Couldn't save the tag catalog to the server")(err);
      });
    }, 800);
    return () => clearTimeout(t);
  }, [agencySettingsLoaded, agencyTagLibrary]);
  // Catálogo y colores de las etiquetas de PÓLIZA. Mismo patrón que los de
  // cliente: no se reenvía lo recién hidratado (`Base` guarda la firma de lo que
  // llegó del servidor) y se espera 800 ms para no escribir en cada tecla.
  const policyTagLibraryBase = useRef();
  useEffect(() => {
    if (!agencySettingsLoaded || !window.__deskteAuth) return;
    let _imp = false;
    try { _imp = !!leerEntrada("deskte:impersonateAgencyId"); } catch {}
    if (currentUser?.isPlatformOwner && !_imp) return;
    // Se manda SOLO lo que cambió desde lo último que se supo del servidor, y
    // el servidor lo aplica sobre lo guardado. Mandar la copia entera borraba
    // lo que otras personas de la agencia habían creado mientras tanto
    // (Pomares, 2026-10-29, E-396). `policyTagLibraryBase` guarda el VALOR, no su firma.
    if (policyTagLibraryBase.current === undefined) { policyTagLibraryBase.current = policyTagLibrary; return; }
    const cambios = cambiosDeCatalogo(policyTagLibraryBase.current, policyTagLibrary);
    if (!hayCambios(cambios)) return;
    const enviado = policyTagLibrary;
    const t = setTimeout(() => {
      import("./crm-app/api.js").then(({ updateAgencyPolicyTagLibrary }) => updateAgencyPolicyTagLibrary(cambios))
        .then((data) => {
          const v = data?.policyTagLibrary;
          if (!(Array.isArray(v))) { policyTagLibraryBase.current = enviado; return; }
          policyTagLibraryBase.current = v;
          setPolicyTagLibrary((ahora) => fusionarRespuesta("catalogo", v, enviado, ahora));
        })
        .catch((err) => {
          if (/no_agency|has no agency/i.test(err?.message || String(err))) return;
          notifySaveFailed("No se pudo guardar el catalogo de etiquetas de poliza", "Couldn't save the policy tag catalog")(err);
        });
    }, 800);
    return () => clearTimeout(t);
  }, [agencySettingsLoaded, policyTagLibrary]);
  const policyTagColorsBase = useRef();
  useEffect(() => {
    if (!agencySettingsLoaded || !window.__deskteAuth) return;
    let _imp = false;
    try { _imp = !!leerEntrada("deskte:impersonateAgencyId"); } catch {}
    if (currentUser?.isPlatformOwner && !_imp) return;
    // Se manda SOLO lo que cambió desde lo último que se supo del servidor, y
    // el servidor lo aplica sobre lo guardado. Mandar la copia entera borraba
    // lo que otras personas de la agencia habían creado mientras tanto
    // (Pomares, 2026-10-29, E-396). `policyTagColorsBase` guarda el VALOR, no su firma.
    if (policyTagColorsBase.current === undefined) { policyTagColorsBase.current = policyTagColors; return; }
    const cambios = cambiosDeColores(policyTagColorsBase.current, policyTagColors);
    if (!hayCambios(cambios)) return;
    const enviado = policyTagColors;
    const t = setTimeout(() => {
      import("./crm-app/api.js").then(({ updateAgencyPolicyTagColors }) => updateAgencyPolicyTagColors(cambios))
        .then((data) => {
          const v = data?.policyTagColors;
          if (!(v && typeof v === "object" && !Array.isArray(v))) { policyTagColorsBase.current = enviado; return; }
          policyTagColorsBase.current = v;
          setPolicyTagColors((ahora) => fusionarRespuesta("colores", v, enviado, ahora));
        })
        .catch((err) => {
          if (/no_agency|has no agency/i.test(err?.message || String(err))) return;
          notifySaveFailed("No se pudieron guardar los colores de etiquetas de poliza", "Couldn't save the policy tag colours")(err);
        });
    }, 800);
    return () => clearTimeout(t);
  }, [agencySettingsLoaded, policyTagColors]);
  // Los plazos de aviso de la agencia. Mismo patrón que los de arriba (no se
  // reenvía lo recién hidratado, 800 ms para no escribir en cada tecla), con
  // una diferencia: NO se intenta guardar si quien está delante no es el dueño.
  // El servidor lo rechazaría con un 403 y el aviso de "no se pudo guardar"
  // saldría por algo que la persona ni siquiera puede hacer.
  const alertLeadBase = useRef();
  useEffect(() => {
    if (!agencySettingsLoaded || !window.__deskteAuth) return;
    if (!puedeCambiarLosPlazos(currentUser)) return;
    let _imp = false;
    try { _imp = !!leerEntrada("deskte:impersonateAgencyId"); } catch {}
    if (currentUser?.isPlatformOwner && !_imp) return;
    const sig = agencyCfgSig({ a: agencyAlertLead, t: agencyAlertLeadByType });
    if (alertLeadBase.current === undefined) { alertLeadBase.current = sig; return; }
    if (sig !== null && sig === alertLeadBase.current) return;
    const t = setTimeout(() => {
      import("./crm-app/api.js").then(({ updateAgencyAlertLead }) => updateAgencyAlertLead(agencyAlertLead, agencyAlertLeadByType))
        .then(() => { alertLeadBase.current = sig; })
        .catch((err) => {
          if (/no_agency|has no agency/i.test(err?.message || String(err))) return;
          notifySaveFailed("No se pudo guardar el tiempo de las alertas", "Couldn't save the alert timing")(err);
        });
    }, 800);
    return () => clearTimeout(t);
  }, [agencySettingsLoaded, agencyAlertLead, agencyAlertLeadByType, currentUser]);
  // El orden del nombre de la agencia. Gemelo exacto del de arriba, incluido el
  // "no lo intentes si no eres el dueño": el servidor lo rechazaria con un 403 y
  // saldria un aviso de "no se pudo guardar" por algo que la persona ni siquiera
  // puede hacer.
  const nameOrderBase = useRef();
  useEffect(() => {
    if (!agencySettingsLoaded || !window.__deskteAuth) return;
    if (!puedeCambiarElOrdenDelNombre(currentUser)) return;
    let _imp = false;
    try { _imp = !!leerEntrada("deskte:impersonateAgencyId"); } catch {}
    if (currentUser?.isPlatformOwner && !_imp) return;
    const sig = agencyCfgSig({ n: agencyNameOrder });
    if (nameOrderBase.current === undefined) { nameOrderBase.current = sig; return; }
    if (sig !== null && sig === nameOrderBase.current) return;
    const t = setTimeout(() => {
      import("./crm-app/api.js").then(({ updateAgencyNameOrder }) => updateAgencyNameOrder(agencyNameOrder))
        .then(() => { nameOrderBase.current = sig; })
        .catch((err) => {
          if (/no_agency|has no agency/i.test(err?.message || String(err))) return;
          notifySaveFailed("No se pudo guardar el orden del nombre", "Couldn't save the name order")(err);
        });
    }, 800);
    return () => clearTimeout(t);
  }, [agencySettingsLoaded, agencyNameOrder, currentUser]);
  const [userPrefs,setUserPrefs]=useState({favorites:[],accentColor:"",accentColor2:""});
  // Keep the global date formatter in sync with the user's preference. Called
  // during render (before children render) so every fmt() call this pass uses
  // the chosen style — a plain module-var assignment, safe + idempotent.
  setDateFormatPref(userPrefs?.dateFormat || 'MMM D, YYYY');
  // El orden del nombre ya NO sale de la persona: manda el de la agencia, y
  // solo si esta no lo fijo se respeta el de cada uno (Lissette 2026-09-15:
  // "si, que sea de la agencia"). La regla vive en crm-app/utils.js para que
  // las pruebas puedan comprobarla sin montar React.
  setNameOrderPref(ordenDeNombreQueManda({ nameOrder: agencyNameOrder }, userPrefs));
  // Collaborators are now agency-shared (#4) — feed the singleton (policy Agent
  // toggle + signature picker) from the agency list, not per-user prefs.
  setCollaboratorsPref(Array.isArray(agencyCollaborators) ? agencyCollaborators : []);
  const prefsSyncReady=useRef(false);
  // Load per-user prefs: localStorage cache first, then merge the server copy
  // (currentUser.uiPrefs from /auth/me) on top so prefs follow the user across
  // devices. localStorage stays as an instant-load cache + offline fallback.
  useEffect(()=>{
    if(!currentUser) { prefsSyncReady.current=false; return; }
    prefsSyncReady.current=false;
    let base={favorites:[],accentColor:"",accentColor2:""};
    try { const stored=localStorage.getItem("dkt6_prefs_"+currentUser.id); if(stored) base=JSON.parse(stored); } catch(e){}
    const sp=currentUser.uiPrefs;
    const merged=(sp && typeof sp==="object" && Object.keys(sp).length) ? {...base,...sp} : base;
    setUserPrefs(merged);
    // Seed localStorage from the server kv blob so synchronous mount-time reads
    // (table page sizes, last client/tab, "unread" stamps) pick up the user's
    // saved values on this device (Lissette 2026-06-14 — "todo en el servidor").
    seedPrefsFromServer(merged.kv);
    // Server-backed device preferences follow the user across devices: apply the
    // saved language / theme / palette on top of the localStorage cache so a new
    // browser/device picks up the user's real choices (Lissette 2026-06-14).
    if(merged.lang==="es"||merged.lang==="en") setLang(merged.lang);
    if(merged.theme==="light"||merged.theme==="dark") setTheme(merged.theme);
    if(merged.palette==="ocean"||merged.palette==="sunset") setPalette(merged.palette);
    prefsSyncReady.current=true;
  },[currentUser?.id]);
  // Save to localStorage (cache) on every change.
  useEffect(()=>{
    if(!currentUser) return;
    try { localStorage.setItem("dkt6_prefs_"+currentUser.id,JSON.stringify(userPrefs)); } catch(e){}
  },[userPrefs,currentUser?.id]);
  // Debounced sync to the server (skip until the initial merge ran, and never
  // while a platform owner is viewing-as another user — that would overwrite
  // the founder's own prefs with the target's).
  useEffect(()=>{
    if(!currentUser || !prefsSyncReady.current || currentUser.impersonatedByPlatform) return;
    // El fallo se registra: se tragaba entero, y una preferencia que no llega
    // al servidor se sigue viendo bien en ESTE navegador (la copia local no se
    // borra al mezclar), asi que sin rastro no hay forma de saber que paso.
    const t=setTimeout(()=>{ import("./crm-app/api.js").then(({updateMyProfile})=>updateMyProfile({uiPrefs:userPrefs}).catch((err)=>console.warn("[uiPrefs] save failed:", err?.message||err))).catch((err)=>console.warn("[uiPrefs] save failed:", err?.message||err)); },1500);
    return ()=>clearTimeout(t);
  },[userPrefs,currentUser?.id]);
  // Mirror language / theme / palette INTO userPrefs so they sync to the server
  // and follow the user across devices. Guarded by prefsSyncReady so the initial
  // hydration above never echoes back, and by equality so there's no loop.
  useEffect(()=>{ if(prefsSyncReady.current) setUserPrefs(p=> p.lang===lang ? p : {...p, lang}); },[lang]);
  useEffect(()=>{ if(prefsSyncReady.current) setUserPrefs(p=> p.theme===theme ? p : {...p, theme}); },[theme]);
  useEffect(()=>{ if(prefsSyncReady.current) setUserPrefs(p=> p.palette===palette ? p : {...p, palette}); },[palette]);
  // Install the uiPrefsStore mirror once: every prefsSet/prefsRemove (page size,
  // last client/tab, freshness stamps) also writes into userPrefs.kv → which the
  // debounced effect above syncs to the server. Reads stay synchronous (localStorage).
  useEffect(()=>{
    installPrefsMirror((key, value)=>{
      // Se poda AQUI, al escribir, no al enviar: asi el bloque que viaja al
      // servidor nunca crece sin techo. Las marcas de "ya lo vi" son dos por
      // ficha abierta y viven en el mismo bloque que el idioma; cuando el
      // conjunto pasaba del tope, el servidor lo descartaba ENTERO y en
      // silencio, y el idioma dejaba de guardarse a partir de la ficha ~32
      // (Lissette 2026-08-23, E-118). El localStorage de este equipo las
      // conserva todas — esto solo acota la copia compartida.
      setUserPrefs(p=>{ const kv={...(p.kv||{})}; if(value==null) delete kv[key]; else kv[key]=String(value); return {...p, kv:podarFrescura(kv)}; });
    });
  },[]);
  // Apply custom accent colors
  useEffect(()=>{
    const shell=document.querySelector(".dkt-shell");
    if(!shell) return;
    if(userPrefs.accentColor){
      shell.style.setProperty("--c-cyan",userPrefs.accentColor);
      shell.style.setProperty("--c-cyan2",userPrefs.accentColor);
      shell.style.setProperty("--c-cyan-dim",userPrefs.accentColor+"1f");
    } else { shell.style.removeProperty("--c-cyan"); shell.style.removeProperty("--c-cyan2"); shell.style.removeProperty("--c-cyan-dim"); }
    if(userPrefs.accentColor2){
      shell.style.setProperty("--c-green",userPrefs.accentColor2);
      shell.style.setProperty("--c-green-dim",userPrefs.accentColor2+"1a");
    } else { shell.style.removeProperty("--c-green"); shell.style.removeProperty("--c-green-dim"); }
  },[userPrefs.accentColor,userPrefs.accentColor2]);
  // Apply per-user font preferences (Settings → Preferences → Text & Appearance).
  // The shell's inline font-family reads `var(--dkt-user-font, system-ui, …)`, so
  // we just steer that variable on <html> here — robust against React re-renders
  // and the shell's inline style. Headings keep --font-display so the brand look
  // survives. Size scales the document root font-size, lifting the rem-based text
  // across the whole app. 'md'/unset removes each override entirely.
  useEffect(()=>{
    const root=document.documentElement;
    if(userPrefs.fontFamily) root.style.setProperty("--dkt-user-font",userPrefs.fontFamily);
    else root.style.removeProperty("--dkt-user-font");
    const SIZE_PX={sm:"15px",lg:"17px",xl:"18px"};
    const px=SIZE_PX[userPrefs.fontSize];
    if(px) root.style.fontSize=px;
    else root.style.removeProperty("font-size");
  },[userPrefs.fontFamily,userPrefs.fontSize]);
  const t=T[lang]; const isOwner=currentUser?.role!=="assistant"; const isAgencyAdmin=["agency_owner","agency_admin"].includes(currentUser?.role);
  // ── AUTO GREETING POPUP on login ──
  // Lissette 2026-05-27: the popup must appear EVERY time someone opens
  // Deskte while there are unsaluted birthdays/holidays. And when ONE
  // teammate sends, it must disappear for the rest. The old logic used a
  // localStorage `dkt_greetings_sent_${todayKey}` blanket gate that hid
  // the popup for the rest of the day on the same device — wrong on both
  // counts. New rules:
  //   - Filter candidates by `hasTeamActionBeenDone` so anything a
  //     teammate already greeted today is excluded.
  //   - No localStorage gate. Dismiss just closes for THIS session;
  //     reopening Deskte will recompute and show again if anything's
  //     still pending.
  //   - Re-run when teamActions arrives or refreshes so the popup
  //     stays in sync with what teammates do in parallel.
  const [greetingPopup, setGreetingPopup] = useState(null);
  // Lissette 2026-05-27: optional date+time picker on the popup to
  // queue the greeting for a future moment instead of firing now. When
  // empty (the common case), the buttons send immediately.
  const [greetingScheduleAt, setGreetingScheduleAt] = useState("");
  // Session-scoped dismiss flag. Once the user closes the popup, we
  // don't reopen it during the same browser tab — even if a teamActions
  // refresh would otherwise re-trigger the effect. Reset only on tab
  // reload (intentional: opening Deskte fresh = show again).
  const popupDismissedTodayRef = useRef(null);
  useEffect(() => {
    if (!currentUser || !clients.length) return;
    // Wait for teamActions to be hydrated (null = still loading) so we
    // don't flash a popup for people a teammate already saluted.
    if (teamActions === null || teamActions === undefined) return;
    const todayKey = localDay();
    if (popupDismissedTodayRef.current === todayKey) return;
    const es = lang === "es";
    const items = [];
    clients.filter(c => c.status === "active").forEach(c => {
      // `person` carries the birthday person's OWN name + contact so the
      // greeting addresses them and is delivered to their own email/phone
      // when on file. If a spouse/dependent has no email, the send falls
      // back to the primary client's email (Lissette 2026-06-01).
      //
      // Dedup is PER PERSON, not per household: it used to skip the whole
      // client the moment anyone in it had been greeted, so on a day when both
      // Luis and his wife had a birthday only one of them ever got a greeting
      // — and the key it asked with (bare clientId + UTC day) was not the one
      // the other screens wrote (ticket 2026-08-14).
      const checkPerson = (dob, name, relation, person) => {
        if (!dob || !birthdayToday(dob)) return;
        if (hasTeamActionBeenDone(bdayGreetingKey(person.personKey, todayKey)).done) return;
        const relLabel = relation ? ` (${relation})` : "";
        items.push({ type: "bday", client: c, person, personKey: person.personKey, dayKey: todayKey, emoji: "🎂", label: `${name}${relLabel}`, sub: es ? "¡Cumpleaños HOY!" : "Birthday TODAY!", sendNow: true });
      };
      const headName = `${c.firstName} ${c.lastName}`;
      checkPerson(c.dob, headName, null, { personKey: bdayPersonKey(c.id), firstName: c.firstName, lastName: c.lastName, email: c.email, phone: c.phone });
      if (hasCurrentSpouse(c) && c.spouse?.dob) checkPerson(c.spouse.dob, `${c.spouse.firstName} ${c.spouse.lastName || c.lastName}`, es ? `Cónyuge de ${headName}` : `Spouse of ${headName}`, { personKey: bdayPersonKey(c.id, 'spouse'), firstName: c.spouse.firstName, lastName: c.spouse.lastName || c.lastName, email: c.spouse.email, phone: c.spouse.phone });
      (c.dependents || []).forEach((dep, i) => { if (dep.dob && dep.firstName) checkPerson(dep.dob, `${dep.firstName} ${dep.lastName || c.lastName}`, es ? `Dependiente de ${headName}` : `Dependent of ${headName}`, { personKey: bdayPersonKey(c.id, 'dep', dep.id || i), firstName: dep.firstName, lastName: dep.lastName || c.lastName, email: dep.email, phone: dep.phone }); });
    });
    const holidays = getUpcomingHolidays();
    const todayHol = holidays.find(h => h.daysUntil === 0);
    // Skip the holiday once a teammate already sent its greetings today. The
    // per-client send logs keys like `hol_<holidayId>_<clientId>_<date>`, so
    // any such record for today means this holiday was handled. (Birthdays are
    // already filtered above via hasTeamActionBeenDone.)
    const holAlreadySent = !!todayHol && (teamActions || []).some(a => a && typeof a.key === "string"
      && a.key.startsWith(`hol_${todayHol.id}_`) && a.key.endsWith(`_${todayKey}`));
    if (todayHol && !holAlreadySent) items.push({ type: "holiday", holiday: todayHol, emoji: todayHol.emoji, label: es ? todayHol.nameEs : todayHol.name, sub: es ? "¡Hoy es feriado!" : "Holiday today!", sendNow: true });
    if (items.length === 0) {
      // Everything for today was greeted — close any stale popup.
      setGreetingPopup(prev => prev && prev.todayKey === todayKey ? null : prev);
      return;
    }
    // First show after 1.5s on initial mount; subsequent recomputes (e.g.
    // teamActions refresh shrinking the list) update in place with no
    // delay.
    setGreetingPopup(prev => {
      if (prev && prev.todayKey === todayKey) return { items, todayKey };
      return prev;
    });
    const t = setTimeout(() => {
      if (popupDismissedTodayRef.current === todayKey) return;
      // Show only once per sign-in (Lissette 2026-06-15): a plain page refresh
      // keeps sessionStorage so it won't re-pop; a fresh login (new browser
      // session) starts empty and shows it again. An already-open popup still
      // updates/closes live via the setGreetingPopup call above.
      try { if (sessionStorage.getItem("deskte:greetingShownSession") === todayKey) return; } catch {}
      try { sessionStorage.setItem("deskte:greetingShownSession", todayKey); } catch {}
      setGreetingPopup(prev => prev && prev.todayKey === todayKey ? prev : { items, todayKey });
    }, 1500);
    return () => clearTimeout(t);
  }, [currentUser?.id, clients, teamActions, lang]);
  const sendAllGreetings = async (channel) => {
    if (!greetingPopup) return;
    const es = lang === "es";
    const fill = (tmpl, c) => (tmpl||"").replace(/\{\{firstName\}\}/g, c.firstName||"").replace(/\{\{lastName\}\}/g, c.lastName||"").replace(/\{\{agentName\}\}/g, presentingAgentName(currentUser));
    const holidays = [];
    greetingPopup.items.forEach(item => {
      if (item.type === "bday") {
        const tpl = (emailTemplates||EMAIL_TEMPLATE_DEFAULTS).find(t2 => t2.id === "et4");
        // Address the birthday person by their own name; deliver to their own
        // email/phone if on file, otherwise fall back to the primary client's.
        const p = item.person || item.client;
        const recipient = { ...item.client, firstName: p.firstName || item.client.firstName, lastName: p.lastName || item.client.lastName, email: p.email || item.client.email, phone: p.phone || item.client.phone };
        const doBday = () => {
          sendGreeting(channel, recipient, fill(es?tpl.subjectEs:tpl.subject, recipient), fill(es?tpl.bodyEs:tpl.body, recipient), lang);
          logTeamAction("greeting_sent", item.personKey, {kind:"bday", channel, forDate:item.dayKey});
        };
        confirmBeforeResend("greeting_sent", item.personKey, {kind:"bday", channel, forDate:item.dayKey}, doBday);
      }
      if (item.type === "holiday") {
        holidays.push(item.holiday);
      }
    });

    // EL SALUDO DE FIESTA VA A TODOS LOS CLIENTES ACTIVOS, y ahora el SMS SALE
    // DE VERDAD por el proveedor de la agencia — antes solo abria N enlaces que
    // el navegador bloqueaba a partir del tercero, asi que en la practica no se
    // mandaba casi nada. Sin preguntar, un clic mandaria cientos de SMS de
    // verdad sin forma de pararlo. El Panel ya preguntaba antes de esto mismo; la
    // ventana de bienvenida, no.
    for (const hol of holidays) {
      const active = clients.filter(c => c.status === "active" && (channel === "email" ? c.email : c.phone));
      if (!active.length) continue;
      const ok = await confirmDialog(es
        ? `Esto enviará el saludo de ${hol.nameEs || hol.name} a ${active.length} cliente(s) por ${channel}. ¿Continuar?`
        : `This will send the ${hol.name} greeting to ${active.length} client(s) via ${channel}. Continue?`);
      if (!ok) continue;
      for (const c of active) {
        const doHol = () => {
          sendGreeting(channel, c, fill(es?hol.subjectEs:hol.subject, c), fill(es?hol.bodyEs:hol.body, c), lang);
          logTeamAction("greeting_sent", c.id, {kind:"holiday", channel, holidayId: hol.id});
        };
        confirmBeforeResend("greeting_sent", c.id, {kind:"holiday", channel, holidayId: hol.id}, doHol);
      }
    }
    // No localStorage write here — the popup-builder useEffect now uses
    // TeamAction dedup to skip people the team already greeted. As soon
    // as the optimistic logTeamAction() calls above land in state, the
    // useEffect recomputes and items.length drops to 0, closing the popup
    // naturally. Other teammates see the same effect via /team-actions
    // refresh or once we wire SSE push (see pending_websocket_push_plan).
    setGreetingPopup(null);
    setGreetingScheduleAt("");
  };
  // Queue the greetings to send at `greetingScheduleAt` instead of now.
  // Only email is supported by the worker today; the buttons that pick
  // sms/whatsapp drop back to the immediate sendAllGreetings path.
  const scheduleAllGreetings = async () => {
    if (!greetingPopup || !greetingScheduleAt) return;
    const es = lang === "es";
    const fill = (tmpl, c) => (tmpl||"").replace(/\{\{firstName\}\}/g, c.firstName||"").replace(/\{\{lastName\}\}/g, c.lastName||"").replace(/\{\{agentName\}\}/g, presentingAgentName(currentUser));
    const runAtIso = new Date(greetingScheduleAt).toISOString();
    const tpl = (emailTemplates||EMAIL_TEMPLATE_DEFAULTS).find(t2 => t2.id === "et4");
    let queued = 0; let skipped = 0;
    for (const item of greetingPopup.items) {
      if (item.type === "bday") {
        // Deliver to the birthday person's own email if on file, else fall
        // back to the primary client's email (Lissette 2026-06-01).
        const p = item.person || item.client;
        const recipientEmail = p.email || item.client.email;
        if (!recipientEmail) { skipped++; continue; }
        const recipient = { ...item.client, firstName: p.firstName || item.client.firstName, lastName: p.lastName || item.client.lastName, email: recipientEmail };
        try {
          await apiCreateScheduledSend({
            clientId: item.client.id,
            channel: "email",
            recipient: recipientEmail,
            subject: fill(es?tpl.subjectEs:tpl.subject, recipient),
            body: fill(es?tpl.bodyEs:tpl.body, recipient),
            runAt: runAtIso,
            source: "birthday_greeting",
            templateId: tpl?.id,
            // Sale de la plantilla sin tocar: el servidor la rearma el día del
            // envío con la plantilla y la ficha de ese día.
            ...plantillaVivaDelSaludo({ sinTocar: true, templateId: tpl?.id, tipo: "bday", lang: es ? "es" : "en", personKey: item.personKey }),
          });
          // Mark in TeamAction so the popup hides this row for everyone. The
          // marker belongs to the BIRTHDAY (today, for this popup), not to
          // whatever date the send was deferred to.
          logTeamAction("greeting_sent", item.personKey, {kind:"bday", channel:"email", scheduled:true, forDate:item.dayKey});
          queued++;
        } catch (err) {
          console.error("scheduleAllGreetings bday failed:", err.message);
          skipped++;
        }
      }
      if (item.type === "holiday") {
        const hol = item.holiday;
        const active = clients.filter(c => c.status === "active" && c.email);
        for (const c of active) {
          try {
            await apiCreateScheduledSend({
              clientId: c.id,
              channel: "email",
              recipient: c.email,
              subject: fill(es?hol.subjectEs:hol.subject, c),
              body: fill(es?hol.bodyEs:hol.body, c),
              runAt: runAtIso,
              source: "holiday_greeting",
              templateId: hol.id,
              ...plantillaVivaDelSaludo({ sinTocar: true, templateId: hol.id, tipo: "holiday", lang: es ? "es" : "en", personKey: c.id }),
            });
            logTeamAction("greeting_sent", c.id, {kind:"holiday", channel:"email", holidayId: hol.id, scheduled:true});
            queued++;
          } catch (err) {
            console.error("scheduleAllGreetings hol failed:", err.message);
            skipped++;
          }
        }
      }
    }
    const at = new Date(greetingScheduleAt).toLocaleString("en-US", { dateStyle:"medium", timeStyle:"short" });
    alert(es ? `Programados ${queued} envíos para ${at}${skipped?` (${skipped} omitidos)`:""}.` : `Scheduled ${queued} sends for ${at}${skipped?` (${skipped} skipped)`:""}.`);
    setGreetingPopup(null);
    setGreetingScheduleAt("");
  };
  // Dismiss just closes for THIS session. Reopening Deskte (tab reload /
  // fresh login) will show the popup again if anyone in today's list
  // still hasn't been greeted — by design (Lissette 2026-05-27).
  const dismissGreeting = () => {
    const todayKey = localDay();
    popupDismissedTodayRef.current = todayKey;
    setGreetingPopup(null);
  };
  const logActivity = (clientId, action, detail) => {
    if (!clientId || !currentUser) return;
    setActivitylog(prev => [...prev, {
      id: uid(), clientId, userId: currentUser.id,
      action, detail, ts: new Date().toISOString()
    }]);
  };
  // ─── TEAM ACTION SYNC ───
  // Scope: a "module unit" is an agent + their assistants (NOT the whole agency).
  // - Solo agent (no parent): [self + own assistants]
  // - Assistant: [parent agent + parent's other assistants]
  // - Agency owner: [self only] — agencies do NOT sync with individual agents
  const agencyMates = useMemo(() => {
    if (!currentUser) return [];
    if (currentUser.role === "agency_owner" || currentUser.role === "agency_admin") {
      return [currentUser.id];
    }
    // Figure out the "anchor" agent: for an agent it's themselves, for an assistant it's parentAgentId
    const anchorAgentId = currentUser.role === "assistant"
      ? (currentUser.parentAgentId || currentUser.id)
      : currentUser.id;
    const mates = [anchorAgentId];
    users.forEach(u => {
      if (u.role === "assistant" && u.parentAgentId === anchorAgentId && !mates.includes(u.id)) {
        mates.push(u.id);
      }
    });
    if (!mates.includes(currentUser.id)) mates.push(currentUser.id);
    return mates;
  }, [users, currentUser]);
  const hasTeamActionBeenDone = useCallback((key) => {
    // Team-actions are ALREADY scoped to the agency by the server, so any row we
    // hold belongs to this agency. We must NOT re-filter by a local sub-group
    // (agencyMates): for an agency_owner that set is just [self], so a greeting
    // the OWNER sent never counted as "done" for a seat (and a seat's send never
    // counted for the owner) — the card kept showing the send button to
    // teammates even though the email already went out (Lissette 2026-06-22).
    const entry = (teamActions||[])
      .filter(a => a.key === key)
      .sort((a,b) => new Date(b.ts) - new Date(a.ts))[0];
    if (!entry) return { done:false };
    const byUser = users.find(u => u.id === entry.userId);
    return { done:true, by: byUser?.name || "Teammate", at: entry.ts, entry };
  }, [teamActions, agencyMates, users]);
  const logTeamAction = useCallback((type, clientId, extra={}) => {
    if (!currentUser) return;
    const key = teamActionKey(type, clientId, extra);
    const record = {
      id: uid(), type, key,
      clientId: clientId || null,
      userId: currentUser.id,
      agencyId: currentUser.agencyId || null,
      ts: new Date().toISOString(),
      details: extra
    };
    // Optimistic local write — the UI feels instant and the legacy
    // `hasTeamActionBeenDone` lookup (which reads from `teamActions`)
    // resolves to {done:true} on the very next render.
    setTeamActions(prev => [...(prev||[]), record]);
    // Fire-and-forget write-through to the backend. Endpoint is idempotent
    // on (agencyId, key) so a double-click or a cross-tab race is fine.
    // We don't await — a network blip shouldn't block the caller's UX.
    if (window.__deskteAuth) {
      import('./crm-app/api.js').then(({ recordTeamAction }) =>
        recordTeamAction({ type, key, clientId: clientId || null, details: extra }),
      ).catch(err => {
        console.error('[team-actions] write-through failed:', err.message);
      });
    }
    return record;
  }, [currentUser, setTeamActions]);
  // Quitar una marca del estado LOCAL. El borrado en el servidor lo hace quien
  // desprograma (crm-app/greetingQueue.js); esto es lo que hace que la tarjeta
  // vuelva a rojo en el acto en vez de esperar los 45 s del refresco.
  const forgetTeamAction = useCallback((key) => {
    if (!key) return;
    setTeamActions(prev => (prev || []).filter(a => a && a.key !== key));
  }, [setTeamActions]);
  const [resendConfirm, setResendConfirm] = useState(null);
  const confirmBeforeResend = useCallback((type, clientId, extra, onConfirm) => {
    const key = teamActionKey(type, clientId, extra);
    const res = hasTeamActionBeenDone(key);
    if (!res.done) { onConfirm(); return; }
    setResendConfirm({
      by: res.by, at: res.at,
      onConfirm: () => { setResendConfirm(null); onConfirm(); },
      onCancel: () => setResendConfirm(null)
    });
  }, [hasTeamActionBeenDone]);
  // LO QUE HAY QUE LEER PARA CUALQUIER AVISO. Son las preferencias de la
  // persona con los plazos de la AGENCIA puestos encima (Lissette 2026-08-28).
  // Se arma una sola vez y se reparte: cada pantalla que se quedara leyendo
  // `userPrefs` a secas enseñaría otra lista, y eso no se nota hasta que dos
  // personas comparan la suya.
  //
  // VA DEBAJO del useState que crea `userPrefs`, no encima: leerlo antes de que
  // exista revienta la pantalla entera y no da error al compilar (E-144).
  const prefsDeAviso = useMemo(
    () => conPlazosDeLaAgencia(userPrefs, { alertLead: agencyAlertLead, alertLeadByType: agencyAlertLeadByType }),
    [userPrefs, agencyAlertLead, agencyAlertLeadByType],
  );
  const licLead=alertLeadDays(prefsDeAviso,"license");
  // Vence la licencia, o faltan HORAS CONTINUAS antes de la fecha límite. Las
  // dos cosas cuentan para el mismo aviso porque las dos te dejan sin poder
  // trabajar (Lissette 2026-08-17). Con las horas ya completas no avisa: estar
  // al día no es un pendiente.
  const licAtRisk=useMemo(()=>licenses.filter(l=>{
    const dExp=l.expiryDate?daysUntil(l.expiryDate):null;
    if(dExp!==null&&dExp>=0&&dExp<=licLead) return true;
    const req=parseFloat(l.ceRequired), done=parseFloat(l.ceCredits)||0;
    if(!Number.isFinite(req)||req<=0||done>=req) return false;
    const dCe=l.ceDeadline?daysUntil(l.ceDeadline):null;
    return dCe!==null&&dCe<=licLead; // incluye vencidas (dCe<0)
  }),[licenses,licLead]);
  const licExpiring=licAtRisk.length;
  const alertCount=useMemo(()=>{ let n=0; clients.forEach(c=>{ const check=(dob,isDep)=>{ if(!dob) return; const db=daysUntilBirthday(dob); if(db<=1) n++; const d65=willTurnAge(dob,65); if(d65!==null&&d65>0&&d65<=365) n++; if(d65!==null&&d65>0&&d65<=90) n++; const d26=willTurnAge(dob,26); if(isDep&&d26!==null&&d26>0&&d26<=365) n++; }; check(c.dob,false); if(c.spouse?.dob) check(c.spouse.dob,false); (c.dependents||[]).forEach(dep=>check(dep.dob,true)); }); policies.forEach(p=>{ const d=daysUntil(p.renewalDate); if(d!==null&&d>=0&&d<=14) n++; // Card expiring within 30 days
    if(p.paymentType==="autopay"&&(p.paymentMethod==="credit_card"||p.paymentMethod==="debit_card")&&p.cardExpMonth&&p.cardExpYear){ const exp=new Date(parseInt(p.cardExpYear),parseInt(p.cardExpMonth),0); const cd=Math.ceil((exp-new Date())/86400000); if(cd<=30) n++; } }); docs.forEach(d=>{ if(d.required&&!d.uploadedAt) n++; }); (eligibilityAlerts||[]).filter(ea=>ea.status==="pending"&&ea.deadline).forEach(ea=>{ const[y,m,d2]=ea.deadline.split("-").map(Number); const dd=Math.ceil((new Date(y,m-1,d2)-new Date(new Date().setHours(0,0,0,0)))/(864e5)); if(dd<=90||dd<0) n++; }); return n; },[clients,policies,docs,eligibilityAlerts]);
  const taskCount=useMemo(()=>tasks.filter(tk=>tk.status!=="done"&&(tk.assignedTo===currentUser?.id||!tk.assignedTo)).length,[tasks,currentUser]);
  // Mirror the Renewals view's base filter: skip inactive/cancelled policies
  // so the sidebar badge matches what the user actually sees in the list
  // (a cancelled policy with an upcoming renewalDate was inflating the count).
  const renewCount=useMemo(()=>policies.filter(p=>{ if(p.status==="inactive"||p.status==="cancelled") return false; const d=daysUntil(p.renewalDate); return d!==null&&d>=0&&d<=30; }).length,[policies]);
  const activeClockIn=timelog.find(e=>e.userId===currentUser?.id&&e.clockIn&&!e.clockOut);

  // ── AUTO ACTIVITY TRACKER ── abre la sesión al entrar y la cierra tras 5 min
  // sin actividad EN DESKTE (ratón, teclado, clic, scroll, toque).
  //
  // Reglas (Lissette 2026-10-17 — Victor salía "en progreso" sin estar y el día
  // le sumaba 18.8 h):
  //   1. Al cerrar por inactividad, la salida es la hora de la ÚLTIMA actividad,
  //      no "ahora". Antes se cerraba en "ahora", así que los 5 min de espera
  //      — y, si la computadora se había dormido, horas enteras — se sumaban.
  //   2. Si la persona vuelve después de 5 min y el reloj aún no lo había visto
  //      (computadora dormida, pestaña congelada), primero se cierra la sesión
  //      vieja en su última actividad y luego se abre otra.
  //   3. Latido: mientras hay actividad, cada minuto se avisa al servidor. Si el
  //      navegador muere sin poder cerrar (sin internet, cierre forzado,
  //      computadora apagada), el servidor cierra la sesión en el último latido
  //      (deskte-api/src/utils/timeEntryReaper.ts). Sin latido no hay horas.
  //   4. La actividad se comparte entre pestañas (localStorage), para que una
  //      pestaña olvidada no cierre la sesión de quien trabaja en otra.
  const INACTIVITY_TIMEOUT = 5 * 60 * 1000; // 5 minutes
  const HEARTBEAT_MS = 60 * 1000;
  const ACTIVITY_KEY = "dkt_last_activity";
  const lastActivityRef = useRef(Date.now());
  const lastSharedWriteRef = useRef(0);
  const lastBeatRef = useRef(0);
  const inactiveTimerRef = useRef(null);
  const isInactiveRef = useRef(false);
  // Cierre por inactividad en vuelo: la reapertura lo espera para no ver la
  // sesión vieja todavía "abierta" y quedarse sin abrir la nueva.
  const closingPromiseRef = useRef(null);
  // In-flight guard so two near-simultaneous triggers (hydrate, activity
  // resume) can't each open a session before the first create lands in
  // state — that race is what produced the stack of duplicate
  // "in progress" rows.
  const clockingRef = useRef(false);
  // Auto clock-in must wait until we've actually loaded the server's
  // entries; otherwise every login opens a fresh session even though one
  // is already open server-side.
  const [timelogLoaded, setTimelogLoaded] = useState(false);
  // Latest timelog for the interval/listener closures, which intentionally
  // don't re-subscribe on every timelog change. The write helpers below also
  // update it in place, so a clock-in right after a clock-out sees the close.
  const timelogRef = useRef(timelog);
  useEffect(() => { timelogRef.current = timelog; }, [timelog]);

  // Última actividad conocida: la de esta pestaña o la de otra pestaña de
  // Deskte, la más reciente.
  const readLastActivity = useCallback(() => {
    let shared = 0;
    try { shared = Number(localStorage.getItem(ACTIVITY_KEY)) || 0; } catch { shared = 0; /* storage bloqueado: solo cuenta esta pestaña */ }
    return Math.max(lastActivityRef.current, shared);
  }, []);
  const markActivity = useCallback((ts) => {
    lastActivityRef.current = ts;
    if (ts - lastSharedWriteRef.current < 5000) return; // mousemove dispara cientos por segundo
    lastSharedWriteRef.current = ts;
    try { localStorage.setItem(ACTIVITY_KEY, String(ts)); } catch { /* storage bloqueado: solo cuenta esta pestaña */ }
  }, []);

  // Hydrate the timelog from the backend whenever the logged-in user
  // changes. Seats get only their own rows; agents/owners get the whole
  // agency's, so a supervisor finally sees their seats' hours.
  useEffect(() => {
    if (!currentUser) { setTimelog([]); setTimelogLoaded(false); return; }
    // PLATFORM_OWNER (Deskte founder) has no agency, so the tenant-scoped
    // /time-entries endpoint rejects them. Time tracking is an agent/seat
    // feature — the founder isn't tracking billable hours. Skip entirely.
    if (currentUser.isPlatformOwner) { setTimelog([]); setTimelogLoaded(false); return; }
    let cancelled = false;
    setTimelogLoaded(false);
    apiListTimeEntries()
      .then(rows => { if (!cancelled) { const list = Array.isArray(rows) ? rows : []; timelogRef.current = list; setTimelog(list); setTimelogLoaded(true); } })
      .catch(() => { if (!cancelled) setTimelog([]); });
    return () => { cancelled = true; };
  }, [currentUser?.id]);

  // Server-authoritative write helpers. No optimistic temp ids: a clock
  // entry is a background session record, the ~ms create latency is
  // invisible, and the live timer reads the active entry once it lands.
  // Using real server ids end-to-end means clock-out/delete never target
  // a row that doesn't exist (the localStorage-ghost class of bug).
  const tlAdd = useCallback(async (partial) => {
    if (!currentUser) return;
    try {
      const saved = await apiCreateTimeEntry({
        userId: currentUser.id, clockOut: null, hours: null, notes: "", ...partial,
      });
      if (!saved?.id) return; // respuesta vacía: no meter undefined en la lista
      timelogRef.current = [...(timelogRef.current || []), saved];
      setTimelog(prev => [...prev, saved]);
    } catch {
      toast.error(lang === "es" ? "No se pudo registrar la hora" : "Couldn't save time entry");
    }
  }, [currentUser, lang]);

  const tlReplace = useCallback((saved) => {
    if (!saved?.id) return;
    timelogRef.current = (timelogRef.current || []).map(e => (e.id === saved.id ? saved : e));
    setTimelog(prev => prev.map(e => (e.id === saved.id ? saved : e)));
  }, []);

  const tlPatch = useCallback(async (id, patch) => {
    try {
      const saved = await apiUpdateTimeEntry(id, patch);
      tlReplace(saved);
    } catch {
      toast.error(lang === "es" ? "No se pudo actualizar la hora" : "Couldn't update time entry");
    }
  }, [lang, tlReplace]);

  const tlDelete = useCallback(async (id) => {
    try {
      await apiDeleteTimeEntry(id);
      setTimelog(prev => prev.filter(e => e.id !== id));
    } catch {
      toast.error(lang === "es" ? "No se pudo borrar la hora" : "Couldn't delete time entry");
    }
  }, [lang]);

  // Single guarded entry point for opening a session. Reads the freshest
  // timelog via the ref (never a stale closure), refuses to run until the
  // server list has loaded, and holds an in-flight lock so concurrent
  // triggers collapse into one create instead of a pile of duplicates.
  const autoClockIn = useCallback(async (note) => {
    if (!currentUser || currentUser.isPlatformOwner || clockingRef.current || !timelogLoaded) return;
    clockingRef.current = true;
    try {
      // Si se está cerrando la sesión anterior, esperar: si no, todavía se
      // ve "abierta" y no se abriría la nueva.
      if (closingPromiseRef.current) await closingPromiseRef.current;
      const open = (timelogRef.current || []).find(e => e?.userId === currentUser.id && e.clockIn && !e.clockOut);
      if (open) return; // already clocked in (per the server-loaded state)
      const now = new Date();
      const time = `${String(now.getHours()).padStart(2,"0")}:${String(now.getMinutes()).padStart(2,"0")}`;
      await tlAdd({ date: localDay(now), clockIn: time, notes: note || (lang === "es" ? "Sesión automática" : "Auto session") });
    } finally {
      clockingRef.current = false;
    }
  }, [currentUser, lang, tlAdd, timelogLoaded]);

  // Horas entre la entrada de la sesión y `end`, con fecha completa: una
  // sesión que cruza la medianoche ya no sale en 0. Máximo 24 h (lo que
  // acepta el servidor).
  const sessionClose = (entry, end) => {
    const start = new Date(`${entry.date}T${String(entry.clockIn).slice(0, 5)}:00`);
    let stop = end;
    if (!Number.isNaN(start.getTime()) && stop < start) stop = start;
    const hours = Number.isNaN(start.getTime()) ? 0 : Math.min(24, Math.max(0, Math.round((stop - start) / 36e5 * 100) / 100));
    const clockOut = `${String(stop.getHours()).padStart(2,"0")}:${String(stop.getMinutes()).padStart(2,"0")}`;
    return { clockOut, hours };
  };

  // `at` = cuándo se fue la persona (su última actividad). Sin `at`, ahora
  // (logout: la persona está delante pulsando el botón).
  const closeActiveEntry = useCallback((extraNote, at) => {
    if (!currentUser) return;
    const active = (timelogRef.current || []).find(e => e?.userId === currentUser.id && e.clockIn && !e.clockOut);
    if (!active) return;
    const { clockOut, hours } = sessionClose(active, at instanceof Date ? at : new Date());
    const notes = extraNote ? ((active.notes ? active.notes + " · " : "") + extraNote) : active.notes;
    // Return the promise so logout can AWAIT the clock-out before the
    // page navigates away — otherwise the PATCH is aborted mid-flight and
    // the session stays "in progress" forever with no recorded duration.
    return tlPatch(active.id, { clockOut, hours, notes });
  }, [currentUser, tlPatch]);

  const autoClockOut = useCallback(() => closeActiveEntry(), [closeActiveEntry]);

  // Pasar a inactivo: cerrar la sesión en el momento de la última actividad.
  const goIdle = useCallback((at) => {
    if (isInactiveRef.current) return closingPromiseRef.current;
    isInactiveRef.current = true;
    const p = Promise.resolve(closeActiveEntry(lang === "es" ? "Inactividad" : "Inactive", at))
      .finally(() => { if (closingPromiseRef.current === p) closingPromiseRef.current = null; });
    closingPromiseRef.current = p;
    return p;
  }, [closeActiveEntry, lang]);

  // Auto clock-in once the server list has loaded. autoClockIn gates on
  // timelogLoaded + the in-flight lock + an open-session check, so firing
  // on every login AND when the load completes can only ever open one.
  useEffect(() => {
    if (!currentUser) return;
    markActivity(Date.now());
    isInactiveRef.current = false;
    autoClockIn();
  }, [currentUser?.id, timelogLoaded, autoClockIn, markActivity]);

  // Activity detection — mouse, keyboard, click, scroll, touch
  useEffect(() => {
    if (!currentUser) return;
    const onActivity = () => {
      const now = Date.now();
      const prev = readLastActivity();
      markActivity(now);
      // Vuelve después de más de 5 min y el reloj de abajo aún no lo había
      // notado (computadora dormida, pestaña congelada): cerrar primero la
      // sesión vieja en la última actividad, para no sumar el rato fuera.
      if (!isInactiveRef.current && now - prev >= INACTIVITY_TIMEOUT) goIdle(new Date(prev));
      if (isInactiveRef.current) {
        // User came back from inactivity — reopen a session. autoClockIn
        // is itself guarded (loaded + in-flight lock + open-check), so it
        // can't stack a duplicate on top of an already-open one.
        isInactiveRef.current = false;
        autoClockIn(lang === "es" ? "Sesión reanudada" : "Session resumed");
      }
    };
    const events = ["mousemove","keydown","click","scroll","touchstart"];
    events.forEach(ev => window.addEventListener(ev, onActivity, { passive: true }));
    return () => events.forEach(ev => window.removeEventListener(ev, onActivity));
  }, [currentUser?.id, lang, autoClockIn, goIdle, readLastActivity, markActivity]);

  // Inactivity checker — runs every 30s; after 5 min idle closes the session
  // AT THE LAST ACTIVITY, not now.
  useEffect(() => {
    if (!currentUser) return;
    const checker = setInterval(() => {
      const last = readLastActivity();
      if (Date.now() - last >= INACTIVITY_TIMEOUT && !isInactiveRef.current) goIdle(new Date(last));
    }, 30000);
    return () => clearInterval(checker);
  }, [currentUser?.id, goIdle, readLastActivity]);

  // Latido: cada minuto, SOLO si hubo actividad desde el anterior. El
  // servidor cierra en el último latido lo que deje de latir.
  useEffect(() => {
    if (!currentUser || currentUser.isPlatformOwner) return;
    const beat = async () => {
      if (isInactiveRef.current) return;
      const last = readLastActivity();
      if (last <= lastBeatRef.current) return; // sin actividad: que el servidor vea el silencio
      const active = (timelogRef.current || []).find(e => e?.userId === currentUser.id && e.clockIn && !e.clockOut);
      if (!active) return;
      lastBeatRef.current = last;
      try {
        const { data, closed } = await apiHeartbeatTimeEntry(active.id);
        if (closed && data) {
          // El servidor ya la había dado por abandonada. La persona está aquí
          // ahora: reflejar el cierre y abrir una nueva.
          tlReplace(data);
          autoClockIn(lang === "es" ? "Sesión reanudada" : "Session resumed");
        }
      } catch (err) {
        console.warn("[time] heartbeat failed:", err?.message);
      }
    };
    const iv = setInterval(beat, HEARTBEAT_MS);
    return () => clearInterval(iv);
  }, [currentUser?.id, lang, autoClockIn, readLastActivity, tlReplace]);

  // Cache the auth token so the tab-close handler (which can't await)
  // can build an authenticated request synchronously. Refreshed on
  // login and every 10 min — MSAL tokens last ~1h so this stays valid.
  const authTokenRef = useRef(null);
  useEffect(() => {
    if (!currentUser) { authTokenRef.current = null; return; }
    let cancelled = false;
    const refresh = () => {
      const g = window.__deskteAuth?.getAccessToken;
      if (g) g().then(t => { if (!cancelled) authTokenRef.current = t; }).catch(() => {});
    };
    refresh();
    const iv = setInterval(refresh, 10 * 60 * 1000);
    return () => { cancelled = true; clearInterval(iv); };
  }, [currentUser?.id]);

  // Best-effort clock-out when the tab/window is closed outright (no
  // Logout click). A normal fetch is aborted on unload, so use
  // keepalive — the browser still delivers it. `pagehide` (not
  // visibilitychange) so merely switching tabs does NOT clock out.
  // Si esto no llega, el servidor la cierra en el último latido.
  useEffect(() => {
    if (!currentUser) return;
    const onPageHide = () => {
      if (isInactiveRef.current) return; // ya cerrada por inactividad
      const active = (timelogRef.current || []).find(e => e?.userId === currentUser.id && e.clockIn && !e.clockOut);
      const token = authTokenRef.current;
      if (!active || !token) return;
      const { clockOut, hours } = sessionClose(active, new Date(readLastActivity()));
      const base = import.meta.env.VITE_API_URL || '';
      try {
        fetch(`${base}/api/v1/time-entries/${active.id}`, {
          method: 'PATCH',
          keepalive: true,
          headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
          body: JSON.stringify({ clockOut, hours, notes: active.notes || '' }),
        }).catch(() => {});
      } catch { /* unload best-effort — nothing else we can do */ }
    };
    window.addEventListener('pagehide', onPageHide);
    return () => window.removeEventListener('pagehide', onPageHide);
  }, [currentUser?.id, readLastActivity]);

  const role = currentUser?.role;
  const isSoloAgent = role === "solo_agent";
  const isAgentInAgency = role === "agent";
  const isAgencyOwner = role === "agency_owner" || role === "agency_admin";
  const isAssistant = role === "assistant";
  const isAgent = isSoloAgent || isAgentInAgency; // has own CRM
  // Agency/Enterprise OWNERS work the full CRM like a solo agent (sharing the
  // book with their co-owner) PLUS team management + the new analytics module —
  // NOT the old management-only owner menu. This also covers the Solo "+1 Admin"
  // add-on: that admin is promoted to a real agency_owner while the agency stays
  // on the SOLO plan, and must still see the full CRM. So ownerFullCrm is true for
  // EVERY owner/admin regardless of plan (the older `plan !== "SOLO"` guard hid all
  // the CRM modules from Solo add-on admins). The legacy management-only NAV branch
  // below is now effectively dead but kept as a harmless fallback.
  //
  // SE DECLARA AQUI, ANTES de `canSeeCRM`, y no puede volver a bajarse: ese es
  // el orden que hace que la puerta de abajo pueda mirarlo (una `const` leida
  // antes de su linea revienta con ReferenceError, no devuelve `undefined`).
  const ownerFullCrm = isAgencyOwner;
  // Quien ve los MODULOS del CRM. Tiene que incluir al dueño con CRM completo:
  // el menu se le arma con `ownerFullCrm` (ver el NAV mas abajo), asi que si
  // esta puerta no lo contempla, el dueño ve las entradas del menu y al pulsar
  // cualquiera no se pinta NADA — sin error, sin aviso, sin nada.
  //
  // Eso es exactamente lo que pasaba (Lissette, 2026-08-26, mirando como un
  // agency_owner: "es un admin agente y no va nada del dashboard"). Eran SEIS
  // modulos muertos a la vez — Inicio, Seguimiento, Citas, Tickets, Eventos del
  // Mes y Envios programados — porque el menu se amplio a los dueños y esta
  // linea se quedo atras. Menu y render se leen de lo MISMO, o se separan otra
  // vez sin que nadie lo note.
  const canSeeCRM = isAgent || isAssistant || ownerFullCrm; // sees CRM modules
  const canSeeOwnerModules = isAgent; // sees metrics, expenses, etc.
  // The agent-only module block (metrics/team/licenses/etc.) is also shown to
  // full-CRM owners.
  const showOwnerModules = canSeeOwnerModules || ownerFullCrm;
  // MI BÓVEDA PERSONAL (Lissette 2026-10-14): claves que solo ve quien las
  // guarda. Para agentes y dueños (tienen PIN propio); no para asistentes, que
  // revelan con el PIN de su agente. Tampoco en "ver como": el servidor la
  // cierra ahí (vault.routes.ts#rutasBovedaPersonal) y el menú no la ofrece.
  const verComoUsuario = (() => { try { return !!leerEntrada("deskte:impersonateUserId"); } catch { return false; } })();
  const veBovedaPersonal = showOwnerModules && !currentUser?.isPlatformOwner && !verComoUsuario;
  // Agency-wide analytics module: shown to any agency owner/admin (Solo agents
  // aren't owners, so they never see it). The Agency/Enterprise PLAN check is
  // enforced by the backend (GET /team/analytics → 403 PLAN_REQUIRED, which the
  // view renders as a friendly message). Gating the nav on currentUser.agency
  // .plan broke under browse-as-agency (currentUser stays the platform owner,
  // not the browsed agency), so it lives server-side instead.

  // Paneles de Reportes — entrada propia, justo debajo de Métricas. Vivía
  // escondida como tercera pestaña de Reportes de Equipo y nadie la encontraba.
  // Se declara una vez y se usa en los dos bloques del menú (agentes/dueños y
  // asientos) porque son ramas excluyentes: cada usuario ve una sola.
  const navDashboards = { id:"report_dashboards", label:lang==="es"?"Paneles de Reportes":"Report Dashboards", icon:LayoutDashboard };

  const NAV = (isAgencyOwner && !ownerFullCrm) ? [
    // AGENCY OWNER (legacy management-only menu — only reached by a non-Agency/
    // Enterprise owner, which in practice doesn't exist; Agency/Enterprise
    // owners fall through to the full CRM menu below + owner extras).
    { id:"agency",    label:lang==="es"?"Mi Agencia":"My Agency", icon:TrendingUp },
    { id:"metrics",   label:lang==="es"?"Métricas":"Metrics", icon:BarChart2 },
    { id:"calendar",  label:lang==="es"?"Calendario":"Calendar", icon:Calendar },
    { id:"tasks",     label:lang==="es"?"Tareas":"Tasks", icon:ListTodo, badge:taskCount>0?taskCount:null, badgeColor:"bg-purple-500 text-white" },
    // Inbox view removed 2026-05-13 — replies to client emails now flow into
    // the client's profile via SendGrid Inbound Parse (Reply-To trick).
    { id:"mass_email", label:lang==="es"?"Email Masivo":"Mass Email", icon:Send },
    { id:"campaigns", label:lang==="es"?"Campañas":"Campaigns", icon:Megaphone },
    { id:"email_suppressions", label:lang==="es"?"No-Enviar (Unsubscribed)":"Unsubscribed", icon:ShieldOff },
    { id:"sms_suppressions", label:lang==="es"?"No-Textear (SMS)":"Do-Not-Text (SMS)", icon:PhoneOff },
    { id:"timetrack", label:lang==="es"?"Horas del Equipo":"Team Hours", icon:Clock },
    { id:"signatures", label:lang==="es"?"Firmas":"Signatures", icon:FileSignature },
    { id:"resources", label:lang==="es"?"Recursos":"Resources", icon:Globe },
    { id:"sheets",    label:lang==="es"?"Hojas":"Sheets", icon:Table },
    { id:"team_training", label:lang==="es"?"Team Training":"Team Training", icon:GraduationCap },
    { id:"expenses",  label:lang==="es"?"Gastos Empresa":"Company Expenses", icon:FileText },
    { id:"my_email",  label:lang==="es"?"Mi Correo":"My Inbox", icon:Mail },
    { id:"profile",   label:lang==="es"?"Mi Perfil":"My Profile", icon:UserCircle },
    { id:"team",      label:lang==="es"?"Equipo":"Team", icon:UserCog },
    { id:"active_members", label:lang==="es"?"Miembros Activos":"Active Members", icon:Users },
    { id:"agent_production", label:lang==="es"?"Producción por Agente":"Production by Agent", icon:BarChart2 },
    { id:"agency_analytics", label:lang==="es"?"Métricas y Análisis":"Metrics & Analytics", icon:TrendingUp },
    { id:"hipaa_seats", label:lang==="es"?"HIPAA Seats":"HIPAA Seats", icon:ShieldCheck },
  ] : [
    // SOLO AGENT / AGENT IN AGENCY / ASSISTANT: full CRM
    // No badge here: the alert count lives on the "Alertas" item below, so
    // showing the same number on Dashboard was a confusing duplicate
    // (Lissette 2026-06-01).
    { id:"dashboard",  label:t.nav.dashboard,   icon:TrendingUp },
    { id:"alerts",     label:lang==="es"?"Alertas":"Alerts", icon:Bell, badge:alertCount>0?alertCount:null, badgeColor:"bg-amber-500 text-black" },
    { id:"clients",    label:t.nav.clients,      icon:Users },
    { id:"conversations", label:lang==="es"?"Conversaciones":"Conversations", icon:MessageSquare },
    { id:"leads",     label:"Leads",  icon:UserPlus },
    { id:"pipeline",  label:lang==="es"?"Embudo":"Pipeline", icon:Layers },
    { id:"onboarding", label:lang==="es"?"Prospecto y Referido":"Prospects & Referrals", icon:Star },
    { id:"lead_forms", label:lang==="es"?"Formularios":"Forms", icon:FileText },
    { id:"applications", label:lang==="es"?"Aplicaciones":"Applications", icon:ClipboardList },
    { id:"policies",   label:t.nav.policies,     icon:Layers },
    { id:"payment_tracker", label:lang==="es"?"Pagos del Mes":"Monthly Payments", icon:CreditCard },
    { id:"renewals",   label:t.nav.renewals,     icon:RefreshCw, badge:renewCount>0?renewCount:null, badgeColor:"bg-orange-500 text-white" },
    { id:"tasks",      label:t.nav.tasks,        icon:ListTodo, badge:taskCount>0?taskCount:null, badgeColor:"bg-purple-500 text-white" },
    // "Plantillas" (plantillas de proceso / listas de tareas) sale del menu por
    // pedido de Lissette (2026-09-02). El 2026-08-20 habia pedido lo contrario
    // -- "quita el power dialer solamente deja el otro" -- asi que esto la
    // corrige a ella misma, con las dos fechas escritas para que nadie lo
    // deshaga creyendo que fue un descuido.
    //
    // Se apaga tambien el render (mas abajo), porque quitarlo del menu no basta:
    // el hash abre la vista sin preguntarle a NAV.
    //
    // Los permisos templates.view / templates.edit NO se tocan: tambien mandan
    // sobre las plantillas de correo de Campanas y sobre las de recordatorio, y
    // quitarlos le habria quitado a los asientos algo que ella no pidio quitar.
    { id:"recurring",  label:lang==="es"?"Recurrentes":"Recurring", icon:RefreshCw },
    // Inbox view removed 2026-05-13 — replies flow into client profiles instead.
    { id:"mass_email", label:lang==="es"?"Email Masivo":"Mass Email", icon:Send },
    { id:"sent_emails", label:lang==="es"?"Emails Enviados":"Sent Emails", icon:Send },
    { id:"sequences",  label:lang==="es"?"Secuencias":"Sequences", icon:RefreshCw },
    { id:"campaigns",  label:lang==="es"?"Campañas":"Campaigns", icon:Megaphone },
    // Encuestas al cliente (Lissette 2026-10-15). Se envian desde Email Masivo.
    { id:"surveys",    label:lang==="es"?"Encuestas":"Surveys", icon:ClipboardList },
    { id:"email_suppressions", label:lang==="es"?"No-Enviar (Unsubscribed)":"Unsubscribed", icon:ShieldOff },
    { id:"sms_suppressions", label:lang==="es"?"No-Textear (SMS)":"Do-Not-Text (SMS)", icon:PhoneOff },
    { id:"quotes_invoices", label:lang==="es"?"Cotizaciones":"Quotes", icon:FileText },
    { id:"invoices",   label:lang==="es"?"Facturas":"Invoices", icon:Receipt },
    { id:"recurring_invoices", label:lang==="es"?"Facturas Recurrentes":"Recurring Invoices", icon:Repeat },
    { id:"requests",   label:t.nav.requests,     icon:Send },
    { id:"signatures", label:t.nav.signatures,   icon:FileSignature },
    { id:"followups",  label:lang==="es"?"Seguimiento":"Follow-ups", icon:ClipboardCheck, badge:fuOverdue>0?fuOverdue:null, badgeColor:"bg-red-500 text-white" },
    { id:"citas", label:lang==="es"?"Citas":"Appointments", icon:CalendarPlus },
    { id:"citas_medicas", label:lang==="es"?"Citas médicas":"Medical visits", icon:CalendarPlus },
    { id:"tickets",    label:lang==="es"?"Tickets":"Tickets", icon:Ticket, badge:ticketsOpen>0?ticketsOpen:null, badgeColor:"bg-amber-500 text-black" },
    { id:"resources",  label:lang==="es"?"Recursos":"Resources", icon:Globe },
    { id:"sheets",     label:lang==="es"?"Hojas":"Sheets", icon:Table },
    { id:"team_training", label:lang==="es"?"Team Training":"Team Training", icon:GraduationCap },
    { id:"reports",    label:lang==="es"?"Comisiones":"Commissions", icon:BarChart2 },
    { id:"commissions_table", label:lang==="es"?"Comisiones por Póliza":"Commissions by Policy", icon:BarChart2 },
    // Lo que se le paga a cada analista (Lissette 2026-10-11).
    { id:"analyst_commissions", label:lang==="es"?"Comisiones por Analista":"Commissions by Analyst", icon:BarChart2 },
    { id:"reports_analytics", label:lang==="es"?"Análisis":"Analytics", icon:TrendingUp },
    { id:"sales_report", label:lang==="es"?"Reporte de Ventas":"Sales Report", icon:BarChart2 },
    { id:"client_reports", label:lang==="es"?"Reportes de Clientes":"Client Reports", icon:Users },
    { id:"team_reports", label:lang==="es"?"Reportes de Equipo":"Team Reports", icon:BarChart2 },
    { id:"active_members", label:lang==="es"?"Miembros Activos":"Active Members", icon:Users },
    { id:"workflows", label:lang==="es"?"Automatizaciones":"Workflows", icon:Activity },
    { id:"ai_assistant", label:lang==="es"?"Asistente AI":"AI Assistant", icon:Sparkles },
    { id:"deskte_ai",  label:aiName, icon:Bot },
    { id:"goals",      label:lang==="es"?"Metas":"Goals", icon:TrendingUp },
    { id:"calendar",  label:lang==="es"?"Calendario":"Calendar", icon:Calendar },
    { id:"month_events", label:lang==="es"?"Eventos del Mes":"This Month", icon:Gift },
    { id:"scheduled_sends", label:lang==="es"?"Correos Programados":"Scheduled Emails", icon:Clock },
    // Power Dialer fuera del menu (Lissette 2026-08-20: "quita o saca el power
    // dialer solamente"). Se quita SOLO de aqui: la vista y su render siguen en
    // el archivo, asi que volver a encenderlo es devolver esta linea. Y como el
    // enlace #<vista> se valida contra NAV, sacarlo de aqui tambien cierra la
    // puerta de atras. Templates NO se toca — ese se queda.
    { id:"automations",label:"AI Automations", icon:Activity },
    { id:"booking",   label:"Booking Link", icon:ExternalLink },
    { id:"import",    label:lang==="es"?"Importar":"Import", icon:Download },
    // Agent-only modules (also shown to full-CRM agency owners; not to assistants)
    ...(showOwnerModules ? [
      { id:"licenses",  label:lang==="es"?"Licencias y Certificaciones":"Licenses & Certifications", icon:FileText, badge:licExpiring>0?licExpiring:null, badgeColor:"bg-amber-500 text-black" },
      { id:"appointments", label:"Company Appointments", icon:CheckCircle },
      { id:"vault",     label:lang==="es"?"Bóveda de Claves":"Password Vault", icon:KeyRound },
      ...(veBovedaPersonal ? [{ id:"my_vault", label:lang==="es"?"Mi Bóveda Personal":"My Personal Vault", icon:Lock }] : []),
      { id:"company_info", label:lang==="es"?"Info de Compañías":"Company Information", icon:Building },
      { id:"expenses",  label:lang==="es"?"Gastos":"Expenses", icon:FileText },
      { id:"payroll",   label:lang==="es"?"Nómina y Formularios":"Payroll & Forms", icon:FileText },
      { id:"metrics",   label:lang==="es"?"Métricas":"Metrics", icon:FileText },
      navDashboards,
      { id:"timetrack", label:t.timetrack.title,  icon:Clock, badge:activeClockIn?"●":null, badgeColor:"bg-emerald-500 text-white" },
      { id:"team",      label:t.nav.team, icon:UserCog },
      { id:"hipaa_seats", label:lang==="es"?"HIPAA Seats":"HIPAA Seats", icon:ShieldCheck },
    ] : []),
    // Owner-only extras for full-CRM agency owners: agency management home +
    // the agent-oversight modules (private-books production + agency analytics).
    ...(ownerFullCrm ? [
      { id:"agency",    label:lang==="es"?"Mi Agencia":"My Agency", icon:Building },
      { id:"agent_production", label:lang==="es"?"Producción por Agente":"Production by Agent", icon:BarChart2 },
      { id:"agency_analytics", label:lang==="es"?"Métricas y Análisis":"Metrics & Analytics", icon:TrendingUp },
    ] : []),
    // Assistant modules — listed here, then filtered by seatPermissions
    // (visibleNAV / SEAT_NAV_PERMISSION_MAP). The seat sees the supervising
    // agent's licenses / company appointments only if the agent granted it.
    ...(isAssistant ? [
      { id:"licenses", label:lang==="es"?"Licencias y Certificaciones":"Licenses & Certifications", icon:FileText },
      { id:"appointments", label:lang==="es"?"Citas con Compañías":"Company Appointments", icon:CheckCircle },
      { id:"vault",     label:lang==="es"?"Bóveda de Claves":"Password Vault", icon:KeyRound },
      { id:"company_info", label:lang==="es"?"Info de Compañías":"Company Information", icon:Building },
      // El asiento mira los paneles compartidos; armarlos requiere no ser asiento
      // (canManage), y verlos requiere reports.view en SEAT_NAV_PERMISSION_MAP.
      navDashboards,
    ] : []),
    // Available to all roles
    { id:"help_center", label:lang==="es"?"Centro de Ayuda":"Help Center", icon:BookOpen },
    { id:"team_chat", label:lang==="es"?"Chat de Equipo":"Team Chat", icon:MessageSquare, badge:chatUnread>0?(chatUnread>99?"99+":chatUnread):null, badgeColor:"bg-cyan-500 text-black" },
    // Support moved to the top-bar 🎧 menu (SupportMenu); no sidebar item.
    { id:"my_email",  label:lang==="es"?"Mi Correo":"My Inbox", icon:Mail },
    { id:"whatsapp_integration", label:lang==="es"?"Integración WhatsApp":"WhatsApp Integration", icon:MessageSquare },
    { id:"phone_integration", label:lang==="es"?"SMS y Llamadas":"SMS & Calls", icon:Phone },
    // HealthSherpa: cada agente conecta SU cuenta (una llave = una cuenta de
    // agente). Las dos primeras NO estan en SEAT_NAV_PERMISSION_MAP, que
    // deniega por defecto: un asistente no tiene cuenta propia alli y no
    // tendria llave que pegar.
    //
    // "Inscribir" SI la ve, si su agente le marca el permiso: en una agencia
    // el asistente es quien prepara la inscripcion. No elige a nombre de
    // quien sale -- eso lo decide el servidor por el dueño del cliente.
    { id:"healthsherpa_integration", label:lang==="es"?"HealthSherpa":"HealthSherpa", icon:HeartPulse },
    { id:"healthsherpa_emparejar", label:lang==="es"?"Emparejar HealthSherpa":"Match HealthSherpa", icon:Link2 },
    { id:"healthsherpa_inscribir", label:lang==="es"?"Inscribir en HealthSherpa":"Enroll in HealthSherpa", icon:UserPlus },
    { id:"profile",   label:lang==="es"?"Mi Perfil":"My Profile", icon:UserCircle },
  ];

  // ── Seat (assistant) sidebar gating — HIPAA Minimum Necessary ──────────
  // Maps NAV item id → seat permission key. Items not in the map are HIDDEN
  // from assistants by default (default-deny). The agent activates each
  // permission individually in "My Team" → seat permissions.
  // Special tokens:
  //   '__always'       → always visible (the seat's own profile/inbox)
  const SEAT_NAV_PERMISSION_MAP = {
    dashboard:          'clients.view',
    clients:            'clients.view',
    conversations:      'conversations.view',
    pipeline:           'leads.view',
    leads:              'leads.view',
    prospects:          'clients.view',
    lead_forms:         'forms.view',
    applications:       'clients.view',
    policies:           'policies.view',
    payment_tracker:    'policies.view',
    onboarding:         'clients.view',
    renewals:           'renewals.view',
    alerts:             'clients.view',
    tasks:              'tasks.view',
    templates:          'templates.view',
    recurring:          'recurring.view',
    email:              'email.connect',
    mass_email:         'campaigns.view',
    sequences:          'sequences.view',
    campaigns:          'campaigns.view',
    surveys:            'campaigns.view',
    // Do-not-contact lists (CAN-SPAM / TCPA) — always visible to seats,
    // read-only: anyone who can message a client must know who opted out.
    // Mutations stay owner/solo-only (backend requireOwnerOrSolo + canMutate).
    email_suppressions: '__always',
    sms_suppressions:   '__always',
    // Solo INSCRIBIR. La pantalla de la llave y la de emparejar siguen fuera
    // del mapa (y por tanto ocultas): no tiene cuenta propia en HealthSherpa.
    healthsherpa_inscribir: 'healthsherpa.enroll',
    quotes_invoices:    'quotes.view',
    invoices:           'invoices.view',
    recurring_invoices: 'recurring.view',
    requests:           'requests.view',
    signatures:         'signatures.view',
    resources:          'resources.view',
    team_training:      '__always',
    reports:            'commissions.view',
    commissions_table:  'commissions.view',
    // Un asiento ve aquí SOLO sus ventas de analista y lo que le toca
    // (Lissette 2026-10-29: "cada seat vea solo lo suyo"), así que no necesita
    // commissions.view — que le abriría las comisiones de toda la agencia.
    // Desde el 2026-10-30 lo ve solo si tiene marcada su casilla en "Qué
    // reportes puede ver" (seatPuedeVerReporte, vía REPORTE_DE_LA_VISTA).
    analyst_commissions: 'reportsOnly.analystCommissions',
    reports_analytics:  'reports.view',
    sales_report:       'reports.view',
    client_reports:     'reports.view',
    team_reports:       'reports.view',
    report_dashboards:  'reports.view',
    active_members:     'reports.view',
    workflows:          'workflows.view',
    automations:        'workflows.view',
    goals:              'goals.view',
    calendar:           'calendar.view',
    // Month events (birthdays + holidays) is client-derived like the
    // dashboard, so a seat sees it with clients.view. Scheduling the
    // greeting still requires campaigns.edit (enforced by the backend and
    // by the `canSchedule` prop, which hides the Schedule buttons).
    month_events:       'clients.view',
    // La cola de envíos es la misma lista agency-scope que ya alimenta los
    // marcadores de "Programado" — campos ligeros, sin asunto ni cuerpo. Un
    // seat la ve con campaigns.view; cancelar sigue siendo cosa de quien
    // programó la fila o del dueño de la agencia (lo impone la ruta DELETE).
    scheduled_sends:    'campaigns.view',
    // Seguimiento / Envíos — seats can VIEW with clients.view; writing needs
    // agent-or-above (the backend's requireAgentOrAbove blocks seat writes),
    // so the board renders read-only for assistants.
    followups:          'clients.view',
    // Tickets — client service is collaborative; seats can use them (they see
    // tickets assigned to or created by them; the backend scopes the rest).
    tickets:            'clients.view',
    // Agent's own credentials — the seat sees the supervising agent's
    // state licenses / company appointments only if granted.
    licenses:           'licenses.view',
    appointments:       'appointments.view',
    vault:              'vault.view',
    company_info:       'vault.view',
    // "Mi Correo" (mailbox connect) is HIDDEN for seats — they don't connect
    // their own mailbox; outbound goes under the supervising agent (Lissette
    // 2026-06-19 #4). No map entry → seat-denied by default; agents/owners
    // still get it via the full NAV (the map only filters seats).
    // Team chat is core team communication — available to every seat.
    team_chat:          '__always',
    // Support: any seat can report a problem to the Deskte team.
    support:            '__always',
    // Ideas board: any seat can propose / vote feature ideas.
    ideas:              '__always',
    // Custom Sheets: shared team tables — open to everyone.
    sheets:             '__always',
    // Deskte AI assistant — available to every seat.
    deskte_ai:          '__always',
    // Help center is for everyone, including seats.
    help_center:        '__always',
    whatsapp_integration: 'clients.edit',
    profile:            '__always',
    // Sent Emails view is gated on the seat being allowed to send. The
    // backend further filters to "mine" by default so seats only see
    // emails they personally sent.
    sent_emails:        'campaigns.view',
    // Import = bulk client/policy creation, so it rides on the same
    // permission as creating/editing clients. A seat the agent has
    // granted clients.edit can import; otherwise still default-deny.
    import:             'clients.edit',
    // Booking Link (Josep, 2026-10-19: "el booking link no le sale a los
    // asientos"). Estaba fuera del mapa —sin llave = oculto para todo asiento—
    // y eso dejaba sin pantalla lo que se hizo el 2026-10-17: el asiento puede
    // tener su propio enlace y cambiar el de cada agente ("Enlace de:"). El
    // servidor ya lo dejaba pasar (booking.routes.ts, enlaceDeQuien); faltaba
    // el menú. Va con el mismo permiso que el Calendario, que es donde caen
    // las citas que entran por el enlace.
    booking:            'calendar.view',
    // ai_assistant, dialer → no key, default-deny for seats
  };
  const _seatPerms = isAssistant ? normalizeSeatPermissions(currentUser?.seatPermissions) : null;
  const seatHasNavPerm = (id) => {
    const key = SEAT_NAV_PERMISSION_MAP[id];
    if (!key) return false;
    if (key === '__always') return true;
    // Los reportes, ademas, uno por uno ("Que reportes puede ver").
    if (REPORTE_DE_LA_VISTA[id]) return seatPuedeVerReporte(_seatPerms, REPORTE_DE_LA_VISTA[id]);
    return hasSeatPermission(_seatPerms, key);
  };
  // PLATFORM_OWNER sees only the dedicated "Platform Admin" button (rendered
  // separately below the nav loop) — no CRM tabs at all. EXCEPT while
  // browsing-as-agency: then they navigate the impersonated agency's CRM
  // with the full sidebar like any agent would.
  let _isImpersonating = false;
  try { _isImpersonating = !!leerEntrada("deskte:impersonateAgencyId"); } catch {}
  const visibleNAV = (currentUser?.isPlatformOwner && !_isImpersonating)
    ? []
    : isAssistant ? NAV.filter(item => seatHasNavPerm(item.id)) : NAV;

  // Snap a seat back to a safe view when its current view is denied (e.g. the
  // supervisor just turned off a permission, or the seat had a stale state).
  useEffect(() => {
    if (!isAssistant) return;
    if (seatHasNavPerm(view)) return;
    // Prefer the first visible NAV item; fall back to "profile" which is always allowed.
    const first = visibleNAV[0]?.id || 'profile';
    if (view !== first) setView(first);
  }, [isAssistant, view, JSON.stringify(currentUser?.seatPermissions || {})]);

  // Demo seeding — see _demoMode above. Runs once on mount and loads the same
  // fictional dataset the reset panel offers, then signs in as the demo agent
  // so the app opens straight on a populated dashboard.
  // Declared here (not next to _demoMode) because every setter it calls is
  // defined further down the component body — and because it reads NAV.
  useEffect(() => {
    if (!_demoMode) return;
    setClients(SEED_CLIENTS); setPolicies(SEED_POLICIES); setDocs(SEED_DOCS);
    setTasks(SEED_TASKS); setCommissions(SEED_COMMISSIONS); setUsers(SEED_USERS);
    setActivitylog(SEED_ACTIVITYLOG); setTimelog(SEED_TIMELOG); setRequests(SEED_REQUESTS);
    setSignatures(SEED_SIGNATURES); setExpenses(SEED_EXPENSES); setLeads(SEED_LEADS);
    setChangeHistory(SEED_CHANGEHISTORY); setDocTemplates(SEED_DOC_TEMPLATES);
    // The demo agent (SEED_USERS u2) — the role the tutorials are written for.
    const demoAgent = SEED_USERS.find(u => u.id === "u2") || SEED_USERS[0];
    // In the PUBLIC demo the agent is a person, not a placeholder: a prospect
    // opening the link is greeted by name. The dev `?demo=1` path keeps the
    // plain "Agent" so the 57 recorded tutorials stay consistent with what a
    // re-recording would produce.
    setCurrentUser(IS_DEMO_BUILD
      ? { ...demoAgent, name: "Sofia Marrero", initials: "SM",
          email: "sofia@example.com", companyName: "Agencia Demo" }
      : demoAgent);

    // Deep link: `#clients`, `#commissions`, … opens the demo straight on that
    // module, so deskte.com/demo/ can hand a visitor the exact screen a tour
    // step is talking about. Validated against NAV — an unknown or stale hash
    // falls back to the dashboard rather than rendering an empty shell. (The
    // view→hash sync effect above keeps writing the hash from here on.)
    let wanted = "";
    try { wanted = (window.location.hash || "").replace(/^#/, ""); } catch {}
    // `#client/<id>` lands on the Clients view; the restore effect there reads
    // the same hash and opens that client's full profile.
    if (wanted.startsWith("client/")) wanted = "clients";
    setView(NAV.some(item => item.id === wanted) ? wanted : "dashboard");
  }, []);

  // Public signing page — no login required
  const hashSign = (typeof window !== "undefined" && window.location.hash || "").match(/#sign\//);
  if (hashSign) {
    return <PublicSigningPage signatures={signatures} onSignaturesChange={setSignatures} clients={clients} />;
  }
  // Public resource portal — no login required
  const hashResources = (typeof window !== "undefined" && window.location.hash || "").match(/#resources\//);
  if (hashResources) {
    return <PublicResourcePortal resources={resources} resourceTokens={resourceTokens} clients={clients} />;
  }
  // (The real client-facing upload portal is DocPortalLandingPage, routed by
  // AuthGate at the PATH /upload/:token — it renders before this SPA. The old
  // #upload/ hash route + PublicUploadPortal demo was removed in M1 cleanup.)
  // F-N7 (audit 2026-05-22): CSS_STR is now loaded from crm-app/styles/dkt.css
  // (imported once in main.jsx) so the SPA's CSP can drop `style-src
  // 'unsafe-inline'`. The previous `<style>{CSS_STR}</style>` wrappers are
  // gone — the class names below still resolve against the bundle CSS.
  if(betaToken && !currentUser) return <BetaOnboardScreen token={betaToken} users={users} setUsers={setUsers} onLogin={(u)=>{setCurrentUser(u);setBetaToken(null);}} lang={lang}/>;
  if(!currentUser) return <LoginScreen users={users} onLogin={setCurrentUser} lang={lang} setLang={setLang}/>;
  return <div className="dkt-shell" data-theme={theme} data-palette={palette} style={{minHeight:"100dvh",background:theme==="dark"?"#070d14":"#f0ece6",color:theme==="dark"?"#c8dff0":"#1a2332",fontFamily:"var(--dkt-user-font, system-ui, sans-serif)"}}>
    {/* HIPAA seat gate — a blocking overlay for seats who haven't completed the
        agency's training. Self-hides when not required (non-seat or already done). */}
    {isAssistant && <HipaaTrainingGate currentUser={currentUser} lang={lang}/>}
    {showOnboarding && <OnboardingTour currentUser={currentUser} lang={lang} onClose={()=>setShowOnboarding(false)} onNavigate={(v)=>setView(v)} onResetDemo={()=>{setClients([]);setPolicies([]);setCommissions([]);setLeads([]);setTasks([]);setChangeHistory([]);setActivitylog([]);setDocs([]);setRequests([]);}}/>}
    {calcOpen && <CalculatorWidget lang={lang} onClose={()=>setCalcOpen(false)} userPrefs={userPrefs} onPrefsChange={setUserPrefs}/>}
    {resendConfirm && (
      <div onClick={resendConfirm.onCancel} style={{position:"fixed",inset:0,zIndex:100001,background:"rgba(0,0,0,.7)",backdropFilter:"blur(6px)",display:"flex",alignItems:"center",justifyContent:"center",padding:"1rem"}}>
        <div onClick={e=>e.stopPropagation()} style={{background:"var(--c-surface,#0d1c2e)",border:"1px solid var(--c-border2,#1f3f60)",borderRadius:16,padding:"1.5rem",maxWidth:420,width:"100%",boxShadow:"0 24px 80px rgba(0,0,0,.6)"}}>
          <div style={{fontSize:"2rem",textAlign:"center",marginBottom:".5rem"}}>⚠️</div>
          <div style={{fontWeight:800,fontSize:"1rem",color:"var(--c-white,#eef6ff)",textAlign:"center",marginBottom:".5rem"}}>
            {lang==="es"?"Esta accion ya fue realizada":"This action was already done"}
          </div>
          <div style={{fontSize:".85rem",color:"var(--c-text2,#7aa3c0)",textAlign:"center",marginBottom:"1.25rem",lineHeight:1.5}}>
            <strong style={{color:"var(--c-cyan,#00d4ff)"}}>{resendConfirm.by}</strong>{" "}
            {lang==="es"?"ya envio esto el":"already sent this on"}{" "}
            <strong>{new Date(resendConfirm.at).toLocaleString("en-US",{dateStyle:"medium",timeStyle:"short"})}</strong>
            <br/>{lang==="es"?"Deseas enviarlo de nuevo?":"Do you want to send it again?"}
          </div>
          <div style={{display:"flex",gap:".5rem"}}>
            <button onClick={resendConfirm.onCancel} style={{flex:1,padding:".65rem",borderRadius:9,border:"1px solid var(--c-border,#1a3550)",background:"var(--c-surface2,#112538)",color:"var(--c-text2,#7aa3c0)",fontWeight:700,fontSize:".85rem",cursor:"pointer"}}>
              {lang==="es"?"Cancelar":"Cancel"}
            </button>
            <button onClick={resendConfirm.onConfirm} style={{flex:1,padding:".65rem",borderRadius:9,border:"none",background:"linear-gradient(135deg,#f59e0b,#d97706)",color:"#fff",fontWeight:700,fontSize:".85rem",cursor:"pointer"}}>
              {lang==="es"?"Enviar de Nuevo":"Send Again"}
            </button>
          </div>
        </div>
      </div>
    )}
    <aside className={`dkt-sidebar${sidebarOpen?" open":""}`}>
      <div className="dkt-logo-wrap">
        <div style={{display:"flex",alignItems:"center",gap:10}}>
          <img src={assetUrl(palette==="sunset"?"logo/dk-arrow-sunset-tight.svg":"logo/dk-arrow-ocean-tight.svg")} alt="" style={{height:38,width:"auto",display:"block",flexShrink:0}}/>
          <div style={{display:"flex",flexDirection:"column",gap:1,lineHeight:1}}>
            <span style={{fontFamily:"var(--font-display)",fontSize:"1.35rem",fontWeight:800,letterSpacing:"-.02em",color:theme==="light"?"#1a2332":"var(--c-white,#eef6ff)",lineHeight:1}}>Deskte</span>
            <div className="dkt-logo-ver" style={{margin:0,lineHeight:1}}>YOUR INSURANCE DESK</div>
          </div>
        </div>
      </div>
      <nav className="dkt-nav">
        {(() => {
          // Split the nav into "favorites" + "rest" so we can render
          // each group with its own heading. The previous version only
          // sorted favorites to the top of one mixed list and showed
          // the toggle star at 0 opacity until hover, which made the
          // feature undiscoverable — Lissette had no way to know she
          // could pin items. New behavior: a labeled "⭐ Favoritos"
          // section appears whenever the agent has at least one pin,
          // the star toggle stays subtly visible on every row, and a
          // thin divider separates the two groups.
          const favs = (userPrefs||{}).favorites||[];
          const favItems = visibleNAV.filter(item => favs.includes(item.id));
          const restItems = visibleNAV.filter(item => !favs.includes(item.id));
          // Collapsible nav groups — remembered in userPrefs.collapsedNav so the
          // user can fold the sections they don't use (great on a small screen).
          const collapsedNav = (userPrefs||{}).collapsedNav||[];
          const isGroupCollapsed = (g) => collapsedNav.includes(g);
          const toggleGroup = (g) => setUserPrefs(p=>{ const cur=(p&&p.collapsedNav)||[]; return {...p, collapsedNav: cur.includes(g)?cur.filter(x=>x!==g):[...cur,g]}; });
          // Group the (non-favorited) nav into labeled sections so the long
          // flat list stops feeling jumbled. Each item id maps to a group;
          // groups render in GROUP_ORDER, and empty groups are skipped (so a
          // seat with limited permissions or a fully-favorited group just
          // doesn't show that header). Anything unmapped falls into "account".
          const NAV_GROUP = {
            dashboard:"summary", alerts:"summary", tasks:"summary", calendar:"summary", month_events:"summary", agency:"summary", tickets:"summary", followups:"summary", citas:"summary", citas_medicas:"summary",
            conversations:"bandeja", leads:"bandeja", pipeline:"bandeja", lead_forms:"bandeja",
            clients:"clients", prospects:"clients", applications:"clients", policies:"clients", payment_tracker:"clients", onboarding:"clients", renewals:"clients", signatures:"clients", requests:"clients", import:"clients",
            quotes_invoices:"sales", invoices:"sales", recurring_invoices:"sales",
            mass_email:"marketing", sent_emails:"marketing", sequences:"marketing", campaigns:"marketing", surveys:"marketing", email_suppressions:"marketing", sms_suppressions:"marketing", templates:"marketing", recurring:"marketing", dialer:"marketing", booking:"marketing",
            workflows:"ai", ai_assistant:"ai", automations:"ai", deskte_ai:"ai",
            reports:"reports", commissions_table:"reports", analyst_commissions:"reports", reports_analytics:"reports", sales_report:"reports", client_reports:"reports", team_reports:"reports", report_dashboards:"reports", active_members:"reports", agent_production:"reports", agency_analytics:"reports", metrics:"reports", goals:"reports",
            licenses:"access", vault:"access", company_info:"access", appointments:"access",
            expenses:"finance", timetrack:"finance", payroll:"finance",
            resources:"resources", sheets:"resources", team_training:"resources", team:"resources", team_chat:"resources", hipaa_seats:"resources",
            my_email:"account", whatsapp_integration:"account", phone_integration:"account", profile:"account", help_center:"account",
          };
          const GROUP_ORDER = ["summary","bandeja","clients","sales","marketing","ai","reports","access","finance","resources","account"];
          const GROUP_LABELS = {
            summary:{es:"Resumen",en:"Overview"},
            bandeja:{es:"Mensajes y Leads",en:"Inbox & Leads"},
            clients:{es:"Clientes y Pólizas",en:"Clients & Policies"},
            sales:{es:"Ventas y Cobros",en:"Sales & Billing"},
            marketing:{es:"Marketing",en:"Marketing"},
            ai:{es:"IA y Automatización",en:"AI & Automation"},
            reports:{es:"Reportes y Metas",en:"Reports & Goals"},
            access:{es:"Licencias y Accesos",en:"Licenses & Access"},
            finance:{es:"Gastos y Horas",en:"Expenses & Time"},
            resources:{es:"Recursos y Equipo",en:"Resources & Team"},
            account:{es:"Mi Cuenta",en:"My Account"},
          };
          const groupOf = (id) => { const g = NAV_GROUP[id]; return GROUP_ORDER.includes(g) ? g : "account"; };
          // Abrir un módulo: lo mismo desde un clic que desde el buscador (Enter).
          const irAModulo = (id) => {
            if(id==="clients")window.__deskteSkipClientRestore=true;
            setView(id);setSidebarOpen(false);setBuscarMenu("");
            window.dispatchEvent(new CustomEvent("deskte:nav-reset",{detail:{view:id}}));
          };
          // EL BUSCADOR (Lissette 2026-10-15): con algo escrito, el menú se
          // vuelve una sola lista con lo que coincide, sin secciones ni
          // favoritos — y sin mirar si la sección estaba plegada.
          const seccionDe = (id) => { const g = GROUP_LABELS[groupOf(id)]; return g ? `${g.es} ${g.en}` : ""; };
          const encontrados = buscarMenu.trim() ? visibleNAV.filter(it => coincideEnMenu(it, buscarMenu, seccionDe(it.id))) : null;
          const cajaBuscar = <div style={{position:"sticky",top:0,zIndex:3,background:"var(--c-bg2,#0b1622)",padding:".15rem .1rem .4rem"}}>
            <div style={{position:"relative"}}>
              <Search size={12} style={{position:"absolute",left:9,top:"50%",transform:"translateY(-50%)",color:"var(--c-text3,#45688a)",pointerEvents:"none"}}/>
              <input type="search" value={buscarMenu} className="dkt-search" aria-label={lang==="es"?"Buscar en el menú":"Search the menu"}
                placeholder={lang==="es"?"Buscar módulo…":"Search module…"}
                onChange={e=>setBuscarMenu(e.target.value)}
                onKeyDown={e=>{
                  if(e.key==="Escape"){ setBuscarMenu(""); e.currentTarget.blur(); }
                  if(e.key==="Enter" && encontrados && encontrados.length){ e.preventDefault(); irAModulo(encontrados[0].id); e.currentTarget.blur(); }
                }}
                style={{paddingLeft:28,fontSize:".74rem",padding:".42rem .6rem .42rem 28px"}}/>
            </div>
          </div>;
          const renderItem = ({id,label,icon:Icon,badge,badgeColor}) => {
            const isFav = favs.includes(id);
            return <div key={id} style={{position:"relative"}}>
              <a href={"#"+id} className={`dkt-nav-btn${view===id?" act":""}`} style={{textDecoration:"none"}}
                onClick={(e)=>{
                  // Let the browser handle modifier-clicks (ctrl/cmd/shift/middle)
                  // so "open in new tab" works; intercept a plain left-click for
                  // the in-app navigation (avoids a full reload).
                  if(e.metaKey||e.ctrlKey||e.shiftKey||e.button===1) return;
                  e.preventDefault();
                  irAModulo(id);
                }}>
                <Icon size={13}/>{label}
                {badge&&<span className={`dkt-nav-bdg ${badgeColor}`}>{badge}</span>}
              </a>
              <button
                onClick={e=>{e.stopPropagation();setUserPrefs(p=>({...p,favorites:isFav?favs.filter(x=>x!==id):[...favs,id]}));}}
                className="dkt-fav-star"
                title={isFav ? (lang==="es"?"Quitar de favoritos":"Remove from favorites") : (lang==="es"?"Añadir a favoritos":"Add to favorites")}
                style={{position:"absolute",right:6,top:"50%",transform:"translateY(-50%)",background:"none",border:"none",cursor:"pointer",fontSize:12,lineHeight:1,color:isFav?"var(--c-amber,#ffb700)":"var(--c-text3,#45688a)",opacity:isFav?1:0.45,padding:2,zIndex:2,transition:"opacity .15s, color .15s"}}
              >{isFav?"★":"☆"}</button>
            </div>;
          };
          if (encontrados) return <>
            {cajaBuscar}
            {encontrados.map(renderItem)}
            {encontrados.length === 0 && <div style={{padding:".6rem .75rem",fontSize:".72rem",color:"var(--c-text3,#45688a)"}}>
              {lang==="es"?"Ningún módulo se llama así.":"No module matches."}
            </div>}
          </>;
          return <>
            {cajaBuscar}
            {favItems.length > 0 && <>
              <div style={{padding:"0 .75rem",marginTop:".25rem",marginBottom:".25rem",fontSize:".58rem",fontWeight:800,letterSpacing:".1em",textTransform:"uppercase",color:"var(--c-amber,#ffb700)",display:"flex",alignItems:"center",gap:4}}>
                ⭐ {lang==="es"?"Favoritos":"Favorites"}
              </div>
              {favItems.map(renderItem)}
              <div style={{height:1,background:"var(--c-border,#1a3550)",margin:".5rem .75rem"}}/>
            </>}
            {GROUP_ORDER.map(g => {
              const items = restItems.filter(it => groupOf(it.id) === g);
              if (items.length === 0) return null;
              const collapsed = isGroupCollapsed(g);
              return <div key={g}>
                {/* Section header — a refined, subtly-tinted bar with a left
                    accent line and a circular toggle on the RIGHT, so it reads
                    as a polished section divider, distinct from the module rows. */}
                <button type="button" onClick={()=>toggleGroup(g)}
                  title={collapsed?(lang==="es"?"Expandir":"Expand"):(lang==="es"?"Contraer":"Collapse")}
                  onMouseEnter={e=>{e.currentTarget.style.background="linear-gradient(135deg,rgba(0,212,255,.13),rgba(0,0,0,.10))";}}
                  onMouseLeave={e=>{e.currentTarget.style.background="linear-gradient(135deg,rgba(0,212,255,.06),rgba(0,0,0,.16))";}}
                  style={{display:"flex",alignItems:"center",gap:9,width:"calc(100% - .5rem)",margin:".6rem .25rem .3rem",padding:".5rem .6rem .5rem .55rem",fontSize:".7rem",fontWeight:700,letterSpacing:".07em",textTransform:"uppercase",color:"var(--c-white,#eef6ff)",background:"linear-gradient(135deg,rgba(0,212,255,.06),rgba(0,0,0,.16))",border:"1px solid rgba(255,255,255,.05)",borderRadius:10,cursor:"pointer",fontFamily:"inherit",textAlign:"left",boxShadow:"0 1px 3px rgba(0,0,0,.18)",transition:"background .18s"}}>
                  <span style={{width:3,height:15,borderRadius:3,background:"var(--c-cyan,#00d4ff)",flexShrink:0,opacity:.85}}/>
                  <span style={{flex:1,minWidth:0,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{lang==="es"?GROUP_LABELS[g].es:GROUP_LABELS[g].en}</span>
                  <span style={{flexShrink:0,display:"flex",alignItems:"center",justifyContent:"center",width:20,height:20,borderRadius:"50%",background:"rgba(0,212,255,.12)",color:"var(--c-cyan,#00d4ff)",fontSize:".58rem",lineHeight:1,transition:"transform .2s",transform:collapsed?"rotate(-90deg)":"none"}}>▾</span>
                </button>
                {!collapsed && items.map(renderItem)}
              </div>;
            })}
          </>;
        })()}
        {currentUser?.isPlatformOwner && (
          <button
            onClick={()=>goPlatform("overview")}
            className={`dkt-nav-btn${view==="platform_admin"&&platformTab==="overview"?" act":""}`}
            style={{marginTop:".5rem",borderTop:"1px solid var(--c-border,#1a3550)",paddingTop:".7rem",color:"#a78bfa"}}
            title="Platform Admin (PLATFORM_OWNER only)">
            🛡️ {lang==="es"?"Platform Admin":"Platform Admin"}
            {supportUnread>0 && <span style={{marginLeft:6,background:"var(--c-cyan,#00d4ff)",color:"#06283d",borderRadius:999,padding:"0 6px",fontSize:".62rem",fontWeight:700}}>{supportUnread>99?"99+":supportUnread}</span>}
          </button>
        )}
        {/* Accesos directos del founder a lo que usa a diario. Entran a la
            misma pantalla de Platform Admin pero abriendo su pestaña, para no
            tener que pasar por Resumen y buscarla cada vez. */}
        {currentUser?.isPlatformOwner && (
          <button
            onClick={()=>goPlatform("customers")}
            className={`dkt-nav-btn${view==="platform_admin"&&platformTab==="customers"?" act":""}`}
            style={{color:"#a78bfa"}}
            title={lang==="es"?"Tus clientes: las agencias que usan Deskte (ficha, seats, etapa, notas)":"Your customers: the agencies using Deskte (file, seats, stage, notes)"}>
            💼 {lang==="es"?"Clientes":"Customers"}
          </button>
        )}
        {currentUser?.isPlatformOwner && (
          <button
            onClick={()=>goPlatform("campaigns")}
            className={`dkt-nav-btn${view==="platform_admin"&&platformTab==="campaigns"?" act":""}`}
            style={{color:"#a78bfa"}}
            title={lang==="es"?"Escribirle a los agentes que usan Deskte, por segmento":"Email the agents using Deskte, by segment"}>
            📣 {lang==="es"?"Campañas":"Campaigns"}
          </button>
        )}
        {currentUser?.isPlatformOwner && (
          <button
            onClick={()=>goPlatform("baa")}
            className={`dkt-nav-btn${view==="platform_admin"&&platformTab==="baa"?" act":""}`}
            style={{color:"#a78bfa"}}
            title={lang==="es"?"Quién aceptó el BAA y quién lo tiene pendiente":"Who accepted the BAA and who is pending"}>
            🛡️ BAA
          </button>
        )}
        {/* La dueña de la plataforma no tiene la pestaña Seguridad de
            Configuración (no lleva un CRM), así que su autenticador entra por
            aquí (auditoría de seguridad 2026-09-27). */}
        {currentUser?.isPlatformOwner && (
          <button
            onClick={()=>{setView("seguridad_cuenta");setSidebarOpen(false);}}
            className={`dkt-nav-btn${view==="seguridad_cuenta"?" act":""}`}
            style={{color:"#00d4ff"}}
            title={lang==="es"?"App autenticadora de tu cuenta (Microsoft/Google Authenticator)":"Your account's authenticator app (Microsoft/Google Authenticator)"}>
            🔐 {lang==="es"?"Autenticador":"Authenticator"}
          </button>
        )}
        {/* Platform owner: direct access to the generic HIPAA Seat Training the
            agencies inherit. The founder's nav is otherwise empty, so this is
            surfaced here alongside Platform Admin (view is reachable via
            #hipaa_seats too). */}
        {currentUser?.isPlatformOwner && (
          <button
            onClick={()=>{setView("hipaa_seats");setSidebarOpen(false);}}
            className={`dkt-nav-btn${view==="hipaa_seats"?" act":""}`}
            style={{color:"#00d4ff"}}
            title={lang==="es"?"Capacitación HIPAA de Seats (contenido genérico para todas las agencias)":"HIPAA Seat Training (generic content for all agencies)"}>
            🎓 HIPAA Seats
          </button>
        )}
      </nav>
      <div className="dkt-foot">
        {activeClockIn&&<button onClick={()=>setView("timetrack")} className="dkt-clk">
          <span style={{width:6,height:6,borderRadius:'50%',background:'var(--c-green,#00ff88)',animation:'pulse 1.5s infinite'}}/>
          {lang==="es"?"Activo desde":"Active since"} {activeClockIn.clockIn}
        </button>}
        <div className="dkt-user-row">
          {/* Clicking your own name opens Mi Perfil. For a PLATFORM_OWNER this
              is the ONLY way in: visibleNAV is empty for them, so before
              2026-08-03 the founder had no route to their own profile at all
              — they couldn't even fix their own display name. Safe for every
              role: `profile` is '__always' in SEAT_NAV_PERMISSION_MAP, so the
              seat snap-back effect won't bounce them out of it. */}
          <button
            type="button"
            onClick={()=>{setView("profile");setSidebarOpen(false);}}
            title={lang==="es"?"Mi Perfil":"My Profile"}
            style={{flex:1,minWidth:0,display:"flex",alignItems:"center",gap:".55rem",background:"none",border:"none",padding:0,margin:0,cursor:"pointer",textAlign:"left",font:"inherit",color:"inherit"}}>
            {currentUser.profilePhoto?<img src={currentUser.profilePhoto} alt="" style={{width:27,height:27,borderRadius:7,objectFit:"cover"}}/>:<div className="dkt-av-sm" style={{width:27,height:27,backgroundColor:currentUser.color}}>{currentUser.initials}</div>}
            <div style={{flex:1,minWidth:0}}>
              <div className="dkt-uname">{currentUser.name}</div>
              {currentUser.role!=="assistant" && (
                <div className="dkt-urole">{currentUser.isPlatformOwner ? "🛡️ Platform Admin" : nombreDelRol(currentUser, users, lang).etiqueta}</div>
              )}
            </div>
          </button>
          <button onClick={async()=>{try{await autoClockOut();}catch{/* don't trap the user if the close fails */}if(window.__deskteAuth?.logout){window.__deskteAuth.logout();}else{setCurrentUser(null);setView("dashboard");}}} style={{background:'none',border:'none',cursor:'pointer',color:'var(--c-text3,#45688a)',padding:4,transition:'color .2s'}} title="Logout"><LogOut size={13}/></button>
        </div>
        <button onClick={()=>setLang(l=>l==="en"?"es":"en")} className="dkt-lng"><Globe size={11}/>{lang==="en"?"🇺🇸 EN — Language":"🇪🇸 ES — Language"}</button>
      </div>
    </aside>
    {sidebarOpen&&<div style={{position:'fixed',inset:0,zIndex:20,background:'rgba(0,0,0,.6)',backdropFilter:'blur(4px)'}} onClick={()=>setSidebarOpen(false)}/>}
    <div className="dkt-main">
      <header className="dkt-header">
        <button onClick={()=>setSidebarOpen(true)} className="dkt-hmenu"><MoreVertical size={16}/></button>
        <span className="dkt-header-tag">{t.tagline}</span>
        <div className="dkt-hpills">
          <button onClick={()=>setPalette(p=>p==="ocean"?"sunset":"ocean")} className="dkt-hpill" title={palette==="ocean"?"Sunset":"Ocean"} style={{color:palette==="sunset"?"#FF6B35":"var(--c-text2,#7aa3c0)"}}><span style={{fontSize:'.8rem'}}>{palette==="ocean"?"🔥":"🌊"}</span></button>
          <div className="dkt-hpill-sep"/>
          <button onClick={()=>setTheme(t=>t==="dark"?"light":"dark")} className="dkt-hpill" title={theme==="dark"?(lang==="es"?"Modo Claro":"Light Mode"):(lang==="es"?"Modo Oscuro":"Dark Mode")}><span style={{fontSize:'.8rem'}}>{theme==="dark"?"☀️":"🌙"}</span></button>
          <div className="dkt-hpill-sep"/>
          <button onClick={()=>setLang(l=>l==="en"?"es":"en")} className="dkt-hpill" title={lang==="en"?"Cambiar a Espanol":"Switch to English"}><span style={{fontSize:'.7rem',fontWeight:700,letterSpacing:'.02em'}}>{lang==="en"?"EN":"ES"}</span></button>
          <div className="dkt-hpill-sep"/>
          <button onClick={()=>setCalcOpen(o=>!o)} className="dkt-hpill" title={lang==="es"?"Calculadora":"Calculator"} style={{color:calcOpen?"var(--c-cyan,#00d4ff)":"var(--c-text2,#7aa3c0)"}}><span style={{fontSize:'.85rem'}}>🧮</span></button>
          <div className="dkt-hpill-sep"/>
          {currentUser && <StickyNoteButton lang={lang} />}
          <div className="dkt-hpill-sep"/>
          {!currentUser?.isPlatformOwner && (
            <>
              <DeskteAiWidget aiName={aiName} lang={lang} active={view==="deskte_ai"} />
              <div className="dkt-hpill-sep"/>
              <SupportMenu lang={lang} unread={supportUnread} onSelect={(entry)=>{ setSidebarOpen(false); if(entry==='suggestion'){ setView('ideas'); } else if(entry==='help'){ setView('help_center'); } else if(entry==='tickets'){ /* Support LANDING with the ticket list (SupportView treats entry 'help' as landing/mode=null) */ setSupportEntry('help'); setView('support'); } else { setSupportEntry(entry); setView('support'); } }} />
              <div className="dkt-hpill-sep"/>
            </>
          )}
          <AnnouncementsBell lang={lang} seenAt={(userPrefs&&userPrefs.announceSeenAt)||""} onSeen={(ts)=>setUserPrefs(p=>({...p,announceSeenAt:ts}))} />
          <div className="dkt-hpill-sep"/>
          <NotificationBell lang={lang} onNavigate={navigateFromLink} />
        </div>
        {/* Reset button removed from header — delete imports via Import module */}
      </header>
      <main className="dkt-content">
        {/* A todo lo ancho (sin el tope de 1200px de .dkt-inner): las pantallas
            de tabla. Lissette 2026-10-11 pidio Renovaciones (E-349) y luego
            "lo mismo en Clientes y Polizas, Prospecto y Pagos del Mes". */}
        <div className={"dkt-inner" + (VISTAS_A_TODO_LO_ANCHO.has(view) ? " dkt-inner-wide" : "")}>
          {/* Browse-as-agency banner — visible whenever a platform owner
              has an impersonation target set in localStorage. Clicking
              "Salir" clears the target and reloads so the SPA re-hydrates
              against the owner's own (empty) tenant. */}
          {(() => {
            let target = null;
            try { target = leerEntrada("deskte:impersonateAgencyId"); } catch (_) {}
            if (!target || !currentUser?.isPlatformOwner) return null;
            return (
              <div style={{ padding: '.55rem .9rem', background: 'linear-gradient(135deg, rgba(139,92,246,.18), rgba(139,92,246,.06))', border: '1px solid rgba(139,92,246,.35)', borderRadius: 9, marginBottom: '.75rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '.75rem', flexWrap: 'wrap' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '.5rem', fontSize: '.78rem', color: '#a78bfa', fontWeight: 700 }}>
                  <span style={{ fontSize: '1rem' }}>🛡️</span>
                  <span>{lang === 'es' ? 'Navegando como agencia (Platform Admin)' : 'Browsing as agency (Platform Admin)'}</span>
                  <span style={{ fontSize: '.62rem', color: '#a78bfa', opacity: .6, fontFamily: 'var(--font-mono)' }}>{target.slice(0, 8)}…</span>
                </div>
                <button
                  type="button"
                  onClick={() => { try { borrarEntrada("deskte:impersonateAgencyId"); } catch (_) {} window.location.href = '/'; }}
                  style={{ padding: '.3rem .8rem', borderRadius: 7, border: '1px solid rgba(139,92,246,.4)', background: 'rgba(139,92,246,.15)', color: '#a78bfa', fontSize: '.7rem', fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}
                >
                  ✕ {lang === 'es' ? 'Salir' : 'Exit'}
                </button>
              </div>
            );
          })()}
          {/* Fichas de cliente abiertas — visible en TODOS los modulos, que es
              justo el sentido: abres un cliente, te vas a Polizas, y sigue ahi
              a un clic. Va debajo del aviso de suplantacion para no tapar una
              advertencia. */}
          <BarraDeFichas fichas={fichas} activaId={fichaActiva} es={lang==="es"}
            onIr={irAFicha} onCerrar={cerrarUnaFicha} />
          {/* View-as-user banner — shown while a platform owner is rendered
              AS a specific user (their role is the target's, so this is
              keyed on the impersonate-user storage key + the backend
              impersonatedByPlatform flag, NOT isPlatformOwner). Exit clears
              the key and reloads back to the founder's own session. */}
          {(() => {
            let target = null;
            try { target = leerEntrada("deskte:impersonateUserId"); } catch (_) {}
            if (!target || !currentUser?.impersonatedByPlatform) return null;
            return (
              <div style={{ padding: '.55rem .9rem', background: 'linear-gradient(135deg, rgba(255,183,0,.16), rgba(255,183,0,.05))', border: '1px solid rgba(255,183,0,.4)', borderRadius: 9, marginBottom: '.75rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '.75rem', flexWrap: 'wrap' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '.5rem', fontSize: '.78rem', color: '#ffb700', fontWeight: 700 }}>
                  <span style={{ fontSize: '1rem' }}>🛡️</span>
                  <span>{lang === 'es' ? `Viendo como ${currentUser?.name || 'usuario'} (Platform Admin)` : `Viewing as ${currentUser?.name || 'user'} (Platform Admin)`}</span>
                  <span style={{ fontSize: '.62rem', color: '#ffb700', opacity: .65, fontFamily: 'var(--font-mono)' }}>{(currentUser?.role || '').toUpperCase()}</span>
                </div>
                <button
                  type="button"
                  onClick={() => { try { borrarEntrada("deskte:impersonateUserId"); } catch (_) {} window.location.href = '/'; }}
                  style={{ padding: '.3rem .8rem', borderRadius: 7, border: '1px solid rgba(255,183,0,.45)', background: 'rgba(255,183,0,.15)', color: '#ffb700', fontSize: '.7rem', fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}
                >
                  ✕ {lang === 'es' ? 'Salir' : 'Exit'}
                </button>
              </div>
            );
          })()}
          <BillingBanner currentUser={currentUser} lang={lang} onUpgradeClick={openBilling} />
          <ConfirmHost lang={lang} />
          {view==="dashboard"  && canSeeCRM && <Dashboard clients={clients} policies={policies} docs={docs} tasks={tasks} currentUser={currentUser} users={users} setView={setView} changeHistory={changeHistory||[]} activitylog={activitylog||[]} eligibilityAlerts={eligibilityAlerts} holidayTemplates={holidayTemplates} emailTemplates={emailTemplates} invoices={invoices} ticketsOpen={ticketsOpen} fuOverdue={fuOverdue} hasTeamActionBeenDone={hasTeamActionBeenDone} teamActionKey={teamActionKey} logTeamAction={logTeamAction} forgetTeamAction={forgetTeamAction} confirmBeforeResend={confirmBeforeResend} t={t} lang={lang} userPrefs={userPrefs} onPrefsChange={setUserPrefs}/>}
          {view==="conversations" && <ConversationsView lang={lang} team={users} refreshSignal={conversationsPing}/>}
          {view==="pipeline" && canSeeCRM && <PipelineView lang={lang} puedeEditar={!isAssistant || hasSeatPermission(_seatPerms,'leads.edit')} refreshSignal={leadsPing}/>}
          {view==="leads"      && <LeadsView leads={leads} onLeadsChange={setLeads} clients={clients} onClientsChange={setClients} onPoliciesAdd={(newPolicies)=>setPolicies(prev=>{const byId=new Map(prev.map(p=>[p.id,p]));newPolicies.forEach(np=>byId.set(np.id,{...(byId.get(np.id)||{}),...np}));return Array.from(byId.values());})} currentUser={currentUser} t={t} lang={lang}/>}
          {view==="help_center" && <HelpCenterView lang={lang} onAskAI={()=>{ setSupportEntry('live'); setView('support'); }} onTickets={()=>{ setSupportEntry('ticket'); setView('support'); }}/>}
          {view==="lead_forms" && <LeadFormsView currentUser={currentUser} lang={lang}/>}
          {view==="applications" && <ApplicationsView lang={lang} clients={clients} clientsLoaded={clientsLoaded} clientsServerTotal={clientsServerTotal}/>}
          {/* "Plantillas" (las de proceso) se apaga tambien aqui, no solo en el
              menu: el manejador de hashchange aplica #<vista> tal cual, sin
              comprobarlo contra NAV, asi que escribir #templates en la barra
              seguiria abriendolo — el mismo cabo suelto que dejo el Power
              Dialer a medias el 2026-08-20. El componente ActionTemplatesView
              sigue en el archivo: devolverlo es esta linea y la del menu. */}
          {view==="recurring" && <RecurringTasksView currentUser={currentUser} clients={clients} users={users} seatLabels={seatLabels} lang={lang}/>}
          {view==="recurring_invoices" && <RecurringInvoicesView clients={clients} lang={lang}/>}
          {view==="reports_analytics" && <ReportsAnalyticsView clients={clients} leads={leads} policies={policies} commissions={commissions} invoices={invoices} lang={lang}/>}
          {view==="sales_report" && <SalesReportView policies={policies} clients={clients} users={users} onPoliciesChange={setPolicies} lang={lang} userPrefs={userPrefs} onPrefsChange={setUserPrefs}/>}
          {view==="client_reports" && <ReportsClientsView lang={lang} currentUser={currentUser} onClientClick={(id)=>{
            // Open the client in a NEW TAB so the report (its results live only
            // in memory) is never lost — pressing Back in the same tab couldn't
            // restore the report list (Lissette 2026-06-18). The app opens the
            // client from the #client/<id> hash on load.
            try {
              const w = window.open(`${window.location.origin}${window.location.pathname}#client/${id}`, "_blank");
              if (!w) throw new Error("popup-blocked");
            } catch {
              // Popups blocked → fall back to same-tab navigation.
              irAlCliente((clients||[]).find(c=>c.id===id) || { id }, setView);
            }
          }}/>}
          {view==="team_reports" && <ReportsTeamView lang={lang} currentUser={currentUser}/>}
          {view==="report_dashboards" && <ReportDashboardsView lang={lang} currentUser={currentUser} policies={policies} clients={clients} onClientClick={c=>irAlCliente(c,setView)}/>}
          {view==="active_members" && <MembersReportView lang={lang}/>}
          {view==="agent_production" && <ProductionByAgentView lang={lang} currentUser={currentUser}/>}
          {view==="agency_analytics" && <AgencyAnalyticsView lang={lang} currentUser={currentUser}/>}
          {view==="workflows" && <WorkflowsView lang={lang} clients={clients} users={users} seatLabels={seatLabels}/>}
          {view==="ai_assistant" && <AIAssistantView clients={clients} policies={policies} lang={lang}/>}
          {view==="deskte_ai" && <DeskteAiPage aiName={aiName} lang={lang} onRename={async(n)=>{ const name=(n||"").trim().slice(0,40); if(!name) return; setAiName(name); try{ const { updateAgencySettings }=await import("./crm-app/api.js"); await updateAgencySettings({ aiAssistantName: name }); }catch(e){ console.error("rename ai failed", e?.message); notifySaveFailed("No se pudo guardar el nombre del asistente en el servidor", "Couldn't save the assistant name to the server")(e); } }}/>}
          {view==="goals"     && <GoalsView currentUser={currentUser} lang={lang}/>}
          {view==="sequences" && <EmailSequencesView currentUser={currentUser} clients={clients} policies={policies} lang={lang}/>}
          {view==="email_suppressions" && <EmailSuppressionsView currentUser={currentUser} clients={clients} lang={lang}/>}
          {view==="sms_suppressions" && <SmsSuppressionsView currentUser={currentUser} clients={clients} lang={lang}/>}
          {view==="clients"    && <Clients clients={clients} policies={policies} docs={docs} tasks={tasks} signatures={signatures} requests={requests} onRequestsChange={setRequests} activitylog={activitylog} onClientsChange={setClients} onPoliciesChange={setPolicies} onDocsChange={setDocs} onTasksChange={setTasks} onActivityLog={logActivity} clientNotes={clientNotes} noteStamps={noteStamps} onClientNotesChange={setClientNotes} users={users} currentUser={currentUser} changeHistory={changeHistory} onChangeHistory={setChangeHistory} docTemplates={docTemplates} eligibilityAlerts={eligibilityAlerts} onEligibilityAlertsChange={handleEligibilityAlertsChange} followups={followups} onFollowupsChange={handleFollowupsChange} tickets={tickets} onSaveTicket={saveTicket} onAddTicketMessage={addTicketMsg} onEditTicketMessage={editTicketMsg} onDeleteTicketMessage={deleteTicketMsg} onDeleteTicket={deleteTicketRow} onNotifyTicketClient={notifyTicketClientRow} loadClientDocs={loadClientDocsForTicket} ticketEmailOnOpen={ticketEmailOnOpen} ticketEmailOnResolve={ticketEmailOnResolve} seatLabels={seatLabels} onSeatLabelsChange={setSeatLabels} ticketStatuses={ticketStatuses} ticketTypes={ticketTypes} customTabDefs={customTabDefs} onCustomTabDefsChange={setCustomTabDefs} tagColors={agencyTagColors} onTagColorsChange={setAgencyTagColors} tagLibrary={agencyTagLibrary} onTagLibraryChange={setAgencyTagLibrary} policyTagLibrary={policyTagLibrary} onPolicyTagLibraryChange={setPolicyTagLibrary} policyTagColors={policyTagColors} onPolicyTagColorsChange={setPolicyTagColors} clientsServerTotal={clientsServerTotal} onClientsServerTotalChange={setClientsServerTotal} clientsLoaded={clientsLoaded} agencySettingsLoaded={agencySettingsLoaded} onFichaAbierta={registrarFicha} userPrefs={userPrefs} t={t} lang={lang}/>}
          {view==="policies"   && <PoliciesView policies={policies} clients={clients} onPoliciesChange={setPolicies} onClientClick={c=>irAlCliente(c,setView)} users={users} seatLabels={seatLabels} currentUser={currentUser} policyTagLibrary={policyTagLibrary} onPolicyTagLibraryChange={setPolicyTagLibrary} policyTagColors={policyTagColors} onPolicyTagColorsChange={setPolicyTagColors} t={t} lang={lang}/>}
          {view==="payment_tracker" && <PaymentTrackerView clients={clients} policies={policies} users={users} seatLabels={seatLabels} currentUser={currentUser} onClientClick={c=>irAlCliente(c,setView)} lang={lang}/>}
          {view==="renewals"   && <RenewalsView policies={policies} clients={clients} users={users} seatLabels={seatLabels} currentUser={currentUser} onPoliciesChange={setPolicies} logTeamAction={logTeamAction} confirmBeforeResend={confirmBeforeResend} onAddClient={()=>{ window.__magAddClient={}; setView("clients"); }} onOpenClient={(cl)=>irAlCliente(cl,setView)} userPrefs={prefsDeAviso} t={t} lang={lang}/>}
          {(view==="onboarding"||view==="prospects") && <OnboardingView agencySettingsLoaded={agencySettingsLoaded} clients={clients} policies={policies} users={users} seatLabels={seatLabels} currentUser={currentUser} onClientsChange={setClients} onPoliciesChange={setPolicies} onClientClick={c=>irAlCliente(c,setView)} lang={lang}/>}
          {view==="alerts"     && <AlertsView userPrefs={prefsDeAviso} licenses={licenses} clients={clients} policies={policies} docs={docs} activitylog={activitylog||[]} users={users} currentUser={currentUser} setView={setView} eligibilityAlerts={eligibilityAlerts} requests={requests} tasks={tasks} tickets={tickets} emailTemplates={emailTemplates} hasTeamActionBeenDone={hasTeamActionBeenDone} logTeamAction={logTeamAction} forgetTeamAction={forgetTeamAction} t={t} lang={lang}/>}
          {view==="tasks"      && <TasksView tasks={tasks} onTasksChange={setTasks} users={users} clients={clients} currentUser={currentUser} t={t} onOpenClient={c=>irAlCliente(c,setView)}/>}
          {view==="mass_email" && <MassEmailView clients={clients} policies={policies} currentUser={currentUser} t={t} lang={lang}/>}
          {view==="my_email"  && <MyEmailView currentUser={currentUser} lang={lang}/>}
          {view==="whatsapp_integration" && <WhatsappIntegrationView lang={lang}/>}
          {view==="phone_integration" && <PhoneIntegrationView lang={lang}/>}
          {view==="healthsherpa_integration" && <HealthSherpaIntegrationView lang={lang}/>}
          {view==="healthsherpa_emparejar" && <HealthSherpaEmparejarView lang={lang}/>}
          {view==="healthsherpa_inscribir" && <HealthSherpaInscribirView lang={lang}/>}
          {view==="sent_emails" && <SentEmailsView currentUser={currentUser} clients={clients} setView={setView} setOpenClientId={(id)=>irAlCliente((clients||[]).find(c=>c.id===id)||{ id },setView)} lang={lang}/>}
          {view==="surveys"    && <EncuestasView lang={lang}/>}
          {view==="campaigns"  && <CampaignsView clients={clients} currentUser={currentUser} holidayTemplates={holidayTemplates} onHolidayChange={setHolidayTemplates} emailTemplates={emailTemplates} onEmailChange={setEmailTemplates} customTemplates={customTemplates} onCustomChange={handleCustomTemplatesChange} lang={lang}/>}
          {view==="quotes_invoices" && <QuotesInvoicesView clients={clients} policies={policies} lang={lang} customApptData={customApptData} compAppts={compAppts} esPlataforma={!!currentUser?.isPlatformOwner || DEMO_COMO_PLATAFORMA} leads={leads} puedeEditarCatalogo={IS_DEMO || puedeCambiarLosPlazos(currentUser)}/>}
          {view==="invoices" && <InvoicesView clients={clients} policies={policies} invoices={invoices} onInvoicesChange={handleInvoicesChange} currentUser={currentUser} lang={lang}/>}
          {view==="platform_admin" && currentUser?.isPlatformOwner && <PlatformAdminView lang={lang} supportUnread={supportUnread}/>}
          {view==="seguridad_cuenta" && currentUser?.isPlatformOwner && <div style={{maxWidth:600}}><AutenticadorPanel lang={lang} email={currentUser?.email}/><CerrarSesionesPanel lang={lang}/></div>}
          {view==="profile"    && <MyProfileView currentUser={currentUser} onSave={(updated)=>{
            // Optimistic local update for snappy UI…
            setUsers(prev=>prev.map(u=>u.id===updated.id?{...u,...updated}:u));
            setCurrentUser(prev=>({...prev,...updated}));
            // …then persist to the server so it syncs across devices and
            // feeds defaults like the license NPN (was localStorage-only).
            if (window.__deskteAuth) {
              import("./crm-app/api.js").then(({ updateMyProfile }) => updateMyProfile({
                name: updated.name, title: updated.title, phone: updated.phone,
                npn: updated.npn, companyName: updated.companyName, companyLogo: updated.companyLogo,
                agencyDisplayName: updated.agencyDisplayName,
                portalDisplayName: updated.portalDisplayName,
                website: updated.website, bio: updated.bio, licenseStates: updated.licenseStates,
                // Social profiles — the backend normalizes "@usuario" into a
                // real URL, so what comes back on the next /auth/me is the
                // canonical link the signature will use.
                instagramUrl: updated.instagramUrl, facebookUrl: updated.facebookUrl,
                linkedinUrl: updated.linkedinUrl, tiktokUrl: updated.tiktokUrl,
                profilePhoto: updated.profilePhoto,
                mailingStreet: updated.mailingStreet,
                mailingCity: updated.mailingCity,
                mailingState: updated.mailingState,
                mailingZip: updated.mailingZip,
                contactEmail: updated.contactEmail,
                contactEmail2: updated.contactEmail2,
                officePhone: updated.officePhone,
                whatsappNumber: updated.whatsappNumber,
                fax: updated.fax,
              })).catch(e=>{
                import("./crm-app/components/Toast.jsx").then(({ toast }) => toast.error((lang==="es"?"No se pudo guardar el perfil en el servidor: ":"Couldn't save profile to server: ")+e.message));
              });
            }
          }} users={users} lang={lang} userPrefs={userPrefs} onPrefsChange={setUserPrefs} agencyCollaborators={agencyCollaborators} onCollaboratorsChange={setAgencyCollaborators} initialTab={profileInitialTab} alertLead={agencyAlertLead} alertLeadByType={agencyAlertLeadByType} onAlertLeadChange={setAgencyAlertLead} onAlertLeadByTypeChange={setAgencyAlertLeadByType} puedeEditarPlazos={puedeCambiarLosPlazos(currentUser)} nameOrder={agencyNameOrder} onNameOrderChange={setAgencyNameOrder} puedeEditarOrdenDelNombre={puedeCambiarElOrdenDelNombre(currentUser)}/>}
          {view==="requests"   && <DocRequests clients={clients} policies={policies} requests={requests} onRequestsChange={setRequests} onClientsChange={setClients} docTemplatesMaster={docTemplatesMaster} onDocTemplatesMasterChange={setDocTemplatesMaster} uploadsBump={uploadsBump} currentUser={currentUser} hasTeamActionBeenDone={hasTeamActionBeenDone} logTeamAction={logTeamAction} confirmBeforeResend={confirmBeforeResend} onOpenClient={c=>irAlCliente(c,setView)} t={t} lang={lang}/>}
          {view==="signatures" && <SignaturesView signatures={signatures} onSignaturesChange={setSignatures} clients={clients} policies={policies} docTemplates={docTemplates} onDocTemplatesChange={handleDocTemplatesChange} t={t} lang={lang} currentUser={currentUser} users={users} hasTeamActionBeenDone={hasTeamActionBeenDone} logTeamAction={logTeamAction} confirmBeforeResend={confirmBeforeResend}/>}
          {view==="followups"  && canSeeCRM && <FollowupsView followups={followups} onFollowupsChange={handleFollowupsChange} clients={clients} requests={requests} currentUser={currentUser} lang={lang} canEdit={!isAssistant || hasSeatPermission(_seatPerms,'tasks.edit')}/>}
          {view==="citas" && canSeeCRM && <AppointmentsView appointments={appointments} onAppointmentsChange={setAppointments} clients={clients} currentUser={currentUser} lang={lang} agencyEmail={currentUser?.email||''} canEdit={!isAssistant || hasSeatPermission(_seatPerms,'appointments.edit') || hasSeatPermission(_seatPerms,'calendar.edit')} customFieldDefs={appointmentFieldDefs} onCustomFieldDefsChange={(next)=>{ setAppointmentFieldDefs(next); if(window.__deskteAuth){ apiUpdateAgencySettings({ appointmentFieldDefs: next }).catch((err)=>console.warn('[appointmentFieldDefs] save failed:', err?.message||err)); } }}/>}
          {view==="citas_medicas" && canSeeCRM && <CitasMedicasView lang={lang} onAbrirCliente={(id)=>irAlCliente((clients||[]).find(c=>c.id===id)||{ id },setView)}/>}
          {view==="tickets"    && canSeeCRM && <TicketsView tickets={tickets} onTicketRestored={tk=>{ if(tk&&tk.id) setTickets(prev=>prev.some(x=>x.id===tk.id)?prev:[tk,...prev]); }} onSaveTicket={saveTicket} onAddMessage={addTicketMsg} onEditMessage={editTicketMsg} onDeleteMessage={deleteTicketMsg} onDeleteTicket={deleteTicketRow} clients={clients} users={users} currentUser={currentUser} lang={lang} seatLabels={seatLabels} customStatuses={ticketStatuses} customTypes={ticketTypes} onCustomStatusesChange={setTicketStatuses} onCustomTypesChange={setTicketTypes} onNotifyClient={notifyTicketClientRow} loadClientDocs={loadClientDocsForTicket} ticketEmailOnOpen={ticketEmailOnOpen} ticketEmailOnResolve={ticketEmailOnResolve} onEmailOnOpenChange={setTicketEmailOnOpen} onEmailOnResolveChange={setTicketEmailOnResolve}/>}
          {view==="resources"  && <ResourcesView resources={resources} onResourcesChange={setResources} resourceTokens={resourceTokens} onResourceTokensChange={setResourceTokens} onSaveResource={saveResourceRow} onDeleteResource={deleteResourceRow} onCreateResourceTokens={createResourceTokensRow} clients={clients} policies={policies} currentUser={currentUser} t={t} lang={lang} canEdit={!isAssistant || hasSeatPermission(_seatPerms,'resources.edit')}/>}
          {view==="team_training" && <TeamTrainingView resources={resources} policies={policies} onResourcesChange={setResources} onSaveResource={saveResourceRow} onDeleteResource={deleteResourceRow} currentUser={currentUser} lang={lang}/>}
          {view==="reports"    && <ReportsView userPrefs={userPrefs} policies={policies} clients={clients} commissions={commissions} onCommissionsChange={setCommissions} onClientsChange={setClients} onPoliciesChange={setPolicies} metricsPerms={metricsPerms} onMetricsPermsChange={setMetricsPerms} tasks={tasks} docs={docs} signatures={signatures} users={users} currentUser={currentUser} t={t} lang={lang} policyTypes={POLICY_TYPES} onOpenClient={c=>irAlCliente(c,setView)}/>}
          {view==="commissions_table" && <CommissionsTableView clients={clients} policies={policies} onPoliciesChange={setPolicies} lang={lang} onClientClick={c=>irAlCliente(c,setView)}/>}
          {/* Las reglas las cambia la agente; un asiento solo ve el reporte
              (el servidor tampoco le deja guardarlas). */}
          {view==="analyst_commissions" && <AnalystCommissionsView clients={clients} policies={policies} users={users} currentUser={currentUser} lang={lang} puedeEditar={currentUser?.role!=="assistant"} userPrefs={userPrefs} onPrefsChange={setUserPrefs}/>}
          {view==="timetrack"  && <TimeTracking timelog={timelog} onAddEntry={tlAdd} onDeleteEntry={tlDelete} users={users} currentUser={currentUser} t={t} lang={lang}/>}
          {view==="team"       && (canSeeOwnerModules || isAgencyOwner) && <UsersManager users={users} onUsersChange={setUsers} currentUser={currentUser} t={t} lang={lang}/>}
          {view==="calendar"  && <CalendarView events={calEvents} onEventsChange={setCalEvents} clients={clients} policies={policies} users={users} currentUser={currentUser} lang={lang}/>}
          {/* canSchedule incluye al dueño/admin, igual que canManage de Correos
              Programados justo abajo. Solo decia `isAgent`, y el admin veia los
              cumpleaños y feriados sin ningun boton "Programar" (Lissette
              2026-09-24, E-324). El servidor ya se lo permitia. */}
          {view==="month_events" && canSeeCRM && <MonthEventsView clients={clients} holidayTemplates={holidayTemplates} emailTemplates={emailTemplates} customTemplates={customTemplates} currentUser={currentUser} canSchedule={isAgent || isAgencyOwner || !!currentUser?.isPlatformOwner || (isAssistant && hasSeatPermission(_seatPerms,'campaigns.edit'))} hasTeamActionBeenDone={hasTeamActionBeenDone} logTeamAction={logTeamAction} forgetTeamAction={forgetTeamAction} lang={lang} onOpenClient={c=>irAlCliente(c,setView)}/>}
          {view==="scheduled_sends" && canSeeCRM && <ScheduledSendsView clients={clients} users={users} currentUser={currentUser} lang={lang} canManage={isAgent || isAgencyOwner || !!currentUser?.isPlatformOwner || (isAssistant && hasSeatPermission(_seatPerms,'campaigns.edit'))} onOpenClient={c=>irAlCliente(c,setView)}/>}
          {/* Power Dialer apagado (Lissette 2026-08-20). Quitarlo del menu no
              bastaba: el enlace #<vista> se aplica tal cual en el manejador de
              hashchange, sin comprobarlo contra NAV, asi que escribir #dialer
              en la barra seguia abriendolo. Se apaga tambien el render. El
              componente PowerDialerView sigue en el archivo: encenderlo otra
              vez es devolver esta linea y la del menu. */}
          {view==="automations" && <AIAutomationsView clients={clients} leads={leads} lang={lang}/>}
          {view==="booking"   && <BookingView currentUser={currentUser} users={users} lang={lang}/>}
          {/* Licencias, Company Appointments, Boveda e Info de Companias se pintan
              con `showOwnerModules`, la MISMA puerta que las pone en el menu. Se
              pintaban con `canSeeOwnerModules` (solo agentes), asi que el admin
              de agencia veia la entrada y al pulsarla no salia nada (Lissette
              2026-09-24: "los agent admin no pueden ver ... licencia y
              appointment"). El mismo fallo que el de canSeeCRM del 2026-08-26. */}
          {view==="licenses"  && showOwnerModules && <LicensesView licenses={licenses} onLicensesChange={setLicenses} onSaveLicense={saveLicenseRow} onDeleteLicense={deleteLicenseRow} currentUser={currentUser} lang={lang} userPrefs={prefsDeAviso}/>}
          {view==="licenses"  && isAssistant && hasSeatPermission(_seatPerms,'licenses.view') && <LicensesView licenses={licenses} onLicensesChange={setLicenses} onSaveLicense={saveLicenseRow} onDeleteLicense={deleteLicenseRow} currentUser={currentUser} lang={lang} userPrefs={prefsDeAviso} userId={currentUser?.parentAgentId || currentUser?.supervisorId} readOnly={!hasSeatPermission(_seatPerms,'licenses.edit')}/>}
          {view==="appointments" && showOwnerModules && <CompanyAppointmentsView appointments={compAppts} onAppointmentsChange={setCompAppts} onToggleCell={toggleCarrierCell} onBulkReplace={bulkReplaceCarrierAppts} customApptData={customApptData} onCustomApptDataChange={handleCustomApptDataChange} lang={lang} currentUser={currentUser}/>}
          {view==="appointments" && isAssistant && hasSeatPermission(_seatPerms,'appointments.view') && <CompanyAppointmentsView appointments={compAppts} onAppointmentsChange={setCompAppts} onToggleCell={toggleCarrierCell} onBulkReplace={bulkReplaceCarrierAppts} customApptData={customApptData} onCustomApptDataChange={handleCustomApptDataChange} lang={lang} readOnly={!hasSeatPermission(_seatPerms,'appointments.edit')} currentUser={currentUser}/>}
          {view==="vault"     && showOwnerModules && <VaultView lang={lang} policyTypes={POLICY_TYPES} currentUser={currentUser}/>}
          {view==="my_vault"  && veBovedaPersonal && <VaultView lang={lang} policyTypes={POLICY_TYPES} currentUser={currentUser} personal/>}
          {view==="vault"     && isAssistant && hasSeatPermission(_seatPerms,'vault.view') && <VaultView lang={lang} policyTypes={POLICY_TYPES} readOnly={!hasSeatPermission(_seatPerms,'vault.edit')} currentUser={currentUser}/>}
          {view==="hipaa_seats" && (canSeeOwnerModules || isAgencyOwner) && <HipaaSeatBundlePanel lang={lang} isPlatformOwner={!!currentUser?.isPlatformOwner}/>}
          {view==="company_info" && showOwnerModules && <CompanyInfoView lang={lang} currentUser={currentUser}/>}
          {view==="company_info" && isAssistant && hasSeatPermission(_seatPerms,'vault.view') && <CompanyInfoView lang={lang} currentUser={currentUser} readOnly={!hasSeatPermission(_seatPerms,'vault.edit')}/>}
          {view==="expenses"  && (canSeeOwnerModules || isAgencyOwner) && <ExpensesView expenses={expenses} onExpensesChange={setExpenses} onSaveExpense={saveExpenseRow} onDeleteExpense={deleteExpenseRow} lang={lang}/>}
          {view==="payroll"   && (canSeeOwnerModules || isAgencyOwner) && <PayrollDocsView lang={lang} currentUser={currentUser} expenses={expenses}/>}
          {view==="metrics"   && (canSeeOwnerModules || isAgencyOwner) && <MetricsView clients={clients} policies={policies} leads={leads} commissions={commissions} expenses={expenses} tasks={tasks} users={users} timelog={timelog} currentUser={currentUser} lang={lang}/>}
          {view==="agency"    && isAgencyOwner && <AgencyView clients={clients} policies={policies} leads={leads} commissions={commissions} expenses={expenses} tasks={tasks} users={users} onUsersChange={setUsers} currentUser={currentUser} lang={lang} licenses={licenses} onLicensesChange={setLicenses} compAppts={compAppts} onAppointmentsChange={setCompAppts} userPrefs={userPrefs} onSetPref={(k,v)=>setUserPrefs(p=>({...p,[k]:v}))}/>}
                    {view==="import"    && <ImportView onClientsChange={setClients} onPoliciesChange={setPolicies} clients={clients} policies={policies} clientsLoaded={clientsLoaded} clientsServerTotal={clientsServerTotal} importBatches={importBatches} onBatchesChange={handleImportBatchesChange} lang={lang}/>}
          {view==="team_chat" && <TeamChatView currentUser={currentUser} lang={lang} onNavigate={navigateFromLink}/>}
          {view==="support" && <SupportView currentUser={currentUser} lang={lang} entry={supportEntry} onEntryConsumed={()=>setSupportEntry(null)} aiName={aiName}/>}
          {view==="ideas" && <IdeasBoard currentUser={currentUser} lang={lang} isPlatformOwner={!!currentUser?.isPlatformOwner}/>}
          {view==="sheets" && <SheetsView currentUser={currentUser} lang={lang} clients={clients} policies={policies} users={users} licenses={licenses} onRefreshCrm={refreshSheetsData} onOpenClient={c=>{
            // Open the client in a NEW TAB (via the #client/<id> deep link) so the
            // sheet you're working in stays open. Falls back to same-tab nav if
            // the browser blocks the popup. Mirrors SalesReportView.
            const id = c?.id;
            try {
              const w = id ? window.open(`${window.location.origin}${window.location.pathname}#client/${id}`, "_blank") : null;
              if (!w) throw new Error("popup-blocked");
            } catch {
              irAlCliente(c, setView);
            }
          }}/>}
        </div>
      </main>
    </div>
    {/* Floating team-chat widget — follows the user across every module so an
        incoming message pops up in the corner. Hidden on the full chat view
        (avoid two live instances) and for a platform owner with no agency. */}
    <ChatWidget
      currentUser={currentUser}
      lang={lang}
      unread={chatUnread}
      hidden={!currentUser || (currentUser.isPlatformOwner && !_isImpersonating) || view==='team_chat'}
      onExpand={()=>setView('team_chat')}
      onNavigate={navigateFromLink}
    />
    {greetingPopup&&<div style={{position:"fixed",inset:0,zIndex:9998,background:"rgba(0,0,0,.7)",display:"flex",alignItems:"center",justifyContent:"center",padding:"1rem",animation:"fadeIn .3s ease"}} onClick={dismissGreeting}>
      <div onClick={e=>e.stopPropagation()} style={{background:"var(--c-bg2,#0b1622)",border:"1px solid var(--c-border2,#1f3f60)",borderRadius:16,padding:"1.75rem",maxWidth:420,width:"100%",boxShadow:"0 20px 60px rgba(0,0,0,.5)"}}>
        <div style={{textAlign:"center",marginBottom:"1.25rem"}}>
          <div style={{fontSize:"2.5rem",marginBottom:".5rem"}}>{greetingPopup.items.some(i=>i.type==="holiday")?greetingPopup.items.find(i=>i.type==="holiday").emoji:"🎂"}</div>
          <div style={{fontFamily:"var(--font-display)",fontWeight:800,fontSize:"1.1rem",color:"var(--c-white,#eef6ff)"}}>{lang==="es"?"¡Buenos días!":"Good morning!"}</div>
          <div style={{fontSize:".8rem",color:"var(--c-text2,#7aa3c0)",marginTop:4}}>{lang==="es"?"Tienes saludos pendientes por enviar hoy":"You have greetings to send today"}</div>
        </div>
        <div style={{display:"flex",flexDirection:"column",gap:".4rem",marginBottom:"1.25rem"}}>
          {greetingPopup.items.map((item,i)=><div key={i} style={{display:"flex",alignItems:"center",gap:".65rem",padding:".6rem .85rem",borderRadius:10,background:"var(--c-surface2,#112538)",border:"1px solid var(--c-border,#1a3550)"}}>
            <span style={{fontSize:"1.3rem",flexShrink:0}}>{item.emoji}</span>
            <div style={{flex:1}}>
              <div style={{fontSize:".84rem",fontWeight:700,color:"var(--c-white,#eef6ff)"}}>{item.label}</div>
              <div style={{fontSize:".68rem",color:"var(--c-text3,#45688a)"}}>{item.sub}{item.type==="holiday"?` — ${clients.filter(c=>c.email&&c.status==="active").length} ${lang==="es"?"clientes":"clients"}`:item.client?.email?` — ${item.client.email}`:""}</div>
            </div>
          </div>)}
        </div>
        {/* Optional date+time picker: when filled, Email button schedules
            instead of sending now. SMS/WhatsApp don't support scheduling
            yet — they always send now. */}
        <div style={{marginBottom:".7rem",padding:".55rem .7rem",background:"var(--c-surface2,#112538)",border:"1px dashed var(--c-border2,#1f3f60)",borderRadius:9}}>
          <label style={{fontSize:".64rem",color:"var(--c-text3,#45688a)",fontWeight:700,textTransform:"uppercase",letterSpacing:".06em",fontFamily:"var(--font-mono)",display:"block",marginBottom:4}}>⏰ {lang==="es"?"Programar para (opcional)":"Schedule for (optional)"}</label>
          <DateTimeField value={greetingScheduleAt} onChange={e=>setGreetingScheduleAt(e.target.value)} lang={lang} />
          {greetingScheduleAt && <div style={{fontSize:".62rem",color:"var(--c-amber,#ffb700)",marginTop:4}}>{lang==="es"?"📅 Se programarán por email a esa fecha/hora. SMS/WhatsApp no soportan programación todavía.":"📅 Will be queued for email at that date/time. SMS/WhatsApp don't support scheduling yet."}</div>}
        </div>
        <div style={{display:"flex",gap:".65rem"}}>
          <button onClick={()=>greetingScheduleAt?scheduleAllGreetings():sendAllGreetings("email")} style={{flex:1,display:"flex",alignItems:"center",justifyContent:"center",gap:4,padding:".6rem",background:"#0099cc20",border:"1px solid #0099cc40",color:"#0099cc",fontWeight:700,fontSize:".78rem",borderRadius:9,cursor:"pointer"}}>📧 {greetingScheduleAt?(lang==="es"?"Programar":"Schedule"):"Email"}</button>
          <button onClick={()=>sendAllGreetings("whatsapp")} disabled={!!greetingScheduleAt} style={{flex:1,display:"flex",alignItems:"center",justifyContent:"center",gap:4,padding:".6rem",background:"#25d36620",border:"1px solid #25d36640",color:"#25d366",fontWeight:700,fontSize:".78rem",borderRadius:9,cursor:greetingScheduleAt?"not-allowed":"pointer",opacity:greetingScheduleAt?.45:1}}>💬 WhatsApp</button>
          <button onClick={()=>sendAllGreetings("sms")} disabled={!!greetingScheduleAt} style={{flex:1,display:"flex",alignItems:"center",justifyContent:"center",gap:4,padding:".6rem",background:"#ffb70020",border:"1px solid #ffb70040",color:"#ffb700",fontWeight:700,fontSize:".78rem",borderRadius:9,cursor:greetingScheduleAt?"not-allowed":"pointer",opacity:greetingScheduleAt?.45:1}}>📱 SMS</button>
          <button onClick={dismissGreeting} style={{padding:".65rem 1rem",borderRadius:10,border:"1px solid var(--c-border,#1a3550)",background:"transparent",color:"var(--c-text2,#7aa3c0)",cursor:"pointer",fontWeight:600,fontSize:".78rem"}}>{lang==="es"?"Después":"Later"}</button>
        </div>
        <div style={{textAlign:"center",marginTop:".75rem",fontSize:".65rem",color:"var(--c-text3,#45688a)"}}>{greetingScheduleAt?(lang==="es"?"Quedará en la cola — puedes verlo en Campañas":"Queued — visible under Campaigns"):(lang==="es"?"No se mostrará de nuevo hoy":"Won't show again today")}</div>
      </div>
    </div>}
    {showReset&&<div style={{position:"fixed",inset:0,zIndex:9999,background:"rgba(0,0,0,.85)",display:"flex",alignItems:"center",justifyContent:"center",padding:"1rem"}}>
      <div style={{background:"#0d1b2a",border:"2px solid #ef4444",borderRadius:16,padding:"2rem",maxWidth:360,width:"100%",textAlign:"center",fontFamily:"inherit"}}>
        <div style={{fontSize:"2.5rem",marginBottom:".75rem"}}>⚠️</div>
        <div style={{fontWeight:800,fontSize:"1rem",color:"#fff",marginBottom:".5rem"}}>{lang==="es"?"¿Resetear el demo?":"Reset the demo?"}</div>
        <div style={{fontSize:".82rem",color:"#8eafc2",lineHeight:1.6,marginBottom:"1.5rem"}}>{lang==="es"?"Borra todos los datos y vuelve al estado original.":"Clears all data and restores original state."}</div>
        <div style={{display:"flex",gap:".75rem",justifyContent:"center"}}>
          <button type="button" onClick={()=>setShowReset(false)} style={{padding:".6rem 1.5rem",borderRadius:9,border:"1px solid #2a4560",background:"transparent",color:"#8eafc2",cursor:"pointer",fontWeight:600,fontSize:".875rem",fontFamily:"inherit"}}>{lang==="es"?"Cancelar":"Cancel"}</button>
          <button type="button" onClick={()=>{setClients(SEED_CLIENTS);setPolicies(SEED_POLICIES);setDocs(SEED_DOCS);setTasks(SEED_TASKS);setCommissions(SEED_COMMISSIONS);setUsers(SEED_USERS);setActivitylog(SEED_ACTIVITYLOG);setTimelog(SEED_TIMELOG);setRequests(SEED_REQUESTS);setSignatures(SEED_SIGNATURES);setLicenses([]);setExpenses(SEED_EXPENSES);setCalEvents([]);setLeads(SEED_LEADS);setImportBatches([]);setChangeHistory(SEED_CHANGEHISTORY);setDocTemplates(SEED_DOC_TEMPLATES);setMetricsPerms([]);setCurrentUser(null);setView("dashboard");setShowReset(false);}}
            style={{padding:".6rem 1.5rem",borderRadius:9,border:"none",background:"#ef4444",color:"#fff",cursor:"pointer",fontWeight:700,fontSize:".875rem",fontFamily:"inherit"}}>{lang==="es"?"Sí, resetear":"Yes, reset"}</button>
        </div>
      </div>
    </div>}
    {currentUser && <StickyNotes currentUser={currentUser} lang={lang} />}
  </div>;
}

export default Deskte;
